(function() {
    'use strict';

    var brand = window.__brand || {};

    var app = angular
        .module('anrescowebApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAnimate',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ui.select',
            'ngSanitize',
            'angular-bind-html-compile',
            'ui.tinymce',
            'ui.sortable',
            'ui.calendar',
            'oitozero.ngSweetAlert',
            'pascalprecht.translate'
        ])
        .constant('BRAND', brand)
        .run(run);

        app.config(["$translateProvider", function($translateProvider){

            var en_translations = {};

            var jp_translations = {
                'greeting': '332423423',
                'Account': 'アカウント',
                'Open Orders': '進行中のオーダー数',
                'View Orders': 'オーダーの確認',
                'Samples In-Progress': '到着待ち検体数',
                'Member Since': 'メンバー登録年',
                'Compliance Statistics': 'コンプライアンス統計',
                'No Statistics Available For This Time Range': '選択期間中のデータはありません',
                'Last 3 Months': '過去３ヶ月',
                'Last 6 Months': '過去６ヶ月',
                'Year To Date': '過去１年',
                'All': '全て',
                'Estimated Due Date Calendar': '納期予定日カレンダー',
                'Filter by': 'フィルター',
                'R&D': 'R&D',
                'Compliance': 'コンプライアンス',
                'Plant': '植物',
                'Concentrate': 'コンセントレート',
                'Edible': '飲食物',
                'Topical': '化粧品',
                'Environmental': 'Environmental',
                'Other': 'その他',
                'Go To Calendar': 'カレンダーを見る',
                'Your profile info': 'ご登録情報',
                'Business Name': '会社名',
                'Primary Contact Name': 'お名前',
                'Direct Phone': '電話番号',
                'Primary Contact Title': '役職名',
                'Website': 'ウェブサイト',
                'Email': 'メールアドレス',
                'Edit Profile': '登録情報変更',
                'Anresco contact info': 'Anresco担当者情報',
                'Primary Representative': '担当者名',
                'Primary Rep Email': '担当者メールアドレス',
                'Primary Rep Phone': '電話番号',
                'General Email': '一般メールアドレス',
                'General Phone': '一般電話番号',
                'Visit Our Site': 'Anrescoウェブサイトはこちら',
                'Home': 'ホーム',
                'Orders': 'オーダー履歴',
                'Samples': '検体履歴',
                'Public Gallery': 'パブリックギャラリー',
                'Calendar': 'カレンダー',
                'Manage': 'アカウント情報',
                'Search': '検索',
                'Number of entries': '合計オーダー数',
                'Filters': 'フィルター',
                'Apply Filters': '適用',
                'Close': '閉じる',
                'Order No.': 'オーダー番号',
                '# of Samples': '検体数',
                'Turnaround Time': '納期',
                'Receive Date Range': '到着日範囲',
                'Status': 'ステータス',
                'Created': 'オーダー済み',
                'Samples Received': '検体到着',
                'Preliminary Results': '中間結果',
                'Receive Date': '到着日',
                'Downloads': 'ダウンロード',
                '3 day (standard)': '3日（通常）',
                'Load': '読み込む',
                'Download Samples': '一括ダウンロード',
                'All Samples': '全ての検体',
                'In Progress': '進行中',
                'Completed': '完了',
                'Table View': 'テーブルビュー',
                'Gallery View': 'ギャラリービュー',
                'Sample No.': '検体番号',
                'Lot #': 'ロット番号',
                'Name': '検体名',
                'Completed Date': '完了日',
                'Starred': 'お気に入り',
                'Sample Name': '検体番号',
                'Enter Number': '番号を入力',
                'e.g.': '例）',
                'Category': 'カテゴリ',
                'Subcategory': 'サブカテゴリ',
                'Order Type': 'オーダー内容',
                '(range)': '範囲指定',
                'Pass/Fail Status': '合否判定',
                'Pass': '合格',
                'Fail': '不合格',
                'Undetermined': '未判定',
                'Completed Date Range': '完了日範囲指定',
                'Start Date': '開始日',
                'End Date': '終了日',
                'Date Range': '日付範囲',
                'Submit': '新規発注',
                'Retrieves by order complete date': 'オーダー作成日での検索',
                'Category (Sub)': 'サブカテゴリー',
                'Total Cannabinoids': 'カンナビノイド合計',
                'Order Number': 'オーダー番号',
                'Received Date': '到着日',
                'Estimated Due Date': '納期予定日',
                'Share': 'シェア',
                'Samples Tab': '検体履歴タブ',
                'TABLE VIEW': 'テーブルビュー',
                'unique features': 'の特徴',
                'View the results of more samples at one time': '一度に多くの検体情報や結果を閲覧可能',
                'Star samples for easy viewing later': '後で見返す時に便利なお気に入り登録機能',
                'Configure columns to quickly view the data that is important to you': '重要なデータを素早く表示するためのカラム設定',
                'GALLERY VIEW': 'ギャラリービュー',
                'View sample images': '検体の画像を表示',
                'For more granular information on a given sample, click on the hyperlinked Sample ID number': '特定の検体に関する詳細な情報については、リンク先の検体 ID番号をクリックしてください。',
                'Total': '合計',
                'Download': 'ダウンロード',
                'Tests': '詳細',
                'Sample ID': '検体ID',
                'Tested': '検査済み',
                'Plant': '植物',
                'Concentrate': 'コンセントレート',
                'Edible': '飲食物',
                'Topical': '化粧品',
                'Select': '選択',
                'Hash': 'ハッシュ',
                'Wax': 'ワックス',
                'Shatter': 'シャッター',
                'Kief': 'キーフ',
                'Rosin': 'ロジン',
                'Isolate': 'アイソレート',
                'Distillate': 'ディスティレート',
                'Crystalline': '結晶',
                'Cartridge': 'カートリッジ',
                'Terpene': 'テルペン',
                'Orally Consumed Concentrate': '経口摂取用濃縮物',
                'Crude': 'クルード',
                'Emulsion': '乳化加工物',
                'Baked Good': '焼き菓子',
                'Hard Candy/Lozenge': 'ハードキャンディ',
                'Soft Chew': 'ソフトキャンディ',
                'Chocolate': 'チョコレート',
                'Solid Fats (Butter, Sat. Fats)': '固形脂（バター、飽和脂肪）',
                'Capsule': 'カプセル',
                'Suppository': '座薬',
                'Syrup/Honey': 'シロップ/ハチミツ',
                'Beverage': '清涼飲料',
                'Carbonated Beverage': '炭酸飲料',
                'Tincture': 'ティンクチャー',
                'Liquid Fats (Oils)': '液状油（オイル）',
                'Orally Dissolving Product': '口腔内崩壊製品',
                'Gummy': 'グミ',
                'Powder': 'パウダー',
                'Infused Product': '含有製品',
                'Lotion/Balm': 'ローション/バーム',
                'Salve': '軟膏',
                'Transdermal Patch': '経皮パッチ',
                'Nanoemulsion': 'ナノエマルジョン',
                'Paper/Wrap': '紙/ラップ',
                'Cones/Tubes': 'コーン/チューブ',
                'Oil': 'オイル',
                'Inactive Ingredient': '添加物',
                'Select Action': 'アクションを選択',
                'Move Up': '上に移動',
                'Move Down': '下に移動',
                'Add Samples': '検体を追加',
                'Remove Selected': '選択アイテムを削除',
                'Set Criteria': '条件の設定',
                'Select Action': 'アクションを選択',
                'Reposition': '並び替え',
                'Select Type': '選択してください',
                'Order Type': 'オーダー内容',
                'Save': '保存',
                'Cancel': 'キャンセル',
                'Sample Number': '検体番号',
                'Lot Number': 'ロット番号',
                'Reset': 'リセット',
                'Search Samples': '検索',
                'RESULTS': '検索結果',
                'Type': '検体種類',
                'see list': '詳細表示',
                'No Samples': '該当なし',
                'CONTACT LIST': '連絡先',
                'COMPANY INFO': '会社情報',
                'Type of Business': '業種',
                'Business Description': '会社概要',
                'Street Address': '住所',
                'State': '都道府県',
                'Phone Number': '電話番号',
                'City': '市区町村',
                'Zip Code': '郵便番号',
                'Country': '国',
                'Fax': 'ファックス',
                'Contact Name': '連絡先氏名',
                'Phone': '電話番号',
                'Title': '役職',
                'Reporting': '結果報告',
                'Billing': '請求',
                'Edit Contact': '連絡先の変更',
                'First Name': 'ファーストネーム',
                'Direct Phone': '直通電話番号',
                'Last Name': 'ラストネーム',
                'To Receive': '受け取り',
                'Admin User': '管理者ユーザー',
                'Username': 'ユーザー名',
                'Password': 'パスワード',
                "leave blank if don't want to change": '変更しない場合は空白のまま',
                'New password': '新規パスワード',
                'Confirm the new password': '新規パスワードを再度入力してください',
                'Password strength': 'パスワードの安全性',
                'Recent Invoices': '直近の請求書',
                'Invoice No.': '請求書番号',
                'Invoiced Date': '発行日',
                'Amount': '金額',
                'recent orders submitted': '直近のオーダー状況',
                'Submit New': '新規オーダー',
                'Remove Sample?': '検体を削除しますか？',
                'Remove Samples?': '検体を削除しますか？',
                "Remove samples from Public Gallery? You can't undo this.": '一度削除すると復元することはできません。',
                "Remove sample from Public Gallery? You can't undo this.": '一度削除すると復元することはできません。',
                "Don't remove": 'キャンセル',
                'Yes, remove': '削除する',
                'Add New Contact': '新規連絡先追加',
                'This action cannot be undone.': '度削除すると復元することはできません。',
                'Delete':'削除',
                
                "Samples Page": "サンプル",
                "Order": "発注",
                "QA/R&D Testing": "検査発注",
                "Samples": "サンプル履歴",
                "Tests": "検査項目",
                "Review": "レビュー",
                "Download Excel": "ダウンロード（Excel）",
                "Upload Excel": "アップロード（Excel）",
                "Delete Samples": "サンプル削除",
                "Add New Samples": "サンプル追加",
                "Sample Name*": "サンプル名*",
                "Lot/Batch #": "ロット/バッチ番号",
                "Product Category": "製品カテゴリ",
                "Product Type": "製品種別",
                "Inhalable/Non-Inhalable": "吸入用 / 非吸入用",
                "Product Specifications": "製品詳細",
                "Please input any internal specifications, label claims, or pass/fail criteria into this field (e.g. 18-22% THC, 100mg CBD +/- 10%, <400ppm acetonitrile). This will allow our lab to proactively investigate any out of spec result, saving time and reducing the potential for analytical or reporting error.": "厚生労働省が定める製品区分、社内規格値、ラベル表示数値、または合否判定基準をこの欄にご記入ください（例：THC含有量、CBD含有量、溶媒残留基準など）。\n規格外の結果が出た場合に迅速に原因を調査できるため、時間の節約につながり、分析や報告ミスの可能性を低減できます。",
                "Sample Name": "サンプル名",
                "e.g. abc123": "例：abc123",
                "Select Category": "カテゴリを選択",
                "Select Type": "種別を選択",
                "Select Inhalable": "吸入種別を選択",
                "e.g. 20% Vit C": "例：CBD 10mg (Other)",
                "Strain Name": "ストレイン名称",
                "Optional": "任意",
                "Strain Type": "ストレイン種別",
                "Sativa": "サティバ",
                "Indica": "インディカ",
                "Hybrid": "ハイブリッド",
                "CBD": "CBD",
                "Label Claims": "表示含有量",
                "Source UID <br>Optional": "ソースUID<br>任意",
                "Source UID": "ソースUID",
                "Medicinal Batch": "医療用バッチ",
                "Next": "次へ",
                "Test Page": "",
                "Search for tests...": "検査項目を検索",
                "Clear": "クリア",
                "Panels": "パネル",
                // "Select Panel": "HIDE",
                // "Clear Panel": "HIDE",
                // "Hide Anresco Panel": "HIDE",
                "Cannabinoid Profile - LCMSMS (Japan Limits - Essential)": "THC残留限度値対応カンナビノイド含有量（10種）",
                "Cannabinoid profiling via LCMSMS per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（D8-THC, THCV, THCVAを除く10種）を実施します。",
                "Cannabinoid Profile - LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（通常13種）",
                "Cannabinoid screen performed via LC-MS/MS for extremely low level detection per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（13種）を実施します。",
                "Cannabinoid Profile Extended Analytes LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（追加分析パッケージ）",
                "Extended cannabinoid screen performed via LC-MS/MS for extremely low level detection per the requirements of Japan MHLW.": "日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（追加分析パッケージ）を実施します。",
                "Pesticide & Mycotoxin Screen - CA DCC": "残留農薬＆マイコトキシン：コンプライアンス",
                "Panel includes 21 category I pesticides, 45 category II pesticides, aflatoxins, and ochratoxins as required by the California DCC.": "カリフォルニア州大麻取締局の要件に準拠した21種類のカテゴリーI農薬、45種類のカテゴリーII農薬、アフラトキシン、およびオクラトキシンが含まれます。",
                "Pesticide Screen - CA DCC": "残留農薬コンプライアンス",
                "Screening for 66 pesticides via LC-MS/MS and GC-MS/MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "LC-MS/MSおよびGC-MS/MSを使用し、カリフォルニア州大麻取締局の基準に基づいた66種類の農薬スクリーニングを実施します。",
                "Microbiological QA Screen": "微生物試験：品質管理",
                "Panel analysis for the following quantitative assays: standard plate count, yeast & mold, coliforms, and generic e. coli.": "標準平板菌数、酵母およびカビ、大腸菌群、一般大腸菌の定量試験を含む微生物分析パネル。",
                "Microbiological Screen (Inhalables) - CA DCC": "微生物試験：コンプライアンス（吸入製品）",
                "Panel analysis for STEC, salmonella, and aspergillus, per DCC guidelines for inhalable products.": "吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌、サルモネラ菌およびアスペルギルスのパネル分析。",
                "Microbiological Screen (Non-inhalables) - CA DCC": "微生物試験：コンプライアンス（非吸入製品）",
                "Panel analysis for STEC and salmonella, per DCC guidelines for non-inhalable products.": "非吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌およびサルモネラ菌のパネル分析。",
                "Heavy Metals - CA DCC": "重金属",
                "Screening for arsenic, cadmium, lead, and mercury via ICP-MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "ICP-MSを用いたヒ素、カドミウム、鉛、水銀のスクリーニング試験（重金属検査）を実施します。",
                "Residual Solvent Screen - CA DCC": "残留溶媒",
                "Screening for 20 residual solvents via GC-MS, applying limits as outlined by the California Department of Cannabis Control (DCC).": "GC-MSを使用し、20種類の残留溶媒のスクリーニングを実施します。",
                "Mycotoxins": "マイコトキシン",
                "Includes Aflatoxins B1, B2, G1, G2, and Ochratoxin A.": "アフラトキシン B1、B2、G1、G2、およびオクラトキシンAの検査を含みます。",
                "Foreign Material - CA DCC": "異物混入物",
                "Homogeneity (5 Samples)": "均質性試験（５サンプル）",
                "Homogeneity USP (10 samples)": "均質性試験",
                "Comparative analysis of cannabinoid results from 10 samples from within the same batch, per USP guidelines.": "米国薬局法（USP）のガイドラインに準拠したカンナビノイドの含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。",
                "Terpene Profile": "テルペン分析",
                "Profiling of 27 of the most commonly found terpenoids in cannabis flower and products via GC-MS.": "GC-MSを使用し、大麻の花や製品に最も一般的に含まれる27種類のテルペノイドのプロファイリングを実施します。",
                "Flavonoid Profile": "フラボノイド分析",
                "Apigenin| Baicalin| Cannflavin A| Cannflavin B| Catechin| Chrysin| Epicatechin| Epigallocatechin Gallate| Isovitexin| Kaempferol| Luteolin| Myricetin| Orientin| Quercetin| Rutin| Vitexin": "アピゲニン｜ケルセチン｜ルテオリン｜ミリセチン｜ケンフェロール｜ルチン｜ビテキシン｜イソビテキシン｜ビテキシン｜オリエンチン｜イソビテキシン｜ルチン｜イソビテキシン｜カテキン｜エピカテキンガレート（EGCG）｜ビテキシン",
                "STEC (Shiga Toxin Producing E. Coli)": "志賀毒素産生性大腸菌",
                "Salmonella": "サルモネラ",
                "Standard Plate Count": "標準平板菌数",
                "Vitamin E Acetate (Tocopheryl Acetate)": "ビタミンEアセテート（トコフェリルアセテート）",
                "Water Activity": "水分活性",
                "Yeast & Mold": "イースト菌及びカビ菌",
                "Previous": "戻る",
                "Order Page": "",
                "Contact Name": "ご登録名",
                "Email Recipients": "メール通知先",
                "Contact Phone #": "お電話番号",
                "Project/PO#<br>Optional": "プロジェクト番号<br>任意",
                "Project/PO#": "プロジェクト番号",
                "Invoicing Address": "ご請求先",
                "Customer/Reporting Address<br>Choose Location/Add New": "発行先名<br>住所選択または新規追加",
                "Customer/Reporting Address": "発行先名",
                "Choose Location/Add New": "住所選択または新規追加",
                "Manufacturing Address<br>Choose Location/Add New": "製造者名<br>住所選択または新規追加",
                "Pickup/Arrival Date": "検体到着予定日",
                "Tracking Number": "追跡番号",
                "Delivery Preference<br>Anresco Pick-Up<br>Client Drop-Off<br>Mail": "提出方法<br>Anrescoによる集荷<br>お客様ご自身でのお届け<br>輸送",
                "Delivery Preference": "提出方法",
                "Turnaround Time<br>5 days (standard)<br>4 days (rush)<br>3 days (rush)<br>2 days (rush)<br>1 days (rush)": "納期<br>5営業日（通常）<br>4営業日（ラッシュ）<br>3営業日（ラッシュ）<br>2営業日（ラッシュ）<br>1営業日（ラッシュ）",
                "Turnaround Time": "納期",
                "5 days (standard)": "5営業日（通常）",
                "4 days (rush)": "4営業日（ラッシュ）",
                "3 days (rush)": "3営業日（ラッシュ）",
                "2 days (rush)": "2営業日（ラッシュ）",
                "1 day (rush)": "1営業日（ラッシュ）",
                "Standard turnaround time varies depending on analysis.\n\t•\tRoutine cannabis and hemp testing has a standard 3 day TAT.\n\t•\tRoutine microbiological and kratom testing has a standard 5 day TAT.\n\t•\tNutritional labeling has a standard 15 day TAT.\n\t•\tMost other assays have a standard 10 day TAT.\n\nExpedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or support@anresco.com for additional info regarding these options.": "標準の納期は、分析内容によって異なります。\n        •        厚生労働省THC残留限度値に対応したカンナビノイド含有量試験の標準納期は5営業日です。\n        •        一般的な大麻製品試験の標準納期は3営業日です。\n        •        一般的な微生物試験の標準納期は5営業日です。\n        •        その他の多くの分析の標準TATは10営業日です。\n\nラッシュサービスには事前承認と追加料金が必要です。詳細については、担当者または japan@anresco.com までお問い合わせください。",
                "Standard turnaround time varies depending on analysis.":"標準の納期は、分析内容によって異なります。 ",
                "Routine cannabis and hemp testing has a standard 3 day TAT.":"  厚生労働省THC残留限度値に対応したカンナビノイド含有量試験の標準納期は5営業日です。",
                "Routine microbiological and kratom testing has a standard 5 day TAT.":"般的な大麻製品試験の標準納期は3営業日です。",
                "Nutritional labeling has a standard 15 day TAT..":"般的な微生物試験の標準納期は5営業日です。",
                "Most other assays have a standard 10 day TAT.":"その他の多くの分析の標準TATは10営業日です。",
                "Expedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or support@anresco.com for additional info regarding these options.":"ラッシュサービスには事前承認と追加料金が必要です。詳細については、担当者または japan@anresco.com までお問い合わせください。",

                "Special Instructions": "その他特記事項",
                "Estimated Report Date": "納期予想日",
                "Review Page": "",
                "Prepayment is required for all new clients. Payment terms can be negotiated for routine clients. After the invoice due date, a finance charge of 2% per month will be applied and any discounts will be nullified.": "初めてご利用されるお客様は前払いが必要です。定期的にご利用いただくお客様については、支払い条件の交渉が可能です。請求書の支払期日を過ぎた場合、月額2%の延滞金が適用され、すべての割引は無効となります。",
                "Federal Tax ID # 94-2528801": "連邦税務識別番号 (Federal Tax ID): 94-2528801",
                "DUNS # 05-458-2416": "DUNS番号: 05-458-2416",
                "Cancel Order": "注文をキャンセル",
                "After Submittion Page": "",
                "Your order has been submitted successfully": "ご発注ありがとうございます。正常に受け付けました。",
                "Print Submission Form": "発注フォームを印刷",
                "View Packaging & Shipping Guidelines": "サンプル発送ガイドラインを確認",
                "Anresco Receiving Address<br>Attn: Lab Sample<br>Anresco Laboratories<br>1375 Van Dyke Avenue<br>San Francisco, CA 94124": "国内発送先：\nAnresco Japan\n〒176-0023　\n東京都練馬区中村北1-13-13 OHDビル702\n03-6427-1829\n\n米国発送先：\nAttn: Lab Sample\nAnresco Laboratories\n1375 Van Dyke Avenue\nSan Francisco, CA 94124",
                "Anresco Receiving Address": "国内発送先：\u003cbr\u003eAnresco Japan \u003cbr\u003e 〒176-0023　\u003cbr\u003e東京都練馬区中村北1-13-13 OHDビル702\u003cbr\u003e03-6427-1829\u003cbr\u003e\u003cbr\u003e米国発送先：",                "Check Order Status": "オーダー状況の確認",
                "Submit Another Order": "新規オーダー発注",

                "Beverage": "飲料",
                "Hard Candy／Lozenge": "飴・トローチ",
                "Liquid Fats (Oil)": "液状油脂（オイル）",
                "Orally Dissolving Products": "口腔内崩壊錠",
                "Powder": "粉末",
                "Soft Chew": "チュアブル",
                "Solid Fats (Butter, sat. fats)": "固形油脂（バターなど）",
                "Suppository": "坐薬",
                "Syrup/Honey": "シロップ・ハチミツ",
                "Concentrate": "濃縮物",
                "Cartridge": "ベイプリキッド、カートリッジ",
                "Emulision": "乳濁液",
                "Orally Consumed Concentrate": "経口摂取濃縮物",
                "inactive Ingredients": "不活性成分",
                "Nanoemulision": "ナノ乳濁液",
                "Oil": "油脂",
                "Flower": "花穂",
                "Lotion/Balm": "ローション・バーム",
                "Transdermal Patch": "経皮摂取パッチ",
                "Leaf/Trim": "葉っぱ",
                "Hemp": "ヘンプ",
                "Infused Pre-Roll": "添加ジョイント",
                "Seed": "種子",
                "No sample has been added": "追加された検体がありません",
                "Time of Collection": "回収時期",
                "Sample Matrix": "検体マトリックス",
                "Sample Description": "検体詳細",
                "Email Recipients": "Eメール受信者",
                "Reporting Address": "発行先住所",
                "Delivery": "配達",
                "Frequent Tests": "頻繁な検査項目",
                "Configured Tests": "設定された検査項目",
                "Requested Tests": "要求された検査項目",
                "Category (Type)": "カテゴリ（種別）",
                "Compliance Testing": "コンプライアンス検査",
                "Matrix": "マトリックス",
                "Batch Name": "バッチ名",
                "No batch has been added": "追加されたバッチがありません",
                "Add New Batch": "新規バッチを追加",
                "TAG UID": "タグUID",
                "Product Batch": "製造バッチ",
                "Harvest Batch": "収穫バッチ",
                "Add Terpenoid Profile": "テルペノイド検査を追加",
                "Analyze by LCMSMS": "LCMSMSによる分析",
                "Product Batch Size (Units)*": "製造バッチサイズ（単位）*",
                "Manufacture Date": "製造日",
                "Unit Weight (g)*": "単位重量（g）*",
                "Submit Order": "この内容で発注",
                
                "Cannabinoid Profile - LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（通常13種）",
                "Cannabinoid Profile - LCMSMS Essential Analytes (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（10種）",
                "Cannabinoid Profile Extended Analytes LCMSMS (Japan Limits)": "THC残留限度値対応カンナビノイド含有量（30種）",
                "Residual Solvent Screen - CA DCC": "残留溶媒 - カリフォルニア州法準拠",
                "Heavy Metals - CA DCC": "重金属 - カリフォルニア州法準拠",
                "Flavonoid Profile": "フラボノイド分析",
                "Heavy Metal Screen - Universal Hemp": "重金属 - 全米基準対応",
                "Homogeneity (5 Samples)": "均質性試験（5サンプル）",
                "Homogeneity USP (10 samples)": "均質性試験（アメリカ薬局方準拠）",
                "Microbiological QA Screen": "微生物試験：品質管理",
                "Microbiological Screen (Inhalables) - CA DCC": "微生物試験 - カリフォルニア州法準拠（吸入製品）",
                "Microbiological Screen (Non-inhalables) - CA DCC": "微生物試験 - カリフォルニア州法準拠（非吸入製品）",
                "Microbiological Screen - Universal Hemp": "微生物試験 - 全米基準対応",
                "Mycotoxins": "マイコトキシン",
                "Pesticide & Mycotoxin Screen - CA DCC": "残留農薬＆マイコトキシン - カリフォルニア州法準拠",
                "Pesticide Screen - CA DCC": "残留農薬 - カリフォルニア州法準拠",
                "Pesticide Screen - Universal Hemp": "残留農薬 - 全米基準対応",
                "STEC (Shiga Toxin Producing E. Coli)": "志賀毒素産生性大腸菌",
                "Salmonella": "サルモネラ菌",
                "Standard Plate Count": "標準平板菌数",
                "Terpene Profile": "テルペン分析",
                "Vitamin E Acetate (Tocopheryl Acetate)": "ビタミンEアセテート（トコフェリルアセテート）",
                "Water Activity": "水分活性",
                "Yeast and Mold - Universal Hemp - TESTING": "酵母菌＆カビ",
                "Foreign Material - CA DCC": "異物混入",
                'Full Panel "Standard" - Concentrate': "フルパネル検査 - スタンダード（濃縮物）",
                'Full Panel "Standard" - Non inhalable/solid': 'フルパネル検査 - スタンダード（固形物・非吸引）',
                'Full Panel "Standard" - Non inhalable/liquid': 'フルパネル検査 - スタンダード（液体・非吸引）',
                'Full Panel "Full Scope" - Concentrate': 'フルパネル検査 - フルスコープ（濃縮物）',
                'Full Panel "Full Scope" - Non inhalable/solid': 'フルパネル検査 - フルスコープ（固形物・非吸引）',
                'Full Panel "Full Scope" - Non inhalable/liquid': 'フルパネル検査 - フルスコープ（液体・非吸引）'
            }

            $translateProvider.translations('en',en_translations);

            $translateProvider.translations('jp',jp_translations);

            $translateProvider.preferredLanguage('en');

          }]);

    app.filter('highlightMatch', function() {
        return function(words, search) {
            return (search ? words.replace(new RegExp('(' + search + ')', 'i'), '<span class="filter-match">$1</span>') : words);
        }
    });

    app.filter('lngFilterOptions', function() {
        return function (options, lng) {
            if (lng == 'jp') {
                var filteredOptions = [];
                var ignore = ['Plant', 'Environmental']
                if (options && options.length) {
                    options.forEach( function(op) {
                        if (!ignore.includes(op.text || op.name)) filteredOptions.push(op);
                    });
                }
                return filteredOptions
            } else return options;

        }
    });

    app.filter('isEmpty', [function() {

        return function(objectOrArray) {

            if(Array.isArray(objectOrArray)) {

                return !objectOrArray.length > 0;

            }

            return angular.equals({}, objectOrArray);

        };

    }]);

    app.filter('numberFormat', function() {
        return function(format, input) {
          var lastChar;

          format= '(___) ___-____';

          if (!input) {
            return;
          }

          for (var index = 0; index < input.length; index++) {
            var char = input.charAt(index);
            if ([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(char))) {
              if (format.indexOf('_') >= 0) {
                format = format.replace('_', char);
                lastChar = char;
              }
            }
          }

          if (lastChar) {
            return format.substring(0, format.lastIndexOf(lastChar) + 1);
          }
        }
      });

      app.directive('phoneNumberFormat', ['$filter', function($filter) {
        return {
          resolve: 'A',
          replace: true,
          link: function(scope, ele, attrs) {
            var modelName = attrs.ngModel;
            var lastNestedObj = attrs.lastnestedobject
            var formatValue = attrs.format;

            scope.$watch(modelName, function(newValue, oldValue) {
              Object.byString(scope, modelName)[lastNestedObj] = $filter('numberFormat')(formatValue, newValue);
            });
          }
        }
      }]);

    app.filter('utcToLocal', ['$filter', function($filter) {
    	return function(utcDateString, format) {
    		if (!utcDateString) return;

    		if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) utcDateString += 'Z';

    		return $filter('date')(utcDateString, format);
    	}
    }]);

    app.directive('collapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
        var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
        return {
            link: function(scope, element, attrs) {
                var expandingExpr = $parse(attrs.expanding),
                    expandedExpr = $parse(attrs.expanded),
                    collapsingExpr = $parse(attrs.collapsing),
                    collapsedExpr = $parse(attrs.collapsed),
                    horizontal = false,
                    css = {},
                    cssTo = {};

                init();

                function init() {
                    horizontal = !!('horizontal' in attrs);
                    if (horizontal) {
                        css = {
                            width: ''
                        };
                        cssTo = {width: '0'};
                    } else {
                        css = {
                            height: ''
                        };
                        cssTo = {height: '0'};
                    }
                    if (!scope.$eval(attrs.collapse)) {
                        element.addClass('in')
                            .addClass('collapse')
                            .attr('aria-expanded', true)
                            .attr('aria-hidden', false)
                            .css(css);
                    }
                }

                function getScrollFromElement(element) {
                    if (horizontal) {
                        return {width: element.scrollWidth + 'px'};
                    }
                    return {height: element.scrollHeight + 'px'};
                }

                function expand() {
                    if (element.hasClass('collapse') && element.hasClass('in')) {
                        return;
                    }

                    $q.resolve(expandingExpr(scope))
                        .then(function() {
                            element.removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', true)
                                .attr('aria-hidden', false);

                            if ($animateCss) {
                                $animateCss(element, {
                                    addClass: 'in',
                                    easing: 'ease',
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).start()['finally'](expandDone);
                            } else {
                                $animate.addClass(element, 'in', {
                                    css: {
                                        overflow: 'hidden'
                                    },
                                    to: getScrollFromElement(element[0])
                                }).then(expandDone);
                            }
                        }, angular.noop);
                }

                function expandDone() {
                    element.removeClass('collapsing')
                        .addClass('collapse')
                        .css(css);
                    expandedExpr(scope);
                }

                function collapse() {
                    if (!element.hasClass('collapse') && !element.hasClass('in')) {
                        return collapseDone();
                    }

                    $q.resolve(collapsingExpr(scope))
                        .then(function() {
                            element
                            // IMPORTANT: The width must be set before adding "collapsing" class.
                            // Otherwise, the browser attempts to animate from width 0 (in
                            // collapsing class) to the given width here.
                                .css(getScrollFromElement(element[0]))
                                // initially all panel collapse have the collapse class, this removal
                                // prevents the animation from jumping to collapsed state
                                .removeClass('collapse')
                                .addClass('collapsing')
                                .attr('aria-expanded', false)
                                .attr('aria-hidden', true);

                            if ($animateCss) {
                                $animateCss(element, {
                                    removeClass: 'in',
                                    to: cssTo
                                }).start()['finally'](collapseDone);
                            } else {
                                $animate.removeClass(element, 'in', {
                                    to: cssTo
                                }).then(collapseDone);
                            }
                        }, angular.noop);
                }

                function collapseDone() {
                    element.css(cssTo); // Required so that collapse works when animation is disabled
                    element.removeClass('collapsing')
                        .addClass('collapse');
                    collapsedExpr(scope);
                }

                scope.$watch(attrs.collapse, function(shouldCollapse) {
                    if (shouldCollapse) {
                        collapse();
                    } else {
                        expand();
                    }
                });
            }
        };
    }]).directive('dropdownCheckboxes', dropdownCheckboxes);

    function dropdownCheckboxes() {
    	return {
        	link: function(scope, element, attrs) {
        		var $btn = $(element).find('button');
        		var $div = $(element).find('div');

        		$btn.click(function(){
        			$(this).toggleClass('btn-active');
        			$div.toggle();
        		});

        	}
    	}
    }

    run.$inject = ['stateHandler', '$rootScope', 'BRAND', 'uibDatepickerPopupConfig'];

    Object.byString = function(o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1');
        s = s.replace(/^\./, '');
        var a = s.split('.');
        for (var i = 0, n = a.length-1; i < n; ++i) {
            var k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    }

    function run(stateHandler, $rootScope, BRAND, uibDatepickerPopupConfig) {
        $rootScope.brand = BRAND || {};
        if (BRAND && BRAND.branding && BRAND.branding.portal_name) {
            document.title = BRAND.branding.portal_name;
        }
        // Date inputs across the app interpolate {{dateformat}} for uib-datepicker-popup.
        // It was never defined, so the popup fell back to parsing typed text as yyyy-MM-dd
        // and silently discarded MM/DD/YYYY entries while the text stayed visible (AP-295).
        // The alternate formats apply to every popup so typed dates parse leniently.
        $rootScope.dateformat = 'MM/dd/yyyy';
        uibDatepickerPopupConfig.altInputFormats = ['M!/d!/yyyy', 'yyyy-MM-dd'];
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'search': {
            	method: 'GET',
            	url: 'api/_search/users',
            	isArray: true
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            backdoor: backdoor,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in

                        //$state.go('accessdenied').then(function() {
                        //LoginService.open();
                        //});
                            //vm.isNavbarCollapsed = true;
                            $state.go('login');

                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function backdoor (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.backdoor(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            return $sessionStorage.previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("anrescowebApp")
    .factory("AuthServerProvider", AuthServerProvider);

  AuthServerProvider.$inject = [
    "$http",
    "$localStorage",
    "$sessionStorage",
    "$q",
  ];

  function AuthServerProvider($http, $localStorage, $sessionStorage, $q) {
    var service = {
      getToken: getToken,
      login: login,
      backdoor: backdoor,
      loginWithToken: loginWithToken,
      storeAuthenticationToken: storeAuthenticationToken,
      logout: logout,
    };

    return service;

    function getToken() {
      return (
        $localStorage.authenticationToken || $sessionStorage.authenticationToken
      );
    }

    function login(credentials) {
      var data = {
        username: credentials.username,
        password: credentials.password,
        rememberMe: credentials.rememberMe,
      };
      return $http.post("api/authenticate", data).success(authenticateSuccess);

      function authenticateSuccess(data, status, headers) {
        var customerId = headers("Customer-ID");
        var contactId = headers("Contact-ID");
        var contactEmail = headers("Contact-Email");
        $localStorage.customerId = customerId;
        $localStorage.contactId = contactId;
        $localStorage.contactEmail = contactEmail;
        $localStorage.language = data.language ? data.language : "English";

        var bearerToken = headers("Authorization");
        if (
          angular.isDefined(bearerToken) &&
          bearerToken.slice(0, 7) === "Bearer "
        ) {
          var jwt = bearerToken.slice(7, bearerToken.length);
          service.storeAuthenticationToken(jwt, credentials.rememberMe);
          return jwt;
        }
      }
    }

    function backdoor(credentials) {
      var data = {
        username: credentials.username,
        password: credentials.password,
        backdoor_username: credentials.backdoor_username,
        rememberMe: credentials.rememberMe,
      };
      return $http.post("api/backdoor", data).success(authenticateSuccess);

      function authenticateSuccess(data, status, headers) {
        console.log(
          "Values returned in backdoor",
          data.language,
          "And \n",
          data
        );
        var customerId = headers("Customer-ID");
        $localStorage.customerId = customerId;
        $localStorage.backdoor_user = true;
        $localStorage.language = data.language ? data.language : "English";

        var isDaichiHeader = headers("Is-Daichi");
        console.log("Is-Daichi header:", isDaichiHeader);
        if (isDaichiHeader === "True") {
          console.log("Setting isDaichi in localStorage");
          $localStorage.isDaichi = "True";
        } else {
          console.log("Not setting isDaichi in localStorage");
        }

        var bearerToken = headers("Authorization");
        if (
          angular.isDefined(bearerToken) &&
          bearerToken.slice(0, 7) === "Bearer "
        ) {
          var jwt = bearerToken.slice(7, bearerToken.length);
          service.storeAuthenticationToken(jwt, credentials.rememberMe);
          return jwt;
        }
      }
    }

    function loginWithToken(jwt, rememberMe) {
      var deferred = $q.defer();

      if (angular.isDefined(jwt)) {
        this.storeAuthenticationToken(jwt, rememberMe);
        deferred.resolve(jwt);
      } else {
        deferred.reject();
      }

      return deferred.promise;
    }

    function storeAuthenticationToken(jwt, rememberMe) {
      if (rememberMe) {
        $localStorage.authenticationToken = jwt;
      } else {
        $sessionStorage.authenticationToken = jwt;
      }
    }

    function logout() {
      delete $localStorage.authenticationToken;
      delete $sessionStorage.authenticationToken;
      delete $localStorage.customer;
      delete $sessionStorage.customer;
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('GraphQLService', GraphQLService);

    GraphQLService.$inject = ['$http', '$q'];

    function GraphQLService($http, $q) {
        var service = {
            query: query,
            publicQuery: publicQuery,
            mutate: mutate
        };

        return service;

        /**
         * Execute a GraphQL query
         * @param {string} queryString - The GraphQL query string
         * @param {object} variables - Variables for the query
         * @returns {promise} Promise with the query result
         */
        function query(queryString, variables) {
            return executeQuery('/api/graphql', queryString, variables);
        }

        /**
         * Execute a public GraphQL query against the limited public schema
         * @param {string} queryString - The GraphQL query string
         * @param {object} variables - Variables for the query
         * @returns {promise} Promise with the query result
         */
        function publicQuery(queryString, variables) {
            return executeQuery('/api/public/graphql', queryString, variables);
        }

        /**
         * Execute a GraphQL mutation
         * @param {string} mutationString - The GraphQL mutation string
         * @param {object} variables - Variables for the mutation
         * @returns {promise} Promise with the mutation result
         */
        function mutate(mutationString, variables) {
            return query(mutationString, variables);
        }

        function executeQuery(endpoint, queryString, variables) {
            return $http.post(endpoint, {
                query: queryString,
                variables: variables || {}
            }).then(function(response) {
                if (response.data.errors) {
                    console.error('GraphQL errors:', response.data.errors);
                    return $q.reject(response.data.errors);
                }
                return response.data.data;
            }).catch(function(error) {
                console.error('GraphQL request failed:', error);
                return $q.reject(error);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$sessionStorage', '$localStorage', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Contact2ForUser', 'CustomerByUser', '$translate'];

    function SidebarController ($rootScope, $scope, $state, $stateParams, $sessionStorage, $localStorage, Auth, Principal, ProfileService, LoginService, Contact2ForUser, CustomerByUser, $translate) {
        var vm = this;

        vm.hideMenu = false;

        $scope.$on('hideMenu', function(newVal) {
            vm.hideMenu = true;
        });

        vm.showsidebar = true;
        if($state.current.name == "customerconfigure"){
            vm.showsidebar = false;
        }
        vm.isSidebarCollapsed = false;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleSidebar = toggleSidebar;
        vm.collapseSidebar = collapseSidebar;
        vm.$state = $state;

        vm.tabs = {
            manage: {
                show: false
            },
            billing: {
                show: false
            },
            submit: {
                show: false
            },
            publicGallery: {
                show: true
            }
        }

        vm.getDbaName = function() {
        	return $sessionStorage.customer ? $sessionStorage.customer.dbaName : $localStorage.customer ? $localStorage.customer.dbaName : '';
        }

        getCustomerData();

        

        function setTabsVisibility(contact, language) {
            var current_user = JSON.parse(localStorage.getItem('jhi-oldUserLogin'))
            current_user = current_user ? current_user.replace(/\"/g, "") : "";
            let country_id = 0;

            if(vm.customerData.country && vm.customerData.country.id) {
                country_id = vm.customerData.country.id;
            }

            // The server applies the Japanese language/country policy and
            // verifies Daichi's identity, including customer impersonation.
            vm.tabs.billing.show = vm.customerData.billingAccess === true;
            vm.tabs.submit.show = true;

            if(($localStorage.isDaichi && $localStorage.isDaichi === 'True') || (country_id === 3 && current_user === 'daichi@anresco.com') || country_id !== 3) {
                vm.tabs.manage.show = true;

            }

            var businessTypeName = (vm.customerData.businessType && vm.customerData.businessType.name)
                ? vm.customerData.businessType.name
                : '';
            if (businessTypeName === 'FDA') {
                vm.tabs.submit.show = false;
                vm.tabs.publicGallery.show = false;
            }
        }

        function getCustomerData() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                    vm.customerData = data;
                    getCurrentContact();
            }
            function onError(error) {
                console.log(error);
            }
        }


        function getCurrentContact() {
            var contact_customer_index = null;

            Contact2ForUser.get({}, onSuccessCustomer, onErrorCustomer);
            function onSuccessCustomer(data, headers) {
                vm.contact = data;

                if(data.contactCustomers && vm.customerData.id) {
                    contact_customer_index = findWithAttr(data.contactCustomers, 'customer_id', vm.customerData.id);
                    if(contact_customer_index != -1) {
                        vm.contact.receive_coa = data.contactCustomers[contact_customer_index].receive_coa;
                        vm.contact.receive_invoice = data.contactCustomers[contact_customer_index].receive_invoice;
                        setTabsVisibility(vm.contact, $localStorage.language)
                        let it;
                        it = setInterval(()=>{
                            let user = localStorage.getItem('jhi-oldUserLogin')
                            // console.log("user",user)
                            if(user) {
                                setTabsVisibility(vm.contact, $localStorage.language)
                                clearInterval(it)
                            }
                        },10)
                    }
                }
            }
            function onErrorCustomer(error) {
                console.log(error);
            }
        }

        function findWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        function login() {
            collapseSidebar();
            $state.go('login');
        }

        function logout() {
            collapseSidebar();
            Auth.logout();
            $state.go('login');
        }

        function toggleSidebar() {
            vm.isSidebarCollapsed = !vm.isSidebarCollapsed;
        }

        function collapseSidebar() {
            vm.isSidebarCollapsed = true;
        }

        vm.japanese_portal = $localStorage.language == 'Japanese' ? true : false;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$rootScope', 'CustomerByUser'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $rootScope, CustomerByUser) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAccbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.tabs = {
            submit: {
                show: false
            }
        }

        getCustomerData();

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.hideDropdown = true; 


        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.toggleAccbar = toggleAccbar;
        vm.collapseAccbar = collapseAccbar;
        vm.$state = $state;

        $rootScope.showSearch = false;
        vm.search = search;
        vm.toggleSearch = toggleSearch;
        vm.closeSearch = closeSearch;


        function getCustomerData() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                var businessTypeName = (data.businessType && data.businessType.name)
                    ? data.businessType.name
                    : '';
                vm.tabs.submit.show = businessTypeName !== 'FDA';
            }
            function onError(error) {
                console.log(error);
            }
        }

        function login() {
            collapseNavbar();
            //LoginService.open();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function toggleAccbar() {
            vm.isAccbarCollapsed = !vm.isAccbarCollapsed;
        }

        function collapseAccbar() {
            vm.isAccbarCollapsed = true;
        }

        function search() {
            $rootScope.searchVm.search(vm.searchQuery);
        }

        function toggleSearch() {
            vm.searchQuery = null;
            $rootScope.showSearch = true;
            $rootScope.$broadcast("focus-search");
            $rootScope.class = "open-search";
        }

        function closeSearch() {
            $rootScope.showSearch = false;
            if (vm.searchQuery) {
                vm.searchQuery = null;
                $rootScope.searchVm.clear();
            }
            $rootScope.class = "close-search";
        }

        $rootScope.$on('$viewContentLoaded', function() {
          angular.element(document).ready(function() {

            $('.scrollbox').enscroll({
              showOnHover: false,
              verticalTrackClass: 'track',
              verticalHandleClass: 'handle'
            });

          });
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('NavbarHeaderController', NavbarHeaderController);

    NavbarHeaderController.$inject = [ '$state', '$stateParams', '$timeout', '$filter', '$sce','focus',
                                        'Auth', 'Principal', 'ProfileService','$location', '$rootScope', '$scope',
                                        '$http', '$localStorage', 'NotificationService', 'Contact2ForUser', 'STAGE', '$translate'];

    function NavbarHeaderController ($state,  $stateParams, $timeout, $filter, $sce, focus,
                                    Auth, Principal, ProfileService, $location, $rootScope, $scope,
                                    $http, $localStorage, NotificationService, Contact2ForUser, STAGE, $translate) {

        var vm = this;
        $translate.use($localStorage.language=="Japanese" ? 'jp' : 'en');
        $rootScope.showSearch = false;
        vm.$state = $state;
        vm.location = $location.path();
        vm.isAuthenticated = true;
        vm.url = $rootScope.toState.name;
        vm.usersList = [];
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        $scope.to_trusted = function(html_code) {
            return $sce.trustAsHtml(html_code);
        }

        vm.logoutCompletely = logoutCompletely

        function logoutCompletely() {
            $localStorage.removeItem('oldUserFirstName')
            $localStorage.removeItem('oldUserLogin')
            logout();
        }


        vm.login = login;
        vm.logout = logout;
        vm.search = search;
        vm.getTopNotifications = getTopNotifications;

        vm.toggleSearch = toggleSearch;
        vm.closeSearch = closeSearch;

        $rootScope.isActive = false;
        $rootScope.toggleSidebar = function() {
             $rootScope.isActive = !$rootScope.isActive;
        }

// YEET: Hiding for now
//        setInterval(function(){
//            if(Principal.isAuthenticated()){
//                getTopNotifications();
//            }
//        }, 60000);

        vm.customers = [];
        Contact2ForUser.get({}, function(res){
        	vm.customers = [];
        	if (res) {
                vm.contact = res;
                if(vm.contact.first_name) {
                    vm.contact.first_name_letter = vm.contact.first_name[0].toUpperCase()
                }
                if(vm.contact.last_name) {
                    vm.contact.last_name_letter = vm.contact.last_name[0].toUpperCase()
                }


        		for (var i = 0; i < res.contactCustomers.length; i++) {
        			vm.customers.push(res.contactCustomers[i].customer);
        			if ($localStorage.customerId == res.contactCustomers[i].customer.id) {
                        vm.selectedCustomer = res.contactCustomers[i].customer;
        				$('#companyPageButton').prop('href', "#/companypage?hash=" + vm.selectedCustomer.hash)
        			}
        		}
        	}
        });

        vm.switchCustomer = function(customer) {
            vm.selectedCustomer = customer;
            $localStorage.customerId = customer.id;
            $rootScope.customer = {};
            $rootScope.customer.customer_type = customer.businessType ? customer.businessType.name : 'Cannabis';
            $rootScope.customer.customer_discount = customer.customer_discount ? customer.customer_discount :  null;
            $localStorage.language = customer.language ? customer.language : 'English';
            $state.reload();
        }

        function getTopNotifications() {
            NotificationService.getTopNotifications({}, onSuccess, onError);

            function onSuccess(data, headers) {
                $rootScope.topNotifications = data;

                    if(parseInt($state.params.page) === 1){

                    if($rootScope.allNotifications){
                        for( var i = 0; i < $rootScope.topNotifications.length; i++ ) {


                            const resoult = $rootScope.allNotifications.filter( function(element) {
                               return element.id === $rootScope.topNotifications[i].id
                            } )


                            if(resoult.length === 0) {
                                $rootScope.allNotifications.unshift($rootScope.topNotifications[i])
                                $rootScope.allNotifications.pop()
                            }
                        }
                    }

                }

                $rootScope.newNotification =  $filter('filter')( $rootScope.topNotifications, {notificationRead: false}).length
            }

            function onError(error) {}
        }

        $scope.notificationSettings = function(){
            $rootScope.notificationTab = 2;
            $location.path('customer-manage');
        }

        $scope.readNotification = function(id){
                $http.put('api/notifications/mark-as-read/'+id).then(
                    function(response) {

                        for( var i = 0; i < $rootScope.topNotifications.length; i++ ) {
                            if ($rootScope.topNotifications[i].id === id ){
                                $rootScope.topNotifications[i] = response.data;
                            }
                        }

                        for( var j = 0; j < $rootScope.allNotifications.length; j++ ) {
                            if ($rootScope.allNotifications[j].id === id ){
                                $rootScope.allNotifications[j] = response.data;
                            }
                        }

                        $rootScope.newNotification =  $filter('filter')( $rootScope.topNotifications, {notificationRead: false}).length
                    }
            );
        }

		$scope.toggleGalleryView = function (galleryState) {
        	$rootScope.galleryView = galleryState;
        };

        /*
        $rootScope.showPublicViewMenu = false;

        $scope.toggleShowPublicViewMenu = function () {
        	$rootScope.showPublicViewMenu = !$rootScope.showPublicViewMenu;
        };
        */

        $scope.markAllAsRead = function(){
            NotificationService.markAllAsRead({}, onSuccess, onError);
            function onSuccess(data, headers) {
                $rootScope.topNotifications = data;

                for( var j = 0; j < $rootScope.topNotifications.length; j++ ) {
                    $rootScope.topNotifications[j].topNotifications = true;
                }

                $scope.newNotification =  $filter('filter')( $rootScope.topNotifications, {notificationRead: false}).length
            }
            function onError(error) {}
        }


        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function search() {
            $rootScope.searchVm.search(vm.searchQuery);
        }

        function toggleSearch() {
            vm.searchQuery = null;
            $rootScope.showSearch = true;
            $rootScope.$broadcast("focus-search");
            $rootScope.class = "open-search";
        }

        function closeSearch() {
            $rootScope.showSearch = false;
            if (vm.searchQuery) {
                vm.searchQuery = null;
                $rootScope.searchVm.clear();
            }
            $rootScope.class = "close-search";
        }

        function logout() {
            NotificationService.markAllAsRead({}, callback, callback);
            function callback(data, headers) {
                collapseNavbar();
                $localStorage.$reset();
                Auth.logout();
                $state.go('login', {reload:true});
                vm.customers = [];
            }
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        $rootScope.$on('$viewContentLoaded', function() {
          angular.element(document).ready(function() {

            $('.scrollbox').enscroll({
              showOnHover: false,
              verticalTrackClass: 'track',
              verticalHandleClass: 'handle'
            });

          });

        });

    }

})();

$(document).click(function(e) {


	  if( e.target.id != 'publicPageMenu' && e.target.id != 'selectPublicAction' ) {
	    $("#publicPageMenu").hide();
	  }
});
angular.module("anrescowebApp").directive("focusOn",['$timeout', function($timeout) {
  return {
    restrict: "A",
    link: function(scope, element, attrs) {
      scope.$on(attrs.focusOn, function(e) {
        $timeout((function() {
          element[0].focus();
        }), 10);
      });
    }
  };
}]);

(function() {
//not used!!!
    angular
        .module('anrescowebApp')
        .factory('focus', ['$rootScope','$timeout', function ($rootScope, $timeout) {
          return function(name) {
            $timeout(function (){
              $rootScope.$broadcast('focusOn', name);
            });
  }
}]);
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        }).state('home.dayModal', {
            url: 'home/calendar/day',
            params: {
            	date: null,
            	samples: null,
            	queryParams: null
            },
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$uibModal', function($uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/calendar/calendar-day-modal.html',
                    controller: 'CalendarDayModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                    	PreviousState: function() {
                    		return {
                    			name: 'home'
                    		}
                    	}
                    }
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope','$rootScope','$window', '$localStorage', 'Customer', 'Principal', 'LoginService', '$state', '$filter','Auth',
                                'ProfileService','CustomerByUser','CustomerOrder', 'Contact2ForUser', 'Invoice','Sample', 'SampleFilter', 'ProductCategory', 'Config', '$translate', 'BRAND'];

    function HomeController ($scope,$rootScope, $window, $localStorage, Customer, Principal, LoginService, $state, $filter, Auth,
                            ProfileService,CustomerByUser,CustomerOrder, Contact2ForUser, Invoice, Sample, SampleFilter, ProductCategory, Config, $translate, BRAND) {

        var vm = this;
        var brand = BRAND || {};
        var brandReps = brand.customer_reps || {};
        var defaultPrimaryRep = {
            name: (brand.branding && brand.branding.portal_team_name) || 'Client Services',
            email: (brand.contact && (brand.contact.support_email || brand.contact.info_email)) || '',
            phone: (brand.contact && brand.contact.main_phone) || ''
        };
      

        vm.currentLanguage = $translate.proposedLanguage();
        angular.element(document).ready(function() {
            angular.element('#wrap').addClass("wrap");
        });

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;

        });
        var current_user = JSON.parse(localStorage.getItem('jhi-oldUserLogin'))
        if(current_user){
            vm.current_user = current_user.replace(/\"/g, "")
        }
        vm.login = login;

        vm.logout = logout;
        vm.customer_type = null;
        vm.account_balance = 0;
        vm.billingAccess = false;
        vm.primary_rep = angular.copy(brandReps.default_primary_rep || (brandReps.primary_rep_list || [])[0] || defaultPrimaryRep);

        if(!vm.isAuthenticated()){
            $localStorage.$reset()
            $state.go('login');
        }

        getCustomerData();

        getCustomerOrdersDate();

        vm.visitOurSite = function () {
            var marketingUrl = (brand.web && (brand.web.marketing_url || brand.web.portal_url)) || window.location.origin;
            $window.open(marketingUrl);
        }

        setPageTitle();

        vm.selectDaterangePassFailChart = selectDaterangePassFailChart;
        google.charts.load('current', {packages: ['corechart']});
        google.charts.setOnLoadCallback(initPassFailChart);

        getQueuedSamples();

        // Calendar Widget
        vm.blackoutDates = []
       
        vm.monthString = moment().format('MMMM YYYY');
        vm.events = [];
        vm.filterSamples = function() {
        	vm.calendarLoading = true;

        	SampleFilter.calendar(createQueryParams(), function(samples){
        		vm.calendarLoading = false;
                vm.calendarLoadError = false;

                var start_date = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.start._d);
				var end_date = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.end._d)

				for(var m = moment(start_date); m.diff(end_date, 'days') <= 0; m.add(1, 'days')) {
                    if([0, 6].includes(m.day()) || vm.holidays.includes(m.format('YYYY-MM-DD'))) {
                        vm.blackoutDates.push(m.format('YYYY-MM-DD'));
                    }
                }

        		var events = [];
        		if (samples && samples.length) {
        			var dayMap = {}
        			for (var i = 0; i < samples.length; i++) {
        				var day = moment(samples[i].dueDate).toDate();
        				var dayKey = samples[i].dueDate;
        				if (!dayMap[dayKey]) dayMap[dayKey] = []
        				var event = {
        						id: samples[i].id,
        						name: samples[i].name ? samples[i].name : '',
        						title: samples[i].id + ' ' + samples[i].name,
        						start: day,
        						end: day,
        						allDay: true,
        						hash: samples[i].hash
        				}
        				dayMap[dayKey].push(event)
        			}
        			for (var k in dayMap) {
    					dayMap[k].push({
    						id: '-1',
    						name: 'Nothing',
    						title: 'Nothing',
    						start: dayMap[k][0].start,
    						end: dayMap[k][0].end,
    						allDay: true,
    						hash: null
    					});
    					events = events.concat(dayMap[k]);
        			}
        		}
        		vm.events[0] = events;
        		$('#estimatedDueDateCalendar').fullCalendar('getView').dayGrid.renderGrid();


        	}, function(error) {
        		vm.calendarLoading = false;
        		vm.calendarLoadError = true;
        	});
        }

        vm.filterOptions = [
        	{text: "R&D", value: 'R&D'},
        	{text: "Compliance", value: 'COMPLIANCE'}
        ];
        var categoryNames = [];
        ProductCategory.query(function(categories){
        	if (!categories) return;
        	for (var i = 0; i < categories.length; i++){
        		vm.filterOptions.push({text: categories[i].name, value: categories[i].id});
        		categoryNames.push(categories[i].name);
        	}
        });
        vm.backgroundImages = {
			'2023-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2023-02-15': 'content/images/calendar_images/PresidentsDay.jpg',
			'2023-05-31': 'content/images/calendar_images/MemorialDay.jpg',
			'2023-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2023-09-06': 'content/images/calendar_images/LaborDay.jpg',
            '2023-11-25': 'content/images/calendar_images/thanksGiving.png',
			'2023-11-26': 'content/images/calendar_images/thanksGiving1.png',
			'2023-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2023-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2023-12-31': 'content/images/calendar_images/newYearEve.jpg',

			'2024-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2024-02-15': 'content/images/calendar_images/PresidentsDay.jpg',
			'2024-05-27': 'content/images/calendar_images/MemorialDay.jpg',
			'2024-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2024-09-02': 'content/images/calendar_images/LaborDay.jpg',
			'2024-11-28': 'content/images/calendar_images/thanksGiving.png',
			'2024-11-29': 'content/images/calendar_images/thanksGiving1.png',
			'2024-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2024-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2024-12-31': 'content/images/calendar_images/newYearEve.jpg',

			'2025-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2025-02-17': 'content/images/calendar_images/PresidentsDay.jpg',
			'2025-05-26': 'content/images/calendar_images/MemorialDay.jpg',
			'2025-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2025-09-01': 'content/images/calendar_images/LaborDay.jpg',
			'2025-11-27': 'content/images/calendar_images/thanksGiving.png',
			'2025-11-28': 'content/images/calendar_images/thanksGiving1.png',
			'2025-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2025-12-25': 'content/images/calendar_images/Christmas1.jpg',

			'2026-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2026-02-16': 'content/images/calendar_images/PresidentsDay.jpg',
			'2026-05-25': 'content/images/calendar_images/MemorialDay.jpg',
			'2026-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2026-09-07': 'content/images/calendar_images/LaborDay.jpg',
			'2026-11-26': 'content/images/calendar_images/thanksGiving.png',
			'2026-11-27': 'content/images/calendar_images/thanksGiving1.png',
			'2026-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2026-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2026-12-31': 'content/images/calendar_images/newYearEve.jpg'

		};

        getOrdersOpenSubmission();

        function setCalendarOptions() {
            vm.calendarOptions = {
                    defaultView: 'week',
                    firstDay: 1,
                    views: {
                        week: {
                            type: 'basic',
                            duration: {
                                weeks: 3
                            }
                        }
                    },
                    height: 300,
                    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    dayNamesShort: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    eventLimit: 1,
                    eventLimitClick: function(cellInfo, jsEvent) {
                        var modalParams = {samples: []};
                        for (var i = 0; i < cellInfo.segs.length; i++){
                            var def = cellInfo.segs[i].footprint.eventInstance.def;
                            modalParams.samples.push({
                                id: def.id,
                                name: def.miscProps.name,
                                hash: def.miscProps.hash
                            });
                        }
                        modalParams.date = cellInfo.date;
                        modalParams.queryParams = createQueryParams();
                        $state.go('home.dayModal', modalParams);
                    },
                    eventLimitText: function(count) {
                        return count - 1;
                    },
                    eventRender: function(event, element) {
                        return '<div class="calendar-sample-event"><strong>' + event.id + '</strong> ' + event.name + '</div>'
                    },
                    eventClick: function(event, jsEvent, view) { $state.go('public', {hash: event.hash}); },
                    viewRender: vm.filterSamples,
                    dayRender: function(date, cell) {
                        cell.append('<div class="calendar-day-no-samples">No Samples</div>');
                        var currentDate = date.format('YYYY-MM-DD');
					if (currentDate in vm.backgroundImages) {
						var cellId = 'cell_' + currentDate;
						cell.attr('id', cellId);
						var backgroundImageUrl = vm.backgroundImages[currentDate];
						cell.css('background-image', 'url(' +backgroundImageUrl+ ')');
						cell.css('object-fit','contain')
						cell.css('background-size','100% 100%');
						cell.find('div.calendar-day-no-samples').css('opacity', '0');
						

						// Remove "Closed" text on days with events
						var dayOfWeek = moment(date).day();
						if (dayOfWeek === 0 || dayOfWeek === 6) {
							cell.find('.fc-day-top').text('');
							cell.find('div.calendar-day-no-samples').remove();
						}
					}
                    },
                    eventAfterAllRender: function(view) {
                        $('#estimatedDueDateCalendar').fullCalendar('clientEvents', function(event) {
                            var td = $('td.fc-day[data-date="' + event.start.format('YYYY-MM-DD') + '"]');
                            td.find('div:first').remove();
                        });

                        var blackout = null;
                        var blackoutCount = null;
                        vm.holidayDates = Object.keys(vm.backgroundImages);
                        var name = " "
                        vm.blackoutDates.forEach( function(date) {
                            blackout = $('td.fc-day[data-date="' + date + '"]');
                            blackout.css('background-color', '#f7f7f7');
                            blackout.find('div.calendar-day-no-samples').css('color', '#c5ced1').text(`Closed\r\n${name}`);
                        });
                        vm.holidayDates.forEach(function(date){
                            blackout = $('td.fc-day-top[data-date="' + date + '"]');
                            blackout.css('visibility', 'hidden');
                        })
                    }
            }
        }
                     

        function createQueryParams() {
        	var params = {};
        	params.estimatedDueDateLower = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.start._d);
        	params.estimatedDueDateUpper = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.end._d);

        	for (var i = 0; i < vm.filterOptions.length; i++) {
        		if (!vm.filterOptions[i].selected) continue;

        		var text = vm.filterOptions[i].text;
        		var value = vm.filterOptions[i].value;

        		// Parse category filter
        		if (categoryNames.indexOf(text) !== -1) {
        			if (params.categoryIdList === undefined) {
        				params.categoryIdList = [value];
        			} else {
        				params.categoryIdList.push(value);
        			}
        		// Parse order type filter
        		} else if (text === 'Compliance') {
        			params.orderType = params.orderType === 'R&D' ? null : value;
        		} else if (text === 'R&D') {
        			params.orderType = params.orderType === 'COMPLIANCE' ? null : value;
        		}
        	}
        	return params;
        }

        function setPageTitle(){
            $rootScope.pageTitle = "Welcome";
        }

        function getCustomerData() {
            Config.holidays({},
                function(data) {
                    var arrayOfHolidays = []
                    data.holidays.forEach(element => {
                        for(var i = 1924; i <= 9999; i++){
                            if (element.date) {
                                var s = element.date.replace('2021',i.toString())
                                arrayOfHolidays.push(s);
                            }
                        } 
                    })
                    vm.holidays = arrayOfHolidays
                    // vm.holidays = data.holidays
                    setCalendarOptions();
                },
                function(e) {
                    console.log(e);
                }
            );

            CustomerByUser.get({}, onSuccessCustomer, onErrorCustomer);
            function onSuccessCustomer(data, headers) {
            	if (data.account_balance == 'null'){
            		data.account_balance = null;
            	}
                vm.customerData = data;
                vm.billingAccess = data.billingAccess === true;
                getRecentInvoices();

                $rootScope.customer = {
                    customer_type: data.businessType && data.businessType.name ? data.businessType.name : 'Cannabis',
                    company_discount: data.company_discount ? data.company_discount : null,
                    customer_id: data.id ? data.id : null
                }

                $localStorage.customer = {
                    id: data.id,
                    dbaName: data.dbaName,
                }

                vm.customer_type = $rootScope.customer.customer_type;

                if(data.primary_anresco_email || data.primary_anresco_rep){
                    vm.primary_rep = {
                        name: data.primary_anresco_rep,
                        email: data.primary_anresco_email,
                        phone: data.primary_anresco_phone
                    };
                };
                getCurrentContact();
            }
            function onErrorCustomer(error) {
                console.log(error);
            }
        }

        function getOrdersOpenSubmission() {
        	CustomerOrder.openSubmissions({}, onSuccessSubmissions, onErrorSubmissions);

        	function onSuccessSubmissions(data) {
        		vm.openSubmissions = data.openSubmissions;
            }

        	function onErrorSubmissions(error) {
                console.log(error);
            }
        }

        
        
        function refreshStorage(){
            $localStorage.oldUserFirstName = null
            $localStorage.oldUserLogin = null
            $localStorage.oldUserLogin = JSON.stringify(vm.contact.login);
            $localStorage.oldUserFirstName = JSON.stringify(vm.contact.first_name);
        }

        function getUnpaidInvoices() {
            Invoice.getUnpaid({},
                function(data) {
                    data.invoices.forEach( function(invoice) {
                        vm.account_balance += invoice.outstanding_amount;
                    });
                },
                function(e) {
                    console.log(e);
                }
            );
        }



        function getCurrentContact() {
            var contact_customer_index = null;

            Contact2ForUser.get({}, onSuccessCustomer, onErrorCustomer);
            function onSuccessCustomer(data, headers) {
                vm.contact = data;

                if(data.contactCustomers && vm.customerData.id) {
                    contact_customer_index = findWithAttr(data.contactCustomers, 'customer_id', vm.customerData.id);
                    if(contact_customer_index != -1) {
                        vm.contact.receive_coa = data.contactCustomers[contact_customer_index].receive_coa;
                        vm.contact.receive_invoice = data.contactCustomers[contact_customer_index].receive_invoice;
                    }
                }
                

                if(vm.billingAccess && vm.contact.receive_invoice) {
                    getUnpaidInvoices();
                }

                refreshStorage();
                $rootScope.userFirstName = vm.contact.first_name;
            }
            function onErrorCustomer(error) {
                console.log(error);
            }
        }

        function findWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }

        function getRecentInvoices() {
            if (!vm.billingAccess) return;
            Invoice.query({
                page: 0,
                size: 5,
                sort: sortInv()
            }, onSuccessInv, onErrorInv);
            function sortInv() {
                var result = ['invoiceDate' + ',' + 'desc'];
                return result;
            }
            function onSuccessInv(data, headers) {
                vm.invoices = data;
            }
            function onErrorInv(error) {
                console.log(error);
            }

        }

        function getCustomerOrdersDate() {
            CustomerOrder.query({
                page: 0,
                size: 5,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = ['dateCreated' + ',' + 'desc'];
                return result;
            }
            function onSuccess(data, headers) {
                vm.customerOrders = data;
          
            }
            function onError(error) {
                console.error("Error fetching limited customer orders:", error);


            }

        }

        function getCustomerOrdersLimited() {
            CustomerOrder.CustomerOrdersLimited({page: 0, size: 5, sort: 'desc'}, function(data) {
              vm.customerOrdersLimited = data.map(order => ({
                    id: order.order_id,  
                    sampleCount: order.sample_count,
                    state: order.state,
                    stateLabel: order.stateLabel.replace(/_/g, ' '),

                    dateReceived: order.date_received, 
                    samples: order.samples.map(sample => ({
                        id: sample.id,
                        name: sample.name,
                        hash: sample.hash 
                    }))
                }));
            }, function(error) {
                console.error("Error fetching limited customer orders:", error);
            });
        }
        
        
        // Call the new function
        getCustomerOrdersLimited();

        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

		// forces the 'resize' callback
		// to wait setTimeout ms value time before
		// considering a resize as 'complete'

		function onResize(c,t) {
			onresize = function() { // refers to window.onresize callback
				clearTimeout(t);
				t = setTimeout(c,250);
				};
			return c;
			};

		// redraws pie chart
		onResize(function(){
			initPassFailChart();
            selectDaterangePassFailChart();
            drawPassFailChart(vm.passFailData);
		});

		// necessary to redraw chart
		vm.passFailData = null;

        function initPassFailChart() {
            vm.dateranges = [
            	'Last 3 Months',
            	'Last 6 Months',
            	'Year To Date',
            	'All'
            ];

            vm.selectedDaterangePassFailChart = vm.dateranges[0];

            Sample.passFailCount({daterange: vm.selectedDaterangePassFailChart}, function(passFailData){
            	if ((passFailData.Passing + passFailData.Failing + passFailData.Other) == 0) {
        			angular.element('#pie-chart').html("<div style='text-align:center;'>"+$translate.instant('No Statistics Available For This Time Range')+"</div>")
        			return
        		}

        		angular.element('#pie-chart').html("")
            	vm.passFailData = passFailData;
            	drawPassFailChart(vm.passFailData);
            });
        }

        function selectDaterangePassFailChart() {
        	Sample.passFailCount({daterange: vm.selectedDaterangePassFailChart}, function(passFailData){
        		if ((passFailData.Passing + passFailData.Failing + passFailData.Other) == 0) {
        			angular.element('#pie-chart').html("<div style='text-align:center;'>"+$translate.instant('No Statistics Available For This Time Range')+"</div>")
        			return
        		}

        		angular.element('#pie-chart').html("");
				vm.passFailData = passFailData;
        		drawPassFailChart(vm.passFailData);
        	});
        }

        function drawPassFailChart(passFailData) {
            // only draw if on home page
            if ($rootScope.toState.name == 'home' && passFailData) {
                var data = new google.visualization.DataTable();
                data.addColumn('string', 'Status');
                data.addColumn('number', 'Count');

                var colors = [
                    '#a6c65c', // Passing
                    '#c86968', // Failing
                    '#415168' // Other
                ];

                data.addRow(['Passing', passFailData.Passing ? passFailData.Passing : 0]);
                data.addRow(['Failing', passFailData.Failing ? passFailData.Failing : 0]);
                data.addRow(['No Status', passFailData.Other ? passFailData.Other : 0]);

                var options = {
                    backgroundColor: 'transparent',
                    pieHole: 0.7,
                    pieSliceText: 'value',
                    pieSliceTextStyle: {
                        color: 'black',
                        fontSize: 1,
                        opacity: 0, // hides text on chart
                        visibility: 'hidden'  // hides text on chart
                    },
                    tooltip: {
                        text: 'value'
                    },
                    chartArea: {
                        top: 30,
                        right: 25,
                        width: '100%',
                        height: '100%'
                    },
                    height: '100%',
                    width: '100%',
                    legend: {
                        position: 'left',
                        alignment: 'center',
                        maxLines: 2,
                        textStyle: {
                            color: '#003f7f',
                            fontSize: 12,
                            fontName: 'OpenSans-Regular',
                            marginBottom: 50,
                            bold: true,
                            toolText: '%'
                        }

                    },
                    colors: colors//,

                };

                var optionsMobile = {
                    backgroundColor: 'transparent',
                    pieHole: 0.7,
                    pieSliceText: 'value',
                    pieSliceTextStyle: {
                        color: 'black',
                        fontSize: 1,
                        opacity: 0, // hides text on chart
                        visibility: 'hidden'  // hides text on chart
                    },
                    tooltip: {
                        text: 'value'
                    },
                    chartArea: {
                        top: 30,
                        left: 0,
                        width: '100%',
                        height: 200
                    },
                    height: 400,
                    width: 270,
                    legend: {
                        position: 'bottom',
                        alignment: 'left',
                        maxLines: 1,
                        textStyle: {
                            color: '#003f7f',
                            fontSize: 12,
                            fontName: 'Open Sans',
                            bold: true,
                            toolText: '%'
                        }

                    },
                    colors: colors//,

                };

                var chart = new google.visualization.PieChart(angular.element('#pie-chart')[0]);
                chart.draw(data, options);

                var chartSmall = new google.visualization.PieChart(angular.element('#pie-chart-mobile')[0]);
                chartSmall.draw(data, optionsMobile);
            }
        }

        function getQueuedSamples() {
        	Sample.incompleteCount(function(data){
        		vm.queuedSamplesCount = data.count;

        	});
        }

        /* Date Utils (import DateUtils service doesn't work) */
        function convertLocalDateFromServer(date) {
    		if (!date) return;

    		if (date.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) utcDateString += 'Z';

            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        vm.openPublicSample = function(event, jsEvent, view) {
        	$state.go('public', {hash: event.hash});
        }

        angular.element(document).ready(function() {


            setTimeout(function () {

                $("#table-payment tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li id='payment-dot-"+index+"' class='tbl-dot-" + index + "'><span  class='tbl-dot'></span></li>";
                    $('#dots-payment').append(addLi);
                });

                var num_col = $("#table-payment tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;
                $("#table-payment tr:first > th").css("width", col_width+"%");

                $("#payment-col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#payment-col-prev").attr('disabled', 'disabled');
                        $("#payment-col-next").prop("disabled", false);
                    }
                    $('.table-payment-col-' + constant).show();
                    $('.table-payment-col-' + constant2).show();
                    $('#payment-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.table-payment-col-' + x).hide();
                    $('#payment-dot-' + x).removeClass('active').addClass('disabled');
                    if(constant == 2 || constant2 >= 2){
                        $("#payment-col-next").prop("disabled", false);
                    }
                });

                $("#payment-col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.table-payment-col-'  + constant).show();
                    $('.table-payment-col-'  + constant2).show();
                    $('#payment-dot-' + constant).removeClass('disabled').addClass('active');
                    $('#payment-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.table-payment-col-'  + x).hide();
                    $('#payment-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#payment-col-next").attr('disabled', 'disabled');
                        $("#payment-col-prev").prop("disabled", false);
                    }
                    $("#payment-col-prev").prop("disabled", false);
                });

            }, 1000);

            //orders table dots
            if(false) {
                setTimeout(function () {

                    $("#table-orders tr:first > th").each(function(index, element) {
                        index++;
                        var addLi = "<li id='orders-dot-"+index+"' class='tbl-dot-" + index + "'><span  class='tbl-dot'></span></li>";
                        $('#dots-orders').append(addLi);
                    });

                    var num_col = $("#table-orders tr:first > th").length;
                    var constant = 2;
                    var constant2 = constant + 1;

                    var col_width = 100 / num_col;
                    $("#table-orders tr:first > th").css("width", col_width+"%");

                    $("#orders-col-prev").click(function() {
                        constant -= 1;
                        constant2 -= 1;
                        if (constant == 2 || constant2 == 2) {
                            $("#orders-col-prev").attr('disabled', 'disabled');
                            $("#orders-col-next").prop("disabled", false);
                        }
                        $('.table-orders-col-' + constant).show();
                        $('.table-orders-col-' + constant2).show();
                        $('#orders-dot-' + constant).removeClass('disabled').addClass('active');
                        var x = constant2 + 1;
                        $('.table-orders-col-' + x).hide();
                        $('#orders-dot-' + x).removeClass('active').addClass('disabled');
                        if(constant == 2 || constant2 >= 2){
                            $("#orders-col-next").prop("disabled", false);
                        }
                    });

                    $("#orders-col-next").click(function() {
                        constant += 1;
                        constant2 += 1;
                        $('.table-orders-col-'  + constant).show();
                        $('.table-orders-col-'  + constant2).show();
                        $('#orders-dot-' + constant).removeClass('disabled').addClass('active');
                        $('#orders-dot-' + constant2).removeClass('disabled').addClass('active');
                        var x = constant - 1;
                        var x2 = constant2 - 1;
                        $('.table-orders-col-'  + x).hide();
                        $('#orders-dot-' + x).removeClass('active').addClass('disabled');
                        if (constant >= num_col || constant2 >= num_col) {
                            $("#orders-col-next").attr('disabled', 'disabled');
                            $("#orders-col-prev").prop("disabled", false);
                        }
                        $("#orders-col-prev").prop("disabled", false);
                    });

                }, 1000);
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SyncQbLogController', SyncQbLogController);

    SyncQbLogController.$inject = ['$state', 'SyncQbLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SyncQbLogController($state, SyncQbLog, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            SyncQbLog.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.syncQbLogs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SyncQbLog', SyncQbLog);

    SyncQbLog.$inject = ['$resource', 'DateUtils'];

    function SyncQbLog ($resource, DateUtils) {
        var resourceUrl =  'api/sync-qb-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.syncDateTime = DateUtils.convertDateTimeFromServer(data.syncDateTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sync-qb-log', {
            parent: 'entity',
            url: '/sync-qb-log?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SyncQbLogs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-logs.html',
                    controller: 'SyncQbLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('sync-qb-log-detail', {
            parent: 'sync-qb-log',
            url: '/sync-qb-log/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SyncQbLog'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-log-detail.html',
                    controller: 'SyncQbLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SyncQbLog', function($stateParams, SyncQbLog) {
                    return SyncQbLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sync-qb-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sync-qb-log-detail.edit', {
            parent: 'sync-qb-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-log-dialog.html',
                    controller: 'SyncQbLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SyncQbLog', function(SyncQbLog) {
                            return SyncQbLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sync-qb-log.new', {
            parent: 'sync-qb-log',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-log-dialog.html',
                    controller: 'SyncQbLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                syncDateTime: null,
                                success: null,
                                updatedContacts: null,
                                updatedCustomers: null,
                                updatedTests: null,
                                updatedSamples: null,
                                updatedOrders: null,
                                deletedContacts: null,
                                deletedCustomers: null,
                                deletedTests: null,
                                deletedSamples: null,
                                deletedOrders: null,
                                errorsGlobal: null,
                                errorsContacts: null,
                                errorsCustomers: null,
                                errorsOrders: null,
                                errorLog: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sync-qb-log', null, { reload: 'sync-qb-log' });
                }, function() {
                    $state.go('sync-qb-log');
                });
            }]
        })
        .state('sync-qb-log.edit', {
            parent: 'sync-qb-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-log-dialog.html',
                    controller: 'SyncQbLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SyncQbLog', function(SyncQbLog) {
                            return SyncQbLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sync-qb-log', null, { reload: 'sync-qb-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sync-qb-log.delete', {
            parent: 'sync-qb-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sync-qb-log/sync-qb-log-delete-dialog.html',
                    controller: 'SyncQbLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SyncQbLog', function(SyncQbLog) {
                            return SyncQbLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sync-qb-log', null, { reload: 'sync-qb-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SyncQbLogDeleteController',SyncQbLogDeleteController);

    SyncQbLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'SyncQbLog'];

    function SyncQbLogDeleteController($uibModalInstance, entity, SyncQbLog) {
        var vm = this;

        vm.syncQbLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SyncQbLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SyncQbLogDetailController', SyncQbLogDetailController);

    SyncQbLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SyncQbLog'];

    function SyncQbLogDetailController($scope, $rootScope, $stateParams, previousState, entity, SyncQbLog) {
        var vm = this;

        vm.syncQbLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('anrescowebApp:syncQbLogUpdate', function(event, result) {
            vm.syncQbLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SyncQbLogDialogController', SyncQbLogDialogController);

    SyncQbLogDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'SyncQbLog'];

    function SyncQbLogDialogController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, SyncQbLog) {
        var vm = this;

        vm.syncQbLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.syncQbLog.id !== null) {
                SyncQbLog.update(vm.syncQbLog, onSaveSuccess, onSaveError);
            } else {
                SyncQbLog.save(vm.syncQbLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:syncQbLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.syncDateTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('faq-manage', {
            parent: 'entity',
            url: '/faq-manage',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'FAQ Manage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faq.html',
                    controller: 'FaqManageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: false
                },
                sort: {
                    value: 'id',
                    squash: false
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('faq-category-detail', {
            parent: 'faq-manage',
            url: '/faq-category/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'FAQ Manage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/faq/faq-category-detail.html',
                    controller: 'FaqCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'FaqManageService', function($stateParams, FaqManageService) {
                    return FaqManageService.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'faq-manage',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('faq-category-detail.edit', {
            parent: 'faq-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-category-dialog.html',
                    controller: 'FaqCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FaqManageService', function(FaqManageService) {
                            return FaqManageService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq-manage', null, { reload: true });
                }, function() {
                    $state.go('faq-manage');
                });
            }]
        })
        .state('faq-detail', {
            parent: 'faq-category-detail',
            url: '/faq/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-add-new-dialog.html',
                    controller: 'FaqAddNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FAQService', function(FAQService) {
                            return FAQService.getFaq({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('faq-category-detail.new', {
            parent: 'faq-manage',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-category-dialog.html',
                    controller: 'FaqCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                categoryTitle: null,
                                faq: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('faq-manage', null, { reload: 'faq-manage' });
                }, function() {
                    $state.go('faq-manage');
                });
            }]
        })
        .state('faq-add-new', {
            parent: 'faq-manage',
            url: '/add-new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-add-new-dialog.html',
                    controller: 'FaqAddNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                categoryTitle: null,
                                faq: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('faq-manage', null, { reload: 'faq-manage' });
                }, function() {
                    $state.go('faq-manage');
                });
            }]
        })
        .state('faq-edit', {
            parent: 'faq-category-detail',
            url: '/edit-faq/{questionId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-edit-dialog.html',
                    controller: 'FaqEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {};
                        }
                    }

                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('faq-category-detail.delete', {
            parent: 'faq-manage',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/faq/faq-category-delete-dialog.html',
                    controller: 'FaqCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FaqManageService', function(FaqManageService) {
                            return FaqManageService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('faq-manage', null, { reload: 'faq-manage' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqManageController', FaqManageController);

    FaqManageController.$inject = ['$state','$rootScope', 'FaqManageService', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FaqManageController($state, $rootScope, FaqManageService, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "FAQ Manage";
        }

        loadAll();

        function loadAll() {
            FaqManageService.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.categories = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('FaqManageService', FaqManageService);

    FaqManageService.$inject = ['$resource', 'DateUtils'];

    function FaqManageService ($resource, DateUtils) {
        var resourceUrl =  'api/faq-category/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.syncDateTime = DateUtils.convertDateTimeFromServer(data.syncDateTime);
                    }
                    return data;
                },
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqCategoryDetailController', FaqCategoryDetailController);

    FaqCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity','FAQService' ];

    function FaqCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, FAQService ) {
        var vm = this;

        vm.categories = entity;
        vm.previousState = previousState.name;
        vm.deleteFaq = deleteFaq;

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "FAQ";
        }

        function deleteFaq(id){
            FAQService.deleteFaq(id).then(function (response) {
                const index = vm.categories.faq.findIndex( function(element){
                    return element === id
                });
                vm.categories.faq.splice(index,1)
            }).catch(function (error) {
                console.log(error)
            })
        }

        var unsubscribe = $rootScope.$on('anrescowebApp:FaqManage', function(event, result) {
            vm.categories = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqCategoryDialogController', FaqCategoryDialogController);

    FaqCategoryDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'FaqManageService'];

    function FaqCategoryDialogController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, FaqManageService) {
        var vm = this;

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "FAQ Manage";
        }

        vm.category = entity;
        vm.clear = clear;
        vm.save = save;
        vm.addNewFaq = addNewFaq;
        vm.newFaq = {
            question:'',
            answer:'',
        }


        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function addNewFaq () {
            console.log(vm.newFaq)
            vm.category.faq.push(angular.copy(vm.newFaq));
            vm.newFaq.question = '';
            vm.newFaq.answer = '';
        }

        function save () {
            vm.isSaving = true;
            if (vm.category.id !== null) {
                FaqManageService.update(vm.category, onSaveSuccess, onSaveError);
            } else {
                FaqManageService.save(vm.category, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:categoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqAddNewDialogController', FaqAddNewDialogController);

    FaqAddNewDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'FaqManageService','FAQService'];

    function FaqAddNewDialogController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, FaqManageService, FAQService) {
        var vm = this;

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "FAQ Manage";
        }


        $scope.faq = {
            answer: "Answer.",
            faqCategory: {
                id: null
            },
            question: "Question ?"
        }


        $scope.setContent = function() {
            $scope.tinymceModel = 'Time: ' + (new Date());
        };

        $scope.tinymceOptions = {
            plugins: [
                'advlist autolink lists link image charmap print preview anchor textcolor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table contextmenu paste code wordcount'
            ],
            toolbar: ' formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat ',
            inline: false,
            menubar: false,
        };

        vm.category = entity;
        vm.clear = clear;
        vm.save = save;


        $scope.getAllFaqCategoriesWithQuestions = function () {
            FAQService.getAllFaqCategories().then(function (res) {
                $scope.categories = res.data;
            }).catch(function (err) {
                console.log(err);
            })
        }

        $scope.getAllFaqCategoriesWithQuestions()


        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log($scope.faq)
            vm.isSaving = true;
            if (vm.category.id !== null) {
                FAQService.updateFaq($scope.faq).then(function (response) {
                    onSaveSuccess(response);
                }).catch(function(error){
                } )
            } else {
                FAQService.createNewFaq($scope.faq).then(function (response) {
                    onSaveSuccess(response);
                }).catch(function(error){
                    onSaveError();
                } );
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:faqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqCategoryDeleteController',FaqCategoryDeleteController);

    FaqCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'FaqManageService'];

    function FaqCategoryDeleteController($uibModalInstance, entity, FaqManageService) {
        var vm = this;

        vm.category = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FaqManageService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FaqEditDialogController', FaqEditDialogController);

    FaqEditDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'FaqManageService','FAQService'];

    function FaqEditDialogController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, FaqManageService, FAQService) {

        var vm = this;

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "FAQ Manage";
        }

        vm.faq = {
                  answer: null,
                  faqCategory: {
                     categoryTitle: null,
                     id: $stateParams.id
                    },
                  id: null,
                  question: null
                };

        function getFaqById () {
            FAQService.getFaq($stateParams.questionId).then(function (response) {
                vm.faq.answer = response.data.answer;
                vm.faq.question = response.data.question;
                vm.faq.id = response.data.id;
            }).catch(function (error) {
                $uibModalInstance.close(result);
            })
        }

        getFaqById();

        $scope.tinymceOptions = {
            plugins: [
                'advlist autolink lists link image charmap print preview anchor textcolor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table contextmenu paste code'
            ],
            toolbar: ' formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat ',
            inline: false,
            menubar: false,
        };
        vm.category = entity;
        vm.clear = clear;
        vm.save = save;

        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            FAQService.updateFaq(vm.faq).then(function (response) {
                onSaveSuccess(response);
            }).catch(function(error){
                onSaveError();
            } )
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:faqUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function () {
    'use strict';

    angular.module('anrescowebApp').controller('CustomerPublicPageController', CustomerPublicPageController);

    CustomerPublicPageController.$inject = ['$rootScope', '$scope', '$state', '$localStorage', 'CustomerPublicService', 'data', 'ProductCategory', 'SampleFilter', 'ParseLinks', 'CustomerByUser', 'AlertService'];

    function CustomerPublicPageController($rootScope, $scope,  $state, $localStorage, CustomerPublicService, data, ProductCategory, SampleFilter, ParseLinks, CustomerByUser, AlertService) {

        var vm = this;
        $rootScope.pageTitle = $state.current.data.pageTitle;

        // Pagination vars
        vm.itemsPerPage = 12;
        vm.page = 1;
        vm.totalitems = 0;
        vm.sort = 'customerOrder.dateCompleted,desc';

        // Assign functions
        vm.searchSamples = searchSamples;
        vm.searchClear = searchClear;
        vm.getPotencyValue = getPotencyValue;

        // Retrieve categories
        vm.categories = [{id: -1, name: "All"}];
        vm.selectedCategoryId = -1;
        ProductCategory.query({}, function(categories){
        	if (categories) {
        		for (var i = 0; i < categories.length; i++) {
        			vm.categories.push(categories[i]);
        		}
        	}
        });

        // Process customer data
        if (data) {
        	setCustomerInfo(data);

        } else {
        	CustomerByUser.get({}, function(data) {
        		$localStorage.customer = {id: data.id, dbaName: data.dbaName};
        		$state.go('customerPublic', {dbaName: data.dbaName}, {location: 'replace'})
        	}, function(err){ $state.go('publicCustomerNotFound', {}, {location: 'replace'}) });
        }

        function setCustomerInfo(data) {
        	vm.customer = data;
        	$rootScope.pageTitle = data.name;

        	if (data.logo) {
        		vm.companyLogo = 'images/logo/' + vm.customer.logo;
        	}

        	if (data.address && data.address !== ',,,, ') {
        		var splits = data.address.split('@');
        		vm.customerStreet = splits[0].trim();
        		vm.customerCity = splits[1].trim();
        		vm.customerState = splits[2].trim();
        		vm.customerCountry = splits[3].trim();
        		vm.customerZip = splits[4].trim();

        		if (vm.customerStreet || vm.customerCity || vm.customerState || vm.customerZip){
        			data.address = '';
        			if (vm.customerStreet) {
        				data.address += vm.customerStreet + ', ';
        			}
        			if (vm.customerCity) {
        				data.address += vm.customerCity + (vm.customerState ? ' ' : ', ');
        			}
        			if (vm.customerState) {
        				data.address += vm.customerState + (vm.customerZip ? ', ' : '');
        			}
        			if (vm.customerZip) {
        				data.address += vm.customerZip;
        			}
        		} else {
        			data.address = null;
        		}

        		vm.mapImageUrl = "/api/public/customers/" + data.id + "/map";
        	}

        	searchSamples();
        }
        function createQueryParams() {
        	var params = {};
        	params.customerId = vm.customer.id;
        	if (vm.searchTerm) params.searchTerm = vm.searchTerm;
        	params.categoryId = vm.selectedCategoryId !== -1 ? vm.selectedCategoryId : null;

        	// Set paging params
        	params.page = vm.page - 1;
            params.size = vm.itemsPerPage;
            params.sort = vm.sort;

        	return params;
        }

        function searchSamples() {
        	document.activeElement.blur();
        	SampleFilter.publicQuery(createQueryParams(), function(samples, headers){
        		vm.publicSamples = samples;
                vm.links = headers('link') == null ? null : ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

        	}, function(error) {
        		AlertService.error("Could not load samples");
        	});
        }

        function searchClear() {
        	vm.searchTerm = null;
        	searchSamples();
        }

        function getPotencyValue(sample, cannabinoid) {
        	if (!sample || !sample.sampleTests) return 'N/A';

        	if (cannabinoid === 'THC') {
        		cannabinoid = 'total_thc_percent';
        	} else if (cannabinoid === 'CBD') {
        		cannabinoid = 'total_cbd_percent';
        	} else if (cannabinoid === 'TOTAL') {
        		cannabinoid = 'total_percent';
        	} else {
        		return "Unknown Cannabinoid";
        	}

        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var t = sample.sampleTests[i];
        		if (!t.assay || !t.assay.portalIdentifier) continue;
        		
        		if (t.assay.portalIdentifier === "POTENCY_LCDAD" || t.assay.portalIdentifier === "POTENCY_LCDAD_NON_PLANT") {
        			if (t.worksheetData && t.worksheetData[cannabinoid]) {
        				return t.worksheetData[cannabinoid].twoDecimalFormattedValue + ' %';
        			}
        		}
        	}

        	return 'N/A';
        }
    }

})();

//(function() {
//    'use strict';
//    angular.module('anrescowebApp').factory('CustomerPublicService', CustomerPublicService);
//
//    CustomerPublicService.$inject = ['$resource'];
//
//    function CustomerPublicService ($resource) {
//        var resourceUrl =  'api/public/customers/:dbaName';
//
//        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET',
//                isArray: false
//            },
//            'getInformationByCompanyName': {
//                method: 'GET',
//                url: 'api/public/customers/:name',
//                isArray: false
//            },
//            'searchCustomer': {
//                method: 'GET',
//                url: 'api/customers/search/:searchString',
//                isArray: true
//            }
//        });
//    }
//})();


(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerPublicService', CustomerPublicService);

    CustomerPublicService.$inject = ['$resource'];

    function CustomerPublicService ($resource) {

        return $resource('api/public/customers/:dbaName', {dbaName: '@dbaName'}, {
            query: { method: 'GET', isArray: true },
            get: {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });

    }

})();

(function() {
    'use strict';

    angular.module('anrescowebApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state('customerPublic', {
            parent: 'app',
            url: '/public/customer/{dbaName}',
            data: {
                authorities: [],
                pageTitle: 'Customer Public'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/customer-public/customer-public.html',
                    controller: 'CustomerPublicPageController',
                    controllerAs: 'vm'
                }
            }
            ,
            resolve: {
                data: function ($state, $stateParams, CustomerPublicService) {
                    var dbaName = $stateParams.dbaName;
                    return CustomerPublicService.get({dbaName: dbaName})
                        .$promise.then(
                            function(data){
                                return data
                            },
                            function(error){
                                /*$state.go('publicCustomerNotFound', {}, {location: 'replace'});*/ });
                }
            }

        });

        $stateProvider.state('publicCustomerNotFound', {
            parent: 'app',
            url: '/customer-public/customer-not-found',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/customer-public/not-found.html'
                }
            }
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Contact', Contact);

    Contact.$inject = ['$resource'];

    function Contact ($resource) {
        var resourceUrl =  'api/contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete': { method: 'DELETE' },
            'update': { method:'PUT' },
            'getByUserId': {
            	method: 'GET',
            	url: 'api/contact/user/:id'
            },
            'updateContactAndUser': {
            	method: 'PUT',
            	url: 'api/contact/user'
            },
            'getByResetKey': {
                method: 'GET',
            	url: 'api/contact/user/reset/:reset_key'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerByUser', CustomerByUser);

    CustomerByUser.$inject = ['$resource'];

    function CustomerByUser ($resource) {
        var resourceUrl =  'api/customers/userid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('anrescowebApp').factory('BillingAccess', BillingAccess);

    BillingAccess.$inject = ['$http', '$q', '$state'];

    function BillingAccess($http, $q, $state) {
        return {
            requireAccess: function() {
                return $http.get('api/customer/billing-access').then(function(response) {
                    if (response.data.allowed === true) {
                        return true;
                    }
                    $state.go('home');
                    return $q.reject({status: 403, message: 'Billing is not available for this account.'});
                });
            }
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerAccount', CustomerAccount)
        .factory('Customer', Customer)
        .factory('CustomerByOrder', CustomerByOrder)
        .factory('CustomerMap', CustomerMap)
        .factory('CustomerSquare', CustomerSquare)
        .factory('CustomerById', CustomerById);

    CustomerAccount.$inject = ['$resource'];
    Customer.$inject = ['$resource'];
    CustomerByOrder.$inject = ['$resource'];
    CustomerMap.$inject = ['$resource'];
    CustomerSquare.$inject = ['$resource'];
    CustomerById.$inject = ['$resource'];

    function CustomerAccount ($resource) {
        var resourceUrl =  'api/customer';

        return $resource(resourceUrl, {}, {
            'create': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'onboard': {
                method: 'POST',
                url: 'api/customer/onboard',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function Customer ($resource) {
        var resourceUrl =  'api/customers/:id/:orderId';

        return $resource(resourceUrl, {orderId: "@orderId"}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                 method: 'POST',
                 transformRequest: function (data) {
                     var copy = angular.copy(data);
                     copy.dateReceived = ZonedDateTime.parse('2016-03-18T12:38:23.561+01:00');
                     copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                     return angular.toJson(copy);
                 }
             }
        });
    }

    function CustomerByOrder ($resource) {
        var resourceUrl =  'api/public/customers/byorder/:orderId';

        return $resource(resourceUrl, {orderId: "@orderId"}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function CustomerMap($resource) {
    	var resourceUrl = 'api/public/customers/:id/map';

    	return $resource(resourceUrl, {id: "@id"}, {
    		'get': {
    			method: 'GET',
    			responseType: 'arraybuffer'
    		}
    	});
    }

    function CustomerById($resource) {
    	var resourceUrl = 'api/customers/internal/:id';

    	return $resource(resourceUrl, {id: "@id"}, {
            'getInternal': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
    	});
    }

    function CustomerSquare($resource) {
    	var resourceUrl = 'api/customer/square';

    	return $resource(resourceUrl, {}, {
            'retrieveCustomer': {
                method: 'GET',
                url: 'api/customer/square/account',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'saveCard': {
                method: 'POST',
                url: 'api/customer/square/card',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'deleteCard': {
                method: 'DELETE',
                url: 'api/customer/square/card',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'updatePrimaryCard': {
                method: 'PUT',
                url: 'api/customer/square/card/primary',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'toggleAutopay': {
                method: 'POST',
                url: 'api/customer/autopay/toggle',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

    	});
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ContactForUser', ContactForUser);

    ContactForUser.$inject = ['$resource'];
    function ContactForUser ($resource) {
        var resourceUrl =  'api/contacts/user/:username';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data ? data[0] : data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ContactForCustomer', ContactForCustomer);

    ContactForCustomer.$inject = ['$resource'];
    function ContactForCustomer ($resource) {
        var resourceUrl =  'api/contacts/customer/:customerId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Contact2ForUser', Contact2ForUser);

    Contact2ForUser.$inject = ['$resource'];
    function Contact2ForUser ($resource) {
        var resourceUrl =  'api/contact/user';

        return $resource(resourceUrl, {}, {

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('BusinessType', BusinessType);

    BusinessType.$inject = ['$resource'];

    function BusinessType ($resource) {
        var resourceUrl =  'api/business-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Config', Config);

    Config.$inject = ['$resource'];

    function Config ($resource) {
        var resourceUrl =  'api/config';

        return $resource(resourceUrl, {}, {
            'holidays': {
            	method: 'GET',
                isArray: false,
                url: 'api/config/holidays'
            },
            'generic': {
            	method: 'GET',
                isArray: false,
                url: 'api/config/generic',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CountryState', CountryState);

    CountryState.$inject = ['$resource'];

    function CountryState ($resource) {
        var resourceUrl =  'api/countries/:id/states';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CountryStateByCode', CountryStateByCode);

    CountryStateByCode.$inject = ['$resource'];

    function CountryStateByCode ($resource) {
        var resourceUrl =  'api/states/:code';

        return $resource(resourceUrl, {code: '@code'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CountryStateByName', CountryStateByName);

    CountryStateByName.$inject = ['$resource'];

    function CountryStateByName ($resource) {
        var resourceUrl =  'api/states/:name';

        return $resource(resourceUrl, {name: '@name'}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerOrder', CustomerOrder);

    CustomerOrder.$inject = ['$resource', 'DateUtils'];

    function CustomerOrder ($resource, DateUtils) {
        var resourceUrl =  'api/customer-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                      data.dateReceived = DateUtils.convertLocalDateFromServer(data.dateReceived);
                        data.dateReceived = DateUtils.utcToLocal(data.dateReceived);
                        data.dateCreated = DateUtils.utcToLocal(data.dateCreated);
                        data.dateCompleted = DateUtils.utcToLocal(data.dateCompleted);
                        data.datePreliminaryResults = DateUtils.utcToLocal(data.datePreliminaryResults);
                        data.checkoutDate = DateUtils.convertLocalDateFromServer(data.checkoutDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateReceived = DateUtils.convertLocalDateToServer(copy.dateReceived);
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateReceived =ZonedDateTime.parse('2016-03-18T12:38:23.561+01:00');
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    return angular.toJson(copy);
                }
            },
            'filter': {
            	url: 'api/customer-orders/filter',
            	method: 'GET',
            	isArray: true
            },
            'filterAll': { // Get all orders without pages
            	url: 'api/customer-orders/filter/all',
            	method: 'GET',
            	isArray: true
            },
            'openSubmissions': {
            	url: 'api/customer-orders/count/opensubmissions',
            	method: 'GET'
            },
            'getCustomerEmails': {
            	url: 'api/customer-orders/get_customer_emails',
            	method: 'GET'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'getUnpaid': {
                method: 'GET',
                url: 'api/invoices/unpaid-invoices',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'filter': {
                method: 'GET',
                url: 'api/invoices/filter',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Sample', Sample);

    Sample.$inject = ['$resource'];

    function Sample ($resource) {
        var resourceUrl =  'api/samples/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' },
            passFailCount:{
            	url: 'api/samples/passfail/count',
            	method: 'GET'
            }
        });
    }
})();

//https://stackoverflow.com/questions/21628378/angularjs-display-blob-pdf-in-an-angular-app
angular.module('anrescowebApp')

    .factory('SampleCoaPdfService',['$http', function ($http) {
             return {
                 downloadPdf: function (hash) {
                 return $http.get('api/public/samples/coa/' + hash, { responseType: 'arraybuffer', timeout: 300000 }).then(function (response) {
                     return response;
                 });
             }
         };
     }]);

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('SampleFilter', SampleFilter);

    SampleFilter.$inject = ['$resource', 'DateUtils'];

    function SampleFilter($resource, DateUtils) {
        var resourceUrl =  'api/samples/filter';

        return $resource(resourceUrl, {}, {
            'query': {
            	method: 'GET',
            	isArray: true
            },
            'queryAll': { // Get all samples without pages
            	method: 'GET',
            	isArray: true,
            	url: 'api/samples/filter/all'
            },
            'calendar': {
                method: 'GET',
            	isArray: true,
            	url: 'api/samples/filter/calendar'
            },
            'publicQuery' : {
            	method: 'GET',
            	isArray: true,
            	url: 'api/public/samples/filter'
            },
            'attributeCounts' : {
                method: 'GET',
                isArray: false,
                url: 'api/samples/count/attribute'
            },
            'attribute' : {
                method: 'GET',
                isArray: true,
                url: 'api/samples/filter/attribute'
            },
            'autofill' : {
                method: 'GET',
                isArray: true,
                url: 'api/samples/filter/autofill'
            },
            'ingredients' : {
                method: 'GET',
                isArray: true,
                url: 'api/samples/filter/ingredients'
            },
            'orderField' : {
                method: 'GET',
                isArray: true,
                url: 'api/samples/filter/order-field'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ProductType', ProductType);

    ProductType.$inject = ['$resource'];

    function ProductType ($resource) {
        var resourceUrl =  'api/product-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() { 
    'use strict'; 
    angular 
        .module('anrescowebApp') 
        .factory('SampleAttachDownload', SampleAttachDownload); 
 
    SampleAttachDownload.$inject = ['$resource']; 
 
    function SampleAttachDownload ($resource) { 
        var resourceUrl =  '/api/samples/attachment/:id'; 
 
        return $resource(resourceUrl, {text: '@text', state: '@state'}, { 
            'query': { method: 'GET', isArray: true}, 
            'get': { 
                method: 'GET', 
                responseType: 'blob', 
                //params: {id_hash: '@id_hash'}, 
                transformResponse: function(data) { 
                    return { data: data } 
                } 
            }, 
            'getPublic': {
                url: '/api/public/:sampleHash/attachment/:id',
                method: 'GET',
                responseType: 'blob',
                transformResponse: function(data) {
                    return { data: data }
                }
            },
            getBadge: { 
                url: 'api/samples/qrcode/badge',
                method: 'GET', 
                responseType: 'blob', 
                params: {text: '@text', state:'@state'}, 
                transformResponse: function(data) { 
                    return { data: data } 
                } 
            },
        }); 
    } 
})();

(function() { 
    'use strict'; 
    angular 
        .module('anrescowebApp') 
        .factory('OrderAttachDownload', OrderAttachDownload); 
 
    OrderAttachDownload.$inject = ['$resource']; 
 
    function OrderAttachDownload ($resource) { 
        var resourceUrl =  '/api/customer-orders/attachment/:id'; 
 
        return $resource(resourceUrl, {id_hash: '@id_hash'}, { 
            'query': { method: 'GET', isArray: true}, 
            'get': { 
                method: 'GET', 
                responseType: 'blob', 
                //params: {id_hash: '@id_hash'}, 
                transformResponse: function(data) { 
                    return { data: data } 
                } 
            } 
        }); 
    } 
})(); 
 
(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('InvoiceAttachDownload', InvoiceAttachDownload);

    InvoiceAttachDownload.$inject = ['$resource'];

    function InvoiceAttachDownload ($resource) {
        var resourceUrl =  '/api/invoices/attachment/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                responseType: 'blob',
                transformResponse: function (data) {
                    return { data: data };
                }
            },
            'merged': {
                method: 'GET',
                url: '/api/invoices/attachment/pdf/merged',
                responseType: 'blob',
                transformResponse: function (data) {
                    return { data: data };
                }
            }
        });
    }
})();


//https://stackoverflow.com/questions/21628378/angularjs-display-blob-pdf-in-an-angular-app
angular.module('anrescowebApp')

    .factory('InvoiceAttachDownloadBytes',['$http', function ($http) {
             return {
                 downloadPdf: function (id) {
                 return $http.get('api/invoices/documents/pdf/' + id, { responseType: 'arraybuffer' }).then(function (response) {
                     return response;
                 });
             }
         };
     }]);

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SampleAttach', SampleAttach);

    SampleAttach.$inject = ['$resource'];

    function SampleAttach ($resource) {
        var resourceUrl =  'api/samples/:id/attachments';

        return $resource(resourceUrl, {ids: '@ids'}, {
            'query': { method: 'GET', isArray: true},
            'getPublic': { url: 'api/public/:hash/attachments', method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            getReports: {
            	url: 'api/samples/report/:id',
            	method: 'GET',
            	isArray: true
            },
            getBulkPictures: {
            	url: 'api/samples/pictures',
            	method: 'GET',
            	isArray:false,
            	params: {ids: '@ids'}
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('OrderAttach', OrderAttach);

    OrderAttach.$inject = ['$resource'];

    function OrderAttach ($resource) {
        var resourceUrl =  '/api/customer-orders/:id/attachments';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

//https://stackoverflow.com/questions/21628378/angularjs-display-blob-pdf-in-an-angular-app
angular.module('anrescowebApp')

    .factory('SampleExportService',['$http', function ($http) {
	     return {
	    	 downloadCsv: function (params) {
	             return $http.get('api/samples/export/csv', { responseType: 'arraybuffer', params: params });
	    	 },
             downloadCoa: function (params) {
                 return $http.get('api/samples/export/coa', { responseType: 'arraybuffer', params: params });
             },
             submitCsvExportJob: function (params) {
                 return $http.post('api/jobs/csv-export', params).then(function (response) {
                     return response.data;
                 });
             }
         };
     }]);

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SampleTest', SampleTest);

    SampleTest.$inject = ['$resource', 'DateUtils'];

    function SampleTest ($resource, DateUtils) {
        var resourceUrl =  'api/sample-tests/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.estimetedStartDate = DateUtils.convertLocalDateFromServer(data.estimetedStartDate);
                        data.estimetedCompleteDate = DateUtils.convertLocalDateFromServer(data.estimetedCompleteDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.estimetedStartDate = DateUtils.convertLocalDateToServer(copy.estimetedStartDate);
                    copy.estimetedCompleteDate = DateUtils.convertLocalDateToServer(copy.estimetedCompleteDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.estimetedStartDate = DateUtils.convertLocalDateToServer(copy.estimetedStartDate);
                    copy.estimetedCompleteDate = DateUtils.convertLocalDateToServer(copy.estimetedCompleteDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ProductTypeByCategory', ProductTypeByCategory);

    ProductTypeByCategory.$inject = ['$resource'];

    function ProductTypeByCategory ($resource) {
        var resourceUrl =  '/api/product-categories/:id/product-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('StrainNameSearch', StrainNameSearch);

    StrainNameSearch.$inject = ['$resource'];

    function StrainNameSearch ($resource) {
        var resourceUrl =  '/api/strain-name/:searchString';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        console.log('search results:' + data);
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

//https://stackoverflow.com/questions/21628378/angularjs-display-blob-pdf-in-an-angular-app
angular.module('anrescowebApp')

    .factory('CustomerOrderPdfService',['$http', function ($http) {
             return {
                 downloadPdf: function (id) {
                 return $http.get('api/customer-order/pdf/' + id, { responseType: 'arraybuffer' }).then(function (response) {
                     return response;
                 });
             }
         };
     }]);

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('OrderPicture', OrderPicture);

    OrderPicture.$inject = ['$resource'];

    function OrderPicture ($resource) {
        var resourceUrl =  'api/customer-orders/:id/pictures';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ProductCategory', ProductCategory);

    ProductCategory.$inject = ['$resource'];

    function ProductCategory ($resource) {
        var resourceUrl =  'api/product-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': {
            	method: 'GET',
            	isArray: true,
            	transformResponse: function(data) {
            		// Make sure "Other" is last in the list
            		var dataJson = JSON.parse(data);
            		var otherCatIdx = null;

            		for (var i = 0; i < dataJson.length; i++){
            			if (dataJson[i].name === "Other") otherCatIdx = i;
            		}
            		
            		dataJson.push(dataJson.splice(otherCatIdx, 1)[0]);
            		return dataJson;
            	}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        console.log('transforming product category: ' + data)
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource'];

    function CustomerSearch ($resource) {
        var resourceUrl =  '/api/customers/search/:searchString';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        console.log('search results:' + data);
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('AddressList', AddressList);

    AddressList.$inject = ['$resource'];
    function AddressList ($resource) {
        var resourceUrl =  'api/locations/:id';

        return $resource(resourceUrl, {}, {

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isArray: true
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                  var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'remove': { method:'DELETE' }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CityList', CityList);

    CityList.$inject = ['$resource'];
    function CityList ($resource) {
        var resourceUrl =  'api/city-name/search/:searchString';

        return $resource(resourceUrl, {}, {

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ZipList', ZipList);

    ZipList.$inject = ['$resource'];
    function ZipList ($resource) {
        var resourceUrl =  'api/zip-code/search/:searchString';

        return $resource(resourceUrl, {}, {

            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Weedmaps', Weedmaps);

    Weedmaps.$inject = ['$resource'];

    function Weedmaps ($resource) {
        var resourceUrl =  'api/sample/:id/publish/weedmaps';

        return $resource(resourceUrl, {id: "@id"}, {
            'publish': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Panel', Panel)
    	.factory('Assay', Assay);

    Panel.$inject = ['$resource'];
    Assay.$inject = ['$resource'];

    function Panel ($resource) {
        var resourceUrl =  'api/panels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function Assay ($resource) {
    	var resourceUrl = '/api/assays/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomPanel', CustomPanel)

    CustomPanel.$inject = ['$resource'];

    function CustomPanel ($resource) {
        var resourceUrl =  'api/custompanels/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'create': {
                method: 'POST'
            },
            'update': {
                method: 'PUT',
                url: 'api/custompanels/:id'
            },
            'delete': {
                method: 'DELETE',
                url: 'api/custompanels/:id'
            }
        });
    }


})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('QRCode', QRCode);

    QRCode.$inject = ['$resource'];

    function QRCode ($resource) {
        var resourceUrl =  'api/samples/qrcode/generate';

        return $resource(resourceUrl, {}, {
            'generate': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SquareService', SquareService)

    SquareService.$inject = ['$resource'];


    function SquareService ($resource) {
        var resourceUrl =  'api/square/';

        return $resource(resourceUrl, {}, {
            'createPayment': {
                method: 'POST',
                url: 'api/square/payment',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'params': {
                method: 'GET',
                url: 'api/square/params',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Payment', Payment)
        .factory('PaymentById', PaymentById);

    Payment.$inject = ['$resource'];
    PaymentById.$inject = ['$resource'];


    function Payment ($resource) {
        var resourceUrl =  'api/payment';

        return $resource(resourceUrl, {}, {
            'getAllPayments': {
                method: 'GET',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'createPayment': {
                method: 'POST',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'createAchPayment': {
                method: 'POST',
                url: 'api/payment/create-ach',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'filter': {
                method: 'GET',
                url: 'api/payment/filter',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'sendReceipt': {
                method: 'POST',
                url: 'api/payment/receipt/send',
                isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }

    function PaymentById ($resource) {
        var resourceUrl =  'api/payment/:paymentId';

        return $resource(resourceUrl, {paymentId: "@paymentId"}, {
            'getPayment': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('PaymentReceipt', PaymentReceipt);

    PaymentReceipt.$inject = ['$resource'];

    function PaymentReceipt ($resource) {
        var resourceUrl =  '/api/payment';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                url: 'api/payment/receipt/print',
                responseType: 'blob',
                transformResponse: function (data) {
                    return { data: data };
                }
            },
            'merged': {
                method: 'GET',
                url: '/api/payment/receipt/print/merged',
                responseType: 'blob',
                transformResponse: function (data) {
                    return { data: data };
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Quotation', Quotation);

    Quotation.$inject = ['$resource'];

    function Quotation ($resource) {
        var resourceUrl =  '/api/quotation/:id';

        return $resource(resourceUrl, {id: "@id"}, {
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update':{
            	method: 'PATCH',
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .service('DownloadUtil', DownloadUtil);

    DownloadUtil.$inject = [];

    function DownloadUtil() {
        this.getFilenameFromContentDisposition = function(cd) {
            if (!cd || typeof cd !== 'string') return 'download';
            try {
                // Prefer RFC 5987 filename*
                var starMatch = cd.match(/filename\*=([^;]+)/i);
                if (starMatch && starMatch[1]) {
                    var v = starMatch[1].trim();
                    var parts = v.split("''"); // UTF-8''<percent-encoded>
                    if (parts.length === 2) {
                        try { return decodeURIComponent(parts[1]); } catch (e) { return parts[1]; }
                    }
                    v = v.replace(/^UTF-8''/i, '');
                    try { return decodeURIComponent(v.replace(/^\"|\"$/g, '')); } catch (e) { return v.replace(/^\"|\"$/g, ''); }
                }

                // Fallback: filename=
                var simple = cd.match(/filename=([^;]+)/i);
                if (simple && simple[1]) {
                    var name = simple[1].trim();
                    if ((name.charAt(0) === '"' && name.charAt(name.length - 1) === '"') ||
                        (name.charAt(0) === "'" && name.charAt(name.length - 1) === "'")) {
                        name = name.substring(1, name.length - 1);
                    }
                    return name;
                }
            } catch (e) {}
            return 'download';
        };
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('AiChat', AiChat);

    AiChat.$inject = ['$http'];

    function AiChat($http) {
        return {
            bootstrap: bootstrap,
            status: status
        };

        function bootstrap() {
            return $http.post('api/ai-chat/bootstrap').then(function(response) {
                return response.data;
            });
        }

        function status() {
            return $http.get('api/ai-chat/status').then(function(response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-triangle',
                sortAsc = 'glyphicon-triangle-top',
                sortDesc = 'glyphicon-triangle-bottom',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-triangle',
                sortAsc = 'glyphicon-triangle-bottom',
                sortDesc = 'glyphicon-triangle-top';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('anrescowebApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            utcToLocal: utcToLocal,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }
        
        // Converts a datetime from server to client's local timezone. Date parameter must have format "2019-01-01T00:00:00"
        function utcToLocal(date) {
        	if (date) {
        		if (date.indexOf('Z') === -1 && date.indexOf('+') === -1) date += 'Z';
        		return new Date(date);
        	}
        	return null;
        }
        

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {

        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            /*$stateProvider.state('login', {
                parent: 'account',
                url: '/login',
                data: {
                    authorities: [],
                    pageTitle: 'Login'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'vm'
                    }
                }
            });*/

            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginController ($rootScope, $state, $timeout, Auth) {
        var vm = this;
        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.showOldUsers = false;
        vm.loginAsSelected = false;
        vm.signOutCompletly = signOutCompletly
        vm.oldUser = null;

        vm.anotherUser = anotherUser;
        vm.step = 'oldUsers';

        function signOutCompletly(){
            vm.step = 'login';
            vm.username = "";
            localStorage.removeItem('oldUserLogin')
            localStorage.removeItem('oldUserFirstName')
        }

        function anotherUser(){
            vm.step = 'login';
            vm.username = "";
        }

        function oldUsersCheck (){
            vm.step = 'login';
            try {
                if(localStorage.getItem('oldUserLogin')){
                    vm.oldUserLogin = JSON.parse(localStorage.getItem('oldUserLogin'))
                    vm.oldUserFirstName = JSON.parse(localStorage.getItem('oldUserFirstName'))
                    vm.step = 'loginAs';
                    vm.username = vm.oldUserLogin;
                    vm.password = '';


                } else {
                    vm.step = 'login';
                }
            }
           catch(err) {}

        }

        oldUsersCheck();

        $timeout(function (){angular.element('#username').focus();});

        //setUpContentWidth();
        /*$scope.$on('$viewContentLoaded', function(){
         // Run after view loaded.
            setUpContentWidth();
        });*/

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            //$uibModalInstance.dismiss('cancel');
        }



        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                //$uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                //if (Auth.getPreviousState()) {
                    //var previousState = Auth.getPreviousState();
                    //Auth.resetPreviousState();
                    //$state.go(previousState.name, previousState.params);
                //}
                $state.go('home',{}, {reload:true});
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            //$uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            //$uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

        // function setUpContentWidth(){
        //     var x = document.getElementsByClassName("remove-all");
        //     var y = document.getElementsByClassName("main-sidebar");
        //     var z = document.getElementsByClassName("content-wrapper");
        //
        //
        //     for (var i = 0; i < z.length; i++) {
        //          if (z[i].classList) {
        //              z[i].classList.toggle("big-box-gone");
        //          }
        //     }
        //
        //
        // }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'account',
            url: '/login',
            data: {
                authorities: [],
                pageTitle: 'Login'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('BackdoorService', BackdoorService);

    BackdoorService.$inject = ['$uibModal'];

    function BackdoorService ($uibModal) {

        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/backdoor/backdoor.html',
                controller: 'BackdoorController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('BackdoorController', BackdoorController);

    BackdoorController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function BackdoorController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.backdoor_username = null;
        vm.rememberMe = true;
        vm.showOldUsers = false;
        vm.loginAsSelected = false;
        vm.signOutCompletly = signOutCompletly
        vm.oldUser = null;

        vm.anotherUser = anotherUser;
        vm.step = 'oldUsers';

        function signOutCompletly(){
            vm.step = 'login';
            vm.username = "";
            localStorage.removeItem('oldUserLogin')
            localStorage.removeItem('oldUserFirstName')
        }

        function anotherUser(){
            vm.step = 'login';
            vm.username = "";
        }

        function oldUsersCheck (){
            vm.step = 'login';
            try {
                if(localStorage.getItem('oldUserLogin')){
                    vm.oldUserLogin = JSON.parse(localStorage.getItem('oldUserLogin'))
                    vm.oldUserFirstName = JSON.parse(localStorage.getItem('oldUserFirstName'))
                    vm.step = 'loginAs';
                    vm.username = vm.oldUserLogin;
                    vm.password = '';


                } else {
                    vm.step = 'login';
                }
            }
           catch(err) {}

        }

        oldUsersCheck();

        $timeout(function (){angular.element('#username').focus();});


        function login (event) {
            event.preventDefault();
            Auth.backdoor({
                username: vm.username,
                password: vm.password,
                backdoor_username: vm.backdoor_username,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                //$uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');
                $state.go('home',{}, {reload:true});
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('backdoor', {
            parent: 'account',
            url: '/backdoor',
            data: {
                authorities: [],
                pageTitle: 'Backdoor'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/backdoor/backdoor.html',
                    controller: 'BackdoorController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';
    angular
    .module('anrescowebApp')
    .directive('fileModel', ['$parse', function ($parse) {

    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var model = $parse(attrs.fileModel);
            var modelSetter = model.assign;

            element.bind('change', function(){
                scope.$apply(function(){
                    modelSetter(scope, element[0].files[0]);
                });
            });
        }
    };
}]);
})();


(function() {
    'use strict';
    angular
    .module('anrescowebApp')
    .directive('onFileChange', function() {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var onChangeHandler = scope.$eval(attrs.onFileChange);

          element.bind('change', function() {
            scope.$apply(function() {
              var files = element[0].files;
              if (files) {
                onChangeHandler(files);
              }
            });
          });

        }
      };
    });

})();


(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('FileUpload', FileUpload);

  FileUpload.$inject = ['$http'];

    function FileUpload($http) {
        this.uploadFileToUrl = function(file, uploadUrl){
            var fd = new FormData();
            /*
             *notice 1st param 'file', which will be used to
             * rettrive file from the java class.
             */
            fd.append('file', file);
            $http.post(uploadUrl, fd, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            })
            .success(function(response){
            } )
            .error(function(error){
            });


        }

            return this;

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('anrescowebApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('anrescowebApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
//                    position: alertOptions.position ? alertOptions.position : 'top right',
                    position: alertOptions.position ? alertOptions.position : 'top',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('anrescowebApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('AiChatOverlayController', AiChatOverlayController)
        .directive('aiChatOverlay', aiChatOverlay)
        .directive('aiChatOverlayFrameLoaded', aiChatOverlayFrameLoaded);

    AiChatOverlayController.$inject = ['$rootScope', '$scope', '$sce', '$state', '$window', 'AiChat', 'Principal'];

    function AiChatOverlayController($rootScope, $scope, $sce, $state, $window, AiChat, Principal) {
        var vm = this;
        var bootstrapToken = null;
        var clearTokenTimer = null;
        var frameWindow = null;
        var retryTimers = [];
        var stateChangeUnsubscribe = angular.noop;
        var visibilityRequestId = 0;

        vm.aiChatOrigin = null;
        vm.error = false;
        vm.frameReady = false;
        vm.iframeSrc = null;
        vm.isOpen = false;
        vm.isVisible = false;
        vm.loading = false;
        vm.close = close;
        vm.open = open;
        vm.retry = loadBootstrap;
        vm.onIframeLoad = onIframeLoad;

        refreshVisibility();
        Principal.identity().finally(refreshVisibility);

        stateChangeUnsubscribe = $rootScope.$on('$stateChangeSuccess', function() {
            refreshVisibility();
            postPageContext();
        });
        $window.addEventListener('message', onFrameMessage);

        $scope.$on('$destroy', function() {
            $window.removeEventListener('message', onFrameMessage);
            stateChangeUnsubscribe();
            resetFrame();
        });

        function refreshVisibility() {
            var requestId = ++visibilityRequestId;

            if (!Principal.isAuthenticated()) {
                vm.isVisible = false;
                close();
                resetFrame();
                return;
            }

            AiChat.status().then(function(status) {
                if (requestId !== visibilityRequestId) {
                    return;
                }

                vm.isVisible = Boolean(status && status.enabled);

                if (!vm.isVisible) {
                    close();
                    resetFrame();
                }
            }).catch(function() {
                if (requestId !== visibilityRequestId) {
                    return;
                }

                vm.isVisible = false;
                close();
                resetFrame();
            });
        }

        function open() {
            if (!vm.isVisible) {
                return;
            }

            vm.isOpen = true;

            if (!vm.iframeSrc && !vm.loading) {
                loadBootstrap();
            }
        }

        function close() {
            vm.isOpen = false;
        }

        function loadBootstrap() {
            vm.loading = true;
            vm.error = false;
            vm.frameReady = false;
            vm.iframeSrc = null;
            vm.aiChatOrigin = null;
            bootstrapToken = null;

            AiChat.bootstrap().then(function(bootstrap) {
                if (!bootstrap || !bootstrap.token || !bootstrap.aiChatOrigin) {
                    showBootstrapError();
                    return;
                }

                bootstrapToken = bootstrap.token;
                vm.aiChatOrigin = bootstrap.aiChatOrigin;
                vm.iframeSrc = $sce.trustAsResourceUrl(bootstrap.aiChatOrigin);
                vm.loading = false;
            }).catch(function() {
                showBootstrapError();
            });
        }

        function onIframeLoad(loadedFrameWindow) {
            if (!bootstrapToken || !vm.aiChatOrigin || !loadedFrameWindow) {
                return;
            }

            frameWindow = loadedFrameWindow;
            scheduleBootstrapPosts(frameWindow);
            vm.frameReady = true;
        }

        function onFrameMessage(event) {
            if (!event || !event.data || !vm.aiChatOrigin || event.origin !== vm.aiChatOrigin) {
                return;
            }

            if (event.data.type === 'AI_CHAT_ORDER_UPDATED') {
                handleOrderUpdated(event);
                return;
            }

            if (event.data.type !== 'AI_CHAT_READY' || !bootstrapToken) {
                return;
            }

            frameWindow = event.source;
            postBootstrap(event.source, bootstrapToken);
        }

        function handleOrderUpdated(event) {
            var orderId = Number(event.data.orderId);
            if (event.source !== frameWindow ||
                    !isFinite(orderId) || orderId <= 0 || Math.floor(orderId) !== orderId ||
                    (event.data.state !== 'CANCELLED' && event.data.state !== 'TURNAROUND_UPDATED' && event.data.state !== 'TESTS_CANCELLED')) {
                return;
            }

            var stateName = ($state.current && $state.current.name) || '';
            var isMatchingOrderDetails = stateName === 'order-details' &&
                Number($state.params && $state.params.orderId) === orderId;
            if (stateName === 'orders' || stateName === 'home' || isMatchingOrderDetails) {
                $scope.$evalAsync(function() {
                    $state.reload();
                });
            }
        }

        function scheduleBootstrapPosts(frameWindow) {
            var token = bootstrapToken;
            clearRetryTimers();

            [0, 250, 1000, 2500].forEach(function(delay) {
                retryTimers.push($window.setTimeout(function() {
                    postBootstrap(frameWindow, token);
                }, delay));
            });

            clearTokenTimer = $window.setTimeout(function() {
                bootstrapToken = null;
            }, 5000);
        }

        function postBootstrap(targetWindow, token) {
            if (!targetWindow || !vm.aiChatOrigin || !token) {
                return;
            }

            targetWindow.postMessage({
                type: 'AI_CHAT_BOOTSTRAP',
                token: token
            }, vm.aiChatOrigin);
            postPageContext();
        }

        function postPageContext() {
            if (!frameWindow || !vm.aiChatOrigin) {
                return;
            }

            frameWindow.postMessage({
                type: 'AI_CHAT_PAGE',
                stateName: ($state.current && $state.current.name) || '',
                orderId: numericStateParam('orderId'),
                invoiceId: $state.current && $state.current.name === 'invoice-details'
                    ? numericStateParam('id')
                    : undefined,
                paymentId: numericStateParam('paymentId')
            }, vm.aiChatOrigin);
        }

        function numericStateParam(key) {
            var value = Number($state.params && $state.params[key]);
            return isFinite(value) && value > 0 ? value : undefined;
        }

        function clearRetryTimers() {
            retryTimers.forEach(function(timer) {
                $window.clearTimeout(timer);
            });
            retryTimers = [];

            if (clearTokenTimer) {
                $window.clearTimeout(clearTokenTimer);
                clearTokenTimer = null;
            }
        }

        function resetFrame() {
            clearRetryTimers();
            bootstrapToken = null;
            frameWindow = null;
            vm.aiChatOrigin = null;
            vm.error = false;
            vm.frameReady = false;
            vm.iframeSrc = null;
            vm.loading = false;
        }

        function showBootstrapError() {
            vm.loading = false;
            vm.error = true;
            vm.iframeSrc = null;
            clearRetryTimers();
            bootstrapToken = null;
        }
    }

    aiChatOverlay.$inject = ['$animate'];

    function aiChatOverlay($animate) {
        return {
            restrict: 'E',
            templateUrl: 'app/components/ai-chat-overlay/ai-chat-overlay.html',
            controller: 'AiChatOverlayController',
            controllerAs: 'vm',
            link: function(scope, element) {
                // ngAnimate suspends ng-hide's display:none while animating.
                // Rapid minimize/expand clicks interrupt those animations and
                // leave the widget and launcher both stuck visible (plus
                // orphaned leave-clones). No animations are wanted here.
                $animate.enabled(element, false);
            }
        };
    }

    function aiChatOverlayFrameLoaded() {
        return {
            restrict: 'A',
            link: function(scope, element) {
                function onLoad() {
                    scope.$applyAsync(function() {
                        if (scope.vm && scope.vm.onIframeLoad) {
                            scope.vm.onIframeLoad(element[0].contentWindow);
                        }
                    });
                }

                element.on('load', onLoad);
                scope.$on('$destroy', function() {
                    element.off('load', onLoad);
                });
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope', '$location'];

    function errorHandlerInterceptor ($q, $rootScope, $location) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('anrescowebApp.httpError', response);

                if(! response.data.path === '/api/notifications/top'){
                    $rootScope.$emit('closeModal', 'Close modal');
                    $location.path('login');
                }

            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            var customerId = $localStorage.customerId;
            var contactId = $localStorage.contactId;
            var contactEmail = $localStorage.contactEmail;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
                if (customerId) config.headers['Customer-ID'] = customerId;
                if (contactId) config.headers['Contact-ID'] = contactId;
                if (contactEmail) config.headers['Contact-Email'] = contactEmail;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'anrescoweb' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'sidebar@': {
                    templateUrl: 'app/layouts/sidebar/sidebar.html',
                    controller: 'SidebarController',
                    controllerAs: 'vm'
                },
                'navbar-header@': {
                    templateUrl: 'app/layouts/navbar-header/navbar-header.html',
                    controller: 'NavbarHeaderController',
                    controllerAs: 'vm'
                }

            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('anrescowebApp')
        .constant('VERSION', "2.0.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('STAGE', "prod")
;
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('UserManagementDialogController',UserManagementDialogController)
    	.controller('UserManagementEditDialogController', UserManagementEditDialogController);

    // Add User
    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User','CustomerSearch', 'ContactForCustomer'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, CustomerSearch, ContactForCustomer) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
       // vm.user = entity;

        vm.loadCustomers = loadCustomers;
        vm.setCustomer = setCustomer;
        vm.selectContact = selectContact;

        vm.populateCustomerContacts = populateCustomerContacts;

        vm.setRole = function(contactCustomer) {
        	if (contactCustomer.role == "ADMIN") {
        		contactCustomer.role = null;
        	} else {
        		contactCustomer.role = "ADMIN";
        	}
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
            
        }

        function onSaveError (error) {
            vm.error = error;
            vm.isSaving = false;
            vm.errorMsg = getErrorMessage(error);
        }

        function save () {
            if (vm.contact.id==null) {
                vm.noContact = 'ERROR';
                return;
            }
            else {
                vm.noContact = null;
            }

            if (vm.contact.password != vm.contact.confirmPassword) {
                vm.doNotMatch = 'ERROR';
                return;
            }
            else {
               vm.doNotMatch = null;
            }
            vm.currentLoginName = vm.contact.login;
            vm.currentLoginEmail = vm.contact.email;
            
            vm.isSaving = true;
            vm.contact.langKey = 'en';
            vm.contact.activated = true;
            User.save(vm.contact, onSaveSuccess, onSaveError);
        }

        function getErrorMessage(response) {
            if (!response || !response.data) return null;
            if (angular.isString(response.data)) return response.data;
            if (angular.isString(response.data.message)) return response.data.message;
            if (response.data.data) {
                if (angular.isString(response.data.data)) return response.data.data;
                if (angular.isString(response.data.data['e.msg'])) return response.data.data['e.msg'];
            }
            return null;
        }

        function loadCustomers(){
            if (vm.searchText == null || vm.searchText == "" ){
                vm.suggestedCustomers =  [];
                vm.customer = null;

            }
            else {
            	clearTimeout(vm.customerSearchTimeout);
            	vm.customerSearchTimeout = setTimeout(searchCustomers, 1000);
            }
            
            function searchCustomers() {
            	CustomerSearch.query({searchString: vm.searchText},onCustomerSearchSuccess, onCustomerSearchError)
            }

            function onCustomerSearchSuccess(data, headers) {
                 vm.suggestedCustomers = data;
                 if (vm.suggestedCustomers.length == 1 && vm.suggestedCustomers[0].name.toLowerCase() == vm.searchText.toLowerCase() ) {
                    vm.customer = vm.suggestedCustomers[0] ;
                 }
                 else if (vm.suggestedCustomers.length >1) {

                    for (var i = 0, len = vm.suggestedCustomers.length; i < len; i++) {
                      if (vm.suggestedCustomers[i].name.toLowerCase() == vm.searchText.toLowerCase()) {

                        vm.customer = vm.suggestedCustomers[i];
                        vm.populateCustomerContacts();
                        return;
                      }
                    }
                    clearCustomer();
                 }
                 else {
                    clearCustomer();
                 }

            }
            function onCustomerSearchError(error) {

            }
        }

        function clearCustomer(){
            vm.customer = null;
            vm.customerContacts = null;
            vm.contact = null;

        }
        function setCustomer(customer){
            vm.customer = customer;
            vm.searchText = vm.customer.name;
            vm.suggestedCustomers =  [];
            vm.populateCustomerContacts();
        }

        function populateCustomerContacts () {
            vm.customerContacts = ContactForCustomer.query({customerId: vm.customer.id});
        }
        
        function selectContact(){
        	if (vm.contact.login) {
        		vm.existingAccount = true
        	} else {
        		vm.existingAccount = false;
        	}
        }
    }
    
    
    // Edit User
    UserManagementEditDialogController.$inject = ['$stateParams', '$uibModalInstance', 'ContactEnt', 'Contact'];

    function UserManagementEditDialogController ($stateParams, $uibModalInstance, ContactEnt, Contact) {
        var vm = this;

        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        ContactEnt.$promise.then(function(contact){
        	vm.contact = contact;
        	if (contact.receive_coa && contact.receive_invoice) {
        		vm.receive = 'both';
        	} else if (contact.receive_coa) {
        		vm.receive = 'coa';
        	} else if (contact.receive_invoice) {
        		vm.receive = 'inv';
        	} else {
        		vm.receive = 'none';
        	}
        });

        vm.setReceive = function() {
            if(vm.receive == 'coa'){
                vm.contact.receive_coa = true;
                vm.contact.receive_invoice = false;
            } else if(vm.receive == 'inv'){
            	vm.contact.receive_coa = false;
                vm.contact.receive_invoice = true;
            } else if(vm.receive == 'both'){
                vm.contact.receive_coa = true;
                vm.contact.receive_invoice = true;
            } else {
            	vm.contact.receive_coa = false;
            	vm.contact.receive_invoice = false;
            }
        }

        function clear() { $uibModalInstance.dismiss('cancel'); }
        function onSaveSuccess(result) { vm.isSaving = false; $uibModalInstance.close(result); }
        function onSaveError(error) { vm.isSaving = false; vm.error = error && error.data ? error.data : 'Something went wrong.'; }
        
        function save() {
        	Contact.updateContactAndUser(vm.contact, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-edit-dialog.html',
                    controller: 'UserManagementEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        ContactEnt: ['Contact', function(Contact) {
                            return Contact.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'anrescoweb'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['$rootScope', 'Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController($rootScope, Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

         setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "User Management";
        }

        
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        vm.search = function() {
        	User.search({
        		page: pagingParams.page - 1,
        		size: vm.itemsPerPage,
        		sort: sort(),
        		search: vm.searchTerm
        	}, onSuccess, onError);
        }
        
        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('anrescowebApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.first_name,
                langKey: account.langKey,
                lastName: account.last_name,
                login: account.login
            };
        };
        
        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data.message === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService', 'Contact', 'AlertService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService, Contact, AlertService) {
        var vm = this;

        Contact.getByResetKey({reset_key: $stateParams.key},
            function(data) {
                if(data.reset_key !== $stateParams.key) {
                    vm.disable_page = true;
                }
                else if(data.reset_date) {
                    var expirey_date = moment(data.reset_date).add(1, 'days');
                    var today = moment();
                    if(today > expirey_date) {
                        vm.disable_page = true;
                    }
                }

                if(vm.disable_page) {
                    AlertService.error('This reset link has expired. Please generate a new one.', null, 'top right');
                }

            },
            function(e) {
                console.log(e);
                AlertService.error('This reset link has expired. Please generate a new one.');
                vm.disable_page = true;
            }
        )

        vm.disable_page = false;
        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
        });

        $timeout(function (){angular.element('#login').focus();});

        setUpContentWidth();

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        function setUpContentWidth(){
            var x = document.getElementsByClassName("remove-all");
            var y = document.getElementsByClassName("main-sidebar");
            var z = document.getElementsByClassName("content-wrapper");


            for (var i = 0; i < z.length; i++) {
                 if (z[i].classList) {
                     z[i].classList.toggle("big-box-gone");
                 }
            }


        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .directive('passwordStrengthBar', passwordStrengthBar);
    
        passwordStrengthBar.$inject = ['$translate'];

    function passwordStrengthBar ($translate) {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>' + $translate.instant('Password strength')+':</small>' +
                '<ul id="strengthBar">' +
                '<li class="point" style="display:inline-block"></li><li class="point" style="display:inline-block"></li><li class="point" style="display:inline-block"></li><li class="point" style="display:inline-block"></li><li class="point" style="display:inline-block"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SignupController', SignupController);

    SignupController.$inject = ['$state', '$stateParams', 'SquareService', 'SweetAlert', 'CustomerAccount', 'Config', 'CustomerById', 'Quotation', '$scope', 'BRAND'];

    function SignupController ($state, $stateParams, SquareService, SweetAlert, CustomerAccount, Config, CustomerById, Quotation, $scope, BRAND) {

        var vm = this;
        var brandContact = (BRAND || {}).contact || {};
        var brandBranding = (BRAND || {}).branding || {};
        var brandPayments = (BRAND || {}).payments || {};
        var brandWireTransfer = brandPayments.wire_transfer || {};
        var fallbackPrimaryRepList = [
            {
                name: brandBranding.portal_team_name || 'Client Services',
                email: brandContact.support_email || brandContact.info_email || '',
                phone: brandContact.main_phone || ''
            }
        ];
        var brandPrimaryRepList = ((BRAND || {}).customer_reps || {}).primary_rep_list || fallbackPrimaryRepList;
        var fallbackWireTransferRows = [
            {left: 'Beneficiary:', right: 'ANRESCO, INCORPORATED'},
            {left: 'Bank Account number:', right: '158236183154'},
            {left: 'Bank Routing:', right: '121122676'},
            {left: 'Bank Swift Code:', right: 'USBKUS44IMT'},
            {left: 'Bank Name:', right: 'U.S. Bank'},
            {left: 'Bank Address:', right: '350 California St. Fl 1'},
            {left: 'Bank City/State:', right: 'San Francisco, CA 94104'}
        ];
        var fallbackWireTransferNote = 'Please note that there is a non-refundable $45 fee for every wire transfer originating from outside of the USA.';
        var wireTransferRows = brandWireTransfer.rows;
        var wireTransferNotes = brandWireTransfer.notes;

        if ((!wireTransferRows || !wireTransferRows.length) && (!brandWireTransfer.sections || !brandWireTransfer.sections.length)) {
            wireTransferRows = fallbackWireTransferRows;
        }

        if (!wireTransferNotes || !wireTransferNotes.length) {
            wireTransferNotes = [brandWireTransfer.international_fee_note || fallbackWireTransferNote];
        }

        angular.element(document).ready(function() {
            angular.element('#wrap').removeClass("wrap");
            $('#t_and_c').on('scroll', chk_scroll);
        });

        $state.INTERNAL_KEY = null;
        vm.loading_quotation = true;
        vm.quotation_valid = null;
        vm.error_message = null;
        vm.ip_info = null;
        vm.submitting = false;
        var square = {};

        vm.nav = {
            next_enabled: true,
            prev_enabled: false,
            show_next: true,
            show_prev: false
        }

        const squareCardInputStyles = {
            '.input-container': {
                borderColor: '#e6ebf0',
                borderRadius: '4px',
              },
              '.input-container.is-focus': {
                borderColor: '#e6ebf0'
              },
              'input::placeholder': {
                color: '#c1c5c9'
              },
              input: {
                color: '#3d5269'
              }
        }

        if($state.$current.data.pageTitle == 'Signup') {
            vm.state = 'quotation';

            fetch("https://ipinfo.io/json?token=818194d3986134").then(
                function(res) {
                    return res.json();
                }
            ).then( function(data) {
                vm.ip_info = data;
            });
        }
        else {
            vm.state = 'success';
            $state.go('signup.success');
        }

        function getInternalKey() {
            Config.generic({data: 'INTERNAL_KEY'},
                function(data) {
                    $state.INTERNAL_KEY = data.data;
                },
                function(e) {
                    console.log(e);
                }
            )
        }

        function getQuotationById(id) {
            Quotation.get({id: id},
                function(data) {
                    if(validRes(data)) {
                        vm.quotation = data;
                        getCustomer(data.customer_id);
                        return data;
                    }
                },
                function(e) {
                    console.log(e);
                });
        }

        if(vm.state == 'quotation' && $stateParams.quotationId == 'new' ) {
            vm.loading_quotation = false;
            vm.quotation_valid = true;
        }
        else if(vm.state == 'quotation' && $stateParams.quotationId != 'success' ) {
            if($stateParams.quotationId.length < 15) {
                showErrorMessage('Error', 'Invalid quotation ID.')
                vm.nav.next_enabled = false;
                vm.quotation_valid = false;
            }
            else {
                vm.quotation_valid = true;

                Quotation.get({id: $stateParams.quotationId},
                    function(data) {
                        if(validRes(data)) {
                            if(data.expiration_date) {
                                var today = new Date(moment())
                                var expiration_date = new Date(data.expiration_date)

                                if(today > expiration_date) {
                                    showErrorMessage('Error', 'Quotation is expired.');
                                    return;
                                }
                            }

                            vm.quotation = data;

                            if(vm.quotation.status != 'ACCEPTED') {
                                Quotation.update({id: vm.quotation.id, status: 'ACCEPTED'},
                                    function(d) {
                                        setTimeout(function(){ getQuotationById(vm.quotation.id); }, 3000);
                                    },
                                    function(e) {
                                        // show error message here and quit process
                                        showErrorMessage('Error', 'Could not update quotation.');
                                        console.log(e);
                                    }
                                );
                            }
                            else {
                                getCustomer(vm.quotation.customer_id)
                            }
                        }
                    },
                    function(e) {
                        console.log(e);
                    }
                );
            }
        }
        // remove this
        vm.changeState = function() {
            $state.go('signup.success');
        }

        function validRes(res) {
            if(res.message) {
                if(res.message == 'A validation error has occurred.') {
                    showErrorMessage('Error', res.data);
                    return false;
                }
            }
            return true;
        }

        function invalidatePage() {
            vm.nav.next_enabled = false;
            vm.current_step.next_active = false;
            vm.current_step.prev_active = false;
            vm.steps.terms_and_conditions.submit_active = false;
            vm.quotation_valid = false;
            vm.loading_quotation = false;
        }

        function getCustomer(customer_id) {
            vm.steps.company_info.company.id = customer_id;
            CustomerById.get({id: customer_id},
                function(data) {
                    if(validRes(data)) {
                    // extract contact id
                        vm.steps.company_info.company.business_name = data.company_name ? data.company_name : null;
                        if(data.company_name) {
                            vm.steps.company_info.company.business_name = data.company_name;
                        }
                        else {
                            vm.steps.company_info.company.business_name = data.name
                        }
                        if(data.contacts) {
                            vm.steps.primary_contact.contact.id = data.contacts[0].id ? data.contacts[0].id : null;
                            vm.steps.primary_contact.contact.first_name = data.contacts[0].first_name ? data.contacts[0].first_name : null;
                            vm.steps.primary_contact.contact.last_name = data.contacts[0].last_name ? data.contacts[0].last_name : null;
                            vm.steps.primary_contact.contact.email_address = data.contacts[0].email ? data.contacts[0].email : null;

                        }
                    }
                    vm.steps.company_info.checkRequiredFields();
                    vm.loading_quotation = false;
                },
                function(e) {
                    // show error message here and quit processx
                    vm.steps.company_info.checkRequiredFields();
                    showErrorMessage('Error', 'Could not retrieve customer.')
                    console.log(e)
                }
            );
        }

        vm.getCustomerComments = function() {
            var comments = '--- Onboarding Completed via Portal --- ';
            comments += '\n Signed by: ' + vm.steps.terms_and_conditions.signed_by;
            comments += '\n Date: ' + moment().format('MMMM Do YYYY, h:mm:ss a');

            if(vm.ip_info) {
                comments += '\n IP Address: ' + vm.ip_info.ip;
                comments += '\n ' + vm.ip_info.city + ', ' + vm.ip_info.region + ' ' + vm.ip_info.postal + ' (estimated)'
                comments += '\n Location: ' + vm.ip_info.loc + ' (estimated)';
            }

            comments += '\n --- End of Onboarding Info --- ';

            return comments;
        }

        function chk_scroll(e) {
            var elem = $(e.currentTarget);
            if ((elem[0].scrollHeight - elem.scrollTop()) < (elem.outerHeight()+500)) {
                angular.element('#read_terms').removeClass("disabled-signup");
            }
        }

        vm.steps = {
            submitAll: function() {
                vm.submitting = true;
                var payload = {}
                var company_info = this.company_info.serializeCustomer()
                var billing_info = {
                    selected_payment_method: this.billing_info.selected_payment_method.display ? this.billing_info.selected_payment_method.display : null,
                    nonce: this.billing_info.square_info.nonce ? this.billing_info.square_info.nonce : null,
                    cardholder_name: this.company_info.company.business_name ? this.company_info.company.business_name : null,
                    customer_name: this.company_info.company.business_name ? this.company_info.company.business_name : null,
                    invoicing_notes : this.billing_info.invoicing_notes ? this.billing_info.invoicing_notes : null
                };

                var primary_contact = this.primary_contact.serializePrimaryContact();

                var contacts = [];
                this.additional_contacts.contacts.forEach( function(contact) {
                    contacts.push(vm.steps.additional_contacts.serializeContact(contact))
                });

                payload = {
                    customer_info: company_info,
                    billing_info: billing_info,
                    primary_contact: primary_contact,
                    contacts_info: contacts
                }

                CustomerAccount.onboard(payload,
                    function(data) {
                        invalidatePage()
                        vm.submitting = false;
                        $state.go('signup.success');
                    },
                    function(e) {
                        vm.submitting = false;
                        var message = e.data && e.data.message ? e.data.message : 'An unhandled exception occurred.'
                        invalidatePage();
                        showErrorMessage('Error', message)
                        console.log(e);
                    }
                );
            },
            company_info : {
                prev: '',
                current: 'company_info',
                next: 'primary_contact',
                title: 'Company Information',
                description: '',
                status: 'in-progress',
                is_active: false,
                show_next: true,
                show_prev: false,
                next_active: false,

                industries: ['Cannabis', 'Food', 'Hemp', 'Kratom', 'FDA DWPE', 'Pharmaceutical'],
                company: {
                    id: null,
                    business_name: '',
                    industry: '',
                    industry: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code: '',
                    country: '',
                    main_phone: '',
                    license_number: ''
                },
                selected_primary_rep: {name: null, email: null, phone: null},
                primary_rep_list : angular.copy(brandPrimaryRepList),
                signed_by: '',
                checkRequiredFields: function() {
                    const isStateRequired = this.company.country === 'United States of America';

                    if(!isStateRequired){
                        this.company.state = '';
                    };

                    if(
                        this.company.business_name &&
                        this.company.industry &&
                        this.company.address &&
                        this.company.city &&
                        (isStateRequired ? this.company.state : true) &&
                        this.company.zip_code &&
                        this.company.country &&
                        this.company.main_phone
                    ) {
                        this.next_active = true;
                    }
                    else {
                        this.next_active = false;
                    }
                },
                createCustomerAddress: function() {
                    const isStateRequired = this.company.country === 'United States of America';
                    var address = '';
                    address += this.company.business_name + '\n';
                    address += this.company.address + '\n';

                    if (isStateRequired) {
                        address += this.company.city + ', ' + this.company.state + ' ' + this.company.zip_code;
                    }
                    else {
                        address += this.company.city + ', ' + this.company.zip_code;
                    }

                    if (this.company.license_number) {
                        address += '\n' + this.company.license_number;
                    }

                    return address;
                },
                serializeCustomer: function() {
                    // console.log("Country data???",this);
                    return {
                        id: this.company.id,
                        customer_name: this.company.business_name.toUpperCase(),
                        country_name: this.company.country,
                        company_name: this.company.business_name,
                        customer_type: this.company.industry,
                        phone: this.company.main_phone,
                        language: this.company.country.toLowerCase().includes('jap') ? 'Japanese' : 'English',
                        address: this.createCustomerAddress(),
                        comments: vm.getCustomerComments(),
                        primary_anresco_rep: this.selected_primary_rep.name,
                        primary_anresco_phone: this.selected_primary_rep.phone,
                        primary_anresco_email: this.selected_primary_rep.email,

                        // for the  default reporting address
                        street_address: this.company.address,
                        city: this.company.city,
                        state: this.company.state,
                        zip_code: this.company.zip_code
                    }
                }
            },
            primary_contact : {
                prev: 'company_info',
                current: 'primary_contact',
                next: 'additional_contacts',
                title: 'Primary Contact',
                description: 'The Primary Contact will automatically have Admin access to edit, add, and delete other users on the company account.',
                status: 'not-started',
                is_active: false,
                show_next: true,
                show_prev: true,
                next_active: false,

                contact: {
                    id: null,
                    first_name: '',
                    last_name: '',
                    title: '',
                    title: '',
                    email_address: '',
                    direct_phone: '',
                    receive_reports: true,
                    receive_invoices: true,
                    is_admin: true
                },
                checkRequiredFields: function() {
                    if(
                        this.contact.first_name &&
                        this.contact.last_name &&
                        this.contact.email_address &&
                        this.contact.direct_phone
                    ) {
                        this.next_active = true;
                    }
                    else {
                        this.next_active = false;
                    }
                },
                serializePrimaryContact: function () {
                    return {
                        id: this.contact.id,
                        first_name: this.contact.first_name,
                        last_name: this.contact.last_name,
                        email_address: this.contact.email_address,
                        phone: this.contact.direct_phone,
                        receive_email: this.contact.receive_reports,
                        receive_invoice_email: this.contact.receive_invoices,
                        is_admin: true
                    }
                }
            },
            additional_contacts : {
                prev: 'primary_contact',
                current: 'additional_contacts',
                next: 'billing_info',
                title: 'Additional Contacts',
                description: '',
                status: 'not-started',
                is_active: false,
                show_next: true,
                show_prev: true,
                next_active: true,


                enable_add_contact: false,
                contact: {
                    first_name: '',
                    last_name: '',
                    title: '',
                    email_address: '',
                    direct_phone: '',
                    receive_reports: true,
                    receive_invoices: true,
                    is_admin: true
                },
                contacts: [
                ],
                checkRequiredFields: function() {
                    if(this.contact.first_name || this.contact.last_name || this.contact.email_address) {
                        if (this.contact.first_name && this.contact.last_name && this.contact.email_address) {
                            this.enable_add_contact = true;
                        }
                        else {
                            this.enable_add_contact = false;
                        }
                    }
                    else {
                        this.enable_add_contact = false;
                    }
                },
                serializeContact: function (contact) {
                    return {
                        first_name: contact.first_name,
                        last_name: contact.last_name,
                        email_address: contact.email_address,
                        phone: contact.direct_phone,
                        receive_email: contact.receive_reports,
                        receive_invoice_email: contact.receive_invoices,
                        is_admin: contact.is_admin ? true : false
                    }
                },
                addContact: function() {
                    this.contacts.push(this.contact);
                    this.contact = {
                        first_name: '',
                        last_name: '',
                        title: '',
                        email_address: '',
                        direct_phone: '',
                        receive_reports: true,
                        receive_invoices: true,
                        is_admin: true
                    }
                    this.checkRequiredFields();
                },
                editContact: function(index) {
                    this.contact = this.contacts[index];
                    this.deleteContact(index);
                    this.checkRequiredFields();
                },
                deleteContact: function(index) {
                    this.contacts.splice(index, 1);
                    this.checkRequiredFields();
                }
            },
            billing_info : {
                prev: 'additional_contacts',
                current: 'billing_info',
                next: 'terms_and_conditions',
                title: 'Billing Information',
                description: 'All new clients are required to prepay for their first submission. Please contact your account representative after your first submission if you prefer to be invoiced.',
                status: 'not-started',
                is_active: false,
                show_next: true,
                show_prev: true,
                next_active: false,
                terms_and_conditions_checked: false,
                selected_payment_method: {id: null, display: null},
                payment_methods: [
                    {id: 'credit_card', display: 'Credit Card'},
                    {id: 'cash', display: 'Cash'},
                    {id: 'check', display: 'Check'},
                    {id: 'wire_transfer', display: 'Wire transfer'},
                ],
                wire_transfer_title: brandWireTransfer.title || '',
                wire_transfer_intro: brandWireTransfer.intro || 'Please make ACH or Wire Transfer payments to:',
                wire_transfer_info: angular.copy(wireTransferRows || []),
                wire_transfer_sections: angular.copy(brandWireTransfer.sections || []),
                wire_transfer_remittance: angular.copy(brandWireTransfer.remittance || null),
                wire_transfer_notes: angular.copy(wireTransferNotes),
                square_info: {
                    nonce: null,
                    api: null,
                    app_id: null,
                    location_id: null
                },
                checkRequiredFields: function() {
                    if(this.selected_payment_method.id) {
                        if(this.selected_payment_method.id == 'credit_card') {
                            createSquarePaymentForm();
                        }
                        else {
                            resetPaymentForm(false);
                        }

                        if(this.selected_payment_method.id == 'credit_card' && this.square_info.nonce != null) {
                            this.next_active = true;
                        }
                        else if(this.selected_payment_method.id == 'credit_card' && this.square_info.nonce == null) {
                            this.next_active = false;
                        }
                        else {
                            this.next_active = true;
                        }
                        var primary_rep = vm.steps.company_info.selected_primary_rep;
                        if (!primary_rep || !primary_rep.name) {
                            this.next_active = false;
                        }
                    }
                    else {
                        this.next_active = false;
                    }
                }
            },
            terms_and_conditions : {
                prev: 'billing_info',
                current: 'terms_and_conditions',
                next: '',
                title: 'Terms and Conditions',
                description: 'Please read the terms and conditions below and sign digitally',
                status: 'not-started',
                is_active: false,
                show_next: false,
                show_prev: true,

                agree_terms: false,
                signed_by: '',
                submit_active: false,

                checkRequiredFields: function() {
                    if(this.signed_by.length > 5 && this.agree_terms) {
                        this.submit_active = true;
                    }
                    else {
                        this.submit_active = false;
                    }
                }
            }
        };

        function createSquarePaymentForm() {
            if (vm.steps.billing_info.square_info.nonce) {
                return;
            }
            if (document.getElementsByClassName('sq-card-wrapper').length > 0) {
                return;
            }
            vm.steps.billing_info.square_info.api = Square.payments(vm.steps.billing_info.square_info.app_id, vm.steps.billing_info.square_info.location_id);

            vm.steps.billing_info.square_info.api.card({style:squareCardInputStyles}).then(data => {
                vm.steps.billing_info.square_info.card_api = data;

                vm.steps.billing_info.square_info.card_api.attach('#card-container').then(data => {
                    square.cardButton = document.getElementById('card-button');
                    square.cardButton.addEventListener('click', eventHandler);
                    square.cardButton.disabled = false;
                })
            })

            function eventHandler(event) {
                event.preventDefault();
                resetPaymentForm();

                try {
                    square.cardButton.disabled = true;

                    vm.steps.billing_info.square_info.card_api.tokenize().then(data => {
                        if (data.status === 'OK') {
                            vm.steps.billing_info.square_info.nonce = data.token;

                            SweetAlert.swal({
                                title: 'Card was processed successfully.',
                                text: error_message,
                                type: 'success',
                                confirmButtonColor: '#4f8fcc',
                                confirmButtonText: 'Ok'
                            });
                            vm.steps.billing_info.square_info.card_api.destroy();
                        }
                        else if(data.errors) {
                            var error_message = '';

                            data.errors.forEach(function (error) {
                                console.error('  ' + error.message);
                                error_message = error_message + '- ' + error.message + '\n';
                            });

                            SweetAlert.swal({
                                title: 'There was an issue with your card.',
                                text: error_message,
                                type: 'warning',
                                confirmButtonColor: '#4f8fcc',
                                confirmButtonText: 'Try Again'
                            });
                            resetPaymentForm();
                        }
                        square.cardButton.disabled = false;
                    });
                }
                catch (e) {
                    console.error(e);
                    SweetAlert.swal({
                        title: 'There was an issue with your card.',
                        text: JSON.stringify(e),
                        type: 'warning',
                        confirmButtonColor: '#4f8fcc',
                        confirmButtonText: 'Ok'
                    });
                }
            };
        }

        const resetPaymentForm = (reset=true) => {
            const card_form = document.getElementsByClassName('sq-card-wrapper');

            if(card_form.length) {
                const cardButton = document.getElementById('card-button')
                if (cardButton) {
                    cardButton.replaceWith(cardButton.cloneNode(true));
                }
                card_form[0].remove();
                if(reset){
                    createSquarePaymentForm();
                }
            }
        }

        $scope.$watch('vm.steps.billing_info.square_info.nonce', function (newVal, oldVal) {
            vm.steps.billing_info.checkRequiredFields();
        });

        function appendSquareAPI() {
            Config.generic({data: 'STAGE'},
                function(data) {
                    var script = document.createElement('script');
                    var square_url = null;

                    if(data.data == 'dev') {
                        square_url = 'https://sandbox.web.squarecdn.com/v1/square.js';
                    }
                    else {
                        square_url = 'https://web.squarecdn.com/v1/square.js';
                    }

                    script.type = 'text\/javascript';
                    script.src = square_url;
                    script.id = 'square-api'
                    $("head").append(script)
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        function showErrorMessage(error_title, error_message) {
            vm.error_message = error_message;
            invalidatePage()
            SweetAlert.swal({
                title: error_title,
                text: error_message,
                type: 'error',
                confirmButtonColor: '#4f8fcc',
                confirmButtonText: 'Ok'
            });
        }

        if(vm.state == 'quotation') {
            SquareService.params({},
                function(data) {
                    vm.steps.billing_info.square_info.app_id = data.square_application_id;
                    vm.steps.billing_info.square_info.location_id = data.square_location_id;
                    appendSquareAPI()
                },
                function(e) {
                    console.log(e)
                }
            );
        }

        // change this to change the first page visible

        vm.steps.company_info.is_active = true;
        vm.current_step = vm.steps.company_info;

        // vm.steps.billing_info.is_active = true;
        // vm.current_step = vm.steps.billing_info;


        vm.nav.next = function(event) {
            event.preventDefault();

            if(vm.current_step.next) {
                vm.steps[vm.current_step.current].status = 'complete'
                vm.steps[vm.current_step.next].status = 'in-progress';
                vm.current_step = vm.steps[vm.current_step.next];

                vm.current_step.next ? vm.nav.next_enabled = true : vm.nav.next_false;
                vm.current_step.prev ? vm.nav.prev_enabled = true : vm.nav.prev_false;

                vm.nav.show_next = vm.current_step.show_next;
                vm.nav.show_prev = vm.current_step.show_prev;
            }
        }

        vm.nav.prev = function(event) {
            event.preventDefault();

            if(vm.current_step.prev) {
                vm.steps[vm.current_step.current].status = 'not-started'
                vm.steps[vm.current_step.prev].status = 'in-progress';
                vm.current_step = vm.steps[vm.current_step.prev];

                vm.current_step.next ? vm.nav.next_enabled = true : vm.nav.next_false;
                vm.current_step.prev ? vm.nav.prev_enabled = true : vm.nav.prev_false;

                vm.nav.show_next = vm.current_step.show_next;
                vm.nav.show_prev = vm.current_step.show_prev;
            }
        }

        vm.nav.stepDotsStatus = function(status) {
            if(status == 'not-started') {
                return '<i class=\"fa fa-circle position-background-circle dark-background-circle\"></i><i class=\"fa fa-circle-o position-main-circle main-circle-not-started\"></i>'
            }
            else if(status == 'in-progress') {
                return '<i class=\"fa fa-circle position-background-circle dark-background-circle\"></i><i class=\"fa fa-circle-o position-main-circle main-circle-in-progress\"></i>'
            }
            else if(status == 'complete') {
                return '<i class=\"fa fa-circle position-background-circle white-background-circle\"></i><i class=\"fa fa-check-circle position-main-circle main-circle-complete\"></i>'
            }
        }

        vm.list_of_countries = [
            "Afghanistan",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bonaire, Sint Eustatius and Saba",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cabo Verde",
            "Cambodia",
            "Cameroon",
            "Canada",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Congo",
            "Cook Islands",
            "Costa Rica",
            "Croatia",
            "Cuba",
            "Curaçao",
            "Cyprus",
            "Czechia",
            "Côte d'Ivoire",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Eswatini",
            "Ethiopia",
            "Falkland Islands [Malvinas]",
            "Faroe Islands",
            "Fiji",
            "Finland",
            "France",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Greece",
            "Greenland",
            "Grenada",
            "Guadeloupe",
            "Guam",
            "Guatemala",
            "Guernsey",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Heard Island and McDonald Islands",
            "Holy See",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran (Islamic Republic of)",
            "Iraq",
            "Ireland",
            "Isle of Man",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jersey",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea",
            "Kuwait",
            "Kyrgyzstan",
            "Lao People's Democratic Republic",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macao",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Micronesia",
            "Moldova",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "New Caledonia",
            "New Zealand",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestine, State of",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Republic of North Macedonia",
            "Romania",
            "Russian Federation",
            "Rwanda",
            "Réunion",
            "Saint Barthélemy",
            "Saint Helena, Ascension and Tristan da Cunha",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Martin (French part)",
            "Saint Pierre and Miquelon",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "Sierra Leone",
            "Singapore",
            "Sint Maarten (Dutch part)",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "South Georgia and the South Sandwich Islands",
            "South Sudan",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen",
            "Sweden",
            "Switzerland",
            "Syrian Arab Republic",
            "Taiwan",
            "Tajikistan",
            "Tanzania, United Republic of",
            "Thailand",
            "Timor-Leste",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom of Great Britain and Northern Ireland",
            "United States Minor Outlying Islands",
            "United States of America",
            "Uruguay",
            "Uzbekistan",
            "Vanuatu",
            "Venezuela (Bolivarian Republic of)",
            "Viet Nam",
            "Virgin Islands (British)",
            "Virgin Islands (U.S.)",
            "Wallis and Futuna",
            "Western Sahara",
            "Yemen",
            "Zambia",
            "Zimbabwe",
            "Åland Islands"
        ];

        vm.list_of_states = [
            'AL', 
            'AK', 
            'AS', 
            'AZ', 
            'AR', 
            'CA', 
            'CO', 
            'CT', 
            'DE', 
            'DC', 
            'FM', 
            'FL', 
            'GA', 
            'GU', 
            'HI', 
            'ID', 
            'IL', 
            'IN', 
            'IA', 
            'KS', 
            'KY', 
            'LA', 
            'ME', 
            'MH', 
            'MD', 
            'MA', 
            'MI', 
            'MN', 
            'MS', 
            'MO', 
            'MT', 
            'NE', 
            'NV', 
            'NH', 
            'NJ', 
            'NM', 
            'NY', 
            'NC', 
            'ND', 
            'MP', 
            'OH', 
            'OK', 
            'OR', 
            'PW', 
            'PA', 
            'PR', 
            'RI', 
            'SC', 
            'SD', 
            'TN', 
            'TX', 
            'UT', 
            'VT', 
            'VI', 
            'VA', 
            'WA', 
            'WV', 
            'WI', 
            'WY'
        ];
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('signup', {
            parent: 'entity',
            url: '/signup/{quotationId}',
            data: {
              authorities: [],
              pageTitle: 'Signup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/signup/signup.html',
                    controller: 'SignupController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('signup.success', {
            parent: 'entity',
            url: '/signup-success',
            data: {
                authorities: [],
                pageTitle: 'Signup Success'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/signup/signup.success.html',
                    controller: 'SignupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {

            }
        });
    }
})();

const POTENCY = 'potencyProfile';
const TERPENES = 'terpeneProfile';
const MICRO = 'microbiology';
const PESTICIDES = 'pesticideResidue';
const PESTICIDES_MORE = 'pesticidesResidueMore';
const RESIDUAL_SOLVENTS = 'residueSolvents';
const HEAVY_METALS = 'heavyMetals';
const MYCOTOXINS = 'mycotoxins';
const SULFUR = 'sulfur';
const WATER_ACTIVITY = 'waterActivity';
const MOISTURE = 'moisture';
const FOREIGN_MATERIALS = 'foreignMaterials';
const ALKALOID = 'alkaloid';
const COLIFORM_AND_ECOLI = 'coliform_and_ecoli';
const YEAST_AND_MOLD = 'yeast_and_mold';
const SALMONELLA = 'salmonella';
const ANISIDINE = 'anisidine';
const OTHER_ANALYSES = 'otherAnalyses'; // Water Activity, Moisture, Foreign Materials, Alkaloid Profiles

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
		.service('DownloadSampleService', function () {
			this.showToast = function(message, className) {
				var toastContainer = document.getElementById('toast-container');
				var toast = document.createElement('div');
				toast.className = 'toast ' + className; 
				toast.textContent = message;
				toastContainer.appendChild(toast);
				setTimeout(function() {
					toastContainer.removeChild(toast);
				}, 3000); 
			};
			this.info = function(message) {
				this.showToast(message, 'info-toast');
			};
			this.error = function(message) {
				this.showToast(message, 'error-toast');
			};
		})
        .controller('SampleLogController', SampleLogController)
        .directive('hoverSampleResults', function(){
        	return {
        		link: function ($scope, element, attrs){
        			setTimeout(function(){
        				var $el = $('.hover-sample-results-' + attrs.hoverSampleIndex);
            			element.bind('mouseenter', function(event){
            				// Trigger lazy load of test results for this sample (Tier 3)
            				var sample = $scope.sample;
            				var vm = $scope.vm;
            				if (vm && vm.loadTestResultsForHover && (!sample.sampleTests || sample.sampleTests.length === 0)) {
            					vm.loadTestResultsForHover(sample);
            				}

            				$el.offset({top: event.pageY - $el.height()/2});
            				// Determine if part of div is offscreen
            				$el.show();
            				var docViewTop = $(window).scrollTop();
            				var docViewBottom = docViewTop + $(window).height();

            				var elemTop = $el.offset().top;
            				var elemBottom = elemTop + $el.height();

            				if (elemBottom > docViewBottom - 48){
            					$el.offset({top: docViewBottom - $el.height() - 48});
            				} else if (elemTop < docViewTop){
            					$el.offset({top: docViewTop + 24});
            				}

            				var elemLeft = $el.offset().left;
            				var elemRight = elemLeft + $el.width();

            				if (elemRight > window.innerWidth) {
            					$el.offset({left: window.innerWidth - $el.width() - 48});
            				} else if (elemLeft < 0) {
            					$el.offset({left: 24});
            				}

            			});

            			element.bind('mouseleave', function(event) {
            				var pointerEl = document.elementFromPoint(event.clientX, event.clientY);
            				if (pointerEl && pointerEl.closest('.hover-sample-results-div')) {
            					// do nothing
            				} else {
            					$el.hide();
            				}
            			});
            			$el.bind('mouseleave', function(){
            				$el.hide();
            			});

        			}, 1000);

        		}
        	}

        }).directive('hoverDisplayResults', function() {
        	return {
        		scope: {sample: '=', determineTestPf: '='},
        		link: function(scope, element, attrs) {
        			function renderTests() {
        				var html = '';
        				if (scope.sample && scope.sample.sampleTests && scope.sample.sampleTests.length > 0) {
        					scope.sample.sampleTests.forEach(function(test) {
        						html += scope.determineTestPf(test, scope.sample);
        					});
        				} else if (scope.sample && scope.sample.testsLoading) {
        					html = '<tr><td colspan="2" style="color:#999;text-align:center;">Loading...</td></tr>';
        				}
        				element.html(html);
        			}

        			// Watch for changes to sampleTests (loaded async on hover)
        			scope.$watch('sample.sampleTests', function(newVal, oldVal) {
        				renderTests();
        			}, true);

        			// Also watch testsLoading for loading state
        			scope.$watch('sample.testsLoading', function(newVal, oldVal) {
        				if (newVal) {
        					renderTests();
        				}
        			});

        			// Initial render
        			renderTests();
				}
			}
        }).directive('displaySampleStatus', function(){
        	return {
            	scope: {sample: '='},
            	link: function(scope, element, attrs) {




                	var PASS_HTML = '<span class="sample-pass"><span class="fa fa-check-circle" title="Pass"></span>&nbsp; </span>';
                	var FAIL_HTML = '<span class="sample-fail"><span class="fa fa-times-circle" title="Fail"></span>&nbsp; </span>';
                	var IN_PROGRESS_HTML = '<span class="sample-in-progress"><span class="fa fa-clock-o" title="In Progress"></span>&nbsp; </span>';
                	var NO_STATUS_HTML = '<span class="sample-no-status"><span class="fa fa-stop-circle" style="color: gray;"></span>&nbsp; </span>';
                	var CAUTION_HTML = '<span class="sample-caution"><span class="fa fa-warning" title="Caution">&nbsp; </span></span>';
					var HOLD_HTML = '<span class="sample-hold"><span class="fa fa-pause-circle" title="Hold">&nbsp; </span></span>';
                    var RETESTING_HTML = '<span class="sample-retesting"><span class="fa fa-repeat" title="Retesting">&nbsp; </span></span>';
					var TESTED_HTML = '<span class="sample-tested"><span class="fa fa-stop-circle" title="Tested"></span>&nbsp; </span>';

					var sample = scope.sample;
					var status = scope.sample.status;
					var sampleTest = scope.sample.sampleTests[0];
					var hasEstimatedDate = sampleTest && sampleTest.estimatedCompleteDate;
					var hasReceivedDate = !!(sample && (sample.receivedDate || sample.orderDateReceived ||
						(sample.order && (sample.order.dateReceived || sample.order.date_received)) ||
						(sample.customerOrder && (sample.customerOrder.dateReceived || sample.customerOrder.date_received))));

                	if (sample.rd) {
                		if (sample.complete) {
					if (sampleTest && sampleTest.worksheetData) {
						if (sampleTest.worksheetData.do_not_show_pass_fail_in_portal) {
							if (sampleTest.worksheetData.do_not_show_pass_fail_in_portal.value){
								if (status === 'COMPLETED') element.html(TESTED_HTML);
								if (status === 'PASS') element.html(TESTED_HTML);
                					if (status === 'FAIL') element.html(TESTED_HTML);
                                    if (status === 'IN_PROGRESS') element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

							}
							else {
								if (status === 'COMPLETED') element.html(TESTED_HTML);
								if (status === 'PASS') element.html(PASS_HTML);
                					if (status === 'FAIL') element.html(FAIL_HTML);
	                                    if (status === 'IN_PROGRESS') element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

							}
						}
						else {
							if (status === 'COMPLETED') element.html(TESTED_HTML);
							if (status === 'PASS') element.html(PASS_HTML);
                					if (status === 'FAIL') element.html(FAIL_HTML);
                					if (status === 'IN_PROGRESS') element.html(IN_PROGRESS_HTML);
                					if (status === 'NO_STATUS') element.html(NO_STATUS_HTML);
                					if (status === 'CAUTION') element.html(CAUTION_HTML);
                					if (status === 'RETESTING') element.html(RETESTING_HTML);
								if (status === 'HOLD') element.html(HOLD_HTML);

						}
					}
					else {
						// R&D sample is complete but has no worksheet data yet - show gray icon
						if (status === 'COMPLETED') element.html(TESTED_HTML);
						if (status === 'PASS') element.html(PASS_HTML);
						if (status === 'FAIL') element.html(FAIL_HTML);
						if (status === 'CAUTION') element.html(CAUTION_HTML);
						if (status === 'RETESTING') element.html(RETESTING_HTML);
						if (status === 'HOLD') element.html(HOLD_HTML);
					}
                		}
					else {
								if (status) element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                            if (status === 'RETESTING') element.html(RETESTING_HTML);
						    if (status === 'HOLD') element.html(HOLD_HTML);

                		}
                	}
					else {
                		if (sample.complete && sample.canSeeReport) {
							if (status === 'COMPLETED') element.html(TESTED_HTML);
                			if (status === 'PASS') element.html(PASS_HTML);
                			if (status === 'FAIL') element.html(FAIL_HTML);
                			if (status === 'IN_PROGRESS') element.html(IN_PROGRESS_HTML);
                			if (status === 'CAUTION') element.html(CAUTION_HTML);
                			if (status === 'RETESTING') element.html(RETESTING_HTML);
							if (status === 'HOLD') element.html(HOLD_HTML);

                		}
						else {
								if (status) element.html((hasReceivedDate && hasEstimatedDate) ? IN_PROGRESS_HTML : NO_STATUS_HTML);
                            if (status === 'RETESTING') element.html(RETESTING_HTML);
							if (status === 'HOLD') element.html(HOLD_HTML);
							if (status === 'COMPLETED') element.html(TESTED_HTML);
                		}
                	}

            	}
        	}
        });

    SampleLogController.$inject = ['$state','$stateParams','$scope','$rootScope', '$filter', '$timeout', 'Sample', 'SampleSearch', 'ParseLinks', 'DateUtils',
        'AlertService', 'paginationConstants', 'pagingParams','Auth', 'Principal', 'ProfileService', 'LoginService', 'SampleFilter', 'Weedmaps',
        'CustomerByUser','SampleAttach','SampleAttachDownload', 'SampleExportService', 'ProductType', 'ProductCategory','ProductTypeByCategory', 'SampleService', 'SampleCoaPdfService','DownloadSampleService','$translate','DownloadUtil', 'GraphQLService'];

    function SampleLogController($state, $stateParams,$scope, $rootScope, $filter, $timeout, Sample, SampleSearch, ParseLinks, DateUtils, AlertService,
                                 paginationConstants, pagingParams,Auth, Principal, ProfileService, LoginService, SampleFilter, Weedmaps,
                                 CustomerByUser,SampleAttach,SampleAttachDownload, SampleExportService, ProductType, ProductCategory,
                                 ProductTypeByCategory, SampleService, SampleCoaPdfService,DownloadSampleService, $translate, DownloadUtil, GraphQLService) { /*,Auth, Principal, ProfileService, LoginService*/

		var vm = this;
		vm.currentLanguage = $translate.proposedLanguage();
        $rootScope.showSearch = pagingParams.search;
        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pagingParams = pagingParams;

        // DownloadUtil provides getFilenameFromContentDisposition

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.getAttachmentsLoader = false;
        vm.itemsPerPage = "10";

        // Initialize column visibility flags to show by default (will be adjusted by getCustomerData for food customers)
        vm.sampleColumnThc = true;
        vm.sampleColumnCbd = true;
        vm.sampleColumnAlkaloids = false;
        vm.sampleColumnMitragynine = false;
        vm.thcCbdFilterOptions = true;

        // Initialize customerData with default consolidated_business_type so columns show immediately
        vm.customerData = { consolidated_business_type: 'cannabis' };

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
		vm.setpagesize = setpagesize;

        if(!vm.isAuthenticated()){
            $state.go('login');
        }

		setPageTitle();
		getcannabinoidWorksheetIds();
		getCustomerData();

			function sampleHasReceivedDate(sample) {
				return !!(sample && (sample.receivedDate || sample.orderDateReceived ||
					(sample.order && (sample.order.dateReceived || sample.order.date_received)) ||
					(sample.customerOrder && (sample.customerOrder.dateReceived || sample.customerOrder.date_received))));
			}

		$scope.determineTestPf =  function(test, parentSample) {
			var html = null;

			html += '<tr>';

			html += '<tr><td>' + test.assay.title + '</td>';
			if (test.canSeeResults) {
				if (test.state == 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				}
				else if (test.state == 'HOLD') {
					html += '<td class="test-hold">Hold</td>';
				}
				else if (test.caution) {
					html += '<td class="test-caution">Caution</td>';
				}
				else if (test.state == "NOT STARTED") {
					if(test.estimatedCompleteDate) {
						html += '<td class="test-in-progress">' + (sampleHasReceivedDate(parentSample) ? 'In Progress' : 'Not Received') + '</td>';
					}
					else {
						html += '<td class="test-not-started">Created</td>';
					}
			}
				else if (test.state == "IN PROGRESS") {
					html += '<td class="test-in-progress">In Progress</td>';
				}
				// Check statusPf first (works with GraphQL response that doesn't include worksheetData)
				else if (test.statusPf == 'PASS') {
					html += '<td class="test-pass">Pass</td>';
				}
				else if (test.statusPf == 'FAIL') {
					html += '<td class="test-fail">Fail</td>';
				}
				// Fallback to worksheetData checks for edge cases (e.g., do_not_show_pass_fail_in_portal)
				else if (test.worksheetData) {
					if (test.worksheetData.do_not_show_pass_fail_in_portal) {
						if (test.worksheetData.do_not_show_pass_fail_in_portal.value) {
							if (test.state == 'COMPLETED'){
								html += '<td class="test-no-pf-status">Tested<td>';
							}
							else {
								html += '<td class="test-in-progress">In Progress</td>';
							}
						}
						else if (test.state == 'COMPLETED'){
							html += '<td class="test-no-pf-status">Tested</td>';
						}
					}
					else if (test.worksheetData.findings_1){
						if (test.worksheetData.findings_1.value){
							html += '<td class="test-pass">Tested</td>';
						}
						else {
							html += '<td class="test-in-progress">In Progress</td>';
						}
					}
					else if (test.state == 'COMPLETED'){
						html += '<td class="test-no-pf-status">Tested</td>';
					}
					else {
						html += '<td class="test-in-progress">In Progress</td>';
					}
				}
				// Tests without worksheets but with results
				else if (test.results) {
					html += '<td class="test-pass">Tested</td>';
				}
				// Completed state without statusPf - show as Tested (not Final Review)
				else if (test.state == 'COMPLETED') {
					html += '<td class="test-no-pf-status">Tested</td>';
				}
				else {
					html += '<td class="test-fail">-</td>';
				}
			}
			else {
				if (test.state == 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				}
				else if (test.state == 'HOLD') {
					html += '<td class="test-hold">Hold</td>';
				}
				else if (['PASS', "FAIL", "COMPLETED"].includes(test.state)) {
					html += '<td class="test-retesting">Final Review</td>';
				}
				else {
						html += '<td class="test-in-progress">' + (sampleHasReceivedDate(parentSample) ? 'In Progress' : 'Not Received') + '</td>';
				}
			}

			html += '</tr>';

			return html;
		}


        if(pagingParams.items != null){
            vm.itemsPerPage = pagingParams.items;
		}

        // Initialize default sample columns in case user does not have custom columns configured
        vm.sampleColumns = {
        		'lotNumber': true,
        		'name': true,
        		'productType': true,
        		'productCategory': true,
        		'thc': true,
        		'cbd': true,
				'alkaloids': true,
				'mitragynine': false,
        		'dateCompleted': true,
        		'weedmaps': false,
        		'public': false,
        		'downloads': true,
        		'sCode': false,
        		'totalCannabinoids': false,
        		'dateReceived': false,
        		'dateRequired': false,
        		'status': false,
        		'orderId': false
        }

        // Try to load cached column settings immediately to prevent flashing on page navigation
        var cachedColumns = sessionStorage.getItem('sampleLogColumns');
        if (cachedColumns) {
        	vm.sampleColumns = angular.extend({}, vm.sampleColumns, JSON.parse(cachedColumns));
        }

        vm.toggleEditColumns = function(){
        	vm.showEditColumns = !vm.showEditColumns;
        	if (vm.showEditColumns == true) {
        		// pass
        	} else {
        		saveSampleColumns();
        	}
        }

        vm.toggleWidget = function(name) {
        	if (vm.activeWidget === "sampleEditColumns") {
        		saveSampleColumns();
        	}

        	vm.activeWidget = name === vm.activeWidget ? null : name;
        }

        Principal.identity().then(function(account) {
        	vm.userAccount = account;
            if (account.userSettings) {
            	var userSettings = JSON.parse(account.userSettings);
            	if (userSettings.sample_columns){
            		// Merge user settings with defaults (so new columns get default values)
            		vm.sampleColumns = angular.extend({}, vm.sampleColumns, userSettings.sample_columns);
            		// Cache for instant restore on page navigation
            		sessionStorage.setItem('sampleLogColumns', JSON.stringify(vm.sampleColumns));
            	}
            }
		});

		function getcannabinoidWorksheetIds() {
			SampleService.getWorksheetParserMap({},
				function(data) {
					vm.cannabioidWorksheets = data.cannabinoid_profile;
					vm.alkaloidsWorksheets = data.alkaloid;
				},
				function(e) {
					console.log(e);
				}
			);
		}

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.sampleFilters = {
        		id: pagingParams.id,
        		orderId: pagingParams.orderId,
        		sampleName: pagingParams.sampleName,
        		lotNumber: pagingParams.lotNumber,
        		metrcId: pagingParams.metrcId,
        		categoryIdList: pagingParams.categoryIdList,
        		category: pagingParams.category,
        		subCategory: pagingParams.subCategory,
        		orderType: pagingParams.orderType,
        		thcLower: pagingParams.thcLower,
        		thcUpper: pagingParams.thcUpper,
        		cbdLower: pagingParams.cbdLower,
        		cbdUpper: pagingParams.cbdUpper,
        		isPass: pagingParams.isPass == 'true' ? pagingParams.isPass != null : null,
				isFail: pagingParams.isFail == 'true' ? pagingParams.isFail != null : null,
        		isUndetermined: pagingParams.isUndetermined == 'true' ? pagingParams.isUndetermined != null : null,
        		isWeedmapsSuccess: pagingParams.isWeedmapsSuccess == 'true' ? pagingParams.isWeedmapsSuccess != null : null,
        		isWeedmapsFail: pagingParams.isWeedmapsFail == 'true' ? pagingParams.isWeedmapsFail != null : null,
        		isWeedmapsNone: pagingParams.isWeedmapsNone == 'true' ? pagingParams.isWeedmapsNone: null,
        		visibility: pagingParams.visibility,
        		completeDateLower: pagingParams.completeDateLower ? convertLocalDateFromServer(pagingParams.completeDateLower) : null,
        		completeDateUpper: pagingParams.completeDateUpper ? convertLocalDateFromServer(pagingParams.completeDateUpper) : null,
        		estimatedDueDateLower: pagingParams.estimatedDueDateLower ? convertLocalDateFromServer(pagingParams.estimatedDueDateLower) : null,
        		estimatedDueDateUpper: pagingParams.estimatedDueDateUpper ? convertLocalDateFromServer(pagingParams.estimatedDueDateUpper) : null,
				starred: pagingParams.starred ? pagingParams.starred : null,
				isInProgress: pagingParams.isInProgress ? pagingParams.isInProgress : null,
				isCompleted: pagingParams.isCompleted ? pagingParams.isCompleted: null,
                sampleMatrix: pagingParams.sampleMatrix? pagingParams.sampleMatrix: null
        }

        vm.sort = function() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        /* Filters */
        vm.page = pagingParams.page;
        vm.populateTypes = function() {
        	if (vm.sampleFilters.category) {
        		vm.productTypes = ProductTypeByCategory.query(vm.sampleFilters.category);
        	} else {
        		vm.productTypes = [];
        	}

        }
        vm.productCategories = ProductCategory.query();
		vm.applyFilters = applySampleFilters;

        function applySampleFilters() {
			// Parse filter criteria and add paging params
			var params = createFilterQueryParams();

        	// Send query
            SampleFilter.query(params, onSuccess, onError);
            function onSuccess(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.samples = result;
                vm.page = 0;
				vm.pagingParams = pagingParams;
            }
            function onError(error) {
            	console.log("Error applying filter");
            	console.log(error);
            }
        }

        function getFilterCount() {
			var totalFilters = 0;
        	for (var key in vm.sampleFilters) {
        		if (vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== undefined && vm.sampleFilters[key] !== false) {
					totalFilters++;
        		}
			}

			vm.totalFilters = totalFilters;
        	return totalFilters;
        }
        getFilterCount();
        vm.getFilterCount = getFilterCount;
        vm.filterSubmit = function() {
			vm.page = 1;
			vm.transition();
			vm.setTabViews();
			loadAll();  // Reload data with new filters
			fetchSampleCounts();  // Refresh tab counts with new filters
		}

		$scope.all = true;
		vm.switchTab = function(tab) {

			if (tab == 'starred') {
				$scope.starred = true
				$stateParams.starred = true;
			}
			else if (tab == 'isInProgress') {
				$scope.isInProgress = true
				$stateParams.isInProgress = true;
			}
			else if (tab == 'isCompleted') {
				$scope.isCompleted = true
				$stateParams.isCompleted = true;
			}
			else if (tab == 'total') {
				$scope.total = true
				$stateParams.total = true;
			}

			angular.forEach(vm.tabs, function(value, key) {
				if (key == tab) {
					vm.tabs[key] = true;
					$scope.activeTab = tab;
					pagingParams[key] = true;
					// Also update vm.sampleFilters for GraphQL
					if (key === 'isInProgress' || key === 'isCompleted' || key === 'starred') {
						vm.sampleFilters[key] = true;
					}
					$scope[key] ? $scope[key] = true : angular.noop;
					$stateParams[key] ? $stateParams[key] = true : angular.noop;
				}
				else {
					vm.tabs[key] = false;
					pagingParams[key] = false;
					// Also clear vm.sampleFilters for GraphQL
					if (key === 'isInProgress' || key === 'isCompleted' || key === 'starred') {
						vm.sampleFilters[key] = null;
					}
					$scope[key] ? $scope[key] = null : angular.noop;
					$stateParams[key] ? $stateParams[key] = null : angular.noop;
				}
			});
			getFilterCount();
			vm.filterSubmit();
		}

		vm.setTabViews = function() {
			if (pagingParams.starred) {
				$('#starred').addClass('active');
				$('#starred_controls').addClass('active');
				$('#isInProgress').removeClass('active');
				$('#total').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
			else if (pagingParams.isInProgress) {
				$('#isInProgress').addClass('active');
				$('#isInProgress_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#total').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
			else if (pagingParams.isCompleted) {
				$('#isCompleted').addClass('active');
				$('#isCompleted_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#total').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#total_controls').removeClass('active');
				$('#isInProgress').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
			}
			else {
				$('#total').addClass('active');
				$('#total_controls').addClass('active');
				$('#starred').removeClass('active');
				$('#isInProgress').removeClass('active');
				$('#starred_controls').removeClass('active');
				$('#isInProgress_controls').removeClass('active');
				$('#isCompleted').removeClass('active');
				$('#isCompleted_controls').removeClass('active');
			}
		}
		vm.setTabViews();

		vm.tabs = {
			total: totalOnly(),
			isInProgress: pagingParams.isInProgress ? pagingParams.isInProgress : false,
			starred: pagingParams.starred ? pagingParams.starred : false,
			isCompleted: pagingParams.isCompleted ?pagingParams.isCompleted : false,
			external: false
		}

		function totalOnly() {
			if (!pagingParams.isInProgress && !pagingParams.starred && !pagingParams.isCompleted) {
				return true;
			}
			else {
				return false;
			}
		}

        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];
        	for (var key in vm.sampleFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateFromServer(vm.sampleFilters[key]);
         		} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
        			params[key] = vm.sampleFilters[key];
        		}
        	}

        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.search = vm.currentSearch;
            params.size = vm.itemsPerPage;
            params.items = params.size;
			params.productCategoryId = vm.productCategoryId;


			angular.forEach(vm.tabs, function(value, key) {
				if (value == true) {
					pagingParams[key] = true;
				}
			});
        	return params;
		}


		function createAttributesCountDict() {
			var dict = {
				starred: [1],
				status: ['IN_PROGRESS'],
				status_copy: ['PASS', 'FAIL', 'COMPLETED'],
				total: [true]
			};

			var filters = Object.assign({}, vm.sampleFilters);
			filters.isInProgress = null;
			filters.starred = null;
			filters.isCompleted = null;

			var payload = {
				headers : dict,
				filters: filters
			}

			vm.filterCounts = {}
			return payload
		}

		function createStarredPayload() {
			var dict = {
				starred: 1,
			};

			var filters = Object.assign({}, vm.sampleFilters);
			filters.isInProgress = null;
			filters.starred = null;
			filters.isCompleted = null;

			var payload = {
				headers : dict,
				filters: filters
			}

			return payload
		}

		function getStarredSamplesCount() {
			// Use GraphQL to refresh starred count
			fetchSampleCounts();
		}

		// GraphQL-based tab counts
		function fetchSampleCounts() {
			var countQuery = [
				'query GetSampleCounts($filters: SampleFilters) {',
				'    sampleCounts(filters: $filters) {',
				'        total',
				'        starred',
				'        inProgress',
				'        completed',
				'    }',
				'}'
			].join('\n');

			// Remove state-specific filters for accurate counts
			var filters = buildGraphQLFilters();
			delete filters.isInProgress;
			delete filters.starred;
			delete filters.isCompleted;
			delete filters.isPass;
			delete filters.isFail;
			delete filters.isUndetermined;

			GraphQLService.query(countQuery, { filters: filters })
				.then(function(data) {
					vm.filterCounts = {
						total: data.sampleCounts.total,
						starred: data.sampleCounts.starred,
						isInProgress: data.sampleCounts.inProgress,
						isCompleted: data.sampleCounts.completed
					};
					// Cache counts and filter hash for page navigation
					sessionStorage.setItem('sampleLogCounts', JSON.stringify(vm.filterCounts));
					sessionStorage.setItem('sampleLogFilterHash', getFilterHash());
				})
				.catch(function(error) {
					console.error('Error fetching sample counts:', error);
				});
		}

		// Only fetch counts on initial load or when filters change (not page changes)
		// Create a hash of current filters to detect changes
		function getFilterHash() {
			var filters = buildGraphQLFilters();
			delete filters.isInProgress;
			delete filters.starred;
			delete filters.isCompleted;
			delete filters.isPass;
			delete filters.isFail;
			delete filters.isUndetermined;
			return JSON.stringify(filters);
		}

		var currentFilterHash = getFilterHash();
		var cachedFilterHash = sessionStorage.getItem('sampleLogFilterHash');
		var cachedCounts = sessionStorage.getItem('sampleLogCounts');

		// Only fetch counts if filters changed or no cache exists
		if (!cachedCounts || cachedFilterHash !== currentFilterHash) {
			fetchSampleCounts();
		} else {
			// Use cached counts
			vm.filterCounts = JSON.parse(cachedCounts);
		}

		// Cache key for totalItems includes tab state
		function getTotalItemsCacheKey() {
			var tabState = (pagingParams.starred ? 'starred' : '') +
						   (pagingParams.isInProgress ? 'inProgress' : '') +
						   (pagingParams.isCompleted ? 'completed' : '') +
						   (pagingParams.isPass ? 'pass' : '') +
						   (pagingParams.isFail ? 'fail' : '') || 'all';
			return 'sampleLogTotalItems_' + tabState + '_' + currentFilterHash;
		}

		// Load cached totalItems to prevent flashing
		var cachedTotalItems = sessionStorage.getItem(getTotalItemsCacheKey());
		if (cachedTotalItems) {
			vm.totalItems = parseInt(cachedTotalItems);
			vm.queryCount = vm.totalItems;
		}

        $scope.canSeeTest = function(sample, testName) {
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
					'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
					'POTENCY_PLANT' : 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			'ALKALOID': 'Alkaloid'
        	}
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = assayIdMap[sample.sampleTests[i].assay.portalIdentifier];
        		if (test === testName) {
        			return sample.sampleTests[i].canSeeResults;
        		}
        	}
        }

        vm.downloadSamplesCsv = function downloadSamplesCsv () {

            var fileName = "samples.csv";
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            SampleExportService.downloadCsv().then(function (result) {
                var file = new Blob([result.data], {type: 'application/json'});
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            });


        }

		function padToTwo(number) {
            return `0${number}`.slice(-2);
		}

		function formatDate(date) {
            var month = date.getUTCMonth() + 1;
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();

            return `${padToTwo(month)}/${padToTwo(day)}/${year}`;
        }

		vm.displayDueDate = function(sample) {
			if(sample.sampleTests.length == 0) return '-';
			var tests = sample.sampleTests;
			var test = null;
			var current_due_date = null;

			for(var test_index = 0; test_index < tests.length; test_index++) {
				test = tests[test_index];
				if(current_due_date == null) current_due_date = test.estimatedCompleteDate;
				if(test.estimatedCompleteDate != current_due_date) return "Various";
			}

            if(!current_due_date) return "-";

			try {
                current_due_date = new Date(current_due_date);
                if(current_due_date == 'Invalid Date') throw 'Invalid Date'

				return formatDate(current_due_date);
			}
			catch(e) {
				console.log(e);
                return current_due_date;
			}
		}

		vm.hasReceivedDate = sampleHasReceivedDate;

		vm.hasDueDate = function(sample) {
			if(!sample.sampleTests || sample.sampleTests.length == 0) return false;
			var test = sample.sampleTests[0];
			return test.estimatedCompleteDate != null && test.estimatedCompleteDate != undefined;
		}

        vm.updateSamplePublicity = function(sample) {
            vm.getAttachmentsLoader = false;
            sample.attachments = null;
            Sample.public({id: sample.id, public: sample.public});

        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.downloadSampleStartDate = false;
        vm.datePickerOpenStatus.downloadSampleEndDate = false;

		$scope.clickCount = 0;
        vm.openCalendar = function(date) {
			$scope.clickCount++;
            vm.datePickerOpenStatus[date] = true;
			if($scope.clickCount > 2 && vm.downloadSamplesError == true ){
				vm.downloadSamplesError = false;
			}

        }

        vm.downloadSample = {
        		startDate: null,
        		endDate: null,
        		type: 'COA'
        }

		$('#downloadSamplesModal').on('show.bs.modal', function () {
            vm.downloadSample.startDate = vm.sampleFilters.completeDateLower;
            vm.downloadSample.endDate = vm.sampleFilters.completeDateUpper;
            vm.downloadSamplesJobSubmitted = false;
            vm.downloadSamplesError = false;
            vm.downloadSamplesNull = false;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });

        vm.downloadingSamples = false;
        vm.downloadSamplesError = false;
        vm.downloadSamplesErrorMsg = '';
        vm.downloadSamplesNull = false;
        vm.downloadSamplesJobSubmitted = false;

        vm.downloadSamples = function() {
        	vm.downloadSamplesError = false;
			vm.downloadSamplesErrorMsg = '';
        	vm.downloadSamplesNull = false;
        	vm.downloadSamplesJobSubmitted = false;

        	if (vm.downloadSample.type === "CSV" && (!vm.downloadSample.startDate || !vm.downloadSample.endDate)) {
        		vm.downloadSamplesError = true;
        		vm.downloadSamplesErrorMsg = 'CSV export requires both a start and end date.';
        		return;
        	}

        	if (vm.downloadSample.type !== "CSV" && !vm.downloadSample.startDate && !vm.downloadSample.endDate) {
        		vm.downloadSamplesError = true;
        		vm.downloadSamplesErrorMsg = 'Please select at least one date.';
        		return;
        	}

        	var sampleExportParams = {
                	startDate: vm.downloadSample.startDate ? vm.downloadSample.startDate.getTime()/1000 : null,
                	endDate: vm.downloadSample.endDate ? vm.downloadSample.endDate.getTime()/1000 : null,
                	type: vm.downloadSample.type
        	}
        	vm.downloadingSamples = true;

        	if (vm.downloadSample.type == "COA") {
            	SampleExportService.downloadCoa(sampleExportParams).then(function (result) {
                    var fileName = "samples";
                    if (sampleExportParams.startDate && sampleExportParams.endDate) {
                    	fileName += " " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy') + " to " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.startDate) {
                    	fileName += " after " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.endDate) {
                    	fileName += " before " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    }
                    fileName += ".zip";

            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	} else {
				var params = {};
				var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];
				for (var key in vm.sampleFilters) {
					if (dateFields.indexOf(key) !== -1 && vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
						params[key] = convertLocalDateToServer(vm.sampleFilters[key]);
					} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
						params[key] = vm.sampleFilters[key];
					}
				}
				sampleExportParams.filter_details = params
            	SampleExportService.submitCsvExportJob(sampleExportParams).then(function (result) {
            		vm.downloadingSamples = false;
            		vm.downloadSamplesJobSubmitted = true;
                }, function(error) {
                	downloadSamplesError(error);
                });
        	}
        }

        /* Publish to weedmaps */
        vm.publishToWeedmapsArgs = {
        		id: null, // required
        		weedmapsListingId: null, // required
        		weedmapsMenuItemName: null, // required
        		weedmapsMenuItemCategory: null, // optional
        		weedmapsMenuItemId: null // optional
        }

        vm.publishToWeedmaps = function() {
        	function onSuccess(data) {
        		vm.publishToWeedmapsSuccess = true;
        		vm.publishingToWeedmaps = false;
        		$timeout(function(){
        			$('#publishToWeedmapsModal').modal('hide');
        			$state.reload();
        		},2000)
        	}
        	function onError(error) { vm.publishToWeedmapsSuccess = false; vm.publishingToWeedmaps = false; }

        	vm.publishingToWeedmaps = true;
        	Weedmaps.publish(vm.publishToWeedmapsArgs, onSuccess, onError);

        }

        vm.emailsPending = [""];
        vm.emailMessage = "";

        vm.sendPublicEmail = function (form) {
        	vm.emailsPending = $('#testtaginput').tagsinput('items')
        	vm.emailSubject = $('#emailSubject').val();
        	//Send The Email
        	if (form.$valid && vm.emailsPending.length > 0){
        		$('#sendPublicSampleButton').attr("disabled", true);
        		Sample.sendEmail({
        			emails: vm.emailsPending,
        			message: vm.emailMessage,
        			public_link: vm.emailSamplePublicLink,
        			pic_url: vm.currentPublicSample.picture,
        			id:vm.currentPublicSample.id,
        			totalTHC: getTotalThc(vm.currentPublicSample),
        			subject: vm.emailSubject
        		}, onSuccess, onError);
        	}
        	else {
        		if (vm.emailsPending.length == 0)
        			$('#emailValidation').show();
        		return
        	}
        	function onSuccess(data, headers) {
        		$('#emailModal').modal('hide');
        		$('#emailModalSuccess').modal('show');
        		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
        }

    $('#emailModalSuccess').on('hidden.bs.modal', function() {
        	$('#testtaginput').tagsinput('removeAll');
        	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
        })

        vm.copyLink = function(id) {
    	  /* Get the text field */
    	  var copyText = document.getElementById(id);
    	  /* Select the text field */
    	  copyText.select();
    	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    	  /* Copy the text inside the text field */
    	  document.execCommand("copy");
        }

        vm.currentPublicSample = null

        vm.createSamplePublicLink = function(sample) {
        	var hash = sample.hash;
        	var fullUrl = window.location.origin +"/#/ps/"+ sample.hash;
        	vm.currentPublicSample = sample;
        	return fullUrl;
        }

        vm.openWeedmapsModal = function(sample) {
        	if (!sample.complete || !sample.canSeeReport) {
        		AlertService.error("Sample " + sample.id + " is not yet ready to be published", null, 'top right');
        		return;
        	}
            vm.publishToWeedmapsArgs = {
            		id: sample.id, // required
            		weedmapsListingId: parseInt(sample.weedmapsListingId), // required
            		weedmapsMenuItemName: sample.weedmapsMenuItemName, // required
            		weedmapsMenuItemCategory: sample.weedmapsMenuItemCategory, // optional
            		weedmapsMenuItemId: sample.weedmapsMenuItemId // optional
            }
            vm.publishToWeedmapsSuccess = null;
        	$('#publishToWeedmapsModal').modal('show');
        }
        $('#publishToWeedmapsModal').on('hidden.bs.modal', function() { vm.publishToWeedmapsArgs = {}; });

        $scope.getReports = function (sample,id) {
	        vm.getReportsLoader = true;
	        vm.idOfSelectedSample = id;


	        if(sample.reports != null){
		        vm.getReportsLoader = false;
		        return;
	        }

	        SampleAttach.getReports({id: id}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getReportsLoader = false;
		        sample.reports = data;

	        }
	        function onError(error) {
	        	AlertService.error(error.data.message);
	        }
		}

		$scope.removeElement = function (allAttachments, at) {
			return allAttachments.filter(function (attachment) {
				if (attachment.id !== at.id) return attachment;
			})

		}

		$scope.reorderAttachments = function (attach) {
			var allAttachments = attach.slice();
			var reordered = [];
            if (attach && attach.length) {
                var newOrder = ['_consolidated_coa', '_coa', '_qr_code', 'pictures'];
                newOrder.forEach(function (reg) {
                    attach.forEach(function (at, key) {
                        if (reg === '_consolidated_coa' && at.file_name.toLowerCase().includes('_consolidated_coa')){
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg === '_coa' && at.file_name.toLowerCase().includes('_coa')) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg === '_qr_code' && at.file_name.toLowerCase().includes('_qr_code')) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
                        }
                        else if (reg ===  'pictures' && at.is_picture) {
							reordered.push(at);
							allAttachments = $scope.removeElement(allAttachments, at);
						}
                    })
                })
			}
			if (allAttachments.length) {
				for (var i = 0; i < allAttachments.length; i++){
					reordered.push(allAttachments[i]);
				}
			}
            return reordered;
    }

        function isLabelAttachment(attachment) {
            if (!attachment) {
                return false;
            }

            if (attachment.type === 'SAMPLE_LABEL_ATTACHMENT') {
                return true;
            }

            var fileName = ((attachment.file_name || '') + '').toLowerCase();
            return /(^labels?(?:\b|[_-])|[_\s-]labels?\b)/.test(fileName);
        }

        $scope.getAttachments = function (sample, id) {
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedSample = id;

				if(sample.attachments != null){
					vm.getAttachmentsLoader = false;
					return;
				}

				SampleAttach.query({id: id}, onSuccess, onError);
				function onSuccess(data, headers) {
					var processed_attachments = [];

					vm.getAttachmentsLoader = false;
					sample.attachments = data;
					sample.attachments.forEach(function(attachment) {
						var fileName = attachment.file_name.toLowerCase();
						if (fileName.includes('coa')) {
							// Only include COA files if canSeeReport is true.
							if (sample.canSeeReport) {
								processed_attachments.push(attachment);
							}
						} else if (!isLabelAttachment(attachment)) {
							// For non-COA files, use the label rule.
							processed_attachments.push(attachment);
						}
					});
					
					sample.attachments = processed_attachments;
				}
				function onError(error) {
					AlertService.error(error.data.message);
				}
		}

        $scope.toggleVisibility = function(id, sample) {
        	Sample.toggleVisibility({id: id},onSuccess,onError);

        	function onSuccess (data, headers) {
        		sample.is_public = data.is_public
        	}

        	function onError(error) {

		    }
        }

        $scope.toggleStarred = function(id, sample) {
        	Sample.toggleStarred({id: id},onSuccess,onError);

        	function onSuccess (data, headers) {
				sample.starred = data.starred
				getStarredSamplesCount()
        	}

        	function onError(error) {

		    }
		}

		$scope.isWithForeignTest = function (sample) {
			var flag = false;
			var test = sample.sampleTests;
			if (test.length) {
				for (var i = 0; i < test.length; i++){
					var t = test[i];
					if (t.assay.portalIdentifier == 'FOREIGN_MATERIAL') flag = true;
				}
				return flag;
			} else return false;
		}

		$scope.isWithCDPHETest = function (sample) {
			var flag = false;
			var test = sample.sampleTests;
			if (test.length) {
				for (var i = 0; i < test.length; i++){
					var t = test[i];
					if (t.assay.portalIdentifier == 'CO_CDPHE') flag = true;
				}
				return flag;
			} else return false;
		}

		$scope.downloadAttachment = function (id_hash, sample) {
			if(id_hash) {
				if(id_hash == 'coa') {
					var a = document.createElement("a");
					document.body.appendChild(a);
					a.style = "display: none";
					SampleCoaPdfService.downloadPdf(sample.hash).then( function(result) {
						var file = new Blob([result.data], {
							type: 'application/pdf'
						});

						a.href = window.URL.createObjectURL(file);
						a.download = sample.id + '_COA_Summary.pdf';
						a.click();
					});
				}
				else if(['california', 'colorado'].includes(id_hash)) {
					SampleAttachDownload.getBadge({text: window.location.host + '/#/ps/' + sample.hash, state: id_hash}, onSuccess, onError);
					var capitalizedState = id_hash.charAt(0).toUpperCase() + id_hash.slice(1);

					function onSuccess(data, headers) {
						var a = document.createElement("a");
						document.body.appendChild(a);
						a.style = "display: none";

						var fileURL = window.URL.createObjectURL(data.data);
						a.href = fileURL;
						a.download = sample.id + '_' + capitalizedState + '_QR_Code_Badge.png';
						a.click();
					}
					function onError(error) {
						console.log(error);
					}

				}
				else {
					SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

					function onSuccess(data, headers) {
						var a = document.createElement("a");
						document.body.appendChild(a);
						a.style = "display: none";

						var fileURL = window.URL.createObjectURL(data.data);
						a.href = fileURL;
						// Parse and sanitize filename from Content-Disposition header
						a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
						a.click();
					}
					function onError(error) {
						console.log(error);
					}
				}
			}
			sample.select = "";
		}

		$scope.starred = pagingParams.starred ? pagingParams.starred : false;

		vm.toggleStarredView = function() {
			$scope.starred = !$scope.starred;

			vm.filterSubmit();
		}

		$('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

		$('#testtaginput').tagsinput('input')[0].type = 'email'
		/*
		 * Gallery View Variables and Functions
		 * */

		$rootScope.galleryView = pagingParams.galleryView ? pagingParams.galleryView : false;
		var picturesLoaded = false;

		// Watch for gallery view toggle to load pictures on-demand
		$rootScope.$watch('galleryView', function(newVal) {
			if (newVal && !picturesLoaded && vm.samples && vm.samples.length > 0) {
				loadAllPictures();
				picturesLoaded = true;
			}
		});

		/* Download Samples */
        function downloadSamplesSuccess(fileName, result) {
    		if (result.data.byteLength == 0) {
    			vm.downloadSamplesNull = true;
    			vm.downloadingSamples = false;
    			return;
    		}

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var file = new Blob([result.data], {type: 'application/json'});
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
            vm.downloadingSamples = false;
        }
        function downloadSamplesError(err) {
            vm.downloadingSamples = false;
            vm.downloadSamplesError = true;

            // Handle both ArrayBuffer responses (old endpoints) and JSON responses (new job endpoint)
            if (err.data instanceof ArrayBuffer) {
                var decodedString = new TextDecoder("utf-8").decode(new Uint8Array(err.data));
                var jsonResponse = JSON.parse(decodedString);
                vm.downloadSamplesErrorMsg = jsonResponse.message;
            } else if (err.data && err.data.message) {
                vm.downloadSamplesErrorMsg = err.data.message;
            } else if (err.data && err.data.error) {
                vm.downloadSamplesErrorMsg = err.data.error;
            } else {
                vm.downloadSamplesErrorMsg = 'An error occurred while processing your request.';
            }

            if (err.status === 404) {
                vm.downloadSamplesErrorMsg = 'No samples found during selected dates, please select new dates.';
            }
        }

        $scope.clearBtn = function() {
            vm.downloadSample.startDate = '';
            vm.downloadSample.endDate = '';
            vm.downloadSamplesError = false;
            vm.downloadSamplesJobSubmitted = false;
        }

        /* Date Utils (import DateUtils service doesn't work) */
        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        /* Login/Logout */
        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        /* Navbar Toggle */
        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }


        function setPageTitle(){
            $rootScope.pageTitle = "Samples";
            $rootScope.searchVm = vm;
		}

		vm.customerType = "";

		// Try to load cached customer data immediately to prevent flashing
		var cachedCustomerData = sessionStorage.getItem('sampleLogCustomerData');
		if (cachedCustomerData) {
			var cached = JSON.parse(cachedCustomerData);
			vm.customerData = cached.customerData;
			vm.customerType = cached.customerType;
			vm.sampleColumnThc = cached.sampleColumnThc;
			vm.sampleColumnCbd = cached.sampleColumnCbd;
			vm.thcCbdFilterOptions = cached.thcCbdFilterOptions;
			vm.sampleColumnAlkaloids = cached.sampleColumnAlkaloids;
			vm.sampleColumnMitragynine = cached.sampleColumnMitragynine;
		}

        function getCustomerData () {
			// Skip fetch if we have cached data
			if (cachedCustomerData) {
				return;
			}

			CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
				var type_of_business = data.businessType.name.toLowerCase();
				vm.customerData = data;
				try {
					vm.customerType = data.businessType.name;
				}
				catch (error) {
					console.log(error);
				}
				if (type_of_business.includes('food')) {
					vm.customerData.consolidated_business_type = 'food';
					vm.sampleColumnThc = false;
					vm.sampleColumnCbd = false;
					vm.thcCbdFilterOptions = false;
					vm.sampleColumnAlkaloids = true;
					vm.sampleColumnMitragynine = true;
				}
				else if (type_of_business.includes('cannabis')) {
					vm.customerData.consolidated_business_type = 'cannabis';
					vm.sampleColumnThc = true;
					vm.sampleColumnCbd = true;
					vm.thcCbdFilterOptions = true;
					vm.sampleColumnAlkaloids = false;
					vm.sampleColumnMitragynine = false;
				}
				else if (type_of_business.includes('hemp')) {
					vm.customerData.consolidated_business_type = 'hemp';
					vm.sampleColumnThc = true;
					vm.sampleColumnCbd = true;
					vm.thcCbdFilterOptions = true;
					vm.sampleColumnAlkaloids = false;
					vm.sampleColumnMitragynine = false;
				}
				else if (type_of_business.includes('kratom')){
					vm.customerData.consolidated_business_type = 'kratom';
					hasAlkaloidsMitragynine();
					vm.sampleColumnThc = false;
					vm.sampleColumnCbd = false;
					vm.thcCbdFilterOptions = false;
					vm.sampleColumnAlkaloids = true;
					vm.sampleColumnMitragynine = true;
				}

				// Cache customer data to prevent flashing on page navigation
				sessionStorage.setItem('sampleLogCustomerData', JSON.stringify({
					customerData: vm.customerData,
					customerType: vm.customerType,
					sampleColumnThc: vm.sampleColumnThc,
					sampleColumnCbd: vm.sampleColumnCbd,
					thcCbdFilterOptions: vm.thcCbdFilterOptions,
					sampleColumnAlkaloids: vm.sampleColumnAlkaloids,
					sampleColumnMitragynine: vm.sampleColumnMitragynine
				}));
            }
            function onError(e) {
				console.log(e);
            }
		}
		vm.determinePotencyDisplayForMitragynineAndAlkaloids = function(sample,potencyType,show_dash) {
			if (!sample.sampleTests) {
				return '';
			}
			var potency = '';
			var ws = null;
			var val = 'twoDecimalFormattedValue';
			if(vm.alkaloidsWorksheets){
				for (var i = 0; i < sample.sampleTests.length; i++) {
					if(vm.alkaloidsWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						if(sample.sampleTests[i].worksheetData) {
							ws = sample.sampleTests[i].worksheetData;
							if(ws[potencyType + '_percent']['value'] == '0') {
								potency = '0%';
							}
							else {
								potency = ws[potencyType + '_percent'][val] ? ws[potencyType + '_percent'][val] + ' %' : '';
							}
						}
					}
				}
			}
			if(show_dash) {
				return potency ? potency : '-';
			}
			else {
				return potency;
			}
		}
		
			vm.determinePotencyDisplay = function(sample, potencyType, total, show_dash) {
			if (!sample.sampleTests) {
				return '';
			}
			var potency = '';
			var ws = null;

			if(total) {
				potencyType = 'thc';
			}

			var val = 'twoDecimalFormattedValue';

			if(vm.cannabioidWorksheets) {
				for (var i = 0; i < sample.sampleTests.length; i++) {
					if(vm.cannabioidWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						if(sample.sampleTests[i].worksheetData) {
							ws = sample.sampleTests[i].worksheetData;


							if(ws['total_' + potencyType + '_mgpp']){
								if(!total) {
									if(ws['total_' + potencyType + '_mgpp']['value'] == '0') {
										potency = '0 mg/pkg';
									}
									else {
										potency = ws['total_' + potencyType + '_mgpp'][val] ? ws['total_' + potencyType + '_mgpp'][val] + ' mg/pkg' : '';
									}
								}
								else {
									if( ws['total_mgpp']['value'] == '0') {
										potency = '0 mg/pkg';
									}
									else {
										potency = ws['total_mgpp'][val] ? ws['total_mgpp'][val] + ' mg/pkg' : '';
									}
								}
							}
							if(ws['units_per_package'] && [null, '', '1'].includes(ws['units_per_package']['value']) && ws['total_' + potencyType + '_mgpu'] && potency == '') {
								if(!total) {
									if(ws['total_' + potencyType + '_mgpu']['value'] == '0') {
										potency = '0 mg/serv';
									}
									else {
										potency = ws['total_' + potencyType + '_mgpu'][val] ? ws['total_' + potencyType + '_mgpu'][val] + ' mg/serv' : '';
									}
								}
								else {
									if(ws['total_mgpu']['value'] == '0') {
										potency = '0 mg/serv';
									}
									else {
										potency = ws['total_mgpu'][val] ? ws['total_mgpu'][val] + ' mg/serv' : '';
									}
								}
							}
							if(!(['0', 0, null].includes(ws['moisture']['value'])) && ws['total_' + potencyType + '_dry_percent'] && potency == '') {
								if(!total) {
									if(ws['total_' + potencyType + '_dry_percent']['value'] == '0') {
										potency = '0% (dry)';
									}
									else {
										potency = ws['total_' + potencyType + '_dry_percent'][val] ? ws['total_' + potencyType + '_dry_percent'][val] + ' % (dry)' : '';
									}
								}
								else {
									if(ws['total_dry_percent']['value'] == '0') {
										potency = '0% (dry)';
									}
									else {
										potency = ws['total_dry_percent'][val] ? ws['total_dry_percent'][val] + ' % (dry)' : '';
									}
								}
							}
							if(!potency) {
								if(!total) {
									if(ws['total_' + potencyType + '_percent']['value'] == '0') {
										potency = '0%';
									}
									else {
										potency = ws['total_' + potencyType + '_percent'][val] ? ws['total_' + potencyType + '_percent'][val] + ' %' : '';
									}
								}
								else {
									if(ws['total_percent']['value'] == '0') {
										potency = '0%';
									}
									else {
										potency = ws['total_percent'][val] ? ws['total_percent'][val] + ' %' : '';
									}
								}
							}
						}
					}
				}
			}

			if(show_dash) {
				return potency ? potency : '-';
			}
			else {
				return potency;
			}
		}


		// function hasAlkaloidsMitragynine(){
		// 	if (vm.userAccount.userSettings) {
		// 		console.log(vm.userAccount.userSettings,'vm.userAccount.userSettingsssssss');
		// 		vm.userAccount.userSettings = JSON.stringify({sample_columns: vm.columns});
		// 	} else {
		// 		var userSettings = JSON.parse(vm.userAccount.userSettings);
		// 			userSettings.sample_columns = vm.sampleColumns;
		// 			console.log(vm.sampleColumns.mitragynine,'vm.sampleColumns');
		// 			if(vm.sampleColumns && !vm.sampleColumns.mitragynine){
		// 				if(vm.customerData.consolidated_business_type.includes('food')){
		// 					vm.sampleColumns.mitragynine = true;
		// 				}
		// 				else{
		// 					vm.sampleColumns.mitragynine = false;
		// 				}
		// 			}
		// 	}
		// }

		function hasAlkaloidsMitragynine(){
			if(vm.customerData.consolidated_business_type.includes('kratom') ){
				vm.sampleColumns.alkaloids = true;
				vm.sampleColumns.mitragynine = true;
			}
			else{
				vm.sampleColumns.alkaloids = false;
				vm.sampleColumns.mitragynine = false;
			}
		}

		$scope.hasCannabinoids = function(sample) {
			if (!sample.sampleTests) {
				return false;
			}
			if(vm.cannabioidWorksheets) {
				for (var i=0; i < sample.sampleTests.length; i++) {
					if(!sample.sampleTests[i].assay) {
						continue;
					}

					if(vm.cannabioidWorksheets.includes(sample.sampleTests[i].assay.worksheet_id)) {
						return true;
					}
				}
			}
			return false;
		}

        function getTotalThc(sample) {
        	if (!sample.sampleTests) return;
        	for (var i = 0; i < sample.sampleTests.length; i++){
        		var test = sample.sampleTests[i];
        		if (!test.assay || !test.assay.portalIdentifier) continue;
        		var assay = test.assay.portalIdentifier;
        		if (assay === 'POTENCY_LCDAD' || assay === 'POTENCY_GCFID' || assay === 'POTENCY_LCMSMS' || assay === 'POTENCY_LCDAD_NON_PLANT') {
					if (test.worksheetData && test.worksheetData.total_dry_percent && test.worksheetData.total_dry_percent.twoDecimalFormattedValue) {
						return test.worksheetData.total_dry_percent.twoDecimalFormattedValue + ' %';
        			}
        		}
        	}
        	return 'N/A';
        }

        /* Edit Columns */
		function saveSampleColumns() {
			if (!vm.userAccount.userSettings) {
				vm.userAccount.userSettings = JSON.stringify({sample_columns: vm.columns});
			} else {
				var userSettings = JSON.parse(vm.userAccount.userSettings);
				userSettings.sample_columns = vm.sampleColumns;
				vm.userAccount.userSettings = JSON.stringify(userSettings);
			}
			// Cache to sessionStorage for instant restore on page navigation
			sessionStorage.setItem('sampleLogColumns', JSON.stringify(vm.sampleColumns));
			Auth.updateAccount(vm.userAccount);
		}

		/* Page loads */
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
            fetchSampleCounts();  // Refresh tab counts for search
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.sampleFilters = {};
            vm.populateTypes();
            vm.transition();
            fetchSampleCounts();  // Refresh tab counts after clearing filters
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
			var params = createFilterQueryParams();

        	if ($rootScope.galleryView) {
        		params['galleryView'] = true;
        	}
        	else {
        		params['galleryView'] = null;
        	}

        	if ($scope.starred ||$stateParams.starred) {
				params['starred'] = true;
			}
        	else {
				params['starred'] = null;
			}

			if ($scope.isInProgress || $stateParams.isInProgress) {
				params['isInProgress'] = true;
			}
			else {
				params['isInProgress'] = null;
			}

			if ($scope.isCompleted || $stateParams.isCompleted) {
				params['isCompleted'] = true;
			}
			else {
				params['isCompleted'] = null;
			}

			$state.go('.', params, { notify: false, reload: false });
			vm.setTabViews();
			loadAll();
        }

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

		function extractPackageValues(samples) {
			samples.forEach( function (sample){
				sample.sampleTests.forEach( function (test){
					if (sample.order.order_type.toLowerCase().includes('compliance')) {
						test.canSeeResults = sample.canSeeReport;
					}
					if (test.worksheetData){
						if (test.worksheetData['total_thc_mgpp']){
							sample.thc_mgpp = test.worksheetData['total_thc_mgpp'].value;
						}
						if (test.worksheetData['total_cbd_mgpp']){
							sample.cbd_mgpp = test.worksheetData['total_cbd_mgpp'].value;
						}
						if (test.worksheetData['total_mgpp']){
							sample.total_mgpp = test.worksheetData['total_mgpp'].value;
						}
					}
				});
			});
		}

        /** Load ALL the Sample Images!
         * Ideally, make an endpoint to retrieve all of the sample images so you don't need to keep calling.
         * **/

        // Cache for test results (Tier 3 - on-demand loading)
        vm.testResultsCache = {};

        // Build GraphQL filters from current filter state
        function buildGraphQLFilters() {
            var filters = {};
            var sf = vm.sampleFilters;

            if (sf.id) filters.id = parseInt(sf.id);
            if (sf.orderId) filters.orderId = parseInt(sf.orderId);
            if (sf.sampleName) filters.sampleName = sf.sampleName;
            if (sf.lotNumber) filters.lotNumber = sf.lotNumber;
            if (sf.metrcId) filters.metrcId = sf.metrcId;
            if (sf.sampleMatrix) filters.sampleMatrix = sf.sampleMatrix;
            if (sf.categoryIdList && sf.categoryIdList.length) filters.categoryIdList = sf.categoryIdList;
            if (sf.category && sf.category.id) filters.categoryIdList = [sf.category.id];
            if (sf.subCategory && sf.subCategory.id) filters.subCategoryId = sf.subCategory.id;
            if (sf.orderType && sf.orderType !== 'ALL') filters.orderType = sf.orderType;
            if (sf.thcLower) filters.thcLower = parseFloat(sf.thcLower);
            if (sf.thcUpper) filters.thcUpper = parseFloat(sf.thcUpper);
            if (sf.cbdLower) filters.cbdLower = parseFloat(sf.cbdLower);
            if (sf.cbdUpper) filters.cbdUpper = parseFloat(sf.cbdUpper);
            if (sf.isPass) filters.isPass = true;
            if (sf.isFail) filters.isFail = true;
            if (sf.isUndetermined) filters.isUndetermined = true;
            // Tab filters - check both vm.sampleFilters and pagingParams (tabs update pagingParams directly)
            if (sf.isInProgress || pagingParams.isInProgress) filters.isInProgress = true;
            if (sf.isCompleted || pagingParams.isCompleted) filters.isCompleted = true;
            if (sf.starred || pagingParams.starred) filters.starred = true;
            if (sf.visibility) filters.visibility = sf.visibility;
            if (sf.isWeedmapsSuccess) filters.isWeedmapsSuccess = true;
            if (sf.isWeedmapsFail) filters.isWeedmapsFail = true;
            if (sf.isWeedmapsNone) filters.isWeedmapsNone = true;

            // Date filters
            if (sf.completeDateLower) {
                filters.completeDateLower = $filter('date')(sf.completeDateLower, 'yyyy-MM-dd');
            }
            if (sf.completeDateUpper) {
                filters.completeDateUpper = $filter('date')(sf.completeDateUpper, 'yyyy-MM-dd');
            }
            if (sf.estimatedDueDateLower) {
                filters.estimatedDueDateLower = $filter('date')(sf.estimatedDueDateLower, 'yyyy-MM-dd');
            }
            if (sf.estimatedDueDateUpper) {
                filters.estimatedDueDateUpper = $filter('date')(sf.estimatedDueDateUpper, 'yyyy-MM-dd');
            }

            // Search
            if (vm.currentSearch) {
                filters.search = vm.currentSearch;
            }

            return filters;
        }

        // Tier 2: Load potency data after initial render
        function loadPotencyData() {
            if (!vm.samples || vm.samples.length === 0) return;

            var sampleIds = vm.samples.map(function(s) { return s.id; });

            // Combined query for potency AND test results (avoids separate hover API call)
            var potencyQuery = [
                'query GetSamplesPotency($sampleIds: [Int!]!) {',
                '    samplesPotencyBatch(sampleIds: $sampleIds) {',
                '        sampleId',
                '        thc',
                '        cbd',
                '        totalCannabinoids',
                '        alkaloids',
                '        mitragynine',
                '        tests {',
                '            id',
                '            assayTitle',
                '            assayPortalIdentifier',
                '            assayWorksheetId',
                '            state',
                '            statusPf',
                '            canSeeResults',
                '            caution',
                '            estimatedCompleteDate',
                '        }',
                '    }',
                '}'
            ].join('\n');

            GraphQLService.query(potencyQuery, { sampleIds: sampleIds })
                .then(function(data) {
                    // Create lookup map
                    var potencyMap = {};
                    data.samplesPotencyBatch.forEach(function(p) {
                        potencyMap[p.sampleId] = p;
                    });

                    // Update samples with potency data AND test results
                    vm.samples.forEach(function(sample) {
                        var potency = potencyMap[sample.id];
                        if (potency) {
                            sample.thcDisplay = potency.thc;
                            sample.cbdDisplay = potency.cbd;
                            sample.totalCannabinoidsDisplay = potency.totalCannabinoids;
                            sample.alkaloidsDisplay = potency.alkaloids;
                            sample.mitragynineDisplay = potency.mitragynine;

                             // Store test results for hover (transformed to match expected structure)
                            sample.sampleTests = potency.tests.map(function(t) {
                                return {
                                    id: t.id,
                                    assay: {
                                        title: t.assayTitle,
                                        portalIdentifier: t.assayPortalIdentifier,
                                        worksheet_id: t.assayWorksheetId
                                    },
                                    state: t.state,
                                    statusPf: t.statusPf,
                                    canSeeResults: t.canSeeResults,
                                    caution: t.caution,
                                    estimatedCompleteDate: t.estimatedCompleteDate
                                };
                            });

                            // Cache test results so hover doesn't need to fetch
                            vm.testResultsCache[sample.id] = sample.sampleTests;
                        }
                        sample.potencyLoaded = true;
                    });
                })
                .catch(function(error) {
                    console.error('Error loading potency data:', error);
                    // Mark as loaded anyway so UI doesn't stay in loading state
                    vm.samples.forEach(function(sample) {
                        sample.potencyLoaded = true;
                    });
                });
        }

        // Hover tooltip: Use cached test results (loaded with potency data)
        // Falls back to API call only if user hovers before potency loads (rare)
        vm.loadTestResultsForHover = function(sample) {
            // Return if already loaded via potency batch
            if (sample.sampleTests && sample.sampleTests.length > 0) {
                return;
            }

            // Return cached if available
            if (vm.testResultsCache[sample.id]) {
                sample.sampleTests = vm.testResultsCache[sample.id];
                return;
            }

            // Fallback: fetch individually if hover happens before potency loads
            sample.testsLoading = true;

            var testQuery = [
                'query GetSampleTests($sampleId: Int!) {',
                '    sampleTestResults(sampleId: $sampleId) {',
                '        id',
                '        assayTitle',
                '        assayPortalIdentifier',
                '        assayWorksheetId',
                '        state',
                '        statusPf',
                '        canSeeResults',
                '        caution',
                '        estimatedCompleteDate',
                '    }',
                '}'
            ].join('\n');

            GraphQLService.query(testQuery, { sampleId: sample.id })
                .then(function(data) {
                    var tests = data.sampleTestResults.map(function(t) {
                        return {
                            id: t.id,
                            assay: {
                                title: t.assayTitle,
                                portalIdentifier: t.assayPortalIdentifier,
                                worksheet_id: t.assayWorksheetId
                            },
                            state: t.state,
                            statusPf: t.statusPf,
                            canSeeResults: t.canSeeResults,
                            caution: t.caution,
                            estimatedCompleteDate: t.estimatedCompleteDate
                        };
                    });

                    vm.testResultsCache[sample.id] = tests;
                    sample.sampleTests = tests;
                    sample.testsLoading = false;
                })
                .catch(function(error) {
                    console.error('Error loading test results:', error);
                    sample.testsLoading = false;
                    sample.sampleTests = [];
                });
        };

        function loadAll() {
            vm.loadingSamples = true;

            // GraphQL query for samples list (Tier 1 - fast initial load)
            var samplesQuery = [
                'query GetSamplesList($page: Int!, $size: Int!, $sort: String, $filters: SampleFilters) {',
                '    samplesList(page: $page, size: $size, sort: $sort, filters: $filters) {',
                '        samples {',
                '            id',
                '            name',
                '            hash',
                '            lotBatchNumber',
                '            status',
                '            starred',
                '            isPublic',
                '            canSeeReport',
                '            complete',
                '            rd',
                '            sCode',
                '            sampleMatrix',
                '            weedmapsState',
                '            orderId',
                '            orderDateReceived',
                '            orderDateCompleted',
                '            orderType',
                '            productCategoryName',
                '            productTypeName',
                '            strainName',
                '            strainType',
                '            dueDate',
                '            testCount',
                '        }',
                '        totalCount',
                '    }',
                '}'
            ].join('\n');

            var filters = buildGraphQLFilters();

            GraphQLService.query(samplesQuery, {
                page: vm.page || pagingParams.page || 1,
                size: parseInt(vm.itemsPerPage) || 10,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                filters: filters
            }).then(function(data) {
                // Transform GraphQL response to match existing sample structure
                vm.samples = data.samplesList.samples.map(function(sample) {
                    return {
                        id: sample.id,
                        name: sample.name,
                        hash: sample.hash,
                        lot_batch_number: sample.lotBatchNumber,
                        lotBatchNumber: sample.lotBatchNumber,
                        status: sample.status,
                        starred: sample.starred,
                        is_public: sample.isPublic,
                        isPublic: sample.isPublic,
                        canSeeReport: sample.canSeeReport,
                        can_see_report: sample.canSeeReport,
                        complete: sample.complete,
                        rd: sample.rd,
                        s_code: sample.sCode,
                        sCode: sample.sCode,
                        sample_matrix: sample.sampleMatrix,
                        sampleMatrix: sample.sampleMatrix,
                        weedmaps_state: sample.weedmapsState,
                        weedmapsState: sample.weedmapsState,

                        // Order info (nested for compatibility)
                        order_id: sample.orderId,
                        customerOrderId: sample.orderId,
                        order: {
                            id: sample.orderId,
                            date_received: sample.orderDateReceived,
                            dateReceived: sample.orderDateReceived,
                            date_completed: sample.orderDateCompleted,
                            dateCompleted: sample.orderDateCompleted,
                            order_type: sample.orderType
                        },
                        customerOrder: {
                            id: sample.orderId,
                            dateReceived: sample.orderDateReceived,
                            dateCompleted: sample.orderDateCompleted
                        },

                        // Product info
                        productCategory: sample.productCategoryName ? { name: sample.productCategoryName } : null,
                        productType: sample.productTypeName ? { name: sample.productTypeName } : null,
                        strainName: sample.strainName ? { name: sample.strainName } : null,
                        strainType: sample.strainType ? { name: sample.strainType } : null,

                        // Due date (pre-computed)
                        dueDateDisplay: sample.dueDate,

                        // Date fields for column display
                        receivedDate: sample.orderDateReceived,
                        dateCompleted: sample.orderDateCompleted,

                        // Initialize empty sampleTests (will be loaded on hover)
                        sampleTests: [],

                        // Potency loading state
                        potencyLoaded: false,
                        thcDisplay: null,
                        cbdDisplay: null,
                        totalCannabinoidsDisplay: null,
                        alkaloidsDisplay: null,
                        mitragynineDisplay: null,
                        testCount: sample.testCount
                    };
                }).filter(function(sample) {
					// Hide samples with no tests for non-compliance orders (food, R&D, medical device, etc.)
					if (sample.testCount === 0) {
						var orderType = sample.order && sample.order.order_type ? sample.order.order_type.toLowerCase() : '';
						// Only show samples with 0 tests if it's a compliance order
						if (!orderType.includes('compliance')) {
							return false;
						}
					}
					return true;
				});

                vm.totalItems = data.samplesList.totalCount;
                vm.queryCount = vm.totalItems;
                vm.loadingSamples = false;

                // Cache totalItems to prevent flashing on page navigation
                sessionStorage.setItem(getTotalItemsCacheKey(), vm.totalItems.toString());

                // Update pagination links
                vm.links = {
                    last: Math.ceil(vm.totalItems / parseInt(vm.itemsPerPage))
                };

                // Reset pictures loaded flag for new samples
                picturesLoaded = false;

                // Only load pictures if in gallery view
                if ($rootScope.galleryView) {
                    loadAllPictures();
                    picturesLoaded = true;
                }

                // Tier 2: Load potency data after render
                $timeout(function() {
                    loadPotencyData();
                }, 0);

            }).catch(function(error) {
                console.error('GraphQL Error loading samples:', error);
                AlertService.error('Failed to load samples');
                vm.loadingSamples = false;
            });

            function loadAllPictures() {
                if (!vm.samples || vm.samples.length === 0) return;

            	var sample_ids = [];
    	        for (var i = 0; i < vm.samples.length; i++) {
					sample_ids.push(vm.samples[i].hash);
    	        }
            	SampleAttach.getBulkPictures({ids: sample_ids}, onPicturesSuccess, onPicturesError);

            	function onPicturesSuccess(pictures) {
                	for (var i = 0; i < vm.samples.length; i++) {
                        if (pictures[vm.samples[i].id] && pictures[vm.samples[i].id][0]) {
                		    var pic = pictures[vm.samples[i].id][0].slice(-1)[0];
        	        	    vm.samples[i].picture = pic ? pic.url : "content/images/no_image_available-small.png";
                        } else {
                            vm.samples[i].picture = "content/images/no_image_available-small.png";
                        }
        	        }
            	}

            	function onPicturesError(error) {
                    console.error('Error loading pictures:', error);
            	}
            }
        }

        loadAll();
        if (vm.sampleFilters.category) {
        	vm.populateTypes();
		}

        angular.element(document).ready(function() {
            setTimeout(function () {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;

                $(window).on("load resize",function(){
                  var winWidth = $(window).width();
                  if(768 >= winWidth) {
                      $("#table tr:first > th").css("width", col_width+"%");
                  }
                });

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if(constant == 2 || constant2 >= 2){
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Sample', Sample);

    Sample.$inject = ['$resource'];

    function Sample ($resource) {

        return $resource('api/samples/:id', {id: '@id', public: '@public', daterange: '@daterage', emails: '@emails', message: '@message', subject: '@subject', public_link: '@public_link', pic_url: '@pic_url', totalTHC: '@totalTHC'}, {
            query: { method: 'GET', isArray: true },
            get: {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            public: {
                url: 'api/sample/:id/:public',
                method: 'PUT'
            },
            passFailCount:{
            	url: 'api/samples/count/passfail',
            	method: 'GET',
            	params: {daterange: '@daterange'}
            },
            incompleteCount: {
            	url: 'api/samples/count/incomplete',
            	method: 'GET'
            },
            toggleVisibility: {
            	url: 'api/samples/:id/togglevisibility',
            	method: 'PUT'
            },
            toggleStarred: {
            	url: 'api/samples/:id/togglestarred',
            	method: 'PUT'
            },
            sendEmail: {
            	url: 'api/sample/email',
            	method: 'PUT',
            	params: {emails: '@emails', message: '@message', public_link: '@public_link', sample_id: '@id', pic_url: '@pic_url', totalTHC: '@totalTHC', subject: '@subject'}
            }
        });

    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('samplelog', {
            parent: 'entity',
            url: '/samplelog?page&sort&search&productCategoryId&items&id&orderId&sampleName&lotNumber&metrcId&categoryIdList&orderType&thcLower&thcUpper&cbdLower&cbdUpper&isPass&isFail&isUndetermined&isWeedmapsSuccess&isWeedmapsFail' +
            	'&isWeedmapsNone&visibility&completeDateLower&completeDateUpper&estimatedDueDateLower&estimatedDueDateUpper&galleryView&starred&isInProgress&isCompleted',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Samples'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/sample-log/sample_log.html',
                    controller: 'SampleLogController',
                    controllerAs: 'vm'
                }
            },
            reloadOnSearch: false,
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,

                productCategoryId: {
                    value: '0',
                    squash: true
                },
                items: null,
                /* Filter params */
        		id: null,
        		orderId: null,
        		sampleName: null,
        		lotNumber: null,
        		metrcId: null,
        		categoryIdList: null,
        		category: null,
        		subCategory: null,
        		orderType: null,
        		thcLower: null,
        		thcUpper: null,
        		cbdLower: null,
        		cbdUpper: null,
        		isPass: null,
        		isFail: null,
        		isUndetermined: null,
        		isWeedmapsSuccess: null,
        		isWeedmapsFail: null,
        		isWeedmapsNone: null,
        		visibility: null,
        		completeDateLower: null,
        		completeDateUpper: null,
        		estimatedDueDateLower: null,
        		estimatedDueDateUpper: null,
        		galleryView: null,
                starred: null,
                isInProgress: null,
                isCompleted: null,
                sampleMatrix: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {

                    return {
                    	/* Paging Params */
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        items: $stateParams.items,
                        /* Filter Params */
                        id: $stateParams.id ? parseInt($stateParams.id) : null,
                        orderId: $stateParams.orderId ? parseInt($stateParams.orderId) : null,
                        sampleName: $stateParams.sampleName,
                        lotNumber: $stateParams.lotNumber,
                        metrcId: $stateParams.metrcId,
                        categoryIdList: $stateParams.categoryIdList,
                        category: $stateParams.category,
                        subCategory: $stateParams.subCategory,
                        orderType: $stateParams.orderType,
                        thcLower: $stateParams.thcLower ? parseInt($stateParams.thcLower) : null,
                        thcUpper: $stateParams.thcUpper ? parseInt($stateParams.thcUpper) : null,
                        cbdLower: $stateParams.cbdLower ? parseInt($stateParams.cbdLower) : null,
                        cbdUpper: $stateParams.cbdUpper ? parseInt($stateParams.cbdUpper) : null,
                        isPass: $stateParams.isPass,
                        isFail: $stateParams.isFail,
                        isUndetermined: $stateParams.isUndetermined,
                        isWeedmapsSuccess: $stateParams.isWeedmapsSuccess,
                        isWeedmapsFail: $stateParams.isWeedmapsFail,
                        isWeedmapsNone: $stateParams.isWeedmapsNone,
                        visibility: $stateParams.visibility,
                        completeDateLower: $stateParams.completeDateLower,
                        completeDateUpper: $stateParams.completeDateUpper,
                        estimatedDueDateLower: $stateParams.estimatedDueDateLower,
                        estimatedDueDateUpper: $stateParams.estimatedDueDateUpper,
                        galleryView: $stateParams.galleryView,
                        starred: $stateParams.starred,
                        isInProgress: $stateParams.isInProgress,
                        isCompleted: $stateParams.isCompleted,
                        sampleMatrix: $stateParams.sampleMatrix
                    }
                }],
            }
        })
        .state('samplelog-detail', {
            parent: 'samplelog',
            url: '/samplelog/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sample'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sample/sample-detail.html',
                    controller: 'SampleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Sample', function($stateParams, Sample) {
                    return Sample.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sample',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('samplelog-detail.edit', {
            parent: 'samplelog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sample/sample-dialog.html',
                    controller: 'SampleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sample', function(Sample) {
                            return Sample.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('samplelog.new', {
            parent: 'samplelog',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sample/sample-dialog.html',
                    controller: 'SampleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lotBatchNumber: null,
                                residualSolvent: null,
                                other: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sample', null, { reload: 'sample' });
                }, function() {
                    $state.go('sample');
                });
            }]
        })
        .state('samplelog.edit', {
            parent: 'samplelog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sample/sample-dialog.html',
                    controller: 'SampleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sample', function(Sample) {
                            return Sample.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sample', null, { reload: 'sample' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('samplelog.view', {
            parent: 'samplelog',
            url: '/{id}/view',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-log/samplelog-dialog.html',
                    controller: 'SampleLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sample', function(Sample) {
                            return Sample.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sample', null, { reload: 'sample' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('samplelog.delete', {
            parent: 'samplelog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sample/sample-delete-dialog.html',
                    controller: 'SampleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sample', function(Sample) {
                            return Sample.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sample', null, { reload: 'sample' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('samplelog.editcolumns', {
            parent: 'samplelog',
            url: '/samples/columns',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams','$state', '$uibModal', function($stateParams,$state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-log/samplelog-columns-dialog.html',
                    controller: 'DialogSampleColumns',
                    controllerAs: 'vm',
                    size: 'lg'
                }).result.then(function() {
                	$state.go('samplelog', {}, {reload: false});
                }, function() {
                    $state.go('samplelog', {}, {reload: false});
                });
            }]
        });
    }


})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('SampleSearch', SampleSearch);

    SampleSearch.$inject = ['$resource'];

    function SampleSearch($resource) {
        var resourceUrl =  'api/_search/samples/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SampleLogDialogController', SampleLogDialogController);

    SampleLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Sample', 'ProductType', 'CustomerOrder'];

    function SampleLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Sample, ProductType, CustomerOrder) {
        var vm = this;

        vm.sample = entity;
        vm.clear = clear;
        vm.save = save;
        vm.producttypes = ProductType.query({filter: 'sample-is-null'});
        $q.all([vm.sample.$promise, vm.producttypes.$promise]).then(function() {
            if (!vm.sample.productType || !vm.sample.productType.id) {
                return $q.reject();
            }
            return ProductType.get({id : vm.sample.productType.id}).$promise;
        }).then(function(productType) {
            vm.producttypes.push(productType);
        });
        vm.customerorders = CustomerOrder.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sample.id !== null) {
                Sample.update(vm.sample, onSaveSuccess, onSaveError);
            } else {
                Sample.save(vm.sample, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:sampleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('DialogSampleColumns', DialogSampleColumns);

    DialogSampleColumns.$inject = ['$state', '$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'Principal', 'Auth'];

    function DialogSampleColumns ($state, $timeout, $scope, $rootScope, $stateParams, $uibModalInstance, Principal, Auth) {

        var vm = this;
        vm.userAccount = null;

        vm.clear = function(){
        	$uibModalInstance.dismiss('cancel');
        }
        vm.save = function(){
        	if (!vm.userAccount.userSettings) {
        		vm.userAccount.userSettings = JSON.stringify({sample_columns: vm.columns});
        	} else {
        		var userSettings = JSON.parse(vm.userAccount.userSettings);
        		userSettings.sample_columns = vm.columns;
        		vm.userAccount.userSettings = JSON.stringify(userSettings);
        	}
        	
            Auth.updateAccount(vm.userAccount).then(function() {
            	vm.clear();
            }).catch(function() {
                console.log("ERR");
            });
        	
        }
        
        vm.columns = [
    		{
    			display_name: 'Sample No.',
    			sort_by_name: 'id',
    			shown: true,
    		},
    		{
    			display_name: 'Name',
    			sort_by_name: 'name',
    			shown: true,
    		},
    		{
    			display_name: 'Category (Sub)',
    			sort_by_name: 'productType.name',
    			shown: true,
    		},
    		{
    			display_name: 'THC',
    			sort_by_name: 'thc',
    			shown: true,
    		},
    		{
    			display_name: 'CBD',
    			sort_by_name: 'cbd',
    			shown: true,
    		},
    		{
    			display_name: 'Completed Date',
    			sort_by_name: 'customerOrder.dateCompleted',
    			shown: true,
    		},
    		/*
    		{
    			display_name: 'Public',
    			sort_by_name: 'isPublic',
    			shown: true,
    		},
    		*/
    		{
    			display_name: 'Downloads',
    			sort_by_name: '',
    			shown: true,
    		}
    	];

        Principal.identity().then(function(account) {
            vm.userAccount = account;
            if (account.userSettings) {
            	var userSettings = JSON.parse(vm.userAccount.userSettings);
            	if (userSettings.sample_columns){
            		vm.columns = userSettings.sample_columns;
            	}
            }
        });

        $rootScope.$on('closeModal', function (event, data) {
            vm.clear();
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CustomerManageController', CustomerManageController);

    CustomerManageController.$inject = ['$scope','$rootScope','$state','$localStorage','Customer','Auth', 'Principal', 'ProfileService',
        'LoginService','CustomerByUser','Contact','ContactForUser', 'BusinessType','Country','CountryState',
        'CountryStateByCode', 'NotificationService','SubscriptionService', 'FileUpload', '$http', 'SweetAlert', 
        'ContactForCustomer', 'Contact2ForUser', '$translate', 'AddressList'];

    function CustomerManageController($scope,$rootScope,$state,$localStorage,Customer,Auth, Principal, ProfileService, LoginService,
                                      CustomerByUser, Contact, ContactForUser, BusinessType,Country,CountryState,
                                      CountryStateByCode, NotificationService, SubscriptionService, FileUpload, $http, SweetAlert, 
                                      ContactForCustomer, Contact2ForUser, $translate, AddressList) {

        var vm = this;

    vm.setLogo = setLogo;
    vm.companyLogo = null;
    vm.activeTab = 'contact_list';

    // Initialize Invoicing list state
    $scope.InvoicingList = "Invoicing_close";
    
    // Toggle function for Invoicing list
    $scope.openInvoicingList = function() {
        if ($scope.InvoicingList === "Invoicing_close") {
            $scope.InvoicingList = "Invoicing_open";
        } else {
            $scope.InvoicingList = "Invoicing_close";
        }
    };

    $scope.downloadOptionList = [
      {
        name: "COA Summary",
        value: "coaSummary",
        selected: false,
        disabled: false
      },
      {
        name: "Consolidated COA",
        value: "consolidatedCoa",
        selected: false,
        disabled: false
      },
      {
        name: "Test COA(s)",
        value: "testCoa",
        selected: false,
        disabled: false
      },
      {
        name: "Pictures",
        value: "pictures",
        selected: false,
        disabled: false
      },
      {
        name: "QR Code",
        value: "qrCode",
        selected: false,
        disabled: false
      },
      {
        name: "All",
        value: "all",
        selected: false,
        disabled: false
      }
    ];

    $scope.updateDownloadOptionList = function (option) {
     if (option.value == "all") {
        if (option.selected) {
          angular.forEach($scope.downloadOptionList, function (option) {
            option.selected = true;
          });
        } else {
          angular.forEach($scope.downloadOptionList, function (option) {
            option.selected = false;
          });
        }
      } else {
        var array = $scope.downloadOptionList.some(e => e.selected == true && e.value != "all");
        if(array){
            $scope.downloadOptionList.find(e => e.value == "all").disabled = true;
            $scope.downloadOptionList.find(e => e.value == "all").selected = false;
        }
        else{
            $scope.downloadOptionList.find(e => e.value == "all").disabled = false;
            $scope.downloadOptionList.find(e => e.value == "all").selected = false;
        }
      }
      if($scope.download_option_list.length == 0){
        angular.forEach($scope.downloadOptionList, function (option) {
          var option_object = {
              name:option.name,
              value:option.value,
              selected:option.selected
          };
          $scope.download_option_list.push(option_object);
        });
      }
      else{
        angular.forEach($scope.downloadOptionList, function (option) {
          $scope.download_option_list.find(e => e.value == option.value).selected = option.selected;
        })
      }
    };

        if($rootScope.notificationTab){
            selectTab($rootScope.notificationTab);
            $rootScope.notificationTab = null;
        }

        vm.deleteContact = function(contact) {
            SweetAlert.swal({
                    title: "Delete " + contact.name + "?",
                    text: ""+$translate.instant("This action cannot be undone."),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#EB5757",
                    confirmButtonText: ""+$translate.instant("Delete"),
                    closeOnConfirm: false
                },
                function(confirm) {
                    if(confirm) {
                        Contact.delete({id: contact.id},
                            function(data) {
                                SweetAlert.swal({
                                    title: contact.name + " deleted successfully.",
                                    type: "success"
                                });
                                getCustomerData();
                                getContactData();    
                            },
                            function(e) {
                                console.log(e);
                            }
                        );    
                    }
                }
            );
        }
        

        $scope.onFilesSelected = function(files) {
           var uploadUrl = "/api/customer/logo";
           var fd = new FormData();

           fd.append('file', files[0]);
           $http.post(uploadUrl, fd, {
               transformRequest: angular.identity,
               headers: {'Content-Type': undefined}

           }).success(function(response){    // response from server
        	   var logo = response.logo
        	   setLogo(logo);

           }).error(function(error){
           });
        };

        function setLogo(logo){
            vm.companyLogo = 'images/logo/' + logo;
            vm.customerData.logo = logo;
        }
        
        $scope.removeLogo = function(){
        	if (!vm.companyLogo) return;
        	var removeUrl = "/api/customer/logo/remove";
        	
        	$http.post(removeUrl, {}).success(function(response){
        		vm.companyLogo = null;
        		vm.customerData.logo = null;
        	}).error(function(response){
        		console.log(response);
        	});
        }


        function getNotificationSettings(){
            SubscriptionService.getSubscriptionSettings({}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.notificationSeting = data;
            }
            function onError(error) {
            }
        }

        vm.updateContact = function(contact){
            Contact.updateContactAndUser(contact,
                function(data) {
                    angular.noop;
                },
                function(e) {
                    console.log(e);
                });
        }

        vm.saveSettings = function () {

           SubscriptionService.saveSubscriptionSettings(vm.notificationSeting, onSuccess, onError);
           function onSuccess(data, headers) {
                console.log(data)
           }
           function onError(error) {
           }
            console.log(vm.notificationSeting)
        }

        // add default address changes
        vm.addressData = {}
        function getDataList() {
          AddressList.get({}, onSuccessCustomer, onErrorCustomer);

          function onSuccessCustomer(data, headers) {
              $scope.records = data;
          }

          function onErrorCustomer(e) {
              console.log(e);
          }
        }
        function invoicing_list_toggle() {
          $scope.InvoicingList = "Invoicing_close";
          $scope.openInvoicingList = function() {
              if ($scope.InvoicingList === "Invoicing_close")
                  $scope.InvoicingList = "Invoicing_open";
              else
                  $scope.InvoicingList = "Invoicing_close";
          };
        }
        function reporting_list_toggle() {
          $scope.ReportingList = "Reporting_close";
          $scope.openReportingList = function() {
              if ($scope.ReportingList === "Reporting_close")
                  $scope.ReportingList = "Reporting_open";
              else
                  $scope.ReportingList = "Reporting_close";
          };
        }
        function manufacturing_list_toggle() {
          $scope.ManufacturingList = "Manufacturing_close";
          $scope.openManufacturingList = function() {
              if ($scope.ManufacturingList === "Manufacturing_close")
                  $scope.ManufacturingList = "Manufacturing_open";
              else
                  $scope.ManufacturingList = "Manufacturing_close";
          };
        }
        function distribution_list_toggle() {
          $scope.DistributionList = "Distribution_close";
          $scope.openDistributionList = function() {
              if ($scope.DistributionList === "Distribution_close")
                  $scope.DistributionList = "Distribution_open";
              else
                  $scope.DistributionList = "Distribution_close";
          };
        }
        function pickup_list_toggle() {
            $scope.PickupList = "Pickup_close";
            $scope.openpickupList = function() {
                if ($scope.PickupList === "Pickup_close")
                    $scope.PickupList = "Pickup_open";
                else
                    $scope.PickupList = "Pickup_close";
            };
        }
        function sampling_list_toggle() {
            $scope.SamplingList = "Sampling_close";
            $scope.opensamplingList = function() {
                if ($scope.SamplingList === "Sampling_close")
                    $scope.SamplingList = "Sampling_open";
                else
                    $scope.SamplingList = "Sampling_close";
            };
        }
        $scope.copyManufacturingData = function(id, fullLocation) {
          vm.customerData.default_addresses['manufacturingLocation'] = id
          vm.fullLocationManufactur = fullLocation;
          manufacturing_list_toggle();          
        }
        $scope.copyReportingData = function(id, fullLocation) {
          vm.customerData.default_addresses['cultivationLocation'] = id
          vm.fullLocationreporting = fullLocation
          reporting_list_toggle();          
        }
        $scope.copyInvoicingData = function(address, city, zipCode, name, state) {
          if(city == "customer_address"){
            vm.fullLocationInvoicing = address;
          }
          else{
            var invoicing_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.invoicing_address = invoicing_address;
            vm.fullLocationInvoicing = invoicing_address;
          }
          console.log(invoicing_address);
          invoicing_list_toggle();
        }
        $scope.copyPickupData = function(address, city, zipCode, name, state,id) {
          vm.customerData.default_addresses['pickupLocation'] = id
          var pickup_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.pickup_address = pickup_address;
            vm.fullLocationPickup = pickup_address;
            pickup_list_toggle();
        }
        $scope.copySamplingData = function(address, city, zipCode, name, state,id) {
          vm.customerData.default_addresses['samplingLocation'] = id
          var Sampling_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.Sampling_address = Sampling_address;
            vm.fullLocationSampling = Sampling_address;
            sampling_list_toggle();
        }
        $scope.copyDistributionData = function(id, fullLocation) {  
          vm.customerData.default_addresses['distributionLocation'] = id
            vm.fullLocationComp = fullLocation;
            distribution_list_toggle();
        }
        $scope.removeAddressData = function(address, addressId, element, input) {
            vm.removeAddressData = address;
            vm.removeAddressId = addressId;
            vm.removeAddressElement = element;

            setTimeout(function() {
                if ('DISTRIBUTION' === input)
                    vm.samplingAddress = "";
                else if ('MANUFACTURING' === input) {
                    vm.manufacturingAddress = "";
                    vm.reportingAddress = "";
                }
                else if ('INVOICING' === input) {
                    vm.invoicingAddress = "";
                }
                else if ('PICKUP' === input) {
                    vm.pickupAddress = "";
                }
            }, 200);
        }

        $scope.newInvoicingAddress = function() {
            if (!vm.InvoicingAddress) {
                vm.InvoicingAddress = {};
            }
            vm.InvoicingAddress.locationType = "INVOICING_LOCATION";
            
            AddressList.save(vm.InvoicingAddress, onSuccessCustomer, onError);

            function onSuccessCustomer(data, headers) {
                getDataList();
                vm.InvoicingAddress = {}; // Clear the form
                $scope.InvoicingList = "Invoicing_close"; // Close the dropdown
            }

            function onError(error) {
                console.error('Error saving invoicing address:', error);
            }
        }

        $scope.newPickupAddress = function() {
            vm.PickupAddress.locationType = "PICKUP_LOCATION";
            AddressList.save(vm.PickupAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newManufacturingAddress = function() {
            vm.ManufacturingAddress.locationType = "CULTIVATION_LOCATION";
            AddressList.save(vm.ManufacturingAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newDistributionAddress = function() {
            vm.DistributionAddress.locationType = "DISTRIBUTION_LOCATION";
            AddressList.save(vm.DistributionAddress, onSuccessCustomer, null);

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.removeAddressQuery = function() {
            AddressList.remove({
                id: vm.removeAddressId
            }, onSuccessCustomer, function() {
            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        manufacturing_list_toggle();
        reporting_list_toggle();
        invoicing_list_toggle();
        distribution_list_toggle();
        pickup_list_toggle();
        sampling_list_toggle();
        getDataList();
        function createAddress(address, city, zipCode, name, medicalLicence, licenceList) {
          var full_address = name + '\n' + address + '\n' + city + ' ' + zipCode;
          var licences = licenceList || medicalLicence;

          if(licences) {
              var parts = licences.split(',');
              for (var i = 0; i < parts.length; i++) {
                  var trimmed = parts[i].trim();
                  if (trimmed) {
                      full_address += '\n' + trimmed;
                  }
              }
          }

          return full_address;
        }

        function createInvoicingAddress(address, city, zipCode, name, state) {
            return name + '\n' + address + '\n' + city + ' ' + zipCode + ' ' + state;
        }

        $scope.clearCityZipListDataOnClose = function() {
          $scope.cityRecordsZips = [];
          $scope.cityRecords = [];
        }

        // add default address changes end

        getNotificationSettings();


        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "Manage";
        }

        vm.error = null;
        vm.mainUser = false;

        vm.businesstypes = null//BusinessType.query();
        vm.countries =  [ "USA", "Canada"]
        vm.mainUser = false;
        vm.notificationSeting = null;
        
        vm.showsidebar = true;
        var sidebar = document.getElementById("main-sidebar");
         if (vm.sidebar!=null) {
            if(sidebar.classList.contains("menu-remove")){
                var z = document.getElementsByClassName("content-wrapper");
                for (i = 0; i < z.length; i++) {
                    if (z[i].classList) {
                        z[i].classList.toggle("big-box-remove");
                    }
                }
            }
        }

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;

        if(!vm.isAuthenticated()){
             $state.go('login');
        }

        getCustomerData();
        
    

        vm.submitCustomer = submitCustomer;

        $scope.download_option_list = [];
        function getCustomerData () {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 if (vm.customerData.businessType)
                 vm.businesstypes = [vm.customerData.businessType];
                 if (vm.customerData.logo!=null) {
                     vm.setLogo(vm.customerData.logo);
                 }

                 if(vm.customerData != null && vm.customerData.address != null){
                     var partsOfStr = vm.customerData.address.split('@');
                     vm.customerData.address_street = partsOfStr[0];
                     vm.customerData.address_city = partsOfStr[1];
                     vm.customerData.address_state = partsOfStr[2];
                     vm.customerData.address_country = partsOfStr[3];
                     vm.customerData.address_zip = partsOfStr[4];
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                	 vm.customerData.privateSampleByDefault = false;
                 }
                 vm.customerData.downloadable_file_options = vm.customerData.downloadable_file_options && JSON.parse(vm.customerData.downloadable_file_options);
                 if(vm.customerData.downloadable_file_options){
                     angular.forEach(vm.customerData.downloadable_file_options,function(element) {
                         $scope.downloadOptionList.find(e => e.name == element.name).selected = element.selected
                     });
                     $scope.download_option_list = vm.customerData.downloadable_file_options;
                 }
                 vm.customerData.default_addresses = vm.customerData.default_addresses ? JSON.parse(vm.customerData.default_addresses) : {};
                  if(vm.customerData.default_addresses){
                    
                    var addresses = vm.customerData.default_addresses
                    var distribution = $scope.records.find(function(record){
                        return record.id == addresses.distributionLocation
                    })
                    if (distribution) {
                      vm.fullLocationComp = distribution.fullLocation;
                    }
                    var manufacture = $scope.records.find(function(record){
                      return record.id == addresses.manufacturingLocation
                    })
                    if (manufacture) {
                      vm.fullLocationManufactur = manufacture.fullLocation;
                    }

                    var pickup = $scope.records.find(function(record){
                        return record.id == addresses.pickupLocation
                    })
                    if (pickup) {
                      vm.fullLocationPickup = pickup.fullLocation;
                    }

                    var sampling = $scope.records.find(function(record){
                        return record.id == addresses.samplingLocation
                    })
                    if (sampling) {
                      vm.fullLocationSampling = sampling.fullLocation;
                    }

                    var reporting = $scope.records.find(function(record){
                        return record.id == addresses.cultivationLocation
                    })
                    if (reporting) {
                      vm.fullLocationreporting = reporting.fullLocation;
                    }
                  }
                 populateStates();
                 getCurrentContact();

                vm.customer_type = vm.customerData.businessType.name.toLowerCase();
            }
            function onError(error) {
                console.log(error);
            }
        }

    function findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] == value) {
          return i;
        }
      }
      return -1;
    }

    function getContactData() {
      ContactForCustomer.query(
        { customerId: vm.customerData.id },
        function (data, headers) {
          vm.contacts = data;
          vm.mainUser = false;

          vm.contacts.forEach(function (contact) {
            if (contact.contactCustomers) {
              contact.contact_customer_index = findWithAttr(
                contact.contactCustomers,
                "customer_id",
                vm.customerData.id
              );

              if (
                contact.contactCustomers[contact.contact_customer_index].role ==
                "ADMIN"
              ) {
                contact.portal = "admin";
              } else if (contact.login) {
                contact.portal = "user";
              } else {
                contact.portal = "none";
              }

              if (
                contact.contactCustomers[contact.contact_customer_index]
                  .contact_id == vm.contact_id
              ) {
                contact.is_current_user = true;
                vm.mainUser = contact.mainUser;
              } else {
                contact.is_current_user = false;
              }
            }
          });
          $state.admin = vm.mainUser;
        },
        function (error) {
          console.log(error);
        }
      );
    }

    function getCurrentContact() {
      Contact2ForUser.get(
        {},
        function (data) {
          vm.contact_id = data.id;
          getContactData();
        },
        function (e) {
          console.log(e);
        }
      );
    }

    vm.populateStates = populateStates;

    vm.determineToReceive = function (contact) {
      for (var i = 0; i < contact.contactCustomers.length; i++) {
        var cc = contact.contactCustomers[i];
        if (cc.customer_id != $localStorage.customerId) continue;

            	if (cc.receive_coa && cc.receive_invoice) {
            		return 'Both';
            	} else if (cc.receive_coa) {
            		return 'COA';
            	} else if (cc.receive_invoice) {
            		return 'Invoice';
            	} else {
            		return 'None';
            	}
        	}
        }

        function populateStates(){
            var country = vm.customerData.address_country;
            if (country == 'Canada') {
                vm.countryStates = [
                    {"code": "Canada", "name": "Canada"}
               ]
            }
            else {
                 vm.countryStates = [
                      {"code": "AK", "name": "Alaska"},
                      {"code": "AL", "name": "Alabama"},
                      {"code": "AR", "name": "Arkansas"},
                      {"code": "AZ", "name": "Arizona"},
                      {"code": "CA", "name": "California"},
                      {"code": "CO", "name": "Colorado"},
                      {"code": "CT", "name": "Connecticut"},
                      {"code": "DC", "name": "Washington DC"},
                      {"code": "DE", "name": "Delaware"},
                      {"code": "FL", "name": "Florida"},
                      {"code": "GA", "name": "Georgia"},
                      {"code": "GU", "name": "Guam"},
                      {"code": "HI", "name": "Hawaii"},
                      {"code": "IA", "name": "Iowa"},
                      {"code": "ID", "name": "Idaho"},
                      {"code": "IL", "name": "Illinois"},
                      {"code": "IN", "name": "Indiana"},
                      {"code": "KS", "name": "Kansas"},
                      {"code": "KY", "name": "Kentucky"},
                      {"code": "LA", "name": "Louisiana"},
                      {"code": "MA", "name": "Massachusetts"},
                      {"code": "MD", "name": "Maryland"},
                      {"code": "ME", "name": "Maine"},
                      {"code": "MI", "name": "Michigan"},
                      {"code": "MN", "name": "Minnesota"},
                      {"code": "MO", "name": "Missouri"},
                      {"code": "MS", "name": "Mississippi"},
                      {"code": "MT", "name": "Montana"},
                      {"code": "NC", "name": "North Carolina"},
                      {"code": "ND", "name": "North Dakota"},
                      {"code": "NE", "name": "Nebraska"},
                      {"code": "NH", "name": "New Hampshire"},
                      {"code": "NJ", "name": "New Jersey"},
                      {"code": "NM", "name": "New Mexico"},
                      {"code": "NV", "name": "Nevada"},
                      {"code": "NY", "name": "New York"},
                      {"code": "OH", "name": "Ohio"},
                      {"code": "OK", "name": "Oklahoma"},
                      {"code": "OR", "name": "Oregon"},
                      {"code": "PA", "name": "Pennsylvania"},
                      {"code": "PR", "name": "Puerto Rico"},
                      {"code": "RI", "name": "Rhode Island"},
                      {"code": "SC", "name": "South Carolina"},
                      {"code": "SD", "name": "South Dakota"},
                      {"code": "TN", "name": "Tennessee"},
                      {"code": "TX", "name": "Texas"},
                      {"code": "UT", "name": "Utah"},
                      {"code": "VA", "name": "Virginia"},
                      {"code": "VI", "name": "Virgin Islands"},
                      {"code": "VT", "name": "Vermont"},
                      {"code": "WA", "name": "Washington"},
                      {"code": "WI", "name": "Wisconsin"},
                      {"code": "WV", "name": "West Virginia"},
                      {"code": "WY", "name": "Wyoming"}

               ]

            }
        }

        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function submitCustomer(){

            vm.isSaving = true;
            vm.error = null;
            vm.customerData.address = vm.customerData.address_street + '@' + vm.customerData.address_city + '@' + vm.customerData.address_state + '@' + vm.customerData.address_country + '@' + vm.customerData.address_zip;
            vm.customerData.downloadable_file_options = angular.toJson($scope.download_option_list);
            vm.customerData.default_addresses = JSON.stringify(vm.customerData.default_addresses)
            Customer.update(vm.customerData, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.addressData = {}
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.error = "SOMETHING WENT WRONG!";
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('DialogCustomerManageController', DialogCustomerManageController);

    DialogCustomerManageController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$localStorage', 'entity', 'ContactForUser', '$state'];

    function DialogCustomerManageController ($timeout, $scope, $stateParams, $uibModalInstance, $localStorage, entity, ContactForUser, $state) {

        var vm = this;
        var customerId = $localStorage.customerId;
        vm.contact = entity;
        vm.disablePassword = false;
        vm.disableLogin = false;

        vm.admin = $state.admin;

        if (vm.contact.id == null) {
            vm.newContact = true;
        }
        else {
            vm.newContact = false;
        }
        console.log(vm.contact.email);
        console.log(vm.newContact);
        if (vm.newContact == false && vm.contact.email == null) {
            vm.contactWithoutUser = true;
        }
        else {
            vm.contactWithoutUser = false;
        }

        //if this is existing Contact
        if (vm.newContact == false) {

            if (vm.contactWithoutUser == false) {
                //if contact has assigned User, disable login
                vm.disableLogin = true;
            }

            if (!vm.contact.currentUser && vm.contactWithoutUser == false )
                vm.disablePassword = true

            if (!vm.contact.mainUser && vm.contact.currentUser )
                vm.disableReceive = true

            for (var i = 0; i < vm.contact.contactCustomers.length; i++) {
            	var cc = vm.contact.contactCustomers[i];
            	if (cc.customer_id != $localStorage.customerId) continue;

            	if (cc.receive_coa && cc.receive_invoice) {
            		vm.receive = 'both';
            	} else if (cc.receive_coa) {
            		vm.receive = 'coa';
            	} else if (cc.receive_invoice) {
            		vm.receive = 'inv';
            	} else {
            		vm.receive = 'none';
            	}
            	
            	vm.isAdmin = cc.role === "ADMIN" ? true : false;
            }
        }

        vm.clear = clear;
        vm.save = save;

        vm.doNotMatch = null;
        vm.noPassword = null;
        vm.errorUserExists = null;
        vm.errorEmailExists = null;
        vm.errorMessage = null;
        vm.error = null;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {

            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.errorMessage = null;
            if (vm.newContact == false && vm.contact.email == null) {
                vm.contactWithoutUser = true;
            }
            if (vm.newContact == false && vm.contact.password != vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.noPassword = null;
                vm.doNotMatch = 'ERROR';
                return;
            }
            else {
                vm.doNotMatch = null;
            }

            // we need password for new user or contact without user
            // if (vm.newContact==true || vm.contactWithoutUser==true ){
            //    if(vm.contact.password == null ||  vm.contact.password == ''){
            //        vm.error = null;
            //        vm.success = null;
            //        vm.noPassword = 'ERROR';
            //        vm.doNotMatch = null;
            //        return;
            //    }
            // }

            vm.isSaving = true;

            if (vm.newContact) {
                if(vm.receive == 'coa'){
                	vm.contact.receive_coa = true;
                	vm.contact.receive_invoice = false;
                } else if(vm.receive == 'inv'){
                	vm.contact.receive_coa = false;
                	vm.contact.receive_invoice = true;
                } else if(vm.receive == 'both'){
                	vm.contact.receive_coa = true;
                	vm.contact.receive_invoice = true;
                } else {
                	vm.contact.receive_coa = false;
                	vm.contact.receive_invoice = false;
                }
            } else {
                for (var i = 0; i < vm.contact.contactCustomers.length; i++) {
                	var cc = vm.contact.contactCustomers[i];
                	if (cc.customer_id != customerId) continue;

                    if(vm.receive == 'coa'){
                        cc.receive_coa = true;
                        cc.receive_invoice = false;
                    } else if(vm.receive == 'inv'){
                    	cc.receive_coa = false;
                        cc.receive_invoice = true;
                    } else if(vm.receive == 'both'){
                        cc.receive_coa = true;
                        cc.receive_invoice = true;
                    } else {
                    	cc.receive_coa = false;
                    	cc.receive_invoice = false;
                    }
                    
                    if (vm.isAdmin) {
                    	cc.role = "ADMIN"
                    } else {
                    	cc.role = null;
                    }
                }
            }


            vm.contact.name = vm.contact.first_name+" "+vm.contact.last_name;

            if (vm.newContact == false) {
                ContactForUser.update(vm.contact, onSaveSuccess, onSaveError);
            } else {
                ContactForUser.save(vm.contact, onSaveSuccess, onSaveError);
           }

       }

        function onSaveSuccess (result) {

            $uibModalInstance.close(result);
            vm.isSaving = false;

        }

        function onSaveError (response) {
            vm.isSaving = false;
            vm.success = null;
            var errorMessage = getErrorMessage(response);
            var legacyErrorMessage = response && response.data ? response.data.data : null;
            var status = response ? response.status : null;
            if (status === 400 && errorMessage) {
                vm.errorMessage = errorMessage;
                vm.error = 'ERROR';
            } else if (status === 400 && legacyErrorMessage === 'login already in use') {
                vm.errorUserExists = 'ERROR';
            }
            else if (status === 400 && legacyErrorMessage === 'This username is already in use') {
                vm.errorUserExists = 'ERROR';
            } else if (status === 400 && legacyErrorMessage === 'e-mail address already in use') {
                vm.errorEmailExists = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
        }

        function getErrorMessage(response) {
            if (!response || !response.data) return null;
            if (angular.isString(response.data)) return response.data;
            if (angular.isString(response.data.message)) return response.data.message;
            if (response.data.data) {
                if (angular.isString(response.data.data)) return response.data.data;
                if (angular.isString(response.data.data['e.msg'])) return response.data.data['e.msg'];
            }
            return null;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SubscriptionService', Subscription);

    Subscription.$inject = ['$resource'];
    function Subscription($resource) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'getSubscriptionSettings': {
                method: 'GET',
                url: 'api/notifications/subscriptions'
            },
            'saveSubscriptionSettings': {
                method: 'POST',
                url: 'api/notifications/subscribe'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource'];

    function Customer ($resource) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customermanage', {
            parent: 'entity',
            url: '/customer-manage',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Customer-Manage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/customer-manage/customer-manage.html',
                    controller: 'CustomerManageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('customermanage.new', {
                    parent: 'customermanage',
                    url: '/new',
                    data: {
                        authorities: ['ROLE_USER']

                    },
                    onEnter: ['$stateParams','$state', '$uibModal', function($stateParams,$state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/pages/customer-manage/dialog.customer-manage.html',
                            controller: 'DialogCustomerManageController',
                            controllerAs: 'vm',
                            size: 'lg',
                            resolve: {

                                entity: function () {
                                    return {
                                        id: null,
                                        name: null,
                                        title: null,
                                        phone: null,
                                        email: null,
                                        receive_invoice: null,
                                        receive_coa: null,
                                        first_name: null,
                                        last_name: null,
                                        mobile: null,
                                        address: null,
                                        managedUser: null
                                    };
                                }
                            }
                        }).result.then(function() {
                            $state.go('customermanage', null, { reload: true });
                        }, function() {
                            $state.go('customermanage');
                        });
                    }]
                })
                .state('customermanage.edit', {
                            parent: 'customermanage',
                            url: '/{id}/edit',
                            data: {
                                authorities: ['ROLE_USER']
                            },
                            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                $uibModal.open({
                                    templateUrl: 'app/pages/customer-manage/dialog.customer-manage.html',
                                    controller: 'DialogCustomerManageController',
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    resolve: {
                                        entity: ['Contact', function(Contact) {
                                            return Contact.get({id : $stateParams.id}).$promise;
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('customermanage', null, { reload: 'customermanage' });
                                }, function() {
                                    $state.go('^');
                                });
                            }]
                        })
                .state('customermanage.delete', {
                            parent: 'customermanage',
                            url: '/{id}/delete',
                            data: {
                                authorities: ['ROLE_USER']
                            },
                            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                $uibModal.open({
                                    templateUrl: 'app/pages/customer-manage/contact-delete-dialog.html',
                                    controller: 'CustomerContactDeleteController',
                                    controllerAs: 'vm',
                                    size: 'md',
                                    resolve: {
                                        entity: ['Contact', function(Contact) {
                                            return Contact.get({id : $stateParams.id}).$promise;
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('customermanage', null, { reload: 'customermanage' });
                                }, function() {
                                    $state.go('^');
                                });
                            }]
                        });
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CustomerContactDeleteController',CustomerContactDeleteController);

    CustomerContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'Contact'];

    function CustomerContactDeleteController($uibModalInstance, entity, Contact) {
        var vm = this;

        vm.contact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Contact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('OrdersController', OrdersController);

OrdersController.$inject = ['$state', '$stateParams','$scope','$rootScope', '$filter', 'CustomerOrder', 'AlertService', 'pagingParams','Auth', 'Principal', 'ProfileService', 'CustomerByUser', 
    'OrderAttach', 'OrderAttachDownload', '$timeout', 'GraphQLService', 'DownloadUtil'];

    function OrdersController($state, $stateParams, $scope,$rootScope, $filter, CustomerOrder,
                              AlertService, pagingParams, Auth, Principal, ProfileService, CustomerByUser, 
                              OrderAttach, OrderAttachDownload, $timeout, GraphQLService, DownloadUtil) { /*,Auth, Principal, ProfileService, LoginService*/

        var vm = this;
        vm.state = {};
        $rootScope.showSearch = pagingParams.search;
        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
    	vm.queryParams = $stateParams.queryParams;

        $scope.starred = pagingParams.starred === true;
        $scope.isInProgress = pagingParams.isInProgress === true;
        $scope.isCompleted = pagingParams.isCompleted === true;
        $scope.total = !$scope.starred && !$scope.isInProgress && !$scope.isCompleted;

        // GraphQL query for order counts - optimized
        function fetchOrderCounts() {
            var countQuery = `
                query GetOrderCounts($filters: OrderFilters) {
                    orderCounts(filters: $filters) {
                        total
                        starred
                        inProgress
                        completed
                    }
                }
            `;
            
            var filters = Object.assign({}, vm.orderFilters || {});
            delete filters.isInProgress;
            delete filters.starred;
            delete filters.isCompleted;
            
            GraphQLService.query(countQuery, { filters: filters })
                .then(function(data) {
                    vm.filterCounts = {
                        total: data.orderCounts.total,
                        starred: data.orderCounts.starred,
                        isInProgress: data.orderCounts.inProgress,
                        isCompleted: data.orderCounts.completed
                    };
                })
                .catch(function(error) {
                    console.error("GraphQL Error fetching counts:", error);
                });
        }
        
        // Initial counts will be fetched by loadAll()
        
        

        $scope.getAttachments = function (order,id) {
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedOrder = id;

	        if(order.attachments != null){
		        vm.getAttachmentsLoader = false;
		        return;
	        }

	        OrderAttach.query({id: id}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getAttachmentsLoader = false;
		        order.attachments = data;
	        }
	        function onError(error) {
	        	AlertService.error(error.data.message);
	        }
        }

		$scope.downloadAttachment = function (id_hash,order) {
		    OrderAttachDownload.get({id: id_hash}, onSuccess, onError);

		    function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
                a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
	            a.click();
		        order.select = "";
		    }

		    function onError(error) {

		    }
		}

        $scope.itemArray = [
            {id: 0, name: 'All', value: 'ALL'},
            {id: 1, name: 'Created', value: 'CREATED'},
            {id: 2, name: 'Samples Received', value: 'SAMPLES_RECEIVED'},
            {id: 3, name: 'Preliminary Results', value: 'PRELIMINARY_RESULTS'},
            {id: 4, name: 'Completed', value: 'COMPLETED'},
            {id: 5, name: 'Retesting', value: 'RETESTING'}
            // {id: 5, name: 'Invoiced', value: 'INVOICED'}
        ];

        $scope.selected = { value: $scope.itemArray[0] };

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "Orders";
            $rootScope.searchVm = vm;
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate || 'dateReceived';
        vm.reverse = pagingParams.ascending || false;
        vm.transition = transition;

        vm.itemsPerPage = "10";
        vm.state = "ALL";
        if(pagingParams.items != null){
            vm.itemsPerPage = pagingParams.items;
        }

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.setpagesize = setpagesize;
        vm.setFilter = setFilter;

        if(!vm.isAuthenticated()){
             $state.go('login');
        }

        if ($rootScope.sampleOrderFilter) {
            vm.state = $rootScope.sampleOrderFilter.value;
            $scope.selected = { value: $rootScope.sampleOrderFilter };
        }

        vm.datePickerOpenStatus = {};

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.toggleWidget = function(name) {
        	vm.activeWidget = name === vm.activeWidget ? null : name;
        }

        vm.listFilters = {
        		"1 day (rush)" : {
        			selected: false,
        			field: "turnaroundTimes"
        		},
        		"2 day (rush)" : {
        			selected: false,
        			field: "turnaroundTimes"
        		},
        		"3 day (rush)" : {
        			selected: false,
        			field: "turnaroundTimes"
        		},
        		"4-5 day (standard)" : {
        			selected: false,
        			field: "turnaroundTimes"
        		},
        		"TATOther" : {
        			selected: false,
        			field: "turnaroundTimes"
        		},

        		"CREATED": {
        			selected: false,
        			field: "states"
        		},
        		"SAMPLES_RECEIVED": {
        			selected: false,
        			field: "states"
        		},
        		"PRELIMINARY_RESULTS": {
        			selected: false,
        			field: "states"
        		},
        		"COMPLETED": {
        			selected: false,
        			field: "states"
        		}
        }
        vm.toggleListFilter = function(field) {
        	var values = [];

        	for (var key in vm.listFilters) {
        		if (vm.listFilters[key].field === field && vm.listFilters[key].selected) {
        			values.push(key);
        		}
        	}
        	vm.orderFilters[field] = values;
        }

        vm.orderFilters = {
        		id: pagingParams.id,
        		sampleCount: pagingParams.sampleCount,
        		turnaroundTimes: pagingParams.turnaroundTimes,
        		dateReceivedLower: pagingParams.dateReceivedLower ? convertLocalDateFromServer(pagingParams.dateReceivedLower) : null,
        		dateReceivedUpper: pagingParams.dateReceivedUpper ? convertLocalDateFromServer(pagingParams.dateReceivedUpper) : null,
        		states: pagingParams.states,
                starred: pagingParams.starred ? true : null,
                isInProgress: pagingParams.isInProgress ? true : null,
                isCompleted: pagingParams.isCompleted ? true : null
        }

            if (vm.orderFilters.isInProgress) {
                vm.orderFilters.states = ["SAMPLES_RECEIVED", "PRELIMINARY_RESULTS"];
            }
            else if (vm.orderFilters.isCompleted) {
                vm.orderFilters.states = ["COMPLETED"];
            } else if (!pagingParams.states) {
                vm.orderFilters.states = null; 
            }
        if (pagingParams.turnaroundTimes) {
        	if (Array.isArray(pagingParams.turnaroundTimes)) {
            	for (var i = 0; i < pagingParams.turnaroundTimes.length; i++) {
            		if (vm.listFilters[pagingParams.turnaroundTimes[i]]) {
            			vm.listFilters[pagingParams.turnaroundTimes[i]].selected = true;
            		}
            	}
        	} else {
        		vm.listFilters[pagingParams.turnaroundTimes].selected = true;
        	}
        }
        if (pagingParams.states) {
        	if (Array.isArray(pagingParams.states)) {
            	for (var i = 0; i < pagingParams.states.length; i++) {
            		if (vm.listFilters[pagingParams.states[i]]) {
            			vm.listFilters[pagingParams.states[i]].selected = true;
            		}
            	}
        	} else {
        		vm.listFilters[pagingParams.states].selected = true;
        	}

        }



        vm.applyFilters = applySampleFilters;
        function applySampleFilters() {
            // Refresh counts with current filters
            fetchOrderCounts();
            
            // Reload orders with filters
            vm.page = 1;
            pagingParams.page = 1;
            loadAll();
        }
        

        function getFilterCount() {
            var totalFilters = 0;
            var excludeKeys = ['isInProgress', 'isCompleted', 'starred'];
            var tabSetsStates = $scope.isInProgress || $scope.isCompleted;
            for (var key in vm.orderFilters) {
                if (excludeKeys.indexOf(key) !== -1) continue;
                if (key === 'states' && tabSetsStates) continue;
                if (vm.orderFilters[key] !== null && vm.orderFilters[key] !== "" && vm.orderFilters[key] !== undefined && vm.orderFilters[key] !== false) {
                    if (Array.isArray(vm.orderFilters[key])) {
                        if (vm.orderFilters[key].length > 0) totalFilters++;
                    } else {
                        totalFilters++;
                    }
                }
            }
            vm.totalFilters = totalFilters;
            return totalFilters;
        }
        
        getFilterCount();
        vm.getFilterCount = getFilterCount;
        vm.filterSubmit = function() {
            vm.page = 1;
            
            var activeTabName = "total";
            if ($scope.starred) activeTabName = "starred";
            else if ($scope.isInProgress) activeTabName = "isInProgress";
            else if ($scope.isCompleted) activeTabName = "isCompleted";
                        
            if (activeTabName === "starred") {
                vm.orderFilters.starred = true;
                pagingParams.starred = true;
            } else if (activeTabName === "isInProgress") {
                vm.orderFilters.states = ["SAMPLES_RECEIVED", "PRELIMINARY_RESULTS"];
                pagingParams.isInProgress = true;
            } else if (activeTabName === "isCompleted") {
                vm.orderFilters.states = ["COMPLETED"];
                pagingParams.isCompleted = true;
            }
            
            vm.transition();
            applySampleFilters();
            
        }

        $scope.all = true;
        vm.switchTab = function(tab) {
            // Preserve manual filters (dates, turnaround times, etc.) when switching tabs
            var preservedFilters = {
                id: vm.orderFilters.id,
                sampleCount: vm.orderFilters.sampleCount,
                turnaroundTimes: vm.orderFilters.turnaroundTimes,
                dateReceivedLower: vm.orderFilters.dateReceivedLower,
                dateReceivedUpper: vm.orderFilters.dateReceivedUpper
            };
            
            // Reset only tab-specific filters
            vm.orderFilters = {
                id: preservedFilters.id,
                sampleCount: preservedFilters.sampleCount,
                turnaroundTimes: preservedFilters.turnaroundTimes,
                dateReceivedLower: preservedFilters.dateReceivedLower,
                dateReceivedUpper: preservedFilters.dateReceivedUpper,
                states: null,
                starred: null
            };
            
            // Reset only state-related listFilters checkboxes
            if (vm.listFilters.CREATED) vm.listFilters.CREATED.selected = false;
            if (vm.listFilters.SAMPLES_RECEIVED) vm.listFilters.SAMPLES_RECEIVED.selected = false;
            if (vm.listFilters.PRELIMINARY_RESULTS) vm.listFilters.PRELIMINARY_RESULTS.selected = false;
            if (vm.listFilters.COMPLETED) vm.listFilters.COMPLETED.selected = false;
            
            $scope.starred = false;
            $scope.isInProgress = false;
            $scope.isCompleted = false;
            $scope.total = false;
            
            $('#starred, #starred_controls, #isInProgress, #isInProgress_controls, #isCompleted, #isCompleted_controls, #total, #total_controls')
                .removeClass('active');
            
            angular.forEach(vm.tabs, function(value, key) {
                vm.tabs[key] = false;
            });
            
            if (tab === 'starred') {
                $scope.starred = true;
                vm.tabs.starred = true;
                pagingParams.starred = true;
                vm.orderFilters.starred = true;
                $('#starred, #starred_controls').addClass('active');
            }
            else if (tab === 'isInProgress') {
                $scope.isInProgress = true;
                vm.tabs.isInProgress = true;
                pagingParams.isInProgress = true;
                vm.orderFilters.states = ["SAMPLES_RECEIVED", "PRELIMINARY_RESULTS"];
                $('#isInProgress, #isInProgress_controls').addClass('active');
            }
            else if (tab === 'isCompleted') {
                $scope.isCompleted = true;
                vm.tabs.isCompleted = true;
                pagingParams.isCompleted = true;
                vm.orderFilters.states = ["COMPLETED"];
                $('#isCompleted, #isCompleted_controls').addClass('active');
            }
            else if (tab === 'total') {
                $scope.total = true;
                vm.tabs.total = true;
                pagingParams.total = true;
                $('#total, #total_controls').addClass('active');
            }
            
            getFilterCount();
            vm.filterSubmit();

        }

        vm.setTabViews = function() {
            setTimeout(function() {
                if (pagingParams.starred) {
                    $('#starred').addClass('active');
                    $('#starred_controls').addClass('active');
                    $('#isInProgress').removeClass('active');
                    $('#total').removeClass('active');
                    $('#isInProgress_controls').removeClass('active');
                    $('#total_controls').removeClass('active');
                    $('#isCompleted').removeClass('active');
                    $('#isCompleted_controls').removeClass('active');
                }
                else if (pagingParams.isInProgress) {
                    $('#isInProgress').addClass('active');
                    $('#isInProgress_controls').addClass('active');
                    $('#starred').removeClass('active');
                    $('#total').removeClass('active');
                    $('#starred_controls').removeClass('active');
                    $('#total_controls').removeClass('active');
                    $('#isCompleted').removeClass('active');
                    $('#isCompleted_controls').removeClass('active');
                }
                else if (pagingParams.isCompleted) {
                    $('#isCompleted').addClass('active');
                    $('#isCompleted_controls').addClass('active');
                    $('#starred').removeClass('active');
                    $('#total').removeClass('active');
                    $('#starred_controls').removeClass('active');
                    $('#total_controls').removeClass('active');
                    $('#isInProgress').removeClass('active');
                    $('#isInProgress_controls').removeClass('active');
                }
                else {
                    $('#total').addClass('active');
                    $('#total_controls').addClass('active');
                    $('#starred').removeClass('active');
                    $('#isInProgress').removeClass('active');
                    $('#starred_controls').removeClass('active');
                    $('#isInProgress_controls').removeClass('active');
                    $('#isCompleted').removeClass('active');
                    $('#isCompleted_controls').removeClass('active');
                }
            }, 10);
        }

		vm.setTabViews();

		vm.tabs = {
			total: totalOnly(),
			isInProgress: pagingParams.isInProgress ? pagingParams.isInProgress : false,
			starred: pagingParams.starred ? pagingParams.starred : false,
			isCompleted: pagingParams.isCompleted ?pagingParams.isCompleted : false,
			external: false
		}

		function totalOnly() {
			if (!pagingParams.isInProgress && !pagingParams.starred && !pagingParams.isCompleted) {
				return true;
			}
			else {
				return false;
			}
		}	
        vm.toggleStarredView = function() {
			$scope.starred = !$scope.starred;

			vm.filterSubmit();
		}

        	function createStarredPayload() {
			var dict = {
				starred: 1,
			};

			var filters = Object.assign({}, vm.CustomerOrder);
			filters.isInProgress = null;
			filters.starred = null;
			filters.isCompleted = null;

			var payload = {
				headers : dict,
				filters: filters
			}

			return payload
		}


        function getStarredOrdersCount() {
			CustomerOrder.attributeCounts(createStarredPayload(),
			function(data){
				vm.filterCounts.starred = data.starred;
			},

			function(e) {
				console.log(e)
			}
		);
		}



        $scope.toggleStarred = function(id, order) {
          
            CustomerOrder.toggleStarred({ id: id }, {}, onSuccess, onError);
         	function onSuccess (data, headers) {
                order.starred = data.starred
        	}

        	function onError(error) {
                console.log("error ", error);
		    }
        };



        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["dateReceivedLower", "dateReceivedUpper"];
        	for (var key in vm.orderFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateToServer(vm.orderFilters[key]);

         		} else if (vm.orderFilters[key] !== "" && vm.orderFilters[key] !== null && vm.orderFilters[key] !== undefined) {
        			params[key] = vm.orderFilters[key];
        		}
        	}

        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.size = vm.itemsPerPage;
            params.items = params.size;
            params.search = vm.currentSearch;
            
            if ($scope.starred) {
                params.starred = true;
            }
            if ($scope.isInProgress) {
                params.isInProgress = true;
            }
            if ($scope.isCompleted) {
                params.isCompleted = true;
            }

        	return params;
        }


     

        function loadAll(skipCountRefresh) {
            // Don't re-fetch counts if we're just paginating
            if (!skipCountRefresh) {
                fetchOrderCounts();
            }
            
            // GraphQL query for orders list - includes samples for due date and preview
            var ordersQuery = `
                query GetOrdersList($page: Int!, $size: Int!, $sort: String, $filters: OrderFilters, $includeSamples: Boolean!) {
                    ordersList(page: $page, size: $size, sort: $sort, filters: $filters, includeSamples: $includeSamples) {
                        orders {
                            id
                            state
                            dateReceived
                            dateCompleted
                            starred
                            sampleCount
                            poNumber
                            turnaroundTime
                            customerName
                            samples {
                                id
                                name
                                hash
                                sampleTests {
                                    estimatedCompleteDate
                                }
                            }
                        }
                        totalCount
                    }
                }
            `;
            
            // Prepare filters
            var filters = {};
            var params = createFilterQueryParams();
            
            // Always include filters from params (including tab-based filters)
            filters = {
                id: params.id,
                starred: params.starred,
                states: params.states,
                turnaroundTimes: params.turnaroundTimes,
                dateReceivedLower: params.dateReceivedLower,
                dateReceivedUpper: params.dateReceivedUpper,
                sampleCount: params.sampleCount,
                search: params.search || vm.currentSearch || pagingParams.search,
                isInProgress: params.isInProgress,
                isCompleted: params.isCompleted
            };
            
            // Prepare sort string - map frontend field names to backend
            var sortField = vm.predicate || 'date_received';
            // Map frontend column names to backend field names
            if (sortField === 'dateReceived') {
                sortField = 'date_received';
            } else if (sortField === 'sampleCount') {
                sortField = 'sample_count';
            }
            var sortString = sortField + ',' + (vm.reverse ? 'asc' : 'desc');
            
            // Show loading state without clearing existing data
            vm.loadingOrders = true;
            
            // Execute GraphQL query - include samples for UI features
            GraphQLService.query(ordersQuery, {
                page: vm.page || pagingParams.page || 1,  // Use vm.page for pagination
                size: parseInt(vm.itemsPerPage) || 20,
                sort: sortString,
                filters: filters,
                includeSamples: true  // Enable samples for hover preview and due dates
            }).then(function(data) {
                // Only update data after successful load
                vm.customerOrders = data.ordersList.orders.map(function(order) {
                    var orderData = {
                        id: order.id,
                        state: order.state,
                        stateLabel: order.state ? order.state.replace(/_/g, ' ').toLowerCase()
                            .replace(/\b\w/g, function(l){ return l.toUpperCase(); }) : '',
                        dateReceived: order.dateReceived || null,  // Keep as ISO string for utcToLocal filter
                        dateCompleted: order.dateCompleted ? new Date(order.dateCompleted) : null,
                        starred: order.starred,
                        sampleCount: order.sampleCount || 0,
                        poNumber: order.poNumber,
                        turnaroundTime: order.turnaroundTime,
                        turnaroundTimeLabel: formatTurnaroundTime(order.turnaroundTime),
                        customer: { name: order.customerName }
                    };
                    
                    // Include samples for UI display (hover preview, modal, due dates)
                    if (order.samples) {
                        orderData.samples = order.samples.map(function(sample) {
                            return {
                                id: sample.id,
                                name: sample.name,
                                hash: sample.hash,
                                sampleTests: sample.sampleTests || []
                            };
                        });
                    } else {
                        orderData.samples = [];
                    }
                    
                    return orderData;
                });
                
                vm.totalItems = data.ordersList.totalCount;
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                
                // Update pagination
                vm.links = {
                    last: Math.ceil(vm.totalItems / parseInt(vm.itemsPerPage))
                };
                
                // Clear loading state
                vm.loadingOrders = false;
                
            }).catch(function(error) {
                console.error("GraphQL Error:", error);
                AlertService.error("Failed to load orders");
                vm.loadingOrders = false;
            });
            
            function formatTurnaroundTime(tat) {
                if (!tat) return '';
                // Return the turnaround time as-is since it's already formatted in the database
                return tat;
            }
        }

        loadAll();

        function getCustomerData () {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
            }
            function onError(error) {

            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition(isPagination) {
            var params = createFilterQueryParams();
            
            if (params.starred === false) {
                delete params.starred;
            }
            if (params.isInProgress === false) {
                delete params.isInProgress;
            }
            if (params.isCompleted === false) {
                delete params.isCompleted;
            }
            
            // For pagination, just reload data without state transition
            if (isPagination) {
                // Update pagingParams with new page value
                pagingParams.page = vm.page;
                
                // Update URL without triggering state reload
                $state.go('.', params, { notify: false, reload: false });
                // Just reload the orders data, not counts
                loadAll(true); // true = skip count refresh
                return;
            }
            
            var currentTabState = {
                starred: $scope.starred,
                isInProgress: $scope.isInProgress,
                isCompleted: $scope.isCompleted,
                total: $scope.total
            };
            
            $state.transitionTo($state.$current, params);
            
            $timeout(function() {
                $scope.starred = currentTabState.starred;
                $scope.isInProgress = currentTabState.isInProgress; 
                $scope.isCompleted = currentTabState.isCompleted;
                $scope.total = currentTabState.total;
                
                vm.forceSyncTabUI();
                            }, 50);
        }
        
        vm.forceSyncTabUI = function() {
            if ($scope.starred) {
                $('#starred, #starred_controls').addClass('active');
                $('#isInProgress, #isInProgress_controls, #isCompleted, #isCompleted_controls, #total, #total_controls').removeClass('active');
            }
            else if ($scope.isInProgress) {
                $('#isInProgress, #isInProgress_controls').addClass('active');
                $('#starred, #starred_controls, #isCompleted, #isCompleted_controls, #total, #total_controls').removeClass('active');
            }
            else if ($scope.isCompleted) {
                $('#isCompleted, #isCompleted_controls').addClass('active');
                $('#starred, #starred_controls, #isInProgress, #isInProgress_controls, #total, #total_controls').removeClass('active');
            }
            else {
                $('#total, #total_controls').addClass('active');
                $('#starred, #starred_controls, #isInProgress, #isInProgress_controls, #isCompleted, #isCompleted_controls').removeClass('active');
            }
        };

        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

        function setFilter(filter) {
            vm.page = 0;
            pagingParams.page = 0;
            $stateParams['page']= 0;
            $rootScope.sampleOrderFilter =  filter;
            vm.state = filter.value;
            loadAll ();
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'dateReceived';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.orderFilters = {};
            
            // Reset all listFilters checkboxes
            for (var key in vm.listFilters) {
                vm.listFilters[key].selected = false;
            }
            
            if (!$scope.starred && !$scope.isInProgress && !$scope.isCompleted) {
                $scope.total = true;
            }
            
            vm.transition();
        }

        /* Date Utils (import DateUtils service doesn't work) */
        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function padToTwo(number) {
            return `0${number}`.slice(-2);
          }

        function formatDate(date) {
            var month = date.getUTCMonth() + 1;
            var day = date.getUTCDate();
            var year = date.getUTCFullYear();

            return `${padToTwo(month)}/${padToTwo(day)}/${year}`;
        }

        vm.parseDueDate = function (order) {
            var current_due_date = null;
            var sample = null;
            var tests = null;
            var test = null;

            for(var sample_index = 0; sample_index < order.samples.length; sample_index++) {
                sample = order.samples[sample_index];
                tests = order.samples[sample_index].sampleTests;

                for(var test_index = 0; test_index < tests.length; test_index++) {
                    test = tests[test_index];
                    if(current_due_date == null) current_due_date = test.estimatedCompleteDate;
                    if(test.estimatedCompleteDate != current_due_date) return "Various";
                }
            }

            if(!current_due_date) return "Not Set";

			try {
                current_due_date = new Date(current_due_date);
                if(current_due_date == 'Invalid Date') throw 'Invalid Date'

				return formatDate(current_due_date);
			}
			catch(e) {
				console.log(e);
                return current_due_date;
			}
        }

        angular.element(document).ready(function() {
            setTimeout(function () {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;
                $("#table tr:first > th").css("width", col_width+"%");

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if(constant == 2 || constant2 >= 2){
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });
        
        vm.SampleDetail = function(samples){
            $('#rdAddRequestedTest').modal('show');
            vm.modalsamples = samples
        }
        vm.redirectSamples = function(orderId){
            $('#rdAddRequestedTest').modal('hide');
        	$state.go('samplelog', {orderId});
        }
        vm.openPublicSample = function(event, jsEvent, view) {
        	$state.go('public', {hash: event.hash});
        }

        $timeout(function() {
            vm.forceSyncTabUI();
        }, 100);
    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerOrder', CustomerOrder);

    CustomerOrder.$inject = ['$resource', 'DateUtils'];

    function CustomerOrder ($resource, DateUtils) {
        var resourceUrl =  'api/customer-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                        data.dateReceived = DateUtils.convertLocalDateFromServer(data.dateReceived);
                        data.dateReceived = DateUtils.utcToLocal(data.dateReceived);
                        data.dateCreated = DateUtils.utcToLocal(data.dateCreated);
                        data.dateCompleted = DateUtils.utcToLocal(data.dateCompleted);
                        data.datePreliminaryResults = DateUtils.utcToLocal(data.datePreliminaryResults);
                        data.checkoutDate = DateUtils.convertLocalDateFromServer(data.checkoutDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateReceived = DateUtils.convertLocalDateToServer(copy.dateReceived);
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    var result = angular.toJson(copy);

                    return result;
                }
            },
            'filter': {
            	url: 'api/customer-orders/filter',
            	method: 'GET',
            	isArray: true,
              
            },
            'countByStatus': {
                url: 'api/customer-orders/count/by-status',
                method: 'GET'
            },
            'filterAll': { // Get all orders without pages
            	url: 'api/customer-orders/filter/all',
            	method: 'GET',
            	isArray: true,
            },
             'attributeCounts' : { // Get Orders Count
                method: 'GET',
                isArray: false,
                url: 'api/customer-orders/count/attribute'
            },
            'openSubmissions': {
            	url: 'api/customer-orders/count/opensubmissions',
            	method: 'GET'
            },
            'getCustomerEmails': {
            	url: 'api/customer-orders/get_customer_emails',
            	method: 'GET'
            },
            'CustomerOrdersLimited': {
                url: 'api/customer-orders/limited',
                method: 'GET',
                isArray: true
            },
            'toggleStarred': {
                url: 'api/customer-orders/:id/togglestarred',
                method: 'PUT'
}
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('orders', {
            parent: 'entity',
            url: '/orders?page&sort&search&state&id&sampleCount&turnaroundTimes&dateReceivedLower&dateReceivedUpper&states&starred&isInProgress&isCompleted',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Orders'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/orders/orders.html',
                    controller: 'OrdersController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dateReceived,desc',
                    squash: true
                },
                starred: null,
                isInProgress: null,
                isCompleted: null, 
                search: null,
                state: {
                    value: 'ALL',
                    squash: true
                },
                items: null,

                // Order Filters
        		id: null,
        		sampleCount: null,
        		turnaroundTimes: null,
        		dateReceivedLower: null,
        		dateReceivedUpper: null,
        		states: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        state: $stateParams.state,
                        items: $stateParams.items,

                        // Order Filters
                		id: $stateParams.id ? parseInt($stateParams.id) : null,
                		sampleCount: $stateParams.sampleCount ? parseInt($stateParams.sampleCount) : null,
                		turnaroundTimes: $stateParams.turnaroundTimes,
                		dateReceivedLower: $stateParams.dateReceivedLower,
                		dateReceivedUpper: $stateParams.dateReceivedUpper,
                		states: $stateParams.states,

                        starred: $stateParams.starred ? true : false,
                        isInProgress: $stateParams.isInProgress ? true : false,
                        isCompleted: $stateParams.isCompleted ? true : false,
                    };
                }],
            }
        })
        .state('orders.view', {
            parent: 'orders',
            url: '/{orderId}/view',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/orders/orders-dialog-old.html',
                    controller: 'OrdersDialogController',
                    controllerAs: 'vm',
                    // comment this to close modal on outside click backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CustomerOrder', function(CustomerOrder) {
                            return CustomerOrder.get({id : $stateParams.orderId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customer-order', null, { reload: 'customer-order' });
                }, function() {
                    $state.go('^');
                });
            }]
        });

    }


})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('CustomerOrderSearch', CustomerOrderSearch);

    CustomerOrderSearch.$inject = ['$resource'];

    function CustomerOrderSearch($resource) {
        var resourceUrl =  'api/_search/customer-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('OrdersDialogController', OrdersDialogController);

    OrdersDialogController.$inject = ['$timeout', 'CustomerOrderPdfService', '$scope', '$rootScope', '$stateParams', '$uibModalInstance',
        'entity', 'CustomerOrder', 'Sample', 'Customer','CustomerByUser','SampleAttach','SampleAttachDownload','OrderPicture', 'OrderAttach', 'OrderAttachDownload', 'DownloadUtil'];

    function OrdersDialogController ($timeout, CustomerOrderPdfService, $scope, $rootScope, $stateParams, $uibModalInstance, entity,
                                     CustomerOrder, Sample, Customer,CustomerByUser,SampleAttach,SampleAttachDownload,OrderPicture, OrderAttach, OrderAttachDownload, DownloadUtil) {

        var vm = this;
        vm.idOfSelectedSample = null;
        vm.numOfSelectedSamplePictures = 0;

        vm.getAttachmentsLoader = false;
        vm.customerOrder = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $rootScope.getOrderAttachments = function (order,id) {
        	
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedOrder = id;

	        if(order.attachments != null){
		        vm.getAttachmentsLoader = false;
		        return;
	        }
	        
	        OrderAttach.query({id: id}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getAttachmentsLoader = false;
		        order.attachments = data;
	        }
	        
	        function onError(error) {
	        	
	        	AlertService.error(error.data.message);
	        }
        }

        $rootScope.downloadOrderAttachment = function (id_hash,order) {
		    OrderAttachDownload.get({id: id_hash}, onSuccess, onError);
		
		    function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
                a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
	            a.click();
		        order.select = "";
		    }
		    
		    function onError(error) {
		
		    }
		}
        
        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });

        vm.progress = 1;

        vm.downloadOrderPdf = downloadOrderPdf;

        if(vm.customerOrder.state == "CREATED"){
            vm.progress = 1
        }
        else if(vm.customerOrder.state == "SAMPLES_RECEIVED"){
            vm.progress = 2;
        }
        else if(vm.customerOrder.state == "PRELIMINARY_RESULTS"){
            vm.progress = 3
        }
        else if(vm.customerOrder.state == "COMPLETED"){
            vm.progress = 4
        }
        else if(vm.customerOrder.state == "INVOICED"){
            vm.progress = 5
        }


        //show loading image first, when order is loaded show cached images,finally show all images from server


        if (vm.customerOrder.cachedPictures != null && vm.customerOrder.cachedPictures.length>0) {
            setPictures(vm.customerOrder.cachedPictures )
        }
        else {
            var defaultPicture = new Array();
            defaultPicture.push({id: 0, name: "Empty Sample", url: "content/images/loading.gif"});
            setPictures(defaultPicture )
        }


        getPictures ();

        function getPictures () {
            var id = entity.id;
            OrderPicture.query({id: id}, onSuccess, onError);

            function onSuccess(data, headers) {
                  setPictures(data);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function setPictures(pictures) {

            vm.pictures = pictures;
            vm.numOfSelectedSamplePictures = vm.pictures.length;

            if( vm.numOfSelectedSamplePictures > 1){
                vm.show = 1;
                console.log(vm.show);
            }
            else {

            }
            if( vm.numOfSelectedSamplePictures < 1){
                for(var i = 0; i <(4 - vm.numOfSelectedSamplePictures ); i++ ){
                    vm.pictures.push({id: i, name: "Empty Sample", url: "content/images/no_image_available-small.png"});
                }
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customerOrder.id !== null) {
                CustomerOrder.update(vm.customerOrder, onSaveSuccess, onSaveError);
            } else {
                CustomerOrder.save(vm.customerOrder, onSaveSuccess, onSaveError);
            }

        }

        function closeModal() {
          $uibModalInstance.close();
        }


        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:customerOrderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateReceived = false;
        vm.datePickerOpenStatus.checkoutDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }


        $scope.getAttachments = function (sample,id) {
            vm.getAttachmentsLoader = true;
            vm.idOfSelectedSample = id;

            if(sample.attachments != null){
                vm.getAttachmentsLoader = false;
                return;
            }

            SampleAttach.query({id: id}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.getAttachmentsLoader = false;
                sample.attachments = data;

            }
            function onError(error) {
                console.log(error.status === 401);
                if(error.status === 401){
                    clear();
                }

                AlertService.error(error.data.message);
            }
        }

        $scope.downloadAttachment = function (id_hash,sample) {
            if(id_hash == ''){return}
            SampleAttachDownload.get({id:id_hash}, onSuccess, onError);
            function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
                a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
	            a.click();
		        sample.select = "";
            }
            function onError(error) {
                if(error.status === 401){
                    clear();
                }

            }
        }

        function downloadOrderPdf () {
            var id = vm.customerOrder.id;

            if (vm.customerOrder.orderType === 'COMPLIANCE') {
             var fileName = id + " Compliance Submission Form.pdf";
            } else {
             var fileName = id + " R&D Submission Form.pdf";
            }

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            CustomerOrderPdfService.downloadPdf(id).then(function (result) {
                var file = new Blob([result.data], {type: 'application/pdf'});
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            }).catch(function(error){
                if(error.status === 401){
                    clear();
                }
            });
        }

        angular.element(document).ready(function() {
            $(".status-wizard-step a").each(function(index, element) {
                index++;
                $(this).attr("id", "open-tooltip-"+index);
                $("#open-tooltip-"+index).click(function(){
                    $(".status-wizard-step a").not(this).removeClass('open');
                    $(this).toggleClass("open");
                    return this;
                });
            });

            $(".status-wizard-step.active > .status-wizard-dot span" ).remove();
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CustomerOrderDetails', CustomerOrderDetails);

    CustomerOrderDetails.$inject = ['$resource', 'DateUtils'];

    function CustomerOrderDetails ($resource, DateUtils) {
        var resourceUrl =  'api/customer-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                        data.dateReceived = DateUtils.convertLocalDateFromServer(data.dateReceived);
                        data.dateReceived = DateUtils.utcToLocal(data.dateReceived);
                        data.dateCreated = DateUtils.utcToLocal(data.dateCreated);
                        data.dateCompleted = DateUtils.utcToLocal(data.dateCompleted);
                        data.datePreliminaryResults = DateUtils.utcToLocal(data.datePreliminaryResults);
                        data.checkoutDate = DateUtils.convertLocalDateFromServer(data.checkoutDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateReceived = DateUtils.convertLocalDateToServer(copy.dateReceived);
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.checkoutDate = DateUtils.convertLocalDateToServer(copy.checkoutDate);
                    var result = angular.toJson(copy);

                    return result;
                }
            },
            'filter': {
            	url: 'api/customer-orders/filter',
            	method: 'GET',
            	isArray: true
            },
            'filterAll': { // Get all orders without pages
            	url: 'api/customer-orders/filter/all',
            	method: 'GET',
            	isArray: true,
            	url: 'api/samples/filter/all'
            },
            'openSubmissions': {
            	url: 'api/customer-orders/count/opensubmissions',
            	method: 'GET'
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order-details', {
            parent: 'entity',
            url: '/order-details/{orderId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Order Details'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/order-details/order-details.html',
                    controller: 'OrderDetailsController',
                    controllerAs: 'vm'
                }
            },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('OrderDetailsController', OrderDetailsController);

    OrderDetailsController.$inject = ['$timeout', 'CustomerOrderPdfService','$scope', '$rootScope', '$stateParams', '$state', 'CustomerOrder',
         'CustomerOrderDetails', 'Sample', 'Customer','CustomerByUser','SampleAttach','SampleAttachDownload','OrderPicture', 'OrderAttach', 'OrderAttachDownload', 'SampleCoaPdfService', 'DownloadUtil'];

    function OrderDetailsController ($timeout, CustomerOrderPdfService, $scope, $rootScope, $stateParams, $state, CustomerOrder,
        CustomerOrderDetails, Sample, Customer, CustomerByUser, SampleAttach, SampleAttachDownload, OrderPicture, OrderAttach, OrderAttachDownload, SampleCoaPdfService, DownloadUtil) {

            var vm = this;

            vm.idOfSelectedSample = null;
            vm.numOfSelectedSamplePictures = 0;
            vm.getAttachmentsLoader = false;
            vm.isComplianceOrder = false;
            vm.orderIsCompleted = false;
            vm.showReports = true;

            vm.due_date_info = {
                same_for_all: false,
                due_date: null
            }

            vm.customerOrder = CustomerOrder.get({id : $scope.toStateParams.orderId},
                function(data) {
                    if (data.state === 'CANCELLED' || data.qbench_state === 'CANCELLED') {
                        $state.go('orders', {}, {location: 'replace'});
                        return;
                    }
                    var type_of_business = data.customer.businessType.name.toLowerCase();

                    afterCustomerOrderGet();

                    if (type_of_business.includes('food')) {
                        vm.consolidated_business_type = 'food';
                    }
                    else {
                        vm.consolidated_business_type = 'cannabis';
                    }

                    parseDueDates(data);
                    checkLotNumbers(data);

                    return data
                },
                function(e) {
                    if (e && e.status === 404) {
                        $state.go('orders', {}, {location: 'replace'});
                        return;
                    }
                    console.log(e);
                }
            );

            function parseDueDates(order) {
                var current_due_date = null;
                var sample = null;
                var tests = null;
                var test = null;

                for(var sample_index = 0; sample_index < order.samples.length; sample_index++) {
                    sample = order.samples[sample_index];
                    tests = order.samples[sample_index].sampleTests;

                    for(var test_index = 0; test_index < tests.length; test_index++) {
                        test = tests[test_index];
                        if(current_due_date == null) current_due_date = test.estimatedCompleteDate;

                        if(test.estimatedCompleteDate != current_due_date) {
                            vm.due_date_info = {
                                same_for_all: false,
                                due_date: null
                            }

                            return
                        }
                    }
                }

                vm.due_date_info = {
                    same_for_all: true,
                    due_date: current_due_date
                }
            }

            function checkLotNumbers(order) {
                vm.hasLotNumbers = false;
                for(var i = 0; i < order.samples.length; i++) {
                    if(order.samples[i].lotBatchNumber) {
                        vm.hasLotNumbers = true;
                        return;
                    }
                }
            }

            function isLabelAttachment(attachment) {
                if (!attachment) {
                    return false;
                }

                if (attachment.type === 'SAMPLE_LABEL_ATTACHMENT') {
                    return true;
                }

                var fileName = ((attachment.file_name || '') + '').toLowerCase();
                return /(^labels?(?:\b|[_-])|[_\s-]labels?\b)/.test(fileName);
            }

            function afterCustomerOrderGet() {
                setOrderProgress()

                vm.isComplianceOrder = vm.customerOrder.order_type.toLowerCase().includes('compliance');
                vm.orderIsCompleted = vm.customerOrder.state == 'COMPLETED';

                // info hover that will list analyses requested with that consulting assay
                var isRDOrder = vm.customerOrder.order_type && vm.customerOrder.order_type.toUpperCase() === 'RD';
                vm.customerOrder.samples.forEach( function(sample) {
                    if (!sample.canSeeReport && !isRDOrder) {
                        vm.showReports = false;
                    }
                    sample.sampleTests.forEach( function(test) {
                        if (test.assay.portalIdentifier == 'CONSULTING') {
                            test.comments = test.comments.slice(18).split('\n');
                        }
                    });
                });
                getPictures();
                $('#orderNo').html('Order No. ' + $scope.toStateParams.orderId);

            }
            
            function setTabsVisibility() {
                $scope.invoiceBtnToggle = false;
                CustomerByUser.get({}, function(customer) {
                    $scope.invoiceBtnToggle = customer.billingAccess === true;
                });
            }

            $rootScope.getOrderAttachments = function (order) {
                var id = $scope.toStateParams.orderId;
                vm.getAttachmentsLoader = true;
                vm.idOfSelectedOrder = id;

                if(order.attachments != null){
                    vm.getAttachmentsLoader = false;
                    return;
                }

                OrderAttach.query({id: id}, onSuccess, onError);
                function onSuccess(data, headers) {
                    vm.getAttachmentsLoader = false;
                    order.attachments = data;
                }

                function onError(error) {
                    console.log(error.data.message)
                    // AlertService.error(error.data.message);
                }
            }

            $rootScope.downloadOrderAttachment = function (id_hash,order) {
                OrderAttachDownload.get({id: id_hash}, onSuccess, onError);

                function onSuccess(data, headers) {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";

                    var fileURL = window.URL.createObjectURL(data.data);
                    a.href = fileURL;
                    a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                    a.click();
                    order.select = "";
                }

                function onError(error) {

                }
            }

            function setOrderProgress() {
                vm.progress = 1;

                if(vm.customerOrder.state == "CREATED"){
                    vm.progress = 1
                }
                else if(vm.customerOrder.state == "SAMPLES_RECEIVED"){
                    vm.progress = 2;
                }
                else if(vm.customerOrder.state == "PRELIMINARY_RESULTS"){
                    vm.progress = 3
                }
                else if(vm.customerOrder.state == "COMPLETED"){
                    vm.progress = 4
                }
                else if(vm.customerOrder.state == "INVOICED"){
                    vm.progress = 5
                }
            }


            vm.downloadOrderPdf = downloadOrderPdf;

            //show loading image first, when order is loaded show cached images,finally show all images from server

                if (vm.customerOrder.cachedPictures != null && vm.customerOrder.cachedPictures.length>0) {
                    setPictures(vm.customerOrder.cachedPictures )
                }
                else {
                    var defaultPicture = new Array();
                    defaultPicture.push({id: 0, name: "Empty Sample", url: "content/images/loading.gif"});
                    setPictures(defaultPicture )
                }

            function getPictures () {
                var id = vm.customerOrder.id;

               OrderPicture.query({id: id}, onSuccess, onError);

                function onSuccess(data, headers) {
                      setPictures(data);
                }

                function onError(error) {
                    console.log(error.data.message)
                    //AlertService.error(error.data.message);
                }
            }

            function setPictures(pictures) {

                vm.pictures = pictures;

                vm.numOfSelectedSamplePictures = vm.pictures.length;

                if( vm.numOfSelectedSamplePictures > 1){
                    vm.show = 1;
                }
                else {

                }
                if( vm.numOfSelectedSamplePictures < 1){
                    for(var i = 0; i <(4 - vm.numOfSelectedSamplePictures ); i++ ){
                        vm.pictures.push({id: i, name: "Empty Sample", url: "content/images/no_image_available-small.png"});
                    }
                }
            }

            $timeout(function (){
                angular.element('.form-group:eq(1)>input').focus();
            });


            // function save () {
            //     vm.isSaving = true;
            //     if (vm.customerOrder.id !== null) {
            //         CustomerOrder.update(vm.customerOrder, onSaveSuccess, onSaveError);
            //     } else {
            //         CustomerOrder.save(vm.customerOrder, onSaveSuccess, onSaveError);
            //     }

            // }

            // function onSaveError () {
            //     vm.isSaving = false;
            // }

            // vm.datePickerOpenStatus.dateReceived = false;
            // vm.datePickerOpenStatus.checkoutDate = false;

            // function openCalendar (date) {
            //     vm.datePickerOpenStatus[date] = true;
            // }


            $scope.getAttachments = function (sample, id) {
                vm.getAttachmentsLoader = true;
                vm.idOfSelectedSample = id;

                if(sample.attachments != null){
                    vm.getAttachmentsLoader = false;
                    return;
                }

                SampleAttach.query({id: id}, onSuccess, onError);
                function onSuccess(data, headers) {
                    var processed_attachments = [];

                    vm.getAttachmentsLoader = false;

                    if(!vm.consolidated_business_type.includes('cannabis')) {
						data.forEach( function(attachment) {
							if(!isLabelAttachment(attachment)) {
								processed_attachments.push(attachment)
							}
						})
                    }
                    else if (!vm.isComplianceOrder) {
                        processed_attachments = data;
                    } else {
                        data.forEach(function(attachment) {
                            if (vm.orderIsCompleted && sample.canSeeReport) {
                                processed_attachments.push(attachment);
                            }
                            else {
                                if (!attachment.file_name.toLowerCase().includes('coa')) {
                                    processed_attachments.push(attachment);
                                }
                            }
                        });
                    }

                    // Sort Order of Sample Downloads 
                    processed_attachments.sort(function(a, b) {
                        var getPriority = function(filename) {
                            var name = filename.toLowerCase();
                            
                            // 1. Consolidated COA
                            if (name.includes('consolidated') && name.includes('coa')) return 1;
                            
                            // 2. Test COAs
                            if (name.includes('coa') && !name.includes('consolidated') && !name.includes('summary')) return 2;
                            
                            // 3. COA Summary 
                            if (name.includes('coa') && name.includes('summary')) return 3;
                            
                            // 4. QR Code
                            if (name.includes('qr') || name.includes('qr_code') || name.includes('qrcode')) return 4;
                            
                            // 5. Photos 
                            if (name.match(/\.(jpg|jpeg|png|gif|bmp|webp|tiff)$/)) return 5;
                            
                            // 6. Other attachments
                            return 6;
                        };
                        
                        return getPriority(a.file_name) - getPriority(b.file_name);
                    });
                    

                    sample.attachments = processed_attachments;
                }

                
                function onError(error) {
                    console.log(error.data.message)
                }
            }

            $scope.downloadAttachment = function (id_hash, sample) {
                if(id_hash && id_hash != 'coa'){
                    SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

                    function onSuccess(data, headers) {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        var fileURL = window.URL.createObjectURL(data.data);
                        a.href = fileURL;
                        a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                        a.click();
                    }
                    function onError(error) {
                        console.log(error);
                    }
                }
                else {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    SampleCoaPdfService.downloadPdf(sample.hash).then(function(result) {
                        var file = new Blob([result.data], {
                            type: 'application/pdf'
                        });

                        a.href = window.URL.createObjectURL(file);
                        a.download = sample.id + '_COA_Summary.pdf';
                        a.click();
                    });
                }
                sample.select = "";
            }


            function downloadOrderPdf () {
                var id = $scope.toStateParams.orderId

                if (vm.customerOrder.orderType === 'COMPLIANCE') {
                 var fileName = id + " Compliance Submission Form.pdf";
                } else {
                 var fileName = id + " R&D Submission Form.pdf";
                }

                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                CustomerOrderPdfService.downloadPdf(id).then(function (result) {
                    var file = new Blob([result.data], {type: 'application/pdf'});
                    var fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    a.click();
                }).catch(function(error){
                    if(error.status === 401){
                        //clear();
                    }
                });
            }

            angular.element(document).ready(function() {
                setTabsVisibility(); 

                $(".status-wizard-step a").each(function(index, element) {
                    index++;
                    $(this).attr("id", "open-tooltip-"+index);
                    $("#open-tooltip-"+index).click(function(){
                        $(".status-wizard-step a").not(this).removeClass('open');
                        $(this).toggleClass("open");
                        return this;
                    });
                });

                $(".status-wizard-step.active > .status-wizard-dot span" ).remove();
            });

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment-details', {
            parent: 'entity',
            url: '/payment-details/{paymentId}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Payment Details'
            },
            resolve: {
                billingAccess: ['BillingAccess', function(BillingAccess) {
                    return BillingAccess.requireAccess();
                }]
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/payment-details/payment-details.html',
                    controller: 'PaymentDetailsController',
                    controllerAs: 'vm'
                }
            },
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('PaymentDetailsController', PaymentDetailsController);

    PaymentDetailsController.$inject = ['$stateParams', 'PaymentById', 'Customer', 'PaymentReceipt', 'AlertService', 'BRAND'];

    function PaymentDetailsController ($stateParams, PaymentById, Customer, PaymentReceipt, AlertService, BRAND) {

        var vm = this;
        var brand = BRAND || {};
        vm.static = {
            anresco_address: (brand.address && brand.address.payment_lines) || [(brand.branding && brand.branding.portal_name) || 'Client Portal']
        }

        PaymentById.getPayment({paymentId: $stateParams.paymentId},
            function(data) {
                vm.payment = data;
                getCustomer(data.customer_id);
                processInvoicesDate();
                processAppliedAmounts();

            },
            function(e) {
                console.log(e);
            }
        )

        function processAppliedAmounts() {
            var invoice_index = null;

            vm.payment.payment_invoices.forEach( function(payment_invoice) {
                invoice_index = findWithAttr(vm.payment.invoices, 'id', payment_invoice.invoice_id);

                if(invoice_index != -1) {
                    vm.payment.invoices[invoice_index].applied_amount = payment_invoice.applied_amount;
                }
            });
        }

        function processInvoicesDate() {
            var date_array = null;
            vm.payment.invoices.forEach( function(invoice) {
                date_array = invoice.invoice_date ? invoice.invoice_date.split('-') : null;

                if(date_array) {
                    invoice.invoice_date = date_array[1] + '/' + date_array[2] + '/' + date_array[0];
                }

                date_array = null;
            });
        }

        function parseAddress(addressString) {
            vm.customer.procesed_address = addressString ? addressString.split('\n') : [];
        }

        function getCustomer(id) {
            Customer.get({id: id},
                function(data) {
                    vm.customer = data;
                    parseAddress(data.address);
                },
                function(e) {
                    console.log(e);
                }
            )
        }

        vm.downloadPaymentReceipt = function() {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            PaymentReceipt.get({id: vm.payment.id},
                function(data){
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = 'Payment_Receipt_' + vm.payment.id + '.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function(e) {
                    console.log(e)
                }
            );
        }

        vm.printPaymentReceipt = function() {
            PaymentReceipt.merged({payments: [vm.payment.id]},
                function (data, headers) {
                    if (data.data.byteLength == 0){
                        return;
                    }
                    var url = URL.createObjectURL(data.data);

                    setTimeout(function() {
                        window.open(url, '_blank');
                    }, 200);

                },
                function (e) {
                    AlertService.error("Could not print payments");
                }
            );
        }
    }

    function findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('PublicViewController', PublicViewController)

    PublicViewController.$inject = ['$state','$stateParams','$scope','$rootScope', '$filter', '$timeout', 'AlertService', 'pagingParams', 'Auth', 'Principal', 'SampleFilter',
        'CustomerByUser', 'ProductCategory', 'PublicView', 'SweetAlert', 'QRCode', '$translate', 'GraphQLService', 'BRAND'];

    function PublicViewController($state, $stateParams,$scope, $rootScope, $filter, $timeout, AlertService, pagingParams, Auth, Principal, SampleFilter,
                                 CustomerByUser, ProductCategory, PublicView, SweetAlert, QRCode, $translate, GraphQLService, BRAND) {

		var vm = this;
		vm.brand = BRAND || {};
		vm.branding = vm.brand.branding || {};
		vm.legal = vm.brand.legal || {};
		vm.companyName = vm.legal.company_name || vm.branding.display_name || 'our portal';
		vm.currentLanguage = $translate.proposedLanguage();							
        $rootScope.showSearch = pagingParams.search;
        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pagingParams = pagingParams;
        vm.sampleFilters = {};

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.getAttachmentsLoader = false;
        vm.itemsPerPage = "20";

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.setpagesize = setpagesize;
        var deferredPublicViewBatchLoad = null;
        var first_shuffel_edit = false;

        setPageTitle();
        $scope.range = new Array(20);

        function setPageTitle(){
            $rootScope.pageTitle = "Public Gallery";
            $rootScope.searchVm = vm;
        }

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

		/* Page loads */
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.sampleFilters = {};
            vm.populateTypes();
            vm.transition();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
        	var params = createFilterQueryParams();

            $state.transitionTo($state.$current, params);
        }

        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];
        	for (var key in vm.sampleFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateToServer(vm.sampleFilters[key]);
         		} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
        			params[key] = vm.sampleFilters[key];
        		}
        	}

        	if ($scope.starred)
        		params['starred'] = true;

        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.search = vm.currentSearch;
            params.size = vm.itemsPerPage;
            params.items = params.size;
            params.productCategoryId = vm.productCategoryId;

        	return params;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            }
            return null;
        }



        /* Login/Logout */
        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        /* Navbar Toggle */
        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function LinkedListNode (sample, prev, next) {
    		this.sample = sample;
    		this.prev = prev;
    		this.next = next;

    		this.getSample = function() {
        		return this.sample;
        	}

        	this.extractNodes = function() {
        		return {id: this.sample.id, previous_sample_id: this.sample.previous_sample_id, next_sample_id: this.sample.next_sample_id, is_public: this.sample.is_public}
        	}
        }

        vm.nodesRemoved = [];

        function SampleLinkedList() {
    		this.head = null;
    		this.tail = null;
    		this.length = 0;

    		this.outerSampleIDPrev = null;
    		this.outerSampleIDNext = null;
    		this.outerSampleIDPrevPrev = null;
    		this.outerSampleIDNextNext = null;

        	this.getHead = function () {
        		return this.head;
        	}

        	this.getTail = function () {
        		return this.tail;
        	}

        	this.setTail = function (node) {
        		this.tail = node;
        	}

        	this.getNode = function(index) {
        		var currentNode = this.head;

        		for (var i = 0; i < this.length; i++) {
        			if (i == index) {
        				return currentNode;
        			}

        			if (currentNode.next != null)
        				currentNode = currentNode.next;
        		}
        	}

        	this.setOuterSampleIDPrev = function(value) {
        		this.outerSampleIDPrev = value;
        	}

        	this.setOuterSampleIDNext = function(value) {
        		this.outerSampleIDNext = value;
        	}

        	this.push = function(node) {
        		this.tail.next = node;
        		this.length++;
        	}

        	this.pushSample = function(sample) {

        		if (this.length == 0) {
            		this.head = new LinkedListNode(sample, null, null);
            		this.tail = this.head

            		this.outerSampleIDPrev = sample.previous_sample_id;
            		this.outerSampleIDNext = sample.next_sample_id;

        		} else {
        			var oldTail = this.tail;
        			var newTail = new LinkedListNode(sample, this.tail, null);

        			oldTail.next = newTail;
        			this.tail = newTail;
        			this.outerSampleIDNext = sample.next_sample_id;
        		}

        		this.length++;
        	}

        	this.addToHeadSample = function(sample) {
        		var oldHead = this.head;

        		this.head = new LinkedListNode(node, null, oldHead);
        		oldHead.prev = this.head;

        		this.length++;
        	}

        	this.addToHead = function(node, newSample) {
        		var oldHead = this.head;

        		if (node.prev != null)
        			node.prev.next = node.next;

        		this.head = node;
        		this.head.prev = null;

        		this.head.next = oldHead;
        		oldHead.prev = this.head;

        		if (newSample)
        			this.length++;
        	}

        	this.printLinkedList = function() {
        		var currentNode = this.head;

        		for (var i = 0; i < this.length; i++) {
        			if (currentNode == null)
        				break;

        			var previous_id = currentNode.prev ? currentNode.prev.sample.id : "None"
        			var next_id = currentNode.next ? currentNode.next.sample.id : "None"
        			console.log("Index " + i + ": " + currentNode.sample.id + " | Prev: " + previous_id + " | Next: " + next_id);

        			currentNode = currentNode.next;
        		}
        	}

        	this.insert = function(node, index, backward) {
        		var currentNode = this.head;

        		for (var i = 0; i < this.length; i++) {
        			if (i == index) { //figure this out
        				var nextNode = null;
        				var prevNode = null;


        				//If moving node is the next node
        				if (currentNode.next && currentNode.next.sample.id == node.sample.id) {
        					nextNode = currentNode;
        					prevNode = currentNode.prev;

        					currentNode.prev.next = node;
        					currentNode.prev = node;
        					currentNode.next = node.next;
        					node.next.prev = currentNode;

        					node.prev = prevNode;
            				node.next = nextNode;

        				}
        				else if (currentNode.next && backward) {
        					nextNode = currentNode.next;
        					prevNode = currentNode.prev;

        					var tempNext = node.next;
        					var tempPrev = node.prev;

        					//remove that node
        					if (tempNext != null)
        						tempNext.prev = tempPrev;

        					if (tempPrev != null) {
        						tempPrev.next = tempNext;
        					} else {
        						this.head = currentNode;
        					}

        					node.next = currentNode;
        					node.prev = prevNode;
        					prevNode.next = node;

        					currentNode.prev = node;

        				}

        				//If moving node is the prev node
        				else if (currentNode.prev && currentNode.prev.sample.id == node.sample.id) {
        					nextNode = currentNode.next;
        					prevNode = currentNode;

        					currentNode.prev = node.prev;
        					node.prev.next = currentNode;

        					currentNode.next = node;

        					node.prev = prevNode;
            				node.next = nextNode;
        				}
        				else if (currentNode.prev) {

        					nextNode = currentNode.next;
        					prevNode = currentNode.prev;

        					var tempNext = node.next;
        					var tempPrev = node.prev;

        					if (tempPrev)
        						tempPrev.next = tempNext;
        					else
        						this.head = tempNext;

        					if (tempNext != null) {
        						tempNext.prev = tempPrev;
        					} else {
        						this.tail = nextNode;
        					}

        					node.next = nextNode;
        					node.prev = currentNode;


        					if (nextNode != null)
        						nextNode.prev = node;

        					currentNode.next = node;
        				}

        				break;
        			}

        			currentNode = currentNode.next;
        		}
        	}

        	this.remove = function(index) {
        		var currentNode = this.head;
        		for (var i = 0; i < this.length; i++) {
        			if (i == index) {
        				var prevNode = currentNode.prev ? currentNode.prev : null;
        				var nextNode = currentNode.next ? currentNode.next : null;

        				if (prevNode != null) {
        					prevNode.next = nextNode;
        					if (index == this.length-1)
        						this.tail = prevNode;
        				}

        				if (nextNode != null) {
        					nextNode.prev = prevNode;
        					if (index == 0)
        						this.head = nextNode;
        				}

        				this.length--;

        				currentNode.sample.is_public = false;
        				currentNode.sample.previous_sample_id = null;
        				currentNode.sample.next_sample_id = null;

        				vm.nodesRemoved.push(currentNode.extractNodes());

        				break;
        			}

        			if (currentNode != null)
        				currentNode = currentNode.next;
        		}
        		this.resortSamples();

        	}

        	this.moveNodesUp = function(indices, iterations) {
        		//Swap the Nodes above node
        		var controller = this;

        		indices.forEach(function(index){
        			var node = controller.getNode(index);

        			if (node.prev != null) {
        				var prevNode = node.prev;
        				var nextNode = node.next;

        				prevNode.next = nextNode;

        				if (prevNode.prev) {
        					prevNode.prev.next = node;
        				} else {
        					controller.head = node;
        				}

        				node.prev = prevNode.prev;

        				prevNode.prev = node;


        				if (index < controller.length - 1)
        					nextNode.prev = prevNode;

        				node.next = prevNode;

        			} else if (index == 0 && !controller.outerSampleIDPrev) {
        				console.log('Can No Longer Move Up Further.');
        			} else if (index == 0) {
        				var newSampleItem = new LinkedListNode({id: controller.outerSampleIDPrev}, null, node.next);
        				var nextNode = node.next;
        				controller.setOuterSampleIDPrev(node.sample.id);

        				controller.head = newSampleItem;

        				if (nextNode)
        					nextNode.prev = controller.head;

        			}
        		});

        		this.resortSamples();
        		return;
        	}

        	this.moveNodesDown = function(indices, iterations) {
        		var controller = this;

        		//Swap the Nodes below node
        		indices.forEach(function(index){
        			var node = controller.getNode(index);

        			if (node.next != null) {
        				var prevNode = node.prev;
        				var nextNode = node.next;

        				if (nextNode.next == null)
        					controller.tail = node;
        				else
        					nextNode.next.prev = node;

        				node.next = nextNode.next;
        				nextNode.next = node

        				if (index > 0) {
	        				prevNode.next = nextNode;
	        				nextNode.prev = prevNode;
        				}
        				else {
        					nextNode.prev = null;
        					controller.head = nextNode;
        				}

        				node.prev = nextNode;

        			}
        			else if (index == controller.length - 1 && !controller.outerSampleIDNext) {
        				console.log('Can No Longer Move Down Further.')
        			}
        			else if (index == controller.length - 1){
        				var newSampleItem = new LinkedListNode({id: controller.outerSampleIDNext}, node.prev, null);
        				var prevNode = node.prev;

        				controller.setOuterSampleIDNext(node.sample.id);
        				controller.setTail(newSampleItem);
        				prevNode.next = controller.tail;


    				}
        		});

        		this.resortSamples();
        		return;
        	}

        	this.moveNode = function(fromIndex, toIndex) {
        		var node = this.getNode(fromIndex);
        		var backwards = false;

        		if (fromIndex == toIndex)
        			return

        		if(fromIndex > toIndex)
        			backwards = true;

        		if (toIndex == 0)
        			this.addToHead(node, false);
        		else
        			this.insert(node, toIndex, backwards);

        		this.resortSamples();

        	}

        	this.pop = function(){
        		this.tail = this.tail.prev;

        		this.tail.next = null;
        		this.length--;
        	}

        	this.resortSamples = function() {
        		var currentNode = this.head;

        		for (var i = 0; i < this.length; i++) {

        			if (i == 0) {
        				currentNode.sample.previous_sample_id = this.outerSampleIDPrev;
        				currentNode.sample.next_sample_id = currentNode.next ? currentNode.next.sample.id : this.outerSampleIDNext;
        			} else if (i == this.length-1) {
        				currentNode.sample.previous_sample_id = currentNode.prev ? currentNode.prev.sample.id : this.outerSampleIDPrev;
        				currentNode.sample.next_sample_id = this.outerSampleIDNext;
        			} else {
        				currentNode.sample.next_sample_id = currentNode.next.sample.id;
        				currentNode.sample.previous_sample_id = currentNode.prev.sample.id;
        			}

        			currentNode = currentNode.next;
        		}


        	}

        	this.returnLinkedListAsArray = function() {
        		var sampleList = [];

        		var currentNode = this.head;
        		sampleList.push(currentNode)

        		while (currentNode.next != null) {
        			currentNode = currentNode.next;
        			sampleList.push(currentNode)
        		}

        		return sampleList
        	}

        	this.returnLinkedListAsDict = function() {
        		var sampleDict = {};

        		var currentNode = this.head;
        		sampleDict[currentNode.sample.id] = currentNode;

        		while (currentNode.next != null) {
        			currentNode = currentNode.next;
        			sampleDict[currentNode.sample.id] = currentNode;
        		}

        		return sampleDict
        	}

        	this.returnLinkedListAsSampleArray = function() {
        		var sampleList = [];

        		var currentNode = this.head;

        		var i = 0;
        		while (currentNode != null && i < this.length) {
        			sampleList.push(currentNode.extractNodes());
        			currentNode = currentNode.next;

        			i++;
        		}

        		var boundaries = this.getOuterSamplesAsSamples();

        		if (boundaries.prevprev) {
        			sampleList.push(boundaries.prevprev)
        		}

        		if (boundaries.prev) {
        			sampleList.push(boundaries.prev)

        		}


        		if (boundaries.next)
        			sampleList.push(boundaries.next)

        		if (boundaries.nextnext)
        			sampleList.push(boundaries.nextnext)

        		return sampleList
        	}

        	this.getOuterSamplesAsSamples = function() {
        		var boundaries = null;

        		if (this.length == 0) { //In the case where we remove like everything.
        			boundaries = {};

        			if (this.outerSampleIDPrev) {
        				boundaries.prev = {id: this.outerSampleIDPrev, next_sample_id: this.outerSampleIDNext}
        			}

        			if (this.outerSampleIDNext) {
        				boundaries.next = {id: this.outerSampleIDNext, previous_sample_id: this.outerSampleIDPrev}
        			}
        		}
        		else {
        			boundaries = {};

        			if (this.outerSampleIDPrevPrev)
        				boundaries.prevprev = {id: this.outerSampleIDPrevPrev, next_sample_id: this.outerSampleIDPrev};

        			if (this.outerSampleIDPrev)
        				boundaries.prev = {id: this.outerSampleIDPrev, previous_sample_id: this.outerSampleIDPrevPrev, next_sample_id: this.head.sample.id};

        			if (this.outerSampleIDNext)
        				boundaries.next = {id: this.outerSampleIDNext, previous_sample_id: this.tail.sample.id, next_sample_id: this.outerSampleIDNextNext};

        			if (this.outerSampleIDNextNext)
        				boundaries.nextnext = {id: this.outerSampleIDNextNext, previous_sample_id: this.outerSampleIDNext};
        		}

        		return boundaries
        	}

        	this.returnLinkedListAsSampleDict = function() {
        		var sampleDict = {};

        		var currentNode = this.head;
        		sampleDict[currentNode.sample.id] = currentNode.sample;

        		while (currentNode.next != null) {
        			currentNode = currentNode.next;
        			sampleDict[currentNode.sample.id] = currentNode.sample;
        		}

        		return sampleDict
        	}

        }

        function mapGraphQLPublicViewSample(sample) {
            return {
                id: sample.id,
                name: sample.name,
                hash: sample.hash,
                picture: sample.pictureUrl || 'content/images/no_image_available-small.png',
                lotBatchNumber: sample.lotBatchNumber,
                is_public: true,
                previous_sample_id: sample.previousSampleId,
                next_sample_id: sample.nextSampleId,
                thc_percent: sample.thcPercent,
                cbd_percent: sample.cbdPercent,
                thc_mgpp: null,
                cbd_mgpp: null
            };
        }

        function setOuterBoundaries() {
            PublicView.getSampleBoundaries({
                prev_sample_id: vm.sampleLinkedList.outerSampleIDPrev,
                next_sample_id: vm.sampleLinkedList.outerSampleIDNext
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.sampleLinkedList.outerSampleIDPrevPrev = data.previous_sample;
                vm.sampleLinkedList.outerSampleIDNextNext = data.next_sample;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPublicViewBatchData() {
            if (!vm.samples || vm.samples.length === 0) {
                return;
            }

            var batchQuery = [
                'query GetPublicViewSamplesPotency($sampleIds: [Int!]!) {',
                '  publicViewSamplesPotencyBatch(sampleIds: $sampleIds) {',
                '    sampleId',
                '    thcMgpp',
                '    cbdMgpp',
                '  }',
                '}'
            ].join('\n');

            GraphQLService.query(batchQuery, {
                sampleIds: vm.samples.map(function(sample) { return sample.id; })
            }).then(function(data) {
                var payloadBySampleId = {};
                (data.publicViewSamplesPotencyBatch || []).forEach(function(payload) {
                    payloadBySampleId[payload.sampleId] = payload;
                });

                vm.samples.forEach(function(sample) {
                    var payload = payloadBySampleId[sample.id];
                    if (!payload) {
                        return;
                    }
                    sample.thc_mgpp = payload.thcMgpp;
                    sample.cbd_mgpp = payload.cbdMgpp;
                });
            }).catch(function(error) {
                console.error('GraphQL Error loading public-view potency batch:', error);
            });
        }

        function cancelDeferredPublicViewBatchLoad() {
            if (!deferredPublicViewBatchLoad) {
                return;
            }

            if (deferredPublicViewBatchLoad.type === 'timeout') {
                $timeout.cancel(deferredPublicViewBatchLoad.handle);
            } else if (deferredPublicViewBatchLoad.type === 'idle' && window.cancelIdleCallback) {
                window.cancelIdleCallback(deferredPublicViewBatchLoad.handle);
            }

            deferredPublicViewBatchLoad = null;
        }

        function schedulePublicViewBatchLoad() {
            cancelDeferredPublicViewBatchLoad();

            if (window.requestIdleCallback) {
                deferredPublicViewBatchLoad = {
                    type: 'idle',
                    handle: window.requestIdleCallback(function() {
                        deferredPublicViewBatchLoad = null;
                        loadPublicViewBatchData();
                    }, { timeout: 800 })
                };
                return;
            }

            deferredPublicViewBatchLoad = {
                type: 'timeout',
                handle: $timeout(function() {
                    deferredPublicViewBatchLoad = null;
                    loadPublicViewBatchData();
                }, 250, false)
            };
        }

        function loadAllWithGraphQL() {
            var listQuery = [
                'query GetPublicViewSamples($page: Int!, $size: Int!) {',
                '  publicViewSamplesList(page: $page, size: $size) {',
                '    samples {',
                '      id',
                '      name',
                '      hash',
                '      pictureUrl',
                '      lotBatchNumber',
                '      thcPercent',
                '      cbdPercent',
                '      previousSampleId',
                '      nextSampleId',
                '    }',
                '    totalCount',
                '  }',
                '}'
            ].join('\n');

            return GraphQLService.query(listQuery, {
                page: vm.page || pagingParams.page || 1,
                size: parseInt(vm.itemsPerPage) || 20
            }).then(function(data) {
                var response = data.publicViewSamplesList;
                vm.totalItems = response.totalCount;
                vm.queryCount = response.totalCount;
                vm.samples = (response.samples || []).map(mapGraphQLPublicViewSample);
                vm.sampleLinkedList = new SampleLinkedList();
                first_shuffel_edit = false;
                vm.samples.forEach(function(sample) {
                    if (sample.next_sample_id === null && sample.previous_sample_id === null) {
                        first_shuffel_edit = true;
                    }
                    vm.sampleLinkedList.pushSample(sample);
                });
                vm.page = pagingParams.page;
                vm.pagingParams = pagingParams;
                if (vm.samples.length) {
                    setOuterBoundaries();
                }
                schedulePublicViewBatchLoad();
                $('#sortable li').each(function() { $(this).show(); });
            });
        }

        function handlePublicViewGraphQLError(error) {
            console.error('GraphQL Error loading public-view samples:', error);
            AlertService.error('Unable to load public gallery samples right now.');
        }

        function loadAll () {
            loadAllWithGraphQL().catch(handlePublicViewGraphQLError);
        }

        vm.hash = 0;
	    function getCustomerData () {
	        CustomerByUser.get({}, onSuccess, onError);
	        function onSuccess(data, headers) {
				vm.customerData = data;
				vm.hash = vm.customerData.hash

				var type_of_business = data.businessType.name.toLowerCase();

				if (type_of_business.includes('food')) {
					vm.customerData.consolidated_business_type = 'food';
				}
				else {
					vm.customerData.consolidated_business_type = 'cannabis';
				}

				$("#copyEmbedLink").prop("value", "<iframe src='"+ window.location.origin +"/#/companypage?hash=" + vm.hash + "' style='height: 800px; width: 1000px'></iframe>" )
				vm.publicSampleCriteria = vm.customerData.public_sample_criteria ? JSON.parse(vm.customerData.public_sample_criteria) : null;
				//Select2 Selector for Criteria
				$('#category').select2({
				tags: true,
				placeholder: "Select Type",
				});

				generateQRCode()
	        }
	        function onError(error) {

	        }
	    }

	    vm.resetCriteria = function() {
	    	if (vm.publicSampleCriteria) {
		       	 $('#category').val(vm.publicSampleCriteria.category).change();
		    	 $('#ALL').prop("checked", vm.publicSampleCriteria.order_type == "ALL");
		    	 $('#RD').prop("checked", vm.publicSampleCriteria.order_type == "RD");
		    	 $('#COMPLIANCE').prop("checked", vm.publicSampleCriteria.order_type == "COMPLIANCE");
		    	 $('#THC_LOW').val(vm.publicSampleCriteria.thc_low);
		    	 $('#THC_HIGH').val(vm.publicSampleCriteria.thc_high);
		    	 $('#CBD_LOW').val(vm.publicSampleCriteria.cbd_low);
		    	 $('#CBD_HIGH').val(vm.publicSampleCriteria.cbd_high);
		    	 $('#sampleStatusPass').prop("checked", vm.publicSampleCriteria.status.indexOf("PASS") != -1);
		    	 $('#sampleStatusFail').prop("checked", vm.publicSampleCriteria.status.indexOf("FAIL") != -1);
		    	 $('#sampleStatusUndetermined').prop("checked", vm.publicSampleCriteria.status.indexOf("UNDETERMINED") != -1);
		    	 $('#sampleDateRange').val(vm.publicSampleCriteria.date_range);
            } else {
            	$('#COMPLIANCE').prop("checked", true);
            	$('#sampleStatusPass').prop("checked", true);
            }
	    }

	    getCustomerData();

        vm.copyLink = function(id) {
      	  /* Get the text field */
      	  var copyText = document.getElementById(id);
      	  /* Select the text field */
      	  copyText.select();
      	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      	  /* Copy the text inside the text field */
      	  document.execCommand("copy");
        }

        vm.getEmbedLink = function() {
        	return window.location.origin + '/#/companypage?hash=' + vm.hash
		}
		function generateQRCode() {
			QRCode.generate({text: vm.getEmbedLink()},
				function(data) {
					vm.shareQRCode = data.qr_code;
				},
				function(e) {
					console.log(e)
				}
			);
		}


       loadAll();
       vm.startIndex = 0;
       vm.endIndex = 0;

       vm.searchedSamplesLength = 0;
       vm.productCategories = ProductCategory.query();

       vm.searchResultsState = "INITIAL";

       vm.searchSamples = function(form){
    	   var inputs = $(form).serializeArray()
    	   var params = {visibility: 'PRIVATE'};

    	   inputs.forEach(function(item, index) {
    		   params[item.name] = item.value;
    	   });

           SampleFilter.query(params, onSuccess, onError);
           function onSuccess(result, headers) {
               vm.searchedSamples = result;
               vm.searchedSamplesLength = headers('X-Total-Count');

               if (vm.searchedSamplesLength > 0)
            	   vm.searchResultsState = "FOUND";
               else
            	   vm.searchResultsState = "NONE";

           }
           function onError(error) {
           	console.log("Error applying filter");
           	console.log(error);
           }

       }

       vm.addSamples = function() {
    	   var checkedSamples = $(':checkbox.selectedSearchSample:checked');
    	   var idsToAdd = []
    	   checkedSamples.each(function() {
    		   var sample = JSON.parse($(this).attr('sample'));
    		   idsToAdd.push(sample.id);
    	   });

    	   PublicView.addSamples({sample_ids: idsToAdd},onSuccess, onError)

    	   function onSuccess(result, headers) {
    		   loadAll();
    		   $('#addSamplesModal').modal('hide');

           }

           function onError(error) {
           	console.log(error);
           }
       }

       vm.clearAddSampleForm = function(form) {
    	   vm.searchResultsState = "INITIAL";
    	   vm.searchedSamples = null;
           vm.searchedSamplesLength = 0;
           $(form)[0].reset();
       }

       $('#addSamplesModal').on('hide.bs.modal', function() {
          //clear out all of the forms.
    	   vm.clearAddSampleForm('#searchSamplesForm');
    	   vm.searchResultsState = "INITIAL";
       });

       vm.selectAllSearchedSamplesToggle = function() {
    	   if ($('#selectAllSearchedSamples').prop('checked')) {
    		   $(':checkbox.selectedSearchSample').prop('checked',true);
    	   } else
    		   $(':checkbox.selectedSearchSample').prop('checked',false);
	   }

	   vm.selectAllPublicViewToggle = function() {
		if ($('#selectAllPubicView').prop('checked')) {
			$(':checkbox.public-view-item-checkbox').prop('checked',true);
		} else
			$(':checkbox.public-view-item-checkbox').prop('checked',false);
	}



       vm.setCriteria = function() {
    	   var criteriaObject = {
    		category: $('#category').val(),
    		order_type: $('input:radio[name="criteriaOrderType"]:checked').val(),
    		status: [],
    		date_range: $('#sampleDateRange').val(),
    		thc_low: $('#THC_LOW').val(),
    		thc_high: $('#THC_HIGH').val(),
    		cbd_low: $('#CBD_LOW').val(),
    		cbd_high: $('#CBD_HIGH').val()
    	   }

    	   if ($('#sampleStatusPass').prop("checked"))
    		   criteriaObject.status.push('PASS');

    	   if ($('#sampleStatusFail').prop("checked"))
    		   criteriaObject.status.push('FAIL');

    	   if ($('#sampleStatusUndetermined').prop("checked"))
    		   criteriaObject.status.push('UNDETERMINED');

    	   PublicView.setCriteria({criteria: criteriaObject},onSuccess, onError);

    	   function onSuccess(result, headers) {
    		   $('#setCriteriaModal').modal('hide');
    		   vm.publicSampleCriteria = result;
           }

           function onError(error) {
        	   console.log(error);
           }

       }

       $('#setCriteriaModal').on('show.bs.modal', function() {
    	  vm.resetCriteria();
       });

       $('#sortable').sortable({
            start: function(event, ui) {
                vm.startIndex = ui.item.index();
            },
            stop: function(event, ui) {
                if (!vm.sampleLinkedList) {
                    return;
                }

                vm.endIndex = ui.item.index();
                vm.sampleLinkedList.moveNode(vm.startIndex, vm.endIndex);

                var samples = vm.sampleLinkedList.returnLinkedListAsSampleArray();
                vm.saveSampleStates(samples, vm.nodesRemoved, true);
            }
       });

		vm.saveSampleStates = function (samples, remove_samples, reload) {
			samples = samples || [];
			remove_samples = remove_samples || [];

			samples.forEach(function(sample) {
				if (sample.previous_sample_id !== null && sample.next_sample_id !== null) {
					first_shuffel_edit = false;
				}
				sample.first_shuffel = first_shuffel_edit;
			});

			PublicView.saveSamples({samples: samples, remove_samples: remove_samples}, onSuccess, onError);

			function onSuccess(result, headers) {
				vm.nodesRemoved = [];
				if (reload) {
					if (vm.sampleLinkedList && vm.sampleLinkedList.length == 0 && vm.page > 1 && !vm.sampleLinkedList.outerSampleIDNext) {
						vm.page--;
						vm.transition();
						return;
					}
					loadAll();
				}
			}

			function onError(error) {
				console.log(error);
			}
		}

		vm.confirmRemove = function(element){
			var text = '';
			$('#confirmRemoveSampleModal').modal('show');

			if (element) {
				$('#confirmRemoveTitle').html($translate.instant("Remove Sample?"))
				$('#confirmRemoveMessage').html($translate.instant("Remove sample from Public Gallery? You can't undo this."))
			} else {
				$('#confirmRemoveTitle').html(""+$translate.instant("Remove Samples?"));
				$('#confirmRemoveMessage').html($translate.instant("Remove samples from Public Gallery? You can't undo this."));
			}

			$('#confirmRemoveSampleButton').on('click', function() {
				(element) ? vm.removeItem(element) : vm.removeMultipleItems();
			});
		   }


		vm.removeMultipleItems = function() {
			var indices = [];
			var idsToRemove = [];

			$('.public-view-item-checkbox:checked').each(function() {
				$(this).prop('checked',false);
				indices.push($(this).closest('li').index());
			});

			$('.public-view-item-checkbox').prop('checked', false);

			if (!indices.length || !vm.sampleLinkedList) {
				return;
			}

			indices.forEach(function(value, index) {
				vm.sampleLinkedList.remove(value - index);
			});

			vm.nodesRemoved.forEach(function(sample) {
				idsToRemove.push(sample.id);
			});

			vm.samples = vm.samples.filter(function(sample) {
				return idsToRemove.indexOf(sample.id) === -1;
			});
			vm.totalItems = Math.max((vm.totalItems || 0) - vm.nodesRemoved.length, 0);
			vm.queryCount = vm.totalItems;

			var samples = vm.sampleLinkedList.returnLinkedListAsSampleArray();
			vm.saveSampleStates(samples, vm.nodesRemoved, true);
		}

		vm.removeItem = function(element) {
			var item = $(element.currentTarget).parent().closest('li');
			var index = item.index();
			if (!vm.sampleLinkedList) {
				return;
			}

			vm.sampleLinkedList.remove(index);
			var idsToRemove = [];
			vm.nodesRemoved.forEach(function(sample) {
				idsToRemove.push(sample.id);
			});

			vm.samples = vm.samples.filter(function(candidate) {
				return idsToRemove.indexOf(candidate.id) === -1;
			});
			vm.totalItems = Math.max((vm.totalItems || 0) - 1, 0);
			vm.queryCount = vm.totalItems;
			$(item).hide();

			var samples = vm.sampleLinkedList.returnLinkedListAsSampleArray();
			vm.saveSampleStates(samples, vm.nodesRemoved, true);
		}

		$('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

		$('#testtaginput').tagsinput('input')[0].type = 'email'

       vm.emailsPending = [""];
       vm.emailMessage = "";

       vm.sendEmail = function (form) {
       	vm.emailsPending = $('#testtaginput').tagsinput('items')
       	vm.emailSubject = $('#emailSubject').val();
       	//Send The Email
       	if (form.$valid && vm.emailsPending.length > 0){
       		$('#sendPublicSampleButton').attr("disabled", true);
       		PublicView.sendEmail({
       			emails: vm.emailsPending,
       			message: vm.emailMessage,
       			public_link: vm.getEmbedLink(),
       			subject: vm.emailSubject,
       			customer_hash: vm.customerData.hash
       		}, onSuccess, onError);
       	}
       	else {
       		if (vm.emailsPending.length == 0)
       			$('#emailValidation').show();
       		return
       	}
       	function onSuccess(data, headers) {
       		$('#emailModal').modal('hide');
       		$('#emailModalSuccess').modal('show');
       		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
       }

       $('#emailModalSuccess').on('hidden.bs.modal', function() {
	       	$('#testtaginput').tagsinput('removeAll');
	       	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
	   });

    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('PublicView', PublicView);

    PublicView.$inject = ['$resource'];

    function PublicView ($resource) {

        return $resource('api/publicview/:id', {id: '@id', public: '@public', emails: '@emails', samples: '@samples', sample_ids: '@sample_ids', prev_sample_id: '@prev_sample_id', next_sample_id: '@next_sample_id', remove_samples: '@remove_samples', criteria: '@criteria', customer_hash: '@customer_hash'}, {
            query: { method: 'GET', isArray: true },
            get: {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            public: {
                url: 'api/publicview/',
                method: 'PUT'
            },
            saveSamples: {
            	url: 'api/publicview/save_samples',
            	method: 'PUT',
            	data: {samples: '@samples', remove_samples: '@remove_samples'}, 
            	isArray: true 
            },
            addSamples: {
            	url: 'api/publicview/add_samples',
            	method: 'PUT',
            	data: {sample_ids: '@sample_ids'}, 
            },
            setCriteria: {
            	url: 'api/publicview/set_criteria',
            	method: 'PUT',
            	data: {criteria: '@criteria'}, 
            },
            getSampleBoundaries: {
            	url: 'api/publicview/sample_boundaries',
            	method: 'GET',
            	data: {prev_sample_id: '@prev_sample_id', next_sample_id: '@next_sample_id'}, 
            },
            sendEmail: {
            	url: 'api/publicview/email',
            	method: 'PUT',
            	params: {emails: '@emails', message: '@message', public_link: '@public_link', subject: '@subject', customer_hash: '@customer_hash'}
            }
        });

    }

})();

(function() {
    'use strict';
    /* TODO: Clean all this because unnecessary page params */
    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('publicviewlog', {
            parent: 'entity',
            url: '/publicviewlog?page&sort&search&productCategoryId&items&id&orderId&sampleName&lotNumber&metrcId&categoryIdList&orderType&thcLower&thcUpper&cbdLower&cbdUpper&isPass&isFail&isUndetermined&isWeedmapsSuccess&isWeedmapsFail' +
            	'&isWeedmapsNone&visibility&completeDateLower&completeDateUpper&estimatedDueDateLower&estimatedDueDateUpper&galleryView&starred',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Public Gallery'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/public-view/publicviewlog.html',
                    controller: 'PublicViewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,

                productCategoryId: {
                    value: '0',
                    squash: true
                },
                items: null,
                /* Filter params */
        		id: null,
        		orderId: null,
        		sampleName: null,
        		lotNumber: null,
        		metrcId: null,
        		categoryIdList: null,
        		category: null,
        		subCategory: null,
        		orderType: null,
        		thcLower: null,
        		thcUpper: null,
        		cbdLower: null,
        		cbdUpper: null,
        		isPass: null,
        		isFail: null,
        		isUndetermined: null,
        		isWeedmapsSuccess: null,
        		isWeedmapsFail: null,
        		isWeedmapsNone: null,
        		visibility: null,
        		completeDateLower: null,
        		completeDateUpper: null,
        		estimatedDueDateLower: null,
        		estimatedDueDateUpper: null,
        		galleryView: null,
        		starred:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {

                    return {
                    	/* Paging Params */
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        items: $stateParams.items,
                        /* Filter Params */
                        id: $stateParams.id ? parseInt($stateParams.id) : null,
                        orderId: $stateParams.orderId ? parseInt($stateParams.orderId) : null,
                        sampleName: $stateParams.sampleName,
                        lotNumber: $stateParams.lotNumber,
                        metrcId: $stateParams.metrcId,
                        categoryIdList: $stateParams.categoryIdList,
                        category: $stateParams.category,
                        subCategory: $stateParams.subCategory,
                        orderType: $stateParams.orderType,
                        thcLower: $stateParams.thcLower ? parseInt($stateParams.thcLower) : null,
                        thcUpper: $stateParams.thcUpper ? parseInt($stateParams.thcUpper) : null,
                        cbdLower: $stateParams.cbdLower ? parseInt($stateParams.cbdLower) : null,
                        cbdUpper: $stateParams.cbdUpper ? parseInt($stateParams.cbdUpper) : null,
                        isPass: $stateParams.isPass,
                        isFail: $stateParams.isFail,
                        isUndetermined: $stateParams.isUndetermined,
                        isWeedmapsSuccess: $stateParams.isWeedmapsSuccess,
                        isWeedmapsFail: $stateParams.isWeedmapsFail,
                        isWeedmapsNone: $stateParams.isWeedmapsNone,
                        visibility: $stateParams.visibility,
                        completeDateLower: $stateParams.completeDateLower,
                        completeDateUpper: $stateParams.completeDateUpper,
                        estimatedDueDateLower: $stateParams.estimatedDueDateLower,
                        estimatedDueDateUpper: $stateParams.estimatedDueDateUpper,
                        galleryView: $stateParams.galleryView,
                        starred: $stateParams.starred
                    }
                }],
            }
        })
    }


})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('InvoiceLogController', InvoiceLogController);

     InvoiceLogController.$inject = ['$state', '$stateParams','$scope','$rootScope', '$http','CustomerOrder','CustomerOrderSearch',
    'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','Auth', 'Principal', 'ProfileService',
    'LoginService','CustomerByUser', 'Invoice', 'InvoiceAttachDownload', 'STAGE', 'SquareService',
    'SweetAlert', 'CustomerSquare', 'Payment', 'PaymentById', 'DateUtils', 'Customer', 'PaymentReceipt', 'Config', 'Contact2ForUser', 'DownloadUtil'];

    function InvoiceLogController($state, $stateParams, $scope,$rootScope, $http, CustomerOrder,CustomerOrderSearch, ParseLinks,
                              AlertService, paginationConstants, pagingParams, Auth, Principal, ProfileService,
                              LoginService,CustomerByUser, Invoice, InvoiceAttachDownload, STAGE, SquareService,
                              SweetAlert, CustomerSquare, Payment, PaymentById, DateUtils, Customer, PaymentReceipt, Config, Contact2ForUser, DownloadUtil) { /*,Auth, Principal, ProfileService, LoginService*/

        var vm = this;
        var square = {};

        Contact2ForUser.get({}, function(res){
        	vm.customers = [];
        	if (res) {
                vm.contact = res;
                if(vm.contact.first_name) {
                    vm.contact.first_name_letter = vm.contact.first_name[0].toUpperCase()
                }
                if(vm.contact.last_name) {
                    vm.contact.last_name_letter = vm.contact.last_name[0].toUpperCase()
                }

                console.log(vm.contact)
        	}
        });

        function dollarsToCents(amount) {
            return Math.round((Number(amount) + Number.EPSILON) * 100);
          }

        function appendSquareAPI() {
            Config.generic({data: 'STAGE'},
                function(data) {
                    var script = document.createElement('script');
                    var square_url = null;

                    if(data.data == 'dev') {
                        square_url = 'https://sandbox.web.squarecdn.com/v1/square.js';
                    }
                    else {
                        square_url = 'https://web.squarecdn.com/v1/square.js';
                    }

                    script.type = 'text\/javascript';
                    script.src = square_url;
                    script.id = 'square-api'
                    $("head").append(script)
                    setTimeout(function() {
                        createSquarePaymentForm();
                    }, 2000);
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        const squareCardInputStyles = {
            '.input-container': {
                borderColor: '#e6ebf0',
                borderRadius: '4px',
              },
              '.input-container.is-focus': {
                borderColor: '#e6ebf0'
              },
              'input::placeholder': {
                color: '#c1c5c9'
              },
              input: {
                color: '#3d5269'
              }
        }

        function createSquarePaymentForm() {
            // Initialize the Payments API client
            vm.payment.api = Square.payments(vm.payment.squareAppId, vm.payment.squareLocationId);
          
            console.log(vm.payment)
            // ----------------------
            //     CARD SETUP
            // ----------------------
            vm.payment.api.card({ style: squareCardInputStyles })
              .then(function(cardData) {
                square.card = cardData;
          
                // Attach the card to the DOM
                square.card.attach('#card-container').then(function() {
                  square.cardButton = document.getElementById('card-button');
                  square.cardButton.addEventListener('click', cardEventHandler);
                  square.cardButton.disabled = false;
                });
              });
          
            // ----------------------
            //     ACH SETUP
            // ----------------------
            var achButton = document.getElementById('ach-button');
            vm.payment.api.ach({ redirectURI: window.location.href })
              .then(function(achData) {
                vm.ach = achData;
          
                // Attach the 'ontokenization' event listener BEFORE calling tokenize
                vm.ach.addEventListener('ontokenization', function(event) {
                  var tokenResult = event.detail.tokenResult;
                  var error = event.detail.error;
          
                  if (error) {
                    // Handle error on tokenize
                    square.cardButton.disabled = false;
                    achButton.disabled = false;
                    vm.payment_processing = false;
                    vm.payment.processSquareRequestErrors('There was an issue connecting with your bank.', [error]);
                  } else if (tokenResult && tokenResult.status === 'OK') {
                    // If successfully tokenized, store the info and initiate ACH payment
                    console.log('Got ACH payment token:', tokenResult.token);
                    try {
                      vm.payment.ach_info = tokenResult;
                      vm.initiatePayment('ach');
                    } catch (e) {
                      square.cardButton.disabled = false;
                      achButton.disabled = false;
                      console.error(e);
                    }
                  }
                });
          
                // Hook up the ACH button AFTER adding the event listener
                achButton.addEventListener('click', achEventHandler);
              });
          
            // ----------------------
            //     CARD HANDLER
            // ----------------------
            function cardEventHandler(event) {
              event.preventDefault();
              resetPaymentForm(); // optional reset if you have such a function
          
              try {
                // Disable the button to avoid duplicate submissions
                square.cardButton.disabled = true;
          
                // Tokenize the card
                square.card.tokenize().then(function(data) {
                  if (data.status === 'OK') {
                    // If successfully tokenized, save the card
                    vm.saveCard(data.token, vm.customerData.company_name, true);
                  } else if (data.errors) {
                    console.log(data);
                    delete vm.payment.api;
                    vm.payment.processSquareRequestErrors('There was an issue saving your card.', data.errors);
                  }
                }).finally(function() {
                  // Re-enable the card button at the end
                  square.cardButton.disabled = false;
                });
              } catch (e) {
                console.error(e);
                vm.payment.processSquareRequestErrors('There was an issue saving your card.', e);
              }
            }
          
            // ----------------------
            //     ACH HANDLER
            // ----------------------
            function achEventHandler(event) {
              event.preventDefault();
              vm.payment_processing = true;
              console.log('calling tokenize for ACH');
              if (!vm.payment.amount) {
                  vm.payment.amount = vm.open_invoices.total_balance;
                }
                
              console.log(vm.payment.amount)
              // Disable the button to avoid duplicate submissions
              square.cardButton.disabled = true;
              achButton.disabled = true;
          
              // Build the ACH options
              var achOptions = getACHOptions();
          
              // We do not process success/failure directly here;
              // the 'ontokenization' event listener handles the result.
              vm.ach.tokenize(achOptions).catch(function(e) {
                // Catch unexpected errors during tokenize
                square.cardButton.disabled = false;
                achButton.disabled = false;
                vm.payment_processing = false;
                console.error(e);
                vm.payment.processSquareRequestErrors('There was an issue connecting with your bank.', e);
              });
            }
          
            // ----------------------
            //  HELPER: ACH OPTIONS
            // ----------------------
            function getACHOptions() {
              return {
                accountHolderName: vm.contact.first_name + ' ' + vm.contact.last_name,
                intent: 'CHARGE',
                total: {
                  amount: dollarsToCents(vm.payment.amount),
                  currencyCode: 'USD'
                }
              };
            }
          }
                    
        const resetPaymentForm = () => {
            const card_form = document.getElementsByClassName('sq-card-wrapper');

            if(card_form.length) {
                const cardButton = document.getElementById('card-button')
                cardButton.replaceWith(cardButton.cloneNode(true));
                card_form[0].remove();
                createSquarePaymentForm();
            }
        }

        SquareService.params({},
            function(data) {
                vm.payment.squareAppId = data.square_application_id;
                vm.payment.squareLocationId = data.square_location_id;
                appendSquareAPI()
            },
            function(e) {
                console.log(e)
            }
        );


        vm.downloadSelectedPaymentReceipts = function() {
            var payment_list = [];
            vm.payment_history.payments.forEach( function(payment) {
                if(payment.checked) {
                    payment_list.push(payment.id);
                }
            });

            PaymentReceipt.merged({payments: payment_list, order: determineOrder(vm.payment_history)},
                function (data, headers) {
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = 'Payments.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function (e) {
                    AlertService.error("Could not print payments");
                }
            );
        }

        vm.downloadPaymentReceipt = function(id) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            PaymentReceipt.get({id: id},
                function(data){
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = 'Payment_Receipt_' + id + '.pdf';
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function(e) {
                    console.log(e)
                }
            );
        }

        vm.downloadOpenBalance = function() {
            Invoice.openBalance({customer_id:  vm.customerData.id},
                function (data, headers) {
                    var filename = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");

                    document.body.appendChild(a);
                    a.download = filename;
                    a.href = url;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function (e) {
                    AlertService.error("Could not print payments.");
                }
            );
        }

        vm.printSelectedPaymentReceipts = function() {
            var payment_list = [];
            vm.payment_history.payments.forEach( function(payment) {
                if(payment.checked) {
                    payment_list.push(payment.id);
                }
            });

            PaymentReceipt.merged({payments: payment_list, order: determineOrder(vm.payment_history)},
                function (data, headers) {
                    if (data.data.byteLength == 0){
                        return;
                    }
                    var url = URL.createObjectURL(data.data);

                    setTimeout(function() {
                        window.open(url, '_blank');
                    }, 200);

                },
                function (e) {
                    AlertService.error("Could not print payments");
                }
            );
        }

        vm.printPaymentReceipt = function(id) {
            PaymentReceipt.merged({payments: [id], order: determineOrder(vm.payment_history)},
                function (data, headers) {
                    if (data.data.byteLength == 0){
                        return;
                    }
                    var url = URL.createObjectURL(data.data);

                    setTimeout(function() {
                        window.open(url, '_blank');
                    }, 200);

                },
                function (e) {
                    AlertService.error("Could not print payments");
                }
            );
        }

        vm.payment = {
            cardHolder: null,
            selectedCard: null,
            amount: null,
            cards: null,
            squareAppId: null,
            primary_card: null,
            pay_selected_total: 0,
            emails: null,
            id: null
        }

        vm.autopay_checked = null;
        vm.autopay_by_date = null;
        vm.show_all_tabs = true;
        vm.activeSnackbar = false;
        vm.make_primary_payment_method = true;
        vm.payment_processing = false;
        vm.autopay_processing = false;
        vm.autopay_by_date_processing = false;
        vm.new_card_autopay_checkbox = false;

        vm.generic = {};
        var generic = {};

        vm.payment_methods = {};

        function determineOrder(tabDict) {
            if(tabDict.sort_filters.filter == 'id') {
                return tabDict.sort_filters.order
            }
            else {
                return tabDict.default_sort.order
            }
        }
        function removeModal(params) {
            if(document.getElementById("plaid-link-iframe-1") && document.getElementById("plaid-link-iframe-1").style.display === "block"){
                $('#infoModal').modal('hide');
            }
        }
        vm.open_invoices = {
            table: 'open_invoices',
            loading: false,
            total_balance: 0,
            total_items: 0,
            page_plus_one: 1,
            invoices: [],
            invoices_to_pay: [],
            all_invoices_checked: false,
            open_filters: false,
            date_picker: {
                invoice_date_lower: null,
                invoice_date_upper: null,
                due_date_lower: null,
                due_date_upper: null,
            },
            filters: {
                amount_lower: null,
                amount_upper: null,
                balance_lower: null,
                balance_upper: null,
                invoice_date_lower: null,
                invoice_date_upper: null,
                due_date_lower: null,
                due_date_upper: null,
            },
            base_filters: {
                size: 20,
                paid: false,
                status: ['APPROVED', 'INVOICED', 'PREPAYMENT', 'PRELIMINARY'],
                balance_lower: 0,
                amount_lower: 0
            },
            sort_filters: {
                field: null,
                order: 'desc'
            },
            default_sort: {
                field: 'invoice_date',
                order: 'desc'
            }
        };

        vm.payment_history = {
            table: 'payment_history',
            loading: false,
            total_items: 0,
            page_plus_one: 1,
            payments: [],
            all_payments_checked: false,
            any_payments_checked: false,
            open_filters: false,
            date_picker: {
                invoice_date_lower: null,
                invoice_date_upper: null,
                due_date_lower: null,
                due_date_upper: null,
                date_paid_lower: null,
                date_paid_upper: null
            },
            filters: {
                payment_amount_lower: null,
                payment_amount_upper: null,
                payment_date_lower: null,
                payment_date_upper: null,
            },
            base_filters: {
                size: 20,
            },
            sort_filters: {
                field: null,
                order: 'desc'
            },
            default_sort: {
                field: 'id',
                order: 'desc'
            }
        }

        vm.closed_invoices = {
            table: 'closed_invoices',
            loading: false,
            total_items: 0,
            page_plus_one: 1,
            invoices: [],
            all_invoices_checked: false,
            any_invoices_checked: false,
            open_filters: false,
            date_picker: {
                invoice_date_lower: null,
                invoice_date_upper: null,
                due_date_lower: null,
                due_date_upper: null,
                date_paid_lower: null,
                date_paid_upper: null
            },
            filters: {
                amount_lower: null,
                amount_upper: null,
                invoice_date_lower: null,
                invoice_date_upper: null,
                due_date_lower: null,
                due_date_upper: null,
                date_paid_lower: null,
                date_paid_upper: null,
            },
            base_filters: {
                size: 20,
                paid: true,
                status: ['INVOICED', 'APPROVED', 'PREPAYMENT', 'PRELIMINARY'],
            },
            sort_filters: {
                field: null,
                order: 'desc'
            },
            default_sort: {
                field: 'invoice_date',
                order: 'desc'
            }
        };

        vm.generic.changeSort = function(tabDict, field) {
            if(tabDict.sort_filters.field == field) {
                if(tabDict.sort_filters.order == 'asc') {
                    tabDict.sort_filters.order = 'desc';
                }
                else if(tabDict.sort_filters.order == 'desc'){
                    tabDict.sort_filters.order = 'asc';
                };
            }
            else {
                tabDict.sort_filters.order = 'desc';
            }

            tabDict.sort_filters.field = field;

            if(tabDict.table == 'payment_history') {
                vm.payment_history.query(false);
            }
            else {
                vm.generic.query(tabDict, false);
            }
        }

        generic.bundleFilters = function(tabDict) {
            var filters = {};

            // if(tabDict.table.includes('invoices')) {
            //     filters['only_return_invoices'] = true;
            // }

            if(tabDict.sort_filters.field == null) {
                filters['sort'] = tabDict.default_sort.field + ',' + tabDict.default_sort.order;
            }
            else {
                filters['sort'] = tabDict.sort_filters.field + ',' + tabDict.sort_filters.order;
            }

            if(tabDict.filters) {
                angular.forEach(tabDict.filters, function(value, key) {
                    filters[key] = value;
                });
            }

            angular.forEach(tabDict.filters, function(value, key) {
                filters[key] = value;
            });

            angular.forEach(tabDict.base_filters, function(value, key) {
                filters[key] = value;
            });

            filters['page'] = tabDict.page_plus_one - 1;

            filters['size'] = parseInt(filters['size'])

            return filters
        }

        function processInvoices(invoices) {
            var processed_invoices = []
            processed_invoices = setInvoicesStatus(invoices);

            return processed_invoices;
        }


        vm.payment_history.checkedInvoices = function() {
            for( var i = 0; i < vm.payment_history.payments.length; i++) {
                    if(vm.payment_history.payments[i].checked) {
                        vm.payment_history.any_invoices_checked = true;
                        return;
                    }
            }
            vm.payment_history.any_invoices_checked = false;
        }

        vm.payment_history.checkAll = function() {
            vm.payment_history.any_invoices_checked = vm.payment_history.all_payments_checked;
            vm.payment_history.payments.forEach( function(payment) {
                payment.checked = vm.payment_history.all_payments_checked;
            });
        }

        vm.payment_history.query = function(query) {
            if(query) {
                vm.payment_history.page_plus_one = 1
            }
            Payment.filter(generic.bundleFilters(vm.payment_history),
                function(data, headers) {
                    vm.payment_history.payments = data.data;
                    vm.payment_history.total_items = data.total_count;
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        vm.payment_history.clearFilters = function() {
            angular.forEach(vm.payment_history.filters, function(value, key) {
                vm.payment_history.filters[key] = null;
            });
           vm.payment_history.query(true);
        }

        vm.generic.clearFilters = function(tabDict) {
            angular.forEach(tabDict.filters, function(value, key) {
                tabDict.filters[key] = null;
            });
           vm.generic.query(tabDict, true);
        }

        vm.generic.query = function(tabDict, query) {
            if(query) {
                tabDict.page_plus_one = 1
            }
            tabDict.loading = true;

            Invoice.filter(generic.bundleFilters(tabDict),
                function(data, headers) {
                    tabDict.invoices = processInvoices(data);
                    tabDict.total_items = headers('X-Total-Count');

                    if("total_balance" in tabDict) {
                        getUnpaidInvoices();
                    }
                    tabDict.loading = false;
                },
                function(e) {
                    console.log(e);
                    tabDict.loading = false;
                }
            );

        }

        vm.activeTab = {
            open_invoices: true,
            closed_invoices: false,
            payment_methods: false,
            payment_history: false,
        }


        function achPaymentPopup() {
            SweetAlert.swal({
                title: 'Payment processed successfully.',
                text: 'Thank you for your payment. It will be in the \'Payment History\' subtab of the portal when it clears, typically in 3-5 business days.',
                type: 'success',
                confirmButtonColor: '#4f8fcc',
                confirmButtonText: 'Ok',
                closeOnConfirm: true
            },
            function(confirm) {
                queryAll();
            });
            $('#infoModal').modal('hide');
            vm.open_invoices.invoices_to_pay = [];
            vm.payment.pay_selected_total = 0;
            vm.emails = null;
            vm.payment.id = null;
            vm.payment_processing = false;
            vm.open_invoices.all_invoices_checked = false;
        }


        function updateInvoices(square_payment_id) {
            Payment.createAchPayment({
                    total: vm.payment.amount,
                    square_payment_id: square_payment_id,
                    invoices: vm.open_invoices.invoices_to_pay_array
                },
                function() {
                    achPaymentPopup();
                },
                function(e) {
                    console.log(e)
                    vm.payment.receipt_number = null;
                    vm.payment_processing = false;
                }
            );
        }


        function applyQBenchPayment(square_payment_id) {
            Payment.createPayment({
                payment_dict: {
                    amount: vm.payment.amount,
                    payment_type_id: 34,
                },
                invoices_dict : {
                    invoice_payments:  vm.open_invoices.invoices_to_pay_array
                },
                params: {
                    square_payment_id: square_payment_id,
                    card_info: vm.payment.primary_card_info
                },
            }, applyPaymentsInBatchSuccess, applyPaymentsInBatchFail);
        }

        function createInvoicesToPayArray() {
            var invoice_payments = [];
            console.log(vm.open_invoices.total_balance);
            if(vm.open_invoices.invoices_to_pay.length > 0) {
                vm.open_invoices.invoices_to_pay.forEach( function(invoice) {
                    if(!hasPendingAch(invoice)) {
                        invoice_payments.push({
                            invoice_id: invoice.id,
                            applied_amount: invoice.outstanding_amount
                        });
                    }
                });
                vm.emails = vm.open_invoices.invoices_to_pay[0].email_to
                vm.payment.amount = vm.payment.pay_selected_total;
            }
            else {
                vm.open_invoices.unpaid_invoices.forEach( function(invoice) {
                    if(!hasPendingAch(invoice)) {
                        invoice_payments.push({
                            invoice_id: invoice.id,
                            applied_amount: invoice.outstanding_amount
                        });
                    }
                });
                vm.emails = vm.open_invoices.unpaid_invoices[0].email_to;
                vm.payment.amount = vm.open_invoices.total_balance;
            }
            
            console.log(vm.payment);
            console.log(vm.payment);
            vm.open_invoices.invoices_to_pay_array = invoice_payments;
        }

        vm.addCheckedInvoices = function() {
            var total = 0;

            vm.payment.pay_selected_total = 0;
            vm.open_invoices.invoices_to_pay = [];

            vm.open_invoices.invoices.forEach( function(invoice) {
                if(invoice.checked) {
                    vm.open_invoices.invoices_to_pay.push(invoice);

                    if(!hasPendingAch(invoice)) total += invoice.outstanding_amount;
                }
            });
            vm.payment.pay_selected_total = total;
            createInvoicesToPayArray();
        }

        vm.closed_invoices.changeInvoicesToPayAll = function() {
            vm.closed_invoices.any_invoices_checked = vm.closed_invoices.all_invoices_checked;
            vm.closed_invoices.invoices.forEach( function(invoice) {
                invoice.checked = vm.closed_invoices.all_invoices_checked;
            });
        }

        vm.closed_invoices.checkedInvoices = function() {
            for( var i = 0; i < vm.closed_invoices.invoices.length; i++) {
                    if(vm.closed_invoices.invoices[i].checked) {
                        vm.closed_invoices.any_invoices_checked = true;
                        return;
                    }
            }
            vm.closed_invoices.any_invoices_checked = false;
        }


        vm.open_invoices.changeInvoicesToPayAll = function() {
            vm.open_invoices.invoices.forEach( function(invoice) {
                invoice.checked = vm.open_invoices.all_invoices_checked;
            });
            vm.addCheckedInvoices()
        }

        vm.open_invoices.changeInvoicesToPay = function() {
            vm.open_invoices.invoices.forEach( function(invoice) {
                if(invoice.checked) {
                    vm.open_invoices.invoices_to_pay.push(invoice);
                }
            });
            vm.addCheckedInvoices()
        }

        vm.changeAutopayDate = function() {
            vm.autopay_by_date_processing = true;
            Customer.updateQbench({'autopay_by_date': vm.autopay_by_date},
                function(data){
                    vm.autopay_by_date_processing = false;
                },
                function(e) {
                    console.log(e);
                    vm.autopay_by_date_processing = false;
                }
            )
        }

        vm.setAutopay = function(value) {
            vm.autopay_processing = true;
            CustomerSquare.toggleAutopay({'autopay': value},
                function(data) {
                    vm.autopay_processing = false;
                    vm.autopay_checked = data.autopay;
                    vm.new_card_autopay_checkbox = false;
                    if(vm.autopay_checked) {
                        $('#snackbar').addClass('activeSnackbar')
                        setTimeout(function()  {
                            $('#snackbar').removeClass('activeSnackbar')
                        },3000);
                    }
                },
                function(e) {
                    vm.autopay_processing = false;
                    console.log(e);
                }
            );
        }

        vm.toggleAutopay = function() {
            if(vm.autopay_checked && !vm.payment.cards) {
                SweetAlert.swal({
                    title: "No Card on File",
                    text: "Please add a primary card using the 'Payment Methods' tab before enabling autopay.",
                    type: "warning",
                    confirmButtonColor: "#27ae60",
                    confirmButtonText: "Ok",
                });
                vm.autopay_checked = false;
            }
            else {
                vm.autopay_processing = true;
                CustomerSquare.toggleAutopay({},
                    function(data) {
                        vm.autopay_processing = false;
                        vm.autopay_checked = data.autopay;
                        if(vm.autopay_checked) {
                            $('#snackbar').addClass('activeSnackbar')
                            setTimeout(function()  {
                                $('#snackbar').removeClass('activeSnackbar')
                            },3000);
                        }
                    },
                    function(e) {
                        vm.autopay_processing = false;
                        console.log(e);
                    }
                );
            }
        }

        vm.payment.updatePrimaryCard = function(id) {
            CustomerSquare.updatePrimaryCard({'square_primary_card_id': id},
            function(data) {
                if(!vm.payment.cards) {
                    getCustomerSquareAccount();
                }
                else {
                    vm.payment.primary_card = id;

                    vm.payment.cards.forEach( function(card) {
                        card.is_primary = false;
                    });

                    vm.payment.cards.forEach( function(card) {
                        if(card.id == id) {
                            card.is_primary = true;
                        }
                    });
                    sortCards();
                }
            },
            function(e) {
                vm.payment.primary_card = null;
                console.log(e);
            })
        }

        function sortCards() {
            vm.payment.cards.sort( function(card_a ,card_b) {
                if (!card_a.is_primary) {
                    return 1;
                }
                else if (!card_b.is_primary){
                    return -1;
                }
            });
        }

        function queryAll() {
            vm.generic.query(vm.open_invoices, false);
            vm.generic.query(vm.closed_invoices, false);
            vm.payment_history.query(false);
        }

        queryAll();

        vm.switchTab = function(tab) {
            angular.forEach(vm.activeTab, function(value, key) {
                vm.activeTab[key] = false;
            });

            vm.activeTab[tab] = true;
        }

        vm.hideAllTabs = function() {
            angular.forEach(vm.activeTab, function(value, key) {
                vm.activeTab[key] = false;
            });

            vm.show_all_tabs = false;
        }

        vm.payment_methods.cancelPaymentMethod = function() {
            vm.payment_methods.show_tab = false;
            vm.switchTab('payment_methods');
            vm.show_all_tabs = true;
            resetPaymentForm();
            // resetSquarePaymentFormFields();
        }

        vm.payment_methods.addPaymentMethod = function() {
            vm.hideAllTabs();
            vm.payment_methods.show_tab = true;
            vm.show_all_tabs = false;
            vm.make_primary_payment_method = true;
            if(!vm.payment.cards && vm.autopay_by_date) {
                vm.new_card_autopay_checkbox = true;
            }
        }

        vm.account_balance = 0;

        vm.markNaBefore = new Date('5/1/2020')

        $scope.itemArray = [
            {id: 0, name: 'All', value: 'ALL'},
            {id: 1, name: 'Approved', value: 'APPROVED'},
            {id: 2, name: 'Draft', value: 'DRAFT'},
            {id: 3, name: 'Invoiced', value: 'INVOICED'},
            {id: 4, name: 'Canceled', value: 'CANCELLED'},
            {id: 5, name: 'Prepayment', value: 'PREPAYMENT'},
            {id: 6, name: 'Preliminary', value: 'PRELIMINARY'},
        ];

        $scope.selected = { value: $scope.itemArray[0]};

        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "Billing";
            $rootScope.searchVm = vm;
        }

        vm.itemsPerPage = "20";
        vm.status = ["INVOICED"];
        vm.filterIsApplied = false;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;

        vm.getCustomerData = getCustomerData;

        vm.showFilterPanel = false;

        getCustomerData();

        vm.datePickerOpenStatus = {};

        vm.toggleFilterPanel = function() {
            vm.showFilterPanel = !vm.showFilterPanel;
        }

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function initialFilterParams() {
            vm.page = 1;
            vm.itemsPerPage = "20";

            vm.orderNumber = null;

            vm.invoiceStatus = {
                DRAFT : false,
                INVOICED : false,
                APPROVED : false,
                PREPAYMENT : false,
                PRELIMINARY : false,
                CANCELLED: false
            }

            vm.amountRange = {
                UPPER: null,
                LOWER: null
            }

            vm.dateRange = {
                UPPER: null,
                LOWER: null
            }
        }

        initialFilterParams()

        function setInvoicesStatus(invoices) {
            var today = new Date(moment());
            invoices.forEach( function(invoice) {
                var date_to_compare = invoice.due_date ? invoice.due_date : invoice.invoice_date;
                if(today > new Date(date_to_compare)) {
                    invoice.past_due = true;
                }
                else {
                    invoice.past_due = false;
                }

                if(hasPendingAch(invoice)) invoice.payment_status = "<span class=\"invoice-status unpaid\">ACH Pending</span>"
                else if(!invoice.past_due && invoice.paid) invoice.payment_status = "<span class=\"invoice-status paid\">Paid</span>"
                else if(!invoice.past_due && !invoice.paid) invoice.payment_status = "<span class=\"invoice-status unpaid\">Unpaid</span>"
                else if(invoice.past_due) invoice.payment_status = "<span class=\"invoice-status past-due\">Past Due</span>"
            });

            return invoices;
        }

        function getUnpaidInvoices() {
            Invoice.getUnpaid({},
                function(data) {
                    vm.open_invoices.unpaid_invoices = data.invoices;
                    vm.open_invoices.total_balance = 0;
                    data.invoices.forEach( function(invoice) {
                        if(!hasPendingAch(invoice)) vm.open_invoices.total_balance += invoice.outstanding_amount;
                    });
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        vm.payment.cardBrands = {
            VISA: 'fa-cc-visa',
            AMERICAN_EXPRESS: 'fa-cc-amex',
            MASTERCARD: 'fa-cc-mastercard',
            DISCOVER: 'fa-cc-discover',
        }

        vm.payment.squareCardToName = {
            VISA: 'Visa',
            AMERICAN_EXPRESS: 'American Express',
            MASTERCARD: 'Mastercard',
            DISCOVER: 'Discover',
        }

        function getCustomerSquareAccount() {
            CustomerSquare.retrieveCustomer({},
                function(data) {
                    vm.payment.cards = data.customer.cards;

                    if(vm.payment.cards) {
                        vm.payment.cards.forEach( function(card) {
                            card.is_primary = false;
                        });

                        vm.payment.cards.forEach( function(card) {
                            if(card.id == vm.payment.primary_card) {
                                card.is_primary = true;
                                vm.payment.primary_card_info = card;
                            }
                        });

                        sortCards();
                    }
                    else if(vm.autopay_checked){
                        vm.setAutopay(false);
                    }

                    if(!vm.payment.primary_card && vm.payment.cards && vm.payment.cards.length > 0) {
                        vm.payment.updatePrimaryCard(vm.payment.cards[0].id);
                    }
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        vm.payment.setCard = function(card) {
            vm.payment.selectedCard = card;
        }

        function applyPaymentsInBatchSuccess(data) {
            sendPaymentReceipt(data.id)
            queryAll();
            SweetAlert.swal({
                title: 'Payment processed successfully.',
                text: 'Thank you for your payment. All billing contacts will be emailed a copy of the payment receipt shortly. The document will also be accessible and available for download via the \'Payment History\' subtab of the portal.',
                type: 'success',
                confirmButtonColor: '#4f8fcc',
                confirmButtonText: 'Ok'
            });

            vm.open_invoices.invoices_to_pay = [];
            vm.payment.pay_selected_total = 0;
            vm.emails = null;
            vm.payment.id = null;
            vm.payment_processing = false;
        }

        function applyPaymentsInBatchFail(e) {
            console.log(e)
            vm.payment.receipt_number = null;
            vm.payment_processing = false;
        }

        vm.createPayment = function(type) {
            vm.payment_processing = true;
            createInvoicesToPayArray();

            var notes = vm.customerData.name + ': ';

            var nonce = '';
            if(type == 'card') nonce = vm.payment.primary_card;
            else if(type == 'ach') nonce = vm.payment.ach_info.token;

            if(vm.open_invoices.invoices_to_pay.length > 0) {
                vm.open_invoices.invoices_to_pay.forEach( function(invoice) {
                    if(type == 'card'){
                        notes += invoice.customer_order_id + ' (Portal Payment)';
                    }
                    else if(type == 'ach'){
                        notes += invoice.customer_order_id + ' (Portal - ACH)';
                    }
                    // notes += invoice.custom_formated_id + ', ';
                    
                });
            }
            else {
                vm.open_invoices.unpaid_invoices.forEach( function(invoice) {
                    if(type == 'card'){
                        notes += invoice.customer_order_id + ' (Portal Payment)';
                    }
                    else if(type == 'ach'){
                        notes += invoice.customer_order_id + ' (Portal - ACH)';
                    }
                    // notes += invoice.custom_formated_id + ', ';
                });
            }

            SquareService.createPayment({
                'nonce': nonce,
                'amount': vm.payment.amount,
                'note' : notes.length > 149 ? notes.substring(0, 149) : notes.substring(0, notes.length - 1) // square caps note length to 150 char
            },
                function(data) {
                    if(data.errors) {
                        vm.payment.processSquareRequestErrors('There was an issue processing your payment.', data.errors);
                        vm.payment_processing = false;
                    }
                    else {
                        vm.payment.receipt_number = data.payment.receipt_number;
                        if(type == 'card') applyQBenchPayment(data.payment.id);
                        if(type == 'ach') updateInvoices(data.payment.id)
                    }
                    vm.payment.amount = null;
                    vm.open_invoices.invoices_to_pay_array = [];
                },
                function(e) {
                    vm.payment_processing = false;
                    vm.payment.amount = null;
                    vm.open_invoices.invoices_to_pay_array = [];
                    vm.invoices.forEach( function(invoice) {
                        invoice.checked = false;
                    });
                    console.log(e);
                }
            );
        }


        vm.initiatePayment = function(type) {
            if(vm.payment.amount == null) {
                vm.payment.amount = vm.open_invoices.total_balance;
            };
            var text = '';

            if(type == 'card') {
                if(!vm.payment.primary_card) {
                    SweetAlert.swal({
                        title: "No Card on File",
                        text: "Please add a primary card using the 'Payment Methods' tab before submitting a payment.",
                        type: "warning",
                        confirmButtonColor: "#27ae60",
                        confirmButtonText: "Ok",
                    });

                    return
                }

                text = `Your primary credit card on file ending in ${vm.payment.primary_card_info.last_4} will be automatically charged. Are you sure you want to submit a payment for $${vm.payment.amount.toFixed(2).toString()}?`;
            }
            else if(type == 'ach') {
                text = `Your bank account ending in ${vm.payment.ach_info.details.bankAccount.accountNumberSuffix} will be automatically charged. Are you sure you want to submit a payment for $${vm.payment.amount.toFixed(2).toString()}?`;
            }

            SweetAlert.swal({
                    title: "Confirm Payment",
                    text: text,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#27ae60",
                    confirmButtonText: "Submit Payment",
                    closeOnConfirm: true
                },
                function(confirm) {
                    if(confirm) {
                        vm.createPayment(type);
                    }
                }
            );
        }



        vm.deleteCard = function(card) {
            SweetAlert.swal({
                title: "Confirm Remove Card",
                text: "Are you sure you want to remove your " + vm.payment.squareCardToName[card.card_brand] + " card ending in " + card.last_4 + "?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f01c1c",
                confirmButtonText: "Remove Card",
                closeOnConfirm: false
            },
                function(confirm) {
                    if(confirm) {
                        CustomerSquare.deleteCard({
                            nonce: card.id,
                        },
                            function(data) {
                                if(data.errors) {
                                    vm.payment.processSquareRequestErrors('There was an issue removing your card.', data.errors);   
                                }
                                else {
                                    getCustomerSquareAccount();
                                    // resetSquarePaymentFormFields()
                                    vm.payment.selectedCard = null;

                                    SweetAlert.swal({
                                        title: 'Your card was removed successfully.',
                                        type: 'success',
                                        confirmButtonColor: '#4f8fcc',
                                        confirmButtonText: 'Ok'
                                    });
                                    if(card.is_primary) {
                                        vm.payment.updatePrimaryCard(null);
                                    }
                                }
                                sortCards();
                            },
                            function(e) {
                                console.log(e);
                            }
                        );
                    }
                }
            );
        }

        vm.saveCard = function(nonce, cardholder_name, show_popup) {
            if(vm.new_card_autopay_checkbox) {
                vm.setAutopay(true);
            }
            CustomerSquare.saveCard({
                nonce: nonce,
                cardholder_name: cardholder_name
            },
            function(data) {
                if(data.errors) {
                    vm.payment.processSquareRequestErrors('There was an issue saving your card.', data.errors);
                    resetPaymentForm();
                }
                else {
                    getCustomerSquareAccount();

                    if(vm.make_primary_payment_method) {
                        vm.payment.updatePrimaryCard(data.card.id);
                    }

                    if(show_popup) {
                        SweetAlert.swal({
                            title: 'Card saved successfully.',
                            type: 'success',
                            confirmButtonColor: '#4f8fcc',
                            confirmButtonText: 'Ok'
                        });
                    }
                    vm.hideAllTabs();
                    vm.switchTab('payment_methods');
                    vm.payment_methods.show_tab = false;
                    vm.show_all_tabs = true;
                    resetPaymentForm();
                }
            },
            function(e) {
                console.log(e);
            }
        );
        }

        vm.payment.addErrorMessage = function(error_message, new_error) {
            return error_message + new_error + '\n'
        }

        vm.payment.processSquareRequestErrors = function(title, errors) {
            var error_message = '';

            angular.forEach(errors, function(item, index) {
                if(item.detail) {
                    error_message = vm.payment.addErrorMessage(error_message, item.detail);
                }
                else if(item.message) {
                    error_message = vm.payment.addErrorMessage(error_message, item.message);
                }
            });

            SweetAlert.swal({
                title: title,
                text: error_message,
                type: 'warning',
                confirmButtonColor: '#4f8fcc',
                confirmButtonText: 'Try Again'
            });
        }

        function sendPaymentReceipt(id) {
            Payment.sendReceipt({id: id, emails: vm.emails},
                function(data) {
                    console.log('sent payment receipt')
                },
                function(e) {
                    console.log(e);
                }
            );
        }



        function resetSquarePaymentFormFields() {
            vm.payment.paymentForm.destroy();
            vm.payment.cardHolder = null;
        }

        vm.saveCardFromFrontEnd = function(event) {
            vm.onGetCardNonce(event);

            if(!vm.payment.cards && vm.new_card_autopay_checkbox) {
                vm.setAutopay(true);
                vm.new_card_autopay_checkbox = false;
            }
        }

        vm.onGetCardNonce = function(event) {
            event.preventDefault();
            vm.payment.paymentForm.requestCardNonce();
        }

        vm.payment.toggleMakePrimary = function() {
            vm.make_primary_payment_method = !vm.make_primary_payment_method;
        }


         if(!vm.isAuthenticated()){
              $state.go('login');
         }

        vm.dropDown = function(id, dropDownOption) {
            if(dropDownOption === 'Download') {
                vm.downloadAttachment(id);
            }
            else if(dropDownOption === 'Print')  {
                vm.printAttachment(id);
            }
        }

        vm.downloadSelectedInvoices = function(tabDict) {
            var invoice_list = []
            tabDict.invoices.forEach( function(invoice) {
                if(invoice.checked) {
                    invoice_list.push(invoice.id);
                }
            });

            InvoiceAttachDownload.merged({invoices: invoice_list, order: determineOrder(tabDict)},
                function(data, headers) {
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = "Invoices.pdf";
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function (e) {
                    AlertService.error("Could not download invoice");
                }
            );
        }

        vm.downloadAttachment = function (invoice) {
            if(invoice == ''){return}
            invoice.isDownloading = true;
            InvoiceAttachDownload.get({id: invoice.id}, onSuccess, onError);

            function onSuccess(data, headers) {
                var url = window.URL.createObjectURL(data.data);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = "Invoice-" + invoice.id + ".pdf";
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
            function onError(error) {
                AlertService.error("Could not download invoice");
            }
        }

        vm.printSelectedInvoices = function(tabDict) {
            var invoice_list = [];
            tabDict.invoices.forEach( function(invoice) {
                if(invoice.checked) {
                    invoice_list.push(invoice.id);
                }
            });

            InvoiceAttachDownload.merged({invoices: invoice_list, order: determineOrder(tabDict)},
                function (data, headers) {
                    if (data.data.byteLength == 0){
                        AlertService.error("Could not print invoice");
                        return;
                    }
                    var url = URL.createObjectURL(data.data);

                    setTimeout(function() {
                        window.open(url, '_blank');
                    }, 200);

                },
                function (error) {
                    AlertService.error("Could not print invoices");
                }
            );
        }

        vm.printAttachment = function (invoice) {
            if(invoice == ''){return}
            InvoiceAttachDownload.get({id: invoice.id}, onSuccess, onError);
            function onSuccess(data, headers) {
                if (data.data.byteLength == 0){
                    AlertService.error("Could not print invoice");
                    return;
                }
                var url = URL.createObjectURL(data.data);

                setTimeout(function() {
                    window.open(url, '_blank');
                }, 200);
            }
            function onError(error) {
                AlertService.error("Could not print invoice");
            }
        }

        function hasPendingAch(invoice) {
            if(invoice.ach_status && invoice.ach_status == 'PENDING') return true;
            return false;
        }

        function getCustomerData () {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.customerData = data;
                vm.payment.primary_card = data.square_primary_card_id;
                vm.payment.primary_card_info = null;
                vm.autopay_checked = data.autopay;
                vm.autopay_by_date = data.autopay_by_date;
                getCustomerSquareAccount();

                vm.account_balance = vm.customerData.account_balance;

                if(!vm.customerData.autopay_by_date) {
                    vm.autopay_by_date = "Invoice Date";
                    vm.changeAutopayDate();
                }
            }
            function onError(e) {
                console.log(e)
                $state.go('customerconfigure');
            }
        }

        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        angular.element(document).ready(function() {
            setTimeout(function () {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;
                $("#table tr:first > th").css("width", col_width+"%");

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if(constant == 2 || constant2 >= 2){
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });
     }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'getUnpaid': {
                method: 'GET',
                url: 'api/invoices/unpaid-invoices',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoicelog', {
            parent: 'entity',
            url: '/invoicelog?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Billing'
            },
            views: {
               'content@': {
                    templateUrl: 'app/pages/invoice-log/invoiceslog.html',
                    controller: 'InvoiceLogController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                billingAccess: ['BillingAccess', function(BillingAccess) {
                    return BillingAccess.requireAccess();
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    copy.paymentDate = DateUtils.convertLocalDateToServer(copy.paymentDate);
                    return angular.toJson(copy);
                }
            },
            'updateInvoices': {
                method: 'POST',
                url: 'api/invoices',
                transformRequest: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getUnpaid': {
                method: 'GET',
                url: 'api/invoices/unpaid-invoices',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'filter': {
                method: 'GET',
                url: 'api/invoices/filter',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'openBalance': {
                method: 'GET',
                url: 'api/invoices/open-balance/:customer_id',
                responseType: 'blob',
                transformResponse: function (data) {
                    return { data: data };
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-details', {
            parent: 'entity',
            url: '/invoice-details/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Invoices Details'
            },
            resolve: {
                billingAccess: ['BillingAccess', function(BillingAccess) {
                    return BillingAccess.requireAccess();
                }]
            },
            views: {
               'content@': {
                    templateUrl: 'app/pages/invoice-details/invoice-details.html',
                    controller: 'InvoiceDetailsController',
                    controllerAs: 'vm'
                }
            },
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('InvoiceDetailsController', InvoiceDetailsController);

    InvoiceDetailsController.$inject = ['$timeout', '$scope', '$rootScope', 'Invoice', 'InvoiceAttachDownload', 'InvoiceAttachDownloadBytes',
                                        'SquareService', 'Payment', 'SweetAlert', 'CustomerSquare'];

    function InvoiceDetailsController ($timeout, $scope, $rootScope, Invoice, InvoiceAttachDownload, InvoiceAttachDownloadBytes,
                                         SquareService, Payment, SweetAlert, CustomerSquare) {
        var vm = this;

        function getPageData() {
            vm.data = Invoice.get({id : $scope.$parent.toStateParams.id},
                function(data) {
                    pageLoad();
                    return data;
                },
                function(e) {
                    console.log(e)
                }
            );
        }

        function pageLoad() {
            $('#invoiceNo').html('Invoice No. ' + vm.data.invoice.custom_formated_id);
            initializeVars();
            parseAddresses();
            processInvoiceItems();
            createPaymentDict();
            setShowLotBatch();
            setInvoiceStatus();
            if(vm.invoice_is_payable) {
                getSquareAccount();
            }
        }

        function initializeVars() {
            vm.invoice_payment = [];
            vm.emails = null;
            vm.account_address = [];
            vm.distributor_address = [];
            vm.manufacturing_address = [];

            vm.payment_processing = false;

            vm.show_lot_batch = false;

            vm.invoice_is_payable = ["INVOICED", "APPROVED", "PREPAYMENT", "PRELIMINARY"].includes(vm.data.invoice.status);

            vm.card_info = null;

            vm.payment = {
                card: null,
                amount: null,
                note: null,
                id: null
            }

            vm.invoice_data = {
                invoice_items: [],
                flat_surcharges: [],
                percent_surcharges: [],
                flat_discounts: [],
                percent_discounts: [],
                subtotals: [],
                total: 0
            }
        }

        function getSquareAccount() {
            CustomerSquare.retrieveCustomer({},
                function(data) {
                    if(data && data.customer && data.customer.cards) {
                        data.customer.cards.forEach( function(card) {
                            if(card.id == vm.data.customer.square_primary_card_id) {
                                vm.card_info = card;
                            }
                        });
                    }
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        function setShowLotBatch() {
            if(vm.data.sampleList.length > 0) {
                vm.show_lot_batch = vm.data.sampleList.some( function(el) {
                    if(el.lotBatchNumber) {
                        return true
                    }
                });
            }
        }

        function setInvoiceStatus() {
            vm.payment_status = "<div></div>"

            if(vm.data.invoice.ach_status && vm.data.invoice.ach_status == 'PENDING') {
                vm.payment_status = "<div class=\"invoice-status unpaid\">ACH Pending</div>";
                vm.invoice_is_payable = false;
            }
            else if(!vm.invoice_is_payable) {
                vm.payment_status = "<div class=\"invoice-status unpaid\">Awaiting Approval</div>";
            }
            else if(vm.data.invoice.paid) {
                vm.payment_status = "<div class=\"invoice-status paid\">Paid</div>";
            }
            else {
                var today = new Date(moment())
                var date_to_compare = vm.data.invoice.due_date ? vm.data.invoice.due_date : vm.data.invoice.invoice_date;


                if(today > new Date(date_to_compare)) {
                    vm.payment_status = "<div class=\"invoice-status past-due\">Past Due</div>";
                }
                else {
                    vm.payment_status = "<div class=\"invoice-status unpaid\">Unpaid</div>";
                }
            }
        }

        function addErrorMessage(error_message, new_error) {
            return error_message + new_error + '\n'
        }

        function processSquareRequestErrors(title, errors) {
            var error_message = '';

            angular.forEach(errors, function(item, index) {
                if(item.detail) {
                    error_message = addErrorMessage(error_message, item.detail);
                }
            });

            SweetAlert.swal({
                title: title,
                text: error_message,
                type: 'warning',
                confirmButtonColor: '#4f8fcc',
                confirmButtonText: 'Try Again'
            });
            vm.payment_processing = false;
        }

        function createPaymentDict() {
            vm.payment.card = vm.data.customer.square_primary_card_id ? vm.data.customer.square_primary_card_id : null;
            vm.payment.amount = vm.data.invoice.outstanding_amount;
            vm.payment.note = vm.data.customer.company_name + ': ' + vm.data.invoice.order.id + ' (Portal Payment)';

            vm.invoice_payment = [{ invoice_id: vm.data.invoice.id, applied_amount: vm.payment.amount }];

            vm.emails = vm.data.invoice.email_to;
        }

        getPageData();

        vm.createPayment = function() {
            if(!vm.payment.card) {
                SweetAlert.swal({
                    title: "No Card on File",
                    text: "Please add a credit card to the 'Payment Methods' tab of the Billing page before attempting to submit a payment.",
                    type: "warning",
                    confirmButtonColor: "#27ae60",
                    confirmButtonText: "Ok",
                });
            }
            else {
                SweetAlert.swal({
                        title: "Confirm Payment",
                        text: "Your primary credit card on file will be automatically charged. Are you sure you want to submit a payment for $" + vm.payment.amount.toFixed(2).toString() + '?',
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#27ae60",
                        confirmButtonText: "Submit Payment",
                        closeOnConfirm: true
                    },
                    function(confirm) {
                        if(confirm) {
                            vm.payment_processing = true;

                            SquareService.createPayment({
                                'nonce': vm.payment.card,
                                'amount': vm.payment.amount,
                                'note' : vm.payment.note
                            },
                                function(data) {
                                    if(data.errors) {
                                        processSquareRequestErrors('There was an issue processing your payment.', data.errors);
                                    }
                                    else {
                                        applyQBenchPayment(data.payment.id);
                                    }
                                },
                                function(e) {
                                    vm.payment_processing = false;
                                    console.log(e);
                                }
                            );
                        }
                    }
                );
            }
        }

        function applyQBenchPayment(square_payment_id) {
            Payment.createPayment({
                payment_dict: {
                    amount: vm.payment.amount,
                    payment_type_id: 34,
                },
                invoices_dict : {
                    invoice_payments: vm.invoice_payment
                },
                params: {
                    square_payment_id: square_payment_id,
                    card_info: vm.card_info ? vm.card_info : false
                },
            },
            function(data) {
                sendPaymentReceipt(data.id)
                createInvoicesToPayArray();
                SweetAlert.swal({
                    title: 'Payment processed successfully.',
                    text: 'Thank you for your payment. All billing contacts will be emailed a copy of the payment receipt shortly. The document will also be accessible and available for download via the \'Payment History\' subtab of the portal.',
                    type: 'success',
                    confirmButtonColor: '#4f8fcc',
                    confirmButtonText: 'Ok'
                });
            },
            function(e) {
                console.log(e)
            }
        );
        }

        function sendPaymentReceipt(id) {
            Payment.sendReceipt({ id: id, emails: vm.emails },
                function(data) {
                    getPageData();
                    setTimeout(() => {
                        vm.payment_processing = false;
                    }, 2000);
                },
                function(e) {
                    console.log(e);
                }
            );
        }

        function parseAddresses() {
            vm.account_address.push(vm.data.customer.company_name)
            if(vm.data.customer.address) {
                var customer_address = vm.data.customer.address.split('\n');
                customer_address.forEach( function(line) {
                    vm.account_address.push(line);
                });
            }

            if(vm.data.customerOrder.samplingAddress) {
                var distributor_address = vm.data.customerOrder.samplingAddress.split('\n');
                distributor_address.forEach( function(line) {
                    vm.distributor_address.push(line);
                });
            }

            if(vm.data.customerOrder.manufacturingAddress) {
                var manufacturing_address = vm.data.customerOrder.manufacturingAddress.split('\n');
                manufacturing_address.forEach( function(line) {
                    vm.manufacturing_address.push(line);
                });
            }
        }


        function processInvoiceItems() {
            vm.data.invoice.invoiceItems.forEach( function(item) {
                if(item.invoice_item_type == 'INVOICE_ITEM') {
                    vm.invoice_data.invoice_items.push(item);
                }
                else if(item.invoice_item_type == 'FLAT_SURCHARGE') {
                    vm.invoice_data.flat_surcharges.push(item);
                }
                else if(item.invoice_item_type == 'PERCENT_SURCHARGE') {
                    vm.invoice_data.percent_surcharges.push(item);
                }
                else if(item.invoice_item_type == 'FLAT_DISCOUNT') {
                    vm.invoice_data.flat_discounts.push(item);
                }
                else if(item.invoice_item_type == 'PERCENT_DISCOUNT') {
                    vm.invoice_data.percent_discounts.push(item);
                }
                else if(item.invoice_item_type == 'SUBTOTAL') {
                    vm.invoice_data.subtotals.push(item);
                }
            });

            vm.invoice_data.total = vm.data.invoice.total;
            vm.invoice_data.outstanding_amount = vm.data.invoice.outstanding_amount;
        }


        vm.downloadAttachment = function (id) {
            InvoiceAttachDownload.get({id: id},
                function (data) {
                    var url = window.URL.createObjectURL(data.data);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = "Invoice-" + vm.data.invoice.custom_formated_id + ".pdf";
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                },
                function (e) {
                    AlertService.error("Could not download invoice");
                }
            );
        }

        $scope.downloadAttachment = function (id) {
            if(id == ''){return}
            InvoiceAttachDownload.get({id: id}, onSuccess, onError);
            function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
                a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
                a.download = 'Invoice ' + vm.data.invoice.custom_formated_id +  '.pdf';
                a.click();
            }
            function onError(error) {

            }
        }
                
        vm.printAttachment = function (id) {
            InvoiceAttachDownload.get({id: id}, onSuccess, onError);
            function onSuccess(data, headers) {
                if (data.data.byteLength == 0){
                    AlertService.error("Could not print invoice");
                    return;
                }
                var url = URL.createObjectURL(data.data);

                setTimeout(function() {
                    window.open(url, '_blank');
                },200);
            }
            function onError(error) {
                AlertService.error("Could not print invoice");
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SampleSubmitController', SampleSubmitController);

    SampleSubmitController.$inject = ['$state', '$rootScope', '$scope', '$localStorage',
                                        'Customer', 'Auth', 'Principal', 'ProfileService',
                                        'LoginService', 'CustomerOrder', 'Contact2ForUser',
                                        'CustomerOrderPdfService', 'AddressList', 'CityList', 'ZipList',
                                        'ProductCategory', 'ProductTypeByCategory', 'StrainNameSearch',
                                        'Assay', 'CustomerByUser', 'CustomPanel', 'ProductType', 'Panel', '$filter', 'SampleFilter', 'SweetAlert', 'AlertService','DataUtils', 'GraphQLService', '$translate', 'BRAND', '$timeout'
                                    ];

    function SampleSubmitController($state, $rootScope, $scope, $localStorage,
                                    Customer, Auth, Principal, ProfileService,
                                    LoginService, CustomerOrder, Contact2ForUser,
                                    CustomerOrderPdfService, AddressList, CityList, ZipList,
                                    ProductCategory, ProductTypeByCategory, StrainNameSearch, Assay,
                                    CustomerByUser, CustomPanel, ProductType, Panel, $filter, SampleFilter, SweetAlert, AlertService, DataUtils, GraphQLService, $translate, BRAND, $timeout
                                    ) {

        var vm = this;
        vm.brand = BRAND || {};
        vm.branding = vm.brand.branding || {};
        vm.contact = vm.brand.contact || {};
        vm.address = vm.brand.address || {};
        vm.companyName = (vm.brand.legal && vm.brand.legal.company_name) || vm.branding.display_name || 'Client Portal';
        vm.pickupLabel = (vm.branding.display_name || 'Lab') + ' Pick-Up';
        vm.getDeliveryPreferenceDisplay = function(deliveryPreference) {
            return deliveryPreference === 'Anresco Pick-Up' ? vm.pickupLabel : deliveryPreference;
        };
        vm.supportEmail = vm.contact.support_email || vm.contact.info_email || '';
        vm.statusEmail = vm.contact.status_email || vm.supportEmail;
        vm.currentLanguage = $translate.proposedLanguage();

        vm.rd = {};
        var rd = {};

        vm.comp = {};
        var comp = {};

        vm.food = {};
        var food = {};

        vm.submitData = false;

        vm.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.show_tab = {
            comp: false,
            rd: false,
            analysis: false,
            fda: false
        };

        vm.active_tab = {
            comp: false,
            rd: false,
            analysis: false,
            fda: false
        }

        // GraphQL query for assays - lightweight payload (13 fields vs 30+ from REST)
        var ASSAYS_LIST_QUERY = `
            query AssaysList($enabled: Boolean) {
                assaysList(enabled: $enabled) {
                    id
                    title
                    reporting_title
                    portalIdentifier
                    portal_client_type
                    portal_client_type_list
                    basePrice
                    analysis_description
                    duration
                    method
                    instrument
                    minimum_quantity_required
                    optimum_quantity_required
                }
            }
        `;


        CustomerByUser.get({}, onSuccess, onError);
        function onSuccess(data, headers) {
            // Update rootScope with fresh data to ensure consistency
            if (!$rootScope.customer) {
                $rootScope.customer = {};
            }
            $rootScope.customer.customer_type = data.businessType ? data.businessType.name : 'Cannabis';
            vm.customer_type = data.businessType ? data.businessType.name.toLowerCase() : 'cannabis';
            
            // Also update the customer type for the RD section
            if (vm.rd) {
                vm.rd.customer_type = $rootScope.customer.customer_type;
            }
            
            setAvailableTabs(vm.customer_type);
        }
        function onError(e) {
            // Fallback to cached data if available
            if ($rootScope.customer && $rootScope.customer.customer_type) {
                vm.customer_type = $rootScope.customer.customer_type.toLowerCase();
                setAvailableTabs(vm.customer_type);
            }
        }


        // Event listeners for file uploads from vanilla JS
        $scope.$on('compFileSelected', function(event, files) {
            if (vm.comp && vm.comp.handleFileSelect) {
                vm.comp.handleFileSelect(files);
            }
        });

        $scope.$on('rdFileSelected', function(event, files) {
            if (vm.rd && vm.rd.handleFileSelect) {
                vm.rd.handleFileSelect(files);
            }
        });

        $scope.$on('foodFileSelected', function(event, files) {
            if (vm.food && vm.food.handleFileSelect) {
                vm.food.handleFileSelect(files);
            }
        });

        $scope.$on('fdaFileSelected', function(event, files) {
            if (vm.fda && vm.fda.handleFileSelect) {
                vm.fda.handleFileSelect(files);
            }
        });

        // Helper function to format file size
        vm.formatFileSize = function(bytes) {
            if (bytes < 1024) {
                return bytes + ' bytes';
            } else if (bytes < 1024 * 1024) {
                return (bytes / 1024).toFixed(2) + ' KB';
            } else {
                return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
            }
        };

        var MAX_ORDER_ATTACHMENT_SIZE = 10 * 1024 * 1024;

        function getTotalFileSize(files) {
            var totalSize = 0;
            angular.forEach(files || [], function(file) {
                totalSize += file && file.size ? file.size : 0;
            });
            return totalSize;
        }

        function readFileForOrderAttachment(file) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(event) {
                    var dataUrl = event.target.result || '';
                    var separatorIndex = dataUrl.indexOf(',');
                    if (separatorIndex === -1) {
                        reject(new Error('The selected file could not be encoded.'));
                        return;
                    }
                    resolve({
                        name: file.name,
                        size: file.size,
                        type: file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        base64: dataUrl.substring(separatorIndex + 1)
                    });
                };
                reader.onerror = function() {
                    reject(new Error('The selected file could not be read.'));
                };
                reader.readAsDataURL(file);
            });
        }

        function handleExcelImport(orderState, fileInputSelector, extractWorkbook) {
            var fileInput = $(fileInputSelector)[0];
            var file = fileInput && fileInput.files ? fileInput.files[0] : null;
            if (!file) return Promise.reject("You must select a file.");

            if (orderState.processingExcelUpload) {
                return Promise.resolve(false);
            }

            if (!/\.xlsx$/i.test(file.name || '')) {
                AlertService.error('Upload failed. Please select an XLSX file.');
                fileInput.value = '';
                return Promise.resolve(false);
            }

            var proposedTotalSize = getTotalFileSize(orderState.uploadedFiles) +
                getTotalFileSize(orderState.importedExcelFiles) + file.size;
            if (proposedTotalSize > MAX_ORDER_ATTACHMENT_SIZE) {
                AlertService.error('Upload failed. The Excel file and document attachments cannot exceed 10MB total.');
                fileInput.value = '';
                return Promise.resolve(false);
            }

            orderState.importedExcelFiles = orderState.importedExcelFiles || [];
            var samplesBeforeImport = (orderState.samples || []).slice();
            var sampleArrayBeforeImport = (orderState.sampleArray || []).slice();
            var assayIndexMapBeforeImport = orderState.excel_assay_index_map;

            function restoreImportState() {
                orderState.samples = samplesBeforeImport;
                orderState.sampleArray = sampleArrayBeforeImport;
                orderState.excel_assay_index_map = assayIndexMapBeforeImport;
                if (typeof orderState.checkPageOne === 'function') {
                    orderState.checkPageOne();
                }
            }

            orderState.processingExcelUpload = true;

            return Promise.all([
                XlsxPopulate.fromDataAsync(file),
                readFileForOrderAttachment(file)
            ])
            .then(function(results) {
                var importSucceeded = false;
                $scope.$apply(function() {
                    importSucceeded = extractWorkbook(results[0]);
                    if (importSucceeded) {
                        // Keep the source workbook separate from documents shown in the UI.
                        // The backend uploads it to QBench without exposing it as a portal document.
                        orderState.importedExcelFiles.push(results[1]);
                    } else {
                        restoreImportState();
                    }
                });
                return importSucceeded;
            })
            .then(function(importSucceeded) {
                fileInput.value = '';
                orderState.processingExcelUpload = false;
                $scope.$apply();
                return importSucceeded;
            })
            .catch(function(error) {
                restoreImportState();
                fileInput.value = '';
                orderState.processingExcelUpload = false;
                $scope.$apply();
                AlertService.error('Upload failed. The Excel file could not be read.');
                return false;
            });
        }

        // $('#submittingModal').modal('show'); ======================

        vm.isExcelImportProcessing = function() {
            return !!(
                (vm.food && vm.food.processingExcelUpload) ||
                (vm.comp && vm.comp.processingExcelUpload) ||
                (vm.rd && vm.rd.processingExcelUpload)
            );
        };

        vm.switch_tab = function(tab, event) {
            if (vm.isExcelImportProcessing()) {
                if (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
                return false;
            }

            angular.forEach(vm.active_tab, function(value, key) {
                vm.active_tab[key] = false;
            });

            vm.active_tab[tab] = true;
            return true;
        };

        function setAvailableTabs(customer_type) {
                        switch(customer_type) {
                case 'cannabis' :
                    vm.show_tab.comp = true;
                    vm.show_tab.rd = true
                    // vm.show_tab.fda = true
                    // vm.active_tab.comp = true;
                    vm.active_tab.rd = true;
                    break;
                case 'hemp':
                    vm.show_tab.rd = true;
                    vm.active_tab.rd = true;
                    // vm.show_tab.fda = true
                    break;
                case 'food service':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
                case 'kratom':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    vm.food.turnaround_time = '5 day (standard)';
                    break;
                case 'other':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
                case 'fda':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    vm.show_tab.fda = true;
                    break;
                default:
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
            }

            getUserEmails();
        }

        vm.give_focus = function(sample, attribute) {
            sample.focus[attribute] = true;
        }

        vm.lose_focus = function(sample, attribute) {
            sample.focus[attribute] = false;
        }

        var QB_VALID_CHARS = /[^A-Za-z0-9,.\?@&!#'~* _\-;+\/:]/g;
        function stripInvalidQBChars(val) {
            if (val === null || val === undefined) return val;
            // Excel can return numeric sample descriptions; normalize before cleaning.
            return String(val).replace(QB_VALID_CHARS, '');
        }

        vm.set_sample_lot_batch_number = function(sample, lot_batch_number) {
            sample.sample_lot_batch_number = stripInvalidQBChars(lot_batch_number);
            sample.options.lot_batch_number = false;
            sample.focus.lot_batch_number = false;
        }

        vm.set_sample_name = function(sample, name) {
            sample.sample_name = stripInvalidQBChars(name);
            sample.options.name = false;
            sample.focus.name = false;
        }

        var ingredientDebounce = null;
        vm.query_ingredients = function(sample) {
            if(ingredientDebounce) { $timeout.cancel(ingredientDebounce); }
            if(sample.ingredient_input.length > 2) {
                ingredientDebounce = $timeout(function() {
                    SampleFilter.ingredients({keyword: sample.ingredient_input},
                        function(data) {
                            sample.options.ingredients = data.length > 0 ? data : [];
                        },
                        function(e) {
                            console.log(e);
                            sample.options.ingredients = [];
                    });
                }, 250);
            } else {
                sample.options.ingredients = [];
            }
        }

        vm.add_ingredient = function(sample, value) {
            if(!sample.sample_product_ingredients_tags) { sample.sample_product_ingredients_tags = []; }
            var val = (value || '').trim();
            var lowerVal = val.toLowerCase();
            var exists = sample.sample_product_ingredients_tags.some(function(t) { return t.toLowerCase() === lowerVal; });
            if(val && !exists) {
                sample.sample_product_ingredients_tags.push(val);
                sample.sample_product_ingredients = sample.sample_product_ingredients_tags.join(', ');
            }
            sample.ingredient_input = '';
            sample.options.ingredients = [];
        }

        vm.remove_ingredient = function(sample, index) {
            if(!sample.sample_product_ingredients_tags) { sample.sample_product_ingredients_tags = []; }
            sample.sample_product_ingredients_tags.splice(index, 1);
            sample.sample_product_ingredients = sample.sample_product_ingredients_tags.length > 0 ? sample.sample_product_ingredients_tags.join(', ') : null;
        }

        vm.ingredient_keydown = function(sample, $event) {
            if($event.keyCode === 13 || $event.keyCode === 188) {
                $event.preventDefault();
                vm.add_ingredient(sample, sample.ingredient_input);
            }
            if($event.keyCode === 8 && !sample.ingredient_input && sample.sample_product_ingredients_tags && sample.sample_product_ingredients_tags.length > 0) {
                vm.remove_ingredient(sample, sample.sample_product_ingredients_tags.length - 1);
            }
        }

        vm.orderFieldOptions = { specialInstructions: [], customerComments: [] };
        vm.orderFieldFocus = {};

        var orderFieldDebounce = null;
        vm.query_order_field = function(orderType, field, dbField) {
            if(orderFieldDebounce) { $timeout.cancel(orderFieldDebounce); }
            var val = vm[orderType][field];
            if(val && val.length > 2) {
                orderFieldDebounce = $timeout(function() {
                    SampleFilter.orderField({field: dbField, keyword: val},
                        function(data) { vm.orderFieldOptions[field] = data; },
                        function(e) { console.log(e); vm.orderFieldOptions[field] = []; });
                }, 250);
            } else { vm.orderFieldOptions[field] = []; }
        }

        vm.set_order_field = function(orderType, field, value) {
            vm[orderType][field] = value;
            vm.orderFieldOptions[field] = [];
        }

        vm.set_sample_autofill = function(sample, option) {
            if(option.name) {
                sample.sample_name = stripInvalidQBChars(option.name);
            }

            if(option.product_category_id) {
                var category_index = findWithAttr(vm[sample.sample_order_type].categories, 'id', option.product_category_id)
                if(category_index != -1) {
                    sample.sample_category = vm[sample.sample_order_type].categories[category_index]
                    vm[sample.sample_order_type].populateTypes(sample)
                }
            }
            else {
                sample.sample_category = null;
            }

            if(option.product_type_id) {
                var type_index = findWithAttr(sample.sample_types, 'id', option.product_type_id)
                if(type_index != -1) {
                    sample.sample_type = sample.sample_types[type_index]
                }
            }
            else {
                sample.sample_type = null;
            }

            if(option.inhalable_edible) {
                var type_index = findWithAttr(vm.inhalable_edible_array , 'name', option.inhalable_edible)
                if(type_index != -1) {
                    sample.sample_inhalable = vm.inhalable_edible_array [type_index]
                }
            }
            else {
                sample.sample_inhalable = null;
            }

            sample.sample_product_ingredients = option.product_ingredients ? option.product_ingredients : null;
            sample.sample_product_ingredients_tags = option.product_ingredients ? option.product_ingredients.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : [];

            sample.focus.autofill = false;
            checkPage(sample.sample_order_type);
        }

        vm.query_autofill = function(sample) {
            sample.sample_name = stripInvalidQBChars(sample.sample_name);
            if(sample.sample_name.length > 2) {
                SampleFilter.autofill({attribute: 'name', keyword: sample.sample_name},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.autofillSampleInfo = [];
                        }
                        else {
                            sample.options.autofill = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }
        vm.query_sample_lot_batch_number = function(sample) {
            sample.sample_lot_batch_number = stripInvalidQBChars(sample.sample_lot_batch_number);
            if(sample.sample_lot_batch_number.length > 2) {
                SampleFilter.attribute({attribute: 'lot_batch_number', keyword: sample.sample_lot_batch_number},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.lot_batch_number = [];
                        }
                        else {
                            sample.options.lot_batch_number = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }

        vm.query_sample_name = function(sample) {
            sample.sample_name = stripInvalidQBChars(sample.sample_name);
            if(sample.sample_name.length > 2) {
                SampleFilter.attribute({attribute: 'name', keyword: sample.sample_name},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.name = [];
                        }
                        else {
                            sample.options.name = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }

        function checkPage(order_type) {
            switch(order_type) {
                case 'rd':
                    vm.rd.checkPageOne();
                    break;
                case 'comp':
                    vm.comp.checkPageOne();
                    break;
                case 'food':
                    vm.food.checkPageOne();
                    break;
            }
        }

        vm.const = {
            PLANT : 'POTENCY_PLANT',
            NON_PLANT: 'POTENCY_LCDAD_NON_PLANT'
        }

        vm.inhalable_edible_array  = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value':'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value':'NONINHALABLE'
            }
        ];

        function getCustomerData() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
                 // not currently being used
                //  vm.customerData.added_assays = JSON.parse(data.added_assays);

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');

                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if(vm.customerData.qbAddress) {
                     vm.customerData.qbAddressArray = vm.customerData.qbAddress.split('\n');
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                	 vm.customerData.privateSampleByDefault = false;
                 }
                 vm.customerData.default_addresses = vm.customerData.default_addresses && JSON.parse(vm.customerData.default_addresses);
                 if(vm.customerData.default_addresses){
                    var addresses = vm.customerData.default_addresses
                    $scope.records.forEach(function(element){
                        if(element.id == addresses.distributionLocation){
                            vm.samplingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                        }

                        if(element.id == addresses.manufacturingLocation){
                            vm.manufacturingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);                            
                        }

                        if(element.id == addresses.pickupLocation){
                            vm.pickup_address = createInvoicingAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence);                            
                        }

                        if(element.id == addresses.samplingLocation){
                            vm.pickup_address = createInvoicingAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence);                            
                        }

                        if(element.id == addresses.cultivationLocation){
                            vm.manufacturingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                            vm.samplingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                        }
                    })
                    var distribution = $scope.records.find(function(record){
                        return record.id == addresses.distributionLocation
                    })
                    if (distribution) {
                      vm.fullLocationComp = distribution.fullLocation;
                    }
                    var manufacture = $scope.records.find(function(record){
                      return record.id == addresses.manufacturingLocation
                    })
                    if (manufacture) {
                      vm.fullLocationManufactur = manufacture.fullLocation;
                    }

                    var pickup = $scope.records.find(function(record){
                        return record.id == addresses.pickupLocation
                    })
                    if (pickup) {
                      vm.fullLocationPickup = pickup.fullLocation;
                    }

                    var sampling = $scope.records.find(function(record){
                        return record.id == addresses.samplingLocation
                    })
                    if (sampling) {
                      vm.fullLocationSampling = sampling.fullLocation;
                    }

                    var reporting = $scope.records.find(function(record){
                        return record.id == addresses.cultivationLocation
                    })
                    if (reporting) {
                      vm.fullLocationreporting = reporting.fullLocation;
                      vm.fullLocationManufactur = reporting.fullLocation;
                    }
                  }
                 if(vm.show_tab.rd) {
                     rd.getAssayData();
                     rd.getCategories();
                     // getQbenchPanels is now called at the end of rd.getAssayData() after showTestsArray is populated
                 }
                 else if(vm.show_tab.analysis) {
                     food.getAssayData();
                     // Both QBench panels and customer panels are now loaded at the end of food.getAssayData()
                }
                getCurrentContact();
            }
            function onError(e) {
                console.log(e);
            }
        }

        rd.getCustomerData = function() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
                 // not currently being used
                //  vm.customerData.added_assays = JSON.parse(data.added_assays);

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');
                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                	 vm.customerData.privateSampleByDefault = false;
                 }

                rd.getAssayData();
            }
            function onError(e) {
                console.log(e);
            }
        }

        rd.getCategories = function() {
            ProductCategory.query({}, onSuccess, onError);

            function onSuccess(data, headers) {
                 // Filter out Environmental category if language is Japanese
                 if ($localStorage.language === 'Japanese') {
                    vm.rd.categories = data.filter(function(category) {
                        return category.name !== 'Environmental';
                    });
                } else {
                    vm.rd.categories = data;
                }
                rd.getTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        food.getCustomerData = function() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');
                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                     vm.customerData.privateSampleByDefault = false;
                 }

                food.getAssayData();
                
                // Load customer-specific panels
                food.getCustomerPanels();
            }
            function onError(error) {

            }
        }

// **************************** START FOOD FUNCTIONS ****************************

        vm.food.step = 1;
        vm.food.pageOneValid = false;
        vm.food.pageTwoValid = false;
        vm.food.pageThreeValid = false;
        vm.food.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.food.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.food.file = null;
        vm.food.specialInstructions = null;
        vm.food.customerComments = null;
        // vm.food.turnaroundTime = null;
        vm.food.turnaroundTime  = vm.food.turnaroundTimeOptions ? null : '10 Days (standard)';
        vm.food.estimated_report_date = null;
        vm.food.categories = null;
        vm.food.sampleArray = [];
        vm.food.all_types = null;
        vm.food.existing_user_added_assays = [];
        vm.food.manufacturing_address = null;
        vm.food.deliveryPreference = null;
        vm.food.orderPO = null;
        vm.food.pickup_arrival_date = null;
        vm.food.emails = '';
        vm.food.samples = [];
        vm.food.tests = [];
        vm.food.testsRequested = [];
        vm.food.testsRequestedCount = [];
        vm.food.total = 0;
        vm.food.mainCollapse = false;
        vm.food.subtotal = null;
        vm.food.total_discount = 0;
        vm.food.excel_assay_header = null;
        vm.food.processingExcelUpload = false;
        vm.food.assay_map = {};
        vm.food.assay_map_by_index = {};
        vm.food.all_assay_map_by_id = {};
        vm.food.all_tests = [];
        vm.food.showTests = {};
        vm.food.showTestsArray = [];
        vm.food.showTestResults = null;
        vm.food.panels = {};
        vm.food.panels.current_panel_index = null;
        vm.food.panels.new_panel_name = null;
        vm.food.panel_by_id_map = {}
        vm.food.current_sample_name = null;
        vm.food.customPanels = [];
        vm.food.qbenchPanels = [];
        vm.food.test_to_search = '';
        vm.food.other_analyses = [];
        vm.food.user_added_assays = [];
        vm.food.existing_user_added_assays = [];
        vm.food.number_of_freq_assays = 0;
        vm.food.submitting = false;
        vm.food_sample_matrix = null;
        vm.food.uploadedFiles = [];
        vm.food.importedExcelFiles = [];

        vm.food.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.food.uploadedFiles);
                currentSize += getTotalFileSize(vm.food.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('food-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.food.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('food-file-upload').value = '';
            }
        };

        vm.food.removeFile = function(index) {
            vm.food.uploadedFiles.splice(index, 1);
        };

        function parseInstrument(instrument) {
            var matching_string = '';
            if(instrument) {
                if(instrument.length > 10) {
                    matching_string = instrument.match(/\(([^)]+)\)/);
                    if(matching_string) {
                        return matching_string[1];
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return instrument;
                }
            }
            else {
                return '';
            }
        }

        function splitString(string) {
            var string_array = null;
            if(string) {
                if(string.includes('|')) {
                    string_array = string.split('|').map( function(item) {
                        return item.trim();
                    });
                }
                else {
                    string_array = string.split(',').map( function(item) {
                        return item.trim();
                    });
                }
                return string_array;
            }
            else {
                return [];
            }
        }

        function addCommasToList(list) {
            if(list) {
                if(list.length > 1) {
                    for(var i = 0; i < list.length - 1; i++) {
                        list[i] += ','
                    }
                }
            }
        }

            // Function to get Japanese description based on assay ID
            function getJapaneseDescription(assayId) {
                // Map of assay IDs to Japanese descriptions from the CSV file
                var japaneseDescriptions = {
                    '930': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（13種）を実施します。',
                    '978': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（D8-THC, THCV, THCVAを除く10種）を実施します。',
                    '931': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（追加分析パッケージ含む30種）を実施します。',
                    '5': 'GC-MSを使用し、カリフォルニア州法で定められている20種類の残留溶媒のスクリーニングを実施します。',
                    '6': 'ICP-MSを用いたヒ素、カドミウム、鉛、水銀のスクリーニング試験（重金属検査）を実施します。',
                    '797': 'アピゲニン｜ケルセチン｜ルテオリン｜ミリセチン｜ケンフェロール｜ルチン｜ビテキシン｜イソビテキシン｜ビテキシン｜オリエンチン｜イソビテキシン｜ルチン｜イソビテキシン｜カテキン｜エピカテキンガレート（EGCG）｜ビテキシン',
                    '780': 'アメリカの各州が定めるヘンプ製品の重金属基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '37': 'カンナビノイド含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。',
                    '12': '米国薬局法（USP）のガイドラインに準拠したカンナビノイドの含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。',
                    '14': '標準平板菌数、酵母およびカビ、大腸菌群、一般大腸菌の定量試験を含む品質管理を目的とした微生物分析パネル。',
                    '4': '吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌、サルモネラ菌およびアスペルギルスのパネル分析を実施します。',
                    '17': '非吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌およびサルモネラ菌のパネル分析を実施します。',
                    '951': 'アメリカの各州が定めるヘンプ製品の微生物基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '16': 'アフラトキシン B1、B2、G1、G2、およびオクラトキシンAの検査を含みます。',
                    '764': 'カリフォルニア州大麻取締局の要件に準拠した21種類のカテゴリーI農薬、45種類のカテゴリーII農薬、アフラトキシン、およびオクラトキシンが含まれます。',
                    '8': 'LC-MS/MSおよびGC-MS/MSを使用し、カリフォルニア州大麻取締局の基準に基づいた66種類の農薬スクリーニングを実施します。',
                    '779': 'アメリカの各州が定めるヘンプ製品の農薬基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '86': '「志賀毒素産生性大腸菌（Shiga toxin-producing E. coli: STEC）」検査は、特に重篤な食中毒を引き起こす可能性のある志賀毒素（Stx、またはベロ毒素: VT）を産生する大腸菌の存在を確認するための検査です。別名「腸管出血性大腸菌（Enterohemorrhagic E. coli: EHEC）」とも呼ばれます。',
                    '315': 'サルモネラ菌検査は、食中毒の原因菌として知られるサルモネラ属菌が存在するかどうかを確認するための検査です。',
                    '75': '「標準平板菌数（Standard Plate Count: SPC）」とは、食品や環境中の衛生状態を評価するための指標となる菌数を測定する検査です。別名「一般生菌数」とも呼ばれます。',
                    '7': 'GC-MSを使用し、大麻の花や製品に最も一般的に含まれる27種類のテルペノイドのプロファイリングを実施します。',
                    '60': '',
                    '18': '「水分活性（water activity: Aw）」とは、食品や化粧品、医薬品などの製品中に含まれる水分の中で、微生物が利用できる自由水の割合を示す指標であり、その製品の保存性や安定性を評価するための重要な検査です。',
                    '1023': '酵母とカビ（これらを総称して「真菌」と呼ぶこともあります）の存在とその量を調べる検査です。これらの微生物は、製品の変質、劣化、または健康被害の原因となることがあるため、品質管理や衛生管理において非常に重要です。',
                    '19': '製品の中に、本来含まれるべきではない物質が混入していないかを確認するための検査全般を指します。顧客からのクレーム対応や、製造工程における品質管理、そして最終的には消費者の安全を確保するために不可欠な検査です。'
                };
                
                return japaneseDescriptions[assayId] || null;
            }


        function parseAssayInfoModalData(assay) {
            var base_price = null;
            var discount = null;
            var display_price = null;
            var method = null
            var instrument = null;
            var description = null;
            var duration = null;
            var minimum_quantity_required = null;
            var optimum_quantity_required = null;

            if(assay.basePrice) {
                base_price = assay.basePrice
            }

            if(vm.company_discount) {
                discount = vm.company_discount;
            }

            if(assay.duration) {
                duration = assay.duration;
            }

            if(assay.minimum_quantity_required) {
                minimum_quantity_required = assay.minimum_quantity_required;
            }

            if(assay.optimum_quantity_required) {
                optimum_quantity_required = assay.optimum_quantity_required;
            }

            if(assay.assay_customer) {
                if(assay.assay_customer.active) {
                    if(assay.assay_customer.basePrice) {
                        base_price = assay.assay_customer.basePrice;
                    }
                    if(assay.assay_customer.discount) {
                        discount = assay.assay_customer.discount;
                    }
                }
            }

            if(assay.instrument) {
                instrument = splitString(assay.instrument)
                instrument.forEach( function(item, index) {
                    if(parseInstrument(item) != ""){
                        instrument[index] = parseInstrument(item);
                    }
                });
                instrument = null
                addCommasToList(method);
            }

            if(assay.method) {
                method = splitString(assay.method);
                // addCommasToList(method);
            }

            if(assay.analysis_description) {
                description = assay.analysis_description;
            }

            if($localStorage.language === 'Japanese') {
                var japaneseDesc = getJapaneseDescription(assay.id);
                if(japaneseDesc) {
                    description = japaneseDesc;
                }
            }


            if(base_price) {
                if(discount) {
                    display_price = base_price * (1 - (discount / 100));
                }
                else {
                    display_price = base_price;
                }
            }

            if(base_price == display_price) {
                display_price = null;
            }

            if(base_price) {
                base_price = $filter('currency')(base_price);
            }

            if(display_price) {
                display_price = $filter('currency')(display_price);
            }

            if(base_price || method || instrument || description || duration || minimum_quantity_required || optimum_quantity_required) {
                return({
                    base_price: base_price,
                    discount: discount,
                    display_price: display_price,
                    method: method,
                    instrument: instrument,
                    description: description,
                    duration: duration,
                    minimum_quantity_required: minimum_quantity_required,
                    optimum_quantity_required: optimum_quantity_required
                });
            }
            else {
                return null;
            }
        }

        food.serializeSamples = function(samples) {
            var serializedSamples = [];
            if (samples) {
                samples.forEach( function(sample){
                    serializedSamples.push({
                        description: sample.sample_name,
                        lotBatchNumber: sample.sample_lot_batch_number ? sample.sample_lot_batch_number : null,
                        timeOfCollection: sample.sample_time_of_collection_backend ? sample.sample_time_of_collection_backend : null,
                        comments: sample.sample_comments ? sample.sample_comments : null,
                        otherAnalysis: sample.sample_other_analyses ? formatOtherAnalyses(sample.sample_other_analyses) : null,
                        sampleTests: formatSampleTests(sample, 'food'),
                        expirationDate: formatDate(sample.sample_expiration_date),
                        production_date: formatDate(sample.sample_production_date),  // ADD THIS 
                        upc_number: sample.sample_upc_number ? sample.sample_upc_number : null,
                        number_of_units_submitted: sample.sample_number_of_units_submitted ? sample.sample_number_of_units_submitted : null,
                        sample_condition: sample.sample_condition ? sample.sample_condition : null,
                        sample_matrix: sample.food_sample_matrix ? sample.food_sample_matrix : null,
                        supplier_name: sample.sample_supplier_name ? sample.sample_supplier_name : null,     // ADD THIS 
                        supplier_lot_code: sample.sample_supplier_lot_code ? sample.sample_supplier_lot_code : null, // ADD THIS 
                        expected_potency: sample.sample_expected_potency ? sample.sample_expected_potency : null
                    });
                });
            }
            return serializedSamples;
        }

        food.serializePayload = function() {
            vm.food.submitting = true;
            var payload = {
                orderType: "FOOD",
                collection_type: null,
                customer_account_id: $localStorage.customerId,
                dateCreated: null,
                dateReceived: null,
                date_submitted: null,
                delivery_preference: formatDeliveryPreference(vm.food.deliveryPreference),
                estimated_arrival_date: formatDate(vm.food.pickup_arrival_date),
                partially_complete: null,
                poNumber: vm.food.orderPO,
                reporting_preference: null,
                sample_condition: null,
                sampledDate: formatDate(vm.food.pickup_arrival_date),
                samplingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
                invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
                shipping_carrier: null,
                specialInstructions: vm.food.specialInstructions,
                customerComments: vm.food.customerComments,
                state: null,
                pickup_address: vm.pickup_address ? vm.pickup_address : null,
                phone_number: vm.contact.phone ? vm.contact.phone : null,
                submitted_by: vm.food.emailsArray.join(),
                dynamic_turnaround_time: vm.food.turnaroundTime,
                id: null,
                samples: food.serializeSamples(vm.food.samples),
                tracking_number: vm.food.tracking_number,
                uploaded_files: vm.food.uploadedFiles,
                source_workbooks: vm.food.importedExcelFiles
            }

            return payload;
        }
        function formatOtherAnalyses(other_analyses) {
            var requested_tests = [];
            angular.forEach(other_analyses, function(value, key) {
                    requested_tests.push(key);
            });

            return requested_tests;
        }       

        vm.food.submitOrder = function() {
            $rootScope.type = 'FOOD';
            CustomerOrder.save(food.serializePayload(), onSaveSuccess, onSaveError);
        }


        vm.food.cancelOrder = function() {
            location.reload();
        }

        vm.food.sampleConditionOptions = ['Ambient', 'Refrigerated', 'Frozen'];

        vm.food.addSample = function() {
            vm.food.samples.push({
                sample_expanded: vm.food.mainCollapse,
                sample_order_type: 'food',
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_time_of_collection: null,
                sample_time_of_collection_frontend: null,
                sample_time_of_collection_backend: null,
                sample_expiration_date: null,
                sample_expiration_date_open: false,
                sample_production_date: null,
                sample_production_date_open: false,
                sample_time_of_collection_open: false,
                sample_calendar_open: false,
                sample_tests: [],
                sample_other_analyses: {},
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                sample_upc_number: null,
                sample_number_of_units_submitted: null,
                sample_condition: null,
                focus: {
                    name: false,
                    lot_batch_number: false
                },
                options: {
                    name: [],
                    lot_batch_number: []
                }
            });
            vm.food.checkPageOne();
        }

        function formatDateTimeForOrder(date, useUTC) {
            var dateObj = new Date(date);
            if (isNaN(dateObj.getTime())) return null;

            var months, days, year, hours, minutes;
            if (useUTC) {
                months = dateObj.getUTCMonth() + 1;
                days = dateObj.getUTCDate();
                year = dateObj.getUTCFullYear();
                hours = dateObj.getUTCHours();
                minutes = dateObj.getUTCMinutes();
            } else {
                months = dateObj.getMonth() + 1;
                days = dateObj.getDate();
                year = dateObj.getFullYear();
                hours = dateObj.getHours();
                minutes = dateObj.getMinutes();
            }

            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;

            var formattedDate = `${months.toString().padStart(2, '0')}/${days.toString().padStart(2, '0')}/${year}`;
            var formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;

            return `${formattedDate} ${formattedTime}`;
        }


        food.formatSampleDateTime = function(sample) {
            // Frontend: local timezone for display
            sample.sample_time_of_collection_frontend = formatDateTimeForOrder(sample.sample_time_of_collection, false);
            // Backend: UTC for QBench submission
            sample.sample_time_of_collection_backend = formatDateTimeForOrder(sample.sample_time_of_collection, true);

            return;
        }

        vm.food.checkPageOne = function() {
            var date = null;
            if (vm.food.samples.length < 1) {
                vm.food.pageOneValid = false;
                return;
            }
            for(var i = 0; i < vm.food.samples.length; i++) {
                date = vm.food.samples[i].sample_time_of_collection;
                if (!vm.food.samples[i].sample_name || !vm.food.samples[i].sample_condition) {
                    vm.food.pageOneValid = false;
                    return;
                }
            }
            vm.food.pageOneValid = true;
            return;
        }

        vm.food.checkPageTwo = function() {
            var other_analysis_is_empty = null;
            var sample_array_is_empty = null;

            for(var i = 0; i < vm.food.samples.length; i++) {
                if(vm.food.samples[i].sample_time_of_collection) {
                    food.formatSampleDateTime(vm.food.samples[i]);
                }

                other_analysis_is_empty = Object.keys(vm.food.samples[i].sample_other_analyses).length == 0;
                sample_array_is_empty = vm.food.sampleArray[i] ? Object.keys(vm.food.sampleArray[i]).length == 0 : true;

                if (sample_array_is_empty && other_analysis_is_empty){
                    vm.food.pageTwoValid = false;
                    return;
                }
                else {
                    if (sample_array_is_empty) {
                        if (Object.values(vm.food.samples[i].sample_other_analyses).indexOf(true) == -1) {
                            vm.food.pageTwoValid = false;
                            return
                        }
                    }
                    else if (other_analysis_is_empty) {
                        if (Object.values(vm.food.sampleArray[i]).indexOf(true) == -1) {
                            vm.food.pageTwoValid = false;
                            return;
                        }
                    }
                    else {
                        if ((Object.values(vm.food.samples[i].sample_other_analyses).indexOf(true) == -1) && (Object.values(vm.food.sampleArray[i]).indexOf(true) == -1)) {
                            vm.food.pageTwoValid = false;
                            return;
                        }
                    }
                }
            }
            vm.food.pageTwoValid = true;
            return;
        }

        vm.food.checkPageThree = function() {
            if (
                !vm.food.pickup_arrival_date ||
                !vm.food.deliveryPreference ||
                !($('#foodEmailRecepients').val().length > 0) ||
                (vm.food.deliveryPreference==='Anresco Pick-Up' && !vm.fullLocationPickup) ||
                (vm.fullLocationPickup && !vm.contact.phone) ||
                vm.pickupOutOfStateError 

            ) {
                vm.food.pageThreeValid = false;
                return;
            }
            vm.food.pageThreeValid = true;
            return;
        }

        vm.food.removeSample = function(index) {
            vm.food.samples.splice(index, 1);
            vm.food.sampleArray.splice(index, 1);
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        vm.food.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.food.estimateReportDate = function(turnaround_time) {
            var days_length = turnaround_time.split(' days')[0];
            var days = null;

            if(days_length.includes('-')) {
                days = days_length.split('-')[1];
            }
            else {
                days = days_length;
            }

            days = parseInt(days);

            if (days && turnaround_time && vm.food.pickup_arrival_date) {
                var tomorrow = new Date(vm.food.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.food.estimated_report_date = tomorrow;
            }

            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.food.estimated_report_date.day = days[tomorrow.getDay()]
                vm.food.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.food.checkPageThree();
        }

        vm.food.deleteChecked = function() {
            for(var i = vm.food.samples.length-1; i >= 0; i--) {
                if (vm.food.samples[i].sample_delete) {
                    vm.food.samples.splice(i, 1);
                }
            }
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        food.resetDeleteCheckboxes = function() {
            $(':checkbox.food-delete-checkbox-header')[0].checked = false;
            vm.food.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.food.clickCheckAllTest = function(col) {
            var testToAdd = vm.food.assay_map_by_index[col];
            var found = false;
            var selector = ':checkbox.assay-col-header-' + col;
            var test = {};

            vm.food.samples.forEach( function(sample, sample_index) {
                sample.sample_tests.forEach( function(test, test_index) {
                    if (test.id == testToAdd.id) {
                        found = true;
                        sample.sample_tests[test_index].checked = $(selector)[0].checked;
                        vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                        
                        // Check if this sample has a panel selected and update panel status if needed
                        if (sample.sample_panel_selected && !$(selector)[0].checked) {
                            vm.food.checkPanelTestsSelection(sample_index);
                        }
                    }
                });
                if (!found) {
                    if (!vm.food.sampleArray[sample_index]) {
                        vm.food.sampleArray[sample_index] = {};
                        vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                    }
                    test = Object.assign({}, testToAdd)
                    vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                    test.checked = $(selector)[0].checked;
                    
                    // Check if this sample has a panel selected and update panel status if needed
                    if (sample.sample_panel_selected && !$(selector)[0].checked) {
                        vm.food.checkPanelTestsSelection(sample_index);
                    }
                    sample.sample_tests.push(test);
                }
                found = false;
               food.checkSampleContainsTrueTests(sample_index);
            });
            vm.food.checkPageTwo();
        }


        vm.food.clickCheckAllDelete = function() {
            vm.food.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.food-delete-checkbox-header')[0].checked;
            });
        }

        vm.food.clickDelete = function(index) {
            vm.food.samples[index].sample_delete = !vm.food.samples[index].sample_delete;
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
        }

        vm.food.checkClick = function (sample, testToAdd, row, col) {
            
            
            var found = false;
            var test = null;
            $(':checkbox.assay-col-header-' + col)[0].checked = false;
            // check if test exists, if yes then checked = !checked
            for(var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].id == testToAdd.id) {
                    found = true;
                    sample.sample_tests[i].checked = vm.food.sampleArray[row][col];
                    // If a test is unchecked and it's part of a panel, check if we need to remove panel association
                    if (!sample.sample_tests[i].checked && sample.sample_panel_selected) {
                        // Call checkPanelTestsSelection to update panel association
                        vm.food.checkPanelTestsSelection(row);
                    }
                    break;
                }
            }
            // if no, add that test
            if (!found) {
                test = Object.assign({}, testToAdd);
                test.checked = true;
                
                
                // Ensure manually added tests have panel_id and panel_name set to null
                test.panel_id = null;
                test.panel_name = null;
                
                // Handle source_uid vs source_id mapping as mentioned in memories
                if (test.source_id && !test.source_uid) {
                    test.source_uid = test.source_id;
                }
                
                sample.sample_tests.push(test);
            }

            food.checkSampleContainsTrueTests(row);
            vm.food.checkPageTwo();
            
            // Always check panel tests selection to ensure UI is updated
            if (sample.sample_panel_selected) {
                vm.food.checkPanelTestsSelection(row);
            } else {
                // Only call organizeTests directly if we didn't call checkPanelTestsSelection
                // (which already calls organizeTests)
                // Organize tests for display
                vm.food.organizeTests(sample);
            }
        }

        vm.food.incrementPage = function() {
            vm.food.step = vm.food.step + 1;

            if(vm.food.step == 2) {
                vm.food.checkPageTwo();
                setTimeout( function() {
                    // food.setInfoBoxCoordinates();
                }, 100);
            }
            else if (vm.food.step == 3) {
                vm.generateTurnaroundTimes(vm.food);
                
                // Figure out which tests will be submitted for step 4 display
                vm.food.samples.forEach(function(sample) {
                    var rawTests = formatSampleTests(sample, 'food');
                    
                    // Reorganize: individual tests first, then grouped by panel
                    var individualTests = [];
                    var panelTests = {};
                    
                    rawTests.forEach(function(test) {
                        if (test.panel && test.panel.id) {
                            // Group by panel ID
                            if (!panelTests[test.panel.id]) {
                                panelTests[test.panel.id] = {
                                    panelName: vm.getPanelDisplayNameById(test.panel.id, 'food'),
                                    tests: []
                                };
                            }
                            panelTests[test.panel.id].tests.push(test);
                        } else {
                            // Individual test
                            individualTests.push(test);
                        }
                    });
                    
                    // Build final organized array
                    sample.actualFormattedTests = individualTests;
                    
                    // Add each panel group
                    Object.keys(panelTests).forEach(function(panelId) {
                        var panel = panelTests[panelId];
                        // Add a panel header marker
                        sample.actualFormattedTests.push({
                            isPanelHeader: true,
                            panelName: panel.panelName
                        });
                        // Add all tests for this panel
                        panel.tests.forEach(function(test) {
                            sample.actualFormattedTests.push(test);
                        });
                    });
                });
            }
            else if(vm.food.step == 4) {
                vm.food.emailsArray = vm.food.emails.split(',');
                // Organize tests for each sample to populate nonPanelTests and panelTests arrays
                vm.food.samples.forEach(function(sample) {
                    vm.food.organizeTests(sample);
                });
            }
            food.cleanUncheckedTests();
        }

        vm.food.decrementPage = function() {
            vm.food.step = vm.food.step - 1;

            if(vm.food.step == 2) {
                vm.food.checkPageTwo();
                setTimeout( function() {
                    // food.setInfoBoxCoordinates();
                }, 100);
            }
        }

        vm.food.removeSample = function(index) {
            vm.food.samples.splice(index, 1);
            vm.food.sampleArray.splice(index, 1);
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        vm.food.cloneSample = function(index) {
            var clonedSample = angular.copy(vm.food.samples[index]);
            vm.food.samples.splice(index + 1, 0, clonedSample);
            if (vm.food.sampleArray && vm.food.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.food.sampleArray[index]);
                vm.food.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        };

        function shouldShowAssayForLanguage(assay) {
            if ($localStorage.language !== 'Japanese') {
                return true;
            }

            var clientTypeList = assay && assay.portal_client_type_list;
            if (typeof clientTypeList === 'string') {
                try {
                    clientTypeList = JSON.parse(clientTypeList);
                } catch (e) {
                    return false;
                }
            }

            return Array.isArray(clientTypeList) && clientTypeList.indexOf('Japanese') !== -1;
        }

        food.addAssay = function(test) {
            if (!shouldShowAssayForLanguage(test)) {
                return;
            }
            if(test.id != 13) {
                // Prevent duplicates in showTestsArray
                if (vm.food.showTestsArray.indexOf(test.display_name) === -1) {
                    vm.food.showTests[test.display_name] = true;
                    vm.food.showTestsArray.push(test.display_name);
                    
                    // Set the index for the new test
                    test.index = vm.food.tests.length;
                    vm.food.tests.push(test);
                    
                    // CRITICAL: Update assay_map so setPanel can find this assay
                    vm.food.assay_map[test.display_name] = [test.index, test];
                    vm.food.assay_map_by_index[test.index] = test;
                }
            }
        }

        food.createAssayMaps = function() {
            vm.food.tests.forEach( function(test, index) {
                test.index = index;
                vm.food.assay_map[test.display_name] = [index, test]
                vm.food.assay_map_by_index[index] = test;
            });
        }

        food.getAssaysAddedByAnrescoBillingTab = function() {
            vm.customerData.assay_customer.forEach( function(assay_customer) {
                vm.food.all_tests.forEach( function(assay) {
                    if (assay.id == assay_customer.assay_id) {
                        // Check if this assay is already in vm.food.tests (added via portal_client_type_list or portal_client_type)
                        var existingTestIndex = findWithAttr(vm.food.tests, 'id', assay.id);
                        
                        if (existingTestIndex != -1) {
                            // Assay already exists in tests (added via precedence 1 or 2)
                            // Update its assay_customer data to include count for frequent tests
                            vm.food.tests[existingTestIndex].assay_customer = assay_customer;
                        } else if (assay_customer.active) {
                            // Only add new assays if they're active
                            food.addAssay(assay);
                        }
                    }
                });
            });
        }

        food.getAssayData = function() {
            // Use GraphQL for lightweight payload (~150KB vs 1.6MB from REST)
            GraphQLService.query(ASSAYS_LIST_QUERY, { enabled: true }).then(function(result) {
                var data = result.assaysList;
                if (data) {
                    var index = 0;
                    var test = null;
                    var add_assay = true;

                    // Build HashMap for O(1) lookup instead of O(n) search per assay
                    var assayCustomerMap = {};
                    if (vm.customerData && vm.customerData.assay_customer) {
                        vm.customerData.assay_customer.forEach(function(ac) {
                            assayCustomerMap[ac.assay_id] = ac;
                        });
                    }
                    data.forEach( function(assay) {
                        // Language eligibility must be checked before business-type or legacy matching.
                        if (!shouldShowAssayForLanguage(assay)) {
                            return;
                        }
                        if (add_assay) {
                            assay.assay_customer = assayCustomerMap[assay.id] || null;

                            test = {
                                info_modal: parseAssayInfoModalData(assay),
                                portal_identifier: assay.portalIdentifier ? assay.portalIdentifier : null,
                                portal_client_type: assay.portal_client_type ? assay.portal_client_type : null,
                                portal_client_type_list: assay.portal_client_type_list ? assay.portal_client_type_list : null,
                                display_name: assay.title,
                                reporting_title: assay.reporting_title ? assay.reporting_title : assay.title,
                                base_price: assay.basePrice,
                                assay_customer: assay.assay_customer ? assay.assay_customer : null,
                                analysis_description: assay.analysis_description ? assay.analysis_description : null,
                                id: assay.id,
                                index: index
                            }
                            // Initialize a flag to track if the assay has been added
                            let assayAdded = false;

                            if(assay.portal_client_type) {
                               if(assay.portal_client_type == 'General') {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('food') && assay.portal_client_type.toLowerCase().includes('food'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('kratom') && assay.portal_client_type.toLowerCase().includes('kratom'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('other') && assay.portal_client_type.toLowerCase().includes('other'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if(assay.portal_client_type.toLowerCase().includes('non-cannabis')) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if (vm.customer_type.toLowerCase() === assay.portal_client_type.toLowerCase()) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                            }

                            // Add new condition to check portal_client_type_list
                            if(assay.portal_client_type_list && !assayAdded) {
                                // Parse the portal_client_type_list if it's a string
                                let clientTypeList = assay.portal_client_type_list;
                                if (typeof clientTypeList === 'string') {
                                    try {
                                        clientTypeList = JSON.parse(clientTypeList);
                                    } catch (e) {
                                        console.error('Error parsing portal_client_type_list for assay', assay.id, e);
                                        clientTypeList = [];
                                    }
                                }
                                
                                if(Array.isArray(clientTypeList)) {
                                    // Check for 'General' type in the list
                                    if(clientTypeList.includes('General')) {
                                        food.addAssay(test);
                                        index++;
                                        assayAdded = true;
                                    } else {
                                        // Convert customer type to lowercase for case-insensitive comparison
                                        var customerTypeLower = vm.customer_type.toLowerCase();
                                        
                                        // Check if any client type in the list matches the customer type
                                        for(let clientType of clientTypeList) {
                                            var lowerClientType = clientType.toLowerCase();
                                            
                                            // Check if customer type contains any of the keywords
                                            if(customerTypeLower.includes('food') && lowerClientType.includes('food') ||
                                               customerTypeLower.includes('kratom') && lowerClientType.includes('kratom') ||
                                               customerTypeLower.includes('other') && lowerClientType.includes('other') ||
                                               lowerClientType.includes('non-cannabis') ||
                                               customerTypeLower === lowerClientType) {
                                                
                                                food.addAssay(test);
                                                index++;
                                                assayAdded = true;
                                                break;
                                            }
                                        }
                                    }
                                    // Special handling for Japanese language and Japanese assays
                                        if ($localStorage.language === 'Japanese') {
                                            // If customer language is Japanese, only show Japanese assays
                                            if (clientTypeList.includes('Japanese')) {
                                                food.addAssay(test);
                                                index++;
                                                assayAdded = true;
                                            }
                                        } else {
                                            // For non-Japanese customers, don't show Japanese-only assays
                                            if (clientTypeList.includes('Japanese') && !clientTypeList.includes('General') && !assayAdded) {
                                                assayAdded = false; // Skip this assay for non-Japanese customers
                                            }
                                        }
                                }
                            }

                            vm.food.all_assay_map_by_id[assay.id] = test;
                            vm.food.all_tests.push(test)
                        }
                        add_assay = true;
                    });

                }
                // getExistingAssays()
                food.getAssaysAddedByAnrescoBillingTab();

                // sorts tests arrray by how many times each test has been ordered
                vm.food.tests.sort( function(test_a ,test_b) {
                    // Get counts, defaulting to 0 if not present
                    var count_a = (test_a.assay_customer && test_a.assay_customer.count) ? test_a.assay_customer.count : 0;
                    var count_b = (test_b.assay_customer && test_b.assay_customer.count) ? test_b.assay_customer.count : 0;
                    
                    // Sort by count descending (highest first)
                    return count_b - count_a;
                });
                
                // Calculate number of frequent assays (up to 5 tests with counts > 0)
                vm.food.number_of_freq_assays = 0;
                for (var i = 0; i < Math.min(5, vm.food.tests.length); i++) {
                    if (vm.food.tests[i]) {
                        // Count tests that have a positive count
                        if (vm.food.tests[i].assay_customer && vm.food.tests[i].assay_customer.count > 0) {
                            vm.food.number_of_freq_assays++;
                        }
                    }
                }

                if (vm.food.number_of_freq_assays != vm.food.tests.length) {
                    var tests_sorted_by_name = vm.food.tests.splice(vm.food.number_of_freq_assays, vm.food.tests.length).sort( function(name_a, name_b) {
                        var comparison = 0;
                        name_a = name_a.display_name ? name_a.display_name : name_a.reporting_title;
                        name_b = name_b.display_name ? name_b.display_name : name_b.reporting_title;
                        if(name_a > name_b) {
                            comparison = 1
                        }
                        else if(name_b > name_a) {
                            comparison = -1
                        }
                        return comparison
                    });
                    vm.food.tests = vm.food.tests.concat(tests_sorted_by_name);
                }
                food.createAssayMaps();

                // Load QBench panels after assay data is ready
                food.getQbenchPanels();
                // Load customer-specific panels after assay data is ready
                food.getCustomerPanels();
            }).catch(function(error) {
                console.error('Failed to load assays via GraphQL:', error);
                AlertService.error('Failed to load available tests. Please refresh the page.');
            });

            // food.setInfoBoxCoordinates();
        }

        food.checkSampleContainsTrueTests = function(index) {
            if (Object.values(vm.food.sampleArray[index]).indexOf(true) == -1) {
                vm.food.samples[index].sample_has_tests = false;
                vm.food.samples[index].sample_panel_selected = false;
                vm.food.samples[index].sample_panel_type = false;
                vm.food.samples[index].sample_panel_by_id = false;
                vm.food.samples[index].sample_current_panel_title = false;

                return;
            }
            vm.food.samples[index].sample_has_tests = true;
            return;
        }

        // removes tests with checked: false, necessary for table on page 4
        food.cleanUncheckedTests = function() {
            if (vm.food.samples.length > 0) {
                vm.food.samples.forEach (function(sample) {
                    if (sample.sample_tests.length > 0) {
                        for(var i = sample.sample_tests.length - 1; i >= 0; i--){
                            if (!sample.sample_tests[i].checked){
                                sample.sample_tests.splice(i, 1);
                            }
                        }
                    }
                    angular.forEach(sample.sample_other_analyses, function(value, key) {
                        if (!value) {
                            delete sample.sample_other_analyses[key];
                        }
                    });
                });
            }
        }

        vm.food.filterAssays = function() {
            vm.food.showTestsArray = Object.keys(vm.food.showTests);
            vm.food.showTestResults = $filter('filter')(vm.food.showTestsArray, vm.food.test_to_search);
            angular.forEach(vm.food.showTests, function(value, key) {
                vm.food.showTests[key] = false;
            });
            vm.food.showTestResults.forEach( function(test) {
                vm.food.showTests[test] = true;
            });
            // food.setInfoBoxCoordinates();
        }

        //filtertering with the ID
        vm.food.customFilter = function(item) {
            var searchText = vm.food.test_to_search;
            if (/^\d+$/.test(searchText)) {
                var idMatches = (item.id.toString().indexOf(searchText) !== -1);
                var assayIdMatches = (item.assay_id && item.assay_id.toString().indexOf(searchText) !== -1);
                return idMatches || assayIdMatches;
            } else {
                return item.display_name.toLowerCase().includes(searchText.toLowerCase());
            }
        };

        vm.food.clear_test_to_search = function() {
            vm.food.test_to_search = '';
            vm.food.filterAssays();
        }

        vm.food.select_test_to_search = function(name) {
            vm.food.test_to_search = name;
            vm.food.filterAssays();
        }

        vm.food.clickCheckAllAddedTest = function(test, index) {
            var selector = ':checkbox.added-assay-col-header-' + index;
            vm.food.samples.forEach( function(sample) {
                sample.sample_other_analyses[test] = $(selector)[0].checked
            });

            vm.food.checkPageTwo();
        }

        food.showAllTests = function() {
            angular.forEach(vm.food.showTests, function(value, key) {
                vm.food.showTests[key] = true;
            });
            return;
        }

        vm.food.addOtherAnalysis = function() {
            vm.food.other_analyses.push(vm.food.test_to_search);
            vm.food.test_to_search = '';
            food.showAllTests()

            return;
        }

        vm.food.clearOtherAnalysis = function() {
            food.showAllTests();
            vm.food.other_analyses = [];
            vm.food.test_to_search = '';

            return;
        }

        food.getPanels = function(panel) {
            var assays_dict = [];
            var accessibleAssays = [];
            var inaccessibleAssays = [];

            if (panel) {
                // Keep panels intact: do not offer a partial panel when an assay is ineligible.
                if (panel.assays.some(function(assay) {
                    return !shouldShowAssayForLanguage(vm.food.all_assay_map_by_id[assay.id] || assay);
                })) {
                    return assays_dict;
                }
                panel.assays.forEach(function(assay) {
                    // Create a more comprehensive assay object
                    var assayObj = {
                        display_name: assay.title,
                        id: assay.id,
                        customer_has_access: assay.customer_has_access || false,
                        in_customer_tests: vm.food.showTestsArray.indexOf(assay.title) !== -1
                    };
                    
                    // Always include all assays in the panel, but track which ones are accessible
                    assays_dict.push(assayObj);
                    
                    if (assayObj.in_customer_tests) {
                        accessibleAssays.push(assayObj);
                    } else {
                        inaccessibleAssays.push(assayObj);
                    }
                });
                
                // Track information about inaccessible assays
                if (inaccessibleAssays.length > 0) {                    
                    // Add a flag to the panel to indicate it has inaccessible assays
                    panel.has_inaccessible_assays = true;
                    panel.inaccessible_assay_count = inaccessibleAssays.length;
                }
            }

            return assays_dict;
        }

        food.setPanelsByIdMap = function() {
            vm.food.qbenchPanels.forEach( function(panel) {
                vm.food.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
            vm.food.customPanels.forEach( function(panel) {
                vm.food.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
        }

        // Internal helper to standardize pushing a panel with assays
        food._processPanel = function(panel, panelType) {
            var assays_dict = food.getPanels(panel);

            // Add ALL assays from the panel to the accessible tests
            // This grants access to panel assays even if customer doesn't normally have them
            assays_dict.forEach(function(assay) {
                if (!assay.in_customer_tests) {
                    // FIRST check if this assay is already in vm.food.tests
                    var existingTestIndex = findWithAttr(vm.food.tests, 'id', assay.id);
                    
                    if (existingTestIndex !== -1) {
                        // Test already exists with proper info_modal from getAssayData()
                        // Just mark it as from_panel, don't replace it
                        vm.food.tests[existingTestIndex].from_panel = true;
                        return; // Skip to next assay
                    }
                    
                    // Now check if we have full assay data
                    var fullAssay = vm.food.all_assay_map_by_id[assay.id];
                    
                    if (fullAssay) {
                        // Assay exists in our system with full data
                        if (vm.food.showTestsArray.indexOf(fullAssay.display_name) === -1) {
                            food.addAssay(fullAssay);
                            fullAssay.from_panel = true;
                        }
                    } 
                    else {
                        // Assay not in all_assay_map_by_id - fetch it individually
                        // Fetch the specific assay data
                        Assay.get({id: assay.id}, function(assayData) {
                            if (assayData) {
                                // Filter assay_customer data for current customer if it exists
                                if (assayData.assay_customer && Array.isArray(assayData.assay_customer)) {
                                    for (var i = 0; i < assayData.assay_customer.length; i++) {
                                        if (assayData.assay_customer[i].customer_id === vm.customerData.id) {
                                            assayData.assay_customer = assayData.assay_customer[i];
                                            break;
                                        }
                                    }
                                    // If no match found, set to null
                                    if (Array.isArray(assayData.assay_customer)) {
                                        assayData.assay_customer = null;
                                    }
                                }
                                
                                // Create a proper test object with full data
                                var test = {
                                    info_modal: parseAssayInfoModalData(assayData),
                                    portal_identifier: assayData.portalIdentifier ? assayData.portalIdentifier : null,
                                    portal_client_type: assayData.portal_client_type ? assayData.portal_client_type : null,
                                    portal_client_type_list: assayData.portal_client_type_list ? assayData.portal_client_type_list : null,
                                    display_name: assayData.title,
                                    reporting_title: assayData.reporting_title ? assayData.reporting_title : assayData.title,
                                    base_price: assayData.basePrice,
                                    assay_customer: assayData.assay_customer,
                                    analysis_description: assayData.analysis_description ? assayData.analysis_description : null,
                                    id: assayData.id,
                                    index: vm.food.tests.length,
                                    from_panel: true
                                };
                                
                                // Add to cache for future use
                                vm.food.all_assay_map_by_id[assayData.id] = test;
                                vm.food.all_tests.push(test);
                                
                                // Add to accessible tests if not already there
                                if (vm.food.showTestsArray.indexOf(test.display_name) === -1) {
                                    food.addAssay(test);
                                }
                            }
                        }, function(error) {
                            console.error('Failed to fetch assay', assay.id, error);
                        });
                    }
                }
            });

            // Re-create the assay dict now that all panel assays are accessible
            assays_dict = food.getPanels(panel);

            // Only add panel if it has assays after processing
            if (assays_dict.length > 0) {
                vm.food.qbenchPanels.push({
                    title: panel.title,
                    assays: assays_dict,
                    id: panel.id,
                    type: panelType || 'qbench_panel',
                    description: panel.description,
                    duration: panel.duration,
                    minimum_quantity_required: panel.minimum_quantity_required,
                    turnaround_time: panel.turnaround_time,
                    min_sample_size: panel.min_sample_size,
                    price: panel.price
                });
            }
        };

        food.pushPanel = function(panel, panelType) {
            // If the list endpoint did not include assays, fetch the full panel as a fallback
            if (!panel || !panel.assays || panel.assays.length === 0) {
                if (!panel || !panel.id) {
                    console.warn('Panel missing id or assays:', panel);
                    return;
                }
                Panel.get({ id: panel.id }, function(fullPanel) {
                    if (fullPanel && fullPanel.assays && fullPanel.assays.length) {
                        food._processPanel(fullPanel, panelType);
                    } else {
                        console.warn('Panel has no assays after fetch:', panel.id);
                    }
                }, function(e) {
                    console.error('Error fetching panel details', e);
                });
                return;
            }

            // Normal path when assays are present on the list payload
            food._processPanel(panel, panelType);
        }

        food.allPanelAssaysPresent = function(assays_dict) {
            var all_assays_present = true;
            assays_dict.forEach( function(assay) {
                if (vm.food.showTestsArray.indexOf(assay.display_name) == -1) {
                    all_assays_present = false;
                }
           });
           return all_assays_present;
        }

        // Helper function to check if panel should be shown based on portal_client_type_list
        function shouldShowPanel(panel, customerType, customerLanguage) {
            var shouldShow = false;
                        
            // PRIMARY METHOD: Check portal_client_type_list first
            if (panel.portal_client_type_list) {
                var clientTypeList = panel.portal_client_type_list;
                
                // Parse if it's a JSON string, otherwise use as-is if already an array
                if (typeof clientTypeList === 'string') {
                    try {
                        clientTypeList = JSON.parse(clientTypeList);
                    } catch (e) {
                        console.error('Error parsing portal_client_type_list for panel', panel.id, e);
                        clientTypeList = [];
                    }
                } else if (!Array.isArray(clientTypeList)) {
                    // If it's neither a string nor an array, treat as empty
                    clientTypeList = [];
                }
                
                
                // Check if list contains matching criteria
                if (Array.isArray(clientTypeList)) {
                    // SPECIAL CASE: Japanese language customers
                    if (customerLanguage === 'Japanese') {
                        // Japanese customers only see panels with 'Japanese' in the list
                        if (clientTypeList.indexOf('Japanese') !== -1) {
                            shouldShow = true;
                        }
                    } 
                    // NORMAL CASE: Non-Japanese customers
                    else {
                        // Check if list contains 'General' or customer's type
                        if (clientTypeList.indexOf('General') !== -1) {
                            shouldShow = true;
                        } else if (clientTypeList.indexOf(customerType) !== -1) {
                            shouldShow = true;
                        } else {
                            // Support flexible matching (e.g., 'Cannabis/Hemp' matches 'Cannabis')
                            for (var i = 0; i < clientTypeList.length; i++) {
                                if (clientTypeList[i].toLowerCase().indexOf(customerType.toLowerCase()) !== -1) {
                                    shouldShow = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            // FALLBACK: Use panel_type if portal_client_type_list not set (only for non-Japanese)
            else if (customerLanguage !== 'Japanese' && panel.panel_type) {
                if (panel.panel_type == 'General') {
                    shouldShow = true;
                } else if (panel.panel_type.toLowerCase().indexOf(customerType.toLowerCase()) !== -1) {
                    shouldShow = true;
                }
            }
            
            return shouldShow;
        }

        food.getQbenchPanels = function() {
            Panel.query({},
                function(data) {
                    data.forEach( function(panel) {
                        if (panel.portalIdentifier) {
                            if (shouldShowPanel(panel, 'Food', $localStorage.language)) {
                                food.pushPanel(panel, 'qbench_panel');
                            }
                        }
                    });
                    food.getPanelsByCustomer();

                    return;
                },
                function(e) {
                    console.log(e);
                    return;
                }
            );
        }

        food.getPanelsByCustomer = function() {
            CustomPanel.query({},
                function(data) {
                    vm.food.customPanels = [];
                    data.forEach( function(panel) {
                        var panelAssays = food.getPanels(panel);
                        if ($localStorage.language === 'Japanese' && panelAssays.length === 0) {
                            return;
                        }
                        vm.food.customPanels.push({
                            title: panel.title,
                            assays: panelAssays,
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    food.setPanelsByIdMap();
                    
                    // After loading custom panels, also load customer-specific panels
                    food.getCustomerPanels();
                },
                function(e){
                    console.log(e);
                }
            );
        }
        
        // Flag to track if food customer panels have been loaded
        var foodCustomerPanelsLoaded = false;
        
        food.getCustomerPanels = function() {
            // If customer panels have already been loaded, don't load them again
            if (foodCustomerPanelsLoaded) {
                return;
            }
            
            // Get the customer ID from the customerData object
            var customerId = vm.customerData && vm.customerData.id ? vm.customerData.id : null;
            
            if (!customerId) {
                return;
            }
            
            Customer.getPanels({id: customerId},
                function(data) {                    
                    // Set the flag to indicate customer panels have been loaded
                    foodCustomerPanelsLoaded = true;
                    
                    // Process each panel
                    data.forEach(function(panel) {
                        // For food customers, include all panels EXCEPT those that are explicitly Cannabis-only
                        // This ensures we don't miss any panels with null types or other non-cannabis types
                        var isCannabisOnly = panel.panel_type && 
                                           panel.panel_type === 'Cannabis' && 
                                           !panel.panel_type.toLowerCase().includes('food') && 
                                           panel.panel_type !== 'General';
                        
                        if (!isCannabisOnly) {
                            food.pushPanel(panel, 'customer_panel');
                        }
                    });
                    
                    // Update the panel_by_id_map to include the customer panels
                    food.setPanelsByIdMap();
                },
                function(error) {
                    console.error('Error fetching food customer panels:', error);
                }
            );
        }
        
        vm.food.removePanelFromSample = function(sampleIndex) {

            Object.keys(vm.food.sampleArray[sampleIndex]).forEach( function(key) {
                vm.food.sampleArray[sampleIndex][key] = false;
            });

            vm.food.tests.forEach( function(test, index) {
                $(':checkbox.assay-col-header-' + index)[0].checked = false;
            })

            vm.food.current_sample_name = false;
            vm.food.samples[sampleIndex].sample_current_panel_title = null;
            vm.food.samples[sampleIndex].sample_panel_selected = null;
            vm.food.samples[sampleIndex].sample_panel_by_id = null;
            vm.food.samples[sampleIndex].sample_panel_type = null;
            vm.food.samples[sampleIndex].sample_has_tests = null;
            vm.food.samples[sampleIndex].sample_tests = [];

            vm.food.checkPageTwo();
        }

        
        vm.food.organizeTests = function(sample) {
            if (!sample) return;
            
            // Create arrays to hold panel and non-panel tests
            sample.nonPanelTests = [];
            sample.panelTests = [];
            
            
            // Get the current panel ID if one is selected
            var currentPanelId = sample.sample_panel_selected;
                        
            // Sort tests into panel and non-panel arrays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                var test = sample.sample_tests[i];
                if (test.checked) {                    
                    // Check if panel_id is undefined, null, or empty string
                    var hasPanelId = test.panel_id !== undefined && test.panel_id !== null && test.panel_id !== '';
                    
                    // A test is part of the panel if:
                    // 1. It has a panel_id property AND
                    // 2. That panel_id matches the currently selected panel AND
                    // 3. A panel is actually selected
                    if (hasPanelId && currentPanelId && test.panel_id == currentPanelId) {
                        sample.panelTests.push(test);
                    } else {
                        // If the test has a panel_id but it doesn't match the current panel,
                        // or if it has no panel_id, it should be treated as a non-panel test
                        sample.nonPanelTests.push(test);
                    }
                }
            }
        };
        
        vm.food.setPanel = function(sample, panelId, panel_type) {            
            // Find the actual sample index by object reference, not by name
            var sampleIndex = vm.food.samples.indexOf(sample);
            
            if (sampleIndex === -1) {
                console.error('Sample not found in samples array');
                return;
            }
            
            vm.food.current_sample_name = sample.sample_name;

            var temp = null;
            if (vm.food.sampleArray[sampleIndex]) {
                delete vm.food.sampleArray[sampleIndex];
            }
            vm.food.sampleArray[sampleIndex] = {};

            // Store existing tests that are not part of the panel
            var existingTests = [];
            if (vm.food.samples[sampleIndex].sample_tests) {
                // Save any manually added tests that are checked
                existingTests = vm.food.samples[sampleIndex].sample_tests.filter(function(test) {
                    return test.checked && !test.panel_id;
                });
                                
                // Clear the tests array to rebuild it
                vm.food.samples[sampleIndex].sample_tests = [];
                
                // Add back the preserved tests first
                existingTests.forEach(function(test) {
                    // Ensure these tests are marked as non-panel tests
                    if (test.panel_id) {
                        delete test.panel_id;
                        delete test.panel_name;
                    }
                    vm.food.samples[sampleIndex].sample_tests.push(test);
                });
            }
            
            // Track assays that customer doesn't have access to
            var inaccessibleAssays = [];
            var accessibleAssays = [];
                        
            vm.food.panel_by_id_map[panelId][1].forEach(function(assay) {
                // IMPORTANT: For panels, we grant access to ALL assays in the panel
                // regardless of customer's normal access rights
                
                // First ensure the assay is in showTests/showTestsArray if it's from a panel
                if (vm.food.showTestsArray.indexOf(assay.display_name) === -1) {
                    // This is a panel assay the customer doesn't normally have access to
                    // Add it to the accessible lists
                    vm.food.showTests[assay.display_name] = true;
                    vm.food.showTestsArray.push(assay.display_name);
                    // Granting access to panel assay
                }
                
                // Check if the assay exists in the assay map
                if (vm.food.assay_map[assay.display_name]) {
                    // Now the customer has access (we just granted it above if needed)
                    // Add accessible assays to the sample
                    temp = Object.assign({}, vm.food.assay_map[assay.display_name][1]);
                    temp.checked = true;
                    
                    // Set panel association on the test
                    temp.panel_id = panelId;
                    temp.panel_name = vm.food.panel_by_id_map[panelId][0];
                    
                    // Handle source_uid vs source_id mapping as mentioned in memories
                    if (temp.source_id && !temp.source_uid) {
                        temp.source_uid = temp.source_id;
                    }
                    
                    vm.food.samples[sampleIndex].sample_tests.push(temp);
                    vm.food.sampleArray[sampleIndex][vm.food.assay_map[assay.display_name][1].index] = true;
                    accessibleAssays.push(assay.display_name);
                } else {
                    // Assay not in assay_map - this shouldn't happen with our previous fixes
                    console.warn('Panel assay not in assay_map:', assay.display_name);
                    inaccessibleAssays.push(assay.display_name);
                }
            });
            
            vm.food.samples[sampleIndex].sample_panel_selected = panelId;
            vm.food.samples[sampleIndex].sample_panel_type = panel_type;
            vm.food.samples[sampleIndex].sample_current_panel_title = vm.food.panel_by_id_map[panelId][0];
            vm.food.current_sample_name = null;
            vm.food.checkPageTwo();
            
            
            // This might be overriding our panel settings
            vm.food.checkPanelTestsSelection(sampleIndex);
                        
            // Organize tests for display
            vm.food.organizeTests(vm.food.samples[sampleIndex]);
            return;
        }

        vm.food.applyPanelToAll = function(panelId, panelType) {
            vm.food.samples.forEach(function(sample) {
                vm.food.setPanel(sample, panelId, panelType);
                sample.sample_panel_by_id = panelId;
            });
        };

        vm.food.clearPanelFromAll = function() {
            vm.food.samples.forEach(function(sample, index) {
                vm.food.removePanelFromSample(index);
            });
        };
        
        // Check if all tests in a panel are selected for a sample

        vm.food.checkPanelTestsSelection = function(sampleIndex) {
            var sample = vm.food.samples[sampleIndex];
            if (!sample.sample_panel_selected) {
                return;
            }
            var panelId = sample.sample_panel_selected;
            
            var panelAssays = vm.food.panel_by_id_map[panelId][1];
            var allAssaysSelected = true;
            var accessibleAssaysInPanel = [];
            var inaccessibleAssaysInPanel = [];
            var selectedAssays = [];
            
            // Get all accessible assays in the panel
            panelAssays.forEach(function(assay) {
                if (vm.food.assay_map[assay.display_name]) {
                    var assayId = vm.food.assay_map[assay.display_name][1].id;
                    var customerHasAccess = vm.food.showTestsArray.indexOf(assay.display_name) !== -1;
                    if (customerHasAccess) {
                        accessibleAssaysInPanel.push(assayId);
                    } else {
                        inaccessibleAssaysInPanel.push(assay.display_name);
                    }
                }
            });
            
            
            // Get all selected assays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].checked) {
                    selectedAssays.push(sample.sample_tests[i].id);
                }
            }
            
            
            // Check if all accessible panel assays are selected
            for (var i = 0; i < accessibleAssaysInPanel.length; i++) {
                if (selectedAssays.indexOf(accessibleAssaysInPanel[i]) === -1) {
                    allAssaysSelected = false;
                    break;
                }
            }
            
            
            if (!allAssaysSelected) {
                sample.sample_panel_selected = null;
                sample.sample_panel_type = null;
                sample.sample_current_panel_title = null;
                
                // Only remove panel association from tests that were part of this panel
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].panel_id === panelId) {
                        delete sample.sample_tests[i].panel_id;
                        delete sample.sample_tests[i].panel_name;
                    }
                }
                
                if (!$rootScope.$$phase) {
                    $rootScope.$apply();
                }
            } else {
                sample.sample_panel_selected = panelId;
                sample.sample_panel_type = sample.sample_panel_type || 'panel';
                sample.sample_current_panel_title = vm.food.panel_by_id_map[panelId][0];
                
                // Only set panel association on tests that are part of this panel
                // DO NOT modify tests that aren't part of this panel
                var panelAssayIds = accessibleAssaysInPanel;
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && panelAssayIds.indexOf(sample.sample_tests[i].id) !== -1) {
                        sample.sample_tests[i].panel_id = panelId;
                        sample.sample_tests[i].panel_name = vm.food.panel_by_id_map[panelId][0];
                    } else if (sample.sample_tests[i].checked) {
                    }
                }
            }
            
            // Organize tests for display
            vm.food.organizeTests(sample);
            
            return allAssaysSelected;
        }

        vm.food.savePanel = function(sampleIndex, step) {
            if (step == 1) {
                vm.food.panels.current_panel_index = sampleIndex;
                $('#addPanelName').modal('show'); 
                return;
            }

            else if (step == 2) {
                var assays = [];
                Object.keys(vm.food.sampleArray[vm.food.panels.current_panel_index]).forEach( function(key) {
                    if (vm.food.sampleArray[vm.food.panels.current_panel_index][key]) {
                        assays.push({id: vm.food.assay_map_by_index[key].id})
                    }
                });

                if (vm.food.panels.new_panel_name && assays) {
                    CustomPanel.create({
                            title: vm.food.panels.new_panel_name,
                            assays: assays
                        },
                        function() {
                            vm.food.samples[vm.food.panels.current_panel_index].sample_has_tests = true;

                            food.getPanelsByCustomerAndSetPanel(vm.food.panels.current_panel_index);
                        },
                        function(e) {
                            console.log(e);
                        }
                    );
                }
                return;
            }
        }

        food.getPanelsByCustomerAndSetPanel = function(sampleIndex) {
            CustomPanel.query({},
                function(data) {
                    vm.food.customPanels = [];
                    var panel_id = null
                    data.forEach( function(panel) {
                        vm.food.customPanels.push({
                            title: panel.title,
                            assays:food.getPanels(panel),
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    food.setPanelsByIdMap();
                    panel_id = vm.food.customPanels[vm.food.customPanels.length-1].id;
                    vm.food.setPanel(vm.food.samples[sampleIndex], panel_id, 'custom_panel');
                    vm.food.samples[sampleIndex].sample_panel_by_id = panel_id;
                    vm.food.samples[sampleIndex].sample_has_tests = false;
                    vm.food.panels.current_panel_index = null;
                    vm.food.panels.new_panel_name = null;

                },
                function(e){
                    console.log(e);
                }
            );
        }


        vm.food.updatePanel = function(sampleIndex, panelId) {
            var assays = [];
            Object.keys(vm.food.sampleArray[sampleIndex]).forEach( function(key) {
                if(vm.food.sampleArray[sampleIndex][key]) {
                    assays.push({id: vm.food.assay_map_by_index[key].id})
                }
            });
            CustomPanel.update({
                id: panelId,
                assays: assays
            },
                function() {
                    vm.food.samples[sampleIndex].sample_has_tests = false;
                    food.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );
            return;
        }

        vm.food.deletePanel = function(panelId) {
            vm.food.customPanels = [];

            CustomPanel.delete({id: panelId},
                function() {
                    food.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );

            return;
        }

        vm.showQbenchPanels = $localStorage.settings || {
            settings: {
                sample_submit:{
                    show_anresco_panels: true
                }
            }
        }

        vm.toggleQbenchPanelVisibility = function(){
            vm.showQbenchPanels.settings.sample_submit.show_anresco_panels = !vm.showQbenchPanels.settings.sample_submit.show_anresco_panels;
            $localStorage.settings = vm.showQbenchPanels;
        };

        food.isSample = function(object) {
            return object.sample_name == vm.food.current_sample_name;
        }

        vm.food.clearPanel = function() {
            vm.food.panels.current_panel_index = null;
            vm.food.current_sample_name = null;
            vm.food.panels.current_panel_index = null;
            vm.food.panels.new_panel_name = null;      
        }

        vm.food.uploadExcel = function() {
            $('#food_upload_excel').click();
        }

        vm.food.collapseAll = function() {
            vm.food.mainCollapse = !vm.food.mainCollapse;
            if (vm.food.samples.length != 0) {
                vm.food.samples.forEach( function(sample) {
                    sample.sample_expanded = vm.food.mainCollapse;
                });
            }
        }

        vm.food.downloadExcel = function() {
            food.generateBlob();
        }

        food.getWorkbook = function() {
            return new Promise(function (resolve, reject) {
                var req = new XMLHttpRequest();
                var url = 'content/files/public/food_analysis.xlsx';

                req.open("GET", url, true);
                req.responseType = "arraybuffer";
                req.onreadystatechange = function () {
                    if (req.readyState === 4){
                        if (req.status === 200) {
                            resolve(XlsxPopulate.fromDataAsync(req.response));
                        } else {
                            reject("Received a " + req.status + " HTTP code.");
                        }
                    }
                };
                req.send();
            });
        }

        food.generate = function(type) {
            return food.getWorkbook()
                .then(function (workbook) {
                    var r = workbook.sheet(0).range("A1:AY1");
                    
                    var lot_field_name = [3868, 8735, 8736, 8748].includes($rootScope.customer.customer_id) ? 'Lot Number*' : 'Lot/Batch #';
                    var header = ['Sample Description*', 'Sample Condition', lot_field_name,  'Expiration Date (MM/DD/YYYY)','Production Date (MM/DD/YYYY)','Date and Time Collected (MM/DD/YYYY HH:MM AM/PM)', 'UPC Number', '# of Units Submitted', 'Sample Matrix', 'Product Specifications', 'Comments', 'Supplier Name', 'Supplier Lot Code'];

                    var dropdownOptions = {}
                    var options = ['Yes', 'No']

                    vm.food.tests.forEach( function(test) {
                        test.display_name ? header.push(test.display_name) : header.push(test.reporting_title);
                        var headerName = test.display_name ? test.display_name : test.reporting_title
                        dropdownOptions[headerName] = options;
                    });
                    
                    header.forEach(function (headerName, index) {
                        var colLetter = getColumnLetter(index);
                        if (dropdownOptions[headerName]) {
                            applyDropdown(workbook.sheet(0), colLetter, dropdownOptions[headerName]);
                        }
                    });

                    r.value([header]);
                    workbook.sheet(0).row(1).style("bold", true);

                    return workbook.outputAsync({ type: type });
                });
        }

        food.generateBlob = function() {
            return food.generate()
                .then(function (blob) {
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, "Analysis Sample Submission.xlsx");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = "Analysis Sample Submission.xlsx";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                })
                .catch(function (err) {
                    alert(err.message || err);
                    throw err;
                });
        }

        // Normalizes header text for consistent matching.
        // Converts to lowercase, trims whitespace, removes text in parentheses, and removes trailing asterisk.
        food.normalizeHeader = function(headerText) {
            var normalized;
            if (typeof headerText !== 'string') {
                return ''; // Return empty string if input is not a string
            }
            normalized = headerText.toLowerCase();
            normalized = normalized.trim();
            normalized = normalized.replace(/\(.*?\)/g, ''); // Remove text within parentheses
            normalized = normalized.replace(/\*$/, ''); // Remove trailing asterisk
            normalized = normalized.trim(); // Trim again after removals
            return normalized;
        };

        // Parses a date value from an Excel cell, handling various formats. (Corrected Version)
        food.parseDateFromCell = function(sheet, rowIndex, colIndex, rawValue) {
            var cell, date, cellFormat, isDateFormat, baseDate, trimmed, dateRegex1, dateRegex2, parsedDate;
            try {
                // Get the cell object using 1-based indices
                cell = sheet.cell(rowIndex, colIndex);

                // Check if the cell exists and has a value before accessing properties
                if (cell && cell.value !== null && cell.value !== undefined) {

                    // Check if it's explicitly a date type in Excel (using property access)
                    if (cell.type === 'd') {
                        // Create Date object from the cell's raw value (using property access)
                        date = new Date(cell.value);
                        // Check if the parsed date is valid
                        if (Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime())) {
                            return date;
                        }
                    }

                    // Check if it's a number that might be a date based on format
                    // Use rawValue here as cell.value might already be a Date object if type was 'd'
                    if (typeof rawValue === 'number') {
                        // Get cell format (style IS a function)
                        cellFormat = (cell.style && typeof cell.style === 'function' && cell.style("numberFormat")) || '';
                        isDateFormat = cellFormat.toLowerCase().indexOf('yy') !== -1 ||
                                    cellFormat.toLowerCase().indexOf('mm') !== -1 ||
                                    cellFormat.toLowerCase().indexOf('dd') !== -1;

                        if (isDateFormat) {
                            // Handle both 1900 and 1904 date systems
                            baseDate = (sheet.workbook &&
                                        sheet.workbook.Workbook &&
                                        sheet.workbook.Workbook.WBProps &&
                                        sheet.workbook.Workbook.WBProps.date1904)
                                        ? 24107 : 25567;
                            // Adjust calculation slightly for potential Excel base date differences
                            // Use Math.round to avoid floating point issues with date serial numbers
                            date = new Date(Math.round((rawValue - baseDate - 1) * 86400 * 1000));

                            // Check if the parsed date is valid
                            if (Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime())) {
                                // Basic sanity check for reasonable date range (e.g., year > 1900)
                                if (date.getFullYear() > 1900) {
                                    return date;
                                }
                            }
                        }
                    }
                } // End check for cell existence and value

                // Handle string dates with specific formats (MM/DD/YYYY, MM-DD-YYYY, YYYY/MM/DD, YYYY-MM-DD)
                // Use rawValue here as it might be a string even if the cell exists
                if (typeof rawValue === 'string') {
                    trimmed = rawValue.trim();
                    // Matches formats like MM/DD/YYYY, MM-DD-YYYY
                    dateRegex1 = /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}$/;
                    // Matches formats like YYYY/MM/DD, YYYY-MM-DD
                    dateRegex2 = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/;

                    if (dateRegex1.test(trimmed) || dateRegex2.test(trimmed)) {
                        parsedDate = new Date(trimmed);
                        // Check if the parsed date is valid
                        if (Object.prototype.toString.call(parsedDate) === "[object Date]" && !isNaN(parsedDate.getTime())) {
                            return parsedDate;
                        }
                    }
                }

            } catch (e) {
                console.error("Error parsing date for cell (" + rowIndex + "," + colIndex + ") with value:", rawValue, e);
                // Fall through to return rawValue if any error occurs
            }

            // Return the original value if no valid date was parsed or if rawValue was null/undefined initially
            return rawValue;
        }; // End of food.parseDateFromCell

        // Parses a datetime value from an Excel cell, preserving time component
            food.parseDateTimeFromCell = function(sheet, rowIndex, colIndex, rawValue) {
                var cell, datetime, cellFormat, isDateFormat, baseDate, trimmed, datetimeRegex, parsedDate;
                try {
                    // Get the cell object using 1-based indices
                    cell = sheet.cell(rowIndex, colIndex);

                    // Check if the cell exists and has a value
                    if (cell && cell.value !== null && cell.value !== undefined) {

                        // Check if it's explicitly a date type in Excel
                        if (cell.type === 'd') {
                            // Create Date object from the cell's raw value (preserves time)
                            datetime = new Date(cell.value);
                            if (Object.prototype.toString.call(datetime) === "[object Date]" && !isNaN(datetime.getTime())) {
                                return datetime;
                            }
                        }

                        // Check if it's a number that might be a datetime based on format
                        if (typeof rawValue === 'number') {
                            cellFormat = (cell.style && typeof cell.style === 'function' && cell.style("numberFormat")) || '';
                            isDateFormat = cellFormat.toLowerCase().indexOf('yy') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('mm') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('dd') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('hh') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('h:') !== -1;

                            if (isDateFormat) {
                                baseDate = (sheet.workbook &&
                                            sheet.workbook.Workbook &&
                                            sheet.workbook.Workbook.WBProps &&
                                            sheet.workbook.Workbook.WBProps.date1904)
                                            ? 24107 : 25569;

                                // Extract date/time components from Excel serial to create local Date
                                var totalDays = rawValue - baseDate;
                                var wholeDays = Math.floor(totalDays);
                                var fractionalDay = totalDays - wholeDays;

                                // Get time components from fractional day
                                var totalSeconds = Math.round(fractionalDay * 86400);
                                var excelHours = Math.floor(totalSeconds / 3600);
                                var excelMinutes = Math.floor((totalSeconds % 3600) / 60);
                                var excelSeconds = totalSeconds % 60;

                                // Get date components via UTC temp date
                                var tempDate = new Date(wholeDays * 86400 * 1000);
                                datetime = new Date(
                                    tempDate.getUTCFullYear(),
                                    tempDate.getUTCMonth(),
                                    tempDate.getUTCDate(),
                                    excelHours,
                                    excelMinutes,
                                    excelSeconds
                                );

                                if (Object.prototype.toString.call(datetime) === "[object Date]" && !isNaN(datetime.getTime())) {
                                    if (datetime.getFullYear() > 1900) {
                                        return datetime;
                                    }
                                }
                            }
                        }
                    }

                    // Handle string datetimes with format MM/DD/YYYY HH:MM:SS or MM/DD/YYYY HH:MM
                    if (typeof rawValue === 'string') {
                        trimmed = rawValue.trim();
                        // Matches formats like "12/12/2025 18:30:00", "12/12/2025 18:30", or "12/12/2025 12:30 PM"
                        datetimeRegex = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?\s*(AM|PM|am|pm)?$/i;

                        var match = datetimeRegex.exec(trimmed);
                        if (match) {
                            var month = parseInt(match[1]) - 1; // Month is 0-indexed
                            var day = parseInt(match[2]);
                            var year = parseInt(match[3]);
                            var hour = parseInt(match[4]);
                            var minute = parseInt(match[5]);
                            var second = match[6] ? parseInt(match[6]) : 0;
                            var ampm = match[7];

                            // Handle AM/PM conversion
                            if (ampm) {
                                if (ampm.toUpperCase() === 'PM' && hour < 12) hour += 12;
                                if (ampm.toUpperCase() === 'AM' && hour === 12) hour = 0;
                            }

                            parsedDate = new Date(year, month, day, hour, minute, second);
                            if (Object.prototype.toString.call(parsedDate) === "[object Date]" && !isNaN(parsedDate.getTime())) {
                                return parsedDate;
                            }
                        }
                    }

                    return null;
                } catch (error) {
                    console.error("Error parsing datetime from cell:", error);
                    return null;
                }
            };

        vm.food.handleExcel = function() {
            return handleExcelImport(vm.food, '#food_upload_excel', function(workbook) {
                    var sheet = workbook.sheet(0);
                    var values = sheet.usedRange().value();
                    return food.extractExcelValues(values, sheet);
            });
        }
        
        food.createExcelAssayMap = function(file) {
            for( var i = vm.food.excel_header_offset; i < file[0].length; i++) {
                if (file[0][i]) {
                    vm.food.excel_assay_index_map[i] = vm.food.assay_map[file[0][i]];
                }
                else {
                    break;
                }
            }
        }

        food.createNewSample = function() {
            return ({
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_time_of_collection: null,
                sample_time_of_collection_frontend: null,
                sample_time_of_collection_backend: null,
                sample_expiration_date: null,
                sample_expiration_date_open: false,
                sample_supplier_name: null,           // ADD THIS 
                sample_supplier_lot_code: null,       // ADD THIS 
                sample_tests: [],
                sample_other_analyses: {},
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                }
            });
        }
        
// Extracts data from the Excel file based on headers.
food.extractExcelValues = function(file, sheet) {
    var headerRow, standardHeaderMapping, requiredSampleProperties,
        headerIndexMap, assayColumnMap, missingHeaders, i, dataRow,
        sampleNameIndex, sample, sampleProperty, testToAdd,
        originalAssayIndex, normalizedHeader, prop, originalHeaderKey;

    // --- Configuration ---
    standardHeaderMapping = {
        'sample description': 'sample_name',
        'sample condition': 'sample_condition',
        'lot/batch #': 'sample_lot_batch_number',
        'lot number': 'sample_lot_batch_number',  // Support both variations for all customers
        'expiration date': 'sample_expiration_date', // Requires special date parsing
        'production date': 'sample_production_date', // Requires special date parsing
      //  'date collected': 'sample_time_of_collection', // Requires special date parsing
        'date and time collected': 'sample_time_of_collection',
        'upc number': 'sample_upc_number',
        '# of units submitted': 'sample_number_of_units_submitted',
        'sample matrix': 'food_sample_matrix',
        'product specifications': 'sample_expected_potency',
        'comments': 'sample_comments',
        'supplier name': 'sample_supplier_name',
        'supplier lot code': 'sample_supplier_lot_code'
    };
    

    // Define which sample properties correspond to required headers
    requiredSampleProperties = ['sample_name']; // Add others if needed, e.g., 'sample_lot_batch_number'

    // --- Header Processing ---
    if (!file || file.length === 0) {
        AlertService.error("Upload failed. The Excel file is empty.");
        return false;
    }
    headerRow = file[0];
    headerIndexMap = {}; // { sample_property: colIndex }
    assayColumnMap = {}; // { colIndex: assayObject }
    var columnMap = {};   // { colIndex: {prop: 'sample_name'} | {assay: obj} }
    // Each column index is mapped individually so headers can appear in any order

    // Map headers to indices and assays
    angular.forEach(headerRow, function(header, colIndex) {
        var normalizedHeader = food.normalizeHeader(header);
        var sampleProperty = standardHeaderMapping[normalizedHeader];
        var matchedAssay = null;

        if (sampleProperty) {
            // Store mapping from internal property name to column index
            headerIndexMap[sampleProperty] = colIndex;
            columnMap[colIndex] = { prop: sampleProperty };
        } else if (normalizedHeader) { // Only check assays if header is not empty after normalization
            // Check assays - prioritize reporting_title, then display_name
            angular.forEach(vm.food.tests, function(test) {
                if (matchedAssay) return; // Already found a match
                if (test.reporting_title && food.normalizeHeader(test.reporting_title) === normalizedHeader) {
                    matchedAssay = test;
                }
            });
            if (!matchedAssay) {
                angular.forEach(vm.food.tests, function(test) {
                    if (matchedAssay) return; // Already found a match
                    if (food.normalizeHeader(test.display_name) === normalizedHeader) {
                        matchedAssay = test;
                    }
                });
            }

            if (matchedAssay) {
                assayColumnMap[colIndex] = matchedAssay;
                columnMap[colIndex] = { assay: matchedAssay };
            }
            // else: Header is unrecognized - ignore silently
        }
    });


    // --- Validate Required Headers ---
    missingHeaders = [];
    angular.forEach(requiredSampleProperties, function(prop) {
        if (!headerIndexMap.hasOwnProperty(prop)) {
            // Find the original-like header key for the error message
            originalHeaderKey = "Unknown Required Header"; // Default
            for (var key in standardHeaderMapping) {
                if (standardHeaderMapping[key] === prop) {
                    // Attempt to reconstruct a user-friendly header name (best effort)
                    originalHeaderKey = key.replace(/\b\w/g, function(l){ return l.toUpperCase() }); // Capitalize words
                    if (prop === 'sample_name') originalHeaderKey += '*'; // Add back asterisk if needed
                    // Add more specific reconstructions if necessary
                    break;
                }
            }
            missingHeaders.push(originalHeaderKey);
        }
    });

    if (missingHeaders.length > 0) {
        AlertService.error("Upload failed. Missing required column(s): " + missingHeaders.join(', '));
        return false; // Stop processing
    }

    // --- Data Row Processing ---
    vm.food.samples = []; // Clear existing samples before adding new ones from Excel
    vm.food.sampleArray = []; // Clear existing sample array

    for (i = 1; i < file.length; i++) {
        dataRow = file[i];
        sampleNameIndex = headerIndexMap['sample_name']; // Get index for sample name

        // Stop processing if the required sample name cell is empty for this row
        if (!dataRow || dataRow.length === 0 || allEmpty(dataRow[sampleNameIndex])) {
            break;
        }

        sample = food.createNewSample(); // Create a new sample structure
        vm.food.sampleArray[i - 1] = {}; // Initialize assay tracking for this sample

        // Process each column by its mapped specification
        angular.forEach(columnMap, function(spec, colIdx) {
            colIdx = parseInt(colIdx);
            var cellVal = (dataRow.length > colIdx) ? dataRow[colIdx] : null;

            if (cellVal === undefined || cellVal === '') {
                cellVal = null;
            }

            if (spec.prop) {
                if (spec.prop === 'sample_expiration_date' && cellVal !== null) {
                    sample.sample_expiration_date = food.parseDateFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_production_date' && cellVal !== null) {
                    sample.sample_production_date = food.parseDateFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_time_of_collection' && cellVal !== null) {
                    sample.sample_time_of_collection = food.parseDateTimeFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_lot_batch_number' && typeof cellVal === 'number') {
                    // Handle case where lot batch number is read as a date serial number
                    // Check if this is likely an Excel date serial number
                    // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                    if (cellVal >= 43101 && cellVal <= 49673) {
                        // Convert Excel date serial number back to date string
                        var baseDate = 25567; // Excel base date for 1900 system
                        var date = new Date(Math.round((cellVal - baseDate - 1) * 86400 * 1000));
                        
                        // Format as MM/DD/YYYY
                        var month = (date.getMonth() + 1).toString().padStart(2, '0');
                        var day = date.getDate().toString().padStart(2, '0');
                        var year = date.getFullYear();
                        sample[spec.prop] = month + '/' + day + '/' + year;
                    } else {
                        // This is just a regular number, not a date
                        sample[spec.prop] = cellVal.toString();
                    }
                } else {
                    sample[spec.prop] = (spec.prop === 'sample_name' || spec.prop === 'sample_lot_batch_number')
                        ? stripInvalidQBChars(cellVal)
                        : cellVal;
                }
            } else if (spec.assay) {
                if (cellVal && typeof cellVal === 'string' && cellVal.trim().toLowerCase() === 'yes') {
                    testToAdd = angular.copy(spec.assay);
                    testToAdd.checked = true;
                    sample.sample_tests.push(testToAdd);
                    sample.sample_has_tests = true;

                    if (vm.food.assay_map && vm.food.assay_map[spec.assay.display_name]) {
                        originalAssayIndex = vm.food.assay_map[spec.assay.display_name][0];
                        vm.food.sampleArray[i - 1][originalAssayIndex] = true;
                    } else {
                        console.warn("Could not find assay '" + spec.assay.display_name + "' in vm.food.assay_map for UI update.");
                    }
                }
            }
        });

        vm.food.samples.push(sample); // Add the processed sample to the main list
    }

    // --- Finalization ---
    vm.food.checkPageOne(); // Validate page one based on newly added samples
    food.resetDeleteCheckboxes(); // Reset UI checkboxes
    if (!vm.food.samples.length) {
        AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
        return false;
    }
    // vm.food.processingExcelUpload = false; // Flag is reset in vm.food.handleExcel's .then/.catch
    return true;
}; // End of food.extractExcelValues function


// **************************** END FOOD FUNCTIONS ****************************

        vm.comp.step = 1;
        vm.comp.pageOneValid = false;
        vm.comp.pageTwoValid = false;
        vm.comp.pageThreeValid = false;
        vm.comp.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.comp.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.comp.file = null;
        vm.comp.specialInstructions = null;
        vm.comp.customerComments = null;
        vm.comp.turnaroundTime = '3 day (standard)';
        vm.comp.estimated_report_date = null;
        vm.comp.categories = null;
        vm.comp.sampleArray = [];
        vm.comp.all_types = null;
        vm.comp.manufacturing_address = null;
        vm.comp.deliveryPreference = 'ANRESCO_PICK_UP';
        vm.comp.orderPO = null;
        vm.comp.pickup_arrival_date = null;
        vm.comp.emails = '';
        vm.comp.samples = [];
        vm.comp.tests = [];
        vm.comp.testsRequested = [];
        vm.comp.testsRequestedCount = [];
        vm.comp.mainCollapse = false;
        vm.comp.total = 0;
        vm.comp.subtotal = null;
        vm.comp.total_discount = 0;
        vm.comp.panels = {};
        vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
        vm.comp.existing_user_added_assays = [];
        vm.comp.phases = [];
        vm.comp.phase_map_by_name = {};
        vm.comp.submitting = false;
        vm.comp.processingExcelUpload = false;
        vm.comp.uploadedFiles = [];
        vm.comp.importedExcelFiles = [];

        vm.comp.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.comp.uploadedFiles);
                currentSize += getTotalFileSize(vm.comp.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('comp-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.comp.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('comp-file-upload').value = '';
            }
        };

        vm.comp.removeFile = function(index) {
            vm.comp.uploadedFiles.splice(index, 1);
        };


// **************************** START COMP FUNCTIONS ****************************

    vm.comp.cancelOrder = function() {
        location.reload(true);
    }

    vm.comp.uploadExcel = function() {
        $('#comp_upload_excel').click();
    }

    vm.comp.handleExcel = function() {
        return handleExcelImport(vm.comp, '#comp_upload_excel', function(workbook) {
            return comp.extractExcelValues(workbook.sheet(0).usedRange().value());
        });
    }

    comp.createPhaseMap = function() {
        vm.comp.phases.forEach( function(phase) {
            vm.comp.phase_map_by_name[phase.name] = phase;
        });
    }

    comp.createNewSample = function() {
        return ({
            sample_expanded: vm.comp.mainCollapse,
            sample_checked: null,
            sample_delete: false,
            sample_name: null,
            sample_lot_batch_number: null,
            sample_category: null,
            sample_type: null,
            sample_types: null,
            sample_inhalable: null,
            sample_metrc_id: null,
            sample_source_id: null,
            sample_strain_name: null,
            sample_strain_type: null,
            sample_label_claims: null,
            sample_expected_potency: null,
            sample_matrix: null,
            sample_product_harvest_batch: 'PRODUCT_BATCH',
            sample_product_batch_size: null,
            sample_manufacture_date_open: false,
            sample_manufacture_date: null,
            sample_harvest_date_open: false,
            sample_harvest_date: null,
            sample_unit_weight: null,
            sample_add_terpenoid_profile: false,
            sample_analyze_by_lcmsms: false,
            focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                }
        });
    }

    comp.extractComplianceValues = function(row) {
        var sample = comp.createNewSample();

        if(!row.every(allEmpty)) {
            var sample_category = row[3] ? formatSampleCategory(row[3]) : null;
            sample.sample_matrix = row[0] ? vm.comp.phase_map_by_name[row[0]] : null;
            sample.sample_name = !allEmpty(row[1]) ? stripInvalidQBChars(row[1]) : null;
            // Handle lot batch number - check if it's a date serial number from Excel
            if (row[2]) {
                if (typeof row[2] === 'number') {
                    // Check if this is likely an Excel date serial number
                    // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                    if (row[2] >= 43101 && row[2] <= 49673) {
                        // Convert Excel date serial number back to date string
                        var baseDate = 25567; // Excel base date for 1900 system
                        var date = new Date(Math.round((row[2] - baseDate - 1) * 86400 * 1000));

                        // Format as MM/DD/YYYY
                        var month = (date.getMonth() + 1).toString().padStart(2, '0');
                        var day = date.getDate().toString().padStart(2, '0');
                        var year = date.getFullYear();
                        sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                    } else {
                        // This is just a regular number, not a date
                        sample.sample_lot_batch_number = row[2].toString();
                    }
                } else {
                    sample.sample_lot_batch_number = stripInvalidQBChars(row[2]);
                }
            } else {
                sample.sample_lot_batch_number = null;
            }
            sample.sample_category = sample_category ? sample_category : null;
            sample.sample_types = sample_category ? sample_category.types : null;
            sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[4]) : null;
            sample.sample_inhalable = row[5] ? formatInhalableFromImport(row[5]) : null;
            sample.sample_source_id = row[6] ? row[6] : null;
            sample.sample_strain_name = row[7] ? row[7] : null;
            sample.sample_strain_type = row[8] ? formatStrainType(row[8]) : null;
            sample.sample_label_claims = row[9] ? row[9] : null;
            sample.sample_expected_potency = row[10] ? row[10] : null;
            sample.sample_add_terpenoid_profile = row[11] ? (row[11] == 'Yes' ? true : false) : false;
            sample.sample_analyze_by_lcmsms = row[12] ? (row[12] == 'Yes' ? true : false) : false;
            sample.sample_product_harvest_batch = row[13] ? comp.formatBatchType(row[13]) : null;
            sample.sample_product_batch_size = row[14] ? row[14] : null;
            row[14] ? (sample.sample_product_harvest_batch == 'PRODUCT_BATCH' ? sample.sample_harvest_date = comp.formatExcelDate(row[15]) : sample.sample_manufacture_date = comp.formatExcelDate(row[15])) : angular.noop;
            sample.sample_product_harvest_batch ? angular.noop : sample.sample_product_harvest_batch = 'PRODUCT_BATCH';
            sample.sample_unit_weight = row[16] ? row[16] : null;
            sample.sample_expanded =  true;
            vm.comp.samples.push(sample);
        }
    }

   comp.extractExcelValues = function(file) {
        if (!file || !file.length || !file[0]) {
            AlertService.error('Upload failed. The Excel file is empty.');
            return false;
        }

        var sampleCountBefore = vm.comp.samples.length;
        comp.createPhaseMap();

        for( var i = 1; i < file.length; i++) {
            comp.extractComplianceValues(file[i]);
        }

        vm.comp.checkPageOne();
        comp.resetDeleteCheckboxes();
        if (vm.comp.samples.length === sampleCountBefore) {
            AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
            return false;
        }
        return true;
    }

    comp.formatExcelDate = function(date) {
        var new_date = new Date(date);

        if (new_date != 'Invalid Date'){
            return new_date
        }
        else {
            return null;
        }
    }

    comp.formatBatchType = function(batchType) {
        if (batchType == 'Product Batch') {
            return 'PRODUCT_BATCH'
        }
        else {
            return 'HARVEST_BATCH'
        }
    }

    vm.comp.downloadExcel = function() {
        comp.generateBlob();
    }

    comp.generateBlob = function() {
        return comp.generate()
            .then(function (blob) {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, "Compliance Sample Submission.xlsx");
                } else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = "Compliance Sample Submission.xlsx";
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
            })
            .catch(function (err) {
                alert(err.message || err);
                throw err;
            });
    }

    comp.generate = function(type) {
        return comp.getWorkbook()
            .then(function (workbook) {
                var r = workbook.sheet(0).range("A1:P1");
                var header = ['Matrix*', 'Sample Name*', 'Lot/Batch #*', 'Product Category*', 'Product Type*', 'Inhalable/Non-Inhalable*', 'Source UID*', 'Strain Name', 'Strain Type', 'Label Claims', 'Product Specifications*', 'Add Terpene Profile', 'Analyze by LCMSMS', 'Batch Type*', 'Batch Size*', 'Batch Date', 'Unit Weight*'];

                r.value([header]);
                workbook.sheet(0).row(1).style("bold", true);
                workbook.sheet(1).hidden(true);

                return workbook.outputAsync({ type: type });
            });
    }

    comp.getWorkbook = function() {
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            var url = 'content/files/public/compliance.xlsx';

            req.open("GET", url, true);
            req.responseType = "arraybuffer";
            req.onreadystatechange = function () {
                if (req.readyState === 4){
                    if (req.status === 200) {
                        resolve(XlsxPopulate.fromDataAsync(req.response));
                    } else {
                        reject("Received a " + req.status + " HTTP code.");
                    }
                }
            };
            req.send();
        });
    }

    vm.comp.collapseAll = function() {
        vm.comp.mainCollapse = !vm.comp.mainCollapse;
        if (vm.comp.samples.length != 0) {
            vm.comp.samples.forEach( function(sample) {
                sample.sample_expanded = vm.comp.mainCollapse;
            });
        }
    }

    function findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(typeof(array[i][attr]) == 'string' && typeof(value) == 'string'){
                if(array[i][attr].toLowerCase() === value.toLowerCase()) {
                    return i;
                }
            }
            else {
                if(array[i][attr] === value) {
                    return i;
                }
            }
        }
        return -1;
    }

    vm.comp.changeMatrix = function(index) {
        var category_index = null;
        var type_index = null;
        var inhalable_index = null;

        if (vm.comp.samples.length < 1) {
            vm.comp.pageOneValid = false;
            return;
        }

        if(vm.comp.samples[index].sample_matrix) {
            if(vm.comp.samples[index].sample_matrix.value == 'PLANT_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Flower')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'PRE_ROLL_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Pre-Roll')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'INHALABLE_EXTRACT_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Concentrate');
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'EDIBLE_COMPLIANCE_PHASE_3') {
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'NONINHALABLE');

                vm.comp.samples[index].sample_category = null;
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'SOLID_EDIBLE_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Edible');
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'NONINHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'INFUSED_PREROLL_COMPLIANCE') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Infused Pre-Roll')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }

            if(category_index) {
                vm.comp.populateTypes(vm.comp.samples[index]);
            }
        }

        vm.comp.checkPageOne();
    }

    vm.comp.checkPageOne = function() {
        if (vm.comp.samples.length < 1) {
            vm.comp.pageOneValid = false;
            return;
        }

        for(var i = 0; i < vm.comp.samples.length; i++){
            if (!vm.comp.samples[i].sample_product_harvest_batch) {
                vm.comp.pageOneValid = false;
                return;
            }
            else {
                if (vm.comp.samples[i].sample_product_harvest_batch == 'PRODUCT_BATCH') {
                    if (!vm.comp.samples[i].sample_matrix ||
                        !vm.comp.samples[i].sample_name ||
                        !vm.comp.samples[i].sample_lot_batch_number ||
                        !vm.comp.samples[i].sample_category ||
                        !vm.comp.samples[i].sample_type ||
                        !vm.comp.samples[i].sample_inhalable ||
                        !vm.comp.samples[i].sample_source_id ||
                        !vm.comp.samples[i].sample_product_batch_size ||
                        !vm.comp.samples[i].sample_unit_weight || 
                        !vm.comp.samples[i].sample_expected_potency) {
                            vm.comp.pageOneValid = false;
                            return;
                    }
                }
                else {
                    if (!vm.comp.samples[i].sample_matrix ||
                        !vm.comp.samples[i].sample_name ||
                        !vm.comp.samples[i].sample_lot_batch_number ||
                        !vm.comp.samples[i].sample_category ||
                        !vm.comp.samples[i].sample_type ||
                        !vm.comp.samples[i].sample_inhalable ||
                        !vm.comp.samples[i].sample_source_id ||
                        !vm.comp.samples[i].sample_product_batch_size) {
                            vm.comp.pageOneValid = false;
                            return;
                    }
                }
            }
        }

        vm.comp.pageOneValid = true;
        return;
    }

    vm.comp.checkPageTwo = function() {
        if (!vm.fullLocationManufactur ||
            !vm.fullLocationComp ||
            !vm.comp.pickup_arrival_date ||
            !vm.fullLocationPickup ||
            !($('#emailToCompliance').val().length > 0) ||
            vm.pickupOutOfStateError
        ) {
            vm.comp.pageTwoValid = false;
            return;
        }
        vm.comp.pageTwoValid = true;
        return;
    }

    vm.comp.submitOrder = function() {
        $rootScope.type = 'COMPLIANCE';
        CustomerOrder.save(comp.serializePayload(), onSaveSuccess, onSaveError);
    }

    comp.serializeSamples = function(samples) {
        var serializedSamples = [];
        if (samples) {
            samples.forEach( function(sample){
                serializedSamples.push({
                    id: null,
                    name: sample.sample_name,
                    lotBatchNumber: sample.sample_lot_batch_number,
                    productCategory: typeof(sample.sample_category) == 'string' ? formatNameDict(sample.sample_category) : sample.sample_category,
                    productType: typeof(sample.sample_type) == 'string' ? formatNameDict(sample.sample_type) : sample.sample_type,
                    strainName: typeof(sample.sample_strain_name) != 'object' ? formatNameDict(sample.sample_strain_name) : sample.sample_strain_name,
                    strainType: typeof(sample.sample_strain_type) == 'string' ? formatNameDict(sample.sample_strain_type) : sample.sample_strain_type,
                    otherAnalysis: null,
                    reportedUnits: null,
                    productBatchSize: sample.sample_product_harvest_batch == 'PRODUCT_BATCH' ? sample.sample_product_batch_size : null,
                    harvestBatchSize: sample.sample_product_harvest_batch == 'HARVEST_BATCH' ? sample.sample_product_batch_size : null,
                    batchType: sample.sample_product_harvest_batch,
                    inhalableEdible: typeof(sample.sample_inhalable) == 'object' ? sample.sample_inhalable.value : sample.sample_inhalable,
                    sourceId: sample.sample_source_id ? sample.sample_source_id : null,
                    sCode: sample.sample_metrc_id ? sample.sample_metrc_id : null,
                    labelClaims: sample.sample_label_claims,
                    expectedPotency: sample.sample_expected_potency,
                    addTerpenes: sample.sample_add_terpenoid_profile ? sample.sample_add_terpenoid_profile : null,
                    analyzeByLCMSMS: sample.sample_analyze_by_lcmsms ? sample.sample_analyze_by_lcmsms : null,
                    manufactureDate: formatDate(sample.sample_manufacture_date),
                    harvestDate: formatDate(sample.sample_harvest_date),
                    sampleWeightPerIncrement: sample.sample_unit_weight ? sample.sample_unit_weight : null,
                    sampleTests: null,
                    phase: sample.sample_matrix.value ? sample.sample_matrix.value : null,
                    medicinal_batch: sample.medicinal_batch

                });
            });
        }
        return serializedSamples;
    }

    comp.serializePayload = function() {
        vm.comp.submitting = true;
        $rootScope.comp_submitting = vm.comp.submitting
        var payload = {
            orderType: "COMPLIANCE",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: vm.comp.deliveryPreference,
            estimated_arrival_date: formatDate(vm.comp.pickup_arrival_date),
            partially_complete: null,
            poNumber: vm.comp.orderPO,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: formatDate(vm.comp.pickup_arrival_date),
            samplingAddress: vm.samplingAddress,
            manufacturingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
            invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
            shipping_carrier: null,
            specialInstructions: vm.comp.specialInstructions,
            customerComments: vm.comp.customerComments,
            state: null,
            submitted_by: vm.comp.emailsArray.join(),
            dynamic_turnaround_time: vm.comp.turnaroundTime,
            id: null,
            samples: comp.serializeSamples(vm.comp.samples),
            tracking_number: vm.comp.tracking_number,
            uploaded_files: vm.comp.uploadedFiles,
            source_workbooks: vm.comp.importedExcelFiles
        }

        return payload;
    }

        vm.comp.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.comp.estimateReportDate = function(turnaround_time){
            var days = null;

            if (turnaround_time.includes('3')) {
                days = 3;
            }
            else if (turnaround_time.includes('2')) {
                days = 2;
            }
            else if (turnaround_time.includes('1')) {
                days = 1;
            }

            if (days && turnaround_time && vm.comp.pickup_arrival_date) {
                var tomorrow = new Date(vm.comp.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.comp.estimated_report_date = tomorrow;
            }

            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.comp.estimated_report_date.day = days[tomorrow.getDay()]
                vm.comp.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.comp.checkPageTwo();
        }

        vm.comp.deleteChecked = function() {
            for(var i = vm.comp.samples.length-1; i >= 0; i--) {
                if (vm.comp.samples[i].sample_delete) {
                    vm.comp.samples.splice(i, 1);
                }
            }
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        }

        vm.comp.clickCheckAllDelete = function() {
            vm.comp.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.comp-delete-checkbox-header')[0].checked;
            });
        }

        vm.comp.clickDelete = function(index) {
            vm.comp.samples[index].sample_delete = !vm.comp.samples[index].sample_delete;
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
        }

        vm.comp.incrementPage = function() {
            vm.comp.step = vm.comp.step + 1;
            if(vm.comp.step == 3) {
                vm.comp.emailsArray = vm.comp.emails.split(',')
            }
        }

        vm.comp.decrementPage = function() {
            vm.comp.step = vm.comp.step - 1;
        }

        vm.comp.removeSample = function(index) {
            vm.comp.samples.splice(index, 1);
            vm.comp.sampleArray.splice(index, 1);
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        }

        vm.comp.cloneSample = function(index) {
            // Create a deep copy of the sample
            var clonedSample = angular.copy(vm.comp.samples[index]);
            
            // IMPORTANT: Reset the fields we want to explicitly set
            clonedSample.sample_category = null;
            clonedSample.sample_type = null;
            clonedSample.sample_types = null;
            clonedSample.sample_inhalable = null;
            
            // Now explicitly set them with the correct references
            
            // 1. Handle sample_category
            if (vm.comp.samples[index].sample_category && vm.comp.categories) {
                for (var i = 0; i < vm.comp.categories.length; i++) {
                    if (vm.comp.categories[i].id === vm.comp.samples[index].sample_category.id) {
                        clonedSample.sample_category = vm.comp.categories[i];
                        break;
                    }
                }
            }
            
            // 2. Handle sample_types and sample_type
            if (clonedSample.sample_category && clonedSample.sample_category.types) {
                clonedSample.sample_types = clonedSample.sample_category.types;
                
                if (vm.comp.samples[index].sample_type) {
                    for (var j = 0; j < clonedSample.sample_types.length; j++) {
                        if (clonedSample.sample_types[j].id === vm.comp.samples[index].sample_type.id) {
                            clonedSample.sample_type = clonedSample.sample_types[j];
                            break;
                        }
                    }
                }
            }
            
            // 3. Handle sample_inhalable
            if (vm.comp.samples[index].sample_inhalable) {
                // If it's a string value
                if (typeof vm.comp.samples[index].sample_inhalable === 'string') {
                    // For comp, we use vm.comp.inhalable_edible_array which exists
                    if (vm.comp.inhalable_edible_array && vm.comp.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.comp.inhalable_edible_array, 'value', vm.comp.samples[index].sample_inhalable);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.comp.inhalable_edible_array[inhalableIndex];
                        } else {
                            // If not found in the array, just use the string directly
                            clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                        }
                    } else {
                        // If no array exists, just use the string directly
                        clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                    }
                } 
                // If it's an object with a value property
                else if (vm.comp.samples[index].sample_inhalable.value) {
                    if (vm.comp.inhalable_edible_array && vm.comp.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.comp.inhalable_edible_array, 'value', vm.comp.samples[index].sample_inhalable.value);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.comp.inhalable_edible_array[inhalableIndex];
                        } else {
                            clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                        }
                    } else {
                        clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                    }
                }
                // Otherwise just copy it directly
                else {
                    clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                }
            }
                        
            // Add the cloned sample to the array
            vm.comp.samples.splice(index + 1, 0, clonedSample);
            if (vm.comp.sampleArray && vm.comp.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.comp.sampleArray[index]);
                vm.comp.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        };
        
        comp.onPageLoad = function() {
            comp.getPanels();
            comp.getCategories();
        }

        comp.getPanels = function() {
            Panel.query({}, function(data){
            if (data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].portalIdentifier) {
                        vm.comp.panels[data[i].portalIdentifier] = data[i];
                    }
                }
                vm.comp.phases = [
                        /* Plant */
                        {
                            'id': vm.comp.panels['PLANT_COMPLIANCE_PHASE_3'].id,
                            'name': 'Plant',
                            'value':'PLANT_COMPLIANCE_PHASE_3'
                        },

                        /* Pre-Roll Compliance */
                        {
                            'id': vm.comp.panels['PRE_ROLL_COMPLIANCE_PHASE_3'].id,
                            'name': 'Pre-Roll',
                            'value': 'PRE_ROLL_COMPLIANCE_PHASE_3'
                        },

                        /* Inhalable Extract */
                        {
                            'id': vm.comp.panels['INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'].id,
                            'name': 'Inhalable Extract',
                            'value':'INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'
                        },

                        /* Infused Pre-Roll */
                        {
                            'id': vm.comp.panels['INFUSED_PREROLL_COMPLIANCE'].id,
                            'name': 'Infused Pre-Roll',
                            'value':'INFUSED_PREROLL_COMPLIANCE'
                        },

                        /* Non-Inhalable */
                        {
                            'id': vm.comp.panels['EDIBLE_COMPLIANCE_PHASE_3'].id,
                            'name': 'Liquid Edible/Topical',
                            'value':'EDIBLE_COMPLIANCE_PHASE_3'
                        },

                        /* Solid Edible */
                        {
                            'id': vm.comp.panels['SOLID_EDIBLE_COMPLIANCE_PHASE_3'].id,
                            'name': 'Solid/Semi-Solid Edible',
                            'value':'SOLID_EDIBLE_COMPLIANCE_PHASE_3'
                        },
                    ];
                }
            });
        }

        vm.comp.addSample = function() {
            vm.comp.samples.push({
                sample_order_type: 'comp',
                sample_expanded: true,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_metrc_id: null,
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_matrix: null,
                sample_product_harvest_batch: 'PRODUCT_BATCH',
                sample_product_batch_size: null,
                sample_manufacture_date_open: false,
                sample_manufacture_date: null,
                sample_harvest_date_open: false,
                sample_harvest_date: null,
                sample_unit_weight: null,
                sample_add_terpenoid_profile: false,
                sample_analyze_by_lcmsms: false,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                },
                medicinal_batch: false
            });
            vm.comp.checkPageOne();
        }

        vm.comp.strainTypes  = [{
            'id': 1,
            'name': 'Sativa'
          }, {
             'id': 2,
             'name': 'Indica'
          }, {
            'id': 3,
            'name': 'Hybrid'
          },
          {
            'id': 4,
            'name': 'CBD'
          }];

        vm.comp.inhalable_edible_array  = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value':'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value':'NONINHALABLE'
            }
        ];

        comp.getCategories = function() {
            ProductCategory.query({}, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.comp.categories = data;
                comp.getTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        comp.getTypes = function() {
            ProductType.query({}, onSuccess, onError);

            function onSuccess(data, headers){
               // Filter out specific product types if language is Japanese
            if ($localStorage.language === 'Japanese') {
                vm.comp.all_types = data.filter(function(type) {
                    return !['Crystalline', 'Hash', 'Kief', 'Infused Products', 'Cones/Tubes', 'Paper/Wrap'].includes(type.name);
                });
            } else {
                vm.comp.all_types = data;
            }
                comp.processCatAndTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        comp.processCatAndTypes = function() {
            for(var i = 0; i < vm.comp.all_types.length; i++){
                for(var j = 0; j < vm.comp.categories.length; j++){
                    if (!vm.comp.categories[j.toString()].types){
                        vm.comp.categories[j.toString()].types = [];
                    }
                    if (vm.comp.all_types[i.toString()].productCategory.id == vm.comp.categories[j.toString()].id){
                        vm.comp.categories[j.toString()].types.push(vm.comp.all_types[i.toString()]);
                    }
                }
            }
        }

        comp.resetDeleteCheckboxes = function() {
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
            vm.comp.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.comp.populateTypes = function(sample) {
            for(var i = 0; i < vm.comp.categories.length; i++) {
                if (sample.sample_category.name == vm.comp.categories[i.toString()].name) {
                    sample.sample_types = vm.comp.categories[i.toString()].types;
                    return;
                }
            }
        }

        comp.onPageLoad();

// ***************************** END COMP FUNCTIONS *****************************
// **************************** START FDA ****************************
        vm.fda = {payload:{}}
        vm.fda.isFdaDisabled = true
        vm.fda.uploadedFiles = [];

        vm.fda.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var maxTotalSize = 10 * 1024 * 1024; // 10MB total
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = 0;
                for (var i = 0; i < vm.fda.uploadedFiles.length; i++) {
                    currentSize += vm.fda.uploadedFiles[i].size;
                }
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > maxTotalSize) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('fda-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.fda.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('fda-file-upload').value = '';
            }
        };

        vm.fda.removeFile = function(index) {
            vm.fda.uploadedFiles.splice(index, 1);
        };

        vm.fda.location = function(address, city, zipCode, name, medicalLicence, fullLocation) {
            vm.fda.payload.warehouse_address = createAddress(address, city, zipCode, name, medicalLicence);
            vm.fda.payload.warehouse_address = fullLocation;
            distribution_list_toggle();
        }
        function checkLineArray(element) {
            return element.productdesc !== '' && element.lineItem !== ''
        }
        vm.fda.checkfdaform = function(){
            var validLineArray
            if(vm.fda.line.length > 0){
                validLineArray = vm.fda.line.every(checkLineArray)
            }
            if(!vm.fda.payload.entry || !vm.fda.payload.warehouse_address || validLineArray === false){
                vm.fda.isFdaDisabled = true
                return false
            }
            else{
                if(!vm.fda.payload.detention_notice || !vm.fda.payload.list_invoice_pack){
                    vm.fda.isFdaDisabled = true
                    return false
                }
                else{
                    vm.fda.isFdaDisabled = false
                }
            }
        }
        vm.fda.submitOrder = function() {
            $rootScope.type = 'FDA'
            vm.fda.checkfdaform()
            vm.fda.payload.order_type = 'FDA';
            vm.fda.payload.customer_account_id = $localStorage.customerId
            vm.fda.payload.samples = vm.fda.line
            vm.fda.payload.uploaded_files = vm.fda.uploadedFiles
            CustomerOrder.save(vm.fda.payload, onSaveSuccess, onSaveError);
            if(vm.fda.submitting){
                ProgressInterval = setInterval(() => {
                    if (vm.progressCount < 31) {
                        vm.progressCount = vm.progressCount - 1;
                        var percentage = (vm.progressCount * 100)/30
                        progressCircle.style.backgroundImage = 'conic-gradient('+ 'rgb(50, 168, 82) ' +  percentage + '%, rgb(183, 237, 197) 0 )';
                        if(vm.progressCount <= 0 ){
                            $('#submitProgressModal').modal('hide');
                        }
                    } else {
                        vm.progressCount = 30;
                    }
                }, 1000);
                $(document).on('click', '.progress-button', function() {
                    $('#submitProgressModal').modal('show');
                });
            }
        }
        vm.fda.line = [{
            productdesc : '',
            lineItem : '',
            batchNo : ''
        }]
        vm.fda.addLine = function (){
            vm.fda.line.push({
                productdesc : '',
                lineItem : '',
                batchNo : ''
            })
            vm.fda.checkfdaform()
        }
        vm.fda.removeLine = function(index){
            vm.fda.line.splice(index,1)
        }

        vm.onfileUpload = function(id) {
            var file = $(`#${id}`)[0].files[0];
            var base64 = DataUtils.toBase64(file, function(data){
                if (!vm.fda.payload[id]) {
                    vm.fda.payload[id] = {}; // Initialize if undefined
                }
                vm.fda.payload[id].name = file.name; 
                vm.fda.payload[id].base64 = data;
                if(id == 'detention_notice' || id == 'list_invoice_pack'){
                    vm.fda.isFdaDisabled = false
                }
            });
            vm.fda.checkfdaform()
        };
// ***************************** END FDA FUNCTIONS *****************************


// **************************** START RND ****************************

        // Helper function to organize tests into panel and non-panel groups for R&D
        vm.rd.organizeTests = function(sample) {
            if (!sample) return;
            
            // Create arrays to hold panel and non-panel tests
            sample.nonPanelTests = [];
            sample.panelTests = [];
            
            
            // Get the current panel ID if one is selected
            var currentPanelId = sample.sample_panel_selected;
            
            // Sort tests into panel and non-panel arrays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                var test = sample.sample_tests[i];
                if (test.checked) {
                    // A test is part of the panel if:
                    // 1. It has a panel_id property AND
                    // 2. That panel_id matches the currently selected panel AND
                    // 3. A panel is actually selected
                    if (test.panel_id && currentPanelId && test.panel_id == currentPanelId) {
                        sample.panelTests.push(test);
                    } else {
                        // If the test has a panel_id but it doesn't match the current panel,
                        // or if it has no panel_id, it should be treated as a non-panel test
                        sample.nonPanelTests.push(test);
                    }
                }
            }
            
            // Debug the variables that control panel button visibility
            };

        vm.rd.step = 1;
        vm.rd.pageOneValid = false;
        vm.rd.pageTwoValid = false;
        vm.rd.pageThreeValid = false;
        vm.rd.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.rd.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.rd.excel_header_offset =  vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp') ? 14 : 5;
        vm.rd.file = null;
        vm.rd.specialInstructions = null;
        vm.rd.customerComments = null;
        vm.rd.turnaroundTime = vm.rd.turnaroundTimeOptions ? '3 day (standard)' : '10 Days (standard)';
        vm.rd.estimated_report_date = null;
        vm.rd.categories = null;
        vm.rd.sampleArray = [];
        vm.rd.all_types = null;
        vm.rd.manufacturing_address = null;
        vm.rd.deliveryPreference = null;
        vm.rd.orderPO = null;
        vm.rd.pickup_arrival_date = null;
        vm.rd.emails = '';
        vm.rd.samples = [];
        vm.rd.tests = [];
        vm.rd.testsRequested = [];
        vm.rd.testsRequestedCount = [];
        vm.rd.mainCollapse = false;
        vm.rd.total = 0;
        vm.rd.subtotal = null;
        vm.rd.total_discount = 0;
        vm.rd.excel_assay_header = null;
        vm.rd.excel_assay_index_map = {};
        vm.rd.assay_map = {};
        vm.rd.assay_map_by_index = {};
        vm.rd.cannabinoid_assays = {}
        vm.rd.cannabinoid_assay_added = false;
        vm.rd.all_assay_map_by_id = {};
        vm.rd.all_tests = [];
        vm.rd.showTests = {};
        vm.rd.showTestsArray = [];
        vm.rd.showTestResults = null;
        vm.rd.panels = {};
        vm.rd.panels.current_panel_index = null;
        vm.rd.panels.new_panel_name = null;
        vm.rd.panel_by_id_map = {}
        vm.rd.current_sample_name = null;
        vm.rd.customPanels = [];
        vm.rd.qbenchPanels = [];
        vm.order_type = vm.rd.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
        vm.rd.test_to_search = '';
        vm.rd.other_analyses = [];
        vm.rd.user_added_assays = [];
        vm.rd.existing_user_added_assays = [];
        vm.rd.number_of_freq_assays = 0;
        vm.rd.submitting = false;
        vm.rd.processingExcelUpload = false;
        vm.rd.uploadedFiles = [];
        vm.rd.importedExcelFiles = [];

        vm.rd.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.rd.uploadedFiles);
                currentSize += getTotalFileSize(vm.rd.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('rd-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.rd.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('rd-file-upload').value = '';
            }
        };

        vm.rd.removeFile = function(index) {
            vm.rd.uploadedFiles.splice(index, 1);
        };

        // **************************** START RND FUNCTIONS ****************************

        rd.showAllTests = function() {
            angular.forEach(vm.rd.showTests, function(value, key) {
                vm.rd.showTests[key] = true;
            });
            return;
        }

        rd.getTypes = function() {
            ProductType.query({}, onSuccess, onError);

            function onSuccess(data, headers){
                vm.rd.all_types = data;
                rd.processCatAndTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        rd.processCatAndTypes = function() {
            for(var i = 0; i < vm.rd.all_types.length; i++){
                for(var j = 0; j < vm.rd.categories.length; j++){
                    if (!vm.rd.categories[j.toString()].types){
                        vm.rd.categories[j.toString()].types = [];
                    }
                    if (vm.rd.all_types[i.toString()].productCategory.id == vm.rd.categories[j.toString()].id){
                        vm.rd.categories[j.toString()].types.push(vm.rd.all_types[i.toString()]);
                    }
                }
            }
        }

        rd.resetDeleteCheckboxes = function() {
            $(':checkbox.delete-checkbox-header')[0].checked = false;
            vm.rd.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.rd.filterAssays = function() {
            vm.rd.showTestsArray = Object.keys(vm.rd.showTests);
            vm.rd.showTestResults = $filter('filter')(vm.rd.showTestsArray, vm.rd.test_to_search);
            angular.forEach(vm.rd.showTests, function(value, key) {
                vm.rd.showTests[key] = false;
            });
            vm.rd.showTestResults.forEach( function(test) {
                vm.rd.showTests[test] = true;
            });
            // rd.setInfoBoxCoordinates();
        }
        //filtertering with the ID
        vm.rd.customFilter = function(item) {
            var searchText = vm.rd.test_to_search;
            if (/^\d+$/.test(searchText)) {
                var idMatches = (item.id.toString().indexOf(searchText) !== -1);
                var assayIdMatches = (item.assay_id && item.assay_id.toString().indexOf(searchText) !== -1);
                return idMatches || assayIdMatches;
            } else {
                return item.display_name.toLowerCase().includes(searchText.toLowerCase());
            }
        };
             
        // not currently being used
        function getExistingAssays() {
            if (vm.customerData.added_assays) {
                vm.customerData.added_assays.forEach( function(id) {
                    vm.rd.addExistingAssay(id);
                });
            }
        }

        // not currently being used
        vm.rd.addExistingAssay = function(id) {
            var test = vm.rd.all_assay_map_by_id[id];

            test.index = vm.rd.tests.length;
            vm.rd.assay_map[test.display_name] = [test.index, test];
            vm.rd.assay_map_by_index[test.index] = test;
            vm.rd.tests.push(test)

            vm.rd.existing_user_added_assays.push(id);

            vm.rd.test_to_search = '';
        }

        vm.rd.clear_test_to_search = function() {
            vm.rd.test_to_search = '';
            vm.rd.filterAssays();
            // rd.setInfoBoxCoordinates();
        }

        vm.rd.select_test_to_search = function(name) {
            vm.rd.test_to_search = name;
            vm.rd.filterAssays();
            // rd.setInfoBoxCoordinates();
        }

        vm.rd.clickCheckAllAddedTest = function(test, index) {
            var selector = ':checkbox.added-assay-col-header-' + index;
            vm.rd.samples.forEach( function(sample) {
                sample.sample_other_analyses[test] = $(selector)[0].checked
            });

            vm.rd.checkPageTwo();
        }

        vm.rd.addOtherAnalysis = function() {
            vm.rd.other_analyses.push(vm.rd.test_to_search);
            vm.rd.test_to_search = '';
            rd.showAllTests()

            return;
        }

        vm.rd.clearOtherAnalysis = function() {
            rd.showAllTests();
            vm.rd.other_analyses = [];
            vm.rd.test_to_search = '';

            return;
        }

        vm.rd.savePanel = function(sampleIndex, step) {
            if (step == 1) {
                vm.rd.panels.current_panel_index = sampleIndex;
                $('#addPanelName').modal('show'); 
                return;
            }

            else if (step == 2) {
                var assays = [];
                Object.keys(vm.rd.sampleArray[vm.rd.panels.current_panel_index]).forEach( function(key) {
                    if (vm.rd.sampleArray[vm.rd.panels.current_panel_index][key]) {
                        assays.push({id: vm.rd.assay_map_by_index[key].id})
                    }
                });

                if (vm.rd.panels.new_panel_name && assays) {
                    CustomPanel.create({
                            title: vm.rd.panels.new_panel_name,
                            assays: assays
                        },
                        function() {
                            vm.rd.samples[vm.rd.panels.current_panel_index].sample_has_tests = true;

                            rd.getPanelsByCustomerAndSetPanel(vm.rd.panels.current_panel_index);
                        },
                        function(e) {
                            console.log(e);
                        }
                    );
                }
                return;
            }
        }

        rd.getPanelsByCustomerAndSetPanel = function(sampleIndex) {
            CustomPanel.query({},
                function(data) {
                    vm.rd.customPanels = [];
                    var panel_id = null
                    data.forEach( function(panel) {
                        vm.rd.customPanels.push({
                            title: panel.title,
                            assays:rd.getPanels(panel),
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    rd.setPanelsByIdMap();
                    panel_id = vm.rd.customPanels[vm.rd.customPanels.length-1].id;
                    vm.rd.setPanel(vm.rd.samples[sampleIndex], panel_id, 'custom_panel');
                    vm.rd.samples[sampleIndex].sample_panel_by_id = panel_id;
                    vm.rd.samples[sampleIndex].sample_has_tests = false;
                    vm.rd.panels.current_panel_index = null;
                    vm.rd.panels.new_panel_name = null;
                },
                function(e){
                    console.log(e);
                }
            );
        }


        vm.rd.updatePanel = function(sampleIndex, panelId) {
            var assays = [];
            Object.keys(vm.rd.sampleArray[sampleIndex]).forEach( function(key) {
                if(vm.rd.sampleArray[sampleIndex][key]) {
                    assays.push({id: vm.rd.assay_map_by_index[key].id})
                }
            });
            CustomPanel.update({
                id: panelId,
                assays: assays
            },
                function() {
                    vm.rd.samples[sampleIndex].sample_has_tests = false;
                    rd.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );
            return;
        }

        vm.rd.deletePanel = function(panelId) {
            vm.rd.customPanels = [];

            CustomPanel.delete({id: panelId},
                function() {
                    rd.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );

            return;
        }

        rd.isSample = function(object) {
            return object.sample_name == vm.rd.current_sample_name;
        }

        rd.isBasicPotencyAssay = function(test) {
            if(test.portal_identifier && [vm.const.PLANT, vm.const.NON_PLANT].includes(test.portal_identifier)) {
                return true;
            }
            else {
                return false
            }
        }

        rd.potencyAssayByCategory = function(category) {
            if(['Plant'].includes(category.name)) {
                return vm.rd.cannabinoid_assays[vm.const.PLANT]
            }
            else if(['Concentrate', 'Edible', 'Topical', 'Environmental', 'Other'].includes(category.name)) {
                return vm.rd.cannabinoid_assays[vm.const.NON_PLANT]
            }
        }

        vm.rd.removePanelFromSample = function(sampleIndex) {
            Object.keys(vm.rd.sampleArray[sampleIndex]).forEach( function(key) {
                vm.rd.sampleArray[sampleIndex][key] = false;
            });

            vm.rd.tests.forEach( function(test, index) {
                $(':checkbox.assay-col-header-' + index)[0].checked = false;
            })

            vm.rd.current_sample_name = false;
            vm.rd.samples[sampleIndex].sample_current_panel_title = null;
            vm.rd.samples[sampleIndex].sample_panel_selected = null;
            vm.rd.samples[sampleIndex].sample_panel_by_id = null;
            vm.rd.samples[sampleIndex].sample_panel_type = null;
            vm.rd.samples[sampleIndex].sample_has_tests = null;
            vm.rd.samples[sampleIndex].sample_tests = [];

            vm.rd.checkPageTwo();
        }

        vm.rd.setPanel = function(sample, panelId, panel_type) {
            // Find the actual sample index by object reference, not by name
            var sampleIndex = vm.rd.samples.indexOf(sample);
            
            if (sampleIndex === -1) {
                console.error('Sample not found in samples array');
                return;
            }
            
            vm.rd.current_sample_name = sample.sample_name;

            var temp = null;
            if (vm.rd.sampleArray[sampleIndex]) {
                delete vm.rd.sampleArray[sampleIndex];
            }
            vm.rd.sampleArray[sampleIndex] = {};

            // Store existing tests that are not part of the panel
            var existingTests = [];
            if (vm.rd.samples[sampleIndex].sample_tests) {
                // Save any manually added tests that are checked
                existingTests = vm.rd.samples[sampleIndex].sample_tests.filter(function(test) {
                    return test.checked && !test.panel_id;
                });
                
                
                // Clear the tests array to rebuild it
                vm.rd.samples[sampleIndex].sample_tests = [];
                
                // Add back the preserved tests first
                existingTests.forEach(function(test) {
                    // Ensure these tests are marked as non-panel tests
                    if (test.panel_id) {
                        delete test.panel_id;
                        delete test.panel_name;
                    }
                    vm.rd.samples[sampleIndex].sample_tests.push(test);
                });
            }
            
            // Track assays that customer doesn't have access to
            var inaccessibleAssays = [];
            var accessibleAssays = [];
            
            // Process each assay in the panel
            vm.rd.panel_by_id_map[panelId][1].forEach(function (assay) {
                // IMPORTANT: For panels, we grant access to ALL assays in the panel
                // regardless of customer's normal access rights
                
                // First ensure the assay is in showTests/showTestsArray if it's from a panel
                if (vm.rd.showTestsArray.indexOf(assay.display_name) === -1) {
                    // This is a panel assay the customer doesn't normally have access to
                    // Add it to the accessible lists
                    vm.rd.showTests[assay.display_name] = true;
                    vm.rd.showTestsArray.push(assay.display_name);
                    // Granting access to R&D panel assay
                }
                
                // Check if the assay exists in the assay map
                if (vm.rd.assay_map[assay.display_name]) {
                    // Now the customer has access (we just granted it above if needed)
                    // Add accessible assays to the sample
                    temp = Object.assign({}, vm.rd.assay_map[assay.display_name][1]);
                    temp.checked = true;
                    
                    // Set panel association on the test
                    temp.panel_id = panelId;
                    temp.panel_name = vm.rd.panel_by_id_map[panelId][0];
                    
                    // Handle source_uid vs source_id mapping
                    if (temp.source_id && !temp.source_uid) {
                        temp.source_uid = temp.source_id;
                    }
                    
                    vm.rd.samples[sampleIndex].sample_tests.push(temp);
                    vm.rd.sampleArray[sampleIndex][vm.rd.assay_map[assay.display_name][1].index] = true;
                    accessibleAssays.push(assay.display_name);
                } else {
                    // Assay not in assay_map - this shouldn't happen with our previous fixes
                    console.warn('R&D Panel assay not in assay_map:', assay.display_name);
                    inaccessibleAssays.push(assay.display_name);
                }
            });
            

            vm.rd.samples[sampleIndex].sample_panel_selected = panelId;
            vm.rd.samples[sampleIndex].sample_panel_type = panel_type;
            vm.rd.samples[sampleIndex].sample_current_panel_title = vm.rd.panel_by_id_map[panelId][0];
            vm.rd.current_sample_name = null;
            vm.rd.checkPageTwo();
            
            // Organize tests for display
            vm.rd.organizeTests(vm.rd.samples[sampleIndex]);

            return;
        }

        vm.rd.applyPanelToAll = function(panelId, panelType) {
            vm.rd.samples.forEach(function(sample) {
                vm.rd.setPanel(sample, panelId, panelType);
                sample.sample_panel_by_id = panelId;
            });
        };

        vm.rd.clearPanelFromAll = function() {
            vm.rd.samples.forEach(function(sample, index) {
                vm.rd.removePanelFromSample(index);
            });
        };
        
        // Check if all tests in a panel are selected for a sample
        vm.rd.checkPanelTestsSelection = function(sampleIndex) {
            var sample = vm.rd.samples[sampleIndex];
            
            // If no panel is selected, nothing to check
            if (!sample.sample_panel_selected) {
                return;
            }
            
            var panelId = sample.sample_panel_selected;
            if (!vm.rd.panel_by_id_map || !vm.rd.panel_by_id_map[panelId] || !vm.rd.panel_by_id_map[panelId][1]) {
                return;
            }
            
            var panelAssays = vm.rd.panel_by_id_map[panelId][1];
            var allAssaysSelected = true;
            var accessibleAssaysInPanel = [];
            var inaccessibleAssaysInPanel = [];
            var selectedAssays = [];
            
            // First, collect all accessible assays that should be in the panel
            panelAssays.forEach(function(assay) {
                if (vm.rd.assay_map[assay.display_name]) {
                    var assayId = vm.rd.assay_map[assay.display_name][1].id;
                    var customerHasAccess = vm.rd.showTestsArray.indexOf(assay.display_name) !== -1;
                    
                    if (customerHasAccess) {
                        accessibleAssaysInPanel.push(assayId);
                    } else {
                        inaccessibleAssaysInPanel.push(assay.display_name);
                    }
                }
            });
            
            // Then, collect all selected assays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].checked) {
                    selectedAssays.push(sample.sample_tests[i].id);
                }
            }
            
            // Check if all accessible panel assays are selected
            for (var i = 0; i < accessibleAssaysInPanel.length; i++) {
                if (selectedAssays.indexOf(accessibleAssaysInPanel[i]) === -1) {
                    allAssaysSelected = false;
                    break;
                }
            }
                        
            // If not all accessible assays are selected, remove panel association
            if (!allAssaysSelected) {
                // Keep the tests but remove panel association
                sample.sample_panel_selected = null;
                sample.sample_panel_type = null;
                sample.sample_current_panel_title = null;
                
                // Only remove panel association from tests that were part of this panel
                // This preserves any manually added tests that aren't part of the panel
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].panel_id === panelId) {
                        delete sample.sample_tests[i].panel_id;
                        delete sample.sample_tests[i].panel_name;
                    }
                }
                
                // For R&D samples, we need to update the UI to reflect individual assays
                // rather than panel assays
                vm.rd.sampleArray[sampleIndex] = {};
                
                // Update the sampleArray to reflect only the checked tests
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && sample.sample_tests[i].index) {
                        vm.rd.sampleArray[sampleIndex][sample.sample_tests[i].index] = true;
                    }
                }
            } else {
                // Make sure panel association is properly set
                sample.sample_panel_selected = panelId;
                sample.sample_panel_type = sample.sample_panel_type || 'panel';
                sample.sample_current_panel_title = vm.rd.panel_by_id_map[panelId][0];
                
                // Only set panel association on tests that are part of this panel
                // DO NOT modify tests that aren't part of this panel
                var panelAssayIds = accessibleAssaysInPanel;
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && panelAssayIds.indexOf(sample.sample_tests[i].id) !== -1) {
                        sample.sample_tests[i].panel_id = panelId;
                        sample.sample_tests[i].panel_name = vm.rd.panel_by_id_map[panelId][0];
                    }
                }
            }
            
            // Organize tests for display
            vm.rd.organizeTests(sample);
            
            return allAssaysSelected;
        }

        vm.rd.strainTypes = [{
            'id': 1,
            'name': 'Sativa'
          }, {
             'id': 2,
             'name': 'Indica'
          }, {
            'id': 3,
            'name': 'Hybrid'
          },
           {
            'id': 4,
            'name': 'CBD'
           }];

        vm.rd.inhalable = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value': 'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value': 'NONINHALABLE'
            }
        ]

        vm.rd.mhlwProductTypes = ['Oil', 'Powder', 'Aqueous Solution', 'Other'];

        vm.rd.cancelOrder = function() {
            vm.rd.step = 1;
            vm.rd.pageOneValid = false;
            vm.rd.pageTwoValid = false;
            vm.rd.pageThreeValid = false;
            vm.rd.specialInstructions = null;
            vm.rd.estimated_report_date = null;
            vm.rd.manufacturing_address = null;
            vm.rd.deliveryPreference = null;
            vm.rd.orderPO = null;
            vm.rd.pickup_arrival_date = null;
            vm.rd.emails = '';
            vm.rd.samples = [];
            vm.fullLocationManufactur = null;
            vm.rd.sampleArray = [];
            vm.rd.mainCollapse = false;
            vm.rd.other_analyses = [];
            vm.rd.user_added_assays = [];
            vm.rd.panels = {};
            vm.rd.panels.current_panel_index = null;
            vm.rd.panels.new_panel_name = null;
            vm.rd.turnaroundTime = '3 day (standard)';
            CustomerOrder.getCustomerEmails({}, onCustomerEmailSuccess, onCustomerEmailError);
        }

         rd.getOrderTotal = function() {
            vm.rd.total = 0;
            vm.rd.subtotal = null;
            vm.rd.total_discount = 0;
            vm.rd.testsRequestedCount.forEach( function(test) {
                // set list price of test
                if (test.assay_customer) {
                    if (test.assay_customer.basePrice) {
                        test.list_price = test.assay_customer.basePrice;
                    }
                    else {
                        if (test.base_price) {
                           test.list_price = test.base_price;
                        }
                        else {
                            test.list_price = null;
                        }
                    }
                }
                else if (test.base_price){
                    test.list_price = test.base_price;
                }
                else {
                    test.list_price = null;
                }
                // set discount of test
                if (test.assay_customer) {
                    if (test.assay_customer.discount) {
                        test.discount = test.assay_customer.discount;
                    }
                    else {
                        if (vm.rd.company_discount) {
                            test.discount = vm.rd.company_discount;
                        }
                        else {
                            test.discount = null;
                        }
                    }
                }
                else if (vm.rd.company_discount){
                    test.discount = vm.rd.company_discount;
                }
                else {
                    test.discount = null;
                }
                // set amount for test and get order subtotal/discount/total
                if (test.list_price && test.count) {
                    if (test.discount) {
                        vm.rd.total_discount = vm.rd.total_discount + (test.list_price * (test.discount / 100));
                        test.amount = (test.list_price * test.count) * (1 - (test.discount / 100));
                        vm.rd.total = vm.rd.total + test.amount
                    }
                    else {
                        test.amount = test.list_price * test.count;
                        vm.rd.total = vm.rd.total + test.amount
                    }
                }
                else {
                    test.amount = null;
                }
            });

            if (vm.rd.total && vm.rd.total_discount) {
                vm.rd.subtotal = vm.rd.total + vm.rd.total_discount;
            }
            else {
                vm.rd.subtotal = vm.rd.total;
            }
        }

        rd.processAllSampleTests = function() {
            vm.rd.testsRequested.length = 0;
            vm.rd.testsRequestedCount.length = 0;
            vm.rd.testsRequested = [];
            vm.rd.testsRequestedCount = [];
            var added = [];
            var to_add = null;

            for(var i = 0; i < vm.rd.samples.length; i++) {
                for(var j = vm.rd.samples[i].sample_tests.length-1; j >= 0; j--) {
                    if(rd.isBasicPotencyAssay(vm.rd.samples[i].sample_tests[j])) {
                        to_add = rd.potencyAssayByCategory(vm.rd.samples[i].sample_category);
                        to_add.checked = true;
                        vm.rd.samples[i].sample_tests[j] = jQuery.extend({}, to_add);
                        vm.rd.testsRequested.push(to_add);
                    }
                    else {
                        vm.rd.testsRequested.push(vm.rd.samples[i].sample_tests[j]);
                    }
                }
            }
            // rd.getOrderTotal();
        }

        vm.rd.estimateReportDate = function(turnaround_time) {
            var days_length = turnaround_time.split(' days')[0];
            var days = null;

            if(days_length.includes('-')) {
                days = days_length.split('-')[1];
            }
            else {
                days = days_length;
            }

            days = parseInt(days);

            if (days && turnaround_time && vm.rd.pickup_arrival_date) {
                var tomorrow = new Date(vm.rd.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.rd.estimated_report_date = tomorrow;
            }
            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.rd.estimated_report_date.day = days[tomorrow.getDay()]
                vm.rd.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.rd.checkPageThree();
        }

        vm.rd.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.rd.populateTypes = function(sample) {
            for(var i = 0; i < vm.rd.categories.length; i++) {
                if (sample.sample_category.name == vm.rd.categories[i.toString()].name) {
                    sample.sample_types = vm.rd.categories[i.toString()].types;
                    return;
                }
            }
        }

        vm.rd.clearPanel = function() {
            vm.rd.panels.current_panel_index = null;
            vm.rd.current_sample_name = null;
            vm.rd.panels.current_panel_index = null;
            vm.rd.panels.new_panel_name = null;        
        }

        vm.rd.uploadExcel = function() {
            $('#rd_upload_excel').click();
        }

        vm.rd.downloadExcel = function() {
            rd.generateBlob();
        }

        rd.getWorkbook = function() {
            return new Promise(function (resolve, reject) {
                var req = new XMLHttpRequest();
                var url = 'content/files/public/cannabis.xlsx';

                req.open("GET", url, true);
                req.responseType = "arraybuffer";
                req.onreadystatechange = function () {
                    if (req.readyState === 4){
                        if (req.status === 200) {
                            resolve(XlsxPopulate.fromDataAsync(req.response));
                        } else {
                            reject("Received a " + req.status + " HTTP code.");
                        }
                    }
                };
                req.send();
            });
        }

        // Function to convert column index to Excel column letter
        function getColumnLetter(index) {
            var letter = '';
            while (index >= 0) {
                letter = String.fromCharCode(index % 26 + 65) + letter;
                index = Math.floor(index / 26) - 1;
            }
            return letter;
        }
        // Function to apply dropdown to a column
        function applyDropdown(sheet, col, options) {
            var range = sheet.range(col + "2:" + col + "1048576"); // Apply dropdown to entire column starting from row 2
            range.dataValidation({
                type: 'list',
                showErrorMessage: true,
                formula1: '"' + options.join(',') + '"'
            });
        }

        rd.generate = function(type) {
            return rd.getWorkbook()
                .then(function (workbook) {
                    var r = workbook.sheet(0).range("A1:AY1");
                    var header = null;

                    if (vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp')) {
                        header = ['Sample Name*', 'Lot/Batch #*', 'Product Category*', 'Product Type*', 'Inhalable/Non-Inhalable*', 'Source UID', 'Strain Name', 'Strain Type', 'Label Claims', 'Product Specifications*', 'Expiration Date', 'Best By Date','Production Date (MM/DD/YYYY)', 'Date Collected (MM/DD/YYYY HH:MM AM/PM)'];
                    }
                    else {
                       header = ['Sample Name*', 'Lot/Batch #*', 'Product Category', 'Product Type', 'Inhalable/Non-Inhalable'];
                    }
                    var dropdownOptions = {}
                    var options = ['Yes', 'No']

                    vm.rd.tests.forEach( function(test) {
                        test.display_name ? header.push(test.display_name) : header.push(test.reporting_title);
                        var headerName = test.display_name ? test.display_name : test.reporting_title
                        dropdownOptions[headerName] = options;
                    });

                    header.forEach(function (headerName, index) {
                        var colLetter = getColumnLetter(index);
                        if (dropdownOptions[headerName]) {
                            applyDropdown(workbook.sheet(0), colLetter, dropdownOptions[headerName]);
                        }
                    });
                    r.value([header]);
                    workbook.sheet(0).row(1).style("bold", true);
                    workbook.sheet(1).hidden(true);
                    return workbook.outputAsync({ type: type });
                });
        }

        rd.generateBlob = function() {
            return rd.generate()
                .then(function (blob) {
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, "QA_RND Sample Submission.xlsx");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = "QA_RND Sample Submission.xlsx";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                })
                .catch(function (err) {
                    alert(err.message || err);
                    throw err;
                });
        }

        vm.rd.handleExcel = function() {
            return handleExcelImport(vm.rd, '#rd_upload_excel', function(workbook) {
                return rd.extractExcelValues(workbook.sheet(0).usedRange().value());
            });
        }

        rd.createExcelAssayMap = function(file) {
            for( var i = vm.rd.excel_header_offset; i < file[0].length; i++) {
                if(file[0][i]) {
                    vm.rd.excel_assay_index_map[i] = vm.rd.assay_map[file[0][i]];
                }
                else {
                    break;
                }
            }
        }

        // Sample columns 0-9 have been identical in every template generation, so they stay
        // positional. Date and assay columns moved between template versions (10 cols before
        // Jun 2025, 12 until Nov 2025, 14 today), so they are located by header name — a stale
        // template must not silently shift "Yes" cells into date columns.
        var RD_DATE_HEADER_MAP = {
            'expiration date': 'expiration_date',
            'best by date': 'best_buy_date',
            'best buy date': 'best_buy_date',
            'production date': 'production_date',
            'date collected': 'date_collected',
            'date and time collected': 'date_collected'
        };
        var RD_DATE_COLUMN_LABELS = {
            expiration_date: 'Expiration Date',
            best_buy_date: 'Best By Date',
            production_date: 'Production Date',
            date_collected: 'Date Collected'
        };
        var RD_BASE_COLUMN_COUNT = 10;

        function normalizeRdHeader(headerText) {
            if (typeof headerText !== 'string') return '';
            return headerText.toLowerCase()
                .trim()
                .replace(/\(.*?\)/g, '')
                .replace(/\*$/, '')
                .trim();
        }

        rd.mapCannabisImportColumns = function(headerRow) {
            var colInfo = { dateCols: {}, assayCols: {}, unknownHeaders: [], missingDateColumns: [] };

            for (var i = RD_BASE_COLUMN_COUNT; i < headerRow.length; i++) {
                var header = headerRow[i];
                if (header === null || header === undefined || header === '') continue;
                var dateProp = RD_DATE_HEADER_MAP[normalizeRdHeader(header)];
                var assayEntry = vm.rd.assay_map[header] || vm.rd.assay_map[String(header).trim()];
                if (dateProp) {
                    colInfo.dateCols[dateProp] = i;
                }
                else if (assayEntry) {
                    colInfo.assayCols[i] = assayEntry;
                }
                else {
                    colInfo.unknownHeaders.push(header);
                }
            }

            for (var prop in RD_DATE_COLUMN_LABELS) {
                if (colInfo.dateCols[prop] === undefined) colInfo.missingDateColumns.push(RD_DATE_COLUMN_LABELS[prop]);
            }

            return colInfo;
        }

        // Import warnings render through AlertService, which trusts HTML — spreadsheet
        // content must be escaped before it is interpolated into a message.
        function escapeImportText(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        // Parses a spreadsheet date cell. Excel date cells arrive as serial numbers; they are
        // converted via UTC calendar components so the date does not shift a day in western
        // timezones. Unreadable values are reported back instead of being dropped.
        function parseImportDateCell(value) {
            if (value === null || value === undefined || value === '') return { empty: true };

            if (value instanceof Date) {
                return isNaN(value.getTime()) ? { ok: false, raw: String(value) } : { ok: true, date: value };
            }

            if (typeof value === 'number' && value <= 0) return { empty: true };

            if (typeof value === 'number' && isFinite(value)) {
                var utc = new Date(Math.round((value - 25569) * 86400 * 1000));
                return { ok: true, date: new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes()) };
            }

            if (typeof value === 'string') {
                var text = value.trim();
                var match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})(\s+(\d{1,2}):(\d{2})\s*(AM|PM)?)?$/i);
                if (match) {
                    var year = parseInt(match[3], 10);
                    if (match[3].length === 2) year += 2000;
                    var hours = match[5] ? parseInt(match[5], 10) : 0;
                    if (match[7] && match[7].toUpperCase() === 'PM' && hours < 12) hours += 12;
                    if (match[7] && match[7].toUpperCase() === 'AM' && hours === 12) hours = 0;
                    var minutes = match[6] ? parseInt(match[6], 10) : 0;
                    var parsed = new Date(year, parseInt(match[1], 10) - 1, parseInt(match[2], 10), hours, minutes);
                    return isNaN(parsed.getTime()) ? { ok: false, raw: text } : { ok: true, date: parsed };
                }
                match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
                if (match) {
                    return { ok: true, date: new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10)) };
                }
                return { ok: false, raw: text };
            }

            return { ok: false, raw: String(value) };
        }

        rd.createNewSample = function() {
            return ({
                sample_expanded: vm.rd.mainCollapse,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_tests: [],
                sample_other_analyses: {},
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                sample_expiration_date: null,
                sample_best_buy_date: null,
                sample_product_ingredients: null,
                sample_product_ingredients_tags: [],
                ingredient_input: '',
                expiration_date: null,
                best_buy_date: null,
                production_date: null,
                production_date_open: false,
                time_of_collection: null,
                time_of_collection_open: false,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false,
                    ingredients: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: [],
                    ingredients: []
                }
            });
        }

        rd.extractCannabisValues = function(row, index, colInfo, importWarnings) {
            vm.rd.sampleArray[index] = {}
            var test = null;
            var sample = rd.createNewSample();

            function readDateCol(prop) {
                var col = colInfo.dateCols[prop];
                if (col === undefined) return null;
                var parsed = parseImportDateCell(row[col]);
                if (parsed.empty) return null;
                if (!parsed.ok) {
                    importWarnings.push('Row ' + (index + 2) + ': could not read ' + RD_DATE_COLUMN_LABELS[prop] +
                        ' value "' + escapeImportText(parsed.raw) + '" — expected a date like MM/DD/YYYY');
                    return null;
                }
                return parsed.date;
            }

            if(!row.every(allEmpty)) {
                var sample_category = row[2] ? formatSampleCategory(row[2]) : null;
                sample.sample_name = !allEmpty(row[0]) ? stripInvalidQBChars(row[0]) : null;
                // Handle lot batch number - check if it's a date serial number from Excel
                if (row[1]) {
                    if (typeof row[1] === 'number') {
                        // Check if this is likely an Excel date serial number
                        // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                        if (row[1] >= 43101 && row[1] <= 49673) {
                            // Convert Excel date serial number back to date string
                            var baseDate = 25567; // Excel base date for 1900 system
                            var date = new Date(Math.round((row[1] - baseDate - 1) * 86400 * 1000));

                            // Format as MM/DD/YYYY
                            var month = (date.getMonth() + 1).toString().padStart(2, '0');
                            var day = date.getDate().toString().padStart(2, '0');
                            var year = date.getFullYear();
                            sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                        } else {
                            // This is just a regular number, not a date
                            sample.sample_lot_batch_number = row[1].toString();
                        }
                    } else {
                        sample.sample_lot_batch_number = stripInvalidQBChars(row[1]);
                    }
                } else {
                    sample.sample_lot_batch_number = null;
                }
                sample.sample_category = sample_category ? sample_category : null;
                sample.sample_types = sample_category ? sample_category.types : null;
                sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[3]) : null;
                sample.sample_inhalable = row[4] ? formatInhalableFromImport(row[4]) : null;
                sample.sample_source_id = row[5] ? row[5] : null;
                sample.sample_strain_name = row[6] ? row[6] : null;
                sample.sample_strain_type = row[7] ? formatStrainType(row[7]) : null;
                sample.sample_label_claims = row[8] ? row[8] : null;
                sample.sample_expected_potency = row[9] ? row[9] : null;
              
                // Dates are located by header name (template layouts changed over time)
                var expirationJsDate = readDateCol('expiration_date');
                var bestBuyJsDate = readDateCol('best_buy_date');
                var productionJsDate = readDateCol('production_date');
                var collectionJsDate = readDateCol('date_collected');

                // Store both the formatted string (for display) and the Date object (for datepicker)
                sample.sample_expiration_date = expirationJsDate ? formatDate(expirationJsDate) : null;
                sample.sample_best_buy_date = bestBuyJsDate ? formatDate(bestBuyJsDate) : null;
                sample.sample_production_date = productionJsDate ? formatDate(productionJsDate) : null;
                sample.sample_time_of_collection = collectionJsDate;

                // For the datepicker, we need to store the actual Date objects
                sample.expiration_date = expirationJsDate;
                sample.best_buy_date = bestBuyJsDate;   
                sample.production_date = productionJsDate;
                sample.time_of_collection = collectionJsDate;
                
                for (var j in colInfo.assayCols) {
                    if (row[j] == 'Yes') {
                        test = Object.assign({}, colInfo.assayCols[j]);

                        if (test[1] && vm.rd.assay_map[test[1].display_name]) {
                            test[1].checked = true;
                            sample.sample_tests.push(test[1])
                            sample.sample_has_tests = true;
                            vm.rd.sampleArray[index][vm.rd.assay_map[test[1].display_name][0]] = true;
                        }
                        test = null;
                    }
                }
                vm.rd.samples.push(sample)
            }
        }

        rd.extractFoodValues = function(row, index) {
            vm.rd.sampleArray[index] = {}
            var test = null;
            var sample = rd.createNewSample();

            if(!row.every(allEmpty)) {
                var sample_category = row[2] ? formatSampleCategory(row[2]) : null;
                sample.sample_name = !allEmpty(row[0]) ? stripInvalidQBChars(row[0]) : null;
                // Handle lot batch number - check if it's a date serial number from Excel
                if (row[1]) {
                    if (typeof row[1] === 'number') {
                        // Check if this is likely an Excel date serial number
                        // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                        if (row[1] >= 43101 && row[1] <= 49673) {
                            // Convert Excel date serial number back to date string
                            var baseDate = 25567; // Excel base date for 1900 system
                            var date = new Date(Math.round((row[1] - baseDate - 1) * 86400 * 1000));

                            // Format as MM/DD/YYYY
                            var month = (date.getMonth() + 1).toString().padStart(2, '0');
                            var day = date.getDate().toString().padStart(2, '0');
                            var year = date.getFullYear();
                            sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                        } else {
                            // This is just a regular number, not a date
                            sample.sample_lot_batch_number = row[1].toString();
                        }
                    } else {
                        sample.sample_lot_batch_number = stripInvalidQBChars(row[1]);
                    }
                } else {
                    sample.sample_lot_batch_number = null;
                }
                sample.sample_category = sample_category ? sample_category : null;
                sample.sample_types = sample_category ? sample_category.types : null;
                sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[3]) : null;
                sample.sample_inhalable = row[4] ? formatInhalableFromImport(row[4]) : null;
                for( var j = vm.rd.excel_header_offset; j < row.length; j++) {
                    if (row[j] == 'Yes') {
                        test = Object.assign({}, vm.rd.excel_assay_index_map[j]);
                        // check if that assay exists for the customer
                        if (test[1] && vm.rd.assay_map[test[1].display_name]) {
                            test[1].checked = true;
                            sample.sample_tests.push(test[1])
                            sample.sample_has_tests = true;
                            vm.rd.sampleArray[index][vm.rd.assay_map[test[1].display_name][0]] = true;
                        }
                        test = null;
                    }
                }
                vm.rd.samples.push(sample)
            }
        }

       rd.extractExcelValues = function(file) {
            if (!file || !file.length || !file[0]) {
                AlertService.error('Upload failed. The Excel file is empty.');
                return false;
            }

            var sampleCountBefore = vm.rd.samples.length;
            if (vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp')) {
                var colInfo = rd.mapCannabisImportColumns(file[0]);
                var importWarnings = [];

                vm.rd.excel_assay_index_map = colInfo.assayCols;

                for( var i = 1; i < file.length; i++) {
                    rd.extractCannabisValues(file[i], i-1, colInfo, importWarnings);
                }

                if (colInfo.unknownHeaders.length) {
                    importWarnings.unshift('Ignored unrecognized column(s): ' + colInfo.unknownHeaders.map(escapeImportText).join(', '));
                }
                if (colInfo.missingDateColumns.length) {
                    importWarnings.unshift('This spreadsheet is missing the ' + colInfo.missingDateColumns.join(', ') +
                        ' column(s), so those values were not imported. Please download the latest template.');
                }
                if (importWarnings.length) {
                    AlertService.warning(importWarnings.slice(0, 6).join('\n'));
                }
            }
            else {
                rd.createExcelAssayMap(file)
                for( var i = 1; i < file.length; i++) {
                    rd.extractFoodValues(file[i], i-1);
                }
            }

            vm.rd.checkPageOne();
            rd.resetDeleteCheckboxes();
            if (vm.rd.samples.length === sampleCountBefore) {
                AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
                return false;
            }
            return true;
        }


        function allEmpty(value) {
            return value === '' || value === null || value === undefined;
        }

        vm.rd.deleteChecked = function() {
            for(var i = vm.rd.samples.length-1; i >= 0; i--) {
                if (vm.rd.samples[i].sample_delete) {
                    vm.rd.samples.splice(i, 1);
                }
            }
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        }

        vm.rd.clickCheckAllDelete = function() {
            vm.rd.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.delete-checkbox-header')[0].checked;
            });
        }

        vm.rd.clickDelete = function(index) {
            vm.rd.samples[index].sample_delete = !vm.rd.samples[index].sample_delete;
            $(':checkbox.delete-checkbox-header')[0].checked = false;
        }

        vm.rd.clickCheckAllTest = function(col) {
            var testToAdd = vm.rd.assay_map_by_index[col];
            var found = false;
            var selector = ':checkbox.assay-col-header-' + col;
            var test = {};

            vm.rd.samples.forEach( function(sample, sample_index) {
                sample.sample_tests.forEach( function(test, test_index) {
                    if (test.id == testToAdd.id) {
                        found = true;
                        sample.sample_tests[test_index].checked = $(selector)[0].checked;
                        vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                        
                        // Check if this sample has a panel selected and update panel status if needed
                        if (sample.sample_panel_selected && !$(selector)[0].checked) {
                            vm.rd.checkPanelTestsSelection(sample_index);
                        }
                    }
                });
                if (!found) {
                    if (!vm.rd.sampleArray[sample_index]) {
                        vm.rd.sampleArray[sample_index] = {};
                        vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                    }
                    test = Object.assign({}, testToAdd)
                    vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                    test.checked = $(selector)[0].checked;
                    
                    // Check if this sample has a panel selected and update panel status if needed
                    if (sample.sample_panel_selected && !$(selector)[0].checked) {
                        vm.rd.checkPanelTestsSelection(sample_index);
                    }
                    sample.sample_tests.push(test);
                }
                found = false;
               rd.checkSampleContainsTrueTests(sample_index);
            });
            vm.rd.checkPageTwo();
        }

        // add/remove test from sample when checkbox clicked
        vm.rd.checkClick = function (sample, testToAdd, row, col) {
            var found = false;
            var test = null;
            $(':checkbox.assay-col-header-' + col)[0].checked = false;
            // check if test exists, if yes then checked = !checked
            for(var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].id == testToAdd.id) {
                    found = true;
                    sample.sample_tests[i].checked = vm.rd.sampleArray[row][col];
                    break;
                }
            }
            // if no, add that test
            if (!found) {
                test = Object.assign({}, testToAdd);
                test.checked = true;
                
                // Ensure manually added tests have panel_id and panel_name set to null
                test.panel_id = null;
                test.panel_name = null;
                
                // Handle source_uid vs source_id mapping as mentioned in memories
                if (test.source_id && !test.source_uid) {
                    test.source_uid = test.source_id;
                }
                
                sample.sample_tests.push(test);
            }
            
            // Check if this sample has a panel selected and update panel status if needed
            if (sample.sample_panel_selected) {
                vm.rd.checkPanelTestsSelection(row);
            }

            rd.checkSampleContainsTrueTests(row);
            vm.rd.checkPageTwo();
            
            // Organize tests for display
            vm.rd.organizeTests(sample);
        }

        vm.rd.collapseAll = function() {
            vm.rd.mainCollapse = !vm.rd.mainCollapse;
            if (vm.rd.samples.length != 0) {
                vm.rd.samples.forEach( function(sample) {
                    sample.sample_expanded = vm.rd.mainCollapse;
                });
            }
        }

        rd.addAssay = function(test) {
            if (!shouldShowAssayForLanguage(test)) {
                return;
            }
            if(test.id != 13) {
                // Prevent duplicates in showTestsArray
                if (vm.rd.showTestsArray.indexOf(test.display_name) === -1) {
                    vm.rd.showTests[test.display_name] = true;
                    vm.rd.showTestsArray.push(test.display_name);
                    
                    // Set the index for the new test
                    test.index = vm.rd.tests.length;
                    vm.rd.tests.push(test);
                    
                    // CRITICAL: Update assay_map so setPanel can find this assay
                    vm.rd.assay_map[test.display_name] = [test.index, test];
                    vm.rd.assay_map_by_index[test.index] = test;
                }
            }

        }

        rd.createAssayMaps = function() {
            vm.rd.tests.forEach( function(test, index) {
                test.index = index;
                vm.rd.assay_map[test.display_name] = [index, test]
                if(test.reporting_title) {
                    vm.rd.assay_map[test.reporting_title] = [index, test];
                }

                vm.rd.assay_map_by_index[index] = test;
            });
        }

        rd.getAssaysAddedByAnrescoBillingTab = function() {
            vm.customerData.assay_customer.forEach( function(assay_customer) {

                vm.rd.all_tests.forEach( function(assay) {
                    if (assay.id == assay_customer.assay_id) {
                        // Check if this assay is already in vm.rd.tests (added via portal_client_type_list or portal_client_type)
                        var existingTestIndex = findWithAttr(vm.rd.tests, 'id', assay.id);
                        
                        if (existingTestIndex != -1) {
                            // Assay already exists in tests (added via precedence 1 or 2)
                            // Update its assay_customer data to include count for frequent tests
                            vm.rd.tests[existingTestIndex].assay_customer = assay_customer;
                        } else if (assay_customer.active) {
                            // Only add new assays if they're active
                            rd.addAssay(assay);
                        }
                    }
                });
            });
        }

         rd.getAssayData = function() {
            // Use GraphQL for lightweight payload (~150KB vs 1.6MB from REST)
            GraphQLService.query(ASSAYS_LIST_QUERY, { enabled: true }).then(function(result) {
                var data = result.assaysList;
                if (data) {
                    var index = 0;
                    var test = null;
                    var add_assay = true;

                    var assayCustomerMap = {};
                    if (vm.customerData && vm.customerData.assay_customer) {
                        vm.customerData.assay_customer.forEach(function(ac) {
                            assayCustomerMap[ac.assay_id] = ac;
                        });
                    }

                    data.forEach( function(assay) {
                        // Language eligibility must be checked before business-type or legacy matching.
                        if (!shouldShowAssayForLanguage(assay)) {
                            return;
                        }
                        if (add_assay) {
                            // O(1) lookup instead of O(n) loop
                            assay.assay_customer = assayCustomerMap[assay.id] || null;

                            test = {
                                info_modal: parseAssayInfoModalData(assay),
                                portal_identifier: assay.portalIdentifier ? assay.portalIdentifier : null,
                                portal_client_type: assay.portal_client_type ? assay.portal_client_type : null,
                                portal_client_type_list: assay.portal_client_type_list ? assay.portal_client_type_list : null,
                                display_name: assay.title,
                                reporting_title: assay.reporting_title ? assay.reporting_title : assay.title,
                                base_price: assay.basePrice,
                                assay_customer: assay.assay_customer ? assay.assay_customer : null,
                                analysis_description: assay.analysis_description ? assay.analysis_description : null,
                                id: assay.id,
                                index: index
                            }

                            // Initialize a flag to track if the assay has been added
                            let assayAdded = false;

                            // Skip logging for assays without portal_client_type - too verbose for production
                            if(!assay.portal_client_type_list && !assay.portal_client_type) {
                                // These are legacy assays without client type configuration
                            }

                            // Check portal_client_type_list first (new primary method)
                            if(assay.portal_client_type_list && !assayAdded) {
                                // Parse the portal_client_type_list if it's a string
                                let clientTypeList = assay.portal_client_type_list;
                                if (typeof clientTypeList === 'string') {
                                    try {
                                        clientTypeList = JSON.parse(clientTypeList);
                                    } catch (e) {
                                        console.error('Error parsing portal_client_type_list for assay', assay.id, e);
                                        clientTypeList = [];
                                    }
                                }
                                
                                if(Array.isArray(clientTypeList)) {
                                    // Check for 'General' type in the list
                                    if(clientTypeList.includes('General')) {
                                        rd.addAssay(test);
                                        index++;
                                        assayAdded = true;
                                    } else {
                                        // Convert customer type to lowercase for case-insensitive comparison
                                        var customerTypeLower = vm.rd.customer_type.toLowerCase();
                                        
                                        // Check if any client type in the list matches the customer type
                                        for(let clientType of clientTypeList) {
                                            var lowerClientType = clientType.toLowerCase();
                                            
                                            // Check if customer type matches any of the conditions
                                            if(customerTypeLower.includes('cannabis') && lowerClientType.includes('cannabis') ||
                                               customerTypeLower.includes('hemp') && lowerClientType.includes('hemp') ||
                                               customerTypeLower.includes('food') && lowerClientType.includes('food') ||
                                               customerTypeLower.includes('kratom') && lowerClientType.includes('kratom') ||
                                               lowerClientType.includes('non-cannabis') ||
                                               customerTypeLower === lowerClientType) {
                                                
                                                // Special handling for cannabis cannabinoid assays
                                                if(customerTypeLower.includes('cannabis') && lowerClientType.includes('cannabis') && rd.isBasicPotencyAssay(test)) {
                                                    vm.rd.cannabinoid_assays[test.portal_identifier] = jQuery.extend({}, test);
                                                    if(!vm.rd.cannabinoid_assay_added) {
                                                        rd.addAssay(test);
                                                        index++;
                                                        vm.rd.cannabinoid_assay_added = true;
                                                    }
                                                } else {
                                                    rd.addAssay(test);
                                                    index++;
                                                }
                                                assayAdded = true;
                                                break;
                                            }
                                        }
                                    }

                                    // Special handling for Japanese language and Japanese assays
                                        if ($localStorage.language === 'Japanese') {
                                        // If customer language is Japanese, only show Japanese assays
                                        if (clientTypeList.includes('Japanese')) {
                                            rd.addAssay(test);
                                            index++;
                                            assayAdded = true;
                                        }
                                    } else {
                                        // For non-Japanese customers, don't show Japanese-only assays
                                        if (clientTypeList.includes('Japanese') && !clientTypeList.includes('General') && !assayAdded) {
                                            assayAdded = false; // Skip this assay for non-Japanese customers
                                        }
}
                                }
                            }

                            // Fall back to portal_client_type if not added yet (legacy method)
                            if(assay.portal_client_type && !assayAdded) {
                                if(assay.portal_client_type == 'General') {
                                    rd.addAssay(test);
                                    index++
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('cannabis') && assay.portal_client_type.toLowerCase().includes('cannabis'))) {
                                    if(rd.isBasicPotencyAssay(test)) {
                                        vm.rd.cannabinoid_assays[test.portal_identifier] = jQuery.extend({}, test);
                                        if(!vm.rd.cannabinoid_assay_added) {
                                            rd.addAssay(test);
                                            index++
                                            vm.rd.cannabinoid_assay_added = true;
                                        }
                                    }
                                    else {
                                        rd.addAssay(test);
                                        index++;
                                    }
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('hemp') && assay.portal_client_type.toLowerCase().includes('hemp'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('food') && assay.portal_client_type.toLowerCase().includes('food'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('kratom') && assay.portal_client_type.toLowerCase().includes('kratom'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                            }
                            vm.rd.all_assay_map_by_id[assay.id] = test;
                            vm.rd.all_tests.push(test)
                        }
                        add_assay = true;
                    });
                }
                // getExistingAssays()
                rd.getAssaysAddedByAnrescoBillingTab();

                
                // sorts tests arrray by how many times each test has been ordered
                vm.rd.tests.sort( function(test_a ,test_b) {
                    // Get counts, defaulting to 0 if not present
                    var count_a = (test_a.assay_customer && test_a.assay_customer.count) ? test_a.assay_customer.count : 0;
                    var count_b = (test_b.assay_customer && test_b.assay_customer.count) ? test_b.assay_customer.count : 0;
                    
                    // Sort by count descending (highest first)
                    return count_b - count_a;
                });
                

                // Calculate number of frequent assays (up to 5 tests with counts > 0)
                vm.rd.number_of_freq_assays = 0;
                for (var i = 0; i < Math.min(5, vm.rd.tests.length); i++) {
                    if (vm.rd.tests[i]) {
                        // Count tests that have a positive count
                        if (vm.rd.tests[i].assay_customer && vm.rd.tests[i].assay_customer.count > 0) {
                            vm.rd.number_of_freq_assays++;
                        }
                    }
                }

                if (vm.rd.number_of_freq_assays != vm.rd.tests.length) {
                    var tests_sorted_by_name = vm.rd.tests.splice(vm.rd.number_of_freq_assays, vm.rd.tests.length).sort( function(name_a, name_b) {
                        var comparison = 0;
                        name_a = name_a.display_name ? name_a.display_name : name_a.reporting_title;
                        name_b = name_b.display_name ? name_b.display_name : name_b.reporting_title;

                        if(name_a > name_b) {
                            comparison = 1
                        }
                        else if(name_b > name_a) {
                            comparison = -1
                        }

                        return comparison
                    });
                    vm.rd.tests = vm.rd.tests.concat(tests_sorted_by_name);
                }

                rd.createAssayMaps();

                // Load QBench panels after assay data is ready
                rd.getQbenchPanels();
                // Load customer-specific panels after assay data is ready
                rd.getCustomerPanels();
            }).catch(function(error) {
                console.error('Failed to load assays via GraphQL:', error);
                AlertService.error('Failed to load available tests. Please refresh the page.');
            });

            // rd.setInfoBoxCoordinates();
        }

         rd.checkSampleContainsTrueTests = function(index) {
            if (Object.values(vm.rd.sampleArray[index]).indexOf(true) == -1) {
                vm.rd.samples[index].sample_has_tests = false;
                vm.rd.samples[index].sample_panel_selected = false;
                vm.rd.samples[index].sample_panel_type = false;
                vm.rd.samples[index].sample_panel_by_id = false;
                vm.rd.samples[index].sample_current_panel_title = false;

                return;
            }
            vm.rd.samples[index].sample_has_tests = true;
            return;
        }

        // removes tests with checked: false
        // necessary for table on page 4
        rd.cleanUncheckedTests = function() {
            if (vm.rd.samples.length > 0) {
                vm.rd.samples.forEach (function(sample) {
                    if (sample.sample_tests.length > 0) {
                        for(var i = sample.sample_tests.length - 1; i >= 0; i--){
                            if (!sample.sample_tests[i].checked){
                                sample.sample_tests.splice(i, 1);
                            }
                        }
                    }
                    angular.forEach(sample.sample_other_analyses, function(value, key) {
                        if (!value) {
                            delete sample.sample_other_analyses[key];
                        }
                    });
                });
            }
        }

        vm.rd.checkPageOne = function() {
            if (vm.rd.samples.length < 1) {
                vm.rd.pageOneValid = false;
                return;
            }

            for(var i = 0; i < vm.rd.samples.length; i++) {
                if (!vm.rd.samples[i].sample_name ||
                    !vm.rd.samples[i].sample_category ||
                    !vm.rd.samples[i].sample_type ||
                    !vm.rd.samples[i].sample_inhalable ||
                    !vm.rd.samples[i].sample_expected_potency ) {
                        vm.rd.pageOneValid = false;
                        return;
                }
            }

            vm.rd.pageOneValid = true;
            return;
        }

        vm.rd.checkPageTwo = function() {
            var other_analysis_is_empty = null;
            var sample_array_is_empty = null;

            for(var i = 0; i < vm.rd.samples.length; i++) {
                other_analysis_is_empty = Object.keys(vm.rd.samples[i].sample_other_analyses).length == 0;
                sample_array_is_empty = vm.rd.sampleArray[i] ? Object.keys(vm.rd.sampleArray[i]).length == 0 : true;

                if (sample_array_is_empty && other_analysis_is_empty){
                    vm.rd.pageTwoValid = false;
                    return;
                }
                else {
                    if (sample_array_is_empty) {
                        if (Object.values(vm.rd.samples[i].sample_other_analyses).indexOf(true) == -1) {
                            vm.rd.pageTwoValid = false;
                            return
                        }
                    }
                    else if (other_analysis_is_empty) {
                        if (Object.values(vm.rd.sampleArray[i]).indexOf(true) == -1) {
                            vm.rd.pageTwoValid = false;
                            return;
                        }
                    }
                    else {
                        if ((Object.values(vm.rd.samples[i].sample_other_analyses).indexOf(true) == -1) && (Object.values(vm.rd.sampleArray[i]).indexOf(true) == -1)) {
                            vm.rd.pageTwoValid = false;
                            return;
                        }
                    }
                }
            }
            vm.rd.pageTwoValid = true;
            return;
        }

        vm.rd.checkPageThree = function() {
            if (
                !vm.rd.pickup_arrival_date ||
                !vm.rd.deliveryPreference ||
                !($('#rdEmailRecepients').val().length > 0) ||
                (vm.rd.deliveryPreference === 'Anresco Pick-Up' && !vm.fullLocationPickup) ||
                (vm.fullLocationPickup && !vm.contact.phone) ||
                vm.pickupOutOfStateError
            ) {
                vm.rd.pageThreeValid = false;
                return;
            }
            vm.rd.pageThreeValid = true;
            return;
        }

        function setHeightOfFirstTable() {
                var rightTableTrHeight = $('.rdTestsTableRight.varHeight thead').height();
                $('.rdTestsTableLeft thead').css('height', rightTableTrHeight);
        }

        vm.generateTurnaroundTimes = function(orderVersion) {
            var durations = [];

            orderVersion.samples.forEach( function(sample) {
                sample.sample_tests.forEach( function(test) {
                    if(test.info_modal && test.info_modal.duration) durations.push(test.info_modal.duration);
                });
            });

            // Replaced this line:
            // if(!durations.length) return;
    
            // With this code:
            if(!durations.length) {
                // For requested assays, set specific options
                var options = [];
                options.push("10 days (standard)");
                
                // Specific rush options: 7, 5, 3, 2, and 1 day
                var rushOptions = [7, 5, 3, 2, 1];
                rushOptions.forEach(function(duration) {
                    options.push(`${duration} days (rush)`);
                });
                
                // Set the options and return early
                orderVersion.turnaroundTimeOptions = options;
                orderVersion.turnaroundTime = options[0];
                return;
            }

            var longest_duration = Math.max(...durations);
            var shortest_duration = Math.min(...durations);
            var options = [];


            if(longest_duration == shortest_duration) {
                options.push(`${longest_duration} days (standard)`);
            }
            else {
                options.push(`${shortest_duration}-${longest_duration} days (standard)`);
            }

            for(var duration = shortest_duration-1; duration > 0; duration--) {
                options.push(`${duration} days (rush)`);
            }

            orderVersion.turnaroundTimeOptions = options;
            orderVersion.turnaroundTime = options[0];

        }

        vm.rd.incrementPage = function() {
            vm.rd.step = vm.rd.step + 1;
            rd.cleanUncheckedTests()
            if (vm.rd.step == 2) {
                vm.rd.checkPageTwo();
                setTimeout( function() {
                    // rd.setInfoBoxCoordinates();
                    setHeightOfFirstTable();
                }, 100);
            }
            else if (vm.rd.step == 3) {
                vm.generateTurnaroundTimes(vm.rd);
                vm.rd.checkPageThree();
                rd.processAllSampleTests();
                
                // Figure out which tests will be submitted for step 4 display
                vm.rd.samples.forEach(function(sample) {
                    var rawTests = formatSampleTests(sample, 'rd');
                    
                    // Reorganize: individual tests first, then grouped by panel
                    var individualTests = [];
                    var panelTests = {};
                    
                    rawTests.forEach(function(test) {
                        if (test.panel && test.panel.id) {
                            // Group by panel ID
                            if (!panelTests[test.panel.id]) {
                                panelTests[test.panel.id] = {
                                    panelName: vm.getPanelDisplayNameById(test.panel.id, 'rd'),
                                    tests: []
                                };
                            }
                            panelTests[test.panel.id].tests.push(test);
                        } else {
                            // Individual test
                            individualTests.push(test);
                        }
                    });
                    
                    // Build final organized array
                    sample.actualFormattedTests = individualTests;
                    
                    // Add each panel group
                    Object.keys(panelTests).forEach(function(panelId) {
                        var panel = panelTests[panelId];
                        // Add a panel header marker
                        sample.actualFormattedTests.push({
                            isPanelHeader: true,
                            panelName: panel.panelName
                        });
                        // Add all tests for this panel
                        panel.tests.forEach(function(test) {
                            sample.actualFormattedTests.push(test);
                        });
                    });
                });
            }
            else if (vm.rd.step == 4) {
                vm.rd.emailsArray = vm.rd.emails.split(',');
                // Organize tests for each sample to populate nonPanelTests and panelTests arrays
                vm.rd.samples.forEach(function(sample) {
                    vm.rd.organizeTests(sample);
                });
            }
        }

        vm.rd.decrementPage = function() {
            vm.rd.step = vm.rd.step - 1;
            rd.cleanUncheckedTests()
            if (vm.rd.step == 2) {
                vm.rd.checkPageTwo();
                setTimeout( function() {
                    // rd.setInfoBoxCoordinates();
                }, 100);
            }
            else if (vm.rd.step == 3) {
                vm.rd.checkPageThree();
                rd.processAllSampleTests();
            }
        }

        vm.rd.removeSample = function(index) {
            vm.rd.samples.splice(index, 1);
            vm.rd.sampleArray.splice(index, 1);
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        }

        vm.rd.cloneSample = function(index) {
            // Create a deep copy of the sample
            var clonedSample = angular.copy(vm.rd.samples[index]);
            
            // IMPORTANT: Reset the fields we want to explicitly set
            clonedSample.sample_category = null;
            clonedSample.sample_type = null;
            clonedSample.sample_types = null;
            clonedSample.sample_inhalable = null;
            
            // Now explicitly set them with the correct references
            
            // 1. Handle sample_category
            if (vm.rd.samples[index].sample_category && vm.rd.categories) {
                for (var i = 0; i < vm.rd.categories.length; i++) {
                    if (vm.rd.categories[i].id === vm.rd.samples[index].sample_category.id) {
                        clonedSample.sample_category = vm.rd.categories[i];
                        break;
                    }
                }
            }
            
            // 2. Handle sample_types and sample_type
            if (clonedSample.sample_category && clonedSample.sample_category.types) {
                clonedSample.sample_types = clonedSample.sample_category.types;
                
                if (vm.rd.samples[index].sample_type) {
                    for (var j = 0; j < clonedSample.sample_types.length; j++) {
                        if (clonedSample.sample_types[j].id === vm.rd.samples[index].sample_type.id) {
                            clonedSample.sample_type = clonedSample.sample_types[j];
                            break;
                        }
                    }
                }
            }
            

               // 3. Handle sample_inhalable
            if (vm.rd.samples[index].sample_inhalable) {
                // If it's a string value (which it is in your case - "INHALABLE")
                if (typeof vm.rd.samples[index].sample_inhalable === 'string') {
                    // Use the global inhalable_edible_array instead of vm.rd.inhalable_edible_array
                    if (vm.inhalable_edible_array && vm.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.inhalable_edible_array, 'value', vm.rd.samples[index].sample_inhalable);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.inhalable_edible_array[inhalableIndex];
                        } else {
                            // If not found in the array, just use the string directly
                            clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                        }
                    } else {
                        // If no array exists, just use the string directly
                        clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                    }
                } 
                        // If it's an object with a value property
                        else if (vm.rd.samples[index].sample_inhalable.value) {
                            if (vm.inhalable_edible_array && vm.inhalable_edible_array.length > 0) {
                                var inhalableIndex = findWithAttr(vm.inhalable_edible_array, 'value', vm.rd.samples[index].sample_inhalable.value);
                                if (inhalableIndex !== -1) {
                                    clonedSample.sample_inhalable = vm.inhalable_edible_array[inhalableIndex];
                                } else {
                                    clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                                }
                            } else {
                                clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                            }
                        }
                        // Otherwise just copy it directly
                        else {
                            clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                        }
                    }
            
            // Add the cloned sample to the array
            vm.rd.samples.splice(index + 1, 0, clonedSample);
            if (vm.rd.sampleArray && vm.rd.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.rd.sampleArray[index]);
                vm.rd.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        };

      
        function formatDeliveryPreference(delivery_preference) {
            $rootScope.deliveryPreference = delivery_preference;

            if (delivery_preference == 'Anresco Pick-Up') {
                return 'ANRESCO_PICK_UP';
            }
            else if (delivery_preference == 'Client Drop-Off') {
                return 'CLIENT_DROP_OFF';
            }
            else if (delivery_preference == 'Mail') {
                return 'MAIL';
            }
            else {
                return null;
            }
        }

        function formatNameDict(name) {
            return name ? {name: name} : null;
        }

        function formatDate(date) {
            if (!date) return null;
            
            // If it's already a string in MM/DD/YYYY format, return as is
            if (typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
                return date;
            }
            
            // Convert to Date object if it isn't already
            var dateObj = date instanceof Date ? date : new Date(date);
            
            // Check for invalid date
            if (isNaN(dateObj.getTime())) {
                return null;
            }
            
            // Format as MM/DD/YYYY with manual padding
            var month = (dateObj.getMonth() + 1).toString();
            month = month.length === 1 ? '0' + month : month;
            
            var day = dateObj.getDate().toString();
            day = day.length === 1 ? '0' + day : day;
            
            var year = dateObj.getFullYear();
            
            return month + '/' + day + '/' + year;
        }

        // Helper function to get test display name by ID
        vm.getTestDisplayNameById = function(testId, orderType) {
            var assayMap = (orderType === 'rd') ? vm.rd.all_assay_map_by_id : vm.food.all_assay_map_by_id;
            if (assayMap && assayMap[testId]) {
                return assayMap[testId].display_name || assayMap[testId].reporting_title;
            }
            // Fallback: check the other type's map
            var otherMap = (orderType === 'rd') ? vm.food.all_assay_map_by_id : vm.rd.all_assay_map_by_id;
            if (otherMap && otherMap[testId]) {
                return otherMap[testId].display_name || otherMap[testId].reporting_title;
            }
            return 'Test #' + testId;
        };
        
        // Helper function to get panel display name by ID
        vm.getPanelDisplayNameById = function(panelId, orderType) {
            var panelMap = (orderType === 'rd') ? vm.rd.panel_by_id_map : vm.food.panel_by_id_map;
            if (panelMap && panelMap[panelId]) {
                return panelMap[panelId][0]; // Panel name is at index 0
            }
            // Fallback: check the other type's map
            var otherMap = (orderType === 'rd') ? vm.food.panel_by_id_map : vm.rd.panel_by_id_map;
            if (otherMap && otherMap[panelId]) {
                return otherMap[panelId][0];
            }
            return 'Panel #' + panelId;
        };

        function formatSampleTests(sample, orderType) {
            var sampleTests = [];
            if (!sample) return sampleTests;
            
            var panelId = sample.sample_panel_selected;
            
            if (panelId) {
                // Use the appropriate maps based on order type
                var panelMap = (orderType === 'rd') ? vm.rd.panel_by_id_map : vm.food.panel_by_id_map;
                var assayMap = (orderType === 'rd') ? vm.rd.assay_map : vm.food.assay_map;
                
                if (panelMap && panelMap[panelId]) {
                    var panelAssays = panelMap[panelId][1];
                    var sendAsPanel = true;
                    
                    // CRITICAL VALIDATION: Check if ALL panel tests are still selected
                    // If ANY panel test is unchecked, the panel must "break" and all tests
                    // should be sent as individual tests (per billing requirements)
                    if (panelAssays && assayMap) {
                        for (var i = 0; i < panelAssays.length; i++) {
                            var assay = panelAssays[i];
                            if (assayMap[assay.display_name]) {
                                var assayId = assayMap[assay.display_name][1].id;
                                var isSelected = false;
                                
                                // Check if this panel test is selected in sample_tests
                                for (var j = 0; j < sample.sample_tests.length; j++) {
                                    if (sample.sample_tests[j].id === assayId && 
                                        sample.sample_tests[j].checked) {
                                        isSelected = true;
                                        break;
                                    }
                                }
                                
                                // If any panel test is not selected, break the panel
                                if (!isSelected) {
                                    sendAsPanel = false;
                                    break;
                                }
                            }
                        }
                    }
                    
                    if (sendAsPanel) {
                        // All panel tests are selected - send with panel association
                        // Add each panel assay WITH panel_id
                        panelAssays.forEach(function(assay) {
                            if (assayMap[assay.display_name]) {
                                var assayId = assayMap[assay.display_name][1].id;
                                var testPayload = {
                                    assay: {id: assayId}
                                };

                                // Only add the panel object if it's NOT a custom panel
                                if (sample.sample_panel_type !== 'custom_panel') {
                                    testPayload.panel = {id: panelId};
                                    testPayload.panel_type = sample.sample_panel_type || 'panel';
                                }
                                sampleTests.push(testPayload);
                            }
                        });
                        
                        // Collect panel assay IDs to identify non-panel tests
                        var panelAssayIds = [];
                        panelAssays.forEach(function(assay) {
                            if (assayMap[assay.display_name]) {
                                panelAssayIds.push(assayMap[assay.display_name][1].id);
                            }
                        });
                        
                        // Add any additional tests that are NOT part of the panel (without panel_id)
                        for (var i = 0; i < sample.sample_tests.length; i++) {
                            var test = sample.sample_tests[i];
                            if (test.checked && panelAssayIds.indexOf(test.id) === -1) {
                                sampleTests.push({
                                    assay: {id: test.id}
                                });
                            }
                        }
                    } else {
                        // Panel is "broken" - at least one panel test was unchecked
                        // Send ALL tests as individual (no panel association)
                        for (var i = 0; i < sample.sample_tests.length; i++) {
                            var test = sample.sample_tests[i];
                            if (test.checked) {
                                sampleTests.push({
                                    assay: {id: test.id}
                                });
                            }
                        }
                    }
                }
            } else {
                // No panel selected - send all as individual tests
                sample.sample_tests.forEach(function(test) {
                    if (test.checked) {
                        sampleTests.push({
                            assay: {id: test.id}
                        });
                    }
                });
            }
            if (sample.sample_other_analyses) {
                if (Object.values(sample.sample_other_analyses).indexOf(true) != -1) {
                    sampleTests.push({
                        // consulting assay
                        assay: {id: 13}
                    });
                }
            }

            return sampleTests;
        }

        
        function formatInhalableFromImport(value) {
            return (value.toUpperCase().includes('NON') || value.toUpperCase().includes('-')) ? vm.rd.inhalable[1] : vm.rd.inhalable[0];
        }


        function formatSampleCategory(cat) {
            if (cat.length > 1){
                for(var i = 0; i < vm.rd.categories.length; i++) {
                    if ((cat.charAt(0).toUpperCase() + cat.substring(1)) == vm.rd.categories[i.toString()].name) {
                        return vm.rd.categories[i.toString()]
                    }
                }
            }
            return  null;
        }

        function checkSampleType(types, type) {
            if (type) {
                type = type.charAt(0).toUpperCase() + type.toLowerCase().substring(1);
                for(var i = 0; i < types.length; i++) {
                    if (type.toLowerCase() == types[i.toString()].name.toLowerCase()) {
                        return types[i.toString()];
                    }
                }
            }
            return null;
        }

        function formatStrainType(name) {
            if (name) {
                name.toUpperCase() == "CBD" ? name = "CBD" : name = name.charAt(0).toUpperCase() + name.toLowerCase().substring(1);
                for(var i = 0; i < vm.rd.strainTypes.length; i++) {
                    if (name == vm.rd.strainTypes[i].name){
                        return vm.rd.strainTypes[i];
                    }
                }
            }
            return null;
        }

        rd.serializeSamples = function(samples) {
            var serializedSamples = [];
            if (samples) {
                samples.forEach( function(sample, sampleIndex){
                    var sampleTestsResult = null;
                    
                    try {
                        sampleTestsResult = formatSampleTests(sample, 'rd');
                    } catch (e) {
                        sampleTestsResult = [];
                    }
                    
                    serializedSamples.push({
                        id: null,
                        name: sample.sample_name,
                        lotBatchNumber: sample.sample_lot_batch_number,
                        productCategory: typeof(sample.sample_category) == 'string' ? formatNameDict(sample.sample_category) : sample.sample_category,
                        productType: typeof(sample.sample_type) == 'string' ? formatNameDict(sample.sample_type) : sample.sample_type,
                        strainName: typeof(sample.sample_strain_name) != 'object' ? formatNameDict(sample.sample_strain_name) : sample.sample_strain_name,
                        strainType: typeof(sample.sample_strain_type) == 'string' ? formatNameDict(sample.sample_strain_type) : sample.sample_strain_type,
                        otherAnalysis: sample.sample_other_analyses ? formatOtherAnalyses(sample.sample_other_analyses) : null,
                        reportedUnits: null,
                        productBatchSize: null,
                        harvestBatchSize: null,
                        batchType: null,
                        inhalableEdible: typeof(sample.sample_inhalable) == 'object' ? sample.sample_inhalable.value : sample.sample_inhalable,
                        sCode: sample.sample_metrc_id ? sample.sample_metrc_id : null,
                        sourceId: sample.sample_source_id ? sample.sample_source_id : null,
                        labelClaims: sample.sample_label_claims,
                        expectedPotency: sample.sample_expected_potency,
                        manufactureDate: formatDate(sample.sample_manufacture_date),
                        harvestDate: formatDate(sample.sample_harvest_date),
                        sampleWeightPerIncrement: null,
                        sampleTests: sampleTestsResult,
                        medicinal_batch: sample.medicinal_batch,
                        mhlw_product_type: sample.mhlw_product_type, 
                        expiration_date: formatDate(sample.expiration_date), 
                        best_buy_date: formatDate(sample.best_buy_date), 
                        production_date: formatDate(sample.production_date),
                        date_collected: sample.time_of_collection ? formatDateTimeForOrder(sample.time_of_collection) : null,
                        product_ingredients: sample.sample_product_ingredients ? sample.sample_product_ingredients : null,
                    });
                });
            }
            return serializedSamples;
        }

        rd.serializePayload = function() {
            vm.rd.submitting = true;
            var payload = {
                orderType: "RD",
                collection_type: null,
                customer_account_id: $localStorage.customerId,
                dateCreated: null,
                dateReceived: null,
                date_submitted: null,
                delivery_preference: formatDeliveryPreference(vm.rd.deliveryPreference),
                estimated_arrival_date: formatDate(vm.rd.pickup_arrival_date),
                partially_complete: null,
                poNumber: vm.rd.orderPO,
                reporting_preference: null,
                sample_condition: null,
                sampledDate: formatDate(vm.rd.pickup_arrival_date),
                manufacturingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
                samplingAddress: vm.samplingAddress ? vm.samplingAddress : null,
                invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
                pickup_address: vm.pickup_address ? vm.pickup_address : null,
                phone_number: vm.contact.phone ? vm.contact.phone : null,
                shipping_carrier: null,
                specialInstructions: vm.rd.specialInstructions,
                customerComments: vm.rd.customerComments,
                state: null,
                submitted_by: vm.rd.emailsArray.join(),
                dynamic_turnaround_time: vm.rd.turnaroundTime.includes('10') ? '10 day (standard)' : vm.rd.turnaroundTime,
                id: null,
                samples: rd.serializeSamples(vm.rd.samples),
                tracking_number: vm.rd.tracking_number,
                uploaded_files: vm.rd.uploadedFiles,
                source_workbooks: vm.rd.importedExcelFiles
            }

            return payload;
        }
        

        vm.rd.submitOrder = function() {
            $rootScope.type = 'R&D'
            CustomerOrder.save(rd.serializePayload(), onSaveSuccess, onSaveError);
        };
        // Function to process a single test asynchronously
        function processTest(sample) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(sample);
                }, 1000); 
            });
        }
        
            // },10000)
            // if(vm.rd.submitting){
            //     setInterval(() => {
            //         SweetAlert.swal({
            //             title: "Submitting your order",
            //             text: `Please remain on this page. The order is processing in the background and should submit in a few moments.`,
            //             type: "info"
            //         });
            //     },5000)
            // }
        

        vm.rd.addSample = function() {
            vm.rd.samples.push({
                sample_order_type: 'rd',
                sample_expanded: vm.rd.mainCollapse,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_tests: [],
                sample_other_analyses: {},
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                },
                medicinal_batch: false
            });
            vm.rd.checkPageOne();
        }

        rd.getPanels = function(panel) {
            var assays_dict = [];

            if (panel) {
                // Keep panels intact: do not offer a partial panel when an assay is ineligible.
                if (panel.assays.some(function(assay) {
                    return !shouldShowAssayForLanguage(vm.rd.all_assay_map_by_id[assay.id] || assay);
                })) {
                    return assays_dict;
                }
                panel.assays.forEach(function(assay) {
                    // Simplified assay object with just the essential properties
                    var assayObj = {
                        display_name: assay.title,
                        id: assay.id
                    };
                    
                    // Always include all assays in the panel
                    assays_dict.push(assayObj);
                });
            }

            return assays_dict;
        }

        rd.setPanelsByIdMap = function() {
            vm.rd.qbenchPanels.forEach( function(panel) {
                vm.rd.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
            vm.rd.customPanels.forEach( function(panel) {
                vm.rd.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
        }

        // Internal helper to standardize pushing a panel with assays (RD)
        rd._processPanel = function(panel, panelType) {
            var assays_dict = rd.getPanels(panel);
          
            // Add ALL assays from the panel to the accessible tests
            assays_dict.forEach(function(assay) {
                if (!assay.in_customer_tests) {
                    // FIRST check if this assay is already in vm.rd.tests
                    var existingTestIndex = findWithAttr(vm.rd.tests, 'id', assay.id);
                    
                    if (existingTestIndex !== -1) {
                        // Test already exists with proper info_modal from getAssayData()
                        // Just mark it as from_panel, don't replace it
                        vm.rd.tests[existingTestIndex].from_panel = true;
                        return; // Skip to next assay
                    }
                    
                    // Now check if we have full assay data
                    var fullAssay = vm.rd.all_assay_map_by_id[assay.id];
                    if (fullAssay && vm.rd.showTestsArray.indexOf(fullAssay.display_name) === -1) {
                        rd.addAssay(fullAssay);
                        fullAssay.from_panel = true;
                    } 
                    else if (!fullAssay) {                        
                        // Fetch the specific assay data
                        Assay.get({id: assay.id}, function(assayData) {
                            if (assayData) {
                                // Filter assay_customer data for current customer if it exists
                                if (assayData.assay_customer && Array.isArray(assayData.assay_customer)) {
                                    for (var i = 0; i < assayData.assay_customer.length; i++) {
                                        if (assayData.assay_customer[i].customer_id === vm.customerData.id) {
                                            assayData.assay_customer = assayData.assay_customer[i];
                                            break;
                                        }
                                    }
                                    // If no match found, set to null
                                    if (Array.isArray(assayData.assay_customer)) {
                                        assayData.assay_customer = null;
                                    }
                                }
                                
                                // Create a proper test object with full data
                                var test = {
                                    info_modal: parseAssayInfoModalData(assayData),
                                    portal_identifier: assayData.portalIdentifier ? assayData.portalIdentifier : null,
                                    portal_client_type: assayData.portal_client_type ? assayData.portal_client_type : null,
                                    portal_client_type_list: assayData.portal_client_type_list ? assayData.portal_client_type_list : null,
                                    display_name: assayData.title,
                                    reporting_title: assayData.reporting_title ? assayData.reporting_title : assayData.title,
                                    base_price: assayData.basePrice,
                                    assay_customer: assayData.assay_customer,
                                    analysis_description: assayData.analysis_description ? assayData.analysis_description : null,
                                    id: assayData.id,
                                    index: vm.rd.tests.length,
                                    from_panel: true
                                };
                                
                                // Add to cache for future use
                                vm.rd.all_assay_map_by_id[assayData.id] = test;
                                vm.rd.all_tests.push(test);
                                
                                // Add to accessible tests if not already there
                                if (vm.rd.showTestsArray.indexOf(test.display_name) === -1) {
                                    rd.addAssay(test);
                                }
                            }
                        }, function(error) {
                            console.error('Failed to fetch assay', assay.id, error);
                        });
                    }
                }
            });

            // Re-create the assay dict now that all panel assays are accessible
            assays_dict = rd.getPanels(panel);

            if (assays_dict.length > 0) {
                vm.rd.qbenchPanels.push({
                    title: panel.title,
                    assays: assays_dict,
                    id: panel.id,
                    type: panelType || 'qbench_panel',
                    description: panel.description,
                    duration: panel.duration,
                    minimum_quantity_required: panel.minimum_quantity_required,
                    turnaround_time: panel.turnaround_time,
                    min_sample_size: panel.min_sample_size,
                    price: panel.price
                });
            }
        };

        rd.pushPanel = function(panel, panelType) {
            if (!panel || !panel.assays || panel.assays.length === 0) {
                if (!panel || !panel.id) {
                    console.warn('RD Panel missing id or assays:', panel);
                    return;
                }
                Panel.get({ id: panel.id }, function(fullPanel) {
                    if (fullPanel && fullPanel.assays && fullPanel.assays.length) {
                        rd._processPanel(fullPanel, panelType);
                    } else {
                        console.warn('RD Panel has no assays after fetch:', panel.id);
                    }
                }, function(e) {
                    console.error('Error fetching RD panel details', e);
                });
                return;
            }

            rd._processPanel(panel, panelType);
        }

        rd.allPanelAssaysPresent = function(assays_dict) {
            // Always return true to show all panels regardless of assay accessibility
            // This matches the behavior in the Food section

            return true;
        }
        
        // Flag to track if customer panels have been loaded
        var customerPanelsLoaded = false;
        
        rd.getCustomerPanels = function() {
            // If customer panels have already been loaded, don't load them again
            if (customerPanelsLoaded) {
                return;
            }
            
            // Get the customer ID from the customerData object
            var customerId = vm.customerData && vm.customerData.id ? vm.customerData.id : null;
            
            if (!customerId) {
                // No customer ID available, skipping customer panels
                return;
            }
            
            // Fetching customer panels
            
            Customer.getPanels({id: customerId},
                function(data) {
         
                    // Set the flag to indicate customer panels have been loaded
                    customerPanelsLoaded = true;
                    
                    // Process each panel
                    data.forEach(function(panel) {
                        rd.pushPanel(panel, 'customer_panel');
                    });
                    
                    // Update the panel_by_id_map to include the customer panels
                    rd.setPanelsByIdMap();
                },
                function(error) {
                    console.error('Error fetching customer panels:', error);
                }
            );
        }
        
        rd.getQbenchPanels = function() {
            // Clear existing panels before loading new ones
            vm.rd.qbenchPanels = [];
            
            // Starting to fetch QBench panels
            
            Panel.query({},
                function(data) {
                    // Processing panels from QBench API
                    
                    data.forEach(function(panel) {
                        if (panel.portalIdentifier) {
                            // Determine customer type for matching
                            var customerType = 'Cannabis'; // default
                            if (vm.rd.customer_type.toLowerCase().indexOf('food') !== -1 || 
                                vm.rd.customer_type.toLowerCase().indexOf('kratom') !== -1 || 
                                vm.rd.customer_type.toLowerCase().indexOf('other') !== -1) {
                                customerType = 'Food';
                            } else if (vm.rd.customer_type.toLowerCase().indexOf('hemp') !== -1) {
                                customerType = 'Hemp';
                            }
                            
                            if (shouldShowPanel(panel, customerType, $localStorage.language)) {
                                rd.pushPanel(panel, 'qbench_panel');
                            }
                        }
                    });
                    
                    rd.getCustomerPanels();
                    rd.getPanelsByCustomer();

                    return;
                },
                function(e) {
                    console.error('Error fetching qbench panels:', e);
                    return;
                }
            );
        }

        rd.getPanelsByCustomer = function() {
            CustomPanel.query({},
                function(data) {
                    vm.rd.customPanels = [];
                    
                    data.forEach(function(panel) {
                        var panelAssays = rd.getPanels(panel);
                        if ($localStorage.language === 'Japanese' && panelAssays.length === 0) {
                            return;
                        }
                        
                        vm.rd.customPanels.push({
                            title: panel.title,
                            assays: panelAssays,
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    
                    rd.setPanelsByIdMap();
                },
                function(e){
                    console.error('Error fetching custom panels:', e);
                }
            );
        }

        // ***************************** END RND FUNCTIONS *****************************

        $scope.$watch('vm.fullLocationManufactur', function() {
            vm.comp.checkPageTwo();
            vm.rd.checkPageThree();
        })

        $scope.$watch('vm.fullLocationComp', function() {
            vm.comp.checkPageTwo();
        });

        $scope.$watch('vm.fullLocationPickup', function() {
            vm.comp.checkPageTwo();
        });



        setPageTitle();

        function setPageTitle() {
            $rootScope.pageTitle = "Submit";
        }

        vm.error = null;
        vm.pickupOutOfStateError = false;
        vm.orderId = $state.params.id;

        //fix sidebar menu state
        vm.showsidebar = true;

        // changing the sequence of calling of apis
        // getCurrentContact();

        getDataList();

        vm.customers = [];
        $scope.$root.samplesComp = [];
        vm.samplesComp = $scope.$root.samplesComp;

        $scope.$root.samplesRnD = [];
        vm.samplesRnD = $scope.$root.samplesRnD;// samplovi su iz root koji su postavljeni u tom kontroleru iz dijaloga


        vm.orderComp = {
            orderType: "COMPLIANCE",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: null,
            estimated_arrival_date: null,
            partially_complete: null,
            poNumber: null,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: null,
            samplingAddress: null,
            invoicing_address: null,
            shipping_carrier: null,
            state: null,
            submitted_by: null,
            turnaround_time: '4-5 day (standard)',

            id: null,
            samples: []

        };

        vm.orderRnD = {
            orderType: "RD",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: null,
            estimated_arrival_date: null,
            partially_complete: null,
            poNumber: null,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: null,
            samplingAddress: null,
            invoicing_address: null,
            shipping_carrier: null,
            state: null,
            submitted_by: null,
            turnaround_time: '4-5 day (standard)',

            id: null,
            samples: []

        };

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;

        if (!vm.isAuthenticated()) {
            $state.go('login');
        }

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.removeAddressId;
        vm.removeAddressElement;
        vm.newAddressList;

        distribution_list_toggle();
        manufacturing_list_toggle();
        invoicing_list_toggle();
        pickup_list_toggle();

        function createAddress(address, city, zipCode, name, medicalLicence, licenceList) {
            var full_address = name + '\n' + address + '\n' + city + ' ' + zipCode;
            var licences = licenceList || medicalLicence;

            if(licences) {
                var parts = licences.split(',');
                for (var i = 0; i < parts.length; i++) {
                    var trimmed = parts[i].trim();
                    if (trimmed) {
                        full_address += '\n' + trimmed;
                    }
                }
            }

            return full_address;
        }

        function createInvoicingAddress(address, city, zipCode, name, state) {
            return name + '\n' + address + '\n' + city + ' ' + zipCode + ' ' + state;
        }

        $scope.copyDistributionData = function(address, city, zipCode, name, medicalLicence, fullLocation, licenceList) {
            vm.samplingAddress = createAddress(address, city, zipCode, name, medicalLicence, licenceList);
            vm.fullLocationComp = fullLocation;
            distribution_list_toggle();
            if(vm.active_tab.comp) {
                vm.distributionAddressDict  = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }

        }

        $scope.copyManufacturingData = function(address, city,  zipCode, name, medicalLicence, fullLocation, licenceList) {
            vm.manufacturingAddress =  createAddress(address, city, zipCode, name, medicalLicence, licenceList);
            vm.fullLocationManufactur = fullLocation;
            if(vm.active_tab.comp) {
                vm.comp.cultivationLocation  = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }
            else {
                vm.reportingAddressDict = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }

            manufacturing_list_toggle();
        }

        $scope.copyInvoicingData = function(address, city, zipCode, name, state) {
            var invoicing_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.invoicing_address = invoicing_address;
            vm.fullLocationInvoicing = invoicing_address;
            invoicing_list_toggle();
            vm.invoicingAddressDict  = {
                name: name,
                address: address,
                city: city,
                zipCode: zipCode,
                state: state
            }
        }

        $scope.copyPickupData = function(address, city, zipCode, name, state) {

            // Check if pickup address state is California
            if (state && state.toUpperCase() !== 'CA' && state.toUpperCase() !== 'CALIFORNIA') {
                vm.pickupOutOfStateError = true;
                vm.pickup_address = null;
                vm.fullLocationPickup = null;
                pickup_list_toggle();
                return;
            }
            
            vm.pickupOutOfStateError = false;

            var pickup_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.pickup_address = pickup_address;
            vm.fullLocationPickup = pickup_address;
            pickup_list_toggle();
            vm.pickupAddressDict  = {
                name: name,
                address: address,
                city: city,
                zipCode: zipCode,
                state: state
            }
        }

        $scope.removeAddressData = function(address, addressId, element, input) {
            vm.removeAddressData = address;
            vm.removeAddressId = addressId;
            vm.removeAddressElement = element;

            setTimeout(function() {
                if ('DISTRIBUTION' === input)
                    vm.samplingAddress = "";
                else if ('MANUFACTURING' === input) {
                    vm.manufacturingAddress = "";
                }
                else if ('INVOICING' === input) {
                    vm.invoicingAddress = "";
                }
                else if ('PICKUP' === input) {
                    vm.pickupAddress = "";
                }
            }, 200);
        }

        function distribution_list_toggle() {
            $scope.DistributionList = "Distribution_close";
            $scope.openDistributionList = function() {
                if ($scope.DistributionList === "Distribution_close")
                    $scope.DistributionList = "Distribution_open";
                else
                    $scope.DistributionList = "Distribution_close";
            };
        }

        function manufacturing_list_toggle() {
            $scope.ManufacturingList = "Manufacturing_close";
            $scope.openManufacturingList = function() {
                if ($scope.ManufacturingList === "Manufacturing_close")
                    $scope.ManufacturingList = "Manufacturing_open";
                else
                    $scope.ManufacturingList = "Manufacturing_close";
            };
        }

        function invoicing_list_toggle() {
            $scope.InvoicingList = "Invoicing_close";
            $scope.openInvoicingList = function() {
                if ($scope.InvoicingList === "Invoicing_close")
                    $scope.InvoicingList = "Invoicing_open";
                else
                    $scope.InvoicingList = "Invoicing_close";
            };
        }

        function pickup_list_toggle() {
            $scope.PickupList = "Pickup_close";
            $scope.openpickupList = function() {
                if ($scope.PickupList === "Pickup_close")
                    $scope.PickupList = "Pickup_open";
                else
                    $scope.PickupList = "Pickup_close";
            };
        }

        $scope.newInvoicingAddress = function() {
            vm.InvoicingAddress.locationType = "INVOICING_LOCATION";
            AddressList.save(vm.InvoicingAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newPickupAddress = function() {
            vm.PickupAddress.locationType = "PICKUP_LOCATION";
            AddressList.save(vm.PickupAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newManufacturingAddress = function() {
            vm.ManufacturingAddress.locationType = "CULTIVATION_LOCATION";
            AddressList.save(vm.ManufacturingAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newDistributionAddress = function() {
            vm.DistributionAddress.locationType = "DISTRIBUTION_LOCATION";
            AddressList.save(vm.DistributionAddress, onSuccessCustomer, null);

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.removeAddressQuery = function() {
            AddressList.remove({
                id: vm.removeAddressId
            }, onSuccessCustomer, function() {
            });

            function onSuccessCustomer(data, headers) {
                vm.removeAddressElement.currentTarget.parentElement.style.display = "none";
            }
        }


        /* Autocomplate cities */

        var showCityListAllowed = false;
        var showZipListAllowed = false;

        $scope.toggleCity = function () {
          if (showCityListAllowed)
             $scope.showCityList = !$scope.showCityList;
        };

        $scope.toggleZip = function () {
          if (showZipListAllowed)
             $scope.showZipList = !$scope.showZipList;
        };

        $scope.loadCity = function(value) {
          if(typeof value == 'undefined')
            return;

          CityList.get({searchString: value}, function(data) {
            if (data.length == 0) {
              $scope.showCityList = false;
              showCityListAllowed = false;
              return;
            } else {
              $scope.showCityList = true;
              showCityListAllowed = true;
            }

            $scope.cityRecords = data;
          }, null);
        }

        $scope.loadZip = function(value) {
          if(typeof value == 'undefined')
            return;

          ZipList.get({searchString: value}, function(data) {
            if (data.length == 0) {
              $scope.showZipList = false;
              showZipListAllowed = false;
              return;
            } else {
              $scope.showZipList = true;
              showZipListAllowed = true;
            }
            $scope.cityRecordsZips = data;
          }, null);
        }

        $scope.clearCityZipListDataOnClose = function() {
          $scope.cityRecordsZips = [];
          $scope.cityRecords = [];
        }


        $scope.cityClick = function(city, zip, whereTo) {
          if (whereTo === 'MANUFACTURING') {
            vm.ManufacturingAddress.city = city;
            vm.ManufacturingAddress.zipCode = zip;
          } else {
            vm.DistributionAddress.city = city;
            vm.DistributionAddress.zipCode = zip;
          }
          $scope.toggleCity();
        }


        $scope.zipClick = function(value, whereTo) {
          if (whereTo === 'MANUFACTURING') {
            vm.ManufacturingAddress.zipCode = value;
          } else {
            vm.DistributionAddress.zipCode = value;
          }
          $scope.toggleZip();
        }


        /********************************************************************/

        function login() {
            collapseNavbar();
            //LoginService.open();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function getDataList() {
            AddressList.get({}, onSuccessCustomer, onErrorCustomer);

            function onSuccessCustomer(data, headers) {
                $scope.records = data;
            }

            function onErrorCustomer(e) {
                console.log(e);
            }
        }

        function getCurrentContact() {
            Contact2ForUser.get({}, onSuccessCustomer, onErrorCustomer);

            function onSuccessCustomer(data, headers) {
                vm.contact = data;
                if (vm.contact.phone === 'null') vm.contact.phone = null;
                // Load panels here to ensure assays are ready

                // Annie commented these to remove duplicate call
                // rd.getQbenchPanels();
                // food.getQbenchPanels();
            }

            function onErrorCustomer(e) {
                console.log(e);
            }
        }

        $scope.submitOrder = function() {
        	vm.isSaving = true;

            vm.orderComp.samples = vm.samplesComp;
            vm.error = null;

            $rootScope.type = vm.orderComp.orderType;

            var date = vm.orderComp.sampledDate;
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            vm.orderComp.sampledDate = date;

            // vm.orderComp.submitted_by = $('#emailToCompliance').val();
            CustomerOrder.save(vm.orderComp, onSaveSuccess, onSaveError);
        }

        $scope.submitorderRnD = function() {
        	vm.isSaving = true;


            var date = vm.orderRnD.estimated_arrival_date;
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            vm.orderComp.estimated_arrival_date = date;

            vm.orderRnD.samples = vm.samplesRnD;

            vm.orderRnD.submitted_by = $('#emailToRD').val();

            $rootScope.type = vm.orderRnD.orderType;
            vm.error = null;

            CustomerOrder.save(vm.orderRnD, onSaveSuccess, onSaveError);
        }


        vm.datePickerOpenStatus.dateReceived = false;
        vm.datePickerOpenStatus.estimated_arrival_date = false;
        vm.datePickerOpenStatus.pickup_arrival_date = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function onSaveSuccess(result) {
            vm.submitData == true;
            if(vm.rd.submitting) vm.rd.submitting = false;
            if(vm.food.submitting) vm.food.submitting = false;
            if(vm.comp.submitting) vm.comp.submitting = false;
            
            vm.isSaving = false;
            vm.orderId = result.id;
            $state.params.id = result.id;
            $state.go('samplesubmit.notify', {
                id: result.id
            });
        }

        function onSaveError(e) {
            console.log(e);
            var error_string = JSON.stringify(e);
            vm.error_string = error_string;

            var request_id = e && e.data && e.data.error ? e.data.error.request_id : undefined;

            
        	vm.isSaving = false;
            vm.error = "ERROR";
            if(vm.food.submitting) vm.food.submitting = false;
            if(vm.comp.submitting) vm.comp.submitting = false;
            if(vm.rd.submitting) vm.rd.submitting = false;
    
            $scope.errorText = '';
            $scope.errorFormPath = '';
            if(e.status == 500 || e.status == 504 || e.status == 400){
                if(vm.customerData.businessType.id == 2){
                    $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />   

                    For this order, please complete a PDF R&D Submission Form instead and include it with your samples. We sincerely apologize for the inconvenience.`;
                    $scope.errorFormPath = 'content/images/Cannabis_Submission_Form.pdf';
                }else{
                    $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />

                    For this order, please complete a PDF Submission Form instead and include it with your samples. We sincerely apologize for the inconvenience.`;
                    $scope.errorFormPath = 'content/images/Anresco-Submission-Form.pdf';
                }
                
            }else{
                $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />

                    For this order, please complete a PDF <a href="content/files/pdf/sample-submit/Anresco-Submission-Form.pdf" download>Submission Form</a> instead and include it with your samples. We sincerely apologize for the inconvenience.`;
            }

            if (request_id)
                $scope.errorText = $scope.errorText + "<br /><br />" + "Request ID: " + request_id;

            SweetAlert.swal({
                title: "Order Submission Error",
                html: true,
                text: $scope.errorText,
                type: "error",
                showCancelButton: true,
                confirmButtonColor: "#4f8fcc",
                confirmButtonText: 'Submission Form',
                closeOnConfirm: true
            }, function(confirm) {
                if(confirm) {
                    if(vm.food.submitting) vm.food.submitting = false;
                    // var a = document.createElement('a');
                    // a.download = `Anresco Error Submit Error.log - ${new Date().toLocaleDateString()}`;
                    // var blob = new Blob([vm.error_string], {type: 'text/plain'});
                    // a.href = window.URL.createObjectURL(blob);
                    // a.click();
                    // a.remove();                   
                    var aAdditionalPDF = document.createElement('a');
                    aAdditionalPDF.download = "SubmissionForm.pdf"; 
                    fetch($scope.errorFormPath) 
                        .then(response => response.arrayBuffer())
                        .then(pdfBuffer => {
                            var pdfBlob = new Blob([pdfBuffer], { type: 'application/pdf' });
                            aAdditionalPDF.href = window.URL.createObjectURL(pdfBlob);
                            aAdditionalPDF.click();
                            aAdditionalPDF.remove();
                        })
                    .catch(error => {
                        console.error("Error fetching additional PDF file:", error);
            });
                }
                else{
                    if(vm.food.submitting) vm.food.submitting = false;
                }
            });
        }

        vm.openShippingGuide = function() {
            // Use different URL for Japanese language
            if ($localStorage.language === 'Japanese') {
                window.open("https://hubs.ly/Q03cmzhp0", "_blank");
            } else {
                window.open("content/files/public/Packaging_and_Shipping_Guidelines_.pdf", "_blank");
            }
        }

        vm.downloadOrderPdf = function() {
            var orderId = $state.params.id;
                        if (orderId) {
                if ($rootScope.type === 'COMPLIANCE') {
                    var fileName = "Compliance Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'R&D' || $rootScope.type === 'RD') {
                    var fileName = "R&D Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'FOOD') {
                    var fileName = "Analysis Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'FDA'){
                    var fileName = "FDA Order " + orderId + ".pdf";
                }

                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                CustomerOrderPdfService.downloadPdf(orderId).then(function(result) {
                    var file = new Blob([result.data], {
                        type: 'application/pdf'
                    });
                    a.href = window.URL.createObjectURL(file);
                    a.download = fileName;
                    a.click();
                });
            }
        }

        rd.setInfoBoxCoordinates = function() {
            var viewBox = $('#wrap');
            var relativeTo = null;
            var target = null;
            var left = null;
            var bottom = null;

            for(var i = 0; i < vm.rd.tests.length; i++) {
                if(vm.rd.tests[i].info_modal) {
                    relativeTo = '#info-modal-icon-' + i.toString();
                    target = '.info-modal-' + i.toString();

                    left = $(relativeTo).offset().left - 218;
                    bottom = viewBox.outerHeight() - $(relativeTo).offset().top - 25;

                    if(viewBox.outerWidth() - left < 350) {
                        left = left - 302;
                        vm.rd.tests[i].left = true;
                    }
                    else {
                        vm.rd.tests[i].left = false;
                    }

                    left = left.toString() + 'px';
                    bottom = bottom.toString() + 'px';

                    $(target).css({ left: left, bottom: bottom })
                }
            }
        }

        food.setInfoBoxCoordinates = function() {
            var viewBox = $('#wrap');
            var relativeTo = null;
            var target = null;
            var left = null;
            var bottom = null;

            for(var i = 0; i < vm.food.tests.length; i++) {
                if(vm.food.tests[i].info_modal) {
                    relativeTo = '#info-modal-icon-' + i.toString();
                    target = '.info-modal-' + i.toString();

                    left = $(relativeTo).offset().left - 218;
                    bottom = viewBox.outerHeight() - $(relativeTo).offset().top - 25;

                    if(viewBox.outerWidth() - left < 350) {
                        left = left - 302;
                        vm.food.tests[i].left = true;
                    }
                    else {
                        vm.food.tests[i].left = false;
                    }

                    left = left.toString() + 'px';
                    bottom = bottom.toString() + 'px';

                    $(target).css({ left: left, bottom: bottom })
                }
            }
        }

        getCustomerData();
        angular.element(document).ready(function() {

            // Scroll is now handled by parent container - no sync needed

            // getCustomerData();

            setTimeout(function() {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;
                $("#table tr:first > th").css("width", col_width + "%");

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant == 2 || constant2 >= 2) {
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });


        $('#emailToCompliance').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email'
    		}
    	});

        $('#rdEmailRecepients').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email rdColumnRightLabel'
            },
        });

        $('#foodEmailRecepients').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email rdColumnRightLabel'
            },
        });

        function getUserEmails() {
            CustomerOrder.getCustomerEmails({},
                function(data) {
                    $('#emailToCompliance').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email'
                        }
                    });

                    $('#rdEmailRecepients').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email rdColumnRightLabel'
                        },
                    });

                    $('#foodEmailRecepients').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email rdColumnRightLabel'
                        },
                    });

                    $('#emailToCompliance').tagsinput('add', data.emails);
                    $('#rdEmailRecepients').tagsinput('add', data.emails);
                    $('#foodEmailRecepients').tagsinput('add', data.emails);

                    $('#emailToCompliance').tagsinput('refresh');
                    $('#rdEmailRecepients').tagsinput('refresh');
                    $('#foodEmailRecepients').tagsinput('refresh');

                    $('input').on('itemAdded', function(event) {
                        !vm.customer_type.includes('food') ? vm.rd.checkPageThree() :  vm.food.checkPageThree();
                    });

                    $('input').on('itemRemoved', function(event) {
                        !vm.customer_type.includes('food') ? vm.rd.checkPageThree() :  vm.food.checkPageThree();
                    });
                    },
                function(e) {
                    console.log(e);
                }
            );
        }

        // leave for now, anresco may want this filter instead of the default angularjs filter
        // $scope.startWith = function(actual, expected) {
        //     var lowerStr = (actual + "").toLowerCase();
        //     return lowerStr.indexOf(expected.toLowerCase()) === 0;
        //   }

    }

})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource'];

    function Customer ($resource) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;

                }
            },
            'update': { method:'PUT' },
            'updateQbench': {
                method: 'PATCH',
                url: 'api/customer/update/qbench',
            },
            'getPanels': {
                method: 'GET',
                url: 'api/customers/:id/panels',
                isArray: true
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'/*,'$scope'*/];

    function stateConfig($stateProvider/*,$scope*/) {
        $stateProvider
        .state('samplesubmit', {
            parent: 'entity',
            url: '/sample-submit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sample-Submit'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/sample-submit/samplesubmit.html',
                    controller: 'SampleSubmitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {

            }
        })
        .state('samplesubmit.notify', {
            parent: 'entity',
            url: '/sample-submit/notify',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sample-Submit'
            },
            params: {
                id: 0
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/sample-submit/samplesubmit.notify.html',
                    controller: 'SampleSubmitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {

            }
        })
        .state('samplesubmit.newcomp', {
            parent: 'samplesubmit',
            url: '/sample-submit-comp/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams','$state', '$uibModal', function($stateParams,$state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-submit/dialog.comp.samplesubmit.html',
                    controller: 'DialogCompSampleSubmitController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {

                        entity: function () {
                            return {
                                name: null,
                                lotBatchNumber: null,
                                productCategory: null,
                                productType: null,
                                strainName: null,
                                strainType: null,
                                id: null,
                                batchType: 'PRODUCT_BATCH',
                                nrUnits: null,
                                sampleWeight: null,
                                sCode: null
                            };
                        }
                    }
                }).result.then(function() {

                    $state.go('samplesubmit');
                }, function() {
                    $state.go('samplesubmit');
                });
            }]
        })
        .state('samplesubmit.editcomp', {
            parent: 'samplesubmit',
            url: '/sample-submit-comp/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-submit/dialog.comp.samplesubmit.html',
                    controller: 'DialogCompSampleSubmitController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lotBatchNumber: null,
                                productCategory: null,
                                productType: null,
                                strainName: null,
                                strainType: null,
                                otherAnalysis: null,
                                reportedUnits: null,
                                id: $stateParams.id,
                                batchType: 'PRODUCT_BATCH',
                                nrUnits: null,
                                sampleWeight: null,
                                sCode: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('samplesubmit');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('samplesubmit.newrnd', {
            parent: 'samplesubmit',
            url: '/sample-submit-rnd/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams','$state', '$uibModal', function($stateParams,$state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-submit/dialog.rnd.samplesubmit.html',
                    controller: 'DialogRndSampleSubmitController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {

                        entity: function () {
                            return {
                                name: null,
                                lotBatchNumber: null,
                                productCategory: null,
                                productType: null,
                                strainName: null,
                                strainType: null,
                                otherAnalysis: null,
                                reportedUnits: null,
                                id: null,
                                productBatchSize:null,
                                harvestBatchSize:null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('samplesubmit');
                }, function() {
                    $state.go('samplesubmit');
                });
            }]
        })
        .state('samplesubmit.editrnd', {
            parent: 'samplesubmit',
            url: '/sample-submit-rnd/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/sample-submit/dialog.rnd.samplesubmit.html',
                    controller: 'DialogRndSampleSubmitController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lotBatchNumber: null,
                                productCategory: null,
                                productType: null,
                                strainName: null,
                                strainType: null,
                                otherAnalysis: null,
                                reportedUnits: null,
                                id: $stateParams.id,

                                tests: [false,false,false,false,false,false,false,false,false,false,false,false]
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('samplesubmit');
                }, function() {
                    $state.go('^');
                });
            }]
        })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('DialogCompSampleSubmitController', DialogCompSampleSubmitController);

    DialogCompSampleSubmitController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Sample',
        'SampleTest', 'ProductType', 'CustomerOrder','ProductCategory','ProductTypeByCategory','StrainNameSearch', 'Panel'];

    function DialogCompSampleSubmitController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, Sample, SampleTest,
                                           ProductType, CustomerOrder,ProductCategory,ProductTypeByCategory,StrainNameSearch,Panel) {

        var vm = this;
        var update = false;


        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });

        vm.strainTypes  = [{
             'id': 1,
             'name': 'Sativa'
           }, {
              'id': 2,
              'name': 'Indica'
           }, {
             'id': 3,
             'name': 'Hybrid'
           },
           {
             'id': 4,
             'name': 'CBD'
           }];

        vm.panels = {}
        vm.phases = [];
        Panel.query({}, function(data){
        	if (data) {
        		for (var i = 0; i < data.length; i++) {
        			if (data[i].portalIdentifier) {
        				vm.panels[data[i].portalIdentifier] = data[i];
        			}
        		}
        		vm.phases = [
        	        	/* Plant */
        	            {
        		           'id': vm.panels['PLANT_COMPLIANCE_PHASE_3'].id,
        		           'name': 'Plant Matrix',
        		           'value':'PLANT_COMPLIANCE_PHASE_3'
        	            },

        	            /* Inhalable Extract */
        	            {
        	            	'id': vm.panels['INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'].id,
        	            	'name': 'Inhalable Extract Matrix',
        	            	'value':'INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'
        	            },

        	            /* Non-Inhalable */
        	            {
        	            	'id': vm.panels['EDIBLE_COMPLIANCE_PHASE_3'].id,
        	            	'name': 'Liquid Edible/Topical Matrix',
        	            	'value':'EDIBLE_COMPLIANCE_PHASE_3'
        	            },

        	            /* Solid Edible */
        	            {
        	            	'id': vm.panels['SOLID_EDIBLE_COMPLIANCE_PHASE_3'].id,
        	            	'name': 'Solid/Semi-Solid Edible Matrix',
        	            	'value':'SOLID_EDIBLE_COMPLIANCE_PHASE_3'
        	            },

        	            /* Pre-Roll Compliance */
        	            {
        	            	'id': vm.panels['PRE_ROLL_COMPLIANCE_PHASE_3'].id,
        	            	'name': 'Pre-Roll Matrix',
        	            	'value': 'PRE_ROLL_COMPLIANCE_PHASE_3'
        	            }
        	            ];
        	}
        });



         vm.inhalable_edible_array  = [{
            'id': 1,
            'name': 'Inhalable',
            'value':'INHALABLE'
            },
            {
            'id': 2,
            'name': 'Non-Inhalable',
            'value':'NONINHALABLE'
            }];

        vm.sample = entity;

        vm.productCategories = ProductCategory.query();

        vm.populateTypes = populateTypes;

        vm.loadStrains = loadStrains;

        vm.setStrainName = setStrainName;

        vm.resetProductAndHarvestInputs = resetProductAndHarvestInputs;

        vm.samples = $scope.$root.samplesComp;

        if(vm.sample.id != null){

            var sampleOld = vm.samples[vm.sample.id];

            vm.sample.name = sampleOld.name;
            vm.sample.lotBatchNumber = sampleOld.lotBatchNumber;
            vm.sample.productCategory = sampleOld.productCategory;
            vm.populateTypes();
            vm.sample.productType = sampleOld.productType;
            vm.sample.strainName = sampleOld.strainName;
            vm.sample.strainType = sampleOld.strainType;
            vm.sample.sCode = sampleOld.sCode;
            vm.sample.addTerpenes = sampleOld.addTerpenes;
            vm.sample.nrUnits = sampleOld.nrUnits;
            vm.sample.sampleWeight = sampleOld.sampleWeight;
            vm.sample.batchType = sampleOld.batchType;
            vm.sample.productBatchSize = sampleOld.productBatchSize;
            vm.sample.harvestBatchSize = sampleOld.harvestBatchSize;
            vm.sample.harvestDate = sampleOld.harvestDate;
            vm.sample.manufactureDate = sampleOld.manufactureDate;

            update = true;
        }

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.datePickerOpenStatus = {
        		harvestDate: false,
        		manufactureDate: false
        }
        vm.openCalendar = openCalendar;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function resetProductAndHarvestInputs(batchType){
        	if (batchType === "PRODUCT_BATCH"){
        		vm.sample.harvestBatchSize = null;
        		vm.sample.sampleWeightPerIncrement = null;
        		vm.sample.harvestDate = null;
        		vm.sample.manufactureDate = null;

        	} else if (batchType === "HARVEST_BATCH"){
        		vm.sample.productBatchSize = null;
        		vm.sample.harvestDate = null;
        		vm.sample.manufactureDate = null;
        	}
        };


        function save (param) {
            if(param == 1){
                if(vm.sample.lotBatchNumber == ''){vm.sample.lotBatchNumber = null}
                if(update){
                    vm.samples[vm.sample.id] = vm.sample;
                    $uibModalInstance.close("");
                }else{
                      if(vm.sample.batchType == 'PRODUCT_BATCH') {
                         vm.sample.harvestBatchSize = null;
                      }

                      if(vm.sample.batchType == 'HARVEST_BATCH') {
                       vm.sample.productBatchSize = null;
                      }

                    vm.sample.id = vm.samples.length;
                    vm.samples.push(vm.sample);
                    $uibModalInstance.close("");
                }
            }

            else if(param == 2 && update){

                if(vm.sample.lotBatchNumber == ''){vm.sample.lotBatchNumber = null}
                    vm.samples[vm.sample.id] =angular.copy(vm.sample);
                    vm.sample.id = vm.samples.length;
                    vm.sample.name = '';
                    vm.sample.lotBatchNumber = null;
                    vm.sample.productCategory = null;
                    vm.sample.productType = null;
                    vm.sample.strainName = null;
                    vm.sample.strainType = null;
                    vm.sample.phase = null;

                    vm.addTerpenes = null;
                    vm.sample.sCode = null;
                    vm.sample.nrUnits = null;
                    vm.sample.sampleWeight = null;
                    vm.productTypes = null;
                    vm.sample.harvestDate = null;
                    vm.sample.manufactureDate = null;
                    update = false;
            }

            else if(param == 2){
                if(vm.sample.lotBatchNumber == ''){
                    vm.sample.lotBatchNumber = null;
                }
                if(update){
                    vm.samples[vm.sample.id] = vm.sample;

                }else{
                     if(vm.sample.batchType == 'PRODUCT_BATCH') {
                        vm.sample.harvestBatchSize = null;
                      }

                      if(vm.sample.batchType == 'HARVEST_BATCH') {
                       vm.sample.productBatchSize = null;
                       vm.sample.sampleWeightPerIncrement = null;
                      }

                    vm.sample.id = vm.samples.length;
                    vm.sampleForArray = angular.copy(vm.sample);
                    vm.samples.push(vm.sampleForArray);

                    vm.sample.name = '';
                    vm.sample.lotBatchNumber = null;
                    vm.sample.productCategory = null;

                    vm.sample.productType = null;
                    vm.sample.strainName = null;
                    vm.sample.strainType = null;
                    vm.sample.phase = null;

                    vm.sample.addTerpenes = null;
                    vm.sample.sCode = null;
                    vm.sample.nrUnits = null;
                    vm.sample.sampleWeight = null;

                    vm.productTypes = null;

                    vm.harvestDate = null;
                    vm.manufactureDate = null;

                    update = false;

                }
            }

        }
        function populateTypes () {
            vm.productTypes = ProductTypeByCategory.query(vm.sample.productCategory);
        }

        function loadStrains(){
           vm.suggestedStrains = StrainNameSearch.query({searchString: vm.sample.strainName.name});
        }

        function setStrainName(name){
            vm.sample.strainName.id = 0;
            vm.sample.strainName.name = name;
            vm.suggestedStrains = [];
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('DialogRndSampleSubmitController', DialogRndSampleSubmitController);

    DialogRndSampleSubmitController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Sample',
        'SampleTest', 'ProductType', 'CustomerOrder','ProductCategory','ProductTypeByCategory','StrainNameSearch', 'Assay'];

    function DialogRndSampleSubmitController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, Sample, SampleTest,
                                           ProductType, CustomerOrder,ProductCategory,ProductTypeByCategory,StrainNameSearch, Assay) {

        var vm = this;
        var update = false;
        
        $rootScope.$on('closeModal', function (event, data) {
            clear();
        });

         vm.strainTypes  = [{
             'id': 1,
             'name': 'Sativa'
           }, {
              'id': 2,
              'name': 'Indica'
           }, {
             'id': 3,
             'name': 'Hybrid'
           },
            {
             'id': 4,
             'name': 'CBD'
            }];

          vm.inhalable_edible_array  = [{
             'id': 1,
             'name': 'Inhalable',
             'value':'INHALABLE'
             },
             {
             'id': 2,
             'name': 'Non-Inhalable',
             'value':'NONINHALABLE'
             }];

        vm.sample = entity;

        resetTests();

        vm.productCategories = ProductCategory.query();

        vm.populateTypes = populateTypes;

        vm.loadStrains = loadStrains;

        vm.setStrainName = setStrainName;

        vm.samples = $scope.$root.samplesRnD;

        vm.assays = {}
        vm.selectedAssays = {}
        vm.assayDescriptions = {}

        vm.takenAssays = [
        	'VITAMIN_E_ACETATE',
        	'POTENCY_LCDAD',
        	'POTENCY_LCMSMS',
        	'FOREIGN_MATERIAL',
        	'HEAVY_METALS',
        	'HOMOGENEITY',
        	'HOMOGENEITY_5',
        	'MICRO_INHALABLES',
        	'MICRO_NON_INHALABLES',
        	'MICRO_QA_SCREEN',
        	'MICRO_PLUS',
        	'MOISTURE',
        	'MYCOTOXINS',
        	'PESTICIDES_PHASE_II',
        	'PESTICIDES_PLUS',
        	'PESTICIDES_MYCOTOXINS',
        	'RESIDUAL_SOLVENT_PHASE_II',
        	'SULFUR',
        	'TERPENE_PROFILE',
        	'WATER_ACTIVITY',
        	'ALKALOID',
        ];
        
        vm.dynamicAssays = [];
        vm.assays_col_1 = [];
        vm.assays_col_2 = [];
        vm.assays_col_3 = [];
        
        Assay.query({}, function(data){
        	if (data) {
        		for (var i = 0; i < data.length; i++) {
        			vm.assays[data[i].portalIdentifier] = data[i];
        			if (data[i].portalIdentifier) {
        				vm.assayDescriptions[data[i].portalIdentifier] = data[i].analysis_description;
        				
        				if (vm.takenAssays.indexOf(data[i].portalIdentifier) == -1 && !data[i].do_not_show_on_portal) {
        					vm.dynamicAssays.push(data[i])
        				}
        			}
        		}
        		var dynamicAssaySize = vm.dynamicAssays.length/3;
        		vm.assays_col_1 = vm.dynamicAssays.slice(0, dynamicAssaySize);
                vm.assays_col_2 = vm.dynamicAssays.slice(dynamicAssaySize, dynamicAssaySize*2);
                vm.assays_col_3 = vm.dynamicAssays.slice(dynamicAssaySize*2, dynamicAssaySize*3);

        	}
        });


        vm.hasSelectedAssay = function(o) {
            if (vm.sample.otherAnalysis) {
                if (vm.sample.otherAnalysis.length >= 2) {
                    o['CONSULTING'] = true;
                    return true;
                }
                else {
                    o['CONSULTING'] = false;
                }

            }
            else {
                o['CONSULTING'] = false;
            }

        	for (var prop in o) {
        		if (o.hasOwnProperty(prop) && o[prop] === true) {
        			return true;
        		}
            }
        	return false;
        }

        if(vm.sample.id != null){

            var sampleOld = vm.samples[vm.sample.id];
            
            vm.sample.name = sampleOld.name;
            vm.sample.lotBatchNumber = sampleOld.lotBatchNumber;
            vm.sample.productCategory = sampleOld.productCategory;
            vm.populateTypes();
            vm.sample.productType = sampleOld.productType;
            vm.sample.strainName = sampleOld.strainName;
            vm.sample.strainType = sampleOld.strainType;
            vm.sample.otherAnalysis = sampleOld.otherAnalysis;
            vm.sample.reportedUnits = sampleOld.reportedUnits;
            vm.sample.harvestDate = sampleOld.harvestDate;
            vm.sample.manufactureDate = sampleOld.manufactureDate;

            sampleOld.sampleTests.forEach(function(sampleTest) {
            	if (sampleTest.assay) {
	            	if (sampleTest.assay.portalIdentifier == 'MOISTURE_CANNABINOID')
	            		return;
	            	vm.selectedAssays[sampleTest.assay.portalIdentifier] = true;
            	}
            });

            update = true;
        }

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.datePickerOpenStatus = {
        		harvestDate: false,
        		manufactureDate: false
        }
        vm.openCalendar = openCalendar;

        function clear () {
            if (!document.activeElement.classList.contains('form-control')) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function resetTests(){
            vm.selectedAssays = {};
        }

        function save (param) {
            var tagsInputItems = $('#otherAnalysisTagsInput').tagsinput('items')
            vm.sample.otherAnalysis = tagsInputItems

            fillSampleTests();
            resetTests();

            if(param == 1){
                if(vm.sample.lotBatchNumber == ''){vm.sample.lotBatchNumber = null}
                if(update){
                    vm.samples[vm.sample.id] = vm.sample;
                    $uibModalInstance.close("");
                }else{
                    vm.sample.id = vm.samples.length;
                    vm.samples.push(vm.sample);


                     $uibModalInstance.close("");
                }
            }

            else if(param == 2 && update){

                if(vm.sample.lotBatchNumber == ''){vm.sample.lotBatchNumber = null}
                    vm.samples[vm.sample.id] = angular.copy(vm.sample);
                    vm.sample.id = vm.samples.length;
                    vm.sample.name = '';
                    vm.sample.lotBatchNumber = null;
                    vm.sample.productCategory = null;
                    vm.productTypes = null;
                    vm.sample.productType = null;
                    vm.sample.strainName = null;
                    vm.sample.strainType = null;
                    vm.sample.otherAnalysis = [];
                    vm.sample.reportedUnits = null;
                    update = false;
            }

            else if(param == 2){
                if(vm.sample.lotBatchNumber == ''){vm.sample.lotBatchNumber = null}
                if(update){
                    vm.samples[vm.sample.id] = vm.sample;

                }else{
                    vm.sample.id = vm.samples.length;
                    vm.sampleForArray = angular.copy(vm.sample);
                    vm.samples.push(vm.sampleForArray);

                    vm.sample.name = '';
                    vm.sample.lotBatchNumber = null;
                    vm.sample.productCategory = null;
                    vm.productTypes = null;
                    vm.sample.productType = null;
                    vm.sample.strainName = null;
                    vm.sample.strainType = null;

                    vm.sample.otherAnalysis = null;
                    vm.sample.reportedUnits = null;
                    update = false;
                }
            }
        }


        function fillSampleTests() {

        	vm.sample.sampleTests = [];

             var has_cannabinoid_test = false;

             for (var key in vm.selectedAssays) {
            	 if (vm.selectedAssays[key] == false) continue;
            	 var assay = vm.assays[key];
            	 //May handle pushing the Moisture (CAN) in the front end here....
            	 vm.sample.sampleTests.push({assay: angular.copy(assay)});

            	 if (key.includes('POTENCY'))
            		 has_cannabinoid_test = true;
             }

             /* Corner Cases for Different Sample Types */
             if (vm.sample.productCategory.name == "Plant" && has_cannabinoid_test) {
            	 vm.sample.sampleTests.push({assay: angular.copy(vm.assays['MOISTURE_CANNABINOID'])});
             }
        }

        function onSaveSuccess (result) {
            $scope.$emit('anrescowebApp:sampleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function populateTypes () {
            vm.productTypes = ProductTypeByCategory.query(vm.sample.productCategory);
        }

        function loadStrains(){
           vm.suggestedStrains = StrainNameSearch.query({searchString: vm.sample.strainName.name});
        }

        function setStrainName(name){
            vm.sample.strainName.id = 0;
            vm.sample.strainName.name = name;
            vm.suggestedStrains = [];
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.resetOtherAnalysis= function() {
            $('#otherAnalysisTagsInput').tagsinput('removeAll');
        }

        angular.element(document).ready(function() {
            $('#otherAnalysisTagsInput').tagsinput({ delimiter: ';', confirmKeys: [13],});
        });
        
    }
})();

//THIS FUNCTIONALITY IS NOT USED ON WEB PORTAL
(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CustomerConfigureController', CustomerConfigureController);

    CustomerConfigureController.$inject = ['$scope','$state','Customer','Auth', 'Principal', 'ProfileService', 'LoginService','CustomerByUser','Contact'];

    function CustomerConfigureController($scope,$state,Customer,Auth, Principal, ProfileService, LoginService, CustomerByUser,Contact) {

        var vm = this;

        setUpContentWidth();
        vm.showsidebar = false;
        $scope.$root.contacts = [];
        vm.contacts = $scope.$root.contacts;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;

        if(!vm.isAuthenticated()){
             $state.go('login');
        }

        vm.customerData;

        vm.submitCustomer = submitCustomer;


        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function submitCustomer(){
           vm.customerData.address = vm.customerData.address_street + '@' + vm.customerData.address_city + '@' + vm.customerData.address_state + '@' + vm.customerData.address_country + '@' + vm.customerData.address_zip;
           Customer.save(vm.customerData, onSaveSuccess, onSaveError);
       }

       function onSaveSuccess (result) {
           $state.go('home');
       }

       function onSaveError () {

       }


    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customerconfigure', {
            parent: 'entity',
            url: '/customer-configure',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Customer-Configure'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/customer-configure/customer-configure.html',
                    controller: 'CustomerConfigureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        ;
    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('FAQPageController', FAQPageController);

    FAQPageController.$inject = ['$scope', '$rootScope','$http','FAQService' , 'Customer', 'Principal', 'LoginService', '$state', 'Auth', 'ProfileService', 'CustomerByUser', 'CustomerOrder', 'Invoice'];

    function FAQPageController($scope, $rootScope,$http, FAQService, Customer, Principal, LoginService, $state, Auth, ProfileService, CustomerByUser, CustomerOrder, Invoice) {

        $scope.getFaqResource = function(){
            $scope.getAllFaqCategoriesWithQuestions();
            $scope.getAllFaqQuestions();
        }

        $scope.questions = [];
        $scope.categoriesWithQuestions = [];
        $scope.questionByCategories = [];
        $scope.selectedCategory = 'all';
        $scope.selectedCategoryIndex = null;

        function setPageTitle() {
            $rootScope.pageTitle = "FAQ";
        }

        setPageTitle();


        $scope.allCategory = function(){
            $scope.selectedCategory = 'all';
        }

        $scope.selectedOneCategiry = function(index){
            $scope.selectedCategoryIndex = index;
            $scope.questionByCategories = $scope.categoriesWithQuestions[$scope.selectedCategoryIndex].faq;
            $scope.selectedCategory = 'category';
        }

        $scope.getAllFaqQuestions = function(){
            FAQService.getAllFaq().then(function (res) {
                $scope.questions = res.data;
            }).catch(function (err) {
                console.log(err);
            })
        }

        $scope.getAllFaqCategoriesWithQuestions = function () {
            FAQService.getAllFaqCategories().then(function (res) {
                $scope.categoriesWithQuestions = res.data;
            }).catch(function (err) {
                console.log(err);
            })
        }

        angular.element(document).ready(function() {
            $(".tab_content").hide();
            $(".tab_content:first").show();
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('faq', {
            parent: 'entity',
            url: '/faq',
            data: {
              authorities: ['ROLE_USER'],
              pageTitle: 'FAQ'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/faq/faq-page.html',
                    controller: 'FAQPageController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

angular.module('anrescowebApp')

    .factory('FAQService',['$http', function ($http) {
        return {
            getAllFaq: function () {
                return $http.get('/api/faq').then(function (response) {
                    return response;
                });
            },
            getFaq: function (id) {
                return $http.get('/api/faq/'+id).then(function (response) {
                    return response;
                });
            },
            deleteFaq: function (id) {
                return $http.delete('/api/faq/'+id).then(function (response) {
                    return response;
                });
            },
            getAllFaqCategories: function () {
                return $http.get('/api/faq-category').then(function (response) {
                    return response;
                });
            },
            createNewFaq: function (data) {
                return $http.post('/api/faq', data).then(function (response) {
                    return response;
                });
            },
            updateFaq: function (data) {
                return $http.put('/api/faq', data).then(function (response) {
                    return response;
                });
            }
        };
    }]);

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('NotificationsController', NotificationsController);

    NotificationsController.$inject = ['$state','$stateParams','$scope', '$rootScope','$http','$sce', '$filter', '$location','LoginService',
        'Auth', 'ParseLinks','ProfileService','paginationConstants', 'pagingParams','Principal', 'CustomerByUser', 'CustomerOrder', 'NotificationService' ];

    function NotificationsController($state, $stateParams, $scope, $rootScope, $http,$sce, $filter, $location, LoginService, Auth,ParseLinks,
                                      ProfileService,  paginationConstants,pagingParams, Principal,  CustomerByUser, CustomerOrder, NotificationService  ) {

        var vm = this;

        $scope.to_trusted = function(html_code) {
            return $sce.trustAsHtml(html_code);
        }

        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        $scope.itemArray = [
            {id: 0, name: 'All', value: null},
            {id: 1, name: 'Order Placed', value: 'ORDER_PLACED'},
            {id: 2, name: 'Sample Received', value: 'SAMPLE_RECEIVED'},
            {id: 3, name: 'Preliminary Results', value: 'PRELIMINARY_RESULTS'},
            {id: 4, name: 'Results Completed', value: 'RESULTS_COMPLETED'},
            {id: 5, name: 'Invoice Available', value: 'INVOICE_AVAILABLE'},
            {id: 6, name: 'Payment Received', value: 'PAYMENT_RECEIVED'}
        ];

        $scope.selected = { value: $scope.itemArray[0] };

        $scope.notificationSettings = function(){
            $rootScope.notificationTab = 2;
            $location.path('customer-manage');
        }
        setPageTitle();

        function setPageTitle(){
            $rootScope.pageTitle = "Notifications";
        }

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.itemsPerPage = "20";

        if(pagingParams.items != null){
            vm.itemsPerPage = pagingParams.items;
        }

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });


        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.setpagesize = setpagesize;
        vm.setFilter = setFilter;

        if(!vm.isAuthenticated()){
            $state.go('login');
        }

        loadAll();

        function loadAll () {

            if (pagingParams.search) {
                NotificationService.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    type: vm.type,
                }, onSuccess, onError);
            }
            else {
                NotificationService.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    type: vm.type,
                    productCategoryId: vm.productCategoryId
                }, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                $rootScope.allNotifications = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
            }
        }


        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {

            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                items: vm.itemsPerPage,
                type: vm.type
            });
        }

        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

        function setFilter(filter) {
            vm.page = 0;
            pagingParams.page = 0;
            $stateParams['page']= 0;
            $rootScope.notificationFilter =  filter;
            vm.type = filter.value;
            loadAll ();
        }

        $scope.markAllAsRead = function(){

            NotificationService.markAllAsRead({}, onSuccess, onError);
            function onSuccess(data, headers) {
                $rootScope.notifications = data;

                for( var j = 0; j < $rootScope.allNotifications.length; j++ ) {
                    $rootScope.allNotifications[j].notificationRead = true;
                }

                for( var i = 0; i < $rootScope.topNotifications.length; i++ ) {
                    $rootScope.topNotifications[i].notificationRead = true;
                }

                $rootScope.newNotification =  $filter('filter')( $rootScope.notifications, {notificationRead: false}).length
            }
            function onError(error) {}
        }


        $scope.readNotification = function(id){
            $http.put('api/notifications/mark-as-read/'+id).then(
                function(response) {

                    for( var i = 0; i < $rootScope.topNotifications.length; i++ ) {
                        if ($rootScope.topNotifications[i].id === id ){
                            $rootScope.topNotifications[i] = response.data;
                        }
                    }

                    for( var j = 0; j < $rootScope.allNotifications.length; j++ ) {
                        if ($rootScope.allNotifications[j].id === id ){
                            $rootScope.allNotifications[j] = response.data;
                        }
                    }

                    $rootScope.newNotification =  $filter('filter')( $rootScope.topNotifications, {notificationRead: false}).length
                }
            );
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('NotificationService', Notifications);

    Notifications.$inject = ['$resource'];
    function Notifications($resource) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getAllNotification': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getTopNotifications': {
                method: 'GET',
                url: 'api/notifications/top',
                isArray: true
            },
            'getSubscriptionSettings': {
                method: 'GET',
                url: 'api/notifications/subscriptions'
            },
            'saveSubscriptionSettings': {
                method: 'POST',
                url: 'api/notifications/subscribe'
            },
            'getAllNotification': {
                method: 'GET',
                url: '/api/notifications'
            },

            'markAllAsRead': {
                method: 'PUT',
                url: 'api/notifications/mark-as-read/all',
                isArray: true
            },
            'markAsRead': {
                method: 'PUT',
                url: 'api/notifications/mark-as-read/:id'


            },


        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notifications', {
            parent: 'entity',
            url: '/notifications?page&type',
            data: {
              authorities: ['ROLE_USER'],
              pageTitle: 'Notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/notifications/notifications.html',
                    controller: 'NotificationsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                search: null,
                state: {
                    value: 'ALL',
                    squash: true
                },
                items: null

            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        items: $stateParams.items
                    };
                }],
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ai-chat', {
            parent: 'app',
            url: '/ai-chat',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Home'
            },
            onEnter: ['$state', function($state) {
                $state.go('home');
            }]
        });
    }
})();

(function () {
    'use strict';

    angular.module('anrescowebApp').controller('PublicPageController', PublicPageController)
    .directive('testStatus', function(){
    	return {
    		scope: {test:'='},
    		link: function (scope, element, attrs){

                var html = '';
                var test = scope.test;

                if (test) {
                	if (test.state === 'RETESTING') {
                		html += '<p class="test-retesting"><span class="fa fa-repeat"></span>&nbsp;<span>Retesting</span></p>';
                	}
                	else if (test.caution) {
                		html += '<p class="test-caution"><span class="fa fa-warning"></span>&nbsp;<span>Caution</span></p>';
                	}
					else if (test.allComplete === false) { // Other Analyses
                		html += '<p class="in-progress"><span class="fa fa-clock-o"></span>&nbsp;<span>In Progress</span></p>';
                	}
					else if (test.canSeeResults) {
                        if (test.statusPf === 'FAIL') {
                            html += '<p class="test-fail"><span class="fa fa-times-circle"></span>&nbsp; Fail</p>';
                        }
                        else if (test.statusPf === 'PASS') {
                            html += '<p class="test-pass"><span class="fa fa-check-circle"></span>&nbsp; Pass</p>';
                        }
                        else {
                            html += '<p class="test-completed"><span class="fa fa-stop-circle"></span>&nbsp;<span>Tested</span></p>';
                        }
                	}
					else {
                		html += '<p class="in-progress"><span class="fa fa-clock-o"></span>&nbsp;<span>In Progress</span></p>';
                	}
				}
				else {
                	html += '<p class="not-tested"><span class="fa fa-stop-circle"></span>&nbsp;<span>Not Tested</span></p>';
                }

                element.html(html);

    		}
    	}
    })
    .directive('testSatusIcon', function() {
        return {
    		scope: {test:'='},
    		link: function (scope, element, attrs){

                var html = '';
                var test = scope.test;

                if (test) {
                	if (test.state === 'RETESTING') {
                		html += '<p class="test-retesting"><span class="fa fa-repeat"></span></p>';
                	}
                	else if (test.caution) {
                		html += '<p class="test-caution"><span class="fa fa-warning"></span></p>';
                	}
					else if (test.allComplete === false) { // Other Analyses
                		html += '<p class="in-progress"><span class="fa fa-clock-o"></span></p>';
                	}
					else if (test.canSeeResults) {
                        if (test.statusPf === 'FAIL') {
                            html += '<p class="test-fail"><span class="fa fa-times-circle"></p>';
                        }
                        else if (test.statusPf === 'PASS') {
                            html += '<p class="test-pass"><span class="fa fa-check-circle"></p>';
                        }
                        else {
                            html += '<p class="test-completed"><span class="fa fa-stop-circle"></span></p>';
                        }
                	}
					else {
                		html += '<p class="in-progress"><span class="fa fa-clock-o"></span></p>';
                	}
				}
				else {
                	html += '<p class="not-tested"><span class="fa fa-stop-circle"></span></p>';
                }

                element.html(html);

    		}
    	}

    })
    .directive('psIcon', function(){
    	return {
    		scope: {title:'='},
    		link: function (scope, element, attrs){
                var title = scope.title ? scope.title.toLowerCase() : '';
                var icon_class = '';

                if(title.includes('cannabis')) {
                    icon_class = 'cannabinoid-icon';
                }
                else if(title.includes('terpenoids')) {
                    icon_class = 'terpenes-icon';
                }
                else if(title.includes('microbio')) {
                    icon_class = 'microbiology-icon';
                }
                else if(title.includes('solvent')) {
                    icon_class = 'solvents-icon';
                }
                else if(title.includes('heavy metals')) {
                    icon_class = 'heavy-metals-icon';
                }
                else if(title.includes('mycotoxins')) {
                    icon_class = 'mycotoxins-icon';
                }
                else if(title.includes('pesticides')) {
                    icon_class = 'pesticides-icon';
                }
                else {
                    icon_class = 'flask-icon';
                }

                element.html('<span class="icon-bar ' + icon_class +'\"></span>');
    		}
    	}
    });

    PublicPageController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$resource', '$localStorage',
                                    '$sessionStorage', 'SampleService', 'Sample', 'SampleSearch', 'Principal', 'CustomerByOrder',
                                     'CustomerMap', 'data', 'SampleCoaPdfService', '$window','SampleAttach','SampleAttachDownload','AlertService','DownloadUtil'];

    function PublicPageController($rootScope, $scope,  $state, $stateParams, $resource, $localStorage,
                                 $sessionStorage, SampleService, Sample, SampleSearch, Principal, CustomerByOrder,
                                  CustomerMap, data, SampleCoaPdfService, $window, SampleAttach, SampleAttachDownload, AlertService, DownloadUtil) {

        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;

        var parsers = {}
        vm.dataExists = data ? true : false;
        vm.sampleReceived = sampleHasReceivedDate(data);
        vm.viewMoreLength = 20;
        vm.viewMore = false;
        vm.view_more_sample_info = false;

        vm.showWideView = false;
        vm.showTallView = false;
        vm.googleChartsLoaded = false;
        vm.cannabinoidsTested = false;
        vm.terpenesTested = false;
        vm.moistureTested = false;
        vm.pesticidesMycotoxins = {
            tested: false,
            mycotoxins_units: 'ppb',
            loq_mycotoxins: '',
            pesticides_units: 'ppm',
            loq_pesticides: '',
            ochratoxin_a_limit: 20,
            total_aflatoxins_limit: 20,
        }

        vm.sample_can_see_report = false;
        vm.selectedDownload = '';
        vm.isComplianceOrder = false;
        vm.cannabinoidChartColorArray = []
        vm.customerDisplayName = '';

		onResize(function(){
            showCorrectView();
            $scope.$apply();
        });

        showCorrectView();
        generateParsers();
        createSectionDecriptionMap();
        createTitleToSectionMap();
        SampleService.getWorksheetParserMap({},
            function(data) {
                delete data['$promise'];
                delete data['$resolved'];
                vm.parserMap = data;
                vm.sections = [];
                if(vm.dataExists) {
                    processSample();
                }
            },
            function(e) {
                console.log(e);
            }
        );

        vm.titleToSection = function(title) {
            if(vm.titleToSectionTitleMap[title]) {
                return vm.titleToSectionTitleMap[title];
            }
            else {
                return title;
            }
        }

        vm.titleToSectionHeader = function(title) {
            if(vm.titleToSetionHeader[title]) {
                return vm.titleToSetionHeader[title];
            }
            else {
                return title;
            }
        }

        function updateAttachmentVisibility() {
            if (!vm.customer || !vm.sample.attachments) {
                return;
            }

            if (vm.customer.canSeeAll) {
                vm.customer.canSeeCOASummary = true;
            }

            angular.forEach(vm.sample.attachments, function(attachment) {
                var fileName = (attachment.file_name || '').toLowerCase();
                attachment.canSee = !!vm.sample_can_see_report &&
                    attachment.type === 'SAMPLE_QBENCH_SAMPLE_PDF' &&
                    fileName.endsWith('.pdf') &&
                    fileName.includes('consolidated') && fileName.includes('coa');
            });
        }

        vm.canDownloadCoaSummary = function() {
            return !!(vm.customer && vm.customer.canSeeCOASummary && vm.sample_can_see_report &&
                (vm.customer.consolidated_business_type === 'cannabis' || vm.customer.consolidated_business_type === 'hemp'));
        };

        vm.hasDownloads = function() {
            return vm.canDownloadCoaSummary() || !!(vm.sample.attachments && vm.sample.attachments.some(function(attachment) {
                return attachment.canSee;
            }));
        };

        function getAttachments(){
            SampleAttach.getPublic({hash: vm.sample.hash}, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.sample.attachments = data;
                updateAttachmentVisibility();
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        function createTitleToSectionMap() {
            vm.titleToSectionTitleMap = {};
            vm.titleToSectionTitleMap["Cannabis"] = 'Cannabinoids';
            vm.titleToSectionTitleMap["Terpenoids"] = 'Terpenes';
            vm.titleToSectionTitleMap["Alkaloids"] = 'Alkaloids';
            vm.titleToSectionTitleMap["Microbiology"] = 'Microbiology';
            vm.titleToSectionTitleMap["Pesticides"] = 'Pesticides';
            vm.titleToSectionTitleMap["Mycotoxins"] = 'Mycotoxins';
            vm.titleToSectionTitleMap["Residual Solvent Screen"] = 'Solvents';
            vm.titleToSectionTitleMap["Heavy Metals"] = 'Heavy Metals';
            vm.titleToSectionTitleMap["Allergens"] = 'Allergens';
            vm.titleToSectionTitleMap["Nutrients"] = 'Nutritionals';
            vm.titleToSectionTitleMap["Antibiotics"] = 'Antibiotics';
            vm.titleToSectionTitleMap["Chemistry"] = 'Chemistry';
            vm.titleToSectionTitleMap["Microscopy"] = 'Microscopy';
            vm.titleToSectionTitleMap["Other Analyses"] = 'Other Analyses';

            vm.titleToSetionHeader = {};
            vm.titleToSetionHeader["Cannabis"] = 'Cannabinoid Profile';
            vm.titleToSetionHeader["Terpenoids"] = 'Terpene Profile';
            vm.titleToSetionHeader["Alkaloids"] = 'Alkaloids';
            vm.titleToSetionHeader["Microbiology"] = 'Microbiology';
            vm.titleToSetionHeader["Pesticides"] = 'Pesticide Residue';
            vm.titleToSetionHeader["Mycotoxins"] = 'Mycotoxins';
            vm.titleToSetionHeader["Residual Solvent Screen"] = 'Residual Solvents';
            vm.titleToSetionHeader["Heavy Metals"] = 'Heavy Metals';
            vm.titleToSetionHeader["Allergens"] = 'Allergens';
            vm.titleToSetionHeader["Nutrients"] = 'Nutritionals';
            vm.titleToSetionHeader["Antibiotics"] = 'Antibiotics';
            vm.titleToSetionHeader["Chemistry"] = 'Chemistry';
            vm.titleToSetionHeader["Microscopy"] = 'Microscopy';
            vm.titleToSetionHeader["Other Analyses"] = 'Other Analyses';
        }

        vm.sectionTested = function(pf) {
            if(pf) {
                var pf_lowercase = pf.toLowerCase();
                if(pf_lowercase.toLowerCase() == 'not_tested' || pf_lowercase.toLowerCase() == 'in_progress' || pf_lowercase.toLowerCase() == 'retesting') {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return false;
            }
        }

        vm.overallPf = function(pf, show_results) {
            if(!show_results && ['tested', 'pass', 'fail'].includes(pf)) {
                return '<span class="test-completed"><span class="fa fa-stop-circle"></span>&nbsp;<span>Final Review</span></span>';
            }

            switch(pf) {
                case "not_tested":
                    return '<span class="not-tested"><span class="fa fa-stop-circle"></span>&nbsp;<span>Not Tested</span></span>';
                case "caution":
                    return '<span class="test-caution"><span class="fa fa-warning"></span>&nbsp;<span>Caution</span></span>';
                case "in_progress":
                    return '<span class="in-progress"><span class="fa fa-clock-o"></span>&nbsp;<span>In Progress</span></span>';
                case "retesting":
                    return '<span class="test-completed"><span class="fa fa-repeat"></span>&nbsp;<span>Retesting</span></span>';
                case "fail":
                    return '<span class="test-fail"><span class="fa fa-times-circle"></span>&nbsp; Fail</span>';
                case "pass":
                    return '<span class="test-pass"><span class="fa fa-check-circle"></span>&nbsp; Pass</span>';
                case "tested":
                    return '<span class="test-completed"><span class="fa fa-stop-circle"></span>&nbsp;<span>Tested</span></span>';
                default:
                    return '<span class="not-tested"><span class="fa fa-stop-circle"></span>&nbsp;<span>Not Tested</span></span>';
            }
        }

        function showCorrectView() {
            if($window.innerWidth < 1366) {
                vm.showWideView = false;
                vm.showTallView = true;

                if(vm.googleChartsLoaded && vm.cannabinoidsTested) {
                    drawCannabinoidChart('resize');
                }
                if(vm.googleChartsLoaded && vm.terpenesTested) {
                    try {
                        drawTerpenesChart('resize');
                    }
                    catch(e) {
                        console.log('Could not render terpenes graph');
                        console.log(e)
                    }
                }
            }
            else {
                setResultsWidth();

                if(vm.googleChartsLoaded && vm.cannabinoidsTested) {
                    drawCannabinoidChart('resize');
                }
                if(vm.googleChartsLoaded && vm.terpenesTested) {
                    try {
                        drawTerpenesChart('resize');
                    }
                    catch(e) {
                        console.log('Could not render terpenes graph');
                    }
                }
                vm.showWideView = true;
                vm.showTallView = false;

                resetPaginationArrows();
            }
        }

        function onResize(c,t) {
            onresize = function() { // refers to window.onresize callback
                clearTimeout(t);
                t = setTimeout(c,250);
                };
            return c;
        }

        $(document).click( function() {
            if(vm.showWideView) {
                resetPaginationArrows();
            }
        })

        function resetPaginationArrows() {
            $('.paginate_button.previous').text('');
            $('.paginate_button.previous').append("<i class=\"fa fa-chevron-left\"><i>");
            $('.paginate_button.next').text('');
            $('.paginate_button.next').append("<i class=\"fa fa-chevron-right\"><i>");
        }

        function determineCategoryShowResults(show_result_array) {
            if(!show_result_array) {
                return false
            }
            else if(show_result_array.includes(false)) {
                return false;
            }
            else {
                return true;
            }
        }

        function determineCategoryPf(pf_array) {
            var category_status = null;

            pf_array = pf_array.join('|').toLowerCase().split('|');

            if(pf_array.includes('not_tested')) {
                category_status = 'not_tested';
            }
            else if (pf_array.includes('in_progress')) {
                category_status = 'in_progress';
            }
            else if (pf_array.includes('retesting')) {
                category_status = 'retesting';
            }
            else if (pf_array.includes('caution')) {
                category_status = 'caution';
            }
            else if (pf_array.includes('fail')) {
                category_status = 'fail';
            }
            else if (pf_array.includes('pass')) {
                category_status = 'pass';
            }
            else {
                category_status = 'tested';
            }

            return category_status;
        }

        function sampleHasReceivedDate(sample) {
            return !!(sample && (sample.receivedDate || sample.orderDateReceived ||
                (sample.order && (sample.order.dateReceived || sample.order.date_received))));
        }

        function testHasReceivedDate(test) {
            return !!(test && (test.receivedDate || test.orderReceivedDate || test.orderDateReceived)) || sampleHasReceivedDate(data);
        }

        function determineTestPf(test) {
            var pf_value = null;

            if (test) {
                if (test.state === 'RETESTING') {
                    pf_value = 'retesting';
                }
                else if (test.caution) {
                    pf_value = 'caution';
                }
                else if (test.allComplete === false) {
                    pf_value = 'in_progress';
                }
                else if(test.orderState === 'CREATED' && !test.statusPf && !testHasReceivedDate(test)) {
                    pf_value = 'not_tested'
                }
                else if (test.statusPf === 'FAIL') {
                    pf_value = 'fail';
                }
                else if (test.statusPf === 'PASS') {
                    pf_value = 'pass';
                }
                else if (test.canSeeResults && test.state =='COMPLETED') {
                    pf_value = 'tested';
                }
                else {
                    pf_value = 'in_progress';
                }
            }
            else {
                pf_value = 'not_tested';
            }

            return pf_value
        }

        function parseEmptyWorksheet(test) {
            var category = test.assay.category ? test.assay.category : test.assay.title;
            var section_index = findWithAttr(vm.sections, 'title', category);

            var pf_dict = {
                canSeeResults: test.canSeeResults ?  test.canSeeResults : null,
                caution: test.caution ? test.caution : null,
                orderState: test.orderState ? test.orderState : null,
                statusPf: test.statusPf ? test.statusPf : null,
                receivedDate: data.receivedDate || data.orderDateReceived ||
                    (data.order && (data.order.dateReceived || data.order.date_received)) || null
            }

            var test_pf = determineTestPf(pf_dict);

            if(section_index == -1) {
                vm.sections.push({
                    title : category,
                    description : null,
                    overall_pf : null,
                    section_data : [],
                    expanded : false,
                    active: false,
                    info_box_open: false,
                });
                section_index = vm.sections.length - 1;
            }
            else {
                vm.sections[section_index].pf_values.push(test_pf);
            }
        }

        function determineUnits(analyte_units, assay_units) {
            if(analyte_units) {
                return analyte_units;
            }
            else if(assay_units) {
                return assay_units;
            }
            else {
                return null;
            }
        }

        function unitsRequired(value) {
            if(!value) {
                return false;
            }

            else if(typeof(value) == 'string') {
                var compare = value.toLowerCase();

                if(compare == 'nt' || compare == 'nd' || compare == 'bloq' || compare == 'blod' || compare == 'blq' || compare == '0' || compare == '0.00') {
                    return true;
                }
                else {
                    return true;
                }
            }
            else {
                return true;
            }
        }

        function findWithAttr(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr].toLowerCase() === value.toLowerCase()) {
                    return i;
                }
            }
            return -1;
        }

        vm.sort_section = function(section) {
            if(!section.current_sort_by) {
                section.sort_by = 'status';
                section.current_sort_by = 'status';
            }
            else if(section.current_sort_by == 'status') {
                section.sort_by = 'name';
                section.current_sort_by = 'name';
            }
            else if(section.current_sort_by == 'name'){
                section.sort_by = 'status';
                section.current_sort_by = 'status';
            }

            section.section_data.sort( function(item_1, item_2) {
                if(!item_1[section.sort_by]) {
                    return 1;
                }
                else if(!item_2[section.sort_by]) {
                    return -1;
                }
                else if(item_1[section.sort_by] > item_2[section.sort_by]) {
                    return 1;
                  }
                else if(item_1[section.sort_by] < item_2[section.sort_by]) {
                    return -1;
                }
                else {
                    return 0
                }
            });
        }

        function findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date) {
            var section_index = findWithAttr(vm.sections, 'title', category);

            if(section_index == -1) {
                vm.sections.push({
                    title : category,
                    description : null,
                    overall_pf : null,
                    section_data : [],
                    pf_values: [test_pf],
                    show_results: [show_result],
                    expanded : false,
                    active: false,
                    info_box_open: false,
                    instrument: [instrument],
                    complete_date: [complete_date],
                    estimated_complete_date: [estimated_complete_date],
                    sort_by: '',
                    current_sort_by: '',
                });
                section_index = vm.sections.length - 1;
            }
            else {
                vm.sections[section_index].pf_values.push(test_pf);
                vm.sections[section_index].instrument.push(instrument);
            }

            return section_index;
        }

        var pass_fail_map = {
            false: 'Pass',
            true: 'Fail'
        }

        function parseValueObject(value_object) {
            if(value_object && value_object.twoDecimalFormattedValue) {
                return parseValue(value_object.twoDecimalFormattedValue)
            }
            else if(value_object && value_object.value) {
                return parseValue(value_object.value);
            }
            else {
                return null;
            }
        }

        function parseValue(value) {
            var parsed_value = parseFloat(value);
            const regex =  /[A-Za-z]/
            if(value) {
                if(value == 'NT' || value == 'ND' || value == 'BLOQ' || value == 'BLOD' || value == 'BLQ' || value.includes('<') || value.includes('>') || regex.test(value)) {
                    return value;
                }
                else if(value == '0' || value == '0.0' || value == '0.00') {
                    return 'ND';
                }
            }
            else {
                return value;
            }

            if(isNaN(parsed_value)) {
                return value;
            }
            else {
                return parsed_value
            }
        }

        function determineGeneralParserAnalyteStatus(analyte, ws) {
            var status = '';
            if(ws[analyte + '_pf']) {
                status = ws[analyte + '_pf'].value;
            }
            else if (ws[analyte + '_fail']) {
                status = pass_fail_map[ws[analyte + '_fail'].value]
            }

            return status;
        }

        function generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
            var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);
            angular.forEach(ws, function(value, key) {
                if(value.display_name && value.value) {
                    if(value.display_name.includes("&amp;delta;")){
                        var new_display_name = value.display_name.replace(/&amp;delta/g, '&Delta');
                        value.display_name = new_display_name
                    }
                    vm.sections[section_index].section_data.push({
                        name: value.display_name ? value.display_name : '',
                        value: value.value ? parseValue(value.value) : '',
                        units: determineUnits(value.units, units),
                        value_exists: unitsRequired(value.value),
                        status: determineGeneralParserAnalyteStatus(key, ws),
                        limit: ws[key + '_limit'] ? ws[key + '_limit'].value : '',
                        lod: ws[key + '_lod'] ? ws[key + '_lod'].value : '',
                        loq: ws[key + '_loq'] ? ws[key + '_loq'].value : '',
                        method:  ws[key + '_method'] ? ws[key + '_method'].value : ''
                    });
                }
            });
        }

        function microParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
            var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

            angular.forEach(ws, function(value, key) {
                var data_value = null;
                if(!key.includes('_method') && key != 'comments' && value) {
                    if(value.twoDecimalFormattedValue) {
                        data_value = value.twoDecimalFormattedValue
                    }
                    else if(value.value) {
                        data_value = value.value
                    }
                    vm.sections[section_index].section_data.push({
                        name: value.display_name ? value.display_name : '',
                        value: data_value ? parseValue(data_value) : '',
                        units: determineUnits(value.units, units),
                        value_exists: unitsRequired(data_value),
                        limit: ws[key + '_limit'] ? ws[key + '_limit'].value : '',
                        lod: ws[key + '_lod'] ? ws[key + '_lod'].value : '',
                        loq: ws[key + '_loq'] ? ws[key + '_loq'].value : '',
                        method:  ws[key + '_method'] ? ws[key + '_method'].value : ''
                    });
                }
            });
        }

        function createSectionDecriptionMap() {
            vm.sectionDescriptionMap = {}

            vm.sectionDescriptionMap['Microbiology'] = 'Screening for fungal and bacteria contamination.';
            vm.sectionDescriptionMap['Residual Solvent Screen'] = 'Screening for residual solvents utilizing gas chromatography mass spectrometry (GC/MS).';
            vm.sectionDescriptionMap['Heavy Metals'] = 'Screening for heavy metals utilizing inductively coupled mass spectrometry (ICP/MS).';
            vm.sectionDescriptionMap['Pesticides'] = 'Screening for pesticide and fungicide residues utilizing liquid chromatography tandem mass spectrometry (LC-MS/MS) & gas chromatography tandem mass spectrometry (GC-MS/MS).';
            vm.sectionDescriptionMap['Mycotoxins'] = 'Screening for mycotoxins utilizing liquid chromatography tandem mass spectrometry (LC-MS/MS).';
            vm.sectionDescriptionMap['Terpenoids'] = 'Identification and quantification of terpenoids utilizing gas chromatography mass spectrometry (GC/MS).';
            vm.sectionDescriptionMap['Cannabis'] = 'Full spectrum cannabinoid profiling and analysis utilizing High Performance Liquid Chromatography (HPLC/UV).';
        }

        function setSectionsInfoData() {
            var lod = '';
            var lod_same_for_all = false;
            var loq = '';
            var loq_same_for_all = false;
            var method = '';
            var method_same_for_all = false;
            var units = '';
            var units_same_for_all = false;
            var limit = '';
            var limit_same_for_all = false;
            var show_status = false;

            for(var i = 0; i < vm.sections.length; i++) {
                lod = '';
                lod_same_for_all = false;
                loq = '';
                loq_same_for_all = false;
                method = '';
                method_same_for_all = false;
                units = '';
                units_same_for_all = false;
                limit = '';
                limit_same_for_all = false;
                show_status = false;

                if(vm.sections[i].section_data) {
                    if(vm.sections[i].section_data.length > 2) {
                        vm.sections[i].section_data.sort( function(a, b) {
                            if(a.value && b.value) {
                                if(typeof(a.value) == 'number' && typeof(b.value) == 'string') {
                                    return -1
                                  }
                                else {
                                    return 0
                                }
                            }
                            else {
                                return 0
                            }
                        });
                    }
                }

                for(var j = 0; j < vm.sections[i].section_data.length; j++) {
                    if(!show_status) {
                        if(vm.sections[i].section_data[j].status) {
                            show_status = true;
                        }
                    }
                    if(!lod) {
                        if(vm.sections[i].section_data[j].lod) {
                            lod = vm.sections[i].section_data[j].lod;
                            lod_same_for_all = true;
                        }
                    }
                    else {
                        if(vm.sections[i].section_data[j].lod) {
                            if(lod != vm.sections[i].section_data[j].lod) {
                                lod_same_for_all = false;
                            }
                        }
                        else {
                            lod_same_for_all = false;
                        }
                    }
                    if(!loq) {
                        if(vm.sections[i].section_data[j].loq) {
                            loq = vm.sections[i].section_data[j].loq;
                            loq_same_for_all = true;
                        }
                    }
                    else {
                        if(vm.sections[i].section_data[j].loq) {
                            if(loq != vm.sections[i].section_data[j].loq) {
                                loq_same_for_all = false;
                            }
                        }
                        else {
                            loq_same_for_all = false;
                        }
                    }
                    if(!method) {
                        if(vm.sections[i].section_data[j].method) {
                            method = vm.sections[i].section_data[j].method;
                            method_same_for_all = true;
                        }
                    }
                    else {
                        if(vm.sections[i].section_data[j].method) {
                            if(method != vm.sections[i].section_data[j].method) {
                                method_same_for_all = false;
                            }
                        }
                        else {
                            method_same_for_all = false;
                        }
                    }
                    if(!units) {
                        if(vm.sections[i].section_data[j].units) {
                            units = vm.sections[i].section_data[j].units;
                            units_same_for_all = true;
                        }
                    }
                    else {
                        if(vm.sections[i].section_data[j].units) {
                            if(units != vm.sections[i].section_data[j].units) {
                                units_same_for_all = false;
                            }
                        }
                        else {
                            units_same_for_all = false;
                        }
                    }
                    if(!limit) {
                        if(vm.sections[i].section_data[j].limit) {
                            limit = vm.sections[i].section_data[j].limit;
                            limit_same_for_all = true;
                        }
                    }
                    else {
                        if(vm.sections[i].section_data[j].limit) {
                            if(limit != vm.sections[i].section_data[j].limit) {
                                limit_same_for_all = false;
                            }
                        }
                        else {
                            limit_same_for_all = false;
                        }
                    }
                }

                vm.sections[i].lod = lod;
                vm.sections[i].lod_same_for_all = lod_same_for_all;
                vm.sections[i].loq = loq;
                vm.sections[i].loq_same_for_all = loq_same_for_all;
                vm.sections[i].method_same_for_all = method_same_for_all;
                vm.sections[i].units = units;
                vm.sections[i].units_same_for_all = units_same_for_all;
                vm.sections[i].limit = limit;
                vm.sections[i].limit_same_for_all = limit_same_for_all;
                vm.sections[i].show_status = show_status;

                if(method.includes(',')) {
                    vm.sections[i].method = method.split(',')
                }
                else {
                    vm.sections[i].method = [method];
                }
            }
        }

        function parseInstrument(instrument) {
            var matching_string = '';
            if(instrument) {
                if(instrument.length > 10) {
                    matching_string = instrument.match(/\(([^)]+)\)/);
                    if(matching_string) {
                        return matching_string[1];
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return instrument;
                }
            }
            else {
                return '';
            }
        }

        function isNdValue(value) {
            let nd_values = ['nd', 'ND', 'nt', 'nt', '0', '0.0', 'null', null, 0, 0.0];
            if(nd_values.includes(value)) return true;

            return false;
        }

        function processSample() {
            var pf_dict = {}
            var units = null;
            var category = null;
            var instrument = null;
            var complete_date = null;
            var estimated_complete_date = null;
            var table_name = null;
            var table_id = null;
            var li = null;
            var done = "<li id=\"done\"></li>";
            var section_index = null;

            var samplingAddress = data.order.samplingAddress;

            if(samplingAddress) {
                vm.customerDisplayName = samplingAddress.split('\n')[0];
            }
            else {
                vm.customerDisplayName = data.order.customer.company_name;
            }

            vm.sample_can_see_report = data.canSeeReport;
            updateAttachmentVisibility();
            try {
                if(data.order.order_type.toLowerCase().includes('compliance')) {
                    vm.isComplianceOrder = true;
                }
                else {
                    vm.isComplianceOrder = false;
                }
            }
            catch(e) {
                console.log('No order type for this sample.');
                vm.isComplianceOrder = false;
            }

            data.sampleTests.forEach( function(test) {
                var show_result = false

                if (vm.isComplianceOrder) {
                    var isOrderComplete = data.order && data.order.state === 'COMPLETED';
                    if (isOrderComplete && data.canSeeReport) {
                        vm.sample_can_see_report = true;
                    }

                    show_result = test.canSeeResults && vm.sample_can_see_report
                }
                
                else if(test.canSeeResults || vm.sample_can_see_report) {
                    show_result = true;
                }

                if(test.assay.worksheet_id && test.worksheetData) {
                    pf_dict = {
                        canSeeResults: test.canSeeResults ?  test.canSeeResults : null,
                        caution: test.caution ? test.caution : null,
                        orderState: test.orderState ? test.orderState : null,
                        statusPf: test.statusPf ? test.statusPf : null,
                        state: test.state ? test.state : null,
                        show_result: show_result,
                        receivedDate: data.receivedDate || data.orderDateReceived ||
                            (data.order && (data.order.dateReceived || data.order.date_received)) || null
                    }

                    category = test.assay.category ? test.assay.category : test.assay.title
                    units = test.assay.units ? test.assay.units : null;
                    instrument = test.assay.instrument ? parseInstrument(test.assay.instrument) : null;
                    complete_date = test.completeDate ? new Date(test.completeDate) : null;
                    estimated_complete_date = test.estimatedCompleteDate ? new Date(test.estimatedCompleteDate) : null;
                    parseWorksheet(test.assay.worksheet_id, test.worksheetData, category, determineTestPf(pf_dict), units, show_result, instrument, complete_date, estimated_complete_date, test.assay);
                }
                else {
                    if(!test.assay.worksheet_id) {
                        console.log('No worksheet id: ', test.assay.title);
                    }
                    else if(!test.worksheetData) {
                        parseEmptyWorksheet(test);
                    }
                }
            });

            moveOtherAnalyses();
            moveTerpenesAndCannabinoids();

            vm.sections.forEach( function(section, index) {
                section.overall_pf = determineCategoryPf(section.pf_values);
                section.overall_show_results = determineCategoryShowResults(section.show_results);

                if(section.title == 'Pesticides') {
                    var failed = 0;
                    if(section.section_data) {
                        section.section_data.forEach( function(analyte) {
                            if(!isNdValue(analyte.value)) {
                                failed++;
                            }
                        });
                    }
                    section.pesticides_detected = failed;
                }

                if(vm.sectionDescriptionMap[section.title]) {
                    section.description = vm.sectionDescriptionMap[section.title];
                }
                else {
                    section.description = 'Analysis for ' + section.title.toLowerCase() + '.';
                }

                if(section.section_data.length > vm.viewMoreLength) {
                    section.view_more = false;
                }

                if(section.instrument) {
                    for(var i = section.instrument.length; i > 0; i--) {
                        if(!section.instrument[i]) {
                           section.instrument.splice(i, 1);
                        }
                    }
                }

                if(section.complete_date) {
                    var latest_date = null;

                    section.complete_date.forEach( function(date) {
                        if(date > latest_date) {
                            latest_date = date;
                        }
                    });
                    section.complete_date = latest_date;
                }

                if(section.estimated_complete_date) {
                    var latest_date = null;

                    section.estimated_complete_date.forEach( function(date) {
                        if(date > latest_date) {
                            latest_date = date;
                        }
                    });
                    section.estimated_complete_date = latest_date;
                }

                section.table_name = section.title.replace(/\s+\(|\)\s|\s|\(|\)|&/g, "-") + '-table';
                // table_name = '#' + section.title.replace(/\s+\(|\)\s|\s|\(|\)/g, "-") + '-table';
                table_name = '#' + section.title.replace(/\s+\(|\)\s|\s|\(|\)|&/g, "-") + '-table';
                table_id = '1' + section.title.replace(/\s+\(|\)\s|\s|\(|\)|&/g, "-") + '-table';
                li = "<li id=\"" + table_id +  "\">" + table_name + "</li>";

                $('#list-of-sections').append(li);
            });

            if(vm.sections[0]) vm.sections[0].active = true;

            setSectionsInfoData();

            if(vm.pesticidesMycotoxins.tested) {
                section_index = findWithAttr(vm.sections, 'title', 'Pesticides');
                if(section_index > -1) {
                    vm.sections[section_index].units = vm.pesticidesMycotoxins.pesticides_units;
                    vm.sections[section_index].units_same_for_all = true;

                    vm.sections[section_index].loq_same_for_all = true;
                    vm.sections[section_index].loq = vm.pesticidesMycotoxins.loq_pesticides;

                    vm.sections[section_index].limit_same_for_all = false;
                }

                section_index = findWithAttr(vm.sections, 'title', 'Mycotoxins');
                if(section_index > -1) {
                    vm.sections[section_index].units = vm.pesticidesMycotoxins.mycotoxins_units;
                    vm.sections[section_index].units_same_for_all = true;

                    vm.sections[section_index].loq_same_for_all = true;
                    vm.sections[section_index].loq = vm.pesticidesMycotoxins.loq_mycotoxins;

                    vm.sections[section_index].limit_same_for_all = false;
                }
            }

            $('#list-of-sections').append(done);
            google.charts.setOnLoadCallback(function () {
                vm.googleChartsLoaded = true;

                if(vm.cannabinoidsTested) {
                    drawCannabinoidChart('first_load');
                }
                if(vm.terpenesTested) {
                    drawTerpenesChart('first_load');
                }
            });

            setResultsWidth();
        }

        function setResultsWidth() {
            var main_container_width = $('.ps-container').width()
            var ps_sample_width = $('.ps-sample').width()
            var ps_results_width = main_container_width - ps_sample_width - 16;
            $('.ps-results').width(ps_results_width);

            if(vm.cannabinoidsTested) {
                drawCannabinoidChart('resize');
            }
            if(vm.terpenesTested) {
                try {
                    drawTerpenesChart('resize');
                }
                catch(e) {
                    console.log('Could not render terpenes graph');
                }
            }
        }

        vm.makeActive = function(title) {
            var section_index = findWithAttr(vm.sections, 'title', title);

            vm.sections.forEach( function(section, index) {
                section.active = false;
            });

            vm.sections[section_index].active = true;
        }

        function moveOtherAnalyses() {
            for(var i = 0; i < vm.sections.length; i++) {
                if(vm.sections[i].title == 'Other Analyses') {
                    vm.sections.push(vm.sections.splice(i, 1)[0]);
                    break;
                }
            }
        }

        function moveTerpenesAndCannabinoids() {
            var front = [];
            var back = [];
            var cannabis_section_index = findWithAttr(vm.sections, 'title', 'Cannabis');
            var terpenes_section_index = findWithAttr(vm.sections, 'title', 'Terpenoids');

            if(cannabis_section_index != -1) {
                front.push(vm.sections[cannabis_section_index]);
            }
            if(terpenes_section_index != -1) {
                front.push(vm.sections[terpenes_section_index]);
            }

            if(front) {
                for(var i = 0; i < vm.sections.length; i++) {
                    if(vm.sections[i].title != 'Terpenoids' &&  vm.sections[i].title != 'Cannabis') {
                        back.push(vm.sections[i]);
                    }
                }

            }

            if(front && back) {
                vm.sections = front.concat(back);
            }
            else if(front) {
                vm.sections = front;
            }
        }

        function isDynamicAnalyte(analyte) {
            var is_dynamic = true;
            var suffixes = ['_comments', '_finding', '_method', '_method_override', '_units', '_instrument', '_limit', '_lod', '_loq', '_status', '_pf'];

            suffixes.forEach( function(suffix) {
                if(analyte.includes(suffix)) {
                    is_dynamic = false;
                }
            });

            return is_dynamic;
        }

        vm.changeCannabinoidTotals = function() {
            var active_unit = vm.sections[0].active_unit;

            if(active_unit == 'dry_mgpg') {
                vm.sections[0].total_thc = vm.sections[0].dry_mgpg_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].dry_mgpg_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].dry_mgpg_total;
                vm.sections[0].active_unit_frontend = ' mg/g (dry)';
            }
            else if(active_unit == 'mgpg') {
                vm.sections[0].total_thc = vm.sections[0].mgpg_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].mgpg_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].mgpg_total;
                vm.sections[0].active_unit_frontend = ' mg/g';
            }
            else if (active_unit == 'dry_percent') {
                vm.sections[0].total_thc = vm.sections[0].dry_percent_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].dry_percent_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].dry_percent_total;
                vm.sections[0].active_unit_frontend = '% (dry)';
            }
            else if (active_unit == 'mgpml') {
                vm.sections[0].total_thc = vm.sections[0].mgpml_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].mgpml_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].mgpml_total;
                vm.sections[0].active_unit_frontend = ' mg/ml';
            }
            else if (active_unit == 'mgpp') {
                vm.sections[0].total_thc = vm.sections[0].mgpp_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].mgpp_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].mgpp_total;
                vm.sections[0].active_unit_frontend = ' mg/pkg';
            }
            else if (active_unit == 'mgpu') {
                vm.sections[0].total_thc = vm.sections[0].mgpu_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].mgpu_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].mgpu_total;
                vm.sections[0].active_unit_frontend = ' mg/serving';
            }
            else if (active_unit == 'percent') {
                vm.sections[0].total_thc = vm.sections[0].percent_total_thc;
                vm.sections[0].total_cbd = vm.sections[0].percent_total_cbd;
                vm.sections[0].total_cannabinoids = vm.sections[0].percent_total;
                vm.sections[0].active_unit_frontend = '%';
            }
            drawCannabinoidChart('resize');
        }

        vm.cannabinoidAnalyteNameMap = {
            s8thc_: 'δ8 THC',
            s9thc_: 'δ9 THC',
            thca_: 'THCA',
            thcv_: 'THCV',
            thcva_: 'THCVA',
            cbd_: 'CBD',
            cbda_: 'CBDA',
            cbdv_: 'CBDV',
            cbn_: 'CBN',
            cbg_: 'CBG',
            cbc_: 'CBC',
            cbga_: 'CBGA',
            cbca_: 'CBCA',
            cbdva_: 'CBDVA',
            cbl_: 'CBL',
            cbt_: 'CBT',
            s8_thcv_: 'δ8 THCV',
            _9r_hexahydrocannabinol_: '9(R)-HHC',            
            _9s_hexahydrocannabinol_: '9(S)-HHC',
            _9r_hhc_acetate_:'9(R)-HHC Acetate',
            _9s_hhc_acetate_:'9(S)-HHC Acetate',
            _1r_thd_: '1(R)-THD',
            _1s_thd_: '1(S)-THD',
            d9_thcb_: 'δ9 THCB',
            d9_thch_: 'δ9 THCH',
            _9r_hhcp_: '9(R)-HHCP',
            _9s_hhcp_: '9(S)-HHCP',
            _9r_hhch_: '9(R)-HHCH',
            _9s_hhch_: '9(S)-HHCH',
            d8_thco_ : 'δ8-THCO',
            _9r_hhco_: '9(R)-HHCO',
            _9s_hhco_: '9(S)-HHCO'
        }

        vm.cannabinoidUnitMap = {
            dry_percent: '% (dry)',
            percent: '%',
            dry_mgpg: 'mg/g',
            mgpg: 'mg/g',
            mgpml: 'mg/ml',
            mgpu: 'mg/serving',
            mgpp: 'mg/pkg'
        }

        vm.cannabinoidColorMap = {
            s8thc_: '#33699a',
            s9thc_: '#4f91cd',
            thca_: '#5db2ff',
            thcv_: '#93ccff',
            thcva_: '#f5b54e',
            cbd_: '#ffd35e',
            cbda_: '#f7cb56',
            cbdv_: '#d4602a',
            cbn_: '#e88050',
            cbg_: '#e99f7c',
            cbc_: '#fab596',
            cbga_: '#33699a',
            cbca_: '#4f91cd',
            s8_thcv_: '#008c47',
            cbca_: '#006b2a',
            cbdva_: '#008844',
            cbl_: '#69f2a4',
            cbt_: '#00a272',
            s8_thcv_: '#d42000',
            _9r_hexahydrocannabinol_: '#8a2a00',            
            _9s_hexahydrocannabinol_: '#cb1515',
            _9r_hhc_acetate_:'#f25555',
            _9s_hhc_acetate_:'#e33b3b',
            _1r_thd_: '#d5231c',
            _1s_thd_: '#bd3600',
            d9_thcb_: '#007a00',
            d9_thch_: '#ab0707',
            _9r_hhcp_: '#cc3623',
            _9s_hhcp_: '#a3160b',
            _9r_hhch_: '#22853e',
            _9s_hhch_: '#2dc257',
            d8_thco_ : '#7ca387',
            _9r_hhco_: '#2d7040',
            _9s_hhco_: '#7de39a'
        }

        vm.cannabinoidsUserToUnitMap = {
            dry_percent: '% (dry)',
            percent:  '%',
            dry_mgpg:' mg/g (dry)',
            mgpg: ' mg/g',
            mgpml: 'mg/ml',
            mgpu: 'mg/serving',
            mgpp: 'mg/pkg'
        }

        function drawCannabinoidChart(method) {
            var data = new google.visualization.DataTable();
            var counter = 0;

            do {
                data = new google.visualization.DataTable();
                counter++;
            } while(!data && counter < 100);

            data.addColumn('string', 'Status');
            data.addColumn('number', 'Count');

            // var colors = [
            //     '#33699a',
            //     '#4f91cd',
            //     '#5db2ff',
            //     '#93ccff',
            //     '#9ab567',
            //     '#f5b54e',
            //     '#ffd35e',
            //     '#f7cb56',
            //     '#d4602a',
            //     '#e88050',
            //     '#e99f7c',
            //     '#fab596',
            // ];
            var colors = vm.cannabinoidChartColorArray

            vm.sections[0].section_data[vm.sections[0].active_unit].forEach( function(analyte) {
                data.addRow([
                    analyte.name,
                    parseFloat(analyte.value)
                ]);
            });

            var options = {
                backgroundColor: 'transparent',
                pieHole: 0.7,
                pieSliceText: 'value',
                pieSliceTextStyle: {
                    color: 'black',
                    fontSize: 1,
                    opacity: 0, // hides text on chart
                    visibility: 'hidden'  // hides text on chart
                },
                tooltip: {
                    text: 'value'
                },
                chartArea: {
                    // top: auto,
                    // right: ,
                    width: '100%',
                    height: '100%'
                },
                height: '100%',
                width: '100%',
                legend: 'none',
                colors: colors
            };

            var formatter = new google.visualization.NumberFormat({
                fractionDigits: 2,
                suffix: vm.sections[0].active_unit_frontend
            });

            formatter.format(data, 1);
			if(data.getNumberOfRows() != 0) {
                if(vm.showWideView) {
                    var chart = null;
                    if(method == 'first_load') {
                        while($('#new-pie-chart').children().length == 0) {
                            chart = new google.visualization.PieChart(angular.element('#new-pie-chart')[0]);
                            chart.draw(data, options);
                        }
                    }
                    else {
                        chart = new google.visualization.PieChart(angular.element('#new-pie-chart')[0]);
                        chart.draw(data, options);
                    }
                }
                else if(vm.showTallView) {
                    var mobileChart = null;

                    if(method == 'first_load') {
                        while($('#mobile-view-cannabis-chart').children().length == 0) {
                            mobileChart = new google.visualization.PieChart(angular.element('#mobile-view-cannabis-chart')[0]);
                            mobileChart.draw(data, options);
                        }
                    }
                    else {
                        mobileChart = new google.visualization.PieChart(angular.element('#mobile-view-cannabis-chart')[0]);
                        mobileChart.draw(data, options);
                    }
                }
			}
        }

        function createTerpenesMap() {
            vm.terpenesMap =  {};
            //GREEN
            vm.terpenesMap["terpinolene"] = {
                slice: 'green',
                color: '#669A8B',
                position: 1
            };
            vm.terpenesMap["eudesmol"] = {
                slice: 'green',
                color: '#669A8B',
                position: 2
            };
            vm.terpenesMap["α-pinene"] = {
                slice: 'green',
                color: '#669A8B',
                position: 3
            };
            vm.terpenesMap["β-pinene"] = {
                slice: 'green',
                color: '#669A8B',
                position: 4
            };
            vm.terpenesMap["camphene"] = {
                slice: 'green',
                color: '#669A8B',
                position: 5
            };

            // BLUE //
            vm.terpenesMap["eucalyptol"] = {
                slice: 'blue',
                color: '#00BFC6',
                position: 6
            };
            vm.terpenesMap["isopulegol"] = {
                slice: 'blue',
                color: '#00BFC6',
                position: 7
            };
            vm.terpenesMap["menthol"] = {
                slice: 'blue',
                color: '#00BFC6',
                position: 8
            };
            vm.terpenesMap["borneol"] = {
                slice: 'blue',
                color: '#00BFC6',
                position: 9
            };

            // PURPLE //
            vm.terpenesMap["trans-beta-ocimene"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 10
            };
            vm.terpenesMap["cis-beta-ocimene"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 11
            };
            vm.terpenesMap["geraniol"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 12
            };
            vm.terpenesMap["linalool"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 13
            };
            vm.terpenesMap["guaiol"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 14
            };
            vm.terpenesMap["α-bisabolol"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 15
            };
            vm.terpenesMap["α-terpineol"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 16
            };
            vm.terpenesMap["citronellol"] = {
                slice: 'purple',
                color: '#F6DBB9',
                position: 17
            };

            // YELLOW //
            vm.terpenesMap["δ-3-carene"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 18
            };
            vm.terpenesMap["cis-nerolidol"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 19
            };
            vm.terpenesMap["trans-nerolidol"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 20
            };
            vm.terpenesMap["limonene"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 21
            };
            vm.terpenesMap["p-cymene"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 22
            };
            vm.terpenesMap["γ-terpinene"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 23
            };
            vm.terpenesMap["α-terpinene"] = {
                slice: 'yellow',
                color: '#F5B54E',
                position: 24
            };

            // RED //
            vm.terpenesMap["ß-myrcene"] = {
                slice: 'red',
                color: '#FF6A59',
                position: 25
            };
            vm.terpenesMap["caryophylleneoxide"] = {
                slice: 'red',
                color: '#FF6A59',
                position: 26
            };
            vm.terpenesMap["α-humulene"] = {
                slice: 'red',
                color: '#FF6A59',
                position: 27
            };
            vm.terpenesMap["ß-caryophyllene"] = {
                slice: 'red',
                color: '#FF6A59',
                position: 28
            };
        }

        function drawTerpenesChart(method) {
            var section_index = findWithAttr(vm.sections, 'title', 'Terpenoids');
            var analyte_index = null;

            angular.forEach(vm.terpenesMap, function(value, key) {
                analyte_index = findWithAttr(vm.sections[section_index].section_data, 'name', key.toLowerCase());

                if(vm.sections[section_index].section_data[analyte_index].value_exists) {
                    vm.sections[section_index].chart_values[value.slice] = vm.sections[section_index].chart_values[value.slice] + vm.sections[section_index].section_data[analyte_index].value;
                }
            });

            var piney_data = vm.sections[section_index].chart_values.green ? +vm.sections[section_index].chart_values.green.toFixed(2) : 0;
            var minty_data = vm.sections[section_index].chart_values.blue ? +vm.sections[section_index].chart_values.blue.toFixed(2) : 0;
            var sweet_data = vm.sections[section_index].chart_values.purple ? +vm.sections[section_index].chart_values.purple.toFixed(2) : 0;
            var citrus_data = vm.sections[section_index].chart_values.yellow ? +vm.sections[section_index].chart_values.yellow.toFixed(2) : 0;
            var spicy_data = vm.sections[section_index].chart_values.red ? +vm.sections[section_index].chart_values.red.toFixed(2) : 0;

            var data = google.visualization.arrayToDataTable([
                ['Terpenes', 'Percentage'],
                ['Piney', piney_data],
                ['Minty', minty_data],
                ['Sweet', sweet_data],
                ['Citrus', citrus_data],
                ['Spicy', spicy_data]
              ]);

            var colors = [
                '#669A8B',
                '#00BFC6',
                '#F6DBB9',
                '#F5B54E',
                '#FF6A59',
            ]

            var options = {
                backgroundColor: 'transparent',
                pieSliceText: 'none',
                chartArea: {
                    width: '100%',
                    height: '100%'
                },
                height: '100%',
                width: '100%',
                legend: 'none',
                colors: colors
            };

            var formatter = new google.visualization.NumberFormat({
                fractionDigits: 2,
                suffix: '%'
            });

            formatter.format(data, 1);

			if(data.getNumberOfRows() != 0) {
                if(vm.showWideView) {
                    var chart = null;

                    if(method == 'first_load') {
                        while($('#new-terpenes-chart').children().length == 0) {
                            chart = new google.visualization.PieChart(angular.element('#new-terpenes-chart')[0]);
                            chart.draw(data, options);
                        }
                    }
                    else {
                        chart = new google.visualization.PieChart(angular.element('#new-terpenes-chart')[0]);
                        chart.draw(data, options);
                    }
                }
                else if(vm.showTallView) {
                    var mobileChart = null;

                    if(method == 'first_load') {
                        while($('#mobile-view-terpenes-chart').children().length == 0) {
                            mobileChart = new google.visualization.PieChart(angular.element('#mobile-view-terpenes-chart')[0]);
                            mobileChart.draw(data, options);
                        }
                    }
                    else {
                        mobileChart = new google.visualization.PieChart(angular.element('#mobile-view-terpenes-chart')[0]);
                        mobileChart.draw(data, options);
                    }
                }
            }
        }

        function alkaloidNameMap(key) {
            var to_return = '';

            if(key.includes('seven_hydroxymitragynine')) {
                to_return  = "7-Hydroxymitragynine";
            }
            else if(key.includes('mitragynine')) {
                to_return  = "Mitragynine";
            }
            else if(key.includes('total_alkaloids')) {
                to_return  = "Total Alkaloids";
            }

            return to_return;
        }

        function generateParsers() {
            parsers.user_configurable = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                if(ws) {
                    test_pf = ws.overall_pf.value;
                }
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                angular.forEach(ws, function(value, key) {
                    if(value.display_name && value.value) {
                        vm.sections[section_index].section_data.push({
                            name: value.display_name ? value.display_name : '',
                            value: value.calculated_value ? value.calculated_value : '',
                            units: determineUnits(null, units),
                            value_exists: unitsRequired(value.twoDecimalFormattedValue),
                            limit: value.limit ? value.limit : '',
                            lod: value.lod ? value.lod : '',
                            loq: value.loq ? value.loq : '',
                            method:  value.method ? value.method : '',
                            status: value.status ? value.status : '',
                        });
                    }
                });
            }
            parsers.dynamic = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);
                var to_push = {};

                angular.forEach(ws, function(value, key) {
                    if(isDynamicAnalyte(key)) {
                        to_push = {
                            name: value.value ? value.value : '',
                            value: parseValueObject(ws[key + '_finding']),
                            units: ws[key + '_units'] ? ws[key + '_units'].value : '',
                            value_exists: ws[key + '_finding'] ? unitsRequired(ws[key + '_finding'].value) : '',
                            lod: ws[key + '_lod'] ? ws[key + '_lod'].value : '',
                            loq: ws[key + '_loq'] ? ws[key + '_loq'].value : '',
                            method: ws[key + '_method'] ? ws[key + '_method'].value : '',
                            limit: ws[key + '_limit'] ? ws[key + '_limit'].value : '',
                        }

                        if(section_index == -1 && to_push.value_exists) {
                            vm.sections.push({
                                title : category,
                                description : null,
                                pf_values: [test_pf],
                                overall_pf: null,
                                section_data : [to_push],
                                expanded : false,
                                acive: false,
                                info_box_open: false,
                                instrument: [instrument],
                                complete_date: [complete_date],
                                estimated_complete_date: [estimated_complete_date]
                            });
                        }
                        else if(to_push.value_exists) {
                            vm.sections[section_index].pf_values.push(test_pf);
                            vm.sections[section_index].section_data.push(to_push);
                        }
                    }
                });
            }
            parsers.heavy_metals = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                angular.forEach(ws, function(value, key) {
                    if(value.display_name && value.value) {
                        vm.sections[section_index].section_data.push({
                            name: value.display_name ? value.display_name : '',
                            value: parseValueObject(value),
                            units: determineUnits(value.units, units),
                            value_exists: unitsRequired(value.twoDecimalFormattedValue),
                            limit: ws[key + '_limit'] ? ws[key + '_limit'].value : '',
                            lod: ws[key + '_lod'] ? ws[key + '_lod'].value : '',
                            loq: ws[key + '_loq'] ? ws[key + '_loq'].value : '',
                            method:  ws[key + '_method'] ? ws[key + '_method'].value : '',
                            status: ws[key + '_pf'] ? ws[key + '_pf'].value : ''
                        });
                    }
                });
            }
            parsers.consulting = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                for(var i = 1; i < 21; i++) {
                    if(ws['analyte_' + i].value) {
                        vm.sections[section_index].section_data.push({
                            name: ws['analyte_' + i].value ? ws['analyte_' + i].value : '',
                            value: ws['findings_' + i].twoDecimalFormattedValue ? parseValue(ws['findings_' + i].twoDecimalFormattedValue) : '',
                            units: unitsRequired(ws['units_' + i].value) ? determineUnits(ws['units_' + i].value, units)  : '',
                            value_exists: unitsRequired(ws['units_' + i].value),
                            limit: ws['limit_' + i].value ? ws['limit_' + i].value : '',
                            lod: ws['lod_' + i].value ? ws['lod_1' + i].value : '',
                            loq: ws['loq_' + i].value ? ws['loq_' + i].value : '',
                            method: ws['method_' + i].value ? ws['method_' + i].value : '',
                        });
                    }
                }
            }
            parsers.generic_food = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                if(ws.findings) {
                    vm.sections[section_index].section_data.push({
                        name: ws.analyte.value,
                        value: ws.findings.twoDecimalFormattedValue ? parseValue(ws.findings.twoDecimalFormattedValue) : '',
                        units: unitsRequired(ws.findings.twoDecimalFormattedValue) ? determineUnits(ws.units.value, units) : '',
                        value_exists: unitsRequired(ws.findings.twoDecimalFormattedValue),
                        limit: '',
                        lod: ws['lod'].value ? ws['lod'].value : '',
                        loq: ws['loq'].value ? ws['loq'].value : '',
                        method: '',
                        status: ws['status'] ? ws['status'].value : ''
                    });
                }
            }
            parsers.vitamin_e = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                if(ws.findings) {
                    vm.sections[section_index].section_data.push({
                        name: 'Vitamin E Acetate',
                        value: ws.findings.twoDecimalFormattedValue ? parseValue(ws.findings.twoDecimalFormattedValue) : '',
                        units: units ? units : 'ppm',
                        value_exists: unitsRequired(ws.findings.twoDecimalFormattedValue)
                    });
                }
            }
            parsers.terpenes = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                createTerpenesMap();
                var section_index = findWithAttr(vm.sections, 'title', category);

                if(section_index == -1) {
                    vm.sections.push({
                        title : category,
                        description : null,
                        overall_pf : null,
                        section_data : [],
                        pf_values: [test_pf],
                        show_results: [show_result],
                        instrument: [instrument],
                        complete_date: [complete_date],
                        estimated_complete_date: [estimated_complete_date],
                        expanded : false,
                        active: false,
                        info_box_open: false,
                        chart_values : {
                            blue: 0,
                            green: 0,
                            yellow: 0,
                            purple: 0,
                            red: 0,
                        }
                    });
                    section_index = vm.sections.length - 1;
                }
                else {
                    vm.sections[section_index].pf_values.push(test_pf);
                }


                var analytes = []
                angular.forEach(ws, function(value, key) {
                    if(value.display_name && value.default_value) {
                        analytes.push({
                            key : key,
                            display_name: value.display_name
                        });
                    }
                });
                analytes.forEach( function(analyte) {
                    if(ws[analyte.key]) {
                        try {
                            vm.sections[section_index].section_data.push({
                                name: analyte.display_name ? analyte.display_name : '',
                                value: parseValue(ws[analyte.key].value),
                                units: unitsRequired(ws[analyte.key].value) ? '%' : '',
                                value_exists: unitsRequired(ws[analyte.key].value),
                                color: analyte.display_name ? { "background-color": vm.terpenesMap[analyte.display_name.toLowerCase()].color } :  { "background-color": '#3a516c' },
                                position: analyte.display_name ? vm.terpenesMap[analyte.display_name.toLowerCase()].position : null
                            });
                        }
                        catch(err) {
                            console.error("Error trying to parse terpenes: " + err);
                            console.error(analyte)
                        }
                    }
                });

                if(ws['total_terpenes']) {
                    vm.sections[section_index].total_terpenes = ws['total_terpenes'].twoDecimalFormattedValue
                }

                vm.sections[section_index].section_data.sort( function(a, b) {
                        return a.position - b.position;
                });

                vm.terpenesTested = true;
            }
            parsers.usp_61_62 = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                microParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.moisture = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findWithAttr(vm.sections, 'title', category);

                if(section_index == -1) {
                    vm.sections.push({
                        title : category,
                        description : null,
                        overall_pf : null,
                        section_data : [],
                        pf_values: [test_pf],
                        show_results: [show_result],
                        expanded : false,
                        active: false,
                        info_box_open: false,
                        instrument: [instrument],
                        complete_date: [complete_date],
                        estimated_complete_date: [estimated_complete_date]
                    });
                    section_index = vm.sections.length - 1;
                }
                else {
                    vm.sections[section_index].pf_values.push(test_pf);
                }

                if(ws.moisture) {
                    if(ws.moisture.value) {
                        vm.sections[section_index].section_data.push({
                            name: ws.moisture.display_name ? ws.moisture.display_name : '',
                            value: ws.moisture.value ? parseValue(ws.moisture.value) : '',
                            units: units ? units : '',
                            value_exists: unitsRequired(ws.moisture.value)
                        });
                    }
                }

                vm.moistureTested = true;
            }
            parsers.mycotoxins = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.microbiology = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.foreign_materials = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.yeast_mold = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                microParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.residual_solvents = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.pesticides = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                angular.forEach(ws, function(value, key) {
                    if(key.includes('_asterisk')) {
                       delete ws[key];
                    }
                });

                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
            parsers.pesticides_mycotoxins = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                vm.pesticidesMycotoxins.tested = true;
                var mycotoxins_ws = {
                    aflatoxin_b1: ws['aflatoxin_b1'] ? ws['aflatoxin_b1'] : '',
                    aflatoxin_b2: ws['aflatoxin_b2'] ? ws['aflatoxin_b2'] : '',
                    aflatoxin_g1: ws['aflatoxin_g1'] ? ws['aflatoxin_g1'] : '',
                    aflatoxin_g2: ws['aflatoxin_g2'] ? ws['aflatoxin_g2'] : '',
                    ochratoxin_a: ws['ochratoxin_a'] ? ws['ochratoxin_a'] : '',
                    ochratoxin_a_limit: {value: vm.pesticidesMycotoxins.ochratoxin_a_limit},
                    ochratoxin_a_pf: ws['ochratoxin_a_pf'] ? ws['ochratoxin_a_pf'] : '',
                    total_aflatoxins: ws['total_aflatoxins'] ? ws['total_aflatoxins'] : '',
                    total_aflatoxins_limit: {value: vm.pesticidesMycotoxins.total_aflatoxins_limit},
                    total_aflatoxins_pf: ws['total_aflatoxins_pf'] ? ws['total_aflatoxins_pf'] : '',
                };

                var mycotoxins_pf = 'in_progress';
                if(ws['overall_pf'] && ws['overall_pf'].value && ws['overall_pf'].value.toLowerCase()) {
                    mycotoxins_pf = ws['overall_pf'].value.toLowerCase();
                }

                var pesticides_pf = 'in_progress';
                if(ws['overall_pf'] && ws['overall_pf_phase2'].value && ws['overall_pf_phase2'].value.toLowerCase()) {
                    pesticides_pf = ws['overall_pf_phase2'].value.toLowerCase();
                }

                if(mycotoxins_pf) delete ws['overall_pf'];
                if(ws['aflatoxin_b1']) delete ws['aflatoxin_b1'];
                if(ws['aflatoxin_b2']) delete ws['aflatoxin_b2'];
                if(ws['aflatoxin_g1']) delete ws['aflatoxin_g1'];
                if(ws['aflatoxin_g2']) delete ws['aflatoxin_g2'];
                if(ws['ochratoxin_a']) delete ws['ochratoxin_a'];
                if(ws['ochratoxin_a_pf']) delete ws['ochratoxin_a_pf'];
                if(ws['total_aflatoxins']) delete ws['total_aflatoxins'];
                if(ws['total_aflatoxins_pf']) delete ws['total_aflatoxins_pf'];

                angular.forEach(ws, function(value, key) {
                    if(key.includes('_asterisk')) {
                       delete ws[key];
                    }
                });

                vm.pesticidesMycotoxins.loq_mycotoxins = ws['loq_mycotoxins'] ? ws['loq_mycotoxins'].value : '';
                vm.pesticidesMycotoxins.loq_pesticides = ws['loq_pesticides'] ? ws['loq_pesticides'].value : '';

                generalParser(mycotoxins_ws, 'Mycotoxins', mycotoxins_pf, '', show_result, '', complete_date, estimated_complete_date, assay);
                generalParser(ws, 'Pesticides', pesticides_pf, '', show_result, '', complete_date, estimated_complete_date, assay);
            }
            parsers.alkaloid = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                var section_index = findSection(category, test_pf, show_result, instrument, complete_date, estimated_complete_date);

                var prefixes = ['mitragynine_', 'seven_hydroxymitragynine_', 'total_alkaloids_'];
                var suffixes = ['percent', 'mgml', 'mgpg', 'mgps']
                var to_push = {};

                prefixes.forEach( function(prefix) {
                    suffixes.forEach( function(suffix) {
                        to_push = {
                            name: ws[prefix + suffix] ? alkaloidNameMap(prefix) : '',
                            value: ws[prefix + suffix] ? parseValue(ws[prefix + suffix].value) : '',
                            units: ws[prefix + suffix] ? ws[prefix + suffix].units : '',
                            value_exists: ws[prefix + suffix] ? parseValue(ws[prefix + suffix].value) : '',
                            limit: ws['limit'] ? ws['limit'].value : '',
                            lod: ws['lod'] ? ws['lod'].value : '',
                            loq: ws['loq'] ? ws['loq'].value : '',
                            method:  ws['method'] ? ws['method'].value : '',
                            status: ws[prefix + suffix + '_pf'] ? ws[prefix + suffix + '_pf'].value : ''
                        }

                        if(to_push.value_exists) {
                            vm.sections[section_index].section_data.push(to_push);
                        }
                    })
                })

            }
            parsers.cannabinoid_profile = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                // Update the description in the sectionDescriptionMap if we have an assay description
                if (assay && assay.analysis_description) {
                    vm.sectionDescriptionMap['Cannabis'] = assay.analysis_description;
                }
                var section_index = 0;
                var analyte_value = '';
                var moisture_tested = '';
                var no_value = ['ND', 'nd', 'nt', 'NT', 'bloq', 'BLOQ', 0, 0.00, '0', '0.00'];
                var cannabinoid_section = {
                    title : category,
                    description : assay && assay.analysis_description ? assay.analysis_description : 'Full spectrum cannabinoid profiling and analysis utilizing High Performance Liquid Chromatography (HPLC/UV).',
                    overall_pf : null,
                    section_data : [],
                    pf_values: [test_pf],
                    show_results: [show_result],
                    instrument: [instrument],
                    complete_date: [complete_date],
                    estimated_complete_date: [estimated_complete_date],
                    expanded : false,
                    active: false,
                    info_box_open: false,
                    active_unit: null,
                    dry_percent_exists: false,
                    percent_exists: false,
                    dry_mgpg_exists: false,
                    mgpg_exists: false,
                    mgpml_exists: false,
                    mgpu_exists: false,
                    mgpp_exists: false,

                    dry_percent_total_thc: null,
                    percent_total_thc: null,
                    dry_mgpg_total_thc: null,
                    mgpg_total_thc: null,
                    mgpml_total_thc: null,
                    mgpu_total_thc: null,
                    mgpp_total_thc: null,

                    dry_percent_total_cbd: null,
                    percent_total_cbd: null,
                    dry_mgpg_total_cbd: null,
                    mgpg_total_cbd: null,
                    mgpml_total_cbd: null,
                    mgpu_total_cbd: null,
                    mgpp_total_cbd: null,

                    dry_percent_total: null,
                    percent_total: null,
                    dry_mgpg_total: null,
                    mgpg_total: null,
                    mgpml_total: null,
                    mgpu_total: null,
                    mgpp_total: null,

                    total_cannabinoids: null,
                }

                if(vm.sections) {
                    vm.sections.unshift(cannabinoid_section);
                }
                else {
                    vm.sections.push(cannabinoid_section)
                }

                var prefixes = [
                    's8thc_', 's9thc_', 'thca_', 'thcv_',
                    'thcva_', 'cbd_', 'cbda_', 'cbdv_',
                    'cbn_', 'cbg_', 'cbc_', 'cbga_', 'cbca_',
                    'cbdva_','cbl_','cbt_','s8_thcv_','_9r_hexahydrocannabinol_',
                    '_9s_hexahydrocannabinol_','_9r_hhc_acetate_','_9s_hhc_acetate_','_1r_thd_','_1s_thd_','d9_thcb_',
                    'd9_thch_','_9r_hhcp_','_9s_hhcp_','_9r_hhch_','_9s_hhch_',
                    'd8_thco_', 'd8_thco_', '_9r_hhco_', '_9s_hhco_'
                ];

                var suffixes = [
                    'dry_percent', 'percent', 'dry_mgpg',
                    'mgpml', 'mgpu', 'mgpp', 'mgpg'
                ]

                vm.cannabinoidChartColorArray = []
                suffixes.forEach( function(suffix) {
                    vm.sections[section_index].section_data[suffix] = [];
                    prefixes.forEach( function(prefix) {
                        analyte_value = 0.00;
                        if(ws[prefix + suffix]) {
                            if(ws[prefix + suffix].twoDecimalFormattedValue) {
                                analyte_value = parseValue(ws[prefix + suffix].twoDecimalFormattedValue);
                            }
                        }
                        vm.cannabinoidChartColorArray.push(vm.cannabinoidColorMap[prefix])
                        vm.sections[section_index].section_data[suffix].push({
                            name: vm.cannabinoidAnalyteNameMap[prefix],
                            value: analyte_value,
                            value_exists: no_value.includes(analyte_value) ? false : true,
                            units: vm.cannabinoidsUserToUnitMap[suffix],
                            color: { 'background-color' : vm.cannabinoidColorMap[prefix] }
                        });
                    });
                });

                if(ws) {
                    vm.sections[section_index].overall_pf = test_pf;

                    if(ws.moisture) {
                        if(ws.moisture.value) {
                            if (ws.moisture.value == '0' || isNaN(ws.moisture.value)){
                                moisture_tested = false;
                            }
                            else {
                                moisture_tested = true;
                            }
                        }
                    }

                    if(ws.total_mgpp) {
                        if(ws.total_mgpp.twoDecimalFormattedValue) {
                        vm.sections[section_index].mgpp_exists = true;
                        vm.sections[section_index].mgpp_total_thc = ws['total_thc_mgpp'] ? ws['total_thc_mgpp'].twoDecimalFormattedValue : '';
                        vm.sections[section_index].mgpp_total_cbd = ws['total_cbd_mgpp'] ? ws['total_cbd_mgpp'].twoDecimalFormattedValue : '';
                        vm.sections[section_index].mgpp_total = ws['total_mgpp'] ? ws['total_mgpp'].twoDecimalFormattedValue : '';

                        if(!vm.sections[section_index].active_unit) {
                            vm.sections[section_index].active_unit = 'mgpp';
                            vm.sections[section_index].active_unit_frontend = ' mg/pkg';
                        }

                        if(!vm.sections[section_index].total_thc) {
                            vm.sections[section_index].total_thc = vm.sections[section_index].mgpp_total_thc;
                        }

                        if(!vm.sections[section_index].total_cbd) {
                            vm.sections[section_index].total_cbd = vm.sections[section_index].mgpp_total_cbd;
                        }

                        if(!vm.sections[section_index].total_cannabinoids) {
                            vm.sections[section_index].total_cannabinoids = vm.sections[section_index].mgpp_total
                        }
                        }
                    }
                    if(ws.total_dry_percent && moisture_tested) {
                        if(ws.total_dry_percent.twoDecimalFormattedValue) {
                            vm.sections[section_index].dry_percent_exists = true;
                            vm.sections[section_index].dry_percent_total_thc = ws['total_thc_dry_percent'] ? ws['total_thc_dry_percent'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].dry_percent_total_cbd =ws['total_cbd_dry_percent'] ? ws['total_cbd_dry_percent'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].dry_percent_total = ws['total_dry_percent'] ? ws['total_dry_percent'].twoDecimalFormattedValue : '';


                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'dry_percent';
                                vm.sections[section_index].active_unit_frontend = '% (dry)';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].dry_percent_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].dry_percent_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].dry_percent_total;
                            }
                        }
                    }
                    if(ws.total_dry_mgpg && moisture_tested) {
                        if(ws.total_dry_mgpg.twoDecimalFormattedValue) {
                            vm.sections[section_index].dry_mgpg_exists = true;
                            vm.sections[section_index].dry_mgpg_total_thc = ws['total_thc_dry_mgpg'] ? ws['total_thc_dry_mgpg'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].dry_mgpg_total_cbd = ws['total_cbd_dry_mgpg'] ? ws['total_cbd_dry_mgpg'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].dry_mgpg_total = ws['total_dry_mgpg'] ? ws['total_dry_mgpg'].twoDecimalFormattedValue : '';

                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'dry_mgpg';
                                vm.sections[section_index].active_unit_frontend = ' mg/g (dry)';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].dry_mgpg_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].dry_mgpg_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].dry_mgpg_total
                            }
                        }
                    }
                    if(ws.total_mgpg) {
                        if(ws.total_mgpg.twoDecimalFormattedValue) {
                            vm.sections[section_index].mgpg_exists = true;
                            vm.sections[section_index].mgpg_total_thc = ws['total_thc_mgpg'] ? ws['total_thc_mgpg'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpg_total_cbd = ws['total_cbd_mgpg'] ? ws['total_cbd_mgpg'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpg_total = ws['total_mgpg'] ? ws['total_mgpg'].twoDecimalFormattedValue : '';

                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'mgpg';
                                vm.sections[section_index].active_unit_frontend = ' mg/g';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].mgpg_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].mgpg_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].mgpg_total
                            }
                        }
                    }

                    if(ws.total_percent) {
                        if(ws.total_percent.twoDecimalFormattedValue) {
                            vm.sections[section_index].percent_exists = true;
                            vm.sections[section_index].percent_total_thc = ws['total_thc_percent'] ? ws['total_thc_percent'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].percent_total_cbd = ws['total_cbd_percent'] ? ws['total_cbd_percent'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].percent_total = ws['total_percent'] ? ws['total_percent'].twoDecimalFormattedValue : ''

                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'percent';
                                vm.sections[section_index].active_unit_frontend = '%';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].percent_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].percent_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].percent_total;
                            }
                        }
                    }
                    if(ws.total_mgpml) {
                        if(ws.total_mgpml.twoDecimalFormattedValue) {
                            vm.sections[section_index].mgpml_exists = true;
                            vm.sections[section_index].mgpml_total_thc = ws['total_thc_mgpml'] ? ws['total_thc_mgpml'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpml_total_cbd = ws['total_cbd_mgpml'] ? ws['total_cbd_mgpml'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpml_total = ws['total_mgpml'] ? ws['total_mgpml'].twoDecimalFormattedValue : '';

                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'mgpml';
                                vm.sections[section_index].active_unit_frontend = ' mg/ml';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].mgpml_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].mgpml_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].mgpml_total;
                            }
                        }
                    }
                    if(ws.total_mgpu) {
                        if(ws.total_mgpu.twoDecimalFormattedValue) {
                            vm.sections[section_index].mgpu_exists = true;
                            vm.sections[section_index].mgpu_total_thc = ws['total_thc_mgpu'] ? ws['total_thc_mgpu'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpu_total_cbd = ws['total_cbd_mgpu'] ? ws['total_cbd_mgpu'].twoDecimalFormattedValue : '';
                            vm.sections[section_index].mgpu_total = ws['total_mgpu'] ? ws['total_mgpu'].twoDecimalFormattedValue : '';

                            if(!vm.sections[section_index].active_unit) {
                                vm.sections[section_index].active_unit = 'mgpu';
                                vm.sections[section_index].active_unit_frontend = ' mg/serving';
                            }

                            if(!vm.sections[section_index].total_thc) {
                                vm.sections[section_index].total_thc = vm.sections[section_index].mgpu_total_thc;
                            }

                            if(!vm.sections[section_index].total_cbd) {
                                vm.sections[section_index].total_cbd = vm.sections[section_index].mgpu_total_cbd;
                            }

                            if(!vm.sections[section_index].total_cannabinoids) {
                                vm.sections[section_index].total_cannabinoids = vm.sections[section_index].mgpu_total;
                            }
                        }
                    }

                }
                console.log(vm.sections[section_index],"vm.sections[section_index]======");
                if(!vm.sections[section_index].overall_pf) vm.sections[section_index].overall_pf = 'in_progress';
                vm.cannabinoidsTested = vm.sections[section_index].overall_pf == 'in_progress' ? false : true;
            }
            parsers.homogeneity = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
                angular.noop;
            }
            parsers.water_activity = function(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
                generalParser(ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
            }
        }

        function parseWorksheet(ws_id, ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay) {
            angular.forEach(vm.parserMap, function(value, key) {
                if(value.includes(ws_id)) {
                    try {
                        parsers[key](ws, category, test_pf, units, show_result, instrument, complete_date, estimated_complete_date, assay);
                    }
                    catch(e) {
                        console.log('Error occured while parsing worksheet id: ', ws_id, category, ws, e);
                    }
                }
            });
        }

        function checkPotencyAndTerpenes() {
            if(angular.equals({}, vm.sample.potencyProfile)) {
                vm.sample.potencyProfile = false;
            }
            if(angular.equals({}, vm.sample.terpeneProfile)) {
                vm.sample.terpeneProfile = false;
            }
        }

        vm.sample = {
                name: null,
                company: null,
                id: null,
                sampleWeight: null,
                sampleType: null,
                starred: null,
                date: null,
                potencyProfile: {},
                terpeneProfile: {},
                canSeeReport: false
        };

        vm[POTENCY] = null;
        vm[TERPENES] = null;

        $scope.collapse = {
                potencyProfile: true,
                terpeneProfile: true,
        };

        if (data) {
        	for (var i = 0; i < data.sampleTests.length; i++){
        		var test = data.sampleTests[i];
        		if (!test.assay) continue;
        		if (test.worksheetData == null) test.worksheetData = {};

        		switch(test.assay.portalIdentifier) {
	        		case "POTENCY_GCFID":
	        		case "POTENCY_LCDAD":
	        		case "POTENCY_LCDAD_NON_PLANT":
	        		case "POTENCY_LCMSMS": setPotencyData(test); break;

	        		case "TERPENE_PROFILE": setTerpeneProfileData(test); break;
	        		default:
	        			if (test.assay.portal_section == "Terpenes") {
	        				setTerpeneProfileData(test);
                        }
	        			break;
        		}
            }
        }

        /* Set paging links (next/previous buttons) */
        vm.prevNext = {prev:null, next:null};
        vm.queryParams = {
        		page: $stateParams.page,
        		size: $stateParams.size,
        		sort: $stateParams.sort,
        		search: $stateParams.search,
        		productCategoryId: $stateParams.productCategoryId
        };
        vm.prevPage = parseInt(vm.queryParams.page);
        vm.nextPage = parseInt(vm.queryParams.page);

        vm.customerType = "";

        CustomerByOrder.get({orderId: data.customerOrderId}).$promise.then(function(c){
            vm.customer = c;
    		var type_of_business = c.businessType.name.toLowerCase();
            
            try {
                vm.customerType = c.businessType.name;
            }
            catch (error) {
                console.log(error);
            }
            
            if (type_of_business.includes('food')) {
                vm.customer.consolidated_business_type = 'food';
            }
            else if (type_of_business.includes('cannabis')) {
                vm.customer.consolidated_business_type = 'cannabis';
            }
            else if (type_of_business.includes('hemp')) {
                vm.customer.consolidated_business_type = 'hemp';
            }
            else if (type_of_business.includes('kratom')) {
                vm.customer.consolidated_business_type = 'kratom';
            }
            else {
                vm.customer.consolidated_business_type = 'cannabis';
            }
            if(vm.customer.downloadable_file_options){
                vm.customer.canSeeCOASummary = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "coaSummary").selected
                vm.customer.canSeeQRcode = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "qrCode").selected
                vm.customer.canSeeConsolidatedCOA = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "consolidatedCoa").selected
                vm.customer.canSeeTestCOA = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "testCoa").selected
                vm.customer.canSeePictures = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "pictures").selected
                vm.customer.canSeeAll = JSON.parse(vm.customer.downloadable_file_options).find(e => e.value == "all").selected
            }
            updateAttachmentVisibility();
        	if (c.logo) {
                vm.companyLogo = 'images/logo/' + vm.customer.logo;
        	}
        	if (c.address !== ',,,, ') {
                var splits = c.address.split('@');
        		vm.customerStreet = splits[0] ? splits[0].trim() : null;
        		vm.customerCity = splits[1] ? splits[1].trim() : null;
        		vm.customerState = splits[2] ? splits[2].trim() : null;
        		vm.customerCountry = splits[3] ? splits[3].trim() : null;
        		vm.customerZip = splits[4] ? splits[4].trim() : null;
                
        		if (vm.customerStreet || vm.customerCity || vm.customerState || vm.customerZip){
                    c.address = vm.customerStreet + ', ' + vm.customerCity + ' ' + vm.customerState + ', ' + vm.customerZip;
        		} else {
                    c.address = null;
        		}
                
                
        		vm.mapImageUrl = "/api/public/customers/" + c.id + "/map";
        	}
            
        	// If user is not signed in, set current customer being viewed
        	if (!$localStorage.authenticationToken || !sessionStorage.authenticationToken) {
                $localStorage.customer = {id: c.id, dbaName: c.dbaName};
        	}
            console.log();
        });
        $scope.toggleStarred = function(id, sample) {
        	Sample.toggleStarred({id: id},onSuccess,onError);

        	function onSuccess (data, headers) {
        		sample.starred = data.starred
        	}

        	function onError(error) {

		    }
        }

        function getPrevNextData(params, getPrev, getNext) {
        	var urlParams = {};
            if (params.page) urlParams.page = params.page - 1;
            if (params.size) urlParams.size = params.size;
            if (params.sort) urlParams.sort = params.sort;
            if (params.search) {
            	urlParams.query = params.search;
            } else if (params.productCategoryId) {
            	urlParams.productCategoryId = params.productCategoryId;
            }

            if (urlParams.query) {
                SampleSearch.query(urlParams, function(samples){
                	setPrevNext(samples, params, getPrev, getNext);
                }, function(error){
                    console.log(error);
                });
            } else {
                 return Sample.query(urlParams, function(samples){
                 	setPrevNext(samples, params, getPrev, getNext);
                 }, function(error){
                     console.log(error);
                 });
            }
        }

        function setPrevNext(samples, params, getPrev, getNext) {
        	var sampleHash = data.hash;
        	if (samples) {
        		if (getPrev) {
        			if (samples.length > 0) {
                        vm.prevNext.prev = samples[samples.length - 1].hash;
        			}
        		} else if (getNext) {
        			if (samples.length > 0) {
                        vm.prevNext.next = samples[0].hash;
        			}
        		} else {
            		for (var i = 0; i < samples.length; i++) {
            			if (samples[i].hash.indexOf(sampleHash) !== -1) {
            				if (i > 0) {
            					vm.prevNext.prev = samples[i-1].hash;
            				} else if (i == 0) {
            					vm.prevPage -= 1;
            					var newParams = angular.copy(params);
            					newParams.page = parseInt(params.page) - 1;
            					if (newParams.page > 0) {
            						getPrevNextData(newParams, true, false);
            					}
            				}
            				if (i+1 < samples.length) {
                                vm.prevNext.next = samples[i+1].hash;
            				} else if (i+1 >= samples.length) {
            					vm.nextPage += 1;
            					var newParams = angular.copy(params);
            					newParams.page = parseInt(params.page) + 1;
            					getPrevNextData(newParams, false, true);
            				}
            			}
            		}
        		}
        	}
        }
        getPrevNextData(vm.queryParams);

        setPageTitle();

        $scope.itemArray = [
            {id: 0, name: 'All', value: 'ALL'},
            {id: 1, name: 'Created', value: 'CREATED'},
            {id: 2, name: 'Samples Received', value: 'SAMPLES_RECEIVED'},
            {id: 3, name: 'Preliminary Results', value: 'PRELIMINARY_RESULTS'},
            {id: 4, name: 'Completed', value: 'COMPLETED'},
            {id: 5, name: 'Invoiced', value: 'INVOICED'}
        ];

        $scope.selected = { value: $scope.itemArray[0] };

        vm.potencyUnit = 'percent';

        vm.setPotencyFields = setPotencyFields;

        function setPageTitle(){
            if( $state.current.name === 'customerPublic') {
                $rootScope.pageTitle = "Customer public page";
            }

            if( $state.current.name === 'public') {
                $rootScope.pageTitle = vm.sample && vm.sample.company ? vm.sample.company : "Sample Results";
            }
        }

        if ($stateParams.hideMenu) {
            vm.hideMenu = true;
            $rootScope.$broadcast('hideMenu');

        }


        vm.togglePotencyUnit = togglePotencyUnit;

        google.charts.load('current', {packages: ['corechart']});

        function setPotencyFields(){

            vm.sample.potencyProfile = {};

            var potencyProfileFields = [];
            if (vm.potencyUnit == 'percent_dry') {

                 potencyProfileFields = [
                    's8thc_dry_percent',
                    's9thc_dry_percent',
                    'thca_dry_percent',
                    'thcv_dry_percent',
                    'thcva_dry_percent',
                    'cbd_dry_percent',
                    'cbda_dry_percent',
                    'cbdv_dry_percent',
                    'cbn_dry_percent',
                    'cbg_dry_percent',
                    'cbc_dry_percent',
                    'cbga_dry_percent',
                    'cbca_dry_percent'
                ];
            }
			else if (vm.potencyUnit == 'percent') {

                 potencyProfileFields = [
                    's8thc_percent',
                    's9thc_percent',
                    'thca_percent',
                    'thcv_percent',
                    'thcva_percent',
                    'cbd_percent',
                    'cbda_percent',
                    'cbdv_percent',
                    'cbn_percent',
                    'cbg_percent',
                    'cbc_percent',
                    'cbga_percent',
                    'cbca_percent'
                ];
            }
            else if (vm.potencyUnit == 'mg/g') {
                potencyProfileFields = [
                    's8thc_dry_mgpg',
                    's9thc_dry_mgpg',
                    'thca_dry_mgpg',
                    'thcv_dry_mgpg',
                    'thcva_dry_mgpg',
                    'cbd_dry_mgpg',
                    'cbda_dry_mgpg',
                    'cbdv_dry_mgpg',
                    'cbn_dry_mgpg',
                    'cbg_dry_mgpg',
                    'cbc_dry_mgpg',
                    'cbga_dry_mgpg',
                    'cbca_dry_mgpg'
                ];
            }
            else if (vm.potencyUnit == 'mg/ml') {
            	potencyProfileFields = [
                    's8thc_mgpml',
                    's9thc_mgpml',
                    'thca_mgpml',
                    'thcv_mgpml',
                    'thcva_mgpml',
                    'cbd_mgpml',
                    'cbda_mgpml',
                    'cbdv_mgpml',
                    'cbn_mgpml',
                    'cbg_mgpml',
                    'cbc_mgpml',
                    'cbga_mgpml',
                    'cbca_mgpml'
                ];
            }
            else if (vm.potencyUnit == 'mg/serving') {
            	potencyProfileFields = [
                    's8thc_mgpu',
                    's9thc_mgpu',
                    'thca_mgpu',
                    'thcv_mgpu',
                    'thcva_mgpu',
                    'cbd_mgpu',
                    'cbda_mgpu',
                    'cbdv_mgpu',
                    'cbn_mgpu',
                    'cbg_mgpu',
                    'cbc_mgpu',
                    'cbga_mgpu',
                    'cbca_mgpu'
                ];
            }
            else if (vm.potencyUnit == 'mg/pkg') {
            	potencyProfileFields = [
                    's8thc_mgpp',
                    's9thc_mgpp',
                    'thca_mgpp',
                    'thcv_mgpp',
                    'thcva_mgpp',
                    'cbd_mgpp',
                    'cbda_mgpp',
                    'cbdv_mgpp',
                    'cbn_mgpp',
                    'cbg_mgpp',
                    'cbc_mgpp',
                    'cbga_mgpp',
                    'cbca_mgpp'
                ];
            }

            if (vm[POTENCY]) {
                potencyProfileFields.forEach(function (item) {
                    if (vm[POTENCY].worksheetData[item]) {

                        vm.sample.potencyProfile[item] = vm[POTENCY].worksheetData[item];

						if (vm[POTENCY].worksheetData[item].value % 1 != 0){
							vm.sample.potencyProfile[item].twoDecimalFormattedValue = fmtTwoDecimals(vm[POTENCY].worksheetData[item]);
						} else {
							vm.sample.potencyProfile[item].twoDecimalFormattedValue = fmtTwoDecimals(vm[POTENCY].worksheetData[item])
						}

                        if (item.includes("s8thc")) {
                        	vm.sample.potencyProfile[item].display_name = '\u03B48 THC';
                        } else if (item.includes("s9thc")) {
                        	vm.sample.potencyProfile[item].display_name = '\u03B49 THC';
                        }

                    }
                });
            }

            checkPotencyAndTerpenes();
        }

        function togglePotencyUnit(){
            drawChart(vm.sample);
        }

		function fmtTwoDecimals(object) {
			if (object){
				if (object.value) {
        			return parseFloat(object.value).toFixed(2);
        		}
				else {
        			return '';
        		}
			}
			return '';
        }

        function drawChart(sample) {

            //moved into separate function so that we can switch units from drop down box
            vm.setPotencyFields();

            var data = new google.visualization.DataTable();

            data.addColumn('string', 'Status');
            data.addColumn('number', 'Count');

            var colors = [
                '#33699a',
                '#4f91cd',
                '#5db2ff',
                '#93ccff',
                '#f5b54e',
                '#ffd35e',
                '#f7cb56',
                '#d4602a',
                '#e88050',
                '#e99f7c',
                '#fab596'
            ];

            for (var i in sample.potencyProfile) {

                if (sample.potencyProfile[i]) {
                    var temp = [];

					if(!sample.potencyProfile[i].display_name){
						if (i.includes("thca_")){
							sample.potencyProfile[i].display_name = 'THCA';
						} else if (i.includes("thcv_")){
							sample.potencyProfile[i].display_name = 'THCV';
						} else if (i.includes("thcva_")){
							sample.potencyProfile[i].display_name = 'THCVA';
						} else if (i.includes("cbd_")){
							sample.potencyProfile[i].display_name = 'CBD';
						} else if (i.includes("cbda_")){
							sample.potencyProfile[i].display_name = 'CBDA';
						} else if (i.includes("cbdv_")){
							sample.potencyProfile[i].display_name = 'CBDV';
						} else if (i.includes("cbn_")){
							sample.potencyProfile[i].display_name = 'CBN';
						} else if (i.includes("cbg_")){
							sample.potencyProfile[i].display_name = 'CBG';
						} else if (i.includes("cbc_")){
							sample.potencyProfile[i].display_name = 'CBC';
						} else if (i.includes("cbga_")){
							sample.potencyProfile[i].display_name = 'CBGA';
						} else if (i.includes("cbca_")){
							sample.potencyProfile[i].display_name = 'CBCA';
						} else {
							sample.potencyProfile[i].display_name = 'ND';
						}
					}

					temp.push(sample.potencyProfile[i].display_name);
					temp.push(parseFloat(sample.potencyProfile[i].value));
                    data.addRow(temp);
                }
            }

            var options = {
                backgroundColor: 'transparent',
                pieHole: 0.7,
                pieSliceText: 'value',
                pieSliceTextStyle: {
                    color: 'black',
                    fontSize: 1,
                    opacity: 0, // hides text on chart
                    visibility: 'hidden'  // hides text on chart
                },
                tooltip: {
                    text: 'value'
                },
                chartArea: {
                    top: 30,
                    right: 25,
                    width: '100%',
                    height: '100%'
                },
                height: '100%',
                width: '100%',
                legend: {
                    position: 'left',
                    alignment: 'center',
                    maxLines: 2,
                    textStyle: {
                        color: '#003f7f',
                        fontSize: 12,
                        fontName: 'OpenSans-Regular',
                        marginBottom: 50,
                        bold: true,
                        toolText: '%'
                    }

                },
                colors: colors

            };

            var optionsMobile = {
                backgroundColor: 'transparent',
                pieHole: 0.7,
                pieSliceText: 'value',
                pieSliceTextStyle: {
                    color: 'black',
                    fontSize: 1,
                    opacity: 0, // hides text on chart
                    visibility: 'hidden'  // hides text on chart
                },
                tooltip: {
                    text: 'value'
                },
                chartArea: {
                    top: 30,
                    left: 0,
                    width: '100%',
                    height: 260
                },
                height: 400,
                width: 270,
                legend: {
                    position: 'bottom',
                    alignment: 'left',
                    maxLines: 1,
                    textStyle: {
                        color: '#003f7f',
                        fontSize: 12,
                        fontName: 'Open Sans',
                        bold: true,
                        toolText: '%'
                    }

                },
                colors: colors//,

            };

            var pre_defined_suffix = '%';

            if (vm.potencyUnit != 'percent') {
            	pre_defined_suffix = vm.potencyUnit;
            }


            var formatter = new google.visualization.NumberFormat({
                fractionDigits: 2,
                suffix: pre_defined_suffix
            });

            formatter.format(data, 1);

            if(data.getNumberOfRows() != 0){
                var chart = new google.visualization.PieChart(angular.element('#pie-chart')[0]);
                chart.draw(data, options);

                var chartSmall = new google.visualization.PieChart(angular.element('#pie-chart-mobile')[0]);
                chartSmall.draw(data, optionsMobile);
            }
        }

        var sampleHash = $stateParams.hash;

        if (data) {
            //show cached picture is exists
            if (data.cachedPictures != null && data.cachedPictures.length>0) {
                 vm.sample.picture = data.cachedPictures[data.cachedPictures.length - 1].url;
            }

            //call service to fetch new pictures
            var samplePictures = SampleService.getPublicPictures({hash: data.hash});
            samplePictures.$promise.then(function (data) {

                if (data.length > 0 && data[0]) {

                    vm.sample.picture = data[data.length - 1].url;
                }
                else {
                    vm.sample.picture = "content/images/no_image_available-small.png";

                }
            }, function (error) {



            });

            if(data.dueDate) {
                vm.due_date = new Date(data.dueDate);
            }

            // GET SOME BASIC DATA ABOUT SAMPLE
            if(data.starred){
                vm.sample.starred = data.starred
            }

            if (data.id) {
                vm.sample.id = data.id;
            }

            if (data.hash) {
                vm.sample.hash = data.hash;
            }

            if (data.name) {
                vm.sample.name = data.name;
            }

            if (data.canSeeReport) {
                vm.sample.canSeeReport = data.canSeeReport;
            }

            if (data.company) {
                vm.sample.company = data.company;
                $rootScope.pageTitle = vm.sample && vm.sample.company ? vm.sample.company : "Sample";
            }

            if (data.sampleWeight) {
                vm.sample.sampleWeight = data.sampleWeight;
            }

            if (data.productCategory && data.productCategory.name){
            	vm.sample.sampleType = data.productCategory.name;
            }
            if (data.productType && data.productType.name) {
                vm.sample.sampleType += ' (' + data.productType.name + ')';
            }

            if (data.date_created) {
                vm.sample.date = new Date(data.date_created);
            }

            if (data.lotBatchNumber) {
            	vm.sample.lotBatchNumber = data.lotBatchNumber;
            }

            if (data.customerOrderId) {
            	vm.sample.customerOrderId = data.customerOrderId;
            }

            var margin = {top: 40, right: 0, bottom: 0, left: 40},
                width = Math.min(300, window.innerWidth - 10) - margin.left - margin.right,
                height = Math.min(width, window.innerHeight - margin.top - margin.bottom - 20);

            /* Circle around the chart */
            /* Values */
            var values = [
                // GREEN
                parseFloat(vm.sample.terpeneProfile.terpinolene && vm.sample.terpeneProfile.terpinolene.value ? vm.sample.terpeneProfile.terpinolene.value : 0) || 0,
                parseFloat(vm.sample.terpeneProfile.eudesmol && vm.sample.terpeneProfile.eudesmol.value ? vm.sample.terpeneProfile.eudesmol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.alpha_pinene && vm.sample.terpeneProfile.alpha_pinene.value ? vm.sample.terpeneProfile.alpha_pinene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.bete_pinene && vm.sample.terpeneProfile.bete_pinene.value ? vm.sample.terpeneProfile.bete_pinene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.camphene && vm.sample.terpeneProfile.camphene.value ? vm.sample.terpeneProfile.camphene.value : 0) || 0,

                // BLUE
                parseFloat(vm.sample.terpeneProfile.eucalyptol && vm.sample.terpeneProfile.eucalyptol.value ? vm.sample.terpeneProfile.eucalyptol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.isopulegol && vm.sample.terpeneProfile.isopulegol.value ? vm.sample.terpeneProfile.isopulegol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.menthol && vm.sample.terpeneProfile.menthol.value ? vm.sample.terpeneProfile.menthol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.borneol && vm.sample.terpeneProfile.borneol.value ? vm.sample.terpeneProfile.borneol.value : 0)|| 0,

                // PURPLE
                parseFloat(vm.sample.terpeneProfile.trans_beta_ocimene && vm.sample.terpeneProfile.trans_beta_ocimene.value ? vm.sample.terpeneProfile.trans_beta_ocimene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.cis_beta_ocimene && vm.sample.terpeneProfile.cis_beta_ocimene.value ? vm.sample.terpeneProfile.cis_beta_ocimene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.geraniol && vm.sample.terpeneProfile.geraniol.value ? vm.sample.terpeneProfile.geraniol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.linalool && vm.sample.terpeneProfile.linalool.value ? vm.sample.terpeneProfile.linalool.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.guaiol && vm.sample.terpeneProfile.guaiol.value ? vm.sample.terpeneProfile.guaiol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.alpha_bisabolol && vm.sample.terpeneProfile.alpha_bisabolol.value ? vm.sample.terpeneProfile.alpha_bisabolol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.alpha_terpinene && vm.sample.terpeneProfile.alpha_terpinene.value ? vm.sample.terpeneProfile.alpha_terpinene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.citronellol && vm.sample.terpeneProfile.citronellol.value ? vm.sample.terpeneProfile.citronellol.value : 0)|| 0,

                // YELLOW
                parseFloat(vm.sample.terpeneProfile.delta_3_carene && vm.sample.terpeneProfile.delta_3_carene.value ? vm.sample.terpeneProfile.delta_3_carene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.cis_nerolidol && vm.sample.terpeneProfile.cis_nerolidol.value ? vm.sample.terpeneProfile.cis_nerolidol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.trans_nerolidol && vm.sample.terpeneProfile.trans_nerolidol.value ? vm.sample.terpeneProfile.trans_nerolidol.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.limonene && vm.sample.terpeneProfile.limonene.value ? vm.sample.terpeneProfile.limonene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.p_cymene && vm.sample.terpeneProfile.p_cymene.value ? vm.sample.terpeneProfile.p_cymene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.gamma_terpinene && vm.sample.terpeneProfile.gamma_terpinene.value ? vm.sample.terpeneProfile.gamma_terpinene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.aplha_terpineol && vm.sample.terpeneProfile.aplha_terpineol.value ? vm.sample.terpeneProfile.aplha_terpineol.value : 0)|| 0,

                // RED
                parseFloat(vm.sample.terpeneProfile.eszett_myrcene && vm.sample.terpeneProfile.eszett_myrcene.value ? vm.sample.terpeneProfile.eszett_myrcene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.caryophylleneoxide && vm.sample.terpeneProfile.caryophylleneoxide.value ? vm.sample.terpeneProfile.caryophylleneoxide.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.alpha_Humulene && vm.sample.terpeneProfile.alpha_Humulene.value ? vm.sample.terpeneProfile.alpha_Humulene.value : 0)|| 0,
                parseFloat(vm.sample.terpeneProfile.eszett_caryophyllene && vm.sample.terpeneProfile.eszett_caryophyllene.value ? vm.sample.terpeneProfile.eszett_caryophyllene.value : 0)|| 0

            ];

            /* get max number */
            var max = Math.max.apply(Math, values);
            if (max % 1 === 0) {
                max = max + 0.01;
            }

            var maxNew = Math.ceil(max);

            if (maxNew - 0.5 > max) {
                max = maxNew - 0.5;
            } else {
                max = maxNew;
            }

            var radarChartData = [
                [
                    // GREEN //
                    {axis: "Terpinolene", value: values[0]},
                    {axis: "Eudesmol", value: values[1]},
                    {axis: "α-Pinene", value: values[2]},
                    {axis: "β-Pinene", value: values[3]},
                    {axis: "Camphene", value: values[4]},

                    // BLUE //
                    {axis: "Eucalyptol", value: values[5]},
                    {axis: "Isopulegol", value: values[6]},
                    {axis: "Menthol", value: values[7]},
                    {axis: "Borneol", value: values[8]},

                    // PURPLE //
                    {axis: "Trans-beta-Ocimene", value: values[9]},
                    {axis: "Cis-beta-Ocimene", value: values[10]},
                    {axis: "Geraniol", value: values[11]},
                    {axis: "Linalool", value: values[12]},
                    {axis: "Guaiol", value: values[13]},
                    {axis: "α-Bisabolol", value: values[14]},
                    {axis: "α-Terpineol", value: values[15]},
                    {axis: "Citronellol", value: values[16]},

                    // YELLOW //
                    {axis: "δ-3-Carene", value: values[17]},
                    {axis: "Cis-Nerolidol", value: values[18]},
                    {axis: "Trans-Nerolidol", value: values[19]},
                    {axis: "Limonene", value: values[20]},
                    {axis: "P-Cymene", value: values[21]},
                    {axis: "γ-Terpinene", value: values[22]},
                    {axis: "α-Terpinene", value: values[23]},

                    // RED //
                    {axis: "ß-Myrcene", value: values[24]},
                    {axis: "Caryoph. Oxide", value: values[25]},
                    {axis: "α-Humulen", value: values[26]},
                    {axis: "ß-Caryophyllene", value: values[27]},

                ]
            ];

            var color = d3.scale.ordinal()
                .range(["#440e62", "#ffffff"]);

            var radarChartOptions = {
                w: width,
                h: height,
                margin: margin,
                maxValue: max,
                levels: max * 2,
                roundStrokes: true,
                color: color,
                format: '%'
            };


            //Call function to draw the Radar chart
            RadarChart(".chart2", radarChartData, radarChartOptions);

            var canvas = document.getElementsByTagName("canvas")[0];


            if (canvas) {
                var context = canvas.getContext("2d");

                context.beginPath();
                context.arc(170, 170, 145, 341 * (Math.PI / 180), 271 * (Math.PI / 180), true);
                context.strokeStyle = "#ffffff";
                context.stroke();

                context.beginPath();
                context.arc(170, 170, 145, 269 * (Math.PI / 180), 199 * (Math.PI / 180), true); // top left
                context.stroke();

                context.beginPath();
                context.arc(170, 170, 145, 197 * (Math.PI / 180), 127 * (Math.PI / 180), true); // bottom left
                context.stroke();

                context.beginPath();
                context.arc(170, 170, 145, 125 * (Math.PI / 180), 56 * (Math.PI / 180), true); // bottom left
                context.stroke();

                context.beginPath();
                context.arc(170, 170, 145, 54 * (Math.PI / 180), 343 * (Math.PI / 180), true); // bottom right
                context.stroke();

                /* Circle quadrants */

                context.beginPath();
                context.arc(170, 170, 130, 342 * (Math.PI / 180), 270 * (Math.PI / 180), true);
                context.fillStyle = "#669A8B";
                context.lineTo(170, 170);
                context.closePath();
                context.fill();

                context.beginPath();
                context.arc(170, 170, 130, 29 * (Math.PI / 180), 342 * (Math.PI / 180), true); // bottom right
                context.fillStyle = "#00BFC6";
                context.lineTo(170, 170);
                context.closePath();
                context.fill();

                context.beginPath();
                context.arc(170, 170, 130, 120 * (Math.PI / 180), 29 * (Math.PI / 180), true); // bottom right
                context.fillStyle = "#F6DBB9";
                context.lineTo(170, 170);
                context.closePath();
                context.fill();

                context.beginPath();
                context.arc(170, 170, 130, 198 * (Math.PI / 180), 120 * (Math.PI / 180), true); // bottom left
                context.fillStyle = "#F5B54E";
                context.lineTo(170, 170);
                context.closePath();
                context.fill();

                context.beginPath();
                context.arc(170, 170, 130, 270 * (Math.PI / 180), 198 * (Math.PI / 180), true); // top left
                context.fillStyle = "#FF6A59";
                context.lineTo(170, 170);
                context.closePath();
                context.fill();
            }

            google.charts.setOnLoadCallback(function () {

                drawChart(vm.sample);

            });
            getAttachments();

        }


        function setTerpeneProfileData(test) {
    		vm[TERPENES] = test;
    		$scope.collapse[TERPENES] = false;

        	if (test.worksheetData) {
                // TERPENE PROFILE DATA STARTS HERE
                var terpeneProfileFields = [

                    'terpinolene',      'alpha_bisabolol',
                    'eudesmol',         'alpha_terpinene',
                    'alpha_pinene',     'citronellol',
                    'bete_pinene',      'delta_3_carene',
                    'camphene',         'cis_nerolidol',
                    'eucalyptol',       'trans_nerolidol',
                    'isopulegol',       'limonene',
                    'menthol',          'p_cymene',
                    'borneol',          'gamma_terpinene',
                    'trans_beta_ocimene','aplha_Terpineol',
                    'cis_beta_ocimene', 'eszett_myrcene',
                    'geraniol',         'caryophylleneoxide',
                    'Linalool',         'alpha_Humulene',
                    'guaiol',           'eszett_caryophyllene'

                ];

                var taste = [

                    'piney',	'sweet',
                    'piney',	'sweet',
                    'piney',	'sweet',
                    'piney',	'citrus',
                    'piney',	'citrus',
                    'minty',	'citrus',
                    'minty',	'citrus',
                    'minty',	'citrus',
                    'minty',	'citrus',
                    'sweet',	'citrus',
                    'sweet',	'spicy',
                    'sweet',	'spicy',
                    'sweet',	'spicy',
                    'sweet',    'spicy'

                ];

                terpeneProfileFields.forEach(function (item, index) {
                    if (test.worksheetData[item]) {
                    	if (test.worksheetData[item].display_name.includes("ÃŸ"))
                    		test.worksheetData[item].display_name = test.worksheetData[item].display_name.replace("ÃŸ","ß")

                        vm.sample.terpeneProfile[item] = test.worksheetData[item];
                        vm.sample.terpeneProfile[item].taste = taste[index];

                    } else {

                        vm.sample.terpeneProfile[item] = {display_name: 'Missing ' + item};
                        vm.sample.terpeneProfile[item].taste = taste[index];

                    }



					// if terpene data contains 'ND' and a number then set the value to just the number
					if (vm.sample.terpeneProfile[item].value){
						if (vm.sample.terpeneProfile[item].value.includes('ND') && hasNumber(vm.sample.terpeneProfile[item].value)){
							vm.sample.terpeneProfile[item].value = vm.sample.terpeneProfile[item].value.replace('ND','')
						}
					}

                });

        	}

        	if (test.results)
        		vm.sample.terpeneProfile[test.assay.title] = {'display_name': test.assay.title, 'value': test.results}
        }

		function hasNumber(myString) {
  			return /\d/.test(myString);
        }

        function setPotencyData(test) {
    		vm[POTENCY] = test;
    		$scope.collapse[POTENCY] = false;

        	if (test.worksheetData) {

            	vm.sample.totalThcPercent = fmtTwoDecimals(test.worksheetData.total_thc_dry_percent);
                vm.sample.totalThcMgpg =  fmtTwoDecimals(test.worksheetData.total_thc_mgpg);
                vm.sample.totalThcDryPercent = fmtTwoDecimals(test.worksheetData.total_thc_dry_percent);
                vm.sample.totalThcDryMgpg = fmtTwoDecimals(test.worksheetData.total_thc_dry_mgpg);
                vm.sample.totalThcMgpu = fmtTwoDecimals(test.worksheetData.total_thc_mgpu);
                vm.sample.totalThcMgpml = fmtTwoDecimals(test.worksheetData.total_thc_mgpml);
                vm.sample.totalThcMgpp = fmtTwoDecimals(test.worksheetData.total_thc_mgpp);

                vm.sample.totalCbdPercent = fmtTwoDecimals(test.worksheetData.total_cbd_percent);
                vm.sample.totalCbdMgpg = fmtTwoDecimals(test.worksheetData.total_cbd_mgpg);
                vm.sample.totalCbdDryPercent = fmtTwoDecimals(test.worksheetData.total_cbd_dry_percent);
                vm.sample.totalCbdDryMgpg = fmtTwoDecimals(test.worksheetData.total_cbd_dry_mgpg);
                vm.sample.totalCbdMgpu = fmtTwoDecimals(test.worksheetData.total_cbd_mgpu);
                vm.sample.totalCbdMgpml = fmtTwoDecimals(test.worksheetData.total_cbd_mgpml);
                vm.sample.totalCbdMgpp = fmtTwoDecimals(test.worksheetData.total_cbd_mgpp);

                vm.sample.totalPercent = fmtTwoDecimals(test.worksheetData.total_percent);
                vm.sample.totalMgpg = fmtTwoDecimals(test.worksheetData.total_mgpg);
                vm.sample.totalDryPercent = fmtTwoDecimals(test.worksheetData.total_dry_percent);
                vm.sample.totalDryMgpg = fmtTwoDecimals(test.worksheetData.total_dry_mgpg);
                vm.sample.totalMgpu = fmtTwoDecimals(test.worksheetData.total_mgpu);
                vm.sample.totalMgpml = fmtTwoDecimals(test.worksheetData.total_mgpml);
                vm.sample.totalMgpp = fmtTwoDecimals(test.worksheetData.total_mgpp);

        	}
        }


        $scope.getTotalThc = getTotalThc;

        function getTotalThc(sample) {
        	if (!sample.sampleTests) return;
        	for (var i = 0; i < sample.sampleTests.length; i++){
        		var test = sample.sampleTests[i];
        		if (!test.assay || !test.assay.portalIdentifier) continue;
        		var assay = test.assay.portalIdentifier;
        		if (assay === 'POTENCY_LCDAD' || assay === 'POTENCY_GCFID' || assay === 'POTENCY_LCMSMS' || assay === 'POTENCY_LCDAD_NON_PLANT') {
        			if (test.worksheetData && test.worksheetData.total_dry_percent && test.worksheetData.total_dry_percent.twoDecimalFormattedValue) {
        				return test.worksheetData.total_dry_percent.twoDecimalFormattedValue + ' %';
        			}
        		}
        	}
        	return 'N/A';
        }

        vm.downloadReport = function () {
            var sample = vm.sample;

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            SampleCoaPdfService.downloadPdf(sample.hash).then(function(result) {
                var file = new Blob([result.data], {
                    type: 'application/pdf'
                });

                a.href = window.URL.createObjectURL(file);
                a.download = sample.id + '_COA_Summary.pdf';
                a.click();
            });
		}

        $('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

        $('#testtaginput').tagsinput('input')[0].type = 'email'

        vm.emailsPending = [""];
        vm.emailMessage = "";

        vm.sendPublicEmail = function (form) {
        	vm.emailsPending = $('#testtaginput').tagsinput('items')
        	vm.emailSubject = $('#emailSubject').val();
        	//Send The Email
        	if (form.$valid && vm.emailsPending.length > 0){
        		$('#sendPublicSampleButton').attr("disabled", true);
        		Sample.sendEmail({
        			emails: vm.emailsPending,
        			message: vm.emailMessage,
        			public_link: vm.emailSamplePublicLink,
        			pic_url: vm.sample.picture,
        			id: vm.sample.id,
        			totalTHC: getTotalThc(vm.sample),
        			subject: vm.emailSubject
        		}, onSuccess, onError);
        	}
        	else {
        		if (vm.emailsPending.length == 0)
        			$('#emailValidation').show();
        		return
        	}
        	function onSuccess(data, headers) {
        		$('#emailModal').modal('hide');
        		$('#emailModalSuccess').modal('show');
        		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
        }

    $('#emailModalSuccess').on('hidden.bs.modal', function() {
        	$('#testtaginput').tagsinput('removeAll');
        	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
        })

        vm.copyLink = function(id) {
    	  /* Get the text field */
    	  var copyText = document.getElementById(id);
    	  /* Select the text field */
    	  copyText.select();
    	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
    	  /* Copy the text inside the text field */
    	  document.execCommand("copy");
        }

        vm.currentPublicSample = null

        vm.createSamplePublicLink = function(sample) {
        	var hash = $stateParams.hash;
        	var fullUrl = window.location.origin +"/#/ps/"+ $stateParams.hash;
        	vm.currentPublicSample = sample;
        	return fullUrl;
        }

        
        vm.downloadAttachment = function (id_hash ,sample) {
            if(id_hash) {
                if(id_hash == 'coa') {
                    if (vm.canDownloadCoaSummary()) {
                        vm.downloadReport();
                    }
                }
                else {
                    var selectedAttachment = sample.attachments && sample.attachments.find(function(attachment) {
                        return attachment.hash === id_hash && attachment.canSee;
                    });
                    if (!selectedAttachment) {
                        vm.selectedDownload = '';
                        return;
                    }

                    SampleAttachDownload.getPublic({sampleHash: sample.hash, id: id_hash}, onSuccess, onError);

                    function onSuccess(data, headers) {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        var fileURL = window.URL.createObjectURL(data.data);
                        a.href = fileURL;
                        a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                        a.click();
                    }
                    function onError(error) {
                        console.log(error);
                    }
                }
            }
            vm.selectedDownload = '';
        }
    }

    function transition() {
        $rootScope.sampleLogCategoryId = vm.productCategoryId;
        $rootScope.sampleSelectedFilter = $scope.selected;

        $state.transitionTo($state.$current, {
            page: vm.page,
            sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
            search: vm.currentSearch,
            items: vm.itemsPerPage,
            productCategoryId: vm.productCategoryId
        });
    }

    angular.element(document).ready(function() {
        setTimeout(function() {

          $(".chart-legend span").each(function(index, element) {
              index++;
              $(this).addClass("span-col-" + index);
          });

          $(window).on('resize load', function() {

            var window = $( window ).width();
            var num_col = $(".chart-legend span").length;

            if(window <= 600) {
              var col_width = 100 / num_col;
              var width = col_width - 1;
              $(".chart-legend span").css("width", width + "%");
            }

          });

          $("#col-prev").click(function() {
              $('.span-col-1').show();
              $('.span-col-2').show();
              $('.span-col-3').show();

              $('.span-col-4').hide();
              $('.span-col-5').hide();

              $('.chart-swiper div').text(' 1/2 ');

              $("#col-prev").attr('disabled', 'disabled');
              $("#col-next").prop("disabled", false);
          });

          $("#col-next").click(function() {

            $('.span-col-4').show();
            $('.span-col-5').show();

            $('.span-col-1').hide();
            $('.span-col-2').hide();
            $('.span-col-3').hide();

            $('.chart-swiper div').html('2/2 ');

            $("#col-next").attr('disabled', 'disabled');
            $("#col-prev").prop("disabled", false);

        });

        }, 1000);
    });


})();

(function() {
    'use strict';

    angular.module('anrescowebApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state('publicOld', {
            parent: 'app',
            url: '/public/samples/{hash}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/public/public.html',
                    controller: 'PublicPageController',
                    controllerAs: 'vm'
                }
            },
             resolve: {
                 data: function ($state, $stateParams, SampleService) {
                    var sampleHash = $stateParams.hash;
                    var token = null;
                    return SampleService.get({hash: sampleHash, token: token})
                      .$promise.then(
                            function(data){
                              return data
                              },
                             function(error){
                                $state.go('publicSampleNotFound', {}, {location: 'replace'}); });
                }
             }
        });

        $stateProvider.state('publicWithTokenOld', {
                    parent: 'app',
                    url: '/public/samples/{hash}/{token}',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/pages/public/public.html',
                            controller: 'PublicPageController',
                            controllerAs: 'vm'
                        }
                    },
                     resolve: {
                         data: function ($state, $stateParams, SampleService) {
                            var sampleHash = $stateParams.hash;
                            var token = $stateParams.token;
                            return SampleService.get({hash: sampleHash, token: token})
                              .$promise.then(
                                    function(data){
                                      return data
                                      },
                                     function(error){
                                        $state.go('publicSampleNotFound', {}, {location: 'replace'}); });
                        }
                     }
                });


        $stateProvider.state('publicSampleNotFound', {
            parent: 'app',
            url: '/public/samples-not-found',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/public/not-found.html'
                }
            }
        });

        $stateProvider.state('public', {
            parent: 'app',
            url: '/ps/{hash}',
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                size: 20,
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,

                productCategoryId: {
                    value: '0',
                    squash: true
                }
            },
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/public/public.html',
                    controller: 'PublicPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                data: function ($state, $stateParams, SampleService) {
                    var sampleHash = $stateParams.hash;
                    var token = null;
                    return SampleService.get({hash: sampleHash, token: token})
                        .$promise.then(
                            function(data){
                                return data
                            },
                            function(error){
                                $state.go('publicSampleNotFound', {}, {location: 'replace'}); });
                }
            }

        });


        // $stateProvider.state('customerPublic', {
        //     parent: 'app',
        //     url: '/customer/{hash}',
        //     data: {
        //         authorities: []
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/pages/public/customer-public.html',
        //             controller: 'PublicPageController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         data: function ($state, $stateParams, SampleService) {
        //             var sampleHash = $stateParams.hash;
        //             var token = null;
        //             return SampleService.get({hash: sampleHash, token: token})
        //                 .$promise.then(
        //                     function(data){
        //                         return data
        //                     },
        //                     function(error){
        //                         $state.go('publicSampleNotFound', {}, {location: 'replace'}); });
        //         }
        //     }
        //
        // });

        $stateProvider.state('publicWithToken', {
                    parent: 'app',
                    url: '/ps/{hash}/{token}',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/pages/public/public.html',
                            controller: 'PublicPageController',
                            controllerAs: 'vm'
                        }
                    },
                     resolve: {
                         data: function ($state, $stateParams, SampleService) {
                            var sampleHash = $stateParams.hash;
                            var token = $stateParams.token;
                            return SampleService.get({hash: sampleHash, token: token})
                              .$promise.then(
                                    function(data){
                                      return data
                                      },
                                     function(error){
                                        $state.go('publicSampleNotFound', {}, {location: 'replace'}); });
                        }
                     }

                });


    }
})();

(function() {
    'use strict';
    angular.module('anrescowebApp').factory('SampleService', SampleService);

    SampleService.$inject = ['$resource'];

    function SampleService ($resource) {
        var resourceUrl =  'api/public/samples/:hash';

        return $resource(resourceUrl, {hash: "@hash", token: "@token"}, {
            'get': {
                method: 'GET',
                url: 'api/public/samples/:hash/:token'
            },
            'getPictures': {
                method: 'GET',
                url: 'api/samples/:id/pictures',
                isArray: true
            },
            'getPublicPictures': {
                method: 'GET',
                url: 'api/public/samples/:hash/pictures',
                isArray: true
            },
            'getWorksheetParserMap': {
                method: 'GET',
                url: 'api/public/worksheet-parser-map',
                isArray: false,
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CompanyPageController', CompanyPageController)

    CompanyPageController.$inject = ['$state','$stateParams','$scope','$rootScope', '$filter', '$timeout', '$q', 'Sample', 'SampleSearch',
        'AlertService', 'pagingParams', 'SampleFilter',
        'SampleAttach','SampleAttachDownload', 'SampleExportService', 'ProductCategory','ProductTypeByCategory', 'CompanyPage', 'Principal', 'SampleCoaPdfService', 'DownloadUtil', 'SampleService', 'GraphQLService'];

    function CompanyPageController($state, $stateParams,$scope, $rootScope, $filter, $timeout, $q, Sample, SampleSearch, AlertService, pagingParams, SampleFilter,
                                 SampleAttach,SampleAttachDownload, SampleExportService, ProductCategory, ProductTypeByCategory, CompanyPage, Principal, SampleCoaPdfService, DownloadUtil, SampleService, GraphQLService) {

        var vm = this;
  $rootScope.showSearch = pagingParams.search;
        
        // Initialize totalFilters property
        vm.totalFilters = 0;

  vm.isAuthenticated = Principal.isAuthenticated;

        vm.search = search;
        vm.clear = clear;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pagingParams = pagingParams;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.cannabioidWorksheets = null;

        $scope.isOtherAnalysis = isOtherAnalysis;
        $scope.hasOtherAnalyses = hasOtherAnalyses;
        $scope.hasCannabinoids = hasCannabinoids;
        $scope.getTotalThc = getTotalThc;
		vm.isinPortal = false
		if(window.top == window.self){
			vm.isinPortal = true
		}
		else{
			vm.isinPortal = false
		}

        $scope.assayIdentifierToName = function(identifier){
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
        			'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			//'ALKALOID': 'Alkaloid'
        	}

        	var assay = assayIdMap[identifier];
        	if (!assay){
        		return "";
        	} else {
        		return assay;
        	}
        }
        $scope.canSeeOtherAnalyses = function(sample) {
        	var canSee = true;
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = sample.sampleTests[i];
        		if (!test.assay) continue;
        		if (test.assay.id === 18 || test.assay.id === 19 || test.assay.id === 15) {
        			if (!test.canSeeResults) canSee = false;
        		}
        	}
        	return canSee;
        }
        $scope.canSeeTest = function(sample, testName) {
        	var assayIdMap = {
        			'POTENCY_LCMSMS': 'Cannabinoid Profile',
        			'POTENCY_GCFID': 'Cannabinoid Profile',
        			'POTENCY_LCDAD': 'Cannabinoid Profile',
        			'POTENCY_LCDAD_NON_PLANT': 'Cannabinoid Profile',
        			'RESIDUAL_SOLVENT_PHASE_II': 'Residual Solvents',
        			'RESIDUAL_SOLVENT_PHASE_I': 'Residual Solvents',
        			'HEAVY_METALS': 'Heavy Metals',
        			'HEAVY_METALS_FOOD': 'Heavy Metals',
        			'TERPENE_PROFILE': 'Terpene Profile',
        			'PESTICIDES_PLUS': 'Pesticide Screen',
        			'PESTICIDES_PHASE_II': 'Pesticide Screen',
        			'MICRO_QA_SCREEN': 'Microbiology',
        			'MICRO_PLUS': 'Microbiology',
        			'MICRO_INHALABLES': 'Microbiology',
        			'MICRO_NON_INHALABLES': 'Microbiology',
        			'MYCOTOXINS': 'Mycotoxins',
        			'WATER_ACTIVITY': 'Water Activity',
        			'FOREIGN_MATERIAL': 'Foreign Materials',
        			'MOISTURE': 'Moisture',
        			'SULFUR': 'Sulfur',
        			'HOMOGENEITY': 'Homogeneity',
        			'HOMOGENEITY_5': 'Homogeneity',
        			'PESTICIDES_MYCOTOXINS': 'Pesticides + Mycotoxins',
        			//'ALKALOID': 'Alkaloid'
        	}
        	for (var i = 0; i < sample.sampleTests.length; i++) {
        		var test = assayIdMap[sample.sampleTests[i].assay.portalIdentifier];
        		if (test === testName) {
        			return sample.sampleTests[i].canSeeResults;
        		}
        	}
		}

		vm.downloadSampleCOA =  function(sample_id, sample_hash) {
			var a = document.createElement("a");
			document.body.appendChild(a);
			a.style = "display: none";
			SampleCoaPdfService.downloadPdf(sample_hash).then(function(result) {
				var file = new Blob([result.data], {
					type: 'application/pdf'
				});

				a.href = window.URL.createObjectURL(file);
				a.download = sample_id + '_COA_Summary.pdf';
				a.click();
			});
		}

		vm.determinePfDisplay = function(pf) {
			switch(pf){
				case "PASS":
					return "<p class=\"test-pass\" style=\"color: #28d300\">\
								<span class=\"fa fa-check-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Pass</span>\
							</p>";
				case "FAIL" :
					return "<p class=\"test-fail\" style=\"color: red\">\
								<span class=\"fa fa-times-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Fail</span>\
							</p>";
				case "IN_PROGRESS":
					return "<p class=\"test-in-progress\" style=\"color: #ff8100\">\
								<span class=\"fa fa-clock-o test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;In Progress</span>\
							</p>";
				case "NO_STATUS":
					return "<p class=\"test-in-progress\" style=\"color: gray\">\
								<span class=\"fa fa-times-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Not Tested</span>\
							</p>";
				case "RETESTING":
					return "<p class=\"test-retesting\" style=\"color: #5eb1bf\">\
								<span class=\"fa fa-repeat test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;Retesting</span>\
							</p>";
				default:
					return "<p class=\"not-tested\" style=\"color: gray\">\
								<span class=\"fa fa-stop-circle test-result-icon\"></span>\
								<span class=\"test-result-text\">&nbsp;No Status</span>\
							</p>";
			}
		}

		$scope.determineTestPf = function(test) {
			var html = '';

			var testTitle = test.assay && test.assay.title ? test.assay.title : '-';
			if (test.state != 'COMPLETED' && test.estimatedCompleteDate) {
				var dueDate = new Date(test.estimatedCompleteDate);
				var formattedDate = ('0' + (dueDate.getUTCMonth() + 1)).slice(-2) + '/' + 
									('0' + dueDate.getUTCDate()).slice(-2) + '/' + 
									 dueDate.getUTCFullYear();
				testTitle += ' <span style="color: #8795a1; font-size: 11px;">(' + formattedDate + ')</span>';
			}

			html += '<tr>';
			html += '<td>' + testTitle + '</td>';

			if (test.canSeeResults) {
				if (test.state === 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				} else if (test.caution) {
					html += '<td class="test-caution">Caution</td>';
				} else if (test.state === 'NOT STARTED') {
					if (test.estimatedCompleteDate) {
						html += '<td class="test-in-progress">In Progress</td>';
					} else {
						html += '<td class="test-not-started">Created</td>';
					}
				} else if (test.state === 'IN PROGRESS') {
					html += '<td class="test-in-progress">In Progress</td>';
				} else if (test.worksheetData) {
					var hidePf = test.worksheetData.do_not_show_pass_fail_in_portal && test.worksheetData.do_not_show_pass_fail_in_portal.value;

					if (hidePf) {
						if (test.state === 'COMPLETED') {
							html += '<td class="test-no-pf-status">Tested</td>';
						} else {
							html += '<td class="test-in-progress">In Progress</td>';
						}
					} else if (test.statusPf === 'PASS') {
						html += '<td class="test-pass">Pass</td>';
					} else if (test.statusPf === 'FAIL') {
						html += '<td class="test-fail">Fail</td>';
					} else if (test.state === 'COMPLETED') {
						html += '<td class="test-no-pf-status">Tested</td>';
					} else {
						html += '<td class="test-in-progress">In Progress</td>';
					}
				} else if (test.results) {
					html += '<td class="test-pass">Tested</td>';
				} else if (test.worksheetData && test.worksheetData.findings_1 && test.worksheetData.findings_1.value) {
					html += '<td class="test-pass">Tested</td>';
				} else {
					html += '<td class="test-fail">-</td>';
				}
			} else {
				if (test.state === 'RETESTING') {
					html += '<td class="test-retesting">Retesting</td>';
				} else if (['PASS', 'FAIL', 'COMPLETED'].indexOf(test.state) !== -1) {
					html += '<td class="test-retesting">Final Review</td>';
				} else {
					html += '<td class="test-in-progress">In Progress</td>';
				}
			}

			html += '</tr>';
			return html;
		}

		vm.determinePotencyDisplay = function(sample, potencyType, total, show_dash) {
			if (!sample || !sample.sampleTests) {
				if (potencyType === 'thc' && sample && sample.thcDisplay) {
					return sample.thcDisplay;
				}
				if (potencyType === 'cbd' && sample && sample.cbdDisplay) {
					return sample.cbdDisplay;
				}
				if (total && sample && sample.totalCannabinoidsDisplay) {
					return sample.totalCannabinoidsDisplay;
				}
				return show_dash ? '-' : '';
			}

			if (!total && potencyType === 'thc' && sample.thcDisplay) {
				return sample.thcDisplay;
			}
			if (!total && potencyType === 'cbd' && sample.cbdDisplay) {
				return sample.cbdDisplay;
			}
			if (total && sample.totalCannabinoidsDisplay) {
				return sample.totalCannabinoidsDisplay;
			}

			if (!vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return show_dash ? '-' : '';
			}

			var potency = '';

			if (total) {
				potencyType = 'thc';
			}

	        	for (var i = 0; i < sample.sampleTests.length && !potency; i++) {
				var test = sample.sampleTests[i];
				if (!isCannabinoidWorksheet(test) || !test.worksheetData) {
					continue;
				}

				potency = getWorksheetPotency(test.worksheetData, potencyType, total);
			}

			if (show_dash) {
				return potency ? potency : '-';
			}
			return potency;
		}

        vm.downloadSamplesCsv = function downloadSamplesCsv () {

            var fileName = "samples.csv";
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            SampleExportService.downloadCsv().then(function (result) {
                var file = new Blob([result.data], {type: 'application/json'});
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            });


		}
		
		vm.showFile = function(name) {
			var dont_show = ['_Labels', '_QR', 'medium', 'serv', '_slider_', ]
			for( var i = 0; i < dont_show.length; i++) {
				if(name.includes(dont_show[i])) {
					return false;
				}
			}
			return true;
		}

		/* Download Samples */
        function downloadSamplesSuccess(fileName, result) {
    		if (result.data.byteLength == 0) {
    			vm.downloadSamplesNull = true;
    			vm.downloadingSamples = false;
    			return;
    		}

            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";

            var file = new Blob([result.data], {type: 'application/json'});
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
            vm.downloadingSamples = false;
        }
        function downloadSamplesError(err) {
        	vm.downloadingSamples = false;
        	vm.downloadSamplesError = true;
        }

        vm.updateSamplePublicity = function(sample) {
            vm.getAttachmentsLoader = false;
            sample.attachments = null;
            Sample.public({id: sample.id, public: ':public'});

        };

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.downloadSampleStartDate = false;
        vm.datePickerOpenStatus.downloadSampleEndDate = false;

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.downloadSample = {
        		startDate: null,
        		endDate: null,
        		type: 'COA'
        }

        vm.downloadingSamples = false;
        vm.downloadSamplesError = false;
        vm.downloadSamplesNull = false;

        vm.downloadSamples = function() {
        	vm.downloadSamplesError = false;
        	vm.downloadSamplesNull = false;
        	var sampleExportParams = {
                	startDate: vm.downloadSample.startDate ? vm.downloadSample.startDate.getTime()/1000 : null,
                	endDate: vm.downloadSample.endDate ? vm.downloadSample.endDate.getTime()/1000 : null,
                	type: vm.downloadSample.type
        	}
        	vm.downloadingSamples = true;
        	if (vm.downloadSample.type == "COA") {
            	SampleExportService.downloadCoa(sampleExportParams).then(function (result) {
                    var fileName = "samples";
                    if (sampleExportParams.startDate && sampleExportParams.endDate) {
                    	fileName += " " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy') + " to " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.startDate) {
                    	fileName += " after " + $filter('date')(vm.downloadSample.startDate, 'MM-dd-yyyy');
                    } else if (sampleExportParams.endDate) {
                    	fileName += " before " + $filter('date')(vm.downloadSample.endDate, 'MM-dd-yyyy');
                    }
                    fileName += ".zip";

            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	} else {
            	SampleExportService.downloadCsv(sampleExportParams).then(function (result) {
            		var fileName = "samples.csv";
            		downloadSamplesSuccess(fileName, result);

                }, function(error) {
                	downloadSamplesError(error);
                });
        	}
        }

        vm.getAttachmentsLoader = false;
        vm.testResultsCache = {};
        var deferredCompanyPageBatchLoad = null;

        vm.setpagesize = setpagesize;

        setPageTitle();
        getcannabinoidWorksheetIds();
        $scope.range = new Array(20);

        function setpagesize(pagesize) {
            vm.itemsPerPage = pagesize;
            loadAll ();
        }

		/* Page loads */
        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.sampleFilters = {};
            vm.populateTypes();
            vm.totalFilters = 0; // Reset filter count
                        
            // Transition to update the URL and reload data
            vm.transition();
        }

        vm.toggleWidget = function(name) {
        	if (vm.activeWidget === "sampleEditColumns") {
        		saveSampleColumns();
        	}

        	vm.activeWidget = name === vm.activeWidget ? null : name;
        }

        function getcannabinoidWorksheetIds() {
        	SampleService.getWorksheetParserMap({},
    			function(data) {
    				vm.cannabioidWorksheets = data && data.cannabinoid_profile ? data.cannabinoid_profile : [];
    			},
    			function(e) {
    				console.log(e);
    			}
    		);
        }

        vm.sampleFilters = {
        		id: pagingParams.id,
        		orderId: pagingParams.orderId,
        		sampleName: pagingParams.sampleName,
        		lotNumber: pagingParams.lotNumber,
        		metrcId: pagingParams.metrcId,
        		categoryIdList: pagingParams.categoryIdList,
        		category: pagingParams.category,
        		subCategory: pagingParams.subCategory,
        		orderType: pagingParams.orderType,
        		thcLower: pagingParams.thcLower,
        		thcUpper: pagingParams.thcUpper,
        		cbdLower: pagingParams.cbdLower,
        		cbdUpper: pagingParams.cbdUpper,
        		isPass: pagingParams.isPass == 'true' ? pagingParams.isPass != null : null,
        		isFail: pagingParams.isFail == 'true' ? pagingParams.isFail != null : null,
        		isUndetermined: pagingParams.isUndetermined == 'true' ? pagingParams.isUndetermined != null : null,
        		isWeedmapsSuccess: pagingParams.isWeedmapsSuccess == 'true' ? pagingParams.isWeedmapsSuccess != null : null,
        		isWeedmapsFail: pagingParams.isWeedmapsFail == 'true' ? pagingParams.isWeedmapsFail != null : null,
        		isWeedmapsNone: pagingParams.isWeedmapsNone == 'true' ? pagingParams.isWeedmapsNone != null: null,
        		visibility: pagingParams.visibility,
        		completeDateLower: pagingParams.completeDateLower ? convertLocalDateFromServer(pagingParams.completeDateLower) : null,
        		completeDateUpper: pagingParams.completeDateUpper ? convertLocalDateFromServer(pagingParams.completeDateUpper) : null,
        		estimatedDueDateLower: pagingParams.estimatedDueDateLower ? convertLocalDateFromServer(pagingParams.estimatedDueDateLower) : null,
        		estimatedDueDateUpper: pagingParams.estimatedDueDateUpper ? convertLocalDateFromServer(pagingParams.estimatedDueDateUpper) : null,
        		starred: pagingParams.starred ? pagingParams.starred : null
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
        	var params = createFilterQueryParams();

        	if ($scope.starred)
        		params['starred'] = true;
        	else
        		params['starred'] = null;
                        
            // Update URL without reloading the page
            $state.go($state.current.name, params, { notify: false });
            
            // Manually reload the data
            loadAll();
        }

        function createFilterQueryParams() {
        	var params = {};
            var dateFields = ["completeDateLower", "completeDateUpper", "estimatedDueDateLower", "estimatedDueDateUpper"];            
        	for (var key in vm.sampleFilters) {
        		if (dateFields.indexOf(key) !== -1) {
         			params[key] = convertLocalDateToServer(vm.sampleFilters[key]);
         		} else if (vm.sampleFilters[key] !== "" && vm.sampleFilters[key] !== null && vm.sampleFilters[key] !== undefined) {
        			params[key] = vm.sampleFilters[key];
        		}
        	}

        	if ($scope.starred)
        		params['starred'] = true;

        	params.hash = vm.customerHash;
        	params.page = vm.page;
        	params.sort = vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc');
            params.search = vm.currentSearch;
            params.size = vm.itemsPerPage;
            params.items = params.size;
            params.productCategoryId = vm.productCategoryId;

        	return params;
        }

		$scope.starred = pagingParams.starred ? pagingParams.starred : false;

        
        vm.filterSubmit = function() {
            // Reset to first page
        	vm.page = 1;
            
            // Update filter count
            var filterCount = 0;
            for (var key in vm.sampleFilters) {
                if (vm.sampleFilters[key] !== null &&
                    vm.sampleFilters[key] !== undefined &&
                    vm.sampleFilters[key] !== "") {
                    filterCount++;
                }
            }
            vm.totalFilters = filterCount;
            
        	vm.transition();
        }

		vm.toggleStarredView = function() {
			$scope.starred = !$scope.starred;

			vm.filterSubmit();
		}

        function setPageTitle(){
            $rootScope.pageTitle = "Company Page";
            $rootScope.searchVm = vm;
        }

        vm.itemsPerPage = "20";
        vm.customerHash = pagingParams.hash ? pagingParams.hash : 100;


        vm.populateTypes = function() {
        	if (vm.sampleFilters.category) {
        		vm.productTypes = ProductTypeByCategory.query(vm.sampleFilters.category);
        	} else {
        		vm.productTypes = [];
        	}

        }

		vm.productCategories = ProductCategory.query();

		
		function showFiles(attachments) {
			var available_attachments = []

			attachments.forEach( function(attachment) {
				if(vm.showFile(attachment.file_name)) {
					available_attachments.push(attachment);
				}
			});

			return available_attachments;
		}


        $scope.getAttachments = function (sample,id) {
	        vm.getAttachmentsLoader = true;
	        vm.idOfSelectedSample = id;


	        if(sample.attachments != null){
		        vm.getAttachmentsLoader = false;
		        return;
	        }

	        CompanyPage.getAttachments({id: sample.hash}, onSuccess, onError);
	        function onSuccess(data, headers) {
		        vm.getAttachmentsLoader = false;
		        sample.attachments = showFiles(data);

	        }
	        function onError(error) {
	        	AlertService.error(error.data.message);
	        }
        }

		$scope.downloadAttachment = function (id_hash, sample) {
		    SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

		    function onSuccess(data, headers) {
	            var a = document.createElement("a");
	            document.body.appendChild(a);
	            a.style = "display: none";

	            var fileURL = window.URL.createObjectURL(data.data);
	            a.href = fileURL;
				a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
	            a.click();
		        sample.select = "";
		    }
		    function onError(error) {

		    }
		}

        vm.createSamplePublicLink = function(sample) {
            var hash = sample.hash;
            var fullUrl = window.location.origin +"/#/ps/"+ sample.hash;
            vm.currentPublicSample = sample;
            ensureCompanyPageSampleBatchData(sample).catch(function(error) {
                console.error('GraphQL Error preloading company page sample batch data:', error);
            });
            return fullUrl;
        }

        vm.emailsPending = [""];
        vm.emailMessage = "";


        vm.sendPublicEmail = function (form) {
            vm.emailsPending = $('#testtaginput').tagsinput('items')
            vm.emailSubject = $('#emailSubject').val();
            //Send The Email
            if (form.$valid && vm.emailsPending.length > 0){
                $('#sendPublicSampleButton').attr("disabled", true);
                ensureCompanyPageSampleBatchData(vm.currentPublicSample).then(function() {
                    CompanyPage.sendEmail({
                        emails: vm.emailsPending,
                        message: vm.emailMessage,
                        public_link: vm.emailSamplePublicLink,
                        pic_url: vm.currentPublicSample.picture,
                        id: vm.currentPublicSample.hash,
                        totalTHC: getTotalThc(vm.currentPublicSample),
                        subject: vm.emailSubject
                    }, onSuccess, onError);
                }).catch(function(error) {
                    console.error('GraphQL Error loading company page sample data for email:', error);
                    $('#sendPublicSampleButton').attr("disabled", false);
                    AlertService.error('Unable to load sample potency right now.');
                });
            }
            else {
                if (vm.emailsPending.length == 0)
                    $('#emailValidation').show();
                return
            }
        	function onSuccess(data, headers) {
        		$('#emailModal').modal('hide');
        		$('#emailModalSuccess').modal('show');
        		$('#sendPublicSampleButton').attr("disabled", false);

	        }

	        function onError(error) {
	        	AlertService.error(error.data.message);
	        	vm.emailsPending = [""];
	            vm.emailMessage = "";
	            $('#sendPublicSampleButton').attr("disabled", false);

	        }
        }

    $('#emailModalSuccess').on('hidden.bs.modal', function() {
        	$('#testtaginput').tagsinput('removeAll');
        	$('#testtaginput').tagsinput('input')[0].placeholder = 'email@example.com';
        })


		$('#testtaginput').tagsinput({
			tagClass: function(item) {
				return 'custom-label label-email'
			}
		});

		$('#testtaginput').on('beforeItemAdd', function(event) {
			var email_re = "^\S+@\S+$";
			if (!event.item.match(/\S+@\S+\.\S+/)) {
				$('#emailValidation').show();
				event.cancel = true;
			} else {
				$('#emailValidation').hide();
				$('#testtaginput').tagsinput('input')[0].placeholder = '';
			}
		});

		$('#testtaginput').on('beforeItemRemove', function(event) {
			if ($('#testtaginput').tagsinput('input')[0].value.length > 0)
				event.cancel = true;
			  // event.item: contains the item
			  // event.cancel: set to true to prevent the item getting removed
		});

		$('#testtaginput').tagsinput('input')[0].type = 'email'

		function updateFilterCount() {
			var filterCount = 0;
			for (var key in vm.sampleFilters) {
				if (vm.sampleFilters[key] !== null &&
					vm.sampleFilters[key] !== undefined &&
					vm.sampleFilters[key] !== "") {
					filterCount++;
				}
			}
			vm.totalFilters = filterCount;
		}

		function buildGraphQLFilters() {
			var filters = {};
			var sf = vm.sampleFilters;

			if (sf.id) filters.id = parseInt(sf.id);
			if (sf.orderId) filters.orderId = parseInt(sf.orderId);
			if (sf.sampleName) filters.sampleName = sf.sampleName;
			if (sf.lotNumber) filters.lotNumber = sf.lotNumber;
			if (sf.metrcId) filters.metrcId = sf.metrcId;
			if (sf.categoryIdList && sf.categoryIdList.length) filters.categoryIdList = sf.categoryIdList;
			if (sf.category && sf.category.id) filters.categoryIdList = [sf.category.id];
			if (sf.subCategory && sf.subCategory.id) filters.subCategoryId = sf.subCategory.id;
			if (sf.orderType && sf.orderType !== 'ALL') filters.orderType = sf.orderType;
			if (sf.thcLower) filters.thcLower = parseFloat(sf.thcLower);
			if (sf.thcUpper) filters.thcUpper = parseFloat(sf.thcUpper);
			if (sf.cbdLower) filters.cbdLower = parseFloat(sf.cbdLower);
			if (sf.cbdUpper) filters.cbdUpper = parseFloat(sf.cbdUpper);
			if (sf.isPass) filters.isPass = true;
			if (sf.isFail) filters.isFail = true;
			if (sf.isUndetermined) filters.isUndetermined = true;
			if (sf.visibility) filters.visibility = sf.visibility;
			if (sf.isWeedmapsSuccess) filters.isWeedmapsSuccess = true;
			if (sf.isWeedmapsFail) filters.isWeedmapsFail = true;
			if (sf.isWeedmapsNone) filters.isWeedmapsNone = true;
			if (sf.starred || $scope.starred) filters.starred = true;

			if (sf.completeDateLower) {
				filters.completeDateLower = $filter('date')(sf.completeDateLower, 'yyyy-MM-dd');
			}
			if (sf.completeDateUpper) {
				filters.completeDateUpper = $filter('date')(sf.completeDateUpper, 'yyyy-MM-dd');
			}
			if (sf.estimatedDueDateLower) {
				filters.estimatedDueDateLower = $filter('date')(sf.estimatedDueDateLower, 'yyyy-MM-dd');
			}
			if (sf.estimatedDueDateUpper) {
				filters.estimatedDueDateUpper = $filter('date')(sf.estimatedDueDateUpper, 'yyyy-MM-dd');
			}
			if (vm.currentSearch) {
				filters.search = vm.currentSearch;
			}

			return filters;
		}

		function mapGraphQLSample(sample) {
			return {
				id: sample.id,
				name: sample.name,
				hash: sample.hash,
				picture: sample.pictureUrl || "content/images/no_image_available-small.png",
				lot_batch_number: sample.lotBatchNumber,
				lotBatchNumber: sample.lotBatchNumber,
				status: sample.status,
				starred: sample.starred,
				is_public: sample.isPublic,
				isPublic: sample.isPublic,
				canSeeReport: sample.canSeeReport,
				can_see_report: sample.canSeeReport,
				complete: sample.complete,
				rd: sample.rd,
				s_code: sample.sCode,
				sCode: sample.sCode,
				sample_matrix: sample.sampleMatrix,
				sampleMatrix: sample.sampleMatrix,
				weedmaps_state: sample.weedmapsState,
				weedmapsState: sample.weedmapsState,
				order_id: sample.orderId,
				customerOrderId: sample.orderId,
				order: {
					id: sample.orderId,
					date_received: sample.orderDateReceived,
					dateReceived: sample.orderDateReceived,
					date_completed: sample.orderDateCompleted,
					dateCompleted: sample.orderDateCompleted,
					order_type: sample.orderType
				},
				customerOrder: {
					id: sample.orderId,
					dateReceived: sample.orderDateReceived,
					dateCompleted: sample.orderDateCompleted
				},
				productCategory: sample.productCategoryName ? { name: sample.productCategoryName } : null,
				productType: sample.productTypeName ? { name: sample.productTypeName } : null,
				strainName: sample.strainName ? { name: sample.strainName } : null,
				strainType: sample.strainType ? { name: sample.strainType } : null,
				dueDateDisplay: sample.dueDate,
				receivedDate: sample.orderDateReceived,
				dateCompleted: sample.orderDateCompleted,
				testCount: sample.testCount,
				sampleTests: [],
				thcDisplay: null,
				cbdDisplay: null,
				totalCannabinoidsDisplay: null
			};
		}

		function getCompanyPageBatchQuery() {
			return [
				'query GetCompanyPageSamplesBatch($customerHash: String!, $sampleIds: [Int!]!) {',
				'  companyPageSamplesBatch(customerHash: $customerHash, sampleIds: $sampleIds) {',
				'    sampleId',
				'    thc',
				'    cbd',
				'    totalCannabinoids',
				'    tests {',
				'      id',
				'      assayId',
				'      assayTitle',
				'      assayPortalIdentifier',
				'      assayWorksheetId',
				'      state',
				'      statusPf',
				'      canSeeResults',
				'      caution',
				'      estimatedCompleteDate',
				'      worksheetData',
				'    }',
				'  }',
				'}'
			].join('\n');
		}

		function applyCompanyPageBatchPayload(sample, payload) {
			if (!sample || !payload) {
				return sample;
			}

			sample.thcDisplay = payload.thc;
			sample.cbdDisplay = payload.cbd;
			sample.totalCannabinoidsDisplay = payload.totalCannabinoids;
			sample.sampleTests = (payload.tests || []).map(function(test) {
				return {
					id: test.id,
					assay: {
						id: test.assayId,
						title: test.assayTitle,
						portalIdentifier: test.assayPortalIdentifier,
						worksheet_id: test.assayWorksheetId
					},
					state: test.state,
					statusPf: test.statusPf,
					canSeeResults: test.canSeeResults,
					caution: test.caution,
					estimatedCompleteDate: test.estimatedCompleteDate,
					worksheetData: test.worksheetData
				};
			});
			sample._companyPageBatchLoaded = true;
			vm.testResultsCache[sample.id] = sample.sampleTests;
			return sample;
		}

		function ensureCompanyPageSampleBatchData(sample) {
			if (!sample) {
				return $q.reject(new Error('Missing sample'));
			}

			if (sample._companyPageBatchLoaded ||
				(sample.sampleTests && sample.sampleTests.length > 0) ||
				sample.thcDisplay ||
				sample.cbdDisplay ||
				sample.totalCannabinoidsDisplay) {
				sample._companyPageBatchLoaded = true;
				return $q.when(sample);
			}

			if (sample._companyPageBatchPromise) {
				return sample._companyPageBatchPromise;
			}

			var batchPromise = GraphQLService.publicQuery(getCompanyPageBatchQuery(), {
				customerHash: vm.customerHash,
				sampleIds: [sample.id]
			}).then(function(data) {
				var payload = (data.companyPageSamplesBatch || [])[0];
				if (payload) {
					applyCompanyPageBatchPayload(sample, payload);
				} else {
					sample._companyPageBatchLoaded = true;
				}
				return sample;
			}, function(error) {
				return $q.reject(error);
			});

			sample._companyPageBatchPromise = batchPromise;
			batchPromise.finally(function() {
				sample._companyPageBatchPromise = null;
			});
			return batchPromise;
		}

		function loadCompanyPageBatchData() {
			if (!vm.samples || vm.samples.length === 0) return;

			var sampleIds = vm.samples.map(function(sample) { return sample.id; });
			GraphQLService.publicQuery(getCompanyPageBatchQuery(), {
				customerHash: vm.customerHash,
				sampleIds: sampleIds
			}).then(function(data) {
				var payloadBySampleId = {};
				(data.companyPageSamplesBatch || []).forEach(function(payload) {
					payloadBySampleId[payload.sampleId] = payload;
				});

				vm.samples.forEach(function(sample) {
					var payload = payloadBySampleId[sample.id];
					if (!payload) {
						return;
					}

					applyCompanyPageBatchPayload(sample, payload);
				});
			}).catch(function(error) {
				console.error('GraphQL Error loading company page batch data:', error);
			});
		}

		function cancelDeferredCompanyPageBatchLoad() {
			if (!deferredCompanyPageBatchLoad) {
				return;
			}

			if (deferredCompanyPageBatchLoad.type === 'timeout') {
				$timeout.cancel(deferredCompanyPageBatchLoad.handle);
			} else if (deferredCompanyPageBatchLoad.type === 'idle' && window.cancelIdleCallback) {
				window.cancelIdleCallback(deferredCompanyPageBatchLoad.handle);
			}

			deferredCompanyPageBatchLoad = null;
		}

		function scheduleCompanyPageBatchLoad() {
			cancelDeferredCompanyPageBatchLoad();

			if (window.requestIdleCallback) {
				deferredCompanyPageBatchLoad = {
					type: 'idle',
					handle: window.requestIdleCallback(function() {
						deferredCompanyPageBatchLoad = null;
						loadCompanyPageBatchData();
					}, { timeout: 800 })
				};
				return;
			}

			deferredCompanyPageBatchLoad = {
				type: 'timeout',
				handle: $timeout(function() {
					deferredCompanyPageBatchLoad = null;
					loadCompanyPageBatchData();
				}, 250, false)
			};
		}

		function loadAllWithGraphQL() {
			var samplesQuery = [
				'query GetCompanyPageSamples($customerHash: String!, $page: Int!, $size: Int!, $sort: String, $filters: SampleFilters) {',
				'  companyPageSamplesList(customerHash: $customerHash, page: $page, size: $size, sort: $sort, filters: $filters) {',
				'    samples {',
				'      id',
				'      name',
				'      hash',
				'      pictureUrl',
				'      lotBatchNumber',
				'      status',
				'      starred',
				'      isPublic',
				'      canSeeReport',
				'      complete',
				'      rd',
				'      sCode',
				'      sampleMatrix',
				'      weedmapsState',
				'      orderId',
				'      orderDateReceived',
				'      orderDateCompleted',
				'      orderType',
				'      productCategoryName',
				'      productTypeName',
				'      strainName',
				'      strainType',
				'      dueDate',
				'      testCount',
				'    }',
				'    totalCount',
				'  }',
				'}'
			].join('\n');

			return GraphQLService.publicQuery(samplesQuery, {
				customerHash: vm.customerHash,
				page: vm.page || pagingParams.page || 1,
				size: parseInt(vm.itemsPerPage) || 20,
				sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				filters: buildGraphQLFilters()
			}).then(function(data) {
				vm.samples = (data.companyPageSamplesList.samples || []).map(mapGraphQLSample);
				vm.totalItems = data.companyPageSamplesList.totalCount;
				vm.queryCount = vm.totalItems;
				vm.page = pagingParams.page;
				vm.pagingParams = pagingParams;
				updateFilterCount();
				scheduleCompanyPageBatchLoad();
			});
		}

		function handleCompanyPageGraphQLError(error) {
			console.error('GraphQL Error loading company page samples:', error);
			AlertService.error('Unable to load company page samples right now.');
		}

		function loadAll () {
			loadAllWithGraphQL().catch(handleCompanyPageGraphQLError);
        }

	    function getCustomerData () {
	        CompanyPage.getCustomer({customer_hash: vm.customerHash}, onSuccess, onError); //Does not work for this page.
	        function onSuccess(data, headers) {
	             vm.customerData = data;
	        }
	        function onError(error) {
	        }
	    }

	    getCustomerData();

        /* Hover functions */
        function isOtherAnalysis(test){
        	if (test && test.assay && test.assay.id){
        		if (test.assay.id == 26 || test.assay.id == 15 || test.assay.id == 18 || test.assay.id == 19) {
        			return true;
        		}
        	}
        	return false;
        }
        function hasOtherAnalyses(sample){
        	if (!sample.sampleTests) return false;
        	for (var i=0; i < sample.sampleTests.length; i++){
        		if (!sample.sampleTests[i].assay) continue;
        		if (isOtherAnalysis(sample.sampleTests[i])){
        			return true;
        		}
        	}
        	return false;
        }
		function hasCannabinoids(sample){
			if (!sample || !sample.sampleTests || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return false;
			}
			for (var i=0; i < sample.sampleTests.length; i++){
				if (isCannabinoidWorksheet(sample.sampleTests[i])){
					return true;
				}
			}
	        	return false;
	        }

		function getTotalThc(sample) {
			if (sample && sample.thcDisplay) {
				return sample.thcDisplay;
			}
			if (!sample || !sample.sampleTests || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
				return 'N/A';
			}
        	for (var i = 0; i < sample.sampleTests.length; i++){
        		var test = sample.sampleTests[i];
	        		if (!isCannabinoidWorksheet(test) || !test.worksheetData) {
	        			continue;
	        		}
        		var ws = test.worksheetData;
        		var percentField = ws.total_dry_percent ? ws.total_dry_percent : ws.total_percent;
        		var display = formatPotencyValue(percentField, '%', { noLeadingSpace: true });
        		if (display) {
        			return display;
        		}
        	}
        	return 'N/A';
	        }

	        function getWorksheetPotency(ws, potencyType, isTotal) {
	        	if (!ws) {
	        		return '';
	        	}
	        	var potency = '';

        	if (ws['total_' + potencyType + '_mgpp']) {
        		potency = isTotal ? formatPotencyValue(ws['total_mgpp'], 'mg/pkg') : formatPotencyValue(ws['total_' + potencyType + '_mgpp'], 'mg/pkg');
        	}

        	if (!potency && isSingleUnitPackage(ws)) {
        		potency = isTotal ? formatPotencyValue(ws['total_mgpu'], 'mg/serving') : formatPotencyValue(ws['total_' + potencyType + '_mgpu'], 'mg/serving');
        	}

        	if (!potency && hasMoistureValue(ws)) {
        		potency = isTotal
        			? formatPotencyValue(ws['total_dry_percent'], '%', { noLeadingSpace: true, trailingText: ' (dry)' })
        			: formatPotencyValue(ws['total_' + potencyType + '_dry_percent'], '%', { noLeadingSpace: true, trailingText: ' (dry)' });
        	}

        	if (!potency) {
        		potency = isTotal
        			? formatPotencyValue(ws['total_percent'], '%', { noLeadingSpace: true })
        			: formatPotencyValue(ws['total_' + potencyType + '_percent'], '%', { noLeadingSpace: true });
        	}

        	return potency;
        }

        function formatPotencyValue(field, unit, options) {
        	if (!field) {
        		return '';
        	}
        	var zeroValue = isZeroField(field);
        	var displayValue = getWorksheetDisplayValue(field);
        	if ((displayValue === null || displayValue === undefined || displayValue === '') && !zeroValue) {
        		return '';
        	}

        	var formattedValue = zeroValue ? '0' : displayValue;
        	var result = formattedValue;
        	var opts = options || {};

        	if (unit) {
        		var separator = opts.noLeadingSpace ? '' : ' ';
        		result += separator + unit;
        	}

        	if (opts.trailingText) {
        		result += opts.trailingText;
        	}

        	return result;
        }

        function getWorksheetDisplayValue(field) {
        	if (!field) {
        		return null;
        	}
        	if (typeof field === 'object') {
        		var bestValue = null;
        		var bestDigits = Number.MAX_VALUE;

        		if (hasContent(field.twoDecimalFormattedValue)) {
        			bestValue = field.twoDecimalFormattedValue;
        			bestDigits = countDigits(bestValue);
        		}

        		if (hasContent(field.value)) {
        			var normalizedValue = normalizeNumericValue(field.value);
        			var rawDigits = countDigits(normalizedValue);
        			if (bestValue === null || rawDigits < bestDigits) {
        				bestValue = normalizedValue;
        				bestDigits = rawDigits;
        			}
        		}

        		if (bestValue !== null) {
        			return bestValue;
        		}
        	}
        	return field;
        }

        function getWorksheetRawValue(field) {
        	if (!field) {
        		return null;
        	}
        	if (typeof field === 'object') {
        		if (hasContent(field.value)) {
        			return field.value;
        		}
        		if (hasContent(field.twoDecimalFormattedValue)) {
        			return field.twoDecimalFormattedValue;
        		}
        	}
        	return field;
        }

        function isZeroField(field) {
        	var raw = getWorksheetRawValue(field);
        	if (raw === null || raw === undefined || raw === '') {
        		return false;
        	}
        	if (typeof raw === 'number') {
        		return raw === 0;
        	}
        	var parsed = parseFloat(raw);
        	return !isNaN(parsed) && parsed === 0;
        }

        function hasContent(value) {
        	return value !== undefined && value !== null && value !== '';
        }

        function countDigits(value) {
        	var text = (value + '').trim();
        	if (!text) {
        		return 0;
        	}
        	var digitsOnly = text.replace(/[^0-9]/g, '');
        	return digitsOnly.length ? digitsOnly.length : text.length;
        }

        function normalizeNumericValue(value) {
        	if (value === null || value === undefined || value === '') {
        		return '';
        	}
        	var numberValue = Number(value);
        	if (!isFinite(numberValue)) {
        		return (value + '').trim();
        	}
        	var normalized = numberValue.toString();
        	if (normalized.indexOf('e') !== -1 || normalized.indexOf('E') !== -1) {
        		normalized = numberValue.toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
        	}
        	if (normalized.indexOf('.') !== -1) {
        		normalized = normalized.replace(/\.0+$/, '');
        	}
        	return normalized;
        }

	        function isSingleUnitPackage(ws) {
	        	if (!ws || ws.units_per_package === undefined || ws.units_per_package === null) {
	        		return false;
	        	}
	        	var raw = getWorksheetRawValue(ws.units_per_package);
	        	if (raw === null || raw === undefined || raw === '') {
	        		return true;
	        	}
	        	if (typeof raw === 'number') {
	        		return raw === 1;
	        	}
	        	var parsed = parseFloat(raw);
	        	if (!isNaN(parsed)) {
	        		return parsed === 1;
	        	}
	        	return raw === '1';
	        }

	        function hasMoistureValue(ws) {
	        	if (!ws || !ws.moisture) {
	        		return false;
	        	}
	        	var raw = getWorksheetRawValue(ws.moisture);
	        	if (raw === null || raw === undefined || raw === '') {
	        		return false;
	        	}
	        	if (typeof raw === 'number') {
	        		return raw !== 0;
	        	}
	        	var parsed = parseFloat(raw);
	        	if (isNaN(parsed)) {
	        		return false;
	        	}
	        	return parsed !== 0;
	        }

	        function isCannabinoidWorksheet(test) {
	        	if (!test || !test.assay || !vm.cannabioidWorksheets || !vm.cannabioidWorksheets.length) {
	        		return false;
	        	}
	        	return vm.cannabioidWorksheets.indexOf(test.assay.worksheet_id) !== -1;
	        }

        vm.copyLink = function(id) {
      	  /* Get the text field */
      	  var copyText = document.getElementById(id);
      	  /* Select the text field */
      	  copyText.select();
      	  copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      	  /* Copy the text inside the text field */
      	  document.execCommand("copy");
        }

       loadAll();

       if (vm.sampleFilters.category) {
       	vm.populateTypes();
       }

       vm.startIndex = 0;
       vm.endIndex = 0;

    }

})();

(function() {
    'use strict';
    /* TODO: Clean all this because unnecessary page params */
    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('companypage', {
            parent: 'app',
            url: '/companypage?page&hash&sort&search&productCategoryId&items&id&orderId&sampleName&lotNumber&metrcId&categoryIdList&orderType&thcLower&thcUpper&cbdLower&cbdUpper&isPass&isFail&isUndetermined&isWeedmapsSuccess&isWeedmapsFail' +
            	'&isWeedmapsNone&visibility&completeDateLower&completeDateUpper&estimatedDueDateLower&estimatedDueDateUpper&galleryView&starred',
            data: {
                authorities: [],
                pageTitle: 'Company Page'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/company-page/companypage.html',
                    controller: 'CompanyPageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,

                productCategoryId: {
                    value: '0',
                    squash: true
                },
                items: null,
                /* Filter params */
        		id: null,
        		orderId: null,
        		sampleName: null,
        		lotNumber: null,
        		metrcId: null,
        		categoryIdList: null,
        		category: null,
        		subCategory: null,
        		orderType: null,
        		thcLower: null,
        		thcUpper: null,
        		cbdLower: null,
        		cbdUpper: null,
        		isPass: null,
        		isFail: null,
        		isUndetermined: null,
        		isWeedmapsSuccess: null,
        		isWeedmapsFail: null,
        		isWeedmapsNone: null,
        		visibility: null,
        		completeDateLower: null,
        		completeDateUpper: null,
        		estimatedDueDateLower: null,
        		estimatedDueDateUpper: null,
        		galleryView: null,
        		starred:null,
        		hash:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {

                    return {
                    	/* Paging Params */
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        items: $stateParams.items,
                        /* Filter Params */
                        id: $stateParams.id ? parseInt($stateParams.id) : null,
                        orderId: $stateParams.orderId ? parseInt($stateParams.orderId) : null,
                        sampleName: $stateParams.sampleName,
                        hash: $stateParams.hash,
                        lotNumber: $stateParams.lotNumber,
                        metrcId: $stateParams.metrcId,
                        categoryIdList: $stateParams.categoryIdList,
                        category: $stateParams.category,
                        subCategory: $stateParams.subCategory,
                        orderType: $stateParams.orderType,
                        thcLower: $stateParams.thcLower ? parseInt($stateParams.thcLower) : null,
                        thcUpper: $stateParams.thcUpper ? parseInt($stateParams.thcUpper) : null,
                        cbdLower: $stateParams.cbdLower ? parseInt($stateParams.cbdLower) : null,
                        cbdUpper: $stateParams.cbdUpper ? parseInt($stateParams.cbdUpper) : null,
                        isPass: $stateParams.isPass,
                        isFail: $stateParams.isFail,
                        isUndetermined: $stateParams.isUndetermined,
                        isWeedmapsSuccess: $stateParams.isWeedmapsSuccess,
                        isWeedmapsFail: $stateParams.isWeedmapsFail,
                        isWeedmapsNone: $stateParams.isWeedmapsNone,
                        visibility: $stateParams.visibility,
                        completeDateLower: $stateParams.completeDateLower,
                        completeDateUpper: $stateParams.completeDateUpper,
                        estimatedDueDateLower: $stateParams.estimatedDueDateLower,
                        estimatedDueDateUpper: $stateParams.estimatedDueDateUpper,
                        galleryView: $stateParams.galleryView,
                        starred: $stateParams.starred
                    }
                }],
            }
        })
        
    }


})();

(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('CompanyPage', CompanyPage);

    CompanyPage.$inject = ['$resource'];

    function CompanyPage ($resource) {

        return $resource('api/companypage/:id', {id: '@id', public: '@public', emails: '@emails', message: '@message', subject: '@subject', public_link: '@public_link', pic_url: '@pic_url', totalTHC: '@totalTHC', customer_hash: '@customer_hash', params: '@params'}, {
            query: { method: 'GET', isArray: true, params: {hash: '@id', params: '@params'} },
            get: {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            public: {
                url: 'api/companypage/:id:public',
                method: 'PUT'
            },
            getCustomer:{
            	url: 'api/companypage/customer',
            	method: 'GET',
            	params: {customer_hash: 'customer_hash'}
            },
            getBulkPictures: {
            	url: 'api/public/samples/pictures',
            	method: 'GET',
            	isArray:false,
            	params: {ids: '@ids'}
            },
            getAttachments:{
            	url: 'api/public/:id/attachments',
            	method: 'GET',
            	isArray:true,
            },
            sendEmail: {
            	url: 'api/public/email',
            	method: 'PUT',
            	params: {emails: '@emails', message: '@message', public_link: '@public_link', sample_id: '@id', pic_url: '@pic_url', totalTHC: '@totalTHC', subject: '@subject'}
            }
        });

    }

})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('calendar', {
            parent: 'app',
            url: '/calendar',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Estimated Due Date Calendar'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            }
        }).state('calendar.dayModal', {
            url: '/day',
            params: {
            	date: null,
            	samples: null,
            	queryParams: null
            },
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$uibModal', function($uibModal) {
                $uibModal.open({
                    templateUrl: 'app/pages/calendar/calendar-day-modal.html',
                    controller: 'CalendarDayModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                    	PreviousState: function() {
                    		return {
                    			name: 'calendar'
                    		}
                    	}
                    }
                });
            }]
        });
    }


})();

(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('CalendarController', CalendarController)
        .controller('CalendarDayModalController', CalendarDayModalController);

    CalendarController.$inject = ['$state','$stateParams','$scope','$rootScope', '$timeout', '$filter', 'ProductCategory', 'SampleFilter', 'Config', '$translate'];

    function CalendarController($state, $stateParams, $scope, $rootScope, $timeout, $filter, ProductCategory, SampleFilter, Config, $translate) {

		var vm = this;
		console.log("Processing calendar");
		vm.currentLanguage = $translate.proposedLanguage();
		$rootScope.pageTitle = $state.current.data.pageTitle;
		foodClientOptions()

        // Toggle Widgets
        vm.toggleWidget = function(name) {
        	vm.activeWidget = name === vm.activeWidget ? null : name;
		}

        // Filter Options
        vm.calendarFilters = {};
        vm.orderStatuses = [
            {text: 'Created', value: 'CREATED'},
            {text: 'Samples Received', value: 'SAMPLES_RECEIVED'},
            {text: 'Preliminary Results', value: 'PRELIMINARY_RESULTS'},
            {text: 'Completed', value: 'COMPLETED'}
        ]
        vm.filterOptions = [
        	{text: "R&D", value: 'RD'},
        	{text: "Compliance", value: 'COMPLIANCE'}
        ];

        vm.categories = [];
        var categoryNames = [];
        ProductCategory.query(function(categories){
        	if (!categories) return;
//        	for (var i = 0; i < categories.length; i++){
//        		vm.filterOptions.push({text: categories[i].name, value: categories[i].id});
//        		categoryNames.push(categories[i].name);
//        	}
			vm.categories = categories;
		});

		Config.holidays({},
			function(data) {
				var arrayOfHolidays = []
				data.holidays.forEach(element => {
					for(var i = moment().subtract(2, 'years').year(); i <= moment().add(2, 'years').year(); i++){
						var date = element.date.replace('2021',i.toString())
						arrayOfHolidays.push({date,name:element.name,imageUrl:element.imageUrl});
					} 
				})
				vm.holidays = arrayOfHolidays
				// vm.holidays = data.holidays
			},
			function(e) {
				console.log(e);
			}
		);

		vm.blackoutDates = []
		vm.blackoutDateswithNames = []

        vm.filterSamples = function() {
        	vm.calendarLoading = true;
        	vm.calendarHeader = $('#estimatedDueDateCalendar .fc-header-toolbar .fc-left h2').text();

        	SampleFilter.calendar(createQueryParams(), function(samples){
        		vm.calendarLoading = false;
				vm.calendarLoadError = false;
				
				var start_date = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.start._d);
				var end_date = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.end._d)
				for(var m = moment(start_date); m.diff(end_date, 'days') <= 0; m.add(1, 'days')) {						
					if([0, 6].includes(m.day())) {
						// if([0, 6].includes(m.day()) || vm.holidays.date.includes(m.format('YYYY-MM-DD'))) {
						vm.blackoutDates.push(m.format('YYYY-MM-DD'));
						vm.blackoutDateswithNames.push(m.format('YYYY-MM-DD'))
					}
				}
				vm.holidays.forEach(e => {
					var holiday = moment(e.date)
					vm.blackoutDates.push(holiday.format('YYYY-MM-DD'));
					vm.blackoutDateswithNames.push({
						date:holiday.format('YYYY-MM-DD'),
						name:e.name,
						imageUrl:e.imageUrl
					})
				})
        		var events = [];
        		if (samples && samples.length) {
        			for (var i = 0; i < samples.length; i++) {
        				var day = moment(samples[i].dueDate).toDate();
        				var event = {
        						id: samples[i].id,
        						name: samples[i].name ? samples[i].name : '',
        						title: samples[i].id + ' ' + samples[i].name,
        						start: day,
        						end: day,
        						allDay: true,
        						hash: samples[i].hash
        				}
        				events.push(event);
        			}
        		}
        		vm.events[0] = events;
				$('#estimatedDueDateCalendar').fullCalendar('getView').dayGrid.renderGrid();
				
        	}, function(error) {
        		vm.calendarLoading = false;
        		vm.calendarLoadError = true;
        	});
        }
		
        // Calendar
        vm.events = [];

        vm.prevMonth = function() { $('#estimatedDueDateCalendar > div.fc-toolbar.fc-header-toolbar > div.fc-right > div > button.fc-prev-button').click(); vm.filterSamples(); }
        vm.nextMonth = function() { $('#estimatedDueDateCalendar > div.fc-toolbar.fc-header-toolbar > div.fc-right > div > button.fc-next-button').click(); vm.filterSamples(); }
        vm.today = function() { $('#estimatedDueDateCalendar > div.fc-toolbar.fc-header-toolbar > div.fc-right > button.fc-today-button').click(); vm.filterSamples(); }

        vm.openPublicSample = function(event, jsEvent, view) { $state.go('public', {hash: event.hash}); }

        function openDayModal(date) {
			var modalParams = {
					samples: []
			};
			$('#estimatedDueDateCalendar').fullCalendar('clientEvents', function(event) {
				if (event.start.format('YYYY-MM-DD') === date) {
					modalParams.samples.push({
						id: event.id,
						name: event.name,
						hash: event.hash
					});
    				modalParams.date = event.start;
    				modalParams.queryParams = createQueryParams();
    				$state.go('calendar.dayModal', modalParams);
				}
			});
        }
		vm.backgroundImages = {
			'2023-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2023-02-15': 'content/images/calendar_images/PresidentsDay.jpg',
			'2023-05-31': 'content/images/calendar_images/MemorialDay.jpg',
			'2023-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2023-09-06': 'content/images/calendar_images/LaborDay.jpg',
			'2023-11-25': 'content/images/calendar_images/ThanksGiving.jpg',
			'2023-11-26': 'content/images/calendar_images/ThanksGiving1.jpg',
			'2023-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2023-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2023-12-31': 'content/images/calendar_images/newYearEve.jpg',

			'2024-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2024-02-15': 'content/images/calendar_images/PresidentsDay.jpg',
			'2024-05-27': 'content/images/calendar_images/MemorialDay.jpg',
			'2024-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2024-09-02': 'content/images/calendar_images/LaborDay.jpg',
			'2024-11-28': 'content/images/calendar_images/ThanksGiving.jpg',
			'2024-11-29': 'content/images/calendar_images/ThanksGiving1.jpg',
			'2024-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2024-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2024-12-31': 'content/images/calendar_images/newYearEve.jpg',

			'2025-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2025-02-17': 'content/images/calendar_images/PresidentsDay.jpg',
			'2025-05-26': 'content/images/calendar_images/MemorialDay.jpg',
			'2025-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2025-09-01': 'content/images/calendar_images/LaborDay.jpg',
			'2025-11-27': 'content/images/calendar_images/ThanksGiving.jpg',
			'2025-11-28': 'content/images/calendar_images/ThanksGiving1.jpg',
			'2025-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2025-12-25': 'content/images/calendar_images/Christmas1.jpg',

			'2026-01-01': 'content/images/calendar_images/NewYear.jpg',
			'2026-02-16': 'content/images/calendar_images/PresidentsDay.jpg',
			'2026-05-25': 'content/images/calendar_images/MemorialDay.jpg',
			'2026-07-04': 'content/images/calendar_images/4thJuly.jpg',
			'2026-09-07': 'content/images/calendar_images/LaborDay.jpg',
			'2026-11-26': 'content/images/calendar_images/thanksGiving.png',
			'2026-11-27': 'content/images/calendar_images/thanksGiving1.png',
			'2026-12-24': 'content/images/calendar_images/Christmas.jpg',
			'2026-12-25': 'content/images/calendar_images/Christmas1.jpg',
			'2026-12-31': 'content/images/calendar_images/newYearEve.jpg'
		};
        vm.calendarOptions = {
        		firstDay: 1,
    			dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    			dayNamesShort: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    			eventLimit: true,
    			eventLimitClick: function(cellInfo, jsEvent) {
    				var modalParams = {samples: []};
    				for (var i = 0; i < cellInfo.segs.length; i++){
    					var def = cellInfo.segs[i].footprint.eventInstance.def;
    					modalParams.samples.push({
    						id: def.id,
    						name: def.miscProps.name,
    						hash: def.miscProps.hash
    					});
    				}
    				modalParams.date = cellInfo.date;
    				modalParams.queryParams = createQueryParams();
    				$state.go('calendar.dayModal', modalParams);
    			},
    			eventRender: function(event, element) {
					return '<div class="calendar-sample-event"><strong>' + event.id + '</strong> ' + event.name + '</div>'
    			},
    			eventClick: vm.openPublicSample,
    			viewRender: vm.filterSamples,
    			dayRender: function(date, cell) {
    				cell.append('<div class="calendar-day-no-samples">'+$translate.instant("No Samples")+'</div>');
    				var thing = $('<a class="calendar-see-list-btn" data-date="' + date.format('YYYY-MM-DD') + '">'+ $translate.instant("see list") +'</a>');
    				thing.click(function(){
    					openDayModal(date.format('YYYY-MM-DD'));
    				});
    				cell.append(thing);
					var currentDate = date.format('YYYY-MM-DD');
					if (currentDate in vm.backgroundImages) {
						var cellId = 'cell_' + currentDate;
						cell.attr('id', cellId);
						var backgroundImageUrl = vm.backgroundImages[currentDate];
						cell.css('background-image', 'url(' +backgroundImageUrl+ ')');
						cell.css('object-fit','contain')
						cell.css('background-size','100% 100%');
						cell.find('div.calendar-day-no-samples').css('color', '#00000000');
						cell.addClass('cell-with-image');

						// Remove "Closed" text on days with events
						var dayOfWeek = moment(date).day();
						if (dayOfWeek === 0 || dayOfWeek === 6) {
							cell.find('.fc-day-top').text('');
							cell.find('div.calendar-day-no-samples').remove();
						}
					}
					
				},
    			eventAfterAllRender: function(view) {
    				// Remove "No Samples" text on days with events
    				$('#estimatedDueDateCalendar').fullCalendar('clientEvents', function(event) {
        				var td = $('td.fc-day[data-date="' + event.start.format('YYYY-MM-DD') + '"]');
        				td.find('div.calendar-day-no-samples').remove();
        				var seeListBtn = td.find('a.calendar-see-list-btn');
        				seeListBtn.show();

						});
						var blackout = null;
						var blackoutCount = null;
						vm.blackoutDates.forEach(function (date, i) {
							if (vm.blackoutDateswithNames[i].date === date) {
								 blackoutCount = $('td.fc-day-top[data-date="' + date + '"]')
								 blackoutCount.css('visibility', 'hidden');
							}
						
						else{
							blackout = $('td.fc-day[data-date="' + date + '"]');
							blackout.css('background-color', '#f7f7f7');
							blackout.find('div.calendar-day-no-samples').css('color', '#c5ced1')
							.text('Closed');
						}
					});

    				$('.fc-more-cell').css('text-align', 'right');
    				$('a.fc-more').css('color', '#f1b21a');	

    				// Assign click event to "see list" button
    				$('.fc-more').each(function(){
    					//var seeListBtn = $('.calendar-see-list-btn[data-date="' +)
    				});
    			}
		}

		function foodClientOptions() {
			if($rootScope.customer) {
				if($rootScope.customer.customer_type.toLowerCase().includes('food')) {
					vm.consolidated_business_type = 'food';
				}
			}

			if(!vm.consolidated_business_type) {
				vm.consolidated_business_type = 'cannabis';
			}
		}

        function createQueryParams() {
        	var params = {};
        	params.estimatedDueDateLower = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.start._d);
        	params.estimatedDueDateUpper = convertLocalDateToServer($('#estimatedDueDateCalendar').fullCalendar('getCalendar').view.end._d);

        	for (var key in vm.calendarFilters) {
        		if (!vm.calendarFilters[key]) continue;
        		params[key] = vm.calendarFilters[key];
			}
			
        	return params;
        }

        /* Date Utils (import DateUtils service doesn't work) */
        function convertLocalDateFromServer(date) {
    		if (!date) return;

    		if (date.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) utcDateString += 'Z';

            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }
    }

    CalendarDayModalController.$inject = ['$state','$stateParams','$scope','$rootScope', '$timeout', '$filter', '$uibModalInstance', 'PreviousState'];

    function CalendarDayModalController($state, $stateParams, $scope, $rootScope, $timeout, $filter, $uibModalInstance, PreviousState) {
    	var vm = this;

    	$scope.$on('$stateChangeStart', function() {
    		$scope.stateChange();
    	});
    	$scope.stateChange = function() {
    		$uibModalInstance.dismiss('cancel');
    	}

    	vm.date = $stateParams.date;
    	vm.samples = $stateParams.samples;
    	vm.queryParams = $stateParams.queryParams;

    	vm.closeModal = function() { $state.go(PreviousState.name); }

    	vm.totalSamples = vm.samples ? vm.samples.length : 0;
    	if (vm.samples) {
        	for (var i = 0; i < vm.samples.length; i++) {
        		if (vm.samples[i].id == -1) {
        			vm.totalSamples -= 1;
        			break;
        		}
        	}
    	}

    	vm.totalSamplesText = vm.totalSamples == 1 ? '1 Sample' : vm.totalSamples + ' total samples';

        vm.openPublicSample = function(event, jsEvent, view) {
        	$state.go('public', {hash: event.hash});
        }

        vm.toSamplesPage = function() {
        	var dateString = vm.date.format('YYYY-MM-DD');
        	vm.queryParams.estimatedDueDateLower = dateString;
        	vm.queryParams.estimatedDueDateUpper = dateString;


        	$state.go('samplelog', vm.queryParams);
        }
    }
})();
(function(){'use strict';angular.module('anrescowebApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<style>.fc-more-cell a.fc-more {\n\tbackground: #edf2f5;\n\tcolor: #556d85;\n\tborder-radius: 3px;\n\ttext-align: left;\n\tmargin: 2px 4px;\n\tpadding: 6px 8px;\n\tfont-family: OpenSans-Bold;\n\tcursor: pointer;\n\tmargin-top: 0.75em;\n\tdisplay: inline-block;\n}\n\n.fc-more-cell a.fc-more::after {\n\tcontent: \' samples\';\n\tfont-family: OpenSans-Regular;\n}\n#estimatedDueDateCalendar > div.fc-toolbar.fc-header-toolbar > div.fc-left > h2 {\n\tdisplay: none;\n}\n\n.a.fc-more {\n\tfont-size: 13px;\n}\n\n.sample-info-container {\n    position: relative;\n    display: inline-block;\n}\n\n.sample-info-modal {\n    display: none;\n    position: absolute;\n    background-color: white;\n    border: 1px solid #ddd;\n    padding: 10px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    min-width: 200px;\n}\n\n.sample-info-container:hover .sample-info-modal {\n    display: block;\n}</style><div ng-cloak><div><div class="tabbackall tabbackallhome"><div class="tab-content tabback home-size-res"><div class="row"><div class="col-lg-8 col-md-8 col-sm-8 col-xs-12"><div calss="row"><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="small-box bg-orange"><p>{{\'Open Orders\' | translate}}</p><div class="topbuffer05"></div><h1>{{vm.openSubmissions}}</h1><div class="topbuffer05"></div><button class="btn btn-primary small-box-button home-button btn-yellow-home" ui-sref="orders({states:[\'CREATED\',\'SAMPLES_RECEIVED\',\'PRELIMINARY_RESULTS\']})">{{\'View Orders\' | translate}}</button></div><div class="topbuffer3"></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="small-box bg-lightblue"><p>{{\'Samples In-Progress\' | translate}}</p><div class="topbuffer05"></div><h1>{{ vm.queuedSamplesCount }}</h1><div class="topbuffer05"></div><button class="btn btn-primary btn-view-samples small-box-button home-button btn-yellow-home" ui-sref="samplelog({isInProgress:true})">View Samples</button></div><div class="topbuffer3"></div></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="small-box bg-darkgrey"><p>{{\'Member Since\' | translate}}</p><div class="topbuffer05"></div><h1>{{vm.customerData.memberSince | date:\'yyyy\'}}</h1></div><div class="topbuffer3"></div></div><div ng-if="vm.billingAccess && vm.contact.receive_invoice" class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><div class="small-box bg-blue"><p>Account Balance</p><div class="topbuffer05"></div><!-- <h1>{{vm.accou ? ("&#36;" + (vm.account_balance | number:\'1.2\')) : "N/A"}}</h1> --><h1>{{vm.account_balance ? ("&#36;" + (vm.account_balance | number:\'1.2\')) : "&#36; 0.00" }}</h1><button ng-show="vm.account_balance > 0" ui-sref="invoicelog" style="margin-top: 16px; padding: 6px 12px; color: white; background-color: #47c047; border: none; border-radius: 4px"><span style="width: 60px">Pay Balance</span></button></div><div class="topbuffer3"></div></div></div></div><div ng-if="vm.customer_type !== \'FDA\'" class="col-lg-4 col-md-4 col-sm-4 col-xs-12"><div class="smallbox bg-color-gray" style="min-height: 350px"><div class="table-responsive"><h3 class="bigbox-title pull-left">{{\'Compliance Statistics\' | translate}}</h3><div class="pull-right select-blue-border hover-btn-blue"><select ng-model="vm.selectedDaterangePassFailChart" ng-change="vm.selectDaterangePassFailChart()" ng-options="daterange as (daterange | translate) for daterange in vm.dateranges"></select></div><div class="clearfix"></div><div class="topbuffer3"></div><div class="smallbox-content"><div class="homepage-compliance-pie-chart-wrapper"><div id="pie-chart"></div><div id="pie-chart-mobile"></div></div></div></div></div><div class="topbuffer3"></div></div></div><div class="row"><div ng-show="vm.contact.receive_coa" class="col-lg-4 col-md-md-4 col-sm-12 col-xs-12"><div class="row-res-size"><div class="tabbackall tabbackall1 tabbackall2 res-size-deta-table"><div class="tab-content tabback tabbackall9 deta-table-size home-size-res"><div class="bigbox box-shadow-table res-size-table-height home-data-box"><div class="row"><div class="col-md-12"><h3 class="bigbox-title">{{\'recent orders submitted\' | translate}}</h3><div class="topbuffer3"></div></div><div class="col-md-12 position-tbl-responsive-control" style="margin-bottom: 10px"><div class="tbl-responsive-control"><ul id="dots-orders" class="tbl-dots"></ul><div class="control-buttons"><div class="control-buttons"><button class="prev btn-controls" id="orders-col-prev" disabled=""></button> <button class="next btn-controls" id="orders-col-next"></button></div></div></div></div></div><div class="table-responsive table-text-left res-data-table view-invo-table home-res-size home-page"><table id="table-orders"><thead><tr><th id="table-orders-col-1" data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="table-orders-col-1 tbl-col-1 tablesaw-cell-persist tablesaw-sortable-head tablesaw-home" style="min-width: 0px"><span>{{\'Order No.\' | translate}}</span></th><th id="table-orders-col-2" data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="table-orders-col-2 tbl-col-2 tablesaw-sortable-head tablesaw-home"><span>{{\'# of Samples\' | translate}}</span></th><th id="table-orders-col-3" data-tablesaw-sortable-col="" data-sortable-numeric="false" data-tablesaw-priority="2" class="table-orders-col-3 tbl-col-3 tablesaw-sortable-head tablesaw-home" style="width: 35%"><span>{{\'Status\' | translate}}</span></th><th id="table-orders-col-4" data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="1" class="table-orders-col-4 tbl-col-4 tablesaw-sortable-head tablesaw-home text-right" style="width: 30%"><span>{{\'Received Date\' | translate}}</span></th></tr></thead><tbody><tr ng-repeat="customerOrder in vm.customerOrdersLimited track by customerOrder.id"><td class="tbl-col-1 text-yellow"><div id="info-modal-icon-0" class="sample-info-modal-trigger product-info" aria-hidden="true" style="width: 70px"><a ui-sref="order-details({orderId:customerOrder.id})" class="hover-sample-id">{{customerOrder.id}}</a><div class="sample-submit-info-modal-shadow-left info-modal-0 sample-info-modal product-description" ng-if="customerOrder.sampleCount > 0"><span style="margin-left: 7px; font-weight: bold; font-size: 15px; color: #2a9ecf">Samples</span><ul style="margin-top: 10px"><li ng-repeat="sample in customerOrder.samples" ng-if="$index < 5"><div ng-if="sample.id != -1" class="calendar-sample-event" ng-click="vm.openPublicSample(sample)"><p>{{ sample.name }}</p></div></li><div class="text-right"><span ng-if="customerOrder.samples.length > 5">+ {{(customerOrder.samples.length) - 5}} more</span></div></ul><button ng-if="sample.id != -1 && customerOrder.samples.length > 5" type="button" class="btn btn-primary btn-list-modal" ng-click="vm.SampleDetail(customerOrder)">See List Page</button></div></div></td><td id="table-orders-col-2" class="table-orders-col-2 tbl-col-2">{{customerOrder.sampleCount}}</td><td id="table-orders-col-3" class="table-orders-col-3 tbl-col-3 text-bold text-left-bold" style="width: 35%"><span ng-if="customerOrder.state == \'CREATED\'" class="table-orders-col-4 order1">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'SAMPLES_RECEIVED\' " class="order2">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'PRELIMINARY_RESULTS\' " class="order3">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'COMPLETED\' " class="order4">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'INVOICED\' " class="order5">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'CANCELLED\' " class="order4">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'RETESTING\' " class="order6">{{customerOrder.stateLabel | translate}}</span></td><td id="table-orders-col-4" class="table-orders-col-4 tbl-col-4 select-box-right" style="width: 30%">{{customerOrder.dateReceived | utcToLocal:\'mediumDate\'}}</td></tr></tbody></table><!--<script src="content/js/table-swiper-home.js"></script>--><div class="saveall homesaveallbtn smallsizebtnhome"><button ui-sref="samplesubmit" class="submitnewhome" ng-if="vm.customer_type !== \'FDA\'">{{\'Submit New\' | translate}} &nbsp; &nbsp; &nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div></div></div></div></div><div class="topbuffer1"></div></div><div class="col-lg-8 col-md-12 col-sm-12 col-xs-12"><div class="bigbox bg-color-gray"><div class="table-responsive"><div class="row"><h3 class="bigbox-title col-md-6 col-sm-12" style="margin-bottom: 8px">{{\'Estimated Due Date Calendar\' | translate}} <small>({{ vm.monthString }})</small></h3><div class="pull-right"><div class="sample-log-btn-div" dropdown-checkboxes><button class="sample-log-btn hover-btn-blue">{{\'Filter by\' | translate}} <i class="fa fa-caret-down"></i></button><div class="edit-columns-div" style="display:none; white-space: nowrap; width: auto; padding: 12px"><div ng-repeat="filter in vm.filterOptions | lngFilterOptions:vm.currentLanguage"><input type="checkbox" class="css-checkbox" id="calendar-filter-{{ filter.value }}" ng-model="filter.selected" ng-change="vm.filterSamples()"><label class="css-label" for="calendar-filter-{{ filter.value }}">{{ filter.text | translate }}</label></div></div></div></div></div><div class="clearfix"></div><div class="bigbox-content" style="overflow-y: auto"><div ui-calendar="vm.calendarOptions" id="estimatedDueDateCalendar" ng-model="vm.events"></div></div></div><div class="row" style="padding: 16px 16px 4px 16px"><div class="saveall homesaveallbtn smallsizebtnhome"><button style="position: static" ui-sref="calendar">{{\'Go To Calendar\' | translate}} &nbsp; &nbsp; &nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div></div><div class="topbuffer3"></div></div></div><div class="row"><div ng-show="vm.billingAccess && vm.contact.receive_invoice && vm.invoices.length > 0" class="col-lg-4 col-md-md-4 col-sm-12 col-xs-12"><div class="row-res-size"><div class="tabbackall tabbackall1 tabbackall2 res-size-deta-table"><div class="tab-content tabback tabbackall9 deta-table-size home-size-res"><div class="bigbox box-shadow-table res-size-table-height-2 home-data-box"><div class="row"><div class="col-md-12"><h3 class="bigbox-title">{{\'Recent Invoices\' | translate}}</h3><div class="topbuffer3"></div></div><div class="col-md-12 position-tbl-responsive-control" style="margin-bottom: 10px"><div class="tbl-responsive-control"><ul id="dots-payment" class="tbl-dots"></ul><div class="control-buttons"><div class="control-buttons"><button class="prev btn-controls" id="payment-col-prev" disabled=""></button> <button class="next btn-controls" id="payment-col-next"></button></div></div></div></div></div><div class="table-responsive table-text-left res-data-table view-invo-table home-res-size"><table id="table-payment"><thead><tr><th data-tablesaw-sortable-col="" id="table-payment-col-1" data-sortable-numeric="" data-tablesaw-priority="persist" class="table-payment-col-1 tbl-col-1 tablesaw-cell-persist tablesaw-sortable-head"><span>{{\'Invoice No.\' | translate}}</span></th><th data-tablesaw-sortable-col="" id="table-payment-col-2" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="table-payment-col-2 table2-col tbl-col-2 tablesaw-sortable-head"><span>{{\'Invoiced Date\' | translate}}</span></th><th data-tablesaw-sortable-col="" id="table-payment-col-3" data-sortable-numeric="false" data-tablesaw-priority="2" class="table-payment-col-3 table2-col tbl-col-3 tablesaw-sortable-head"><span>{{\'Amount\' | translate}}</span></th><!-- <th data-tablesaw-sortable-col="" id="table-payment-col-4" data-sortable-numeric="" data-tablesaw-priority="1" class="table-payment-col-4 table2-col tbl-col-4 tablesaw-sortable-head text-right">\n                                                        <span>Payment Date</span>\n                                                    </th> --></tr></thead><tbody><tr ng-repeat="invoice in vm.invoices track by invoice.id"><td id="table-payment-col-1" class="table-payment-col-1 tbl-col-1 text-yellow"><a ui-sref="invoice-details({id:invoice.id})">{{invoice.custom_formated_id}}</a></td><td id="table-payment-col-2" class="table-payment-col-2 table2-col tbl-col-2">{{invoice.invoice_date| date:\'mediumDate\'}}</td><td id="table-payment-col-3" class="table-payment-col-3 table2-col tbl-col-3">{{invoice.total ? ("&#36;" + (invoice.total | number:\'1.2\')) : ""}}</td><!-- <td  id="table-payment-col-4"class="table-payment-col-4 table2-col tbl-col-4 select-box-right">{{invoice.payment_date| date:\'mediumDate\'}}</td> --></tr></tbody></table><div class="saveall homesaveallbtn homesaveallbtn2 smallsizebtnhome"><!--<button ui-sref="invoicelog">View All Invoices &nbsp; &nbsp; &nbsp; <i class="fa fa-angle-right" aria-hidden="true"></i> </button>--></div></div></div></div></div></div><div class="topbuffer3"></div></div><div class="col-lg-4 col-md-md-4 col-sm-12 col-xs-12"><div class="bigbox bg-color-gray" style="overflow-x: auto"><div class="table-responsive"><h3 class="bigbox-title" style="margin:0px">{{\'Your profile info\' | translate}}</h3><div class="topbuffer3"></div><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-building" aria-hidden="true"></i><p class="big-heading">{{\'Business Name\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading">{{vm.customerData.company_name != \'null\' ? vm.customerData.company_name : \'\'}}</p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-user" aria-hidden="true"></i><p class="big-heading">{{\'Primary Contact Name\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading">{{vm.customerData.name != \'null\' ? vm.customerData.name : \'\'}}</p></div></div></div><br>&nbsp;<br><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-phone" aria-hidden="true"></i><p class="big-heading">{{\'Direct Phone\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading">{{vm.customerData.phone != \'null\' ? vm.customerData.phone : \'\'}}</p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-id-card-o" aria-hidden="true"></i><p class="big-heading">{{\'Primary Contact Title\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading">Managing Director</p></div></div></div><br>&nbsp;<br><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-link" aria-hidden="true"></i><p class="big-heading">{{\'Website\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading"><a href="#">{{vm.customerData.website != \'null\' ? vm.customerData.website : \'\'}}</a></p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-envelope-o" aria-hidden="true"></i><p class="big-heading">{{\'Email\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading"><a href="mailto:{{vm.contact.email}}">{{vm.contact.email != \'null\' ? vm.contact.email : \'\'}}</a></p></div></div></div><div class="saveall homesaveallbtn smallsizebtnhome"><button ui-sref="customermanage" ng-show="vm.customerData.country.id == \'3\' && vm.current_user == \'daichi@anresco.com\'">{{\'Edit Profile\' | translate}} &nbsp; &nbsp; &nbsp; <i class="fa fa-angle-right" aria-hidden="true"></i></button> <button ui-sref="customermanage" ng-show="vm.customerData.country.id != \'3\'">{{\'Edit Profile\' | translate}} &nbsp; &nbsp; &nbsp; <i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div></div><div class="topbuffer3"></div></div><div class="col-lg-4 col-md-md-4 col-sm-12 col-xs-12"><div class="bigbox bg-color-gray" style="overflow-x: auto"><div class="table-responsive"><h3 class="bigbox-title" style="margin:0px">Contact Info</h3><div class="topbuffer3"></div><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-user" aria-hidden="true"></i><p class="big-heading">{{\'Primary Representative\' | translate}}</p><div class="topbuffer05"></div><!--        <p class="small-heading">{{vm.customerData.primary_anresco_rep}}</p> --><p class="small-heading">{{vm.primary_rep.name}}</p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-envelope-o" aria-hidden="true"></i><p class="big-heading">{{\'Primary Rep Email\' | translate}}</p><div class="topbuffer05"></div><!-- <p class="small-heading"><a href="mailto:{{vm.customerData.primary_anresco_email}}">{{vm.customerData.primary_anresco_email}}</a></p> --><p class="small-heading"><a href="mailto:{{vm.primary_rep.email}}">{{vm.primary_rep.email}}</a></p></div></div></div><br>&nbsp;<br><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-phone" aria-hidden="true"></i><p class="big-heading">{{\'Primary Rep Phone\' | translate}}</p><div class="topbuffer05"></div><!--   <p class="small-heading">{{vm.customerData.primary_anresco_phone}}</p> --><p class="small-heading">{{vm.primary_rep.phone}}</p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-envelope-o" aria-hidden="true"></i><p class="big-heading">{{\'General Email\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading"><a ng-href="mailto:{{brand.contact.support_email}}">{{brand.contact.support_email}}</a></p></div></div></div><br>&nbsp;<br><div class="bigbox-content"><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-phone" aria-hidden="true"></i><p class="big-heading">{{\'General Phone\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading">{{brand.contact.main_phone}}</p></div></div><div class="col-md-6 col-sm-12 col-xs-12"><div class="col-bigbox-content"><i class="fa fa-link" aria-hidden="true"></i><p class="big-heading">{{\'Website\' | translate}}</p><div class="topbuffer05"></div><p class="small-heading"><a ng-href="{{brand.web.marketing_url}}" target="_blank" rel="noopener">{{brand.web.marketing_label || brand.web.marketing_url}}</a></p></div></div></div><div class="saveall homesaveallbtn smallsizebtnhome"><button ng-click="vm.visitOurSite()">Test</button><!--<button class="btntableall">Visit Our Site &nbsp; &nbsp; &nbsp; <i class="fa fa-angle-right" aria-hidden="true"></i></button>--> <button ng-click="vm.visitOurSite()" class="btntableall">{{\'Visit Our Site\' | translate}} &nbsp; &nbsp; &nbsp; <i class="fa fa-angle-right" aria-hidden="true"></i></button></div></div></div><div class="topbuffer3"></div></div></div></div></div></div></div><!--<script src="content/js/table-swiper-home.js"></script>-->');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div class="login-page"><div class="logo-shadow login-box"><div class="background-logo-img"></div><div class="signinbox signinbox-center"><div class="logo" align="center"><div class="topbuffer5"></div><img src="/content/brand/logo.png" alt="portal logo" class="auth-brand-logo"><div class="topbuffer6"></div></div><div class="sign-in-box"><div class="header header-radius"><div align="center"><p class="signup-title">Register</p></div></div><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form class="tabbackall" ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="tab-content tabback singuptable tabbackall6 box-bg-color"><div class="companyinfo"><label class="form-label">Username</label><div class="Username2"><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="topbuffer3"></div><div class="Username2"><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="topbuffer3"></div><div class="Password2"><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="topbuffer3"></div><div class="Password2"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="topbuffer3"></div></div><hr><div class="topbuffer3"></div><div class="button-bar"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></div></div></form></div></div><div class="topbuffer5"></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header" style="padding-right:20px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated">Activated</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog-original.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header" style="padding-right:20px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create User</h4></div><div class="modal-body"><!--<jhi-alert-error></jhi-alert-error>--><div class="form-group"><label>Choose Customer</label><input name="customer" class="form-control" type="text" placeholder="Type Customer Name" ng-model="vm.searchText" ng-change="vm.loadCustomers()"><div class="popup" ng-show="vm.suggestedCustomers.length > 0"><div class="popuptext-wide" id="myPopup"><span ng-repeat="customer in vm.suggestedCustomers track by customer.id" ng-click="vm.setCustomer(customer)">{{customer.name}}<br></span></div></div></div><div class="form-group"><label>Choose Contact</label><select ng-change="vm.selectContact()" name="contacts" class="selectpicker select-box-padding" data-live-search="true" title="Select Contact" ng-model="vm.contact" ng-options="contact as contact.name for contact in vm.customerContacts track by contact.id"><option value="">Select Contact</option></select></div><div class="form-group"><label>USER DATA</label><div ng-show="vm.existingAccount"><p class="help-block">This Contact already has User account.</p></div></div><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.contact.id" readonly="readonly"></div><div ng-if="false" class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-disabled="vm.existingAccount" ng-model="vm.contact.login" required ng-minlength="4" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-disabled="vm.existingAccount" ng-model="vm.contact.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label">Password</label><input type="password" class="form-control" name="password" ng-disabled="vm.existingAccount" ng-model="vm.contact.password" ng-minlength="4" ng-maxlength="50" required placeholder="Password"><div ng-show="editForm.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.contact.password"></password-strength-bar></div><div class="form-group"><label class="control-label">Confirm Password</label><input type="password" class="form-control" name="password" ng-disabled="vm.existingAccount" ng-model="vm.contact.confirmPassword" ng-minlength="4" ng-maxlength="50" required placeholder="Confirm the new password"><div ng-show="editForm.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="editForm.confirmPassword.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.maxlength">Your password cannot be longer than 50 characters.</p></div></div><!--<div class="form-group">--><!--<label for="activated">--><!--<input ng-disabled="vm.contact.managedUser.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated">--><!--<span>Activated</span>--><!--</label>--><!--</div>--><!--<div class="form-group">--><!--<label>Profiles</label>--><!--<select class="form-control" multiple name="authority" ng-model="vm.contact.managedUser.authorities"--><!--ng-options="authority for authority in vm.authorities">--><!--</select>--><!--</div>--><div class="form-group"><jhi-alert-error></jhi-alert-error></div><div ng-show="vm.doNotMatch && vm.contact.password != vm.contact.confirmPassword" class="alert alert-danger">Password and confirmation password do not match!</div><div ng-show="vm.noContact && vm.contact.id == null" class="alert alert-danger">Please select Contact</div><div ng-show="vm.errorMsg && (vm.contact.login == vm.currentLoginName || vm.contact.email == vm.currentLoginEmail)" class="alert alert-danger">{{vm.errorMsg}}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.existingAccount" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header" style="padding-right:20px"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Edit User {{ vm.contact.id }}</h4></div><div class="modal-body"><div class="row" style="margin-bottom: 12px"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="card"><ul class="nav nav-tabs" role="tablist"><li role="presentation" class="active" id="user_tab"><a aria-controls="home" role="tab" data-toggle="tab" onclick="selectTab(0)">User Info</a></li><li role="presentation" id="customers_tab"><a aria-controls="profile" role="tab" data-toggle="tab" onclick="selectTab(1)">Customers</a></li></ul></div></div></div><div class="tab-content"><div id="user" role="tabpanel" class="row tab-pane active" style="cursor: default"><div class="form-group col-md-12"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.contact.id" readonly="readonly"></div><div class="form-group col-md-6"><label class="control-label">First Name</label><input type="text" class="form-control" ng-model="vm.contact.first_name" name="firstName" required></div><div class="form-group col-md-6"><label class="control-label">Last Name</label><input type="text" class="form-control" ng-model="vm.contact.last_name" name="lastName" required></div><div class="form-group col-md-6"><label class="control-label">Direct Phone</label><input type="text" class="form-control" ng-model="vm.contact.phone" name="phone"></div><div class="form-group col-md-6"><label class="control-label">Title</label><input type="text" class="form-control" ng-model="vm.contact.title" name="title"></div><!-- \t\t\t\t<div class="form-group col-md-6">\n\t\t            <label>Receive Email</label>\n\t\t            <select class="selectpicker select-box-padding" data-live-search="true" title="Select Type"  ng-model="vm.receive" name="toReceive" ng-change="vm.setReceive()">\n\t\t                <option value="none">None</option>\n\t\t                <option value="coa">COA</option>\n\t\t                <option value="inv">Invoice</option>\n\t\t                <option value="both">Both</option>\n\t\t            </select>\n\t\t\t\t</div>\n\t\t\t\t<div class="col-md-6 col-md-offset-6"></div> --><div class="form-group col-md-6"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.contact.login" ng-minlength="4" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.contact.email" required ng-maxlength="100" ng-change="vm.setEmail()"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group col-md-6"><label class="control-label">Password</label><input type="password" class="form-control" name="password" ng-model="vm.contact.password" ng-minlength="4" ng-maxlength="50" placeholder="Password"><div ng-show="editForm.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="editForm.password.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.contact.user.password"></password-strength-bar></div><div class="form-group col-md-6"><label class="control-label">Confirm Password</label><input type="password" class="form-control" name="password" ng-model="vm.contact.confirmPassword" ng-minlength="4" ng-maxlength="50" placeholder="Confirm the new password"><div ng-show="editForm.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="editForm.confirmPassword.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="editForm.confirmPassword.$error.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-12"><jhi-alert-error></jhi-alert-error></div><div ng-show="vm.doNotMatch && vm.contact.password != vm.contact.confirmPassword" class="alert alert-danger">Password and confirmation password do not match!</div><div ng-show="vm.noContact && vm.contact.id == null" class="alert alert-danger">Please select Contact</div></div><div id="customers" role="tabpanel" class="row tab-pane" style="cursor: default"><div class="table-responsive table-text-left res-data-table"><table id="table"><thead><tr><th>Customer</th><th>Receive COA</th><th>Receive Invoice</th><th>Admin</th></tr></thead><tbody ng-repeat="contactCustomer in vm.contact.contactCustomers"><tr><td>{{contactCustomer.customer.name}}</td><td><input style="cursor:pointer" type="checkbox" ng-model="contactCustomer.receive_coa" ng-checked="contactCustomer.receive_coa"></td><td><input style="cursor:pointer" type="checkbox" ng-model="contactCustomer.receive_invoice" ng-checked="contactCustomer.receive_invoice"></td><td><input style="cursor:pointer" type="checkbox" ng-model="contactCustomer.role" ng-true-value="\'ADMIN\'" ng-false-value="null" ng-checked="contactCustomer.role == \'ADMIN\'"></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form><script>function selectTab(i) {\n        if(i == 0){\n             //document.getElementById("MyElement").classList.add("active");\n            $("#user").addClass("active");\n            $("#user_tab").addClass("active");\n            $("#customers").removeClass("active");\n            $("#customers_tab").removeClass("active");\n        }\n        else if(i == 1){\n            $("#user").removeClass("active");\n            $("#user_tab").removeClass("active");\n            $("#customers").addClass("active");\n            $("#customers_tab").addClass("active");\n        }\n    }</script>');
$templateCache.put('app/admin/user-management/user-management.html','<div style="padding:10px"><!--<h2>Users</h2>--><div class="row"><div class="col-md-4" style="padding-top:20px; padding-bottom:20px"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div><div class="col-md-12" style="padding-top:20px; padding-bottom:20px"><input ng-model="vm.searchTerm" ng-keyup="$event.keyCode == 13 ? vm.search() : null"> <button class="btn btn-primary" ng-click="vm.search()"><span>Search Users</span></button> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">Searches by the user\'s name, login, email, and customer name.</span></a></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><!--<th></th>--></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><!--<td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td>--><td>{{user.id}}</td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login==user.login">Activated</button></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--                         <button type="submit"\n                                ui-sref="user-management-detail({login:user.login})"\n                                class="btn btn-info btn-sm">\n                            <span class="glyphicon glyphicon-eye-open"></span>\n                            <span class="hidden-xs hidden-sm"></span>\n                        </button> --> <button type="submit" ui-sref="user-management.edit({id:user.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button><!--                         <button type="submit"\n                                ui-sref="user-management.delete({login:user.login})"\n                                class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login">\n                            <span class="glyphicon glyphicon-remove-circle"></span>\n                            <span class="hidden-xs hidden-sm"></span>\n                        </button> --></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/ai-chat-overlay/ai-chat-overlay.html','<div class="ai-chat-overlay" ng-if="vm.isVisible" ng-class="{\'is-open\': vm.isOpen}"><button type="button" class="ai-chat-launcher" ng-if="!vm.isOpen" ng-click="vm.open()" aria-label="Open Anresco AI support"><span class="ai-chat-launcher-icon"><i class="fa fa-comments-o" aria-hidden="true"></i> </span><span class="ai-chat-launcher-label">Ask Anresco AI</span></button><section class="ai-chat-widget" ng-show="vm.isOpen" aria-label="Anresco AI"><button type="button" class="ai-chat-widget-close" ng-click="vm.close()" aria-label="Minimize Anresco AI"><i class="fa fa-minus" aria-hidden="true"></i></button><div class="ai-chat-widget-body"><div class="ai-chat-loading" ng-if="vm.loading">Starting Anresco AI...</div><div class="ai-chat-error" ng-if="vm.error"><p>Anresco AI could not start.</p><button type="button" class="btn btn-primary btn-sm" ng-click="vm.retry()">Try again</button></div><iframe id="ai-chat-overlay-frame" class="ai-chat-frame" ng-if="vm.iframeSrc && !vm.error" ng-src="{{vm.iframeSrc}}" ai-chat-overlay-frame-loaded title="Anresco AI"></iframe></div></section></div>');
$templateCache.put('app/components/backdoor/backdoor.html','<div class="login-page"><div class="logo-shadow login-box"><div class="background-logo-img"></div><div class="signinbox signinbox-center"><div class="logo" align="center"><div class="topbuffer5"></div><img src="/content/brand/logo.png" alt="portal logo" class="auth-brand-logo"><div class="topbuffer6"></div></div><div class=""><!--col-md-8 col-md-offset-2--><div class="alert alert-danger alert-margin" ng-show="vm.authenticationError"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="sign-in-box"><div class="header header-radius"><div align="center"><p class="signup-title">Sign In</p></div></div><form class="tabbackall" role="form" ng-submit="vm.login($event)"><div class="tab-content tabback singuptable tabbackall6 box-bg-color"><div ng-switch="vm.step"><!--OLD USERS--><div class="companyinfo" ng-switch-when="oldUsers"><div class="old-users-wrap"><div class="old-users-acc"><p>Choose account:</p><ul><li ng-repeat="user in vm.usersList track by user.id"><a ng-click="vm.loginAs(user)">{{user.email}}</a></li></ul></div><div class="old-users-back"><a ng-click="vm.step = \'loginWithOldUsers\'">Not your account ?</a></div></div></div><!--LOGIN AS FORM --><div class="companyinfo" ng-switch-when="loginAs"><!--<p class="signup-title">Sign In</p>--><div class="signas-wrap"><p class="signas-title">Hello {{ vm.oldUserFirstName}} ({{ vm.oldUserLogin}})</p><a class="pull-left foggotpass" ng-click="vm.anotherUser()">Another Account ?</a><br></div><div class="topbuffer3"></div><div class="Password2"><label class="pull-left form-label" ng-if="!vm.loginAsSelected">Password</label><input type="password" placeholder="Enter Password" type="password" id="password" placeholder="Your password" ng-model="vm.password"> <i class="fa fa-lock" aria-hidden="true"></i></div><hr class="hrLogin"><div class="button-bar"><div class="topbuffer2"></div><input ng-if="false" type="hidden" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <a ng-if="false" class="white-btn-a" ng-click="vm.signOutCompletly()">Sign Out Completely</a> <button type="submit" class="btn btn-primary pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2">Sign In</button></div></div><!--LOGIN FORM --><div class="companyinfo" ng-switch-when="login"><label class="form-label">Master Username</label><div class="Username2"><input type="text" placeholder="Enter Master Username" id="username" placeholder="Your username" ng-model="vm.username"> <i class="fa fa-user" aria-hidden="true"></i></div><div class="topbuffer3"></div><label class="form-label">Backdoor Username</label><div class="Username2"><input type="text" placeholder="Enter Backdoor Username" id="backdoor_username" placeholder="Their username" ng-model="vm.backdoor_username"> <i class="fa fa-user" aria-hidden="true"></i></div><div class="topbuffer3"></div><label class="pull-left form-label" ng-if="!vm.loginAsSelected">Master Password</label><div class="Password2"><input type="password" placeholder="Enter Master Password" type="password" id="password" placeholder="Your password" ng-model="vm.password"> <i class="fa fa-lock" aria-hidden="true"></i></div><br><hr class="hrLogin"><div class="button-bar"><!--<button type="button" class="btn btn-default pull-left btnlogin btnsmallsize hover-btn-blue" ng-click="vm.register()">Register as a Customer</button>--><div class="topbuffer2"></div><input type="hidden" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <button type="submit" class="btn btn-primary pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2">Sign In</button></div></div></div></div></form></div></div><div class="topbuffer5"></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="login-page"><div class="logo-shadow login-box"><div class="background-logo-img"></div><div class="signinbox signinbox-center"><div class="logo" align="center"><div class="topbuffer5"></div><img src="/content/brand/logo.png" alt="portal logo" class="auth-brand-logo"><div class="topbuffer6"></div></div><div class=""><!--col-md-8 col-md-offset-2--><div class="alert alert-danger alert-margin" ng-show="vm.authenticationError" style="text-align: center">The username/password combo provided is incorrect or doesn\'t exist. Please contact your account representative if you are unsure of your account status.</div></div><div class="sign-in-box"><div class="header header-radius"><div align="center"><p class="signup-title">Sign In</p></div></div><form class="tabbackall" role="form" ng-submit="vm.login($event)"><div class="tab-content tabback singuptable tabbackall6 box-bg-color"><div ng-switch="vm.step"><!--OLD USERS--><div class="companyinfo" ng-switch-when="oldUsers"><div class="old-users-wrap"><div class="old-users-acc"><p>Choose account:</p><ul><li ng-repeat="user in vm.usersList track by user.id"><a ng-click="vm.loginAs(user)">{{user.email}}</a></li></ul></div><div class="old-users-back"><a ng-click="vm.step = \'loginWithOldUsers\'">Not your account ?</a></div></div></div><!--LOGIN AS FORM --><div class="companyinfo" ng-switch-when="loginAs"><!--<p class="signup-title">Sign In</p>--><div class="signas-wrap"><p class="signas-title">Hello {{ vm.oldUserFirstName}} ({{ vm.oldUserLogin}})</p><a class="pull-left foggotpass" ng-click="vm.anotherUser()">Another Account ?</a><br></div><div class="topbuffer3"></div><div class="Password2"><label class="pull-left form-label" ng-if="!vm.loginAsSelected">Password</label><a href="" ng-click="vm.requestResetPassword()" class="pull-right foggotpass">Forgot Username or Password?</a> <input type="password" placeholder="Enter Password" type="password" id="password" placeholder="Your password" ng-model="vm.password"> <i class="fa fa-lock" aria-hidden="true"></i></div><hr class="hrLogin"><div class="button-bar"><div class="topbuffer2"></div><input ng-if="false" type="hidden" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <a ng-if="false" class="white-btn-a" ng-click="vm.signOutCompletly()">Sign Out Completely</a> <button type="submit" class="btn btn-primary pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2">Sign In</button></div></div><!--LOGIN FORM --><div class="companyinfo" ng-switch-when="login"><label class="form-label">Email</label><div class="Username2"><input type="text" placeholder="Enter Email" id="username" placeholder="Your email" ng-model="vm.username"> <i class="fa fa-user" aria-hidden="true"></i></div><div class="topbuffer3"></div><label class="pull-left form-label" ng-if="!vm.loginAsSelected">Password</label><div class="Password2"><input type="password" placeholder="Enter Password" type="password" id="password" placeholder="Your password" ng-model="vm.password"> <i class="fa fa-lock" aria-hidden="true"></i></div><a href="" ng-click="vm.requestResetPassword()" class="pull-right foggotpass">Forgot Username or Password?</a><br><hr class="hrLogin"><div class="button-bar"><!--<button type="button" class="btn btn-default pull-left btnlogin btnsmallsize hover-btn-blue" ng-click="vm.register()">Register as a Customer</button>--><div class="topbuffer2"></div><input type="hidden" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <button type="submit" class="btn btn-primary pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2">Sign In</button></div></div></div></div></form></div></div><div class="topbuffer5"></div></div></div>');
$templateCache.put('app/entities/faq/faq-add-new-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin-right: 20px" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySyncQbLogLabel">New FAQ</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><select name="faqCategory" id="" class="form-control" ng-model="faq.faqCategory.id" required><option value="">Select category</option><option value="{{category.id}}" ng-repeat="category in categories">{{category.categoryTitle}}</option></select></div><div><textarea ui-tinymce="tinymceOptions" ng-model="faq.question"></textarea></div><br><div><textarea ui-tinymce="tinymceOptions" ng-model="faq.answer"></textarea></div><div class="modal-footer" style="background-color: #ffffff"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/faq/faq-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.category.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this FAQ category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/faq/faq-category-detail.html','<div><jhi-alert-error></jhi-alert-error><h1>{{vm.category.categoryTitle}}</h1><div ng-if="vm.categories.faq.length < 1"><br><h3>The is no FAQ for this category</h3></div><div ng-if="vm.categories.faq.length > 0"><table class="jh-table table table-striped"><thead><tr><th style="min-width: 400px"><span>Question</span></th><th><span>Answer</span></th></tr></thead><tbody><tr ng-repeat="question in vm.categories.faq  track by question.id"><td bind-html-compile="question.question" class="faq-question"></td><td bind-html-compile="question.answer" class="faq-answer"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq-edit({questionId:question.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-click="vm.deleteFaq(question.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><br><br><button type="submit" ui-sref="faq-manage" class="btn btn-info" style="margin: 10px"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/entities/faq/faq-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin-right: 20px" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySyncQbLogLabel">Create or edit a Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="categoryTitle">Category name</label><input type="text" class="form-control" id="categoryTitle" name="categoryTitle" ng-model="vm.category.categoryTitle"></div><div class="modal-footer" style="background-color: #ffffff"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/faq/faq-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySyncQbLogLabel">Create new category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div><textarea ui-tinymce="tinymceOptions" ng-model="vm.faq.question"></textarea></div><br><div><textarea ui-tinymce="tinymceOptions" ng-model="vm.faq.answer"></textarea></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/faq/faq.html','<div><jhi-alert></jhi-alert><br><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="faq-category-detail.new"><span class="glyphicon glyphicon-plus"></span> <span>New FAQ Category</span></button> <button class="btn btn-primary" ui-sref="faq-add-new"><span class="glyphicon glyphicon-plus"></span> <span>New FAQ</span></button></div></div></div><br><style>.table-border-collapse {border-collapse: collapse}\n        .td-left-border {border-left: 1px solid #ddd;}\n        .td-right-border {border-right: 1px solid #ddd;}\n        .h2-local {padding-left: 12px; padding-top: 12px; padding-bottom:12px}</style><div class="table-responsive table-border-collapse"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" style="width:55px"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="category in vm.categories track by category.id"><td class="td-left-border">{{category.id}}</td><td>{{category.categoryTitle}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="faq-category-detail({id:category.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="faq-category-detail.edit({id:category.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ng-disabled="category.faq.length > 0" ui-sref="faq-category-detail.delete({id:category.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/sync-qb-log/sync-qb-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.syncQbLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Sync Qb Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/sync-qb-log/sync-qb-log-detail.html','<div><h2><span>Sync Qb Log</span> {{vm.syncQbLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Sync Date Time</span></dt><dd><span>{{vm.syncQbLog.syncDateTime | date:\'medium\'}}</span></dd><dt><span>Success</span></dt><dd><span>{{vm.syncQbLog.success}}</span></dd><dt><span>Updated Contacts</span></dt><dd><span>{{vm.syncQbLog.updatedContacts}}</span></dd><dt><span>Updated Customers</span></dt><dd><span>{{vm.syncQbLog.updatedCustomers}}</span></dd><dt><span>Updated Tests</span></dt><dd><span>{{vm.syncQbLog.updatedTests}}</span></dd><dt><span>Updated Samples</span></dt><dd><span>{{vm.syncQbLog.updatedSamples}}</span></dd><dt><span>Updated Orders</span></dt><dd><span>{{vm.syncQbLog.updatedOrders}}</span></dd><dt><span>Deleted Contacts</span></dt><dd><span>{{vm.syncQbLog.deletedContacts}}</span></dd><dt><span>Deleted Customers</span></dt><dd><span>{{vm.syncQbLog.deletedCustomers}}</span></dd><dt><span>Deleted Tests</span></dt><dd><span>{{vm.syncQbLog.deletedTests}}</span></dd><dt><span>Deleted Samples</span></dt><dd><span>{{vm.syncQbLog.deletedSamples}}</span></dd><dt><span>Deleted Orders</span></dt><dd><span>{{vm.syncQbLog.deletedOrders}}</span></dd><dt><span>Errors Global</span></dt><dd><span>{{vm.syncQbLog.errorsGlobal}}</span></dd><dt><span>Errors Contacts</span></dt><dd><span>{{vm.syncQbLog.errorsContacts}}</span></dd><dt><span>Errors Customers</span></dt><dd><span>{{vm.syncQbLog.errorsCustomers}}</span></dd><dt><span>Errors Orders</span></dt><dd><span>{{vm.syncQbLog.errorsOrders}}</span></dd><dt><span>Error Log</span></dt><dd><span>{{vm.syncQbLog.errorLog}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="sync-qb-log-detail.edit({id:vm.syncQbLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/entities/sync-qb-log/sync-qb-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySyncQbLogLabel">Create or edit a Sync Qb Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.syncQbLog.id"><label for="id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.syncQbLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_syncDateTime">Sync Date Time</label><div class="input-group"><input id="field_syncDateTime" type="text" class="form-control" name="syncDateTime" datetime-picker="MM/dd/yyyy HH:mm" ng-model="vm.syncQbLog.syncDateTime" is-open="vm.datePickerOpenStatus.syncDateTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'syncDateTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_success">Success</label><input type="checkbox" name="success" id="field_success" ng-model="vm.syncQbLog.success"></div><div class="form-group"><label class="control-label" for="field_updatedContacts">Updated Contacts</label><input type="number" class="form-control" name="updatedContacts" id="field_updatedContacts" ng-model="vm.syncQbLog.updatedContacts"></div><div class="form-group"><label class="control-label" for="field_updatedCustomers">Updated Customers</label><input type="number" class="form-control" name="updatedCustomers" id="field_updatedCustomers" ng-model="vm.syncQbLog.updatedCustomers"></div><div class="form-group"><label class="control-label" for="field_updatedTests">Updated Tests</label><input type="number" class="form-control" name="updatedTests" id="field_updatedTests" ng-model="vm.syncQbLog.updatedTests"></div><div class="form-group"><label class="control-label" for="field_updatedSamples">Updated Samples</label><input type="number" class="form-control" name="updatedSamples" id="field_updatedSamples" ng-model="vm.syncQbLog.updatedSamples"></div><div class="form-group"><label class="control-label" for="field_updatedOrders">Updated Orders</label><input type="number" class="form-control" name="updatedOrders" id="field_updatedOrders" ng-model="vm.syncQbLog.updatedOrders"></div><div class="form-group"><label class="control-label" for="field_deletedContacts">Deleted Contacts</label><input type="number" class="form-control" name="deletedContacts" id="field_deletedContacts" ng-model="vm.syncQbLog.deletedContacts"></div><div class="form-group"><label class="control-label" for="field_deletedCustomers">Deleted Customers</label><input type="number" class="form-control" name="deletedCustomers" id="field_deletedCustomers" ng-model="vm.syncQbLog.deletedCustomers"></div><div class="form-group"><label class="control-label" for="field_deletedTests">Deleted Tests</label><input type="number" class="form-control" name="deletedTests" id="field_deletedTests" ng-model="vm.syncQbLog.deletedTests"></div><div class="form-group"><label class="control-label" for="field_deletedSamples">Deleted Samples</label><input type="number" class="form-control" name="deletedSamples" id="field_deletedSamples" ng-model="vm.syncQbLog.deletedSamples"></div><div class="form-group"><label class="control-label" for="field_deletedOrders">Deleted Orders</label><input type="number" class="form-control" name="deletedOrders" id="field_deletedOrders" ng-model="vm.syncQbLog.deletedOrders"></div><div class="form-group"><label class="control-label" for="field_errorsGlobal">Errors Global</label><input type="number" class="form-control" name="errorsGlobal" id="field_errorsGlobal" ng-model="vm.syncQbLog.errorsGlobal"></div><div class="form-group"><label class="control-label" for="field_errorsContacts">Errors Contacts</label><input type="number" class="form-control" name="errorsContacts" id="field_errorsContacts" ng-model="vm.syncQbLog.errorsContacts"></div><div class="form-group"><label class="control-label" for="field_errorsCustomers">Errors Customers</label><input type="number" class="form-control" name="errorsCustomers" id="field_errorsCustomers" ng-model="vm.syncQbLog.errorsCustomers"></div><div class="form-group"><label class="control-label" for="field_errorsOrders">Errors Orders</label><input type="number" class="form-control" name="errorsOrders" id="field_errorsOrders" ng-model="vm.syncQbLog.errorsOrders"></div><div class="form-group"><label class="control-label" for="field_errorLog">Error Log</label><input type="text" class="form-control" name="errorLog" id="field_errorLog" ng-model="vm.syncQbLog.errorLog"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/sync-qb-log/sync-qb-logs.html','<div><h2 class="h2-local">Sync Qb Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sync-qb-log.new"><span class="glyphicon glyphicon-plus"></span> <span>Create new Sync Qb Log</span></button></div></div></div><br><style>.table-border-collapse {border-collapse: collapse}\n        .td-left-border {border-left: 1px solid #ddd;}\n        .td-right-border {border-right: 1px solid #ddd;}\n        .h2-local {padding-left: 12px; padding-top: 12px; padding-bottom:12px}</style><div class="table-responsive table-border-collapse"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th colspan="4"></th><th colspan="3"><span>Customers</span> <span class="glyphicon"></span></th><th colspan="3"><span>Contacts</span> <span class="glyphicon"></span></th><th colspan="3"><span>Orders</span> <span class="glyphicon"></span></th><th colspan="2"><span>Sampes</span> <span class="glyphicon"></span></th><th colspan="2"><span>Tests</span> <span class="glyphicon"></span></th><th colspan="3"></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" style="width:55px"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="syncDateTime" style="width:130px"><span>Sync Date</span> <span class="glyphicon glyphicon-sort"></span></th><th style="width:130px"><span>Up After Date</span> <span class="glyphicon"></span></th><th><span>Success</span> <span class="glyphicon"></span></th><th class="td-left-border" title="Updated"><span>U</span> <span class="glyphicon"></span></th><th title="Deleted"><span>D</span> <span class="glyphicon"></span></th><th title="Errors"><span>E</span> <span class="glyphicon"></span></th><th class="td-left-border" title="Updated"><span>U</span> <span class="glyphicon"></span></th><th title="Deleted"><span>D</span> <span class="glyphicon"></span></th><th title="Errors"><span>E</span> <span class="glyphicon"></span></th><th class="td-left-border" title="Updated"><span>U</span> <span class="glyphicon"></span></th><th title="Deleted"><span>D</span> <span class="glyphicon"></span></th><th title="Errors"><span>E</span> <span class="glyphicon"></span></th><th class="td-left-border" title="Updated"><span>U</span> <span class="glyphicon"></span></th><th title="Deleted"><span>D</span> <span class="glyphicon"></span></th><th class="td-left-border" title="Updated"><span>U</span> <span class="glyphicon"></span></th><th title="Deleted"><span>D</span> <span class="glyphicon"></span></th><th class="td-left-border"><span>Global Errors</span> <span class="glyphicon"></span></th><th><span>Error Log</span> <span class="glyphicon"></span></th><th></th></tr></thead><tbody><tr ng-repeat="syncQbLog in vm.syncQbLogs track by syncQbLog.id"><td><a ui-sref="sync-qb-log-detail({id:syncQbLog.id})">{{syncQbLog.id}}</a></td><td>{{syncQbLog.syncDateTime | date:\'MM/dd/yyyy HH:mm\'}}</td><td>{{syncQbLog.updatedAfterDateTime | date:\'MM/dd/yyyy HH:mm\'}}</td><td style="{{ syncQbLog.success == true ? \'color:black\' : \'color:red\' }}">{{syncQbLog.success}}</td><td class="td-left-border">{{syncQbLog.updatedCustomers}}</td><td>{{syncQbLog.deletedCustomers}}</td><td>{{syncQbLog.errorsCustomers}}</td><td class="td-left-border">{{syncQbLog.updatedContacts}}</td><td>{{syncQbLog.deletedContacts}}</td><td>{{syncQbLog.errorsContacts}}</td><td class="td-left-border">{{syncQbLog.updatedOrders}}</td><td>{{syncQbLog.deletedOrders}}</td><td>{{syncQbLog.errorsOrders}}</td><td class="td-left-border">{{syncQbLog.updatedSamples}}</td><td>{{syncQbLog.deletedSamples}}</td><td class="td-left-border">{{syncQbLog.updatedTests}}</td><td>{{syncQbLog.deletedTests}}</td><td class="td-left-border">{{syncQbLog.errorsGlobal}}</td><td ng-if="syncQbLog.errorLog.length>=55" title="{{syncQbLog.errorLog}}">{{syncQbLog.errorLog | limitTo:55}}...</td><td ng-if="syncQbLog.errorLog.length===null || syncQbLog.errorLog.length< 55">{{syncQbLog.errorLog}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sync-qb-log-detail({id:syncQbLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="sync-qb-log.edit({id:syncQbLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down"></span></button> <button type="submit" ui-sref="sync-qb-log.delete({id:syncQbLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><!--<span class="hipster img-responsive img-rounded"></span>--></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation" ng-show="vm.isAuthenticated() || vm.$state.current.name==\'public\'"><!--ng-switch-when="true" has-authority="ROLE_ADMIN"--><div class="container"><div class="navbar-header"><div class="col-xs-7"><a ui-sref="home" class="navbar-brand" style="height:50px"><img src="/content/brand/logo@3x.png" alt="portal logo" class="img-responsive navbar-brand-logo"></a></div><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><div class="header header2account"><div class="container-fluid"><div class="rightside rightsidehome"><div class="dropdown"><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><button data-toggle="dropdown"><i class="fa fa-user" aria-hidden="true"></i> <span class="caret"></span></button></a><ul class="dropdown-menu" uib-dropdown-menu uib-collapse="vm.isAccbarCollapsed" ng-switch="vm.isAuthenticated()"><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span>Sign out</span></a></li></ul></li></div></div><!-- Start - Notifications --><div class="rightside" ng-if="!vm.hideDropdown"><div class="dropdown"><ul><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="notifications"><button data-toggle="dropdown" class="notification-button"><span class="notification-label">3</span> <i class="fa fa-flag" aria-hidden="true"></i> <span class="caret"></span></button></a><ul class="dropdown-menu nofi-dropdown" uib-dropdown-menu uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><li><ul class="notification-list scrollbox"><!-- Start - Notification List Render --><li class="unread-li"><a href="javascript:void(0)"><div class="sort-name"><span class="n-blue">SF</span></div><div class="subject"><p>13 Samples Test</p><p>Samples <span class="notification-link">#123123123</span></p><p><i class="fa fa-clock-o" aria-hidden="true"></i> May 23rd at 10:15am</p></div><span class="notification-dot unread-dot"></span></a></li><li><a href="javascript:void(0)"><div class="sort-name"><span class="n-green">OC</span></div><div class="subject"><p>Order Test 5648</p><p>Order <span class="notification-link">#123123123</span></p><p><i class="fa fa-clock-o" aria-hidden="true"></i> May 23rd at 8:00am</p></div><span class="notification-dot"></span></a></li><li><a href="javascript:void(0)"><div class="sort-name"><span class="n-lightred">RI</span></div><div class="subject"><p>Test Test Test 356</p><p>Test <span class="notification-link">#123123123</span></p><p><i class="fa fa-clock-o" aria-hidden="true"></i> May 23rd at 10:15am</p></div><span class="notification-dot"></span></a></li><li class="unread-li"><a href="javascript:void(0)"><div class="sort-name"><span class="n-blue">SF</span></div><div class="subject"><p>13 Samples Test</p><p>Samples <span class="notification-link">#123123123</span></p><p><i class="fa fa-clock-o" aria-hidden="true"></i> May 23rd at 10:15am</p></div><span class="notification-dot unread-dot"></span></a></li><li class="unread-li"><a href="javascript:void(0)"><div class="sort-name"><span class="n-green">OC</span></div><div class="subject"><p>Order Test 5648</p><p>Order <span class="notification-link">#123123123</span></p><p><i class="fa fa-clock-o" aria-hidden="true"></i> May 23rd at 8:00am</p></div><span class="notification-dot unread-dot"></span></a></li><!-- End - Notification List Render --></ul></li><li class="buttons-field"><a ui-sref="notifications" href="#/notifications" class="btn btn-primary">View All</a> <button class="btn btn-white">Mark All as Read</button> <button class="btn btn-settings"><i class="fa fa-cog"></i></button></li></ul></li><li class="title-icon">Notifications</li></ul></div></div><!-- End - Notifications --><!-- START - Search --><div class="rightside" ng-if="(pageTitle == \'Samples\') || (pageTitle == \'Orders\')"><div class="dropdown"><ul><li uib-dropdown class="dropdown pointer"><!--<a href="javascript:void(0)">--> <a href="javascript:void(0)"><button id="search" ng-click="vm.toggleSearch()"><i class="fa fa-search" aria-hidden="true"></i></button></a></li><li class="title-icon">Search</li></ul></div></div></div></div></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="fa fa-tachometer"></span> <span class="hidden-sm">&nbsp;&nbsp; Home</span></a></li><li ng-show="vm.tabs.submit.show" ui-sref-active="active"><a ui-sref="samplesubmit" ng-click="vm.collapseNavbar()"><span class="fa fa-hand-pointer-o"></span> <span class="hidden-sm">&nbsp;&nbsp; Submit</span></a></li><li ui-sref-active="active"><a ui-sref="orders" ng-click="vm.collapseNavbar()"><span class="fa fa-check-square-o"></span> <span class="hidden-sm">&nbsp;&nbsp; Orders</span></a></li><li ui-sref-active="active"><a ui-sref="samplelog" ng-click="vm.collapseNavbar()"><span class="fa fa-table"></span> <span class="hidden-sm">&nbsp;&nbsp; Samples</span></a></li><li ui-sref-active="active"><a ui-sref="invoicelog" ng-click="vm.collapseNavbar()"><span class="fa fa-usd usdlogo"></span> <span class="hidden-sm">&nbsp;&nbsp; Billing</span></a></li><li ui-sref-active="active"><a ui-sref="customermanage" ng-click="vm.collapseNavbar()"><span class="fa fa-address-card-o"></span> <span class="hidden-sm">&nbsp;&nbsp; Manage</span></a></li><!-- Start - Notification and faq links --><li ui-sref-active="active"><a ui-sref="faq" href="#/faq" class="link-on-mob" ng-click="vm.collapseNavbar()"><i class="fa fa-question-circle-o"></i> <span class="hidden-sm">&nbsp;&nbsp; FAQ</span></a></li><!-- End - Notification and faq links --><li ui-sref-active="active"><a ui-sref="customerPublic({dbaName: vm.getDbaName()})" ng-click="vm.collapseNavbar()"><i class="fa fa-briefcase"></i> <span class="hidden-sm">&nbsp;&nbsp; Company Page</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm">&nbsp;&nbsp; Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Customer</span></a></li><li ui-sref-active="active"><a ui-sref="assay" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Assay</span></a></li><li ui-sref-active="active"><a ui-sref="business-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Business Type</span></a></li><li ui-sref-active="active"><a ui-sref="contact" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Contact</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Country</span></a></li><li ui-sref-active="active"><a ui-sref="billing-info" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Billing Info</span></a></li><li ui-sref-active="active"><a ui-sref="customer-order" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Customer Order</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Invoice</span></a></li><li ui-sref-active="active"><a ui-sref="product-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Product Type</span></a></li><li ui-sref-active="active"><a ui-sref="sample" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sample</span></a></li><li ui-sref-active="active"><a ui-sref="sample-test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sample Test</span></a></li><li ui-sref-active="active"><a ui-sref="sync-qb-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sync QBench Log</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">&nbsp;&nbsp; Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span>Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span>Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">&nbsp;&nbsp; Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/navbar-header/navbar-header.html','<style>.dropdown-menu {\n    border-radius: 4px;\n    border: 1px solid #e3e3e3;\n    padding: 0;\n    margin: 0;\n    max-height: none;\n}\n\n.dropdown-menu > li > a\n {\n    padding: 0;\n    font-weight: normal;\n    color: #3a516b;\n    padding: 14px;\n    border-bottom: 1px solid #e3e3e3;\n}\n\n.dropdown-menu > li > a:focus, \n.dropdown-menu > li > a:hover {\n    background: #3a516b;\n    color: white !important;\n}\n\n.circle-for-name {\n    background: #3a516b;\n    border-radius: 50%;\n    height: 37px; \n    width: 37px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    font-size: 15px;\n    color: white;\n    border: none;\n}\n\n.active-account {\n    background: #3a516b;\n    color: white !important;\n}</style><div class="content-wrapper ng-scope" ng-if="vm.isAuthenticated() || vm.$state.current.name==\'customerPublic\' || vm.$state.current.name == \'public\'" ng-init="vm.getTopNotifications()"><div class="ng-scope"><div class="content-wrapper-x"><div class="header"><div class="container-fluid" style="text-align:center"><div style="float:left"><button class="toggle-sidebar" ng-click="toggleSidebar()" type="button"><i class="fa fa-bars nav-btn-a" aria-hidden="true"></i></button><h2 ng-if="toState.name != \'home\' && toState.name != \'order-details\' && toState.name != \'invoice-details\'">{{pageTitle | translate}}</h2><button ng-show="(pageTitle == \'Samples\')" class="galleryInfoButton" data-toggle="modal" data-target="#samplesTabIntroModal"><i class="glyphicon glyphicon-info-sign" style="font-size:17px;color: #556d85"></i></button> <button ng-show="(pageTitle == \'Public Gallery\')" class="galleryInfoButton" data-toggle="modal" data-target="#publicViewIntroModal"><i class="glyphicon glyphicon-info-sign" style="font-size:17px;color: #556d85"></i></button><div ng-show="(pageTitle == \'Public Gallery\')" style="float:right;width: 135px"><a id="selectPublicAction" style="width: 135px; margin-top: 25px; margin-left: 25px; height: 32px" class="btn btn-public-view" onclick="{$(\'#publicPageMenu\').is(\':visible\') ? $(\'#publicPageMenu\').hide() : $(\'#publicPageMenu\').show()}">{{\'Select Action\' | translate}} &nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-caret-down" aria-hidden="true"></i></a><div style="position: absolute;width: 135px;z-index: 1000; margin-left: 25px"><div style="display:none;width:auto" id="publicPageMenu" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 downloads-button"><ul style="width: 100%"><li style="width: 100%"><a id="companyPageButton" ui-sref="companypage({hash: \'400\'})" target="_blank"><button class="btn" style="display: inline-block; height: auto; width: 100%"><span style="margin-left: -45px"><i class="fa fa-eye"></i> &nbsp;&nbsp; View</span></button></a></li><li style="width: 100%"><a><button class="btn" style="display: inline-block; height: auto; width: 100%" data-toggle="modal" data-target="#embedLinkModal"><span style="margin-left: -5px"><i class="fa fa-link fa-flip-horizontal"></i> &nbsp;&nbsp; Embed Link</span></button></a></li><li style="width: 100%"><a><button class="btn" style="display: inline-block; height: auto; width: 100%" data-toggle="modal" data-target="#shareGalleryModal"><span style="margin-left: -40px"><i class="fa fa-share-alt"></i> &nbsp;&nbsp; Share</span></button></a></li></ul></div></div></div><h2 ng-if="toState.name  == \'home\'">{{pageTitle}} {{userFirstName}}</h2><h2 id="orderNo" ng-if="toState.name == \'order-details\'"></h2><h2 id="invoiceNo" ng-if="toState.name == \'invoice-details\'"></h2></div><!-- START Public Gallery Controllers --><div class="centerelement" ng-if="(pageTitle == \'Samples\' && !showSearch)"><div style="text-align:center"><div style="width: 265px" class="btn-group"><a type="button" class="btn buttongroupbtn" ng-class="{\'active\':!galleryView}" ng-click="toggleGalleryView(false)">{{\'Table View\' | translate}}</a> <a type="button" class="btn buttongroupbtn" ng-class="{\'active\':galleryView}" ng-click="toggleGalleryView(true)">{{\'Gallery View\' | translate}}</a></div></div></div><!-- END Public Gallery Controllers --><div class="rightside account"><div class="dropdown" ng-if="vm.isAuthenticated()"><ul><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><button data-toggle="dropdown" class="account-button"><i class="fa fa-user" aria-hidden="true"></i> <span class="caret"></span></button></a><ul class="dropdown-menu text-align-left" uib-dropdown-menu uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><li ng-if="false" ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logoutCompletely()" id="logout"><span>Sign out completely</span></a></li><li style="display: flex; flex-direction: row; padding: 14px; border-bottom: 1px solid #e3e3e3; min-width: 200px"><div class="circle-for-name">{{ vm.contact.first_name_letter ? vm.contact.first_name_letter : \'\'}}{{ vm.contact.last_name_letter ? vm.contact.last_name_letter : \'\'}}</div><div style="display: flex; margin-left: 14px; flex-direction: column; color: #3a516b"><div>{{ vm.contact.first_name ? vm.contact.first_name : \'\' }} {{ vm.contact.last_name ? vm.contact.last_name : \'\' }}</div><div style="font-family: OpenSans-Light; font-size: 12px">{{ vm.contact.login }}</div></div></li><li ng-if="vm.customers && vm.customers.length > 1" style="padding: 14px; font-family: OpenSans-Semibold; color: #3a516b; border-bottom: 1px solid #e3e3e3" ui-sref-active="active" ng-switch-when="true"><div>Companies:</div></li><li ng-if="vm.customers && vm.customers.length > 1" ng-repeat="customer in vm.customers"><a ng-click="vm.switchCustomer(customer)" ng-class="{ \'active-account\' :  vm.selectedCustomer == customer}">{{ customer.company_name }}</a></li><li ui-sref-active="active" ng-switch-when="true"><a style="font-family: OpenSans-Semibold" href="" ng-click="vm.logout()" id="logout"><span>Log Out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span>Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span>Register</span></a></li></ul></li><li class="title-icon">{{\'Account\' | translate}}</li></ul></div></div><!-- -YEET-: Hiding for now --><!-- Start - Notifications --><!--                      <div class="rightside" ng-if="vm.isAuthenticated()">\n                        <div class="dropdown">\n                              <ul>\n                                <li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer">\n\n                                    <a class="dropdown-toggle" uib-dropdown-toggle href="" id="notifications">\n                                        <button data-toggle="dropdown" class="notification-button">\n                                          <span class="notification-label" ng-if="newNotification">{{newNotification}}</span>\n                                          <i class="fa fa-flag" aria-hidden="true"></i> <span class="caret"></span>\n                                        </button>\n                                    </a>\n\n                                    <ul class="dropdown-menu nofi-dropdown" uib-dropdown-menu uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()">\n                                      <li>\n                                        <ul class="notification-list scrollbox">\n                                            <div  ng-repeat="notification in topNotifications track by notification.id " ng-switch="notification.notificationOrigin">\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="ORDER_PLACED">\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="RESULTS_COMPLETED" >\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="SAMPLE_RECEIVED" >\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="PRELIMINARY_RESULTS" >\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="INVOICE_AVAILABLE" >\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                                <li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="PAYMENT_RECEIVED" >\n                                                    <div  bind-html-compile="notification.web2Description"></div>\n                                                </li>\n\n                                            </div>\n                                       </ul>\n                                      </li>\n\n                                      <li class="buttons-field">\n                                        <a ui-sref="notifications" href="#/notifications" class="btn btn-primary">View All</a>\n                                        <button class="btn btn-white" ng-click="markAllAsRead()">Mark All as Read</button>\n                                        <button class="btn btn-settings" ng-click="notificationSettings()"><i class="fa fa-cog"></i></button>\n                                      </li>\n                                    </ul>\n\n                                </li>\n                                <li class="title-icon">Notifications</li>\n                                </ul>\n                            </div>\n                    </div> --><!-- End - Notifications --><div class="rightside" ng-if="vm.isAuthenticated()"><div class="dropdown"><ul><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a ui-sref="faq" href="#/faq" id="faq"><button><i class="fa fa-question" aria-hidden="true"></i></button></a></li><li class="title-icon">FAQ</li></ul></div></div><!-- START - Search --><div class="rightside" ng-if="(pageTitle == \'Samples\') || (pageTitle == \'Orders\')"><div class="dropdown"><ul><li uib-dropdown class="dropdown pointer"><a href="javascript:void(0)"><button id="search" ng-click="vm.toggleSearch()"><i class="fa fa-search" aria-hidden="true"></i></button></a></li><li class="title-icon">{{\'Search\' | translate}}</li></ul></div></div><div class="search-box" ng-class="class" ng-if="((pageTitle == \'Samples\') || (pageTitle == \'Orders\')) " ng-show="showSearch"><form id="searchForm" ng-submit="vm.search()"><input style="float:left" focus-on="focus-search" id="searchBox" type="text" name="search" ng-model="vm.searchQuery" placeholder="Search" value="" class="input-search"></form><i class="fa fa-times" id="close-search" ng-click="vm.closeSearch()"></i></div><!-- END - Search --></div></div></div></div></div>');
$templateCache.put('app/layouts/sidebar/sidebar.html','<!--<div id="main-sidebar" class="main-sidebar" ng-if="vm.isAuthenticated() || vm.$state.current.name==\'public\' || vm.$state.current.name==\'publicSampleNotFound\'  ">--><!--<div id="main-sidebar" class="main-sidebar" ng-if="vm.isAuthenticated() ">--><div id="main-sidebar" class="main-sidebar" ng-class="{\'menu-remove\': isActive}" ng-if="vm.isAuthenticated() || vm.$state.current.name==\'public\' || vm.$state.current.name==\'publicSampleNotFound\'  || vm.$state.current.name==\'customerPublic\'"><div class="hlogo remove-all" ng-class="{\'menu-name-remove\': isActive}"><a ui-sref="home"><img src="/content/brand/logo-sidebar.png" alt="portal logo" class="sidebar-brand-logo"></a></div><div class="nav-bg-img"></div><hr><div class="sidebar-menu"><ul ng-if="vm.isAuthenticated()"><a ui-sref="home" ui-sref-active="active"><li><i class="fa fa-home" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; {{\'Home\' | translate}}</span></li></a><a ng-show="vm.tabs.submit.show" ui-sref="samplesubmit" ui-sref-active="active"><li><i class="fa fa-hand-pointer-o" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; {{\'Submit\' | translate}}</span></li></a><a ui-sref="orders" ui-sref-active="active"><li><i class="fa fa-list-ul" aria-hidden="true"></i> <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}" ng-class="{\'menu-name-remove\': isActive}">&nbsp; &nbsp; {{\'Orders\' | translate}}</span></li></a><a ui-sref="samplelog" ui-sref-active="active"><li><i class="fa fa-eyedropper" aria-hidden="true"></i> <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}">&nbsp; &nbsp; {{\'Samples\' | translate}}</span></li></a><a ng-show="vm.tabs.publicGallery.show" ui-sref="publicviewlog" ui-sref-active="active"><li><i class="fa fa-users" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; {{\'Public Gallery\' | translate}}</span></li></a><a ui-sref="calendar" ui-sref-active="active"><li><i class="fa fa-calendar" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; {{\'Calendar\' | translate}}</span></li></a><a ng-show="vm.tabs.manage.show" ui-sref="customermanage" ui-sref-active="active"><li><i class="fa fa-id-card" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; {{\'Manage\' | translate}}</span></li></a><a ng-show="vm.tabs.billing.show" ui-sref="invoicelog" ui-sref-active="active"><li><i class="fa fa-usd" aria-hidden="true"></i> <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}">&nbsp; &nbsp; {{\'Billing\' | translate}}</span></li></a><!-- -YEET-: Hiding for now --><!--             <a ui-sref="notifications" ui-sref-active="active">\n                <li> <i class="fa fa-flag" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; Notifications</span></li>\n            </a> --><!-- -YEET-: Hiding for now --><!--             <a ui-sref="customerPublic({dbaName: vm.getDbaName()})" ui-sref-active="active">\n                <li> <i class="fa fa-briefcase" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; Company Page</span></li>\n            </a> --></ul><ul ng-if="!vm.isAuthenticated()"><a ui-sref="login" ui-sref-active="active"><li><i class="fa fa-tachometer" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; Login</span></li></a><!-- -YEET-: Hiding for now --><!--             <a ui-sref="customerPublic({dbaName: vm.getDbaName()})" ui-sref-active="active">\n                <li> <i class="fa fa-th" aria-hidden="true"></i><span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp; Company</span></li>\n            </a> --></ul><ul class="sidebar-nav admin-list" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><i class="fa fa-th"></i> <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}">&nbsp; &nbsp; {{\'Entities\' | translate}}</span></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="sync-qb-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sync QBench Log</span></a></li><li ui-sref-active="active"><a ui-sref="faq-manage" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>FAQ Manage</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--             <li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN">\n                <a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu">\n                        <span>\n                            <i class="fa fa-user"></i>\n                            <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}"> &nbsp; &nbsp;\n                                Account\n                            </span>\n                        </span>\n                </a>\n                <ul class="dropdown-menu" uib-dropdown-menu>\n                    <li ui-sref-active="active" ng-switch-when="true">\n                        <a ui-sref="settings" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-wrench"></span>&nbsp;\n                            <span>Settings</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active" ng-switch-when="true">\n                        <a ui-sref="password" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-lock"></span>&nbsp;\n                            <span>Password</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active" ng-switch-when="true">\n                        <a ui-sref="sessions" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-cloud"></span>&nbsp;\n                            <span>Sessions</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active" ng-switch-when="true">\n                        <a href="" ng-click="vm.logout()" id="logout">\n                            <span class="glyphicon glyphicon-log-out"></span>&nbsp;\n                            <span>Sign out</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active" ng-switch-when="false">\n                        <a href="" ng-click="vm.login()" id="login">\n                            <span class="glyphicon glyphicon-log-in"></span>&nbsp;\n                            <span>Sign in</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active" ng-switch-when="false">\n                        <a ui-sref="register" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                            <span>Register</span>\n                        </a>\n                    </li>\n                </ul>\n            </li> --><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer" has-authority="ROLE_ADMIN"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><i class="fa fa-institution"></i> <span class="remove-all" ng-class="{\'menu-name-remove\': isActive}">&nbsp; &nbsp; {{\'Administration\' | translate}}</span></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseSidebar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>{{\'User management\' | translate}}</span></a></li><!--                     <li ui-sref-active="active">\n                        <a ui-sref="jhi-metrics" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-dashboard"></span>&nbsp;\n                            <span>Metrics</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active">\n                        <a ui-sref="jhi-health" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-heart"></span>&nbsp;\n                            <span>Health</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active">\n                        <a ui-sref="jhi-configuration" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-list-alt"></span>&nbsp;\n                            <span>Configuration</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active">\n                        <a ui-sref="audits" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-bell"></span>&nbsp;\n                            <span>Audits</span>\n                        </a>\n                    </li>\n                    <li ui-sref-active="active">\n                        <a ui-sref="logs" ng-click="vm.collapseSidebar()">\n                            <span class="glyphicon glyphicon-tasks"></span>&nbsp;\n                            <span>Logs</span>\n                        </a>\n                    </li> --><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseSidebar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li></ul></div></div>');
$templateCache.put('app/pages/calendar/calendar-day-modal.html','<div class="modal-header modal-sample-submit"><div class="topbuffer1"></div><h4 class="modal-title pull-left samplemodaltitle">Samples - <span style="color: #2a9ecf">{{ vm.date.format(\'MMMM DD\') | uppercase }}</span> <small>({{ vm.totalSamplesText }})</small></h4><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.closeModal()"></i></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><ul class="calendarDayModalSamples"><li ng-repeat="sample in vm.samples"><div ng-if="sample.id != -1" class="calendar-sample-event" ng-click="vm.openPublicSample(sample)"><strong>{{ sample.id }}</strong> {{ sample.name }}</div></li></ul></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><div class="topbuffer2"></div><button ng-click="vm.closeModal()" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> &nbsp; &nbsp; Cancel &nbsp; &nbsp; &nbsp;</button> <button type="button" class="btn btn-primary" ng-click="vm.toSamplesPage()">See List Page</button></div>');
$templateCache.put('app/pages/calendar/calendar.html','<style>.fc-day {\n\t\tposition: relative;\n\t}\n\t.fc-more-cell {\n\t\ttext-align: right;\n\t}\n\n\t.fc-content-skeleton {\n\t\tpointer-events: none;\n\t}\n\n\t.fc-content-skeleton a,\n\t.fc-content-skeleton .calendar-sample-event {\n\t\tpointer-events: all;\n\t}\n\n\t.fc-header-toolbar .fc-left h2 {\n\t\tdisplay: none;\n\t}</style><div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid"><div class="row"><div class="col-md-6"><div class="sample-log-btn-div"><button class="sample-log-btn hover-btn-blue" ng-click="vm.today()">Today</button></div><div class="sample-log-btn-div" style="margin-right: 0"><button type="button" class="sample-log-btn hover-btn-blue" style="border-right: none !important; border-radius: 3px 0 0 3px" ng-click="vm.prevMonth()"><i class="fa fa-angle-left"></i></button></div><div class="sample-log-btn-div" style="margin-left: -4px"><button type="button" class="sample-log-btn hover-btn-blue" style="border-left: none !important; border-radius: 0 3px 3px 0" ng-click="vm.nextMonth()"><i class="fa fa-angle-right"></i></button></div><span style="font-family: OpenSans-Semibold; color: #2d4760; padding-left: 15px">{{ vm.calendarHeader }}</span></div><div class="col-md-6" style="padding-right: 40px"><div class="pull-right"><div id="btn-sample-filters" class="sample-log-btn-div"><button ng-class="vm.activeWidget === \'calendarEditFilters\' ? \'btn-active\' : \'\'" ng-click="vm.toggleWidget(\'calendarEditFilters\')" type="button" class="sample-log-btn pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue"><i class="fa fa-sliders"></i>&nbsp; {{\'Filters\' | translate}} <span ng-show="vm.totalFilters > 0">({{vm.totalFilters}})</span> <i class="fa fa-caret-down"></i></button></div></div></div><div style="clear:both"></div><div ng-show="vm.activeWidget === \'calendarEditFilters\'" class="row tabbackall filters-div" style="border-top: 1px solid #e6ebf0; margin-top: 16px; padding-top: 8px; padding-right: 8px"><div class="col-md-12"><div class="pull-right" style="padding-right: 12px" ng-click="vm.toggleWidget(\'sampleEditFilters\')">\xD7</div></div><div class="col-md-12"><table class="filters-table"><tr><td class="filter-column col-sm-2"><div class="form"><label>{{\'Type\' | translate}}</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Category" ng-model="vm.calendarFilters.categoryIdList" ng-options="category.id as (category.name | translate) for category in vm.categories  | lngFilterOptions:vm.currentLanguage"><option value="">{{\'Select\' | translate}}</option></select></div></div></td><td class="filter-column col-sm-2"><div class="form"><label>{{\'Status\' | translate}}</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" ng-options="status.value as (status.text | translate) for status in vm.orderStatuses track by status.value" ng-model="vm.calendarFilters.orderStates"><option value="">{{\'Select\' | translate}}</option></select></div></div></td><td ng-show="!vm.consolidated_business_type.includes(\'food\')" class="filter-column col-sm-8"><div class="form"><label for="filterAllOrders" style="margin-right: 8px"><input type="radio" name="filterCalendarOrderType" id="filterAllOrders" checked="checked" ng-model="vm.calendarFilters.orderType"> <span class="css-label" style="font-family: OpenSans-Regular">{{\'All\' | translate}}</span></label><label for="filterRndOrders" style="margin-right: 8px"><input type="radio" name="filterCalendarOrderType" id="filterRndOrders" value="RD" ng-model="vm.calendarFilters.orderType"> <span class="css-label" style="font-family: OpenSans-Regular">R&D</span></label><label for="filterComplianceOrders" style="margin-right: 8px"><input type="radio" name="filterCalendarOrderType" id="filterComplianceOrders" value="COMPLIANCE" ng-model="vm.calendarFilters.orderType"> <span class="css-label" style="font-family: OpenSans-Regular">{{\'Compliance\' | translate}}</span></label></div></td></tr></table></div><div class="col-md-12" style="border-top: 1px solid #e6ebf0; margin-top: 24px; padding-top: 16px"><div class="pull-right"><button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" ng-click="vm.toggleWidget(\'sampleEditFilters\')"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" style="margin-left: 8px" ng-if="vm.getFilterCount() > 0" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle" aria-hidden="true"></i> Clear Filters</button> <button type="button" class="btn btn-primary" style="margin-left: 8px" ng-click="vm.filterSamples()">{{\'Apply Filters\' | translate}}</button></div></div></div><div class="col-md-12"><div class="text-center"><span class="alert alert-warning" ng-if="vm.calendarLoading">Loading...</span> <span class="alert alert-danger" ng-if="vm.calendarLoadError">Could not load samples</span></div></div></div></div></div><div class="tabbackall"><div class="tab-content tabback"><div class="bigbox box-shadow-table res-box-height"><div ui-calendar="vm.calendarOptions" id="estimatedDueDateCalendar" ng-model="vm.events"></div></div></div></div></div>');
$templateCache.put('app/pages/company-page/companypage.html','<style>.filters-div input::-webkit-outer-spin-button,\n\t.filters-div input::-webkit-inner-spin-button,\n\t#publishToWeedmapsForm input::-webkit-outer-spin-button,\n\t#publishToWeedmapsForm input::-webkit-inner-spin-button {\n\t    /* display: none; <- Crashes Chrome on hover */\n\t    -webkit-appearance: none;\n\t    margin: 0; /* <-- Apparently some margin are still there even though it\'s hidden */\n\t}\n\n\tbutton.btn-no-style {\n\t\tborder: none;\n\t\tbackground-color: transparent;\n\t\toutline:none;\n\t}\n\n\t.help-block {\n\t  display: block;\n\t  margin-top: 5px;\n\t  margin-bottom: 10px;\n\t  color: #777;\n\t}\n\n\t.test-result-text {\n\t\tfont-size: 14px\n\t}\n\n\t#table>tbody>tr>td {\n\t\tpadding: 8px 0!important;\n    }\n\n\ta.non-click{\n\t\tcursor: default;\n        color: black;\n\t\twhite-space: nowrap;\n\t}\n\ta.non-click:hover{\n\t\tcursor: default;\n        color: black;\n\t}</style><div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid wrapper"><div class="row position-tbl-responsive-control"><div class="col-lg-5 col-md-5 col-sm-6 col-xs-6" style="float:left;line-height:32px;height:32px"><div style="color: #34485C;font-family: OpenSans-Semibold"><!-- <img ng-if="vm.customerData.logo" src="{{vm.customerData.logo}}" style="width:20px;height:20px;margin-right: 5px">  --> {{vm.customerData.company_name}}</div></div><div class="col-lg-7 col-md-7 col-sm-8 col-xs-8 statuslist statuslist1"><!--<div id="btn-sample-csv" class="btn-box-for-sample-csv">\n                        <button type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#downloadSamplesModal">{{\'Download Samples\' | translate}}</button>\n                    </div>--><div id="btn-sample-filters" class="sample-log-btn-div"><button ng-class="vm.activeWidget === \'sampleEditFilters\' ? \'btn-active\' : \'\'" ng-click="vm.toggleWidget(\'sampleEditFilters\')" type="button" class="sample-log-btn pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue"><i class="fa fa-sliders"></i>&nbsp; {{\'Filters\' | translate}} <span ng-show="vm.totalFilters > 0">({{vm.totalFilters}})</span> <i class="fa fa-caret-down"></i></button></div></div><!-- Table dots --><div class="tbl-responsive-control" ng-show="!galleryView"><ul class="tbl-dots"></ul></div><!--./ Table dots --><div style="clear:both"></div><div ng-show="vm.activeWidget === \'sampleEditFilters\'" class="row tabbackall filters-div" style="border-top: 1px solid #e6ebf0; margin-top: 8px; padding-top: 8px; padding-right: 8px"><div class="col-md-12"><div class="pull-right" style="padding-right: 12px" ng-click="vm.toggleWidget(\'sampleEditFilters\')">\xD7</div></div><div class="col-md-12"><table class="filters-table"><tr><td class="filter-column"><div class="form"><label>Sample ID</label><input type="number" placeholder="Enter sample ID" class="filter-input" ng-model="vm.sampleFilters.id"></div><div class="form"><label>Order ID</label><input type="number" placeholder="Enter order ID" class="filter-input" ng-model="vm.sampleFilters.orderId"></div></td><td class="filter-column"><div class="form"><label>Sample Name:</label><input placeholder="e.g. Blue Dream" class="filter-input" ng-model="vm.sampleFilters.sampleName"></div><div class="form"><label>Lot No.:</label><input placeholder="e.g. 11232145" class="filter-input" ng-model="vm.sampleFilters.lotNumber"></div><div class="form"><label>METRC ID:</label><input placeholder="e.g. 1245836556" class="filter-input" ng-model="vm.sampleFilters.metrcId"></div></td><td class="filter-column"><div class="form"><label>Category</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Category" ng-change="vm.populateTypes()" ng-model="vm.sampleFilters.category" ng-options="category as category.name for category in vm.productCategories track by category.id"><option value="">{{\'Select\' | translate}}</option></select></div></div><div class="form"><label>Subcategory</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Type" ng-model="vm.sampleFilters.subCategory" ng-options="productType as productType.name for productType in vm.productTypes track by productType.id"><option value="">{{\'Select\' | translate}}</option></select></div></div></td><td class="filter-column"><div class="form"><label>Order Type</label><div><label for="filterAllOrders"><input type="radio" name="filterSampleOrderType" id="filterAllOrders" checked="checked" value="ALL" ng-model="vm.sampleFilters.orderType"> <span class="css-label">All</span></label></div><div><label for="filterRndOrders"><input type="radio" name="filterSampleOrderType" id="filterRndOrders" value="R&D" ng-model="vm.sampleFilters.orderType"> <span class="css-label">R&D</span></label></div><div><label for="filterComplianceOrders"><input type="radio" name="filterSampleOrderType" id="filterComplianceOrders" value="COMPLIANCE" ng-model="vm.sampleFilters.orderType"> <span class="css-label">Compliance</span></label></div></div></td><td class="filter-column"><div class="form row"><div class="col-md-12"><label>THC % (range):</label></div><div class="col-md-6 filter-input-range-1"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.thcLower"></div><div class="col-md-6 filter-input-range-2"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.thcUpper"></div></div><div class="form row"><div class="col-md-12"><label>CBD % (range):</label></div><div class="col-md-6 filter-input-range-1"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.cbdLower"></div><div class="col-md-6 filter-input-range-2"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.cbdUpper"></div></div></td><!-- <td class="filter-column">\n\t\t\t\t\t\t\t\t\t<div class="form">\n\t\t\t\t\t\t\t\t\t\t<label>Pass/Fail Status</label>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsPass" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isPass">\n\t\t\t\t                            <label for="sampleFilterIsPass" class="css-label">Pass</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsFail" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isFail">\n\t\t\t\t                            <label for="sampleFilterIsFail" class="css-label">Fail</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsUndetermined" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isUndetermined">\n\t\t\t\t                            <label for="sampleFilterIsUndetermined" class="css-label">Undetermined</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t</div>\n\t\t\t\t\t\t\t\t</td> --><!-- <td class="filter-column">\n\t\t\t\t\t\t\t\t\t<div class="form">\n\t\t\t\t\t\t\t\t\t\t<label>Weedmaps Pubish Status</label>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsWeedmapsPublishedSuccess" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsSuccess">\n\t\t\t\t                            <label for="sampleFilterIsWeedmapsPublishedSuccess" class="css-label">Success</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsWeedmapsPublishedFail" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsFail">\n\t\t\t\t                            <label for="sampleFilterIsWeedmapsPublishedFail" class="css-label">Fail</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t\t<div>\n\t\t\t                   \t\t\t\t<input id="sampleFilterIsWeedmapsPublishedNone" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsNone">\n\t\t\t\t                            <label for="sampleFilterIsWeedmapsPublishedNone" class="css-label">None</label>\n\t\t\t                   \t\t\t</div>\n\t\t\t                   \t\t</div>\n\t\t\t\t\t\t\t\t</td> --><!--\n\t\t\t\t\t\t\t\t<td class="filter-column">\n\t\t\t\t\t\t\t\t\t<div class="form">\n\t\t\t\t\t\t\t\t\t\t<label>Public Visibility:</label>\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t            <label for="filterSamplesIsPublicAndPrivate">\n\t\t\t\t\t\t\t\t                <input type="radio" name="filterSamplesVisiblity" id="filterSamplesIsPublicAndPrivate" checked  value="BOTH" ng-model="vm.sampleFilters.visibility">\n\t\t\t\t\t\t\t\t                <span class="css-label">Both</span>\n\t\t\t\t\t\t\t\t            </label>\n\t\t\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t            <div>\n\t\t\t\t\t\t\t\t            <label for="filterSamplesIsPublic">\n\t\t\t\t\t\t\t\t                <input type="radio" name="filterSamplesVisiblity" id="filterSamplesIsPublic" value="PUBLIC" ng-model="vm.sampleFilters.visibility">\n\t\t\t\t\t\t\t\t                <span class="css-label">Visible</span>\n\t\t\t\t\t\t\t\t            </label>\n\t\t\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t            <div>\n\t\t\t\t\t\t\t\t            <label for="filterSamplesIsPrivate">\n\t\t\t\t\t\t\t\t                <input type="radio" name="filterSamplesVisiblity"  id="filterSamplesIsPrivate"  value="PRIVATE" ng-model="vm.sampleFilters.visibility">\n\t\t\t\t\t\t\t\t                <span class="css-label">Not Visible</span>\n\t\t\t\t\t\t\t\t            </label>\n\t\t\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t        </div>\n\t\t\t\t\t\t\t\t</td> --><td class="filter-column"><div class="form"><label>Completed Date Range:</label><div class="filter-input-date"><input class="filter-input" placeholder="Start Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sampleFilters.completeDateLower" is-open="vm.datePickerOpenStatus.sampleFilterCompleteDateLower" ng-click="vm.openCalendar(\'sampleFilterCompleteDateLower\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'sampleFilterCompleteDateLower\')"></i></div><div class="filter-input-date"><input class="filter-input" placeholder="End Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sampleFilters.completeDateUpper" is-open="vm.datePickerOpenStatus.sampleFilterCompleteDateUpper" ng-click="vm.openCalendar(\'sampleFilterCompleteDateUpper\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'sampleFilterCompleteDateUpper\')"></i></div></div></td></tr></table></div><div class="col-md-12"><div class="pull-right"><button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" ng-click="vm.toggleWidget(\'sampleEditFilters\')"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" style="margin-left: 8px" ng-if="vm.totalFilters > 0" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle" aria-hidden="true"></i> Clear Filters</button> <button type="button" class="btn btn-primary" style="margin-left: 8px" ng-click="vm.filterSubmit()">{{\'Apply Filters\' | translate}}</button></div></div></div></div></div></div><!-- Simple Filters Section --><div class="wrapper" style="margin-top: 15px; margin-bottom: 15px"><div style="background-color: #f9fcfe; border: 1px solid #e6ebf0; border-radius: 4px; padding: 20px"><!-- Filters Row --><div class="row" style="margin-bottom: 15px"><!-- Sample Name --><div class="col-lg-3 col-md-6" style="margin-bottom: 8px"><div><label style="font-size: 14px; font-weight: 600; color: #34485C; margin-bottom: 8px; display: block">Sample Name</label><input placeholder="e.g. Blue Dream" class="form-control" style="height: 38px" ng-model="vm.sampleFilters.sampleName" ng-keypress="$event.keyCode === 13 && vm.filterSubmit()"></div></div><!-- Sample ID --><div class="col-lg-3 col-md-6" style="margin-bottom: 8px"><div><label style="font-size: 14px; font-weight: 600; color: #34485C; margin-bottom: 8px; display: block">Sample ID</label><input type="number" placeholder="Enter ID" class="form-control" style="height: 38px" ng-model="vm.sampleFilters.id" ng-keypress="$event.keyCode === 13 && vm.filterSubmit()"></div></div><!-- Lot Number --><div class="col-lg-3 col-md-6" style="margin-bottom: 8px"><div><label style="font-size: 14px; font-weight: 600; color: #34485C; margin-bottom: 8px; display: block">Lot Number</label><input placeholder="e.g. 11232145" class="form-control" style="height: 38px" ng-model="vm.sampleFilters.lotNumber" ng-keypress="$event.keyCode === 13 && vm.filterSubmit()"></div></div><!-- Category --><div class="col-lg-3 col-md-6" style="margin-bottom: 8px"><div><label style="font-size: 14px; font-weight: 600; color: #34485C; margin-bottom: 8px; display: block">Category</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Select" ng-change="vm.populateTypes()" ng-model="vm.sampleFilters.category" ng-options="category as category.name for category in vm.productCategories track by category.id"><option value="">{{\'Select\' | translate}}</option></select></div></div></div></div><!-- Buttons Row --><div class="row"><div class="col-md-12"><div style="display: flex; gap: 10px"><button type="button" class="btn btn-primary" ng-click="vm.filterSubmit(); $event.preventDefault();" style="background-color: #4f8fcc"><i class="fa fa-search"></i> Apply</button><!-- Hide Advanced button group on xs and sm screens --><div class="btn-group hidden-xs hidden-sm"><button type="button" class="btn btn-default dropdown-toggle" ng-click="vm.toggleWidget(\'sampleEditFilters\')" style="color: #333">Advanced Filters <i class="fa fa-caret-down"></i></button></div><button type="button" class="btn btn-default" ng-if="vm.totalFilters > 0" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle"></i> Clear</button></div></div></div></div></div><div class="tabbackall tabbackall3 tabbackal4"><!-- tabbackall1 --><div class="sub-content wrapper" style="padding-left: none; padding-top: 10px"><div style="float:left;line-height: 40px">{{\'Number of entries\' | translate}}: {{vm.totalItems}}</div><div style="float:right"><a style="width: 100px; margin-right: 15px" class="btn btn-static-white" ng-click="vm.toggleStarredView()" ng-class="{active: starred}"><i class="fa fa-star"></i>&nbsp;&nbsp;Starred&nbsp;&nbsp;</a><div class="custom-selectbox"><select id="lunch2" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div></div></div><div class="tab-content tabback wrapper" style="padding-right: 0" ng-switch on="vm.customerData.businessType.id"><div><!-- Embed Link --><div class="row" style="text-align:center; margin-top: -15px; margin-bottom: 20px" ng-show="showEmbedLink"><input type="text" onkeydown="return false;" style="width: 300px; height: 30px; color: #28d300" value="{{vm.embedLink}}"><a class="btn btn-link" ng-click="vm.copyEmbedLink()"><i class="fa fa-copy"></i> Copy Embed Link</a></div><div ng-init="galleryStateManagerObject = []" ng-repeat="sample in vm.samples track by sample.id" class="gallery-sample-box"><div ng-init="galleryStateManagerObject[sample.id]={showShares:false, showResults: false, showReports:false}" class="bigbox box-shadow-table" style="padding-top:20px;height: 504px"><div style="line-height: 30px;margin-bottom: 10px"><h3 class="bigbox-title" style="height: 15px"><div style="float:left; margin-right: 5px"><i ng-show="!sample.starred" class="fa fa-star-o favorite-button"></i><i ng-show="sample.starred" class="fa fa-star favorite-button"></i></div><a target="_blank" style="color:#556d85; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; max-width: 100%" ui-sref="public({hash:sample.hash})">{{sample.name}}</a></h3><!-- <div style="float:right">\n\n\t\t\t\t            \t<span style="font-size: 13px; color: #34485c; margin-right: 10px;float: left;" ng-show="!sample.is_public">Not Visible</span>\n\t\t\t\t            \t<span style="font-size: 13px; color: #34485c; margin-right: 10px;float: left;" ng-show="sample.is_public">Visible</span>\n\t\t\t\t            \t<label class="switch" style="margin-top: -12px !important;">\n\t\t\t                        <input type="checkbox" ng-checked="{{sample.is_public}}" ng-click="toggleVisibility(sample.id, sample)">\n\t\t\t                        <div class="slider round"></div>\n\t\t\t                        </input>\n\t\t\t                    </label>\n\n\t\t\t            \t</div>--><!-- <span style="margin-left: -18px;"><span style="color:#2a9ecf" class="big-heading">Sample ID:</span> {{sample.id}}</span> --> <span class="sample-id"><span style="color:#2a9ecf" class="big-heading">{{\'Sample ID\' | translate}}:</span> <a target="_blank" ui-sref="public({hash:sample.hash})" style="font-weight: 500;color: #f1b21a !important">{{sample.id}}</a></span></div><hr style="margin-left: -15px; margin-right: -15px; margin-bottom:0px; margin-top:0px"><div style="height: 370px"><div ng-show="!galleryStateManagerObject[sample.id].showResults" style="margin-left: -15px; margin-right: -15px"><div class="photocontainer center-img" style="height: 305px !important; position: relative"><a ui-sref="public({hash:sample.hash})"><img class="center-img" style="border: 1px" ng-src="{{ sample.picture ? sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture" loading="lazy" decoding="async"></a></div><table class="sample-metrics-table" ng-class="{\'has-cannabinoids\': hasCannabinoids(sample)}"><thead><tr><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading"><img style="width: 15px" src="content/images/thc-icon.png"> THC</th><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading"><img style="width: 15px" src="content/images/cbd-icon.png"> CBD</th><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading">Total</th><th class="sample-metrics-heading status-heading">Status</th></tr></thead><tbody><tr><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'thc\', false, true) }}</td><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'cbd\', false, true) }}</td><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'total\', true, true) }}</td><td class="sample-metrics-cell status-cell"><div class="sample-status-text"><p class="test-pass" style="color: #28d300" ng-if=\'sample.status === "PASS"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Pass</span></p><p class="test-fail" style="color: red" ng-if=\'sample.status === "FAIL"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Fail</span></p><p class="test-in-progress" style="color: #ff8100" ng-if=\'sample.status === "IN_PROGRESS" && vm.hasDueDate(sample)\'><span class="fa fa-clock-o test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "IN_PROGRESS" && !vm.hasDueDate(sample)\'><span class="fa fa-stop-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "NO_STATUS"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Not Tested</span></p><p class="test-retesting" style="color: #5eb1bf" ng-if=\'sample.status === "RETESTING"\'><i class="fa fa-repeat test-result-icon"></i> <span class="test-result-text">&nbsp;Retesting</span></p></div></td></tr></tbody></table></div><div style="background-color: #f9fcfe;margin-left:-15px;margin-right:-15px; height: 100%;padding-bottom: 10px" ng-show="galleryStateManagerObject[sample.id].showResults"><div ng-show="galleryStateManagerObject[sample.id].showResults" style="background-color: #f1f7fa; padding-top:5px"><a style="float:right; margin-right: 10px" ng-click="galleryStateManagerObject[sample.id].showResults = !galleryStateManagerObject[sample.id].showResults"><i class="fa fa-times-circle"></i></a><table class="sample-metrics-table" ng-class="{\'has-cannabinoids\': hasCannabinoids(sample)}"><thead><tr><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading"><img style="width: 15px" src="content/images/thc-icon.png"> THC</th><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading"><img style="width: 15px" src="content/images/cbd-icon.png"> CBD</th><th ng-if="hasCannabinoids(sample)" class="sample-metrics-heading">Total</th><th class="sample-metrics-heading status-heading">Status</th></tr></thead><tbody><tr><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'thc\', false, true) }}</td><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'cbd\', false, true) }}</td><td ng-if="hasCannabinoids(sample)" class="sample-metrics-cell">{{ vm.determinePotencyDisplay(sample, \'total\', true, true) }}</td><td class="sample-metrics-cell status-cell"><div class="sample-status-text"><p class="test-pass" style="color: #28d300" ng-if=\'sample.status === "PASS"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Pass</span></p><p class="test-fail" style="color: red" ng-if=\'sample.status === "FAIL"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Fail</span></p><p class="test-in-progress" style="color: #ff8100" ng-if=\'sample.status === "IN_PROGRESS"\'><span class="fa fa-clock-o test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "NO_STATUS"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Not Tested</span></p><p class="test-retesting" style="color: #5eb1bf" ng-if=\'sample.status === "RETESTING"\'><span class="fa fa-repeat test-result-icon"></span> <span class="test-result-text">&nbsp;Retesting</span></p></div></td></tr></tbody></table></div><hr style="margin-bottom:0px; margin-top:0px"><div style="overflow:auto; height: 259px"><table class="hover-tests-table"><thead><tr><th>Tests</th><th>Status</th></tr></thead><tbody style="overflow:auto; height: 100px" hover-display-results determine-test-pf="determineTestPf" sample="sample" is-other-analysis="isOtherAnalysis" has-other-analyses="hasOtherAnalyses" can-see-other-analyses="canSeeOtherAnalyses" assay-identifier-to-name="assayIdentifierToName"><tr ng-repeat="test in sample.sampleTests"><td>{{ test.assay.title }}</td><td ng-bind-html="vm.determinePfDisplay(test.statusPf)"></td></tr></tbody></table></div></div></div><div><hr style="margin-left: -15px; margin-right: -15px; margin-top: 2px; margin-bottom: 15px"><div style="vertical-align: middle"><div style="float:left"><a class="btn btn-link action-button" data-toggle="modal" data-target="#shareSampleModal" ng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)" ng-class="{active: galleryStateManagerObject[sample.id].showShares}" ng-click="galleryStateManagerObject[sample.id].showShares = !galleryStateManagerObject[sample.id].showShares"><i class="fa fa-share-alt"></i></a></div><div style="float:right; vertical-align: middle"><a style="width: 80px" class="btn btn-link img-gallery-btn test-button" ng-class="{active: galleryStateManagerObject[sample.id].showResults}" ng-click="galleryStateManagerObject[sample.id].showResults = !galleryStateManagerObject[sample.id].showResults"><i class="fa {{galleryStateManagerObject[sample.id].showResults == true ? \'fa-arrow-down\' : \'fa-arrow-up\'}}"></i> Tests</a> <a style="width: 115px; background-color: #4f8fcc; margin-left: 10px" class="btn btn-primary img-gallery-btn" ng-if="!sample.attachments" ng-click="getAttachments (sample,sample.id)"><i class="fa fa-arrow-circle-down"></i> Download</a><div class="custom-selectbox img-gallery-btn downloads-button" style="width: 115px; float:right; margin-left: 5px; margin-top: -1px" ng-if="sample.attachments"><div style="width: 100%; color: black;height: 100%" ng-click="sample.attachments.length >= 1 ? galleryStateManagerObject[sample.id].showReports = !galleryStateManagerObject[sample.id].showReports : null" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 downloads-button sample-report-selectbox"><span ng-show="sample.attachments.length == 0">Empty</span> <span ng-show="sample.attachments.length > 0">Select</span></div><div ng-show="galleryStateManagerObject[sample.id].showReports && sample.attachments" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 downloads-button" style="width:auto;position:absolute; z-index: 9"><a class="non-click download-options" ng-repeat="attach in sample.attachments track by $index" ng-click="downloadAttachment(attach.hash, sample)">{{attach.file_name}}<br></a><a ng-show="hasCannabinoids(sample)" ng-click="vm.downloadSampleCOA(sample.id, sample.hash)">{{ sample.id }}_COA_Summary.pdf</a></div></div></div></div></div></div></div></div><!-- FOOTER PAGE SELECTER --><div class="page-list company-footer"><div class="company-box"><span hidden></span></div><div class="company-box mobile-box-pagination" ng-if="(vm.itemsPerPage * 1) < (vm.totalItems* 1)"><span style="margin-left: -14px"><uib-pagination class="pagination pageset" total-items="vm.queryCount" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></span></div><div class="company-box statuslist mobile-box-statuslist"><!-- <div class="btn-box-for-sample-csv">\n                        <button type="button" type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#downloadSamplesModal">{{\'Download Samples\' | translate}}</button>\n\t\t\t\t\t</div> --> <span><div class="custom-selectbox"><select id="lunch4" class="selectpicker select-box-padding-tiny" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div></span></div></div></div></div></div><!-- DOWNLOAD SAMPLES MODAL (CSV / COA) --><div id="downloadSamplesModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Download Samples\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><form id="downloadSamplesForm"><div class="row"><div class="col-md-12"><div class="form"><label class="cm-label">Date Range</label><a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">Retrieves by order complete date</span></a><div class="row"><div class="youremail foodadddate datepickerdate ss-input col-md-6"><input class="datepicker" placeholder="Start Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.downloadSample.startDate" is-open="vm.datePickerOpenStatus.downloadSampleStartDate" ng-click="vm.openCalendar(\'downloadSampleStartDate\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'estimated_arrival_date\')"></i></div><div class="youremail foodadddate datepickerdate ss-input col-md-6"><input class="datepicker" placeholder="End Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.downloadSample.endDate" is-open="vm.datePickerOpenStatus.downloadSampleEndDate" ng-click="vm.openCalendar(\'downloadSampleEndDate\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'estimated_arrival_date\')"></i></div></div></div><div class="form"><label for="downloadCoa"><input type="radio" name="downloadSamplesFileType" id="downloadCoa" ng-model="vm.downloadSample.type" checked="checked" value="COA"> <span class="checkBoxLabel">COA</span></label><label for="downloadCsv"><input type="radio" name="downloadSamplesFileType" id="downloadCsv" ng-model="vm.downloadSample.type" value="CSV"> <span class="checkBoxLabel">CSV</span></label></div></div><div class="col-md-12" ng-show="vm.downloadSamplesError"><div class="alert alert-danger" role="alert"><strong>Error:</strong> An error occurred while attempting to download samples</div></div><div class="col-md-12" ng-show="vm.downloadSamplesNull"><div class="alert alert-warning" role="alert"><strong>Warning:</strong> No samples found for given date range</div></div></div></form></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="vm.downloadSamples()" ng-disabled="(!vm.downloadSample.startDate && !vm.downloadSample.endDate)" ng-show="vm.downloadingSamples == false">Submit</button> <button type="button" class="btn btn-primary" disabled="disabled" ng-show="vm.downloadingSamples">Downloading...</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal --><div id="emailModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\'; " class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Info via Email</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style" style="font-size: 12px"><div style="height: 150px; margin-left: 10px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.currentPublicSample.picture ? vm.currentPublicSample.picture : \'content/images/loading.gif\' }}" alt="Sample picture" loading="lazy" decoding="async"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.currentPublicSample.name}}</h4><p><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Sample ID:</span> {{vm.currentPublicSample.id}}</p><p ng-show="vm.currentPublicSample.lotBatchNumber"><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Lot/Batch Number:</span> {{vm.currentPublicSample.lotBatchNumber}}</p></div></div><div style="clear:both"></div><div style="padding-left:25px;padding-right:25px"><form name="emailForm"><div class="row"><strong>Emails:</strong><br><p><input id="testtaginput" type="text" data-role="tagsinput" class="form-control" placeholder="email@example.com" name="email" ng-change="vm.setEmail()" style="width:100%" ng-model="vm.emailsPending[$index]" size="100"></p><p id="emailValidation" class="help-block" style="color: darkred;display:none">Please Enter a valid Email Address</p><br></div><div class="row"><strong>Subject</strong> <input id="emailSubject" type="text" style="width: 100%; height: 35px" value="{{vm.customerData.company_name}}, Sample ID: {{vm.currentPublicSample.id}}"></div><br><div class="row"><strong>Sample Page URL</strong> <input type="text" readonly="readonly" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copyPublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px; font-family: OpenSans-Semibold" ng-click="vm.copyLink(\'copyPublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div><br><div class="row"><strong>Message:</strong><p><textarea rows="4" class="form-control" ng-model="vm.emailMessage" placeholder="Optional Message"></textarea></p></div></form></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left hover-btn-blue cancel SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\';" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Close</button> <button id="sendPublicSampleButton" class="btn btn-primary pull-right" style="background-color: #4f8fcc" ng-click="vm.sendPublicEmail(emailForm)">Send</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal Success --><div id="emailModalSuccess" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Email has been sent</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><div style="height: 50px; width: 315px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.currentPublicSample.picture ? vm.currentPublicSample.picture : \'content/images/loading.gif\' }}" alt="Sample picture" loading="lazy" decoding="async"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.currentPublicSample.name}}</h4><span><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Sample ID:</span> {{vm.currentPublicSample.id}}</span></div></div><br><div style="clear: both"></div><br>You successfully shared Sample <strong>{{vm.currentPublicSample.name}}</strong> with <span ng-repeat="email in vm.emailsPending track by $index"><span ng-if="$last && vm.emailsPending.length > 1">and </span><strong>{{email}}</strong><span ng-if="!$last && vm.emailsPending.length > 1">, </span></span>.</div><div class="modal-footer modal-sample-submit" style="text-align:center"><button type="button" class="btn btn-default hover-btn-blue SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Share Sample Modal --><div id="shareSampleModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Page</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style" style="font-family: OpenSans-Semibold !important"><button class="circle-share-btn" data-toggle="modal" data-target="#emailModal" data-dismiss="modal"><i class="fa fa-envelope circle-share-icon"></i></button><br><span style="padding-left: 2px; color: #556d85; font-family: OpenSans-SemiBold">Email</span><br><br><strong style="font-family: OpenSans-Semibold !important">Copy Link to Public Sample Page:</strong> <input type="text" readonly="readonly" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copySamplePublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copySamplePublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/pages/customer-configure/customer-configure.html','<!-- THIS FUNCTIONALITY IS NOT USED ON WEB PORTAL --><div class="logo-shadow"><div class="signuppagedemo"><form id="msform"><fieldset><div class=""><div class="logo" align="center"><div class="topbuffer3"></div><img src="/content/brand/logo.png" alt="logo" class="content-brand-logo"><div class="topbuffer3"></div></div><div class="box-shadow-big"><div class="header headersign"><div align="center"><p class="signup-title">Welcome to {{ (brand.branding && brand.branding.portal_name) || \'Client Portal\' }}</p></div></div><div class="tabbackall tabbackall1"><div class="tab-content tabback tabbacksignup box-bg-color"><div class="pager" align="center"><div class=""><div class="row bs-wizard" style="border-bottom:0"><div class="col-xs-3 signuptable"></div><div class="col-xs-2 bs-wizard-step active signuptable2"><div class="text-center bs-wizard-stepnum">Company Info</div><div class="progress progress3"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">1</a></div><div class="col-xs-2 bs-wizard-step disabled signuptable2"><div class="text-center bs-wizard-stepnum">Contact Info</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">2</a></div><div class="col-xs-2 bs-wizard-step disabled signuptable2"><div class="text-center bs-wizard-stepnum">Billing</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">3</a></div></div></div><div class="topbuffer3"></div></div><div role="tabpanel" class="companyinfo" id="home"><div class="form"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Business Name <span>&nbsp;*</span></label><input type="text" placeholder="Your Business Name" ng-model="vm.customerData.company_name"><div class="topbuffer2"></div><label>Company Logo</label><div class="topbuffer1"></div><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 upload-img-res upload-img-res1"><div class="row rowimg"><img src="/content/images/logo.png" alt="logo" class="img-responsive"></div></div><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 res-size-img-uplode res-size-img-uplode1"><div class="imgicon"><div class="topbuffer3"></div><input id="upload" type="file"> <a href="" id="upload_link"><span><i class="fa fa-cloud-upload" aria-hidden="true"></i> &nbsp; Upload New Logo</span><br></a><div class="topbuffer1"></div><a href=""><span><i class="fa fa-trash-o" aria-hidden="true"></i> &nbsp; Remove Logo</span></a></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>Type of Business <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Food and Beverages Service" ng-model="vm.customerData.type_of_business"><option value="Food and Beverages Service">Food and Beverages Service</option><option value="Canabis Service">Canabis Service</option></select></div><div class="topbuffer2"></div><label>Business Description</label><input type="text" placeholder="Describe your Business with few words" ng-model="vm.customerData.businessDescription"><div class="topbuffer2"></div><label>Website URL</label><input type="text" placeholder="your company website URL" ng-model="vm.customerData.website"></div></div><hr><div class="topbuffer5"></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Street Address <span>&nbsp;*</span></label><input type="text" placeholder="e.g. Main Street 87" ng-model="vm.customerData.address_street"><div class="topbuffer2"></div><div class="row"><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>State</label><div class="custom-selectbox-big w100"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="CA" ng-model="vm.customerData.address_state"><option>CA</option><option>CA 1</option><option>CA 3</option></select></div></div><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>Zip Code <span>&nbsp;*</span></label><input type="text" placeholder="e.g. 94105" ng-model="vm.customerData.address_zip"></div></div><div class="topbuffer2"></div><label>Phone Number <span>&nbsp;*</span></label><input type="text" placeholder="555-555-556" ng-model="vm.customerData.phone"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>City <span>&nbsp;*</span></label><input type="text" placeholder="San Francisco" ng-model="vm.customerData.address_city"><div class="topbuffer2"></div><label>Country</label><div class="custom-selectbox-big w100"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Select Country" ng-model="vm.customerData.address_country"><option>Select Country</option><option>Select Country 2</option><option>Select Country 3</option></select></div><div class="topbuffer2"></div><label>Fax</label><input type="text" placeholder="555-555-556" ng-model="vm.customerData.fax"></div></div><hr><div class="topbuffer3"></div><input type="button" class="next smallsizenext" value="Next" align="center"> <i class="fa fa-long-arrow-right right-side-arrow smallsizeiconnext" aria-hidden="true"></i></div></div></div></div></div></div></div></div></fieldset><fieldset><div class=""><div class="logo" align="center"><div class="topbuffer3"></div><img src="/content/brand/logo.png" alt="logo" class="content-brand-logo"><div class="topbuffer3"></div></div><div class="box-shadow-big"><div class="header headersign"><div class="" align="center"><p class="signup-title">Welcome to {{ (brand.branding && brand.branding.portal_name) || \'Client Portal\' }}</p></div></div><div class="tabbackall tabbackall1"><div class="tab-content tabback tabbacksignup box-bg-color"><div class="pager" align="center"><div class="topbuffer2"></div><div class=""><div class="row bs-wizard" style="border-bottom:0"><div class="col-xs-3 signuptable"></div><div class="col-xs-2 bs-wizard-step complete signuptable2"><div class="text-center bs-wizard-stepnum">Company Info</div><div class="progress progress3 progress4"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">1</a></div><div class="col-xs-2 bs-wizard-step active signuptable2"><div class="text-center bs-wizard-stepnum">Contact Info</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">2</a></div><div class="col-xs-2 bs-wizard-step disabled signuptable2"><div class="text-center bs-wizard-stepnum">Billing</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">3</a></div></div></div><div class="topbuffer3"></div></div><div role="tabpanel" class="companyinfo" id="profile"><div class="topbuffer3"></div><div class="form"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Primary Contact Name <span>&nbsp;*</span></label><input type="text" placeholder="Michael Gavin" ng-model="vm.customerData.name"><div class="topbuffer2"></div><label>Direct Phone <span>&nbsp;*</span></label><input type="text" placeholder="555-555-555" ng-model="vm.customerData.phone"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>Title <span>&nbsp;*</span></label><input type="text" placeholder="Your Title"><div class="topbuffer2"></div><label>Email <span>&nbsp;*</span></label><input type="text" placeholder="primarycontact@mail.com" ng-model="vm.customerData.primary_email"><div class="topbuffer2"></div></div><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div align="center"><hr><div class="topbuffer3"></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>How\u2019d you hear about us?</label><div class="custom-selectbox-big w100"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Google Search" ng-model="vm.customerData.how_did_you_hear_about_us"><option>Google Search</option><option>Google Search Service 2</option><option>Google Search Service 3</option></select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>Account Representative <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Laila Lam" ng-model="vm.customerData.primary_anresco_rep"><option>Laila Lam</option><option>Laila Lam Service 2</option><option>Laila Lam Service 3</option></select></div></div></div><hr><div class="topbuffer3"></div><div class="signup-btn-pre"><input type="button" name="previous" class="previous previousbtnsignup" value="Previous"> <i class="fa fa-long-arrow-left left-side-page-arrow previousbtnsignuparow" aria-hidden="true"></i></div><input type="button" name="next" class="next" value="Next"> <i class="fa fa-long-arrow-right right-side-arrow" aria-hidden="true"></i></div></div></div></div></div></div></div></div></fieldset><fieldset><div class=""><div class="logo" align="center"><div class="topbuffer3"></div><img src="/content/brand/logo.png" alt="logo" class="content-brand-logo"><div class="topbuffer3"></div></div><div class="box-shadow-big"><div class="header headersign"><div class="" align="center"><p class="signup-title">Welcome to {{ (brand.branding && brand.branding.portal_name) || \'Client Portal\' }}</p></div></div><div class="tabbackall tabbackall1"><div class="tab-content tabback tabbacksignup box-bg-color"><div class="pager" align="center"><div class="topbuffer2"></div><div class=""><div class="row bs-wizard" style="border-bottom:0"><div class="col-xs-3 signuptable"></div><div class="col-xs-2 bs-wizard-step complete signuptable2"><div class="text-center bs-wizard-stepnum">Company Info</div><div class="progress progress3 progress4"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">1</a></div><div class="col-xs-2 bs-wizard-step complete signuptable2"><div class="text-center bs-wizard-stepnum">Contact Info</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">2</a></div><div class="col-xs-2 bs-wizard-step active signuptable2"><div class="text-center bs-wizard-stepnum">Billing</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">3</a></div></div></div><div class="topbuffer2"></div></div><div role="tabpanel" class="companyinfo" id="messages"><div class="topbuffer1"></div><p align="center" class="clients2">{{ (brand.legal && brand.legal.company_name) || \'The lab\' }} requires prepayment for all new clients</p><div class="topbuffer4"></div><div class="form"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Billing Type <span>&nbsp;*</span></label><input type="text"><div class="topbuffer2"></div><label>Credit Card Number <span>&nbsp;*</span></label><input type="text" placeholder="Enter CC Number without spaces"><div class="topbuffer2"></div><div class="col-lg-7 col-md-7 col-sm-12 col-xs-12"><div class="row"><label>Expiration Date <span>&nbsp;*</span></label><br><div class="col-lg-4 col-md-4 col-sm-6 col-xs-6"><div class="row"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="01"><option>01</option><option>02</option><option>03</option></select></div></div><div class="col-lg-8 col-md-8 col-sm-6 col-xs-6"><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="2016"><option>2016</option><option>2017</option><option>2018</option></select></div></div></div><div class="col-lg-5 col-md-5 col-sm-12 col-xs-12 divres"><div class="row"><label>CCV <span>&nbsp;*</span></label><input type="text" placeholder="279"></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>Credit Card Type <span>&nbsp;*</span></label><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Select Type"><option>Select Type</option><option>AMEX 2</option><option>AMEX 3</option></select><div class="topbuffer2"></div><label>Card Holder\u2019s Name <span>&nbsp;*</span></label><input type="text" placeholder="Name on the card"><div class="topbuffer2"></div></div></div><hr><div class="topbuffer3"></div><h3 class="Billing">Billing Address Information</h3><div class="topbuffer4"></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Street Address <span>&nbsp;*</span></label><input type="text" placeholder="251 Main Street 87"><div class="topbuffer2"></div><div class="row"><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>State <span>&nbsp;*</span></label><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Maryland"><option>Maryland</option><option>Maryland 1</option><option>Maryland 3</option></select></div><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>Zip Code <span>&nbsp;*</span></label><input type="text" placeholder="21154"></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>City <span>&nbsp;*</span></label><input type="text" placeholder="Baltimore"><div class="topbuffer2"></div><label>Country</label><select id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Select Country"><option>Select Country</option><option>india</option><option>usa</option></select></div></div><hr><div class="topbuffer3"></div><td class="check-box-size"><input type="checkbox" name="checkboxG9" id="checkboxG9" class="css-checkbox"><label for="checkboxG9" class="css-label wiretransfer2">I prefer to pay by cash, check or wire-transfer</label></td><hr><div class="topbuffer3"></div><div class="signup-btn-pre"><input type="button" name="previous" class="previous previousbtnsignup" value="Previous"> <i class="fa fa-long-arrow-left left-side-page-arrow previousbtnsignuparow" aria-hidden="true"></i></div><!--<input type="submit" name="submit" class="submit action-button" value="Finish" />--> <input type="button" name="submit" class="submit action-button" value="Finish" ng-click="vm.submitCustomer()"></div></div></div></div></div></div></div></div></fieldset></form></div></div><script src="https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js"></script><script>$(function () {\n\t\t\t\t$("#upload_link").on(\'click\', function (e) {\n\t\t\t\t\te.preventDefault();\n\t\t\t\t\t$("#upload:hidden").trigger(\'click\');\n\t\t\t\t});\n\t\t\t});</script><script>//jQuery time\n\t\t\tvar current_fs, next_fs, previous_fs; //fieldsets\n\t\t\tvar left, opacity, scale; //fieldset properties which we will animate\n\t\t\tvar animating; //flag to prevent quick multi-click glitches\n\t\t\t$(".next").click(function () {\n\t\t\t\tif (animating) return false;\n\t\t\t\tanimating = true;\n\t\t\t\tcurrent_fs = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent();\n\t\t\t\tnext_fs = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().next();\n\t\t\t\t//activate next step on progressbar using the index of next_fs\n\t\t\t\t$("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");\n\t\t\t\t//show the next fieldset\n\t\t\t\tnext_fs.show();\n\t\t\t\t//hide the current fieldset with style\n\t\t\t\tcurrent_fs.animate({\n\t\t\t\t\topacity: 0\n\t\t\t\t}, {\n\t\t\t\t\tstep: function (now, mx) {\n\t\t\t\t\t\t//as the opacity of current_fs reduces to 0 - stored in "now"\n\t\t\t\t\t\t//1. scale current_fs down to 80%\n\t\t\t\t\t\tscale = 1 - (1 - now) * 0.2;\n\t\t\t\t\t\t//2. bring next_fs from the right(50%)\n\t\t\t\t\t\tleft = (now * 50) + "%";\n\t\t\t\t\t\t//3. increase opacity of next_fs to 1 as it moves in\n\t\t\t\t\t\topacity = 1 - now;\n\t\t\t\t\t\tnext_fs.css({\n\t\t\t\t\t\t\t\'left\': left\n\t\t\t\t\t\t\t, \'opacity\': opacity\n\t\t\t\t\t\t});\n\t\t\t\t\t}\n\t\t\t\t\t, duration: 200\n\t\t\t\t\t, complete: function () {\n\t\t\t\t\t\tcurrent_fs.hide();\n\t\t\t\t\t\tanimating = false;\n\t\t\t\t\t}, //this comes from the custom easing plugin\n\t\t\t\t\teasing: \'easeInOutBack\'\n\t\t\t\t});\n\t\t\t});\n\t\t\t$(".previous").click(function () {\n\t\t\t\tif (animating) return false;\n\t\t\t\tanimating = true;\n\t\t\t\tcurrent_fs = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().parent();\n\t\t\t\tprevious_fs = $(this).parent().parent().parent().parent().parent().parent().parent().parent().parent().parent().prev();\n\t\t\t\t//de-activate current step on progressbar\n\t\t\t\t$("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");\n\t\t\t\t//show the previous fieldset\n\t\t\t\tprevious_fs.show();\n\t\t\t\t//hide the current fieldset with style\n\t\t\t\tcurrent_fs.animate({\n\t\t\t\t\topacity: 0\n\t\t\t\t}, {\n\t\t\t\t\tstep: function (now, mx) {\n\t\t\t\t\t\t//as the opacity of current_fs reduces to 0 - stored in "now"\n\t\t\t\t\t\t//1. scale previous_fs from 80% to 100%\n\t\t\t\t\t\tscale = 0.8 + (1 - now) * 0.2;\n\t\t\t\t\t\t//2. take current_fs to the right(50%) - from 0%\n\t\t\t\t\t\tleft = ((1 - now) * 50) + "%";\n\t\t\t\t\t\t//3. increase opacity of previous_fs to 1 as it moves in\n\t\t\t\t\t\topacity = 1 - now;\n\t\t\t\t\t\t//current_fs.css({\'left\': left});\n\t\t\t\t\t\tprevious_fs.css({\n\t\t\t\t\t\t\t\'left\': left\n\t\t\t\t\t\t\t, \'opacity\': opacity\n\t\t\t\t\t\t});\n\t\t\t\t\t}\n\t\t\t\t\t, duration: 200\n\t\t\t\t\t, complete: function () {\n\t\t\t\t\t\tcurrent_fs.hide();\n\t\t\t\t\t\tanimating = false;\n\t\t\t\t\t}, //this comes from the custom easing plugin\n\t\t\t\t\teasing: \'easeInOutBack\'\n\t\t\t\t});\n\t\t\t});\n\t\t\t$(".submit").click(function () {\n\t\t\t\treturn false;\n\t\t\t})</script><script src="http://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.3/jquery.easing.min.js"></script>');
$templateCache.put('app/pages/customer-manage/contact-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.contact.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Contact?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/pages/customer-manage/customer-manage.html','<style>.checkboxContainer input:checked ~ .checkmark {\r\n        background-color: #27AE60;\r\n        border: none;\r\n    }\r\n\r\n    .checkmark {\r\n        border: 1.2px solid #3D5269;\r\n        box-sizing: border-box;\r\n        border-radius: 2.4px;\r\n    }\r\n    .customer-manage-table thead th.user{\r\n        width: 5%;\r\n    }\r\n    .customer-manage-table thead th.name{\r\n        width: 20%;\r\n    }\r\n    .customer-manage-table thead th.email{\r\n        width: 30%;\r\n    }\r\n    .customer-manage-table thead th.phone{\r\n        width: 15%;\r\n    }\r\n    .customer-manage-table thead th.title{\r\n        width: 10%;\r\n    }\r\n    .customer-manage-table thead th.report{\r\n        width: 5%;\r\n    }\r\n    .customer-manage-table thead th.bill{\r\n        width: 5%;\r\n    }\r\n    .customer-manage-table thead th.action{\r\n        width: 10%;\r\n    }\r\n    .customer-manage-table tbody tr td.elip{\r\n        white-space: nowrap; \r\n        overflow: hidden;\r\n        text-overflow: ellipsis; \r\n    }</style><div><div class="tabbackall"><div class="tab-content tabback"><div class="rdRow"><div style="float: left; width: 300px"><span style="float: left"><button ng-click="vm.activeTab = \'contact_list\'" ng-class="{\'customer-manage-ui-button-active\' : vm.activeTab == \'contact_list\', \'customer-manage-ui-button-inactive\' : vm.activeTab != \'contact_list\'}" class="customer-manage-ui-button">{{\'CONTACT LIST\' | translate}}</button> </span><span style="margin-left: 16px"><button ng-click="vm.activeTab = \'company_info\'" ng-class="{\'customer-manage-ui-button-active\' : vm.activeTab == \'company_info\', \'customer-manage-ui-button-inactive\' : vm.activeTab != \'company_info\'}" class="customer-manage-ui-button">{{\'COMPANY INFO\' | translate}}</button></span></div><div style="margin-left: auto"><button ng-show="vm.mainUser && vm.activeTab == \'contact_list\'" ui-sref="customermanage.new" type="button" ui-sref="home" data-toggle="modal" data-target="#myModal" class="add-new-contact-button"><!-- <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;Add New Contact</button> --> <svg style="margin-left: -120px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> <span style="display: block; margin-top: -27px; text-align: right">&nbsp;&nbsp;{{\'Add New Contact\' | translate}}</span></button></div></div><form role="tabpanel" ng-class="{\'active\' : vm.activeTab == \'company_info\'}" class="tab-pane companyinfo" style="cursor: default" id="home" ng-submit="vm.submitCustomer()"><div class="form"><div class="row"><div class="col-lg-8 col-md-8 col-sm-12 col-xs-12"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>{{\'Business Name\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.company_name" maxlength="255"><div class="topbuffer5" style="display:none"></div><label style="visibility:hidden;display:none">{{\'Company Logo\' | translate}}</label><div class="topbuffer1" tyle="display:none;"></div><div class="row" style="visibility:hidden;display:none"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4"><div ng-show="vm.companyLogo" class="row rowimg"><img ng-src="{{vm.companyLogo}}" alt="logo" class="img-responsive"></div></div><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 res-size-img-uplode"><div class="imgicon"><div class="topbuffer3"></div><input id="upload" type="file" file-model="myFile" style="visibility: hidden" on-file-change="onFilesSelected"> <a href="" onclick="document.getElementById(\'upload\').click(); return false" id="upload_link"><span><i class="fa fa-cloud-upload" aria-hidden="true"></i> &nbsp; Upload New Logo</span><br></a><div class="topbuffer1"></div><a ng-click="removeLogo()" ng-show="vm.companyLogo"><span><i class="fa fa-trash-o" aria-hidden="true"></i> &nbsp; Remove Logo</span></a></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>{{\'Type of Business\' | translate}}</label><div class="custom-selectbox-big w100"><select disabled="disabled" id="selectBusinessType" class="selectpicker select-box-padding" data-live-search="true" name="businessType" ng-model="vm.customerData.businessType" ng-options="businessType as businessType.name for businessType in vm.businesstypes track by businessType.id"><option value=""></option></select></div><div ng-if="false"><div class="topbuffer2"></div><label>{{\'Website\' | translate}} URL</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.website"><div class="topbuffer2"></div><label>{{\'Business Description\' | translate}}</label><textarea ng-disabled="vm.mainUser==false" rows="3" ng-model="vm.customerData.businessDescription"></textarea></div></div></div><hr class="hr-customer-manage" ng-if="false"><div class="row" ng-if="false"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>{{\'Street Address\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.address_street" maxlength="41"><div class="topbuffer2"></div><div class="row"><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>{{\'State\' | translate}}</label><div class="custom-selectbox-big w100"><select ng-disabled="vm.mainUser==false" id="selectCountryState" data-live-search="true" class="selectpicker select-box-padding" name="countryState" ng-model="vm.customerData.address_state"><option value=""></option><option ng-repeat="countryState in vm.countryStates" value="{{countryState.code}}">{{countryState.name}}</option></select></div></div><div class="col-lg-6 col-xs-6 col-sm-6 col-xs-12"><label>{{\'Zip Code\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.address_zip"></div></div><div class="topbuffer2"></div><label>{{\'Phone Number\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.phone"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>{{\'City\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.address_city"><div class="topbuffer2"></div><label>{{\'Country\' | translate}}</label><div class="custom-selectbox-big w100"><select ng-disabled="vm.mainUser==false" id="selectCountry" class="selectpicker select-box-padding" data-live-search="true" name="country" ng-change="vm.populateStates()" ng-model="vm.customerData.country.name" ng-option="{{vm.customerData.country.name}}"><option value="Japan">Japan</option><option value="USA">USA</option><option value="Canada">Canada</option></select></div><div class="topbuffer2"></div><label>{{\'Fax\' | translate}}</label><input ng-disabled="vm.mainUser==false" type="text" ng-model="vm.customerData.fax"></div></div><hr class="hr-customer-manage"><div class="row"><div class="col-sm-12 col-xs-12"><label>{{\'Downloadable Files on Sample Page\' | translate}}</label><div style="display:flex;flex-wrap: wrap"><div ng-repeat="option in downloadOptionList" ng-if="!(option.name === \'COA Summary\') || (option.name === \'COA Summary\' && (vm.customer_type.includes(\'cannabis\') || vm.customer_type.includes(\'hemp\')))"><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" ng-checked="vm.downloadOptionList[option.id].selected" ng-model="option.selected" value="option.name" ng-click="updateDownloadOptionList(option)" ng-disabled="option.disabled" type="checkbox"> <span style="display: inline-block" ng-class="{\'disabledcheckmark\' : option.disabled, \'checkmark\' : !option.disabled}"></span> <span style="display: inline-block;margin:0 30px 0 25px;color:#556d85">{{option.name}}</span></label></div></div><div class="topbuffer2"></div></div></div><div class="topbuffer2"></div><hr class="hr-customer-manage"><!-- address model --><div class="rdView rdViewRowBasic"><div><div style="text-align: left; font-weight: bolder; font-size: 16px">Default addresses</div></div><div class="rdViewRow2"><div><div class="row text-left"><div class="col-sm-6 topbuffer2" ng-if="vm.customer_type.includes(\'cannabis\')  || vm.customer_type.includes(\'hemp\') "><label class="rdColumnLeftLabel">Distributor Address</label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 100% !important; height: 45px" ng-click="openDistributionList()" type="text" name="CM-location" class="add_option" ng-model="vm.fullLocationComp" placeholder="Choose Location / Add New" value="" readonly="readonly"></div><ul style="width: 100% !important" id="locationList" class="add_new_list location-list" ng-class="DistributionList"><li class="add_new_option" style="width: 100% !important; height: 45px" data-toggle="modal" data-target="#add-new-distribution">+ Add New</li><li ng-repeat="address in records" style="width: 100% !important; height: 45px" ng-click="copyDistributionData(address.id, address.fullLocation)" ng-if="address.locationType === \'DISTRIBUTION_LOCATION\'"><span class="spanDataAddress">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'DISTRIBUTION\')" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="col-sm-6 topbuffer2" ng-if="vm.customer_type.includes(\'cannabis\')  || vm.customer_type.includes(\'hemp\')"><label>Cultivation/Manufacturing Location</label><div class="input-autocomplate"><div class="add-option-caretRD"><input ng-click="openManufacturingList()" style="height: 45px" type="text" name="d-location" class="add_option" ng-model="vm.fullLocationManufactur" placeholder="Choose Location / Add New" value="" readonly="readonly"></div><ul style="width: 100% !important" class="add_new_list location-list" ng-class="ManufacturingList"><li style="width: 100% !important; height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-manufacturing">+ Add New</li><li style="width: 100% !important; height: 45px" ng-repeat="address in records" ng-click="copyManufacturingData(address.id, address.fullLocation)" ng-if="address.locationType === \'CULTIVATION_LOCATION\'"><span class="spanDataAddress">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'MANUFACTURING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="col-sm-6 topbuffer2"><label>Pickup Address</label><div class="input-autocomplate"><div class="add-option-caretRD"><input ng-click="openpickupList()" style="height: 45px" type="text" name="pickup-location" class="add_option" ng-model="vm.fullLocationPickup" placeholder="Select pickup address" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="PickupList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-pickup">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-click="copyPickupData(address.address, address.city,  address.zipCode, address.distributorName,  address.state,address.id)" ng-if="address.locationType === \'PICKUP_LOCATION\'"><span class="spanDataAddress">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'PICKUP\');vm.rd.checkPageThree()" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="col-sm-6 topbuffer2" ng-if="vm.customer_type.includes(\'cannabis\')  || vm.customer_type.includes(\'hemp\')"><label>Sampling Address</label><div class="input-autocomplate"><div class="add-option-caretRD"><input ng-click="opensamplingList()" style="height: 45px" type="text" name="pickup-location" class="add_option" ng-model="vm.fullLocationSampling" placeholder="Select pickup address" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="SamplingList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-pickup">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-click="copySamplingData(address.address, address.city,  address.zipCode, address.distributorName,  address.state,address.id)" ng-if="address.locationType === \'PICKUP_LOCATION\'"><span class="spanDataAddress">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'PICKUP\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="col-sm-6 topbuffer2"><label class="rdColumnLeftLabel">Reporting Address</label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 100% !important; height: 45px" ng-click="openReportingList()" type="text" name="CM-location" class="add_option" ng-model="vm.fullLocationreporting" placeholder="Choose Location / Add New" value="" readonly="readonly"></div><ul style="width: 100% !important" class="add_new_list location-list" ng-class="ReportingList"><li style="width: 100% !important; height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-manufacturing">+ Add New</li><li style="width: 100% !important; height: 45px" ng-repeat="address in records" ng-click="copyReportingData(address.id, address.fullLocation)" ng-if="address.locationType === \'CULTIVATION_LOCATION\'"><span class="spanDataAddress">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'MANUFACTURING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="col-sm-6 topbuffer2"><div class="rdColumn"><label>Invoicing Address</label><div class="input-autocomplate"><div class="add-option-caretRD"><input ng-click="openInvoicingList()" style="height: 45px" type="text" name="invoicing-location" class="add_option" ng-model="vm.fullLocationInvoicing" placeholder="{{vm.customerData.qbAddress.replace(\'\\n\', \'; \').substring(0, 70) + \'...\'}}" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="InvoicingList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-invoicing">+ Add New</li><li><span class="spanDataAddress" ng-click="copyInvoicingData(vm.customerData.qbAddress.replace(\'\\n\', \'; \'),\'customer_address\')">{{vm.customerData.qbAddress.replace(\'\\n\', \'; \')}}</span></li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'INVOICING_LOCATION\'"><span class="spanDataAddress" ng-click="copyInvoicingData(address.address, address.city, address.zipCode, address.distributorName, address.state)">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'INVOICING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div></div></div></div></div><!-- address model end --><hr class="hr-customer-manage"><div class="saveall"><button ng-show="vm.mainUser" class="btn btn-primary" ng-disabled="vm.isSaving" ng-click="submitCustomer()">{{\'Save\' | translate}}</button></div></div></div></div></form><form role="tabpanel" ng-class="{\'active\' : vm.activeTab == \'contact_list\'}" class="tab-pane active companyinfo fullheight" id="profile" style="cursor: default"><div class="form"><div class="row"><div class="bigbox no-shadow" style="margin-bottom: 100px"><table class="customer-manage-table"><thead style="border-bottom: 1px solid #DFEAF7"><tr><th class="user"></th><th class="name">{{\'Contact Name\' | translate}}</th><th class="email">{{\'Email\' | translate}}</th><th class="phone">{{\'Phone\' | translate}}</th><th class="title">{{\'Title\' | translate}}</th><th class="report">{{\'Reporting\' | translate}}</th><th class="bill">{{\'Billing\' | translate}}</th><th class="action"></th></tr></thead><tbody><tr ng-repeat="contact in vm.contacts track by contact.id"><td style="position: relative" ng-switch="contact.portal"><i ng-switch-when="admin" class="fa fa-user text-yellow manage-tab-popover-trigger" aria-hidden="true"></i><div ng-switch-when="admin" class="manage-tab-popover manage-tab-popover-shadow" style="top: -67px; left: -7px"><div style="justify-content: space-between; padding: 8px; color: #293a4c; display: flex; width: 109px; height: auto; flex-direction: column"><div style="font-family: OpenSans-Semibold; font-size: 16px;  font-weight: 700">Admin</div><div style="font-family: OpenSans-Regular; font-size: 10px; font-weight: 400">This contact has admin privledges</div></div><svg style="position: absolute; bottom: -10px; left: 12px" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L0.473721 0.75L19.5263 0.75L10 12Z" fill="white"/></svg></div><i ng-switch-when="user" class="fa fa-user manage-tab-popover-trigger" style="color: black" aria-hidden="true"></i><div ng-switch-when="user" class="manage-tab-popover manage-tab-popover-shadow" style="top: -68px; left: -7px"><div style="justify-content: space-between; padding: 8px; color: #293a4c; display: flex; width: 109px; height: auto; flex-direction: column"><div style="font-family: OpenSans-Semibold; font-size: 16px;  font-weight: 700">Portal User</div><div style="font-family: OpenSans-Regular; font-size: 10px; font-weight: 400">This contact has a portal account.</div></div><svg style="position: absolute; bottom: -10px; left: 12px" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L0.473721 0.75L19.5263 0.75L10 12Z" fill="white"/></svg></div><i ng-switch-when="none" class="fa fa-user-times ps-analyte-gray manage-tab-popover-trigger" aria-hidden="true"></i><div ng-switch-when="none" class="manage-tab-popover manage-tab-popover-shadow" style="top: -110px; left: -6px"><div style="justify-content: space-between; padding: 8px; color: #293a4c; display: flex; width: 109px; height: auto; flex-direction: column"><div style="font-family: OpenSans-Semibold; font-size: 16px;  font-weight: 700">No Account</div><div style="font-family: OpenSans-Regular; font-size: 10px; font-weight: 400">This contact does not have a portal account. Click the edit icon on the right to create one.</div></div><svg style="position: absolute; bottom: -10px; left: 12px" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L0.473721 0.75L19.5263 0.75L10 12Z" fill="white"/></svg></div></td><td class="text-dark-blue elip" style="font-family: OpenSans-Semibold">{{contact.name}}</td><td class="elip">{{contact.email}}</td><td class="elip">{{contact.phone}}</td><td class="elip">{{contact.title}}</td><td><label style="display: inline-block" class="checkboxContainer"><input ng-disabled="!vm.mainUser" ng-checked="contact.contactCustomers[contact.contact_customer_index].receive_coa" ng-model="contact.contactCustomers[contact.contact_customer_index].receive_coa" ng-click="vm.updateContact(contact)" class="public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span ng-class="{ \'no-pointer-events\': !vm.mainUser }" style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></td><td><label style="display: inline-block" class="checkboxContainer"><input ng-disabled="!vm.mainUser" ng-checked="contact.contactCustomers[contact.contact_customer_index].receive_invoice" ng-model="contact.contactCustomers[contact.contact_customer_index].receive_invoice" ng-click="vm.updateContact(contact)" class="public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span ng-class="{ \'no-pointer-events\': !vm.mainUser }" style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></td><td ng-if="vm.mainUser || contact.is_current_user"><span ui-sref="customermanage.edit({id:contact.id})" class="edit-icon" style="cursor: pointer">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span ng-disabled="contact.is_current_user" ng-click="vm.deleteContact(contact)" ng-class="{\'trash-icon\' : !contact.is_current_user, \'trash-icon-disabled no-pointer-events\' : contact.is_current_user}" style="margin-left: 15px; cursor: pointer">&nbsp;&nbsp;&nbsp;&nbsp;</span></td><td ng-if="!vm.mainUser && !contact.is_current_user" style="position: relative"><span class="manage-tab-popover-trigger"><span class="edit-icon-disabled">&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="trash-icon-disabled" style="margin-left: 15px">&nbsp;&nbsp;&nbsp;&nbsp;</span></span><div class="manage-tab-popover manage-tab-popover-shadow" style="top: -61px; left: -2px"><div style="justify-content: space-between; padding: 8px; color: #293a4c; display: flex; width: 109px; height: auto; flex-direction: column"><div style="text-align: left; font-family: OpenSans-Regular; font-size: 10px; font-weight: 400">Only Admins may <span style="font-family: OpenSans-Bold">edit</span> or <span style="font-family: OpenSans-Bold">delete</span> contacts</div></div></div></td></tr></tbody></table></div></div><div class="saveall" ng-if="false"><button ng-show="vm.mainUser" class="btn btn-primary" ng-click="vm.submitCustomer()" ng-disabled="vm.isSaving">Save</button></div></div></form><form role="tabpanel" class="tab-pane companyinfo" style="cursor: default" id="notification"><h2 class="information manage-title">NOTIFICATIONS</h2><div class="topbuffer3"></div><div class="form"><div class="recived-notifications"><label class="title">Receive notifications</label><label class="switch"><input class="ng-pristine ng-untouched ng-valid ng-not-empty" aria-invalid="false" type="checkbox" ng-model="vm.notificationSeting.receiveNotifications"><div class="slider round"></div></label></div><div class="row"><div class="col-lg-5 box-notifications bigbox res-box-height"><table id="table-notifications"><thead><tr><th class="tbl-col-1"></th><th class="tbl-col-2"><span>Web</span></th><th class="tbl-col-3"><span>Mobile App</span></th></tr></thead><tbody><tr><td class="tbl-col-1">Order placed</td><td class="tbl-col-2"><input name="checkbox-1" id="checkbox-1" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[0].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-1" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-2" id="checkbox-2" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[1].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-2" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr><tr><td class="tbl-col-1">Samples received</td><td class="tbl-col-2"><input name="checkbox-3" id="checkbox-3" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[2].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-3" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-4" id="checkbox-4" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[3].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-4" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr><tr><td class="tbl-col-1">{{\'Preliminary Results\' | translate}}</td><td class="tbl-col-2"><input name="checkbox-5" id="checkbox-5" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[4].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-5" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-6" id="checkbox-6" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[5].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-6" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr><tr><td class="tbl-col-1">Reports Completed</td><td class="tbl-col-2"><input name="checkbox-7" id="checkbox-7" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[6].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-7" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-8" id="checkbox-8" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[7].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-8" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr><tr><td class="tbl-col-1">Invoice Available</td><td class="tbl-col-2"><input name="checkbox-9" id="checkbox-9" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[8].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-9" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-10" id="checkbox-10" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[9].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-10" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr><tr><td class="tbl-col-1">Payment received</td><td class="tbl-col-2"><input name="checkbox-11" id="checkbox-11" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[10].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-11" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td><td class="tbl-col-3"><input name="checkbox-12" id="checkbox-12" ng-disabled="!vm.notificationSeting.receiveNotifications" ng-model="vm.notificationSeting.notificationsSubscriptions[11].subscribed" class="css-checkbox ng-valid ng-dirty ng-valid-parse ng-touched ng-empty" aria-invalid="false" type="checkbox"><label for="checkbox-12" class="css-label" ng-class="!vm.notificationSeting.receiveNotifications ? \'css-label-disabled\' : \'\'"></label></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-5 text-left"><button class="btn btn-primary" ng-click="vm.saveSettings()">Save</button></div></div></div></form></div></div><!-- Modal - Add new distribution --><div class="modal fade addOption" id="add-new-invoicing" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.InvoicingAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.InvoicingAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.InvoicingAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.InvoicingAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.InvoicingAddress.state" class="form-control"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newInvoicingAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.InvoicingAddress.distributorName || !vm.InvoicingAddress.address || !vm.InvoicingAddress.city || !vm.InvoicingAddress.zipCode || !vm.InvoicingAddress.state"></div></div></form></div></div><!-- Modal - Add new manufacturing --><div class="modal fade addOption" id="add-new-manufacturing" role="dialog" style="z-index: 2000"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content new-location-modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name<span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.ManufacturingAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Manufacturing Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.ManufacturingAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.ManufacturingAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.ManufacturingAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.ManufacturingAddress.state" class="form-control"></div></div><div class="row" ng-if="vm.customer_type.includes(\'cannabis\') || vm.customer_type.includes(\'hemp\')"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>License #(s) <span class="require-field" ng-hide="vm.ManufacturingAddress.licenseNA">*</span></label><input type="text" ng-model="vm.ManufacturingAddress.licenceList" class="form-control" ng-disabled="vm.ManufacturingAddress.licenseNA" placeholder="e.g. LIC-001, LIC-002, LIC-003"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group" style="padding-top: 32px"><label style="font-weight: normal"><input type="checkbox" ng-model="vm.ManufacturingAddress.licenseNA" ng-change="vm.ManufacturingAddress.licenseNA ? (vm.ManufacturingAddress.licenceList = \'N/A\') : (vm.ManufacturingAddress.licenceList = \'\')"> N/A</label></div></div></div><div class="modal-footer new-location-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newManufacturingAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.ManufacturingAddress.distributorName || !vm.ManufacturingAddress.address || !vm.ManufacturingAddress.city || !vm.ManufacturingAddress.zipCode || !vm.ManufacturingAddress.state || (vm.ManufacturingAddress.licenceList === \'\' && !vm.ManufacturingAddress.licenseNA)"></div></div></form></div></div><!-- Modal - Add new distribution --><div class="modal fade addOption" id="add-new-distribution" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.DistributionAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.DistributionAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.DistributionAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.DistributionAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.DistributionAddress.state" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>License #(s) <span class="require-field">*</span></label><input type="text" ng-model="vm.DistributionAddress.licenceList" class="form-control" placeholder="e.g. LIC-001, LIC-002, LIC-003"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newDistributionAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.DistributionAddress.distributorName || !vm.DistributionAddress.address || !vm.DistributionAddress.city || !vm.DistributionAddress.zipCode || !vm.DistributionAddress.state || !vm.DistributionAddress.licenceList"></div></div></form></div></div><!-- Modal - Add new pickup --><div class="modal fade addOption" id="add-new-pickup" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.PickupAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.PickupAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.PickupAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.PickupAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.PickupAddress.state" class="form-control"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newPickupAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.PickupAddress.distributorName || !vm.PickupAddress.address || !vm.PickupAddress.city || !vm.PickupAddress.zipCode || !vm.PickupAddress.state"></div></div></form></div></div><!-- Modal - Remove option --><div class="modal fade" id="removeModal" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Delete Location</h4></div><div class="modal-body"><p>Are you sure you want to permanently delete location<br><strong>{{vm.removeAddressData}}</strong>?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="removeAddressQuery()" data-dismiss="modal">Delete</button></div></div></div></div><script>// function selectTab(i) {\r\n        //     if(i == 0){\r\n                 //document.getElementById("MyElement").classList.add("active");\r\n        //         $("#home").addClass("active");\r\n        //         $("#home_tab").addClass("active");\r\n        //         $("#profile").removeClass("active");\r\n        //         $("#profile_tab").removeClass("active");\r\n        //         $("#notifications").removeClass("active");\r\n        //         $("#notifications_tab").removeClass("active");\r\n        //     }\r\n        //     else if(i == 1){\r\n        //         $("#home").removeClass("active");\r\n        //         $("#home_tab").removeClass("active");\r\n        //         $("#profile").addClass("active");\r\n        //         $("#profile_tab").addClass("active");\r\n        //         $("#notification").removeClass("active");\r\n        //         $("#notification_tab").removeClass("active");\r\n        //     }\r\n        //     else if(i == 2){\r\n        //         $("#home").removeClass("active");\r\n        //         $("#home_tab").removeClass("active");\r\n        //         $("#profile").removeClass("active");\r\n        //         $("#profile_tab").removeClass("active");\r\n        //         $("#notification").addClass("active");\r\n        //         $("#notification_tab").addClass("active");\r\n        //     }\r\n        // }</script><script>\'use strict\';\r\n\r\n        $(document).ready(function() {\r\n\r\n            setTimeout(function () {\r\n\r\n\r\n                $("#table tr:first > th").each(function(index, element) {\r\n                    index++;\r\n                    var addLi = "<li class=\'tbl-dot-" + index + "\'><span class=\'tbl-dot\'></span></li>";\r\n                    $("ul.tbl-dots").append(addLi);\r\n                });\r\n\r\n                var num_col = $("#table tr:first > th").length;\r\n                var constant = 2;\r\n                var constant2 = constant + 1;\r\n\r\n                var num_col = num_col - 1; // oduzimam jednu kolonu da ne vrsi proracun sirine kolone gde je ikonica za brisanje.\r\n                var col_width = 100 / num_col;\r\n                $("#table tr:first > th").css("width", col_width+"%");\r\n\r\n                $("#payment-col-prev").click(function() {\r\n                    constant -= 1;\r\n                    constant2 -= 1;\r\n                    if (constant == 2 || constant2 == 2) {\r\n                        $("#payment-col-prev").attr(\'disabled\', \'disabled\');\r\n                        $("#payment-col-next").prop("disabled", false);\r\n                    }\r\n                    $(\'.tbl-col-\' + constant).show();\r\n                    $(\'.tbl-col-\' + constant2).show();\r\n                    $(\'.tbl-dot-\' + constant).removeClass(\'disabled\').addClass(\'active\');\r\n                    var x = constant2 + 1;\r\n                    $(\'.tbl-col-\' + x).hide();\r\n                    $(\'.tbl-dot-\' + x).removeClass(\'active\').addClass(\'disabled\');\r\n                    if(constant == 2 || constant2 >= 2){\r\n                        $("#payment-col-next").prop("disabled", false);\r\n                    }\r\n                });\r\n\r\n                $("#payment-col-next").click(function() {\r\n                    constant += 1;\r\n                    constant2 += 1;\r\n                    $(\'.tbl-col-\' + constant).show();\r\n                    $(\'.tbl-col-\' + constant2).show();\r\n                    $(\'.tbl-dot-\' + constant).removeClass(\'disabled\').addClass(\'active\');\r\n                    $(\'.tbl-dot-\' + constant2).removeClass(\'disabled\').addClass(\'active\');\r\n                    var x = constant - 1;\r\n                    var x2 = constant2 - 1;\r\n                    $(\'.tbl-col-\' + x).hide();\r\n                    $(\'.tbl-dot-\' + x).removeClass(\'active\').addClass(\'disabled\');\r\n                    if (constant >= num_col || constant2 >= num_col) {\r\n                        $("#payment-col-next").attr(\'disabled\', \'disabled\');\r\n                        $("#payment-col-prev").prop("disabled", false);\r\n                    }\r\n                    $("#payment-col-prev").prop("disabled", false);\r\n                });\r\n\r\n            }, 1000);\r\n\r\n        });\r\n\r\n        $(window).on(\'load, resize\', function(){\r\n            var screen = $(window).width();\r\n            if( 768 <  screen ) {\r\n                $(\'th, td\').attr(\'style\', \'\');\r\n            }\r\n        });</script></div>');
$templateCache.put('app/pages/customer-manage/dialog.customer-manage.html','<form name="form" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><div class="topbuffer1"></div><h2 class="modal-title pull-left samplemodaltitle" ng-show="vm.newContact">{{\'New Contact\' | translate}}</h2><h2 class="modal-title pull-left samplemodaltitle" ng-hide="vm.newContact">{{\'Edit Contact\' | translate}}</h2><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i></div><div class="modal-body tabbackall tabbackall20"><div class="devider"><div class="topbuffer2"></div><div class="row form"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>{{\'First Name\' | translate}} <span>&nbsp;*</span></label><input type="text" ng-model="vm.contact.first_name" tabindex="1"><div class="topbuffer2"></div><label>{{\'Direct Phone\' | translate}}</label><input type="text" ng-model="vm.contact.phone" tabindex="3"><div class="topbuffer2"></div><label>{{\'Email\' | translate}} <span>&nbsp;*</span></label><input type="text" ng-model="vm.contact.email" tabindex="5"><div class="topbuffer2"></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>{{\'Last Name\' | translate}} <span>&nbsp;*</span></label><input type="text" ng-model="vm.contact.last_name" tabindex="2"><div class="topbuffer2"></div><label>{{\'Title\' | translate}}</label><input type="text" ng-model="vm.contact.title" tabindex="4"><div class="topbuffer2"></div><label>{{\'Access\' | translate}} <span>&nbsp;*</span></label><select ng-disabled="vm.disableReceive || !vm.admin" id="selectReceive" class="selectpicker select-box-padding" data-live-search="true" title="Select Type" ng-model="vm.receive" tabindex="6"><option value="none">None</option><option value="coa">Reporting</option><option value="inv">Invoice</option><option value="both">Both</option></select></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><input ng-disabled="!vm.admin" type="checkbox" name="adminCheckbox" id="adminCheckbox" class="css-checkbox" ng-model="vm.isAdmin" tabindex="7"><label for="adminCheckbox" ng-class="{\'ps-analyte-gray no-pointer-events\' : !vm.admin || !vm.contact.login}" class="css-label">{{\'Admin User\' | translate}}</label></div></div></div><div class="tabback customer-manage-signup-box" ng-hide="vm.newContact"><div class="row"><div class="col-md-4"><label class="form-label">{{\'Username\' | translate}}<span>&nbsp;*</span></label><div class="Username2"><input type="text" class="form-control" id="login" name="login" placeholder="Username" ng-disabled="vm.disableLogin" ng-model="vm.contact.login" ng-minlength="4" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required tabindex="8"><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Username is required to be at least 4 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Username can only contain lower-case letters and digits.</p></div></div></div><div class="col-md-4"><label class="form-label">{{\'Password\' | translate}}<span ng-if="vm.contact.id==null">&nbsp;*</span></label><small ng-if="vm.contact.id != null && vm.contact.currentUser">&nbsp;({{\'leave blank if don&#x27;t want to change\' | translate}})</small><div class="Password2"><input type="password" class="form-control" id="password" name="password" placeholder="{{\'New password\' | translate}}" ng-disabled="vm.disablePassword" ng-model="vm.contact.password" ng-minlength="4" ng-maxlength="50" required tabindex="9"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.contact.password"></password-strength-bar></div></div><div class="col-md-4"><label class="form-label">&nbsp;</label><div class="Password2"><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'Confirm the new password\' | translate}}" ng-disabled="vm.disablePassword" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required tabindex="10"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div></div></div></div><div class="alert alert-danger" ng-show="vm.error"><span ng-if="vm.errorMessage">{{vm.errorMessage}}</span> <span ng-if="!vm.errorMessage"><strong>Registration failed!</strong> Please try again later.</span></div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Username already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.noPassword">Please enter password!</div><div ng-show="vm.contactWithoutUser" class="alert alert-danger">This Contact does not have Web portal account. Please enter Username and Password to create user account</div></div><div class="modal-footer"><div class="topbuffer2"></div><button type="button" ng-click="vm.clear()" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> &nbsp; &nbsp; {{\'Cancel\' | translate}} &nbsp; &nbsp; &nbsp;</button> <button ng-if="vm.contact.id==null" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-disabled="vm.isSaving || vm.contact.first_name == null || vm.contact.first_name == \'\' || vm.contact.last_name == null || vm.contact.last_name == \'\' || vm.contact.email == null || vm.contact.email == \'\' || vm.receive == undefined">Add Contact</button><!-- <button ng-if="vm.contact.id==null" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-disabled="vm.isSaving || vm.contact.first_name == null || vm.contact.first_name == \'\' || vm.contact.last_name == null || vm.contact.last_name == \'\' || vm.contact.email == null || vm.contact.email == \'\' || vm.contact.login == null || vm.contact.login == \'\' || vm.contact.password == null || vm.contact.password == \'\' "> Add Contact </button> --> <button ng-if="vm.contact.id!=null" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-disabled="vm.isSaving || vm.contact.first_name == null || vm.contact.first_name == \'\' || vm.contact.last_name == null || vm.contact.last_name == \'\' || vm.contact.email == null || vm.contact.email == \'\' || vm.contact.login == null || vm.contact.login == \'\' ">{{\'Save\' | translate}}</button><div class="topbuffer2"></div></div></form>');
$templateCache.put('app/pages/customer-public/customer-public.html','<div class="row company-info"><div ng-if="vm.companyLogo" class="col-md-3 col-sm-12"><img ng-src="{{vm.companyLogo}}" alt="logo" class="img-responsive" style="max-height: 85px; width: auto; display: block; margin-left: auto; margin-right: auto"></div><div ng-if="vm.customer.phone != null || vm.customer.address != null" class="col-md-3 col-sm-12"><table style="width: 100%"><tr ng-if="vm.customer.phone"><td style="width: 20%; padding-right: 24px">Phone</td><td style="font-family: OpenSans-Regular">{{ vm.customer.phone }}</td></tr><tr ng-if="vm.customer.address"><td style="width: 20%; padding-right: 24px">Address</td><td style="font-family: OpenSans-Regular">{{ vm.customer.address }}</td></tr></table></div><div ng-if="vm.customer.facebook_link || vm.customer.twitter_link || vm.customer.instagram_link || vm.customer.website" class="col-md-3 col-sm-12"><div class="social-links"><a ng-if="vm.customer.facebook_link" target="_blank" ng-href="{{vm.customer.facebook_link}}"><i class="fa fa-facebook fa-lg"></i></a> <a ng-if="vm.customer.twitter_link" target="_blank" ng-href="{{vm.customer.twitter_link}}"><i class="fa fa-twitter fa-lg"></i></a> <a ng-if="vm.customer.instagram_link" target="_blank" ng-href="{{vm.customer.instagram_link}}"><i class="fa fa-instagram fa-lg"></i></a></div><div ng-if="vm.customer.website" class="customer-public-website"><div>Website</div><div><a target="_blank" ng-href="{{ vm.customer.website }}" class="text-yellow">{{ vm.customer.website }}</a></div></div></div><div ng-if="vm.customer.address" class="col-md-3 col-sm-12"><a target="_blank" ng-href="https://maps.google.com/?q={{ vm.customer.address }}"><img ng-src="{{vm.mapImageUrl}}" style="max-height: 100px; width: auto; max-width: 100%; border: 2px solid white"></a></div></div><div class="topbuffer5"></div><div class="customer-public-search-bar-wrapper"><div class="customer-public-search-bar" ng-class="{\'show-icon\': !vm.searchTerm}"><i class="fa fa-times customer-public-search-close" ng-click="vm.searchClear()" ng-show="vm.searchTerm"></i><form ng-submit="vm.searchSamples()"><input class="customer-public-search" placeholder="Lot # or Sample/Order ID" ng-model="vm.searchTerm"></form></div><div class="customer-public-filter-by"><span>Filter By</span><div class="custom-selectbox custom-selectbox-blue mgTop7" style="margin-left: 12px"><ui-select ng-model="vm.selectedCategoryId" class="select-option-box" ng-change="vm.searchSamples()"><ui-select-match><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="item.id as item in vm.categories track by item.id"><span ng-bind="item.name"></span></ui-select-choices></ui-select></div></div></div><div class="customer-public-filter-by-sm"><span>Filter By</span><div class="custom-selectbox custom-selectbox-blue mgTop7" style="margin-left: 12px"><ui-select ng-model="vm.selectedCategoryId" class="select-option-box" ng-change="vm.searchSamples()"><ui-select-match><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="item.id as item in vm.categories track by item.id"><span ng-bind="item.name"></span></ui-select-choices></ui-select></div></div><div class="public-page-content" style="padding: 50px 0px !important; background-color: #f3f7fa !important"><div class="public-item" ng-repeat="sample in vm.publicSamples | filter:userSearch"><div class="public-item-img"><div ng-if="sample.cachedPictures"><a ui-sref="public({hash:sample.hash})"><img class="customer-public-sample-img" ng-src="{{ sample.cachedPictures ? sample.cachedPictures[0].url : \'\' }}" alt=""></a></div><div ng-if="!sample.cachedPictures"><a ui-sref="public({hash:sample.hash})"><img class="customer-public-sample-img" src="content/images/no-images-placeholder-400x300.png" alt=""></a></div></div><a ui-sref="public({hash:sample.hash})"><h3>{{sample.name}}</h3></a><ul class="sample-list"><li class="list-item"><span class="thc-icon-public" style="color: #556d85"></span><p class="big-heading">THC</p><p class="small-heading" style="color: #556d85; !important; margin-left:5px">{{ vm.getPotencyValue(sample, \'THC\') }}</p></li><li class="list-item"><span class="cbd-icon-public" style="color: #556d85"></span><p class="big-heading">CBD</p><p class="small-heading" style="color: #556d85; !important; margin-left:5px">{{ vm.getPotencyValue(sample, \'CBD\') }}</p></li><li class="list-item"><p class="big-heading">Total</p><p class="small-heading" style="color: #556d85; !important; margin-left:5px">{{ vm.getPotencyValue(sample, \'TOTAL\') }}</p></li></ul></div><div class="page-list"><div class="text-center mobile-box-pagination" ng-if="(1*vm.totalItems) > (1*vm.itemsPerPage)"><uib-pagination class="pagination pageset" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.searchSamples()"></uib-pagination></div></div></div><hr><footer class="container-fluid"><ul><li><a ng-href="{{brand.web.marketing_url}}" target="_blank" rel="noopener">{{brand.web.marketing_label || \'Website\'}}</a></li><li><a href="#">FAQ</a></li><li><a href="#">About Us</a></li><li><a href="#">Contact</a></li></ul></footer>');
$templateCache.put('app/pages/customer-public/not-found.html','<div class="text-center" style="height: 100vh; position: relative; font-family: \'Open Sans\', sans-serif; font-weight: 400; font-size: 22px"><div style="margin-top: 100px"><img src="content/images/sad-smiley.png" alt="Not found"><p style="margin-top: 100px">Sorry, but the customer you are looking for could not be found.</p></div><footer class="container-fluid" style="position: absolute; bottom: 0; left: 50%; transform: translateX(-50%)"><ul><li><a ng-href="{{brand.web.marketing_url}}" target="_blank" rel="noopener">{{brand.web.marketing_label || \'Website\'}}</a></li><li><a href="#">FAQ</a></li><li><a href="#">About Us</a></li><li><a href="#">Contact</a></li></ul></footer></div>');
$templateCache.put('app/pages/faq/faq-page.html','<div ng-init="getFaqResource()"><div class="sub-header"><div class="container-fluid"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padd"><ul class="tabs"><li ng-class="{\'active\': selectedCategory === \'all\'}" ng-click="allCategory()">All</li><li ng-repeat="(index,category ) in categoriesWithQuestions" ng-click="selectedOneCategiry(index)">{{category.categoryTitle}}</li></ul></div></div></div></div><!-- ALL --><div class="tab_container"><div id="tab1" class="tab_content"><div class="panel-group" id="accordion"><!-- start panel --><div ng-if="selectedCategory === \'all\'"><div class="panel panel-default" id="panel{{index}}" ng-repeat="(index,question ) in questions"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-target="#collapse{{index}}" class="collapsed faq-question" bind-html-compile="question.question"></a></h4></div><div id="collapse{{index}}" class="panel-collapse collapse"><div class="panel-body"><div bind-html-compile="question.answer" class="faq-answer"></div></div></div></div></div><div ng-if="selectedCategory === \'category\'"><div class="panel panel-default" id="panel{{index}}" ng-repeat="(index,question ) in questionByCategories"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-target="#collapse{{index}}" class="collapsed"><div bind-html-compile="question.question" class="faq-question"></div></a></h4></div><div id="collapse{{index}}" class="panel-collapse collapse"><div class="panel-body"><p bind-html-compile="question.answer" class="faq-answer"></p></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/invoice-details/invoice-details.html','<style>#invoice-details {\n        color: #3D5269;\n    }\n\n    .flex-row {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .flex-column {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .flex-row-align-end {\n        justify-content: flex-end;\n    }\n\n    .flex-row-align-start {\n        justify-content: flex-start;\n    }\n\n    .card {\n        display: flex;\n        padding: 16px;\n        background-color: white;\n    }\n\n    #analysis-table,\n    #samples-table {\n        width: 100%;\n        table-layout: fixed;\n        white-space: nowrap;\n        margin-bottom: 16px;\n    }\n\n    #analysis-table > thead > tr > th:nth-child(6),\n    #samples-table > thead > tr > th:nth-child(5),\n    #analysis-table > tbody > tr > td:nth-child(6),\n    #samples-table > tbody > tr > td:nth-child(5) {\n        text-align: right;\n    }\n\n    #analysis-table > tbody > tr > td:nth-child(1) {\n        font-family: OpenSans-SemiBold;\n    }\n\n    #analysis-table > thead > tr > th:nth-child(1),\n    #analysis-table > tbody > tr > td:nth-child(1) {\n        width: 25%;\n    }\n\n    #analysis-table > thead > tr > th:nth-child(6),\n    #analysis-table > tbody > tr > td:nth-child(6) {\n        width: 100px;\n    }\n\n    #analysis-table > thead > tr,\n    #samples-table > thead > tr {\n        color: #2D9CDB;\n        font-family: OpenSans-SemiBold;\n    }\n\n    #analysis-table > thead > tr > th,\n    #samples-table > thead > tr > th,\n    #analysis-table > tbody > tr > td,\n    #samples-table > tbody > tr > td {\n        height: 45px;\n        padding: 10px 0;\n        border-bottom: 1px solid #DFEAF7;\n    }\n\n    .semibold {\n        color: blue;\n        font-family: OpenSans-SemiBold;\n    }\n\n    .invoice-status {\n        border-radius: 56px;\n        padding: 2px 12px;\n        font-family: OpenSans-Semibold;\n        font-size: 12px;\n        white-space: nowrap;\n    }\n\n    .past-due {\n        background-color: #edd4ce;\n    }\n\n    .unpaid {\n        background-color: rgba(243,176,51,0.5);\n    }\n\n    .paid {\n        background-color: #27AE60;\n        color: white;\n    }</style><div id="invoice-details" class="flex-row" style="min-height: 500px; font-size: 13px !important"><div class="flex-column" style="width: 100%; padding: 30px"><div class="flex-row"><button type="button" class="btnPrimaryWhite" ui-sref="invoicelog"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;Back</button> <button class="btnPrimaryWhite" style="margin-left: auto" ng-click="vm.printAttachment(vm.data.invoice.id)"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp;Print Invoice</button> <button class="btnPrimaryWhite" style="margin-left: 16px" ng-click="vm.downloadAttachment(vm.data.invoice.id)"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Invoice</button></div><div class="flex-row" style="margin-top: 48px"><div class="flex-column" style="flex-grow: 4; font-size: 13px"><div class="flex-row"><div ng-bind-html="vm.payment_status"></div></div><div class="flex-row" style="margin-top: 16px; margin-bottom: 8px"><span style="width: 140px">{{ ((brand.branding && brand.branding.display_name) || \'Lab\') + \' Order No.\' }}</span> <a class="text-yellow" style="font-family: OpenSans-SemiBold; margin-left: 8px" ui-sref="order-details({orderId: vm.data.invoice.order_id})">{{ vm.data.invoice.order_id }}</a></div><div class="flex-row" style="margin-bottom: 8px"><span style="width: 140px">Turnaround Time</span> <span style="font-family: OpenSans-SemiBold; margin-left: 8px" ng-cloak>{{ vm.data.customerOrder ? vm.data.customerOrder.turnaroundTimeLabel : \'\' }}</span></div><div ng-if="invoice.order.poNumber" class="flex-row" style="margin-bottom: 8px"><span style="width: 140px">PO No.</span> <span style="font-family: OpenSans-SemiBold; margin-left: 8px">{{ vm.data.customerOrder ? vm.data.customerOrder.poNumber : \'\' }}</span></div></div><div class="flex-column" style="flex-grow: 1; font-size: 13px" ng-cloak><div class="flex-row flex-row-align-end" style="margin-bottom: 8px; font-family: OpenSans-SemiBold">Account Name</div><div class="flex-row flex-row-align-end" ng-repeat="line in vm.account_address track by $index">{{ line }}</div></div><div ng-if="vm.distributor_address.length > 0" class="flex-column" style="flex-grow: 1; font-size: 13px" ng-cloak><div class="flex-row flex-row-align-end" style="margin-bottom: 8px; font-family: OpenSans-SemiBold">Distributor</div><div class="flex-row flex-row-align-end" ng-repeat="line in vm.distributor_address track by $index">{{ line }}</div></div><div ng-if="vm.manufacturing_address.length > 0" class="flex-column" style="flex-grow: 1; font-size: 13px" ng-cloak><div class="flex-row flex-row-align-end" style="margin-bottom: 8px; font-family: OpenSans-SemiBold">Cultivator/Manufacturer</div><div class="flex-row flex-row-align-end" ng-repeat="line in vm.manufacturing_address track by $index">{{ line }}</div></div></div><div class="flex-row" style="margin-top: 32px"><div class="flex-column" style="width: 100%"><div class="flex-column" style="width: 100%; padding-right: 24px"><div class="card"><table id="analysis-table"><thead><tr><th>Analysis Performed</th><th>Quantity</th><th>Unit Price</th><th>Discount</th><th>Surcharge</th><th>Amount</th></tr></thead><tbody ng-cloak><tr ng-repeat="item in vm.invoice_data.invoice_items track by item.id"><td style="white-space: normal; padding-right: 10px">{{ item.name }}</td><td>{{ item.quantity }}</td><td>&#36;{{ item.base_price.toFixed(2) | number : 2 }}</td><td>{{ item.discount > 0 ? \'-\' + item.discount + \'%\' : \'-\' }}</td><td>{{ item.surcharge > 0 ? \'+\' + item.surcharge + \'%\' : \'-\' }}</td><td>&#36;{{ item.amount.toFixed(2) | number : 2 }}</td></tr></tbody></table></div></div><div class="flex-column" style="width: 100%; padding-right: 24px; padding-top: 24px"><div class="card"><table id="samples-table"><thead><tr><th>Sample ID</th><th>Sample Name</th><th>Category Type</th><th ng-show="vm.show_lot_batch">Lot No.</th><th>Tests</th></tr></thead><tbody ng-cloak><tr ng-repeat="sample in vm.data.sampleList track by sample.id"><td style="vertical-align: top"><a class="text-yellow" ui-sref="public({hash:sample.hash})">{{ sample.id }}</a></td><td style="vertical-align: top">{{ sample.name ? sample.name : \'-\' }}</td><td style="vertical-align: top">{{ sample.productCategory.name ? sample.productCategory.name : \'-\' }}</td><td ng-show="vm.show_lot_batch" style="vertical-align: top">{{ sample.lotBatchNumber ? sample.lotBatchNumber : \'-\' }}</td><td><div style="white-space: normal; margin-bottom: 5px" ng-repeat="assay in sample.sampleTests">{{ assay.assay.title }}</div></td></tr></tbody></table></div></div></div><div class="flex-column card" style="width: 300px; padding: 16px 24px" ng-cloak><div class="flex-row" style="font-family: OpenSans-Bold; margin-bottom: 16px; font-size: 16px">Order Summary</div><div ng-repeat="item in vm.invoice_data.invoice_items" class="flex-column" style="margin-bottom: 12px"><div class="flex-row" style="margin-bottom: 2px; font-family: OpenSans-SemiBold">{{ item.name }}</div><div class="flex-row" style="justify-content: space-between"><span style="color: #8795A1">Amount</span><span>&#36;{{ item.amount.toFixed(2) | number : 2 }}</span></div></div><div class="flex-column" style="padding: 16px 0; border-top: 1px solid #DFEAF7; border-bottom: 1px solid #DFEAF7"><div ng-repeat="surcharge in vm.invoice_data.flat_surcharges track by surcharge.id" class="flex-row" style="justify-content: space-between; margin-bottom: 4px"><span style="color: #8795A1">{{ surcharge.name }}</span><span>&#36;{{ surcharge.amount.toFixed(2) | number : 2 }}</span></div><div ng-repeat="discount in vm.invoice_data.flat_discounts track by discount.id" class="flex-row" style="justify-content: space-between; margin-bottom: 4px"><span style="color: #8795A1">{{ discount.name }}</span><span>-&#36;{{ discount.amount.toFixed(2) | number : 2 }}</span></div><div ng-repeat="subtotal in vm.invoice_data.subtotals track by subtotal.id" class="flex-row" style="justify-content: space-between; margin-bottom: 4px"><span style="color: #8795A1">{{ subtotal.name }}</span><span>&#36;{{ subtotal.amount.toFixed(2) | number : 2 }}</span></div><div ng-repeat="surcharge in vm.invoice_data.percent_surcharges track by surcharge.id" class="flex-row" style="justify-content: space-between; margin-bottom: 4px"><span style="color: #8795A1">{{ surcharge.name }}</span><span>&#36;{{ surcharge.amount.toFixed(2) | number : 2 }}</span></div><div ng-repeat="discount in vm.invoice_data.percent_discounts track by discount.id" class="flex-row" style="justify-content: space-between; margin-bottom: 4px"><span style="color: #8795A1">{{ discount.name }}</span><span>-&#36;{{ discount.amount.toFixed(2) | number : 2 }}</span></div></div><div class="flex-row" style="padding-top: 16px; justify-content: space-between; font-family: OpenSans-SemiBold"><span>Total</span><span>&#36;{{ vm.invoice_data.total.toFixed(2) | number : 2 }}</span></div><div ng-if="!vm.data.invoice.paid && (vm.invoice_data.total != vm.invoice_data.outstanding_amount)" class="flex-row" style="padding-top: 8px; justify-content: space-between; font-family: OpenSans-SemiBold"><span>Payments</span><span>-&#36;{{ (vm.invoice_data.total.toFixed(2) - vm.invoice_data.outstanding_amount.toFixed(2)) | number : 2 }}</span></div><div ng-if="!vm.data.invoice.paid && (vm.invoice_data.total != vm.invoice_data.outstanding_amount)" class="flex-row" style="padding-top: 8px; justify-content: space-between; font-family: OpenSans-SemiBold"><span>Outstanding</span><span>&#36;{{ vm.invoice_data.outstanding_amount.toFixed(2) | number : 2 }}</span></div><div ng-if="!vm.data.invoice.paid && vm.data.invoice.outstanding_amount > 0" style="padding-top: 16px"><button ng-show="!vm.payment_processing && vm.invoice_is_payable" ng-click="vm.createPayment()" style="width: 100%; color: white; padding: 4px 0; background-color: #27AE60; border: none; border-radius: 4px">Pay {{ vm.invoice_data.total != vm.invoice_data.outstanding_amount ? \'Outstanding\' : \'Total\' }} via Card</button> <button ng-show="vm.payment_processing && vm.invoice_is_payable" class="no-pointer-events" style="width: 100%; color: white; padding: 4px 0; background-color: #93A4B8; border: none; border-radius: 4px">Payment Processing&nbsp;<i class="fa fa-spinner fa-spin"></i></button> <button ng-show="!vm.invoice_is_payable" class="no-pointer-events" style="width: 100%; color: white; padding: 4px 0; background-color: #93A4B8; border: none; border-radius: 4px">Pay {{ vm.invoice_data.total != vm.invoice_data.outstanding_amount ? \'Outstanding\' : \'Total\' }} via Card</button></div></div></div></div></div>');
$templateCache.put('app/pages/invoice-log/invoiceslog.html','<style>/* The snackbar - position it at the bottom and in the middle of the screen */\n    #snackbar {\n        visibility: hidden; /* Hidden by default. Visible on click */\n        min-width: 250px; /* Set a default minimum width */\n        margin-left: -125px; /* Divide value of min-width by 2 */\n        background-color: #e3fcef; /* Black background color */\n        color: #172b4d; /* White text color */\n        text-align: center; /* Centered text */\n        border-radius: 13px; /* Rounded borders */\n        padding: 16px; /* Padding */\n        position: fixed; /* Sit on top of the screen */\n        z-index: 1; /* Add a z-index if needed */\n        left: 50%; /* Center the snackbar */\n        top: 13px; /* 30px from the bottom */\n        display: flex;\n        align-items: center;\n        box-shadow: 0px 0px 1px 0px #000000 4%;\n        box-shadow: 0px 2px 6px 0px #000000 4%;\n        box-shadow: 0px 16px 24px 0px #000000 6%;\n    }\n\n    /* Show the snackbar when clicking on a button (class added with JavaScript) */\n    #snackbar.activeSnackbar {\n        visibility: visible; /* Show the snackbar */\n        /* Add animation: Take 0.5 seconds to fade in and out the snackbar.\n        However, delay the fade out process for 2.5 seconds */\n        -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;\n        animation: fadein 0.5s, fadeout 0.5s 2.5s;\n    }\n\n    /* Animations to fade the snackbar in and out */\n    @-webkit-keyframes fadein {\n        from {top: 0; opacity: 0;}\n        to {top: 13px; opacity: 1;}\n    }\n\n    @keyframes fadein {\n        from {top: 0; opacity: 0;}\n        to {top: 13px; opacity: 1;}\n    }\n\n    @-webkit-keyframes fadeout {\n        from {top: 13px; opacity: 1;}\n        to {top: 0; opacity: 0;}\n    }\n\n    @keyframes fadeout {\n        from {top: 13px; opacity: 1;}\n        to {top: 0; opacity: 0;}\n    }\n\n    .switch {\n        position: relative;\n        display: inline-block;\n        width: 40px;\n        height: 20px;\n    }\n\n    .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #607e9f;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    .slider:before {\n        position: absolute;\n        content: "";\n        height: 16px;\n        width: 16px;\n        left: 2px;\n        bottom: 2px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    input:checked + .slider {\n        background-color: #27AE60;\n    }\n\n    input:focus + .slider {\n        box-shadow: 0 0 1px #2196F3;\n    }\n\n    input:checked + .slider:before {\n        -webkit-transform: translateX(20px);\n        -ms-transform: translateX(20px);\n        transform: translateX(20px);\n    }\n\n    /* Rounded sliders */\n    .slider.round {\n        border-radius: 34px;\n        margin-top: 0 !important;\n    }\n\n    .slider.round:before {\n        border-radius: 50%;\n    }\n\n    #open-invoice-table > thead > tr > th:nth-child(7),\n    #open-invoice-table > tbody > tr > td:nth-child(7) {\n        text-align: center;\n        padding-right: 8%;\n    }\n\n    #payments-table,\n    #open-invoice-table,\n    #closed-invoice-table {\n        border-collapse: collapse;\n        table-layout: fixed;\n        width: 100%;\n    }\n\n    #payments-table > tbody > tr,\n    #open-invoice-table > tbody > tr,\n    #closed-invoice-table > tbody > tr  {\n        height: 32px;\n    }\n\n    #payments-table > thead > tr,\n    #open-invoice-table > thead > tr,\n    #closed-invoice-table > thead > tr  {\n        height: 40px;\n        white-space: nowrap;\n    }\n\n    #payments-table > tbody > tr > td,\n    #open-invoice-table > tbody > tr > td,\n    #closed-invoice-table > tbody > tr > td {\n        color: #3D5269;\n    }\n\n    #payments-table > thead > tr > th:nth-child(6),\n    #payments-table > tbody > tr > td:nth-child(6) {\n        text-align: center !important;\n        width: 78px  !important;\n        padding-right: 16px;\n    }\n\n    #open-invoice-table > thead > tr > th:nth-child(8),\n    #open-invoice-table > tbody > tr > td:nth-child(8),\n    #closed-invoice-table > thead > tr > th:nth-child(7),\n    #closed-invoice-table > tbody > tr > td:nth-child(7) {\n        text-align: center !important;\n        width: 78px  !important;\n        padding-right: 16px;\n    }\n\n    #payments-table > thead > tr > th:nth-child(1),\n    #payments-table > tbody > tr > td:nth-child(1),\n    #open-invoice-table > thead > tr > th:nth-child(1),\n    #open-invoice-table > tbody > tr > td:nth-child(1),\n    #closed-invoice-table > thead > tr > th:nth-child(1),\n    #closed-invoice-table > tbody > tr > td:nth-child(1) {\n        padding-left: 8px;\n        width: 56px;\n    }\n\n    .checkboxContainer input:checked ~ .checkmark {\n        background-color: #27AE60;\n        border: none;\n    }\n\n    .checkmark {\n        border: 1.2px solid #3D5269;\n        box-sizing: border-box;\n        border-radius: 2.4px;\n    }\n\n    #add-payment-method {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        height: 76px;\n        background: white;\n        border: 1px dashed #b8c2cc;\n        border-radius: 5px;\n        padding: 0 24px;\n        color: #2D9CDB;\n    }\n\n    #add-payment-method:hover {\n        background: #edf3fa;\n    }\n\n    .flex-column {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .flex-row {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .flex-center {\n        justify-content: center;\n        align-content: center;\n        align-items: center;\n    }\n\n    .payment-methods-input {\n        width: 100%;\n        height: 38px;\n        border: 1px solid #e6ebf0;\n        border-radius: 2px;\n        margin-top: 8px;\n        padding: 9px 10px;\n        color: #3d5269;\n    }\n\n    .payment-methods-nav-btn {\n        height: 32px;\n        width: 172px;\n        border-radius: 4px;\n        padding: 6px 16px;\n        border: none;\n    }\n\n    .payment-methods-gray-btn {\n        background-color: #3d5269;\n        color: white\n    }\n\n    .payment-methods-gray-btn:hover {\n        transition: background-color .2s ease-in-out;\n        background-color: #eff5fb;\n        color: #3d5269;\n    }\n\n    .payment-methods-light-btn {\n        background-color: #eff5fb;\n        color: #3d5269;\n    }\n\n    .payment-methods-light-btn:hover {\n        transition: background-color .2s ease-in-out;\n        background-color: #3d5269;\n        color: #eff5fb;\n    }\n\n    .invoice-status {\n        border-radius: 56px;\n        padding: 2px 12px;\n        font-family: OpenSans-Semibold;\n        font-size: 12px;\n        white-space: nowrap;\n    }\n\n    .past-due {\n        background-color: #edd4ce;\n    }\n\n    .unpaid {\n        background-color: rgba(243,176,51,0.5);\n    }\n\n    .paid {\n        background-color: #5edc31;\n    }\n\n    .pagination {\n\t\tfont-size: 13px !important;\n\t}\n\n\t.pagination > li:last-child > a,\n\t.pagination > li:last-child > span,\n\t.pagination > li:first-child > a,\n\t.pagination > li:first-child > span,\n\t.pageset li a {\n\t\tborder-radius: 3px;\n\t\tbackground: none;\n\t\tborder: none;\n\t\tcolor: #3D5269;\n\t}\n\n    .pagination > li > a:focus,\n\t.pagination > li > a:hover,\n\t.pagination > li > span:focus,\n\t.pagination > li > span:hover,\n\t.pagination > .active > a,\n    .pagination > .active > a:focus,\n    .pagination > .active > a:hover,\n    .pagination > .active > span,\n    .pagination > .active > span:focus,\n    .pagination > .active > span:hover {\n        background-color: #647F9C !important;\n        border-color: #647F9C !important;\n    }\n\n    #sq-card-number::before {\n        content: \'&#8596\';\n    }\n\n    .invisible {\n        opacity: 0;\n    }\n\n    .opacity-50 {\n        opacity: 50%;\n    }</style><div class="content-wrapper-x content-page-height" style="padding: 0 30px; font-size: 13px !important"><div id="snackbar"><i class="fa fa-check-circle" style="color: #006a43; font-size: 23px"></i><span style="margin-left: 16px; font-family: OpenSans-Semibold">Autopay successfully enabled</span></div><div ng-show="vm.show_all_tabs" class="invoice-log-sub-header" ng-style="{ \'no-pointer-events\': vm.payment_processing }" style="margin-top: 32px; margin-bottom: 24px"><div style="margin-right: 16px"><button ng-click="vm.switchTab(\'open_invoices\')" class="customer-manage-ui-button" ng-class="{ \'customer-manage-ui-button-active\': vm.activeTab.open_invoices, \'customer-manage-ui-button-inactive\': !vm.activeTab.open_invoices }">OPEN INVOICES</button></div><div style="margin-right: 16px"><button ng-click="vm.switchTab(\'closed_invoices\')" class="customer-manage-ui-button" ng-class="{ \'customer-manage-ui-button-active\': vm.activeTab.closed_invoices, \'customer-manage-ui-button-inactive\': !vm.activeTab.closed_invoices }">CLOSED INVOICES</button></div><div style="margin-right: 16px"><button ng-click="vm.switchTab(\'payment_methods\')" class="customer-manage-ui-button" ng-class="{ \'customer-manage-ui-button-active\': vm.activeTab.payment_methods, \'customer-manage-ui-button-inactive\': !vm.activeTab.payment_methods }">PAYMENT METHODS</button></div><div><button ng-click="vm.switchTab(\'payment_history\')" class="customer-manage-ui-button" ng-class="{ \'customer-manage-ui-button-active\': vm.activeTab.payment_history, \'customer-manage-ui-button-inactive\': !vm.activeTab.payment_history }">PAYMENT HISTORY</button></div><div style="margin-left: auto; display: flex; align-items: center"><button ng-click="vm.downloadOpenBalance()" ng-class="{ \'no-pointer-events btnPrimaryCancel\': !vm.open_invoices.total_balance }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Open Balance</button></div></div><div ng-show="vm.activeTab.open_invoices"><div class="invoice-log-sub-header" style="background: white; height: 64px; align-items: center; padding: 0 24px"><button ng-show="vm.payment_processing" style="margin-right: 16px; padding: 6px 12px; color: white; background-color: #93A4B8; border: none; border-radius: 4px"><span style="width: 60px">Payment Processing&nbsp;<i class="fa fa-spinner fa-spin"></i></span></button> <button ng-click="vm.initiatePayment(\'card\')" ng-show="vm.open_invoices.total_balance > 0 && !vm.payment_processing" style="margin-right: 16px; padding: 6px 12px; color: white; background-color: #27AE60; border: none; border-radius: 4px"><span style="width: 60px">Pay {{ vm.open_invoices.invoices_to_pay.length == 0 && vm.open_invoices.total_balance > 0 ? "Balance" : "Selected" }} via Card</span></button> <button id="ach-button" ng-show="vm.open_invoices.total_balance > 0 && !vm.payment_processing" style="margin-right: 16px; padding: 6px 12px; color: white; background-color: #27AE60; border: none; border-radius: 4px" data-toggle="modal" data-target="#infoModal"><span style="width: 60px">Pay {{ vm.open_invoices.invoices_to_pay.length == 0 && vm.open_invoices.total_balance > 0 ? "Balance" : "Selected" }} via ACH</span></button><div ng-show="vm.payment.pay_selected_total" style="color: #3D5269">Selected: <span style="font-family: OpenSans-Semibold">&#36;{{ vm.payment.pay_selected_total ? (vm.payment.pay_selected_total.toFixed(2) | number : 2) : 0 }}</span></div><div style="margin-left: auto; color: #3D5269">Account Balance: <span style="font-family: OpenSans-Semibold">&#36;{{ vm.open_invoices.total_balance ? (vm.open_invoices.total_balance.toFixed(2) | number : 2) : \'0\' }}</span></div><div style="margin-left: 20px; color: #3D5269; display: flex; align-items: center; position: relative"><span style="display: flex; align-items: center; margin-right: 8px; position: relative; width: 40px; height: 20px"><label ng-class="{ \'no-pointer-events\': vm.autopay_processing }" class="switch"><input ng-class="{ \'no-pointer-events\': vm.autopay_processing }" type="checkbox" ng-checked="vm.autopay_checked" ng-model="vm.autopay_checked" ng-click="vm.toggleAutopay()"><div class="slider round"></div><span ng-show="!vm.autopay_checked" style="pointer-events: none; font-size: 10px; position: absolute; color: white; top: 3px; right: 5px">Off</span> <span ng-show="vm.autopay_checked" style="pointer-events: none; font-size: 10px; position: absolute; color: white; top: 3px; right: 22px">On</span></label></span><span style="font-family: OpenSans-Semibold">Autopay&nbsp;</span>is&nbsp;<span ng-show="!vm.autopay_checked" style="width: 55px">disabled</span><span ng-show="vm.autopay_checked" style="width: 55px; color: #27AE60">enabled</span>&nbsp; <i class="fa fa-info-circle manage-tab-popover-trigger"></i><div class="manage-tab-popover" style="margin-bottom: 75px; padding: 2px 4px; border: 1px solid #cbd4dd; width: max-content; right: -24px"><p ng-show="vm.customerData.autopay_log && vm.autopay_checked">{{ vm.customerData.autopay_log }}</p><p ng-show="vm.customerData.autopay_log && !vm.autopay_checked">{{ vm.customerData.autopay_log }}</p><p style="font-size: 10px; color: #7F9DCD">In the event your card is not charged due to technical issues on our end<br>your card will be manually charged at a later date.</p></div><!-- <div  class="manage-tab-popover" style="margin-bottom: 58px; padding: 2px 4px; border: 1px solid #cbd4dd; width: max-content; right: -24px;">\n                    \n                    <br>\n                    <p style="font-size: 10px;" >\n                        In the event your card is not charged due to technical issues on our end <br> your card will be manually charged at a later date\n                    </p>\n                </div> --></div></div><div class="bigbox" style="display: flex; flex-direction: column; margin-top: 16px; box-shadow: none !important; border-radius: 0 !important"><div class="flex-row" style="justify-content: flex-end; margin-bottom: 10px"><button ng-class="{ \'no-pointer-events btnPrimaryCancel\': vm.open_invoices.invoices_to_pay.length == 0 }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.printSelectedInvoices(vm.open_invoices)"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp;Print Selected Reports</button> <button ng-class="{ \'no-pointer-events btnPrimaryCancel\': vm.open_invoices.invoices_to_pay.length == 0 }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.downloadSelectedInvoices(vm.open_invoices)"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Selected Reports</button> <button class="btnPrimaryWhite" style="height: unset; padding: 4px 8px" ng-click="vm.open_invoices.open_filters = !vm.open_invoices.open_filters"><i class="fa fa-sliders"></i>&nbsp;&nbsp;&nbsp;{{\'Filters\' | translate}}</button></div><div><div class="flex-column" ng-show="vm.open_invoices.open_filters" style="width: 100%; padding: 20px 0; border-bottom: 1px solid #DFEAF7; margin-bottom: 20px"><div class="flex-row" style="justify-content: space-between; margin-bottom: 20px"><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Invoice Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Invoice date lower limit" ng-model="vm.open_invoices.filters.invoice_date_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.open_invoices.date_picker.invoice_date_lower" ng-click="vm.open_invoices.date_picker.invoice_date_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Invoice date upper limit" ng-model="vm.open_invoices.filters.invoice_date_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.open_invoices.date_picker.invoice_date_upper" ng-click="vm.open_invoices.date_picker.invoice_date_upper = true"></div></div></div><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Due Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Due date lower limit" ng-model="vm.open_invoices.filters.due_date_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.open_invoices.date_picker.due_date_lower" ng-click="vm.open_invoices.date_picker.due_date_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Due date upper limit" ng-model="vm.open_invoices.filters.due_date_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.open_invoices.date_picker.due_date_upper" ng-click="vm.open_invoices.date_picker.due_date_upper = true"></div></div></div></div><div class="flex-row" style="justify-content: space-between; margin-bottom: 20px"><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Amount Range ($)</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Amount lower limit" ng-model="vm.open_invoices.filters.amount_lower"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Amount upper limit" ng-model="vm.open_invoices.filters.amount_upper"></div></div></div><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Balance Range ($)</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Balance lower limit" ng-model="vm.open_invoices.filters.balance_lower"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Balance upper limit" ng-model="vm.open_invoices.filters.balance_upper"></div></div></div></div><div class="flex-row" style="height: 30px; align-items: right; justify-content: flex-end"><button class="btnPrimaryCancel" style="height: unset; margin-right: 16px" ng-click="vm.open_invoices.open_filters = false">{{\'Close\' | translate}}</button> <button class="btnPrimaryWhite" style="height: unset; margin-right: 16px" ng-click="vm.generic.clearFilters(vm.open_invoices)">Clear Filters</button> <button class="btnPrimaryBlue" style="height: unset" ng-click="vm.generic.query(vm.open_invoices, true)">{{\'Apply Filters\' | translate}}</button></div></div><table id="open-invoice-table" ng-cloak><thead style="color: #2D9CDB; font-family: OpenSans-Semibold"><tr><th><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="vm.open_invoices.all_invoices_checked" ng-change="vm.open_invoices.changeInvoicesToPayAll()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></th><th ng-click="vm.generic.changeSort(vm.open_invoices, \'id\')"><div class="flex-row flex-center"><div>Invoice No.</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'id\' && vm.open_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'id\' && vm.open_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.open_invoices, \'invoice_date\')"><div class="flex-row flex-center"><div>Invoice Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'invoice_date\' && vm.open_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'invoice_date\' && vm.open_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.open_invoices, \'due_date\')"><div class="flex-row flex-center"><div>Due Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'due_date\' && vm.open_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'due_date\' && vm.open_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.open_invoices, \'total\')"><div class="flex-row flex-center"><div>Amount</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'total\' && vm.open_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'total\' && vm.open_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.open_invoices, \'outstanding_amount\')"><div class="flex-row flex-center"><div>Balance</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'outstanding_amount\' && vm.open_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.open_invoices.sort_filters.field == \'outstanding_amount\' && vm.open_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th>Status</th><th>Actions</th></tr></thead><tbody ng-if="vm.open_invoices.invoices.length > 0"><tr ng-repeat="invoice in vm.open_invoices.invoices" style="padding: 8px 0px; border-top: 1px solid #DFEAF7; border-bottom: 1px solid #DFEAF7"><td><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="invoice.checked" ng-change="vm.open_invoices.changeInvoicesToPay()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></td><td class="text-yellow"><a ui-sref="invoice-details({id:invoice.id})" style="padding: 0">{{ invoice.custom_formated_id }}</a></td><td>{{ invoice.invoice_date | date : \'MM/dd/yyyy\' }}</td><td>{{ invoice.due_date ? (invoice.due_date | date : \'MM/dd/yyyy\') : (invoice.invoice_date | date : \'MM/dd/yyyy\') }}</td><td>&#36;{{ invoice.total ? (invoice.total.toFixed(2) | number : 2) : \'\' }}</td><td>&#36;{{ invoice.outstanding_amount ? (invoice.outstanding_amount.toFixed(2) | number : 2) : \'\' }}</td><td><span ng-bind-html="invoice.payment_status"></span></td><td><i class="fa fa-download" style="margin-right: 16px; color: #607e9f" ng-click="vm.downloadAttachment(invoice)"></i><i class="fa fa-print" style="color: #607e9f" ng-click="vm.printAttachment(invoice)"></i></td></tr></tbody></table><div class="flex-column" ng-show="vm.open_invoices.invoices.length == 0"><div class="flex-row" style="justify-content: center; align-items: center; margin-top: 135px; color: #3D5269"><span ng-show="vm.open_invoices.loading == false">No Open Invoices</span> <span ng-show="vm.open_invoices.loading == true"><i class="fa fa-spinner fa-spin" style="font-size: 30px"></i></span></div></div></div></div><div class="page-list"><div class="mobile-box-pagination" style="display: flex; justify-content: space-between"><div class="custom-selectbox"><select class="selectpicker select-box-padding-tiny" ng-model="vm.open_invoices.base_filters.size" ng-change="vm.generic.query(vm.open_invoices, true)"><option value="10">10</option><option value="20" ng-selected="true">20</option><option value="50">50</option></select></div><uib-pagination ng-show="vm.open_invoices.base_filters.size < vm.open_invoices.total_items" class="pagination pageset" total-items="vm.open_invoices.total_items" items-per-page="vm.open_invoices.base_filters.size" ng-model="vm.open_invoices.page_plus_one" ng-change="vm.generic.query(vm.open_invoices, false)"></uib-pagination></div></div></div><div ng-show="vm.activeTab.closed_invoices"><div class="bigbox" style="display: flex; flex-direction: column; margin-top: 16px; box-shadow: none !important; border-radius: 0 !important"><div class="flex-row" style="justify-content: flex-end; margin-bottom: 10px"><button ng-class="{ \'no-pointer-events btnPrimaryCancel\': !vm.closed_invoices.any_invoices_checked }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.printSelectedInvoices(vm.closed_invoices)"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp;Print Selected Reports</button> <button ng-class="{ \'no-pointer-events btnPrimaryCancel\': !vm.closed_invoices.any_invoices_checked }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.downloadSelectedInvoices(vm.closed_invoices)"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Selected Reports</button> <button class="btnPrimaryWhite" style="height: unset; padding: 4px 8px" ng-click="vm.closed_invoices.open_filters = !vm.closed_invoices.open_filters"><i class="fa fa-sliders"></i>&nbsp;&nbsp;&nbsp;{{\'Filters\' | translate}}</button></div><div><div class="flex-column" ng-show="vm.closed_invoices.open_filters" style="width: 100%; padding: 20px 0; border-bottom: 1px solid #DFEAF7; margin-bottom: 20px"><div class="flex-row" style="justify-content: space-between; margin-bottom: 20px"><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Invoice Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Invoice date lower limit" ng-model="vm.closed_invoices.filters.invoice_date_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.invoice_date_lower" ng-click="vm.closed_invoices.date_picker.invoice_date_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Invoice date upper limit" ng-model="vm.closed_invoices.filters.invoice_date_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.invoice_date_upper" ng-click="vm.closed_invoices.date_picker.invoice_date_upper = true"></div></div></div><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Due Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Due date lower limit" ng-model="vm.closed_invoices.filters.due_date_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.due_date_lower" ng-click="vm.closed_invoices.date_picker.due_date_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Due date upper limit" ng-model="vm.closed_invoices.filters.due_date_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.due_date_upper" ng-click="vm.closed_invoices.date_picker.due_date_upper = true"></div></div></div></div><div class="flex-row" style="justify-content: space-between; margin-bottom: 20px"><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Amount Range ($)</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Amount lower limit" ng-model="vm.closed_invoices.filters.amount_lower"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Amount upper limit" ng-model="vm.closed_invoices.filters.amount_upper"></div></div></div><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Payment Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Payment date lower limit" ng-model="vm.closed_invoices.filters.date_paid_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.date_paid_lower" ng-click="vm.closed_invoices.date_picker.date_paid_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Payment date upper limit" ng-model="vm.closed_invoices.filters.date_paid_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.closed_invoices.date_picker.date_paid_upper" ng-click="vm.closed_invoices.date_picker.date_paid_upper = true"></div></div></div></div><div class="flex-row" style="height: 30px; align-items: right; justify-content: flex-end"><button class="btnPrimaryCancel" style="height: unset; margin-right: 16px" ng-click="vm.closed_invoices.open_filters = false">{{\'Close\' | translate}}</button> <button class="btnPrimaryWhite" style="height: unset; margin-right: 16px" ng-click="vm.generic.clearFilters(vm.closed_invoices)">Clear Filters</button> <button class="btnPrimaryBlue" style="height: unset" ng-click="vm.generic.query(vm.closed_invoices, true)">{{\'Apply Filters\' | translate}}</button></div></div><table id="closed-invoice-table"><thead style="color: #2D9CDB; font-family: OpenSans-Semibold"><tr><th><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="vm.closed_invoices.all_invoices_checked" ng-change="vm.closed_invoices.changeInvoicesToPayAll()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></th><th ng-click="vm.generic.changeSort(vm.closed_invoices, \'id\')"><div class="flex-row flex-center"><div>Invoice No.</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'id\' && vm.closed_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'id\' && vm.closed_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.closed_invoices, \'invoice_date\')"><div class="flex-row flex-center"><div>Invoice Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'invoice_date\' && vm.closed_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'invoice_date\' && vm.closed_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.closed_invoices, \'due_date\')"><div class="flex-row flex-center"><div>Due Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'due_date\' && vm.closed_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'due_date\' && vm.closed_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.closed_invoices, \'total\')"><div class="flex-row flex-center"><div>Amount</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'total\' && vm.closed_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'total\' && vm.closed_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.closed_invoices, \'date_paid\')"><div class="flex-row flex-center"><div>Payment Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'date_paid\' && vm.closed_invoices.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.closed_invoices.sort_filters.field == \'date_paid\' && vm.closed_invoices.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th>Actions</th></tr></thead><tbody ng-if="vm.closed_invoices.invoices.length > 0"><tr ng-repeat="invoice in vm.closed_invoices.invoices" style="padding: 8px 0px; border-top: 1px solid #DFEAF7; border-bottom: 1px solid #DFEAF7"><td><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="invoice.checked" ng-change="vm.closed_invoices.checkedInvoices()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></td><td class="text-yellow"><a ui-sref="invoice-details({id:invoice.id})" style="padding: 0">{{ invoice.custom_formated_id }}</a></td><td>{{ invoice.invoice_date | date : \'MM/dd/yyyy\' }}</td><td>{{ invoice.due_date ? (invoice.due_date | date : \'MM/dd/yyyy\') : (invoice.invoice_date | date : \'MM/dd/yyyy\') }}</td><td>&#36;{{ invoice.total ? (invoice.total.toFixed(2) | number : 2) : \'\' }}</td><td>{{ invoice.date_paid | date : \'MM/dd/yyyy\' }}</td><td><i class="fa fa-download" style="margin-right: 16px; color: #607e9f" ng-click="vm.downloadAttachment(invoice)"></i><i class="fa fa-print" style="color: #607e9f" ng-click="vm.printAttachment(invoice)"></i></td></tr></tbody></table><div class="flex-column" ng-if="vm.closed_invoices.invoices.length == 0"><div class="flex-row" style="justify-content: center; align-items: center; margin-top: 135px; color: #3D5269">No Closed Invoices</div></div></div></div><div class="page-list"><div class="mobile-box-pagination" style="display: flex; justify-content: space-between"><div class="custom-selectbox"><select class="selectpicker select-box-padding-tiny" ng-model="vm.closed_invoices.base_filters.size" ng-change="vm.generic.query(vm.closed_invoices, true)"><option value="10">10</option><option value="20" ng-selected="true">20</option><option value="50">50</option></select></div><uib-pagination ng-show="vm.closed_invoices.base_filters.size < vm.closed_invoices.total_items" class="pagination pageset" total-items="vm.closed_invoices.total_items" items-per-page="vm.closed_invoices.base_filters.size" ng-model="vm.closed_invoices.page_plus_one" ng-change="vm.generic.query(vm.closed_invoices, false)"></uib-pagination></div></div></div><div ng-show="vm.activeTab.payment_methods"><div style="display: flex; flex-direction: column; width: 50%; min-height: 341px; min-width: 540px; background: white; border-radius: 6px; padding: 32px"><div style="font-family: OpenSans-Bold; color: #3D5269; font-size: 16px">Your Payment Methods</div><div style="color: #3D5269; margin-top: 8px">Add and manage payment methods with our secure payment system.</div><div style="color: #3D5269; display: flex; align-items: center; margin-top: 24px"><span style="display: flex; align-items: center; margin-right: 8px; position: relative; width: 40px; height: 20px"><label ng-class="{ \'no-pointer-events\': vm.autopay_processing }" class="switch"><input ng-class="{ \'no-pointer-events\': vm.autopay_processing }" type="checkbox" ng-checked="vm.autopay_checked" ng-model="vm.autopay_checked" ng-click="vm.toggleAutopay()"><div class="slider round"></div><span ng-show="!vm.autopay_checked" style="pointer-events: none; font-size: 10px; position: absolute; color: white; top: 3px; right: 5px">Off</span> <span ng-show="vm.autopay_checked" style="pointer-events: none; font-size: 10px; position: absolute; color: white; top: 3px; right: 22px">On</span></label></span><span style="font-family: OpenSans-Semibold">Autopay&nbsp;</span>is&nbsp;<span ng-show="!vm.autopay_checked" style="width: 55px">disabled</span><span ng-show="vm.autopay_checked" style="width: 55px; color: #27AE60">enabled</span>&nbsp; <i class="fa fa-info-circle manage-tab-popover-trigger"></i><div class="manage-tab-popover" style="margin-bottom: 75px; padding: 2px 4px; border: 1px solid #cbd4dd; width: max-content; right: -24px"><p ng-show="vm.customerData.autopay_log && vm.autopay_checked">{{ vm.customerData.autopay_log }}</p><p ng-show="vm.customerData.autopay_log && !vm.autopay_checked">{{ vm.customerData.autopay_log }}</p><p style="font-size: 10px; color: #7F9DCD">In the event your card is not charged due to technical issues on our end<br>your card will be manually charged at a later date.</p></div><span ng-class="{ \'opacity-50 no-pointer-events\': !vm.autopay_checked }" style="margin-left: auto; display: inline-flex"><div style="padding-top: 8px; margin-right: 8px">Autopay on:</div><div class="custom-selectbox"><select ng-class="{ \'no-pointer-events\': vm.autopay_by_date_processing }" class="selectpicker select-box-padding-tiny" style="color: inherit; width: 172px" ng-model="vm.autopay_by_date" ng-change="vm.changeAutopayDate()"><option value="Invoice date" ng-selected="vm.autopay_by_date == \'Invoice Date\'">Invoice Date</option><option value="Due date" ng-selected="vm.autopay_by_date == \'Due Date\'">Due Date</option></select></div></span></div><div class="flex-column" style="margin-top: 8px"><div class="flex-row" style="align-items: center; margin-top: 16px" ng-repeat="card in vm.payment.cards"><div class="flex-column" style="width: 67px; margin-right: 8px"><i class="fa {{ vm.payment.cardBrands[card.card_brand] }}" style="font-size: 52px"></i></div><div class="flex-column" style="justify-content: space-between; height: 46px"><div class="flex-row" style="color: #27ae60; font-family: OpenSans-Semibold; white-space: nowrap">{{ vm.payment.squareCardToName[card.card_brand] }} **** {{ card.last_4 }}</div><div class="flex-row" style="color: #3d5269; font-family: OpenSans-Light; white-space: nowrap; font-size: 12px">Expiry date: {{ ("00"+card.exp_month).slice(-2) }}/{{ card.exp_year }}</div></div><div class="flex-row" style="justify-content: flex-end"><div ng-show="card.is_primary" style="display: flex; justify-content: center; align-items: center; height: 24px; width: 114px; background-color: #eff5fb; color: #3d5269; border-radius: 56px; font-family: OpenSans-Semibold">Primary Card</div><div ng-show="!card.is_primary" ng-click="vm.payment.updatePrimaryCard(card.id)" style="display: flex; justify-content: center; align-items: center; width: 131px;font-family: OpenSans-Semibold; color: #2d9cdb">Set as primary card</div></div><div class="flex-row" style="width: 86px"><span ng-if="false" class="edit-icon" style="height: 14px"></span> <span class="trash-icon" ng-click="vm.deleteCard(card)" style="margin-left: auto; height: 14px; width: 18px"></span></div></div></div><div style="display: flex; flex-direction: column; margin-top: 24px"><div><button id="add-payment-method" ng-click="vm.payment_methods.addPaymentMethod()"><div>Add Payment Method</div><div><i class="fa fa-plus"></i></div></button></div></div></div></div><div ng-show="vm.activeTab.payment_history"><div class="bigbox" style="display: flex; flex-direction: column; margin-top: 16px; box-shadow: none !important; border-radius: 0 !important"><div class="flex-row" style="justify-content: flex-end; margin-bottom: 10px"><button ng-class="{ \'no-pointer-events btnPrimaryCancel\': !vm.payment_history.any_invoices_checked }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.printSelectedPaymentReceipts()"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp;Print Selected Reports</button> <button ng-class="{ \'no-pointer-events btnPrimaryCancel\': !vm.payment_history.any_invoices_checked }" class="btnPrimaryWhite" style="height: unset; padding: 4px 8px; margin-right: 16px" ng-click="vm.downloadSelectedPaymentReceipts()"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Selected Reports</button> <button class="btnPrimaryWhite" style="height: unset; padding: 4px 8px" ng-click="vm.payment_history.open_filters = !vm.payment_history.open_filters"><i class="fa fa-sliders"></i>&nbsp;&nbsp;&nbsp;{{\'Filters\' | translate}}</button></div><div><div class="flex-column" ng-show="vm.payment_history.open_filters" style="width: 100%; padding: 20px 0; border-bottom: 1px solid #DFEAF7; margin-bottom: 20px"><div class="flex-row" style="justify-content: space-between; margin-bottom: 20px"><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Payment Date Range</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" placeholder="Payment date lower limit" ng-model="vm.payment_history.filters.payment_date_lower" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.payment_history.date_picker.payment_date_lower" ng-click="vm.payment_history.date_picker.payment_date_lower = true"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" placeholder="Payment date upper limit" ng-model="vm.payment_history.filters.payment_date_upper" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" is-open="vm.payment_history.date_picker.payment_date_upper" ng-click="vm.payment_history.date_picker.payment_date_upper = true"></div></div></div><div class="flex-row" style="width: 48%; justify-content: center; align-items: center"><div class="flex-column"><div class="flex-row" style="align-items: center; font-size: 13px; font-family: OpenSans-Semibold; margin-bottom: 10px; color: #3D5269"><label style="white-space: nowrap; margin-bottom: 0">Payment Amount Range ($)</label></div><div class="flex-row" style="justify-content: center; align-items: center"><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Payment amount lower limit" ng-model="vm.payment_history.filters.payment_amount_lower"><div style="width: 60px; text-align: center">-</div><input class="payment-methods-input" style="margin-top: 0" type="number" placeholder="Payment amount upper limit" ng-model="vm.payment_history.filters.payment_amount_upper"></div></div></div></div><div class="flex-row" style="height: 30px; align-items: right; justify-content: flex-end"><button class="btnPrimaryCancel" style="height: unset; margin-right: 16px" ng-click="vm.payment_history.open_filters = false">{{\'Close\' | translate}}</button> <button class="btnPrimaryWhite" style="height: unset; margin-right: 16px" ng-click="vm.payment_history.clearFilters()">Clear Filters</button> <button class="btnPrimaryBlue" style="height: unset" ng-click="vm.payment_history.query(true)">{{\'Apply Filters\' | translate}}</button></div></div><table id="payments-table"><thead style="color: #2D9CDB; font-family: OpenSans-Semibold"><tr><th><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="vm.payment_history.all_payments_checked" ng-change="vm.payment_history.checkAll()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></th><th ng-click="vm.generic.changeSort(vm.payment_history, \'id\')"><div class="flex-row flex-center"><div>Payment No.</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'id\' && vm.payment_history.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'id\' && vm.payment_history.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.payment_history, \'payment_date\')"><div class="flex-row flex-center"><div>Payment Date</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'payment_date\' && vm.payment_history.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'payment_date\' && vm.payment_history.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.payment_history, \'payment_type\')"><div class="flex-row flex-center"><div>Payment method</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'payment_type\' && vm.payment_history.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'payment_type\' && vm.payment_history.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th ng-click="vm.generic.changeSort(vm.payment_history, \'amount\')"><div class="flex-row flex-center"><div>Payment amount</div><div class="flex-column" style="height: 20px; justify-content: center; padding-left: 8px; color: #3D5269"><i class="fa fa-caret-up" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'amount\' && vm.payment_history.sort_filters.order == \'asc\'}" style="height: 10px"></i> <i class="fa fa-caret-down" ng-class="{\'invisible\' : vm.payment_history.sort_filters.field == \'amount\' && vm.payment_history.sort_filters.order == \'desc\'}" style="height: 10px; margin-bottom: 5px"></i></div></div></th><th>Actions</th></tr></thead><tbody ng-if="vm.payment_history.payments.length > 0"><tr ng-repeat="payment in vm.payment_history.payments" style="padding: 8px 0px; border-top: 1px solid #DFEAF7; border-bottom: 1px solid #DFEAF7"><td><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-checked="payment.cheked" ng-model="payment.checked" ng-change="vm.payment_history.checkedInvoices()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></td><td class="text-yellow"><a ui-sref="payment-details({paymentId: payment.id})">{{ payment.id }}</a></td><td>{{ payment.payment_date | date : \'MM/dd/yyyy\' }}</td><td>{{ payment.payment_type }}</td><td>&#36;{{ payment.amount ? (payment.amount.toFixed(2) | number : 2) : \'\' }}</td><td><i ng-click="vm.downloadPaymentReceipt(payment.id)" class="fa fa-download" style="margin-right: 16px; color: #607e9f"></i> <i ng-click="vm.printPaymentReceipt(payment.id)" class="fa fa-print" style="color: #607e9f"></i></td></tr></tbody></table><div class="flex-column" ng-if="vm.payment_history.payments.length == 0"><div class="flex-row" style="justify-content: center; align-items: center; margin-top: 135px; color: #3D5269">No Payments Recevied</div></div></div></div><div class="page-list"><div class="mobile-box-pagination" style="display: flex; justify-content: space-between"><div class="custom-selectbox"><select class="selectpicker select-box-padding-tiny" ng-model="vm.payment_history.base_filters.size" ng-change="vm.payment_history.query(true)"><option value="10">10</option><option value="20" ng-selected="true">20</option><option value="50">50</option></select></div><uib-pagination ng-show="vm.payment_history.base_filters.size < vm.payment_history.total_items" class="pagination pageset" total-items="vm.payment_history.total_items" items-per-page="vm.payment_history.base_filters.size" ng-model="vm.payment_history.page_plus_one" ng-change="vm.payment_history.query(false)"></uib-pagination></div></div></div><div ng-show="vm.payment_methods.show_tab"><div class="flex-row" style="margin: 24px 0px; color: #3d5269; font-size: 24px; font-weight: 400">Add a new payment method</div><div class="flex-column" style="color: #3d5269; width: 540px; border-radius: 6px; background: white; padding: 32px"><div id="card-container" style="width: 480px"></div><div style="display: grid; grid-template-columns: repeat(3, 1fr)"><div class="flex-row" style="margin-top: 8px"><span ng-show="!vm.payment.cards"><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="vm.new_card_autopay_checkbox"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label><span style="color: #3d5269; margin-left: 23px">Autopay</span></span></div><button ng-click="vm.payment_methods.cancelPaymentMethod()" class="payment-methods-nav-btn payment-methods-light-btn" style="margin-right: 16px">CANCEL</button> <button id="card-button" class="payment-methods-nav-btn payment-methods-gray-btn">SAVE</button></div><div style="font-size: 18px; font-family: OpenSans-Bold; display: none">Payment Information</div><div class="flex-column" style="height: 100%; display: none"><div class="flex-row" style="margin-top: 40px"><div class="flex-column" style="height: 66px; width: 572px; margin-right: 16px"><div class="flex-row" style="font-family: OpenSans-Semibold">Cardholder Name<span style="color: #b8c2cc; font-family: OpenSans-Semibold">&nbsp;(as it appears on card)</span></div><div class="flex-row"><input type="text" placeholder="Enter cardholder name" class="payment-methods-input" ng-model="vm.payment.cardHolder"></div></div></div><div class="flex-row" style="margin-top: 24px"><div class="flex-column" style="height: 66px; width: 572px; margin-right: 16px"><div class="flex-row" style="font-family: OpenSans-Semibold">Card Number</div><div class="flex-row"><input id="sq-card-number" class="payment-methods-input"></div></div></div><div class="flex-row" style="margin-top: 24px"><div class="flex-row" style="height: 66px; width: 572px; margin-right: 16px"><div class="flex-column" style="margin-right: 16px"><div class="flex-row" style="font-family: OpenSans-Semibold">Expiration Date</div><div class="flex-row"><input id="sq-expiration-date" class="payment-methods-input"></div></div><div class="flex-column" style="margin-right: 16px"><div class="flex-row" style="font-family: OpenSans-Semibold">CVV</div><div class="flex-row"><input id="sq-cvv" class="payment-methods-input"></div></div><div class="flex-column"><div class="flex-row" style="font-family: OpenSans-Semibold">Zip Code</div><div class="flex-row"><input id="sq-zip-code" class="payment-methods-input"></div></div></div></div><div class="flex-row" style="margin-top: 24px"><span><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-checked="vm.make_primary_payment_method" ng-click="vm.payment.toggleMakePrimary()"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label><span style="color: #3d5269; margin-left: 23px">Make this my primary payment method</span></span></div><div ng-show="!vm.payment.cards" class="flex-row" style="margin-top: 24px"><span><label style="display: inline-block" class="checkboxContainer"><input class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-model="vm.new_card_autopay_checkbox"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label><span style="color: #3d5269; margin-left: 23px">Autopay</span></span></div><div class="flex-row" style="justify-content: flex-start; margin-top: auto"><button ng-click="vm.payment_methods.cancelPaymentMethod()" class="payment-methods-nav-btn payment-methods-light-btn" style="margin-right: 16px">CANCEL</button> <button ng-click="vm.saveCardFromFrontEnd($event)" class="payment-methods-nav-btn payment-methods-gray-btn">SAVE</button></div></div></div></div></div><!-- ACH payments when being directed to plaid Modal --><div id="infoModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><div class="logo-image"><img src="/content/brand/logo.png" alt="portal logo" class="img-responsive modal-brand-logo"></div><div><h4 class="modal-title align-center">Pay Balance via ACH</h4><p>You will be redirected to Plaid to make the connection to your bank account to pay by ACH, You will need to login to your bank to do this.</p></div></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/pages/notifications/notifications.html','<div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid"><div class="row position-tbl-responsive-control"><div class="col-lg-12 col-md-12 statuslist"><div class="notifications-row pull-right"><button class="btn btn-white" ng-click="markAllAsRead()">Mark All as Read</button> <button class="btn btn-settings" ng-click="notificationSettings()"><i class="fa fa-cog"></i></button></div><p class="select-title-box">Filter results by:</p><ui-select ng-model="selected.value" class="select-option-box" ng-change="vm.setFilter(selected.value)"><ui-select-match><span ng-bind="$select.selected.name"></span></ui-select-match><ui-select-choices repeat="item in (itemArray | filter: $select.search) track by item.id"><span ng-bind="item.name" style="color: #2d4760"></span></ui-select-choices></ui-select></div></div></div></div><div class="tabbackall tabbackall3 tabbackal4"><div class="tab-content tabback" ng-switch on="vm.customerData.businessType.id"><div class="bigbox box-shadow-table res-box-height notification-page"><ul class="notification-list"><div ng-repeat="notification in allNotifications track by notification.id " ng-switch="notification.notificationOrigin"><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="ORDER_PLACED"><div bind-html-compile="notification.web1Description"></div></li><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="RESULTS_COMPLETED"><div bind-html-compile="notification.web1Description"></div></li><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="SAMPLE_RECEIVED"><div bind-html-compile="notification.web1Description"></div></li><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="PRELIMINARY_RESULTS"><div bind-html-compile="notification.web1Description"></div></li><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="INVOICE_AVAILABLE"><div bind-html-compile="notification.web1Description"></div></li><li ng-class="notification.notificationRead ? \'\' : \'unread-li\' " ng-switch-when="PAYMENT_RECEIVED"><div bind-html-compile="notification.web1Description"></div></li></div></ul></div><div class="page-list"><div class="pull-left mobile-box-pagination" ng-if="(vm.itemsPerPage * 1) < (vm.totalItems* 1)"><uib-pagination class="pagination pageset" total-items="vm.queryCount" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="statuslist mobile-box-statuslist"><div class="custom-selectbox"><select id="lunch4" class="selectpicker select-box-padding-tiny" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="5">5</option><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div></div></div></div></div></div>');
$templateCache.put('app/pages/order-details/order-details.html','<div class="content-wrapper-x content-page-height"><form role="form" novalidate><div class="modal-header" style="background-color: white; height: 60px"><div style="vertical-align: middle"><button type="button" class="btn-sample-csv pull-left fullbtnsmall hover-btn-blue" style="margin-left: 20px; width: 162px !important; font-family: OpenSans-Semibold" ui-sref="orders"><i class="fa fa-arrow-left" style="margin-right: 10px"></i> Back to Order List</button> <button id="invoiceBtn" type="button" ng-if="invoiceBtnToggle" class="pull-right pullright5 btn" ui-sref="invoice-details({id: vm.customerOrder.invoices[0].id})"><i class="fa fa-file-text icon-margin"></i>Invoice No. {{vm.customerOrder.invoices[0].custom_formated_id}}</button></div></div><div><div class="tabbackall tabbackall10" style="max-width: 70%; margin: auto; background-color: #eff5fb"><div class="tabback tabback36 popuptabelist tab-content-786" id="unset-768"><div class="file-status" style="background-color: rgb(237,243,250) !important"><!--progress 1--><div ng-show="vm.progress == 1" class="row status-wizard" style="background-color: #eff5fb !important"><div class="col-xs-3 status-wizard-step active"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus1">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\' }}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Sample Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus2">2 <span>Sample Received</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus3">3 <span>Preliminary Result</span></a></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus4">4 <span>{{\'Completed\' | translate}}</span></a></div></div><!--progress 2--><div ng-show="vm.progress == 2" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a></div></div><!--progress 3--><div ng-show="vm.progress == 3" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div></div><!--progress 4--><div ng-show="vm.progress == 4" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCompleted | date:\'MM/dd/yyyy\'}}</div></div></div><!--progress 5--><div ng-show="vm.progress == 5" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order<br>Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Sample<br>Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary<br>Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span><br>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCompleted | date:\'MM/dd/yyyy\'}}</div></div></div></div><div class="topbuffer3" id="unset-768"></div></div><div class="tables"><div class="center clearfix"><div class="col-md-12 col-table-slider-orders-popup"><div class="row"><div class="col-md-5 col-left-info-slider"><table class="table table-bordered tbl orders-popup-tbl"><tbody><tr><td style="background-color: #eff5fb" colspan="2" class="text-left-side tbl-right">Submitted By <span>{{vm.customerOrder.submissionContact}}</span></td></tr><tr><td style="background-color: #eff5fb" class="text-left-side tbl-right">Turnaround Time</td><td style="background-color: #eff5fb" class="text-right-side">{{vm.customerOrder.turnaroundTimeLabel}}</td></tr><tr><td style="background-color: #eff5fb" class="text-left-side tbl-right">Due Date</td><td style="background-color: #eff5fb" class="text-right-side">{{ vm.due_date_info.same_for_all ? (vm.due_date_info.due_date | date:\'MM/dd/yyyy\' : \'UTC\') : \'Various\' }}</td></tr><tr><td style="background-color: #eff5fb" class="text-left-side tbl-right">Purchase Order</td><td style="background-color: #eff5fb" class="text-right-side">{{vm.customerOrder.poNumber}}</td></tr><tr ng-if="vm.customerOrder.manufacturingAddress"><td style="background-color: #eff5fb" class="text-left-side tbl-right">Manufacturing Address</td><td style="background-color: #eff5fb; white-space: pre-line" class="text-right-side">{{vm.customerOrder.manufacturingAddress}}</td></tr><tr><td colspan="2" style="background-color: #eff5fb"><div class="col-xs-4 no-padding-left"><button ng-if="!vm.customerOrder.attachments" ng-click="getOrderAttachments (vm.customerOrder,vm.customerOrder.id)" class="btn btn-primary" style="font-family: OpenSans-Semibold">Downloads &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i></button><div class="select-wrapper" style="width: 150px" ng-if="vm.customerOrder.attachments"><select id="lunch" class="selectpicker select-box-table table_select" data-live-search="true" title="Select" ng-model="vm.customerOrder.select" ng-change="downloadOrderAttachment(vm.customerOrder.select,vm.customerOrder)" value="select"><option value="" ng-if="!vm.customerOrder.attachments.length < 1 ">{{\'Select\' | translate}}</option><option value="" ng-if="vm.customerOrder.attachments.length < 1 ">Empty</option><option ng-repeat="attach in vm.customerOrder.attachments track by attach.id" value="{{attach.hash}}" ng-click="downloadOrderAttachment(vm.customerOrder.select,vm.customerOrder)">{{attach.file_name}}</option></select></div></div></td></tr></tbody></table></div><div class="col-md-7 col-carousel"><div id="Carousel" class="carousel slide" data-interval="false"><div class="carousel-inner"><div class="item active"><img ng-src="{{vm.pictures[0].url}}" class="img-responsive"></div><div ng-if="$index !== 0" class="item" ng-repeat="picture in vm.pictures track by picture.id"><img ng-src="{{picture.url}}" class="img-responsive"></div></div><span class="left carousel-control slider-arrow slider-arrowprev ng-hide" ng-show="vm.show" data-target="#Carousel" data-slide="prev"></span> <span class="right carousel-control slider-arrow slider-arrownext ng-hide" ng-show="vm.show" data-target="#Carousel" data-slide="next"></span></div></div></div></div></div></div></div><div class="tabbackall tabbackall10 clearfix mt-30" style="max-width: 85%; margin: auto; background-color: #eff5fb"><div class="tabback orders-dialog-table"><div class="bigbox box-shadow-table table-height"><div class="table-responsive table-text-left res-data-table view-invo-table"><table class="table table-bordered tablesaw-stack tablesaw-sortable tablesaw tablesaw-swipe" data-tablesaw-sortable="" data-tablesaw-sortable-switch="" data-tablesaw-mode="swipe" data-tablesaw-minimap="" id="tablesaw-1431"><thead><tr><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Sample ID</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Sample Description</button></th><th ng-if="vm.hasLotNumbers" data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Lot Number</button></th><th ng-if="!vm.due_date_info.same_for_all" data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Due Date</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Analysis</button></th><th class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn tablesaw-sortable-btnlast">Downloads</button></th></tr></thead><tbody><tr ng-repeat="sample in vm.customerOrder.samples track by sample.id"><td class="text-yellow"><a ng-click="vm.clear()" ui-sref="public({hash:sample.hash})">{{sample.id}}</a></td><td>{{sample.name}}</td><td ng-if="vm.hasLotNumbers">{{ sample.lotBatchNumber }}</td><td ng-if="!vm.due_date_info.same_for_all"><span ng-repeat="test in sample.sampleTests track by test.id">{{ test.estimatedCompleteDate | date:\'MM/dd/yyyy\' : \'UTC\' }}<br></span></td><td><span ng-if="!sample.panel" ng-repeat="test in sample.sampleTests track by test.id"><span ng-if="test.assay.portalIdentifier != \'CONSULTING\'">{{ test.assay.title }} <span ng-if="test.state != \'COMPLETED\' && test.estimatedCompleteDate" style="color: #8795a1; font-size: 12px">({{ test.estimatedCompleteDate | date:\'MM/dd/yyyy\' : \'UTC\' }})</span> </span><span ng-if="test.assay.portalIdentifier == \'CONSULTING\'" class="spanDataAddress">{{ test.assay.title }} <span ng-if="test.state != \'COMPLETED\' && test.estimatedCompleteDate" style="color: #8795a1; font-size: 12px">({{ test.estimatedCompleteDate | date:\'MM/dd/yyyy\' : \'UTC\' }})</span> <a class="ss-tooltips"><i class="fa fa-info-circle" aria-hidden="true"></i> <span style="padding: 15px !important; line-height: 25px; width: 200px; opacity: 1 !important; color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important"><ul style="display: block"><li ng-repeat="requested_analysis in test.comments">\u2022 {{ requested_analysis }}</li></ul></span></a></span><br></span><span ng-if="sample.panel">{{ sample.panel.title }} <span ng-repeat="test in sample.sampleTests"><span ng-if="!test.panel"><br>{{ test.assay.title }}<span ng-if="test.state != \'COMPLETED\' && test.estimatedCompleteDate" style="color: #8795a1; font-size: 12px"> ({{ test.estimatedCompleteDate | date:\'MM/dd/yyyy\' : \'UTC\' }})</span></span></span></span></td><td class="select-box-btn load-btn"><div ng-if="!sample.attachments"><a class="btn btn-sm btn-load btn-success select-loader" ng-click="getAttachments (sample,sample.id)"><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;Load<div ng-if="vm.getAttachmentsLoader && vm.idOfSelectedSample == sample.id" class="loader"><i class="fa fa-refresh" aria-hidden="true"></i></div></a></div><div class="select-wrapper" ng-if="sample.attachments" style="margin: 0"><select id="lunch" class="selectpicker select-box-table table_select" ng-click="getAttachments (sample,sample.id)" data-live-search="true" title="Select" ng-model="sample.select" ng-change="downloadAttachment(sample.select,sample)" value="select"><option value="" ng-if="!sample.attachments.length < 1 ">{{\'Select\' | translate}}</option><option value="" ng-if="sample.attachments.length < 1 ">Empty</option><option ng-repeat="attach in sample.attachments track by attach.id" value="{{attach.hash}}" ng-click="downloadAttachment(sample.select,sample)">{{attach.file_name}}</option><option ng-if="(vm.consolidated_business_type.includes(\'cannabis\') || vm.consolidated_business_type.includes(\'hemp\')) && sample.canSeeReport && vm.showReports" value="coa">{{ sample.id }}_COA_Summary.pdf</option></select></div></td></tr></tbody></table></div></div></div></div></div></form></div><script src="app/pages/sample-log/slider.js"></script>');
$templateCache.put('app/pages/orders/orders-dialog-old.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><div class=""><div class="topbuffer1"></div><h2 class="modal-title pull-left samplemodaltitle newsamplepopup">Order {{vm.customerOrder.name}} #{{vm.customerOrder.id}}</h2><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i></div></div><div class="modal-body tabbackall20"><div class="tabbackall tabbackall10"><div class="tabback tabback36 popuptabelist tab-content-786" id="unset-768"><div class="file-status"><!--progress 1--><div ng-show="vm.progress == 1" class="row status-wizard"><div class="col-xs-3 status-wizard-step active"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus1">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\' }}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Sample Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus2">2 <span>Sample Received</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus3">3 <span>Preliminary Result</span></a></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus4">4 <span>{{\'Completed\' | translate}}</span></a></div><!--                           <div class="col-xs-2 status-wizard-step disable">active\r\n                            <div class="text-center status-wizard-stepnum">Invoiced</div>\r\n                            <div class="status-progress"><div class="status-progress-bar"></div></div>\r\n                            <a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus5">5 <span>Invoiced</span></a>\r\n                              <div class="status-wizard-info text-center"></div>\r\n                          </div> --></div><!--progress 2--><div ng-show="vm.progress == 2" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a></div><!--                             <div class="col-xs-2 status-wizard-step disable">active\r\n                              <div class="text-center status-wizard-stepnum">Invoiced</div>\r\n                              <div class="status-progress"><div class="status-progress-bar"></div></div>\r\n                              <a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">5 <span>Invoiced</span></a>\r\n\r\n                            </div> --></div><!--progress 3--><div ng-show="vm.progress == 3" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div></div><!--                           <div class="col-xs-2 status-wizard-step disable">active\r\n                            <div class="text-center status-wizard-stepnum">Invoiced</div>\r\n                            <div class="status-progress"><div class="status-progress-bar"></div></div>\r\n                            <a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">5 <span>Invoiced</span></a>\r\n\r\n                          </div> --></div><!--progress 4--><div ng-show="vm.progress == 4" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Samples Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCompleted | date:\'MM/dd/yyyy\'}}</div></div><!--                           <div class="col-xs-2 status-wizard-step disable">active\r\n                            <div class="text-center status-wizard-stepnum">Invoiced</div>\r\n                            <div class="status-progress"><div class="status-progress-bar"></div></div>\r\n                            <a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">5 <span>Invoiced</span></a>\r\n                              <div class="status-wizard-info text-center">{{\'In Progress\' | translate}}</div>\r\n                          </div> --></div><!--progress 5--><div ng-show="vm.progress == 5" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">Order Created</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>Order<br>Created</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCreated | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Samples Received</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>Sample<br>Received</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateReceived | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">Preliminary Result</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>Preliminary<br>Result</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.datePreliminaryResults | date:\'MM/dd/yyyy\'}}</div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span><br>{{\'Completed\' | translate}}</span></a><div class="status-wizard-info text-center">{{vm.customerOrder.dateCompleted | date:\'MM/dd/yyyy\'}}</div></div><!--                           <div class="col-xs-2 status-wizard-step active">active\r\n                            <div class="text-center status-wizard-stepnum">Invoiced</div>\r\n                            <div class="status-progress"><div class="status-progress-bar"></div></div>\r\n                            <a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">5 <span><br>Invoiced</span></a>\r\n                              <div class="status-wizard-info text-center">{{vm.customerOrder.dateInvoiced | date:\'MM/dd/yyyy\'}}</div>\r\n                          </div> --></div></div><div class="topbuffer3" id="unset-768"></div></div><div class="tables"><div class="center clearfix"><div class="col-md-12 col-table-slider-orders-popup"><div class="row"><div class="col-md-5 col-left-info-slider"><table class="table table-bordered tbl orders-popup-tbl"><tbody><tr><td colspan="2" class="text-left-side tbl-right">Submitted By <span>{{vm.customerOrder.submissionContact}}</span></td></tr><tr><td class="text-left-side tbl-right">Turnaround Time</td><td class="text-right-side">{{vm.customerOrder.turnaroundTimeLabel}}</td></tr><tr><td class="text-left-side tbl-right">Est. Completion Date</td><td class="text-right-side">{{vm.customerOrder.dateRequired | date:\'MM/dd/yyyy\'}}</td></tr><tr><td class="text-left-side tbl-right">Purchase Order</td><td class="text-right-side">{{vm.customerOrder.poNumber}}</td></tr><!-- \r\n                                      <tr ng-click="vm.downloadOrderPdf()">\r\n                                          <td colspan="2" class="text-left-side tbl-right">\r\n                                            <a href="javascript:void(0)" style="color: #2a9ecf">Generate Submission Form</a>\r\n                                            <i class="fa fa-file-pdf-o" aria-hidden="true" style="float: right; font-size: 16px;"></i>\r\n                                          </td>\r\n                                      </tr> --><tr><td colspan="2"><div class="col-xs-4 no-padding-left"><button ng-if="!vm.customerOrder.attachments" ng-click="getOrderAttachments (vm.customerOrder,vm.customerOrder.id)" class="btn btn-primary">Downloads &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-angle-down" aria-hidden="true"></i></button><div class="select-wrapper" style="width: 150px" ng-if="vm.customerOrder.attachments"><select id="lunch" class="selectpicker select-box-table table_select" data-live-search="true" title="Select" ng-model="vm.customerOrder.select" ng-change="downloadOrderAttachment(vm.customerOrder.select,vm.customerOrder)" value="select"><option value="" ng-if="!vm.customerOrder.attachments.length < 1 ">{{\'Select\' | translate}}</option><option value="" ng-if="vm.customerOrder.attachments.length < 1 ">Empty</option><option ng-repeat="attach in vm.customerOrder.attachments track by attach.id" value="{{attach.hash}}" ng-click="downloadOrderAttachment(vm.customerOrder.select,vm.customerOrder)">{{attach.file_name}}</option></select></div></div></td></tr></tbody></table></div><div class="col-md-7 col-carousel"><div id="Carousel" class="carousel slide" data-interval="false"><div class="carousel-inner"><div class="item active"><img ng-src="{{vm.pictures[0].url}}" class="img-responsive"></div><div ng-if="$index !== 0" class="item" ng-repeat="picture in vm.pictures track by picture.id"><img ng-src="{{picture.url}}" class="img-responsive"></div></div><span class="left carousel-control slider-arrow slider-arrowprev ng-hide" ng-show="vm.show" data-target="#Carousel" data-slide="prev"></span> <span class="right carousel-control slider-arrow slider-arrownext ng-hide" ng-show="vm.show" data-target="#Carousel" data-slide="next"></span></div></div></div></div></div></div><div class="tabbackall clearfix mt-30"><div class="tabback orders-dialog-table"><div class="bigbox box-shadow-table table-height"><div class="table-responsive table-text-left res-data-table view-invo-table"><table class="table table-bordered tablesaw-stack tablesaw-sortable tablesaw tablesaw-swipe" data-tablesaw-sortable="" data-tablesaw-sortable-switch="" data-tablesaw-mode="swipe" data-tablesaw-minimap="" id="tablesaw-1431"><thead><tr><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Sample ID</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Sample Description</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Lot Number</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Analysis</button></th><th class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn tablesaw-sortable-btnlast">Downloads</button></th></tr></thead><tbody><tr ng-repeat="sample in vm.customerOrder.samples track by sample.id"><td class="text-yellow"><a ng-click="vm.clear()" ui-sref="public({hash:sample.hash})">{{sample.id}}</a></td><td>{{sample.name}}</td><td>{{ sample.lotBatchNumber }}</td><td><span ng-if="!sample.panel" ng-repeat="test in sample.sampleTests track by test.id"><span>{{test.assay.title}}</span><br></span><span ng-if="sample.panel">{{ sample.panel.title }} <span ng-repeat="test in sample.sampleTests"><span ng-if="!test.panel"><br>{{ test.assay.title }}</span></span></span></td><td class="select-box-btn load-btn"><div ng-if="!sample.attachments"><a class="btn btn-sm btn-load btn-success select-loader" ng-click="getAttachments (sample,sample.id)"><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;Load<div ng-if="vm.getAttachmentsLoader && vm.idOfSelectedSample == sample.id" class="loader"><i class="fa fa-refresh" aria-hidden="true"></i></div></a></div><div class="select-wrapper" ng-if="sample.attachments" style="margin: 0"><select id="lunch" class="selectpicker select-box-table table_select" ng-click="getAttachments (sample,sample.id)" data-live-search="true" title="Select" ng-model="sample.select" ng-change="downloadAttachment(sample.select,sample)" value="select"><option value="" ng-if="!sample.attachments.length < 1 ">{{\'Select\' | translate}}</option><option value="" ng-if="sample.attachments.length < 1 ">Empty</option><option ng-repeat="attach in sample.attachments track by attach.id" value="{{attach.hash}}" ng-click="downloadAttachment(sample.select,sample)">{{attach.file_name}}</option></select></div></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer orders-dialog-modal-footer"></div></form><script src="app/pages/sample-log/slider.js"></script>');
$templateCache.put('app/pages/orders/orders.html','<style>.filters-div input::-webkit-outer-spin-button,\n\t.filters-div input::-webkit-inner-spin-button {\n\t    /* display: none; <- Crashes Chrome on hover */\n\t    -webkit-appearance: none;\n\t    margin: 0; /* <-- Apparently some margin are still there even though it\'s hidden */\n\t}\n\t.uib-datepicker-popup.dropdown-menu {\n\t\tleft: auto !important;\n    }\n\n\t#table>tbody>tr>td {\n\t\tpadding: 10px 0!important;\n    }</style><div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid"><div class="row position-tbl-responsive-control"><div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 statuslist2"><!-- <p>{{\'Number of entries\' | translate}}: {{vm.totalItems}}</p> --></div><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 statuslist statuslist1"><div id="btn-sample-filters" class="sample-log-btn-div"><button ng-class="vm.activeWidget === \'orderEditFilters\' ? \'btn-active\' : \'\'" ng-click="vm.toggleWidget(\'orderEditFilters\')" type="button" class="sample-log-btn pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue"><i class="fa fa-sliders"></i>&nbsp; {{\'Filters\' | translate}} <span ng-show="vm.totalFilters > 0">({{vm.totalFilters}})</span> <i class="fa fa-caret-down"></i></button></div><div class="custom-selectbox margin-right-15 mgTop7"><select id="pageCount" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10" selected="selected">10</option><option value="20">20</option><option value="50">50</option></select></div></div><!-- Table dots --><div class="tbl-responsive-control"><ul class="tbl-dots"></ul><div class="control-buttons"><div class="control-buttons"><button class="prev btn-controls" id="col-prev" disabled="disabled"></button> <button class="next btn-controls" id="col-next"></button></div></div></div><!--./ Table dots --><div style="clear:both"></div><div ng-show="vm.activeWidget === \'orderEditFilters\'" class="row tabbackall filters-div" style="border-top: 1px solid #e6ebf0; margin-top: 8px; padding-top: 8px; padding-right: 8px"><div class="col-md-12"><div class="pull-right" style="padding-right: 12px" ng-click="vm.toggleWidget(\'orderEditFilters\')">\xD7</div></div><div class="col-md-12"><table class="filters-table"><tr><td class="filter-column"><div class="form"><label>{{\'Order No.\' | translate}}</label><input type="number" placeholder="Enter Number" class="filter-input" ng-model="vm.orderFilters.id"></div></td><td class="filter-column"><div class="form"><label>{{\'# of Samples\' | translate}}</label><input type="number" placeholder="Enter number" class="filter-input" ng-model="vm.orderFilters.sampleCount"></div></td><td class="filter-column"><div class="form"><label>{{\'Turnaround Time\' | translate}}</label><div class="row"><div class="col-md-6"><div><input id="orderFilterTAT1Day" type="checkbox" class="css-checkbox" ng-model="vm.listFilters[\'1 day (rush)\'].selected" ng-change="vm.toggleListFilter(\'turnaroundTimes\')"><label for="orderFilterTAT1Day" class="css-label">1 day</label></div><div><input id="orderFilterTAT2Day" type="checkbox" class="css-checkbox" ng-model="vm.listFilters[\'2 day (rush)\'].selected" ng-change="vm.toggleListFilter(\'turnaroundTimes\')"><label for="orderFilterTAT2Day" class="css-label">2 day</label></div><div><input id="orderFilterTAT3Day" type="checkbox" class="css-checkbox" ng-model="vm.listFilters[\'3 day (rush)\'].selected" ng-change="vm.toggleListFilter(\'turnaroundTimes\')"><label for="orderFilterTAT3Day" class="css-label">3 day</label></div></div><div class="col-md-6"><div><input id="orderFilterTAT4Day" type="checkbox" class="css-checkbox" ng-model="vm.listFilters[\'4-5 day (standard)\'].selected" ng-change="vm.toggleListFilter(\'turnaroundTimes\')"><label for="orderFilterTAT4Day" class="css-label">4-5 day</label></div><div><input id="orderFilterTATOther" type="checkbox" class="css-checkbox" ng-model="vm.listFilters[\'TATOther\'].selected" ng-change="vm.toggleListFilter(\'turnaroundTimes\')"><label for="orderFilterTATOther" class="css-label">{{\'Other\' | translate}}</label></div></div></div></div></td><td class="filter-column"><div class="form"><label>{{\'Receive Date Range\' | translate}}:</label><div class="filter-input-date"><input class="filter-input" placeholder="Start Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.orderFilters.dateReceivedLower" is-open="vm.datePickerOpenStatus.orderFilterDateReceivedLower" ng-click="vm.openCalendar(\'orderFilterDateReceivedLower\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'orderFilterDateReceivedLower\')"></i></div><div class="filter-input-date"><input class="filter-input" placeholder="End Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.orderFilters.dateReceivedUpper" is-open="vm.datePickerOpenStatus.orderFilterDateReceivedUpper" ng-click="vm.openCalendar(\'orderFilterDateReceivedUpper\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'orderFilterDateReceivedUpper\')"></i></div></div></td><td class="filter-column"><div class="form"><label>{{\'Status\' | translate}}:</label><div><input id="orderFilterStateCreated" type="checkbox" class="css-checkbox" ng-model="vm.listFilters.CREATED.selected" ng-change="vm.toggleListFilter(\'states\')"><label for="orderFilterStateCreated" class="css-label order1">{{\'Created\' | translate}}</label></div><div><input id="orderFilterStateSamplesReceived" type="checkbox" class="css-checkbox" ng-model="vm.listFilters.SAMPLES_RECEIVED.selected" ng-change="vm.toggleListFilter(\'states\')"><label for="orderFilterStateSamplesReceived" class="css-label order2">{{\'Samples Received\' | translate}}</label></div><div><input id="orderFilterStatePreliminaryResults" type="checkbox" class="css-checkbox" ng-model="vm.listFilters.PRELIMINARY_RESULTS.selected" ng-change="vm.toggleListFilter(\'states\')"><label for="orderFilterStatePreliminaryResults" class="css-label order3">{{\'Preliminary Results\' | translate}}</label></div><div><input id="orderFilterStateCompletetd" type="checkbox" class="css-checkbox" ng-model="vm.listFilters.COMPLETED.selected" ng-change="vm.toggleListFilter(\'states\')"><label for="orderFilterStateCompletetd" class="css-label order4">{{\'Completed\' | translate}}</label></div></div></td></tr></table></div><div class="col-md-12" style="margin-top: 12px; padding-right: 35px"><div class="pull-right"><button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" ng-click="vm.toggleWidget(\'orderEditFilters\')"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" style="margin-left: 8px" ng-if="vm.getFilterCount() > 0" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle" aria-hidden="true"></i> Clear Filters</button> <button type="button" class="btn btn-primary" style="margin-left: 8px" ng-click="vm.filterSubmit()">{{\'Apply Filters\' | translate}}</button></div></div></div></div></div></div><div class="sub-content"><div class="container-fluid" style="padding-left: 0"><ul class="nav-tabs" role="tablist" style="width: 650px; text-align: center"><li id="total" class="col-sm-3 samplelog-sample-filter filter-active" role="presentation"><a ng-click="vm.switchTab(\'total\')" aria-controls="total_controls" role="presentation" data-toggle="tab">{{\'All Orders\' | translate}} <span>{{ vm.filterCounts.total }}</span></a></li><li id="isInProgress" ng-disabled="vm.filterCounts.isInProgress == 0" ng-class="{\'filter-active\' : vm.filterCounts.isInProgress > 0, \'filter-disabled\' : vm.filterCounts.isInProgress == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'isInProgress\')" aria-controls="isInProgress_controls" role="tab" data-toggle="tab">{{\'In Progress\' | translate}} <span>{{ vm.filterCounts.isInProgress }}</span></a></li><li id="isCompleted" ng-disabled="vm.filterCounts.isCompleted == 0" ng-class="{\'filter-active\' : vm.filterCounts.isCompleted > 0, \'filter-disabled\' : vm.filterCounts.isCompleted == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'isCompleted\')" aria-controls="completed_controls" role="tab" data-toggle="tab">{{\'Completed\' | translate}} <span>{{ vm.filterCounts.isCompleted }}</span></a></li><li id="starred" ng-disabled="vm.filterCounts.starred == 0" ng-class="{\'filter-active\' : vm.filterCounts.starred > 0, \'filter-disabled\' : vm.filterCounts.starred == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'starred\')" aria-controls="starred_controls" role="tab" data-toggle="tab">{{\'Starred\' | translate}} <i class="fa fa-star"></i><span>{{ vm.filterCounts.starred }}</span></a></li></ul></div></div><hr style="margin: 1px 30px"><div class="sub-content"><div style="float:left;line-height: 40px">{{\'Number of entries\' | translate}}: {{vm.totalItems}}</div></div><div ng-show="food_submitting" class="alert alert-warning display-Progress" role="alert"><i class="fa fa-2x fa-spinner fa-spin"></i>&nbsp;&nbsp;&nbsp;<span>Submitting your order...</span></div><div class="tabbackall tabbackall3 tabbackal4"><!-- tabbackall1 --><div class="tab-content tabback"><div class="bigbox box-shadow-table res-box-height"><div class="table-responsive table-text-left res-data-table"><!-- Table Swiper Begin --><!-- Loading indicator - commented out for now since it\'s fast enough\n                    <div ng-if="vm.loadingOrders" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">\n                        <i class="fa fa-spinner fa-spin fa-2x" style="color: #2a9ecf; opacity: 0.7;"></i>\n                    </div>\n                    --><table id="table"><!-- ng-style="vm.loadingOrders && {\'opacity\': \'0.5\'}" --><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" class="tbl-col-1"><span>{{\'Order No.\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="sampleCount" class="tbl-col-2"><span>{{\'# of Samples\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th class="tbl-col-3"><span>{{\'Turnaround Time\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th class="tbl-col-4"><span>{{\'Due Date\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="dateReceived" class="tbl-col-4"><span>{{\'Receive Date\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="state" class="tbl-col-5"><span>{{\'Status\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th class="tbl-col-5"><span class="tablesaw-sortable-btn">{{\'Order Downloads\' | translate}}</span> <span class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle" style="cursor: pointer"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 340px; left: -290px; bottom: 20px; margin-bottom: -5px; max-height: 400px; overflow-y: auto"><svg style="position: absolute; top: 100%" height="20" width="50"><polygon points="20,0 11,10 20,20" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; padding:5px; text-align: left;line-height: 1.2; font-family: OpenSans-Semibold; font-size: 14px;font-weight:700">Order level downloads only contain Chain of Custody and other files applicable to the entire order. COAs, sample images, QR codes, and other sample specific deliverables can be downloaded via the sample downloads column lower on this page or via the \'Samples\' tab.</div></div></div></span></th></tr></thead><tbody><tr ng-repeat="customerOrder in vm.customerOrders track by customerOrder.id"><td class="tbl-col-1 text-yellow"><div id="info-modal-icon-0" class="sample-info-modal-trigger product-info" aria-hidden="true"><a style="display: inline" ng-click="toggleStarred(customerOrder.id, customerOrder)"><i ng-show="!customerOrder.starred" class="fa fa-star-o favorite-button"></i> <i ng-show="customerOrder.starred" class="fa fa-star favorite-button"></i> </a><a ui-sref="order-details({orderId:customerOrder.id})" class="hover-sample-id">{{customerOrder.id}}</a><div class="sample-submit-info-modal-shadow-left info-modal-0 sample-info-modal product-description" ng-if="customerOrder.sampleCount > 0"><span style="margin-left: 7px; font-weight: bold; font-size: 15px; color: #2a9ecf">Samples</span><ul style="margin-top: 10px"><li ng-repeat="sample in customerOrder.samples" ng-if="$index < 5"><div ng-if="sample.id != -1" class="calendar-sample-event" ng-click="vm.openPublicSample(sample)"><p>{{ sample.name }}</p></div></li><div class="text-right"><span ng-if="customerOrder.samples.length > 5">+ {{(customerOrder.samples.length) - 5}} more</span></div></ul><button ng-if="sample.id != -1 && customerOrder.samples.length > 5" type="button" class="btn btn-primary btn-list-modal" ng-click="vm.SampleDetail(customerOrder)">See List Page</button></div></div></td><td class="tbl-col-2 text-gray"><!-- <div id="info-modal-icon-0" class="sample-info-modal-trigger product-info" aria-hidden="true"> --> <span>{{customerOrder.sampleCount }}</span><!-- <i id="info-modal-icon-0" class="sample-submit-info-modal-trigger product-info fa fa-info-circle" aria-hidden="true"></i> --><!-- <div class="sample-submit-info-modal-shadow-left info-modal-0 sample-info-modal product-description" ng-if="customerOrder.sampleCount > 0">\n                                            <p ng-repeat="sample in customerOrder.samples">{{sample.name}}</p>\n                                            <span style="margin-left: 7px; font-weight: bold; font-size: 15px;">Samples</span>\n                                            <ul style="margin-top: 10px;">\n                                                <li ng-repeat="sample in customerOrder.samples" ng-if="$index < 5">\n                                                    <div ng-if="sample.id != -1" class="calendar-sample-event" ng-click="vm.openPublicSample(sample)"><p>{{ sample.name }}</p> </div>                                                    \n                                                </li>\n                                                <span ng-if="customerOrder.samples.length > 5"> + {{(customerOrder.samples.length) - 5}} more</span>\n                                            </ul>\n                                            <button ng-if="sample.id != -1 && customerOrder.samples.length > 5" type="button" class="btn btn-primary" ng-click="vm.SampleDetail(customerOrder)">See List Page</button>\n                                        </div> --><!-- </div>                                     --></td><td class="tbl-col-3 text-gray">{{customerOrder.turnaroundTimeLabel | translate}}</td><td class="tbl-col-4 text-gray">{{ vm.parseDueDate(customerOrder) ? vm.parseDueDate(customerOrder) : \'None\' }}</td><td class="tbl-col-4 text-gray">{{customerOrder.dateReceived | utcToLocal:\'MM/dd/yyyy\'}}</td><td class="tbl-col-5 text-left-bold"><span ng-if="customerOrder.state == \'CREATED\'" class="order1">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'SAMPLES_RECEIVED\' " class="order2">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'PRELIMINARY_RESULTS\' " class="order3">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'COMPLETED\' " class="order4">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'INVOICED\' " class="order5">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'CANCELLED\' " class="order4">{{customerOrder.stateLabel | translate}}</span> <span ng-if="customerOrder.state == \'RETESTING\' " class="order6">{{customerOrder.stateLabel | translate}}</span></td><td class="tbl-col-15 select-box-btn tbl-col-14 load-btn" style="padding: 0 !important"><div ng-if="!customerOrder.attachments"><a class="btn btn-sm btn-load btn-success select-loader" ng-click="getAttachments (customerOrder,customerOrder.id)"><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;{{\'Load\' | translate}}<div ng-if="vm.getAttachmentsLoader && vm.idOfSelectedOrder == customerOrder.id" class="loader"><i class="fa fa-refresh" aria-hidden="true"></i></div></a></div><div class="select-wrapper" ng-if="customerOrder.attachments"><select id="lunch" class="selectpicker select-box-table table_select" ng-click="getAttachments (customerOrder,customerOrder.id)" data-live-search="true" title="Select" ng-model="customerOrder.select" ng-change="downloadAttachment(customerOrder.select,customerOrder)" value="select"><option value="" ng-if="!customerOrder.attachments.length < 1 ">{{\'Select\' | translate}}</option><option value="" ng-if="customerOrder.attachments.length < 1 ">Empty</option><option ng-repeat="attach in customerOrder.attachments track by attach.id" value="{{attach.hash}}" ng-click="downloadAttachment(customerOrder.select,customerOrder)">{{attach.file_name}}</option></select></div></td></tr></tbody></table><!-- ./ Table Swiper End --></div></div><div class="page-list"><div class="pull-left mobile-box-pagination" ng-if="(vm.itemsPerPage * 1) < (vm.totalItems* 1)"><uib-pagination class="pagination pageset" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition(true)"></uib-pagination></div><div class="statuslist mobile-box-statuslist"><div class="custom-selectbox"><select id="lunch" class="selectpicker select-box-padding-tiny" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10" selected="selected">10</option><option value="20">20</option><option value="50">50</option></select></div></div></div></div></div><!-- Modal - Add rd requested test --><div class="modal fade" id="rdAddRequestedTest" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Samples (Order {{vm.modalsamples.id}})</h4></div><div class="modal-body" style="background-color: #fff"><ul class="calendarDayModalSamples"><li ng-repeat="sample in vm.modalsamples.samples" style="margin-bottom: 10px"><div ng-if="sample.id != -1" class="calendar-sample-event" ng-click="vm.openPublicSample(sample)"><strong>{{ sample.id }}</strong> {{ sample.name }}</div></li></ul></div><div class="modal-footer"><button class="btnPrimaryCancel" ng-click="vm.rd.clearOtherAnalysis()" data-dismiss="modal"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;Cancel</button> <button class="add-panel-btn" style="height: 35px; width: auto" ng-click="vm.redirectSamples(vm.modalsamples.id)" style="float: right">View list</button></div></div></div></div></div>');
$templateCache.put('app/pages/payment-details/payment-details.html','<style>#invoice-details {\n        color: #3D5269;\n    }\n\n    .flex-row {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .flex-column {\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n    }\n\n    .flex-row-align-end {\n        justify-content: flex-end;\n    }\n\n    .flex-row-align-start {\n        justify-content: flex-start;\n    }\n\n    .card {\n        display: flex;\n        padding: 16px;\n        background-color: white;\n    }\n\n    #invoices-table {\n        width: 100%;\n        table-layout: fixed;\n        white-space: nowrap;\n        margin-bottom: 16px;\n    }\n    #invoices-table > tbody > tr > td:nth-child(1) {\n        font-family: OpenSans-SemiBold;\n    }\n\n    #invoices-table > thead > tr > th:nth-child(1),\n    #invoices-table > tbody > tr > td:nth-child(1) {\n        width: 25%;\n    }\n\n    #invoices-table > thead > tr{\n        color: #2D9CDB;\n        font-family: OpenSans-SemiBold;\n    }\n\n    #invoices-table > thead > tr > th,\n    #invoices-table > tbody > tr > td{\n        height: 45px;\n        padding: 10px 0;\n        border-bottom: 1px solid #DFEAF7;\n    }\n\n    .semibold {\n        color: blue;\n        font-family: OpenSans-SemiBold;\n    }</style><div id="invoice-details" class="flex-row" style="min-height: 500px; font-size: 13px !important"><div class="flex-column" style="width: 100%; padding: 30px"><div class="flex-row"><a ui-sref="invoicelog"><button type="button" class="btnPrimaryWhite"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;Back</button> </a><button class="btnPrimaryWhite" style="margin-left: auto" ng-click="vm.printPaymentReceipt()"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp;Print Payment Receipt</button> <button class="btnPrimaryWhite" style="margin-left: 16px" ng-click="vm.downloadPaymentReceipt()"><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;Download Payment Receipt</button></div><div class="flex-row" style="margin-top: 48px"><div class="flex-column" style="flex-grow: 4; font-size: 13px"><div class="flex-row"><div ng-bind-html="vm.payment_status"></div></div><div class="flex-row" style="margin-top: 16px; margin-bottom: 8px"><span style="width: 140px">Date Received</span> <span style="font-family: OpenSans-SemiBold; margin-left: 8px">{{ vm.payment.payment_date ? vm.payment.payment_date : \'\' }}</span></div><div class="flex-row" style="margin-bottom: 8px"><span style="width: 140px">Payment Method</span> <span style="font-family: OpenSans-SemiBold; margin-left: 8px" ng-cloak>{{ vm.payment.payment_type ? vm.payment.payment_type : \'\' }}</span></div></div><div class="flex-column" style="flex-grow: 1; font-size: 13px" ng-cloak><div class="flex-row flex-row-align-end" style="margin-bottom: 8px; font-family: OpenSans-SemiBold">Received By</div><div class="flex-row flex-row-align-end" ng-repeat="line in vm.static.anresco_address track by $index">{{ line }}</div></div><div class="flex-column" style="flex-grow: 1; font-size: 13px" ng-cloak><div class="flex-row flex-row-align-end" style="margin-bottom: 8px; font-family: OpenSans-SemiBold">Received From</div><div class="flex-row flex-row-align-end" ng-repeat="line in vm.customer.procesed_address track by $index">{{ line }}</div></div></div><div class="flex-row" style="margin-top: 32px"><div class="flex-column" style="width: 100%"><div class="flex-column" style="width: 100%; padding-right: 24px"><div class="card"><table id="invoices-table"><thead><tr><th>Date</th><th>Invoice No.</th><th>Amount</th><th>Applied</th><th>Balance</th></tr></thead><tbody ng-cloak><tr ng-repeat="invoice in vm.payment.invoices"><td>{{ invoice.invoice_date }}</td><td class="text-yellow"><a ui-sref="invoice-details({id: invoice.id})">{{ invoice.custom_formated_id}}</a></td><td>&#36;{{ invoice.total.toFixed(2) | number : 2 }}</td><td>-&#36;{{ invoice.applied_amount.toFixed(2) | number : 2 }}</td><td>&#36;{{ invoice.outstanding_amount.toFixed(2) | number : 2 }}</td></tr></tbody></table></div></div></div><div class="flex-column card" style="width: 300px; padding: 16px 24px" ng-cloak><div class="flex-row" style="font-family: OpenSans-Bold; border-bottom: 1px solid #DFEAF7; padding-bottom: 24px; margin-bottom: 24px; font-size: 16px">Payment Amount</div><div class="flex-row" style="justify-content: space-between; font-family: OpenSans-SemiBold"><span>Total</span><span>&#36;{{ vm.payment.amount.toFixed(2) | number : 2 }}</span></div></div></div></div></div>');
$templateCache.put('app/pages/public/not-found.html','<div class="public-sample-not-found-wrapper"><div class="public-sample-not-found"><img src="content/images/sad-smiley.png" alt="Not found"><h1>Sorry, but the results for this sample have not been<br>made publicly available.</h1></div><footer class="container-fluid"><ul><li><a ng-href="{{ (brand.web && (brand.web.marketing_url || brand.web.portal_url)) || \'#\' }}">{{ (brand.web && brand.web.marketing_label) || ((brand.branding && brand.branding.display_name) || \'Portal\') }}</a></li><li><a href="#">FAQ</a></li><li><a href="#">About Us</a></li><li><a href="#">Contact</a></li></ul></footer></div>');
$templateCache.put('app/pages/public/public.html','<style ng-if="vm.hideMenu==true">.wrap {\r\n        width: 100% !important;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .sidebar {\r\n        width: 0;\r\n        opacity: 0\r\n    }</style><style>body {\r\n        background-color: #EAF1F9;\r\n    }\r\n\r\n    svg>g>g:last-child {\r\n        pointer-events: none\r\n    }\r\n\r\n    a:focus, a:active {\r\n        outline: none;\r\n    }\r\n\r\n    .dataTables_wrapper {\r\n        width: 100%;\r\n    }\r\n\r\n    .next, .prev {\r\n        height: 25px;\r\n        width: unset;\r\n    }\r\n    .dataTables_wrapper .dataTables_paginate .paginate_button {\r\n        border: none !important;\r\n        background-color: none !important;\r\n        background: none !important;\r\n        color: #606F7B !important;\r\n        height: 22px;\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_paginate .paginate_button.current {\r\n        font-family: OpenSans-Bold !important;\r\n        color: #606F7B !important\r\n    }\r\n\r\n    .dataTables_wrapper .dataTables_paginate .paginate_button:hover {\r\n        border: none !important;\r\n        background-color: none !important;\r\n        background: none !important;\r\n        color: black !important;\r\n        font-family: OpenSans-Semibold !important;\r\n        color: #606F7B !important\r\n    }\r\n\r\n    .dataTables_info, .dataTables_length {\r\n        margin-left: 16px;\r\n        color: #3D5269 !important\r\n    }\r\n\r\n    .dataTables_length > label > select{\r\n        border-radius: 4px;\r\n        border: 1px solid #3D5269 !important;\r\n        color: #3D5269 !important\r\n    }\r\n\r\n    table.dataTable thead {\r\n        background-color: #edf3fa;\r\n    }\r\n\r\n    table.dataTable thead .sorting,\r\n    table.dataTable thead .sorting_asc,\r\n    table.dataTable thead .sorting_desc  {\r\n        font-family: OpenSans-Semibold;\r\n        color: #3D5269;\r\n    }\r\n\r\n    table.dataTable thead td {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    table.dataTable.no-footer {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #terpenes-table > * {\r\n        flex: 0 0 50px;\r\n    }\r\n\r\n    #cannabinoids-table {\r\n        flex: 0 0 50px;\r\n    }\r\n\r\n    .terpene-color-dot {\r\n        display: inline-block;\r\n        width: 13px;\r\n        height: 13px;\r\n        border-radius: 100%;\r\n        margin-right: 10px;\r\n        margin-left: 0px;\r\n        position: relative;\r\n        top: -1px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    table.dataTable tbody th, table.dataTable tbody td,\r\n    table.dataTable thead th, table.dataTable thead td {\r\n        padding: 10px 16px;\r\n    }\r\n\r\n    .dataTables_paginate.paging_simple_numbers {\r\n        position: absolute !important;\r\n        top: -11px !important;\r\n        right: 0 !important;\r\n    }\r\n\r\n    *:focus {\r\n        outline: 0;\r\n    }</style><script>var waitForSelectorLoad = function(selector, callback) {\r\n        if (jQuery(selector).length) {\r\n            callback();\r\n        } else {\r\n            setTimeout(function() {\r\n            waitForSelectorLoad(selector, callback);\r\n            }, 100);\r\n    }\r\n    };\r\n\r\n    waitForSelectorLoad(\'#done\', function() {\r\n        var element_id = null;\r\n        for( var i = 0; i < $("#list-of-sections li").length; i++) {\r\n            element_id = "#" + $(\'#list-of-sections li\')[i].id.slice(1);\r\n\r\n            $(element_id).dataTable({\r\n                searching: false,\r\n                retrieve: true,\r\n                "columnDefs": [\r\n                    { "type": "num-fmt", "targets": 1 }\r\n                ],\r\n                "order": [],\r\n                "lengthMenu": [ [10, 25, 50, -1], [10, 25, 50, "All"] ]\r\n            });\r\n        }\r\n    });</script><div style="display: none" id="list-of-sections"></div><div ng-if="false" class="row"><div class="chart-2-pie-wrapper"><div class="chart-2-wrapper"><canvas id="desktop-terpene-radar-chart" style="margin-top: -40px; margin-left: -40px" width="300" height="300" id="circle-page-rehaul"></canvas><div class="desktop-terpene-radar-chart-container"></div></div><div class="chart-legend"><span class="span-col-1"><i class="blue"></i> Piney</span> <span class="span-col-2"><i class="green"></i> Minty</span> <span class="span-col-3"><i class="purple"></i> Sweet</span> <span class="span-col-4"><i class="pink"></i> Citrus</span> <span class="span-col-5"><i class="red"></i> Spicy</span><div class="chart-swiper"><button id="col-prev" class="button-prev-next" disabled="disabled"></button><div>1/2</div><button id="col-next" class="button-prev-next"></button></div></div></div></div><div class="public-sample" ng-cloak ng-show="vm.sample.id"><div style="display: flex; flex-direction: column; align-items: center; padding: 0 30px"><div ng-show="vm.showWideView == true" class="ps-container"><div class="ps-info" style="margin-top: 24px; display: flex; flex-direction: column; justify-content: center"><div style="margin-left: auto; margin-bottom: 24px"><select class="form-select" aria-label="Download sample file" ng-if="vm.hasDownloads()" ng-model="vm.selectedDownload" ng-change="vm.downloadAttachment(vm.selectedDownload, vm.sample)"><option value="">Downloads</option><option ng-if="vm.canDownloadCoaSummary()" value="coa">{{ vm.sample.id }}_COA_Summary.pdf</option><option ng-repeat="attach in vm.sample.attachments track by attach.hash" value="{{attach.hash}}" ng-if="attach.canSee">{{attach.file_name}}</option></select><button class="btn-primary-gray" style="margin-left: 16px" data-toggle="modal" data-target="#shareSampleModal" ng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)"><i class="fa fa-share-alt"></i>&nbsp;&nbsp;&nbsp;Share</button> <button class="ps-nav-btn" ui-sref="public({hash:vm.prevNext.prev, page: vm.prevPage})" ng-show="vm.prevNext.prev"><i class="fa fa-chevron-left"></i></button> <button class="ps-nav-btn" style="padding-right: 0" ui-sref="public({hash:vm.prevNext.next, page: vm.nextPage})" ng-show="vm.prevNext.next"><i class="fa fa-chevron-right"></i></button></div><div style="display: flex; flex-direction: row"><div class="ps-sample ps-shadow" style="width: 257px; max-height: 642px; padding: 10px 0; background: white; border-radius: 5px;"><div class="ps-img-box"><img id="ps-img-box" style="max-width: 240px; max-height: 200px" ng-src="{{ vm.sample.picture ? vm.sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"></div><div style="padding: 0 15px"><div style="display: flex; margin-top: 10px; align-items: center; height: 32px; text-align: left; font-family: OpenSans-Bold; font-size: 17px; color: #3D5269">{{ vm.sample.name }}</div><table id="ps-sample-table" style="margin-top: 16px; width: 100%"><tbody><tr style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Company</td><td class="ps-table-finding" style="text-align: right">{{ vm.customerDisplayName ? vm.customerDisplayName : \'\' }}</td></tr><tr style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">{{ ((brand.branding && brand.branding.display_name) || \'Lab\') + \' ID\' }}</td><td class="ps-table-finding" style="text-align: right">{{ vm.sample.id }}</td></tr><tr style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Order ID</td><td class="ps-table-finding" style="text-align: right">{{ vm.sample.customerOrderId }}</td></tr><tr ng-if="vm.sample.lotBatchNumber" style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Lot/Batch Number</td><td class="ps-table-finding" style="text-align: right">{{ vm.sample.lotBatchNumber ? vm.sample.lotBatchNumber : \'\' }}</td></tr><tr ng-if="vm.sample.sampleWeight" style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Sample Wt</td><td class="ps-table-finding" style="text-align: right"></td>{{ vm.sample.sampleWeight ? vm.sample.sampleWeight : \'\' }}</tr><tr ng-if="vm.sample.sampleType" style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Type</td><td class="ps-table-finding" style="text-align: right">{{ vm.sample.sampleType ? vm.sample.sampleType : \'\' }}</td></tr><tr ng-if="vm.sample.date" style="border-bottom: 1px solid lightgray"><td class="ps-table-item" style="text-align: left">Date</td><td class="ps-table-finding" style="text-align: right">{{ vm.sample.date | date }}</td></tr></tbody></table></div></div><div class="ps-results ps-shadow" style="background: white; border-radius: 5px; min-height: 600px"><div class="rdCustomScrollBar ps-overflow-scroll" style="justify-content: space-between; display: flex; flex-direction: row; background: #f5f6f9; width: 100%"><a id="{{ section.title }}" ng-click="vm.makeActive(section.title)" ng-repeat="section in vm.sections" ng-class="{\'ps-active-tab ps-shadow\' : section.active, \'ps-inactive-tab\' : !section.active }" style="padding-left: 24px; min-width: 196px; height: 78px; padding-right: 24px; flex: 1; display: flex; justify-content: flex-end; flex-direction: column; padding-bottom: 8px"><p ps-icon title="section.title"></p><div style="color: #3D5269; font-family: inherit; white-space: nowrap" ng-bind="vm.titleToSection(section.title)"></div><div style="align-items: flex-end; font-size: 10px; white-space: nowrap; margin-right: 5px" ng-bind-html="vm.overallPf(section.overall_pf, section.overall_show_results)"></div></a></div><div ng-repeat="section in vm.sections" style="flex-direction: column; flex: 1"><div style="flex-direction: column; flex: 1; justify-content: left; min-height: 500px; margin-top: 24px; margin-bottom: 20px" ng-class="{\'ps-display-section\' : section.active, \'ps-hide-section\' : !section.active }"><div style="padding-left: 16px; display: inline"><div style="width: 60%; float: left"><div style="position: relative; display: flex; margin-bottom: 10px; font-family: OpenSans-Bold; color: #3D5269; font-size: 18px"><span style="font-family: OpenSans-Semibold" ng-bind="vm.titleToSectionHeader(section.title)"></span>&nbsp;<div><button class="ps-test-info-box-trigger" ng-show="section.complete_date" style="background: none; border: none"><i ng-class="{ \'fa-times-circle\' : hover, \'fa-info-circle\' : !hover}" ng-mouseenter="hover = true" ng-mouseleave="hover = false" style="padding: 5px; top: 2px; z-index: 100; position: relative; top: -7px; font-size: 14px; color: #556d85 !important" class="fa"></i></button><div class="ps-shadow" ng-class="{ \'ps-display-block\' : box_hover, \'ps-test-info-box\' : !box_hover}" ng-mouseenter="box_hover = true; hover = true" ng-mouseleave="box_hover = false; hover = false" style="top: -3px; z-index: 1; font-size: 14px; flex-direction: column; flex: 1; background-color: white; padding: 25px 10px 15px 10px; position: absolute; border-radius: 5px; min-height: 50px; width: 300px"><div ng-show="method && section.method_same_for_all" ng-repeat="method in section.method" style="padding: 5px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid lightgray"><div style="font-family: OpenSans-Semibold">Method</div><div style="text-align: right">{{ method }}</div></div><div ng-show="instrument" ng-repeat="instrument in section.instrument" style="padding: 5px 0; justify-content: space-between; display: flex; flex-direction: row;  border-bottom: 1px solid lightgray"><div style="font-family: OpenSans-Semibold">Instrument</div><div style="text-align: right">{{ instrument }}</div></div><div ng-show="section.lod" style="padding: 5px 0; justify-content: space-between; display: flex; flex-direction: row;  border-bottom: 1px solid lightgray"><div style="font-family: OpenSans-Semibold">Limit of Detection</div><div style="text-align: right">{{ section.lod }}</div></div><div ng-show="section.loq" style="padding: 5px 0; justify-content: space-between; display: flex; flex-direction: row;  border-bottom: 1px solid lightgray"><div style="font-family: OpenSans-Semibold">Limit of Quantification</div><div style="text-align: right">{{ section.loq }}</div></div><div ng-show="section.complete_date" style="padding: 5px 0; justify-content: space-between; display: flex; flex-direction: row;  border-bottom: 1px solid lightgray"><div style="font-family: OpenSans-Semibold">Date Completed</div><div style="text-align: right">{{ section.complete_date | date }}</div></div></div></div></div><div ng-if="section.description" style="margin-bottom: 20px; color: #606F7B">{{ section.description }}</div></div><div class="ps-cannabinoids-graphic-box" style="float: right; margin-right: 40px; display: block"><div style="display: flex" ng-if="section.title.toLowerCase() == \'terpenoids\' && vm.sectionTested(section.overall_pf) && section.overall_show_results"><div style="align-items: center; margin-top: 20px; height: 80px; width: 130px; border-radius: 4px; background-color: #EFF5FB"><div style="display: flex; justify-content: center; margin-top: 6px"><div class="terpenes-icon"></div></div><div style="margin-top: 8px; font-family: OpenSans-Bold; color: #3D5269; text-align: center">{{ section.total_terpenes }}%</div><div style="font-family: OpenSans-Semibold; color: #647F9C; text-align: center">Total Terpenes</div></div><div style="margin-left: 30px; margin-right: 1%; height: 110px; width: 110px"><div style="display: inline-block; height: 100%; width: 100%" id="new-terpenes-chart"></div></div></div><div style="display: flex" ng-if="section.title.toLowerCase() == \'cannabis\' && vm.sectionTested(section.overall_pf) && section.overall_show_results"><div style="display: flex; flex-direction: column; padding: 8px 0; min-height: 75px; width: 110px; border-radius: 4px; background-color: #EFF5FB"><div style="margin: auto" class="thc-icon-public"></div><div style="margin-top: 8px; font-family: OpenSans-Bold; color: #3D5269; text-align: center">{{ section.total_thc ? section.total_thc : \'0\' }}{{ section.active_unit_frontend }}</div><div style="font-family: OpenSans-Semibold; color: #647F9C; text-align: center">Total THC</div></div><div style="display: flex; flex-direction: column; padding: 8px 0; margin-left: 40px; min-height: 75px; width: 110px; border-radius: 4px; background-color: #EFF5FB"><div style="margin: auto" class="cbd-icon-public"></div><div style="margin-top: 8px; font-family: OpenSans-Bold; color: #3D5269; text-align: center">{{ section.total_cbd ? section.total_cbd : \'0\' }}{{ section.active_unit_frontend }}</div><div style="font-family: OpenSans-Regular; color: #556d85; text-align: center">Total CBD</div></div></div><div style="display: flex" ng-if="section.title.toLowerCase() == \'pesticides\' && vm.sectionTested(section.overall_pf) && section.overall_show_results"><div style="text-align: center; padding-top: 8px 0; margin-left: 40px; min-height: 75px; width: 110px; border-radius: 4px; background-color: #EFF5FB"><div style="margin-left: 6px; margin-top: 4px" class="pesticides-icon"></div><div style="font-family: OpenSans-Bold; color: black; text-align: center">{{ section.pesticides_detected }}</div><div style="font-family: OpenSans-Regular; color: #556d85; text-align: center">Pesticides Detected</div></div></div></div></div><div ng-if="vm.sectionTested(section.overall_pf) && section.title.toLowerCase() == \'cannabis\' && section.overall_show_results"><div style="display: flex; flex-direction: row"><div style="width: 60%"><div style="margin-left: 15px"><select style="text-align-last: center; padding: 3px 6px; color: #647F9C; border: 1px solid transparent; border-radius: 3px; background-color: #EFF5FB" ng-change="vm.changeCannabinoidTotals()" ng-model="section.active_unit" name="activeCannabinoidUnit" id="activeCannabinoidUnit"><option ng-if="section.dry_percent_exists" value="dry_percent">% (dry)</option><option ng-if="section.percent_exists" value="percent">%</option><option ng-if="section.dry_mgpg_exists" value="dry_mgpg">mg/g (dry)</option><option ng-if="section.mgpg_exists" value="mgpg">mg/g</option><option ng-if="section.mgpml_exists" value="mgpml">mg/ml</option><option ng-if="section.mgpu_exists" value="mgpu">mg/serving</option><option ng-if="section.mgpp_exists" value="mgpp">mg/pkg</option></select></div><div id="cannabinoids-table" style="overflow-x:auto; height: 360px; display: flex; flex-flow: column wrap; margin-bottom: 20px"><div ng-class="{ \'no-analyte-value-opacity\' : !analyte.value_exists }" style="min-width: 180px;margin-left: 16px; padding-top: 15px; border-bottom: 1px solid lightgray; padding-bottom: 15px" ng-repeat="analyte in section.section_data[section.active_unit]"><div style="float: left"><span><i class="terpene-color-dot" ng-style="analyte.color" ng-class="{ \'no-value-dot\' : !analyte.value_exists }"></i></span><span class="ps-table-item">{{ analyte.name }}</span></div><div style="float: right"><span style="color: #606F7B">{{ analyte.value }}{{ analyte.units == \'%\' || analyte.units == \'% (dry)\' ? \'\' : \' \' }}{{ analyte.units }}</span></div></div></div></div><div style="position: relative; width: 40%; display: flex; justify-content: center; align-items: center"><div style="position: absolute"><span style="text-align: center; display: block; font-size: 18px; color: #3D5269; font-family: OpenSans-Bold">{{ section.total_cannabinoids }}{{ section.active_unit_frontend }}</span> <span style="text-align: center; display: block; font-size: 14px; color: #3D5269">Total Cannabinoids</span></div><div style="height: 80%; width: 80%" id="new-pie-chart"></div></div></div></div><div ng-if="vm.sectionTested(section.overall_pf) && section.title.toLowerCase() == \'terpenoids\' && section.overall_show_results"><div><div style="display: flex; flex-direction: row; margin-left: 15px; width: 400px; justify-content: space-between"><div style="color: #8795A1"><i class="terpene-color-dot piney-dot"></i>Piney</div><div style="color: #8795A1"><i class="terpene-color-dot minty-dot"></i>Minty</div><div style="color: #8795A1"><i class="terpene-color-dot sweet-dot"></i>Sweet</div><div style="color: #8795A1"><i class="terpene-color-dot citrus-dot"></i>Citrus</div><div style="color: #8795A1"><i class="terpene-color-dot spicy-dot"></i>Spicy</div></div></div><div id="terpenes-table" style="height: 500px; display: flex; flex-flow: column wrap; margin-bottom: 20px"><div style="margin: 0 15px; padding-top: 15px; border-bottom: 1px solid lightgray" ng-repeat="analyte in section.section_data"><div style="float: left"><span><i class="terpene-color-dot" ng-style="analyte.color"></i></span><span class="ps-table-item">{{ analyte.name }}</span></div><div style="float: right"><span style="color: #606F7B">{{ analyte.value }}{{ analyte.units }}</span></div></div></div></div><table ng-if="section.overall_show_results && (vm.sectionTested(section.overall_pf) && section.title.toLowerCase() != \'terpenoids\' && section.title.toLowerCase() != \'cannabis\')" style="width: 100%; margin-left: 0; flex-grow: 1" id="{{ section.table_name }}" class="nowrap"><thead><tr><td style="width: 100px">Analyte</td><td style="width: 100px">Findings {{ section.units && section.units_same_for_all ? \'(\' + section.units + \')\': \'\' }}</td><td ng-if="section.units && !section.units_same_for_all" style="width: 100px">Unit</td><td ng-if="section.limit && !section.limit_same_for_all" style="width: 100px">Limit</td><td ng-if="section.limit && section.limit_same_for_all" style="width: 100px">{{ section.limit }}</td><td ng-if="section.show_status" style="width: 100px">Status</td></tr></thead><tbody><tr ng-repeat="analyte in section.section_data"><td style="width: 100px; font-family: OpenSans-Semibold; color: #3D5269" ng-bind-html="analyte.name"></td><td style="width: 100px; color: #606F7B">{{ analyte.value ? analyte.value : \'-\'}}</td><td ng-if="section.units && !section.units_same_for_all" style="width: 100px; color: #606F7B">{{ analyte.units ? analyte.units : \'-\' }}</td><td ng-if="section.limit && !section.limit_same_for_all" style="width: 100px; color: #606F7B">{{ analyte.limit ? analyte.limit : \'-\' }}</td><td ng-if="section.limit && section.limit_same_for_all" style="width: 100px; color: #606F7B">{{ section.limit }}</td><td ng-if="section.show_status" style="width: 100px" ng-class="{ \'test-pass\' : analyte.status.toLowerCase() == \'pass\', \'test-fail\' :  analyte.status.toLowerCase() == \'fail\', \'test-caution\' : analyte.status.toLowerCase() == \'caution\'}">{{ analyte.status ? analyte.status : \'-\' }}</td></tr></tbody></table><div ng-if="!section.overall_show_results || !vm.sectionTested(section.overall_pf)" style="display: flex; flex-direction: column; flex: 1; justify-content: flex-end; align-items: center; padding-bottom: 180px;color: #3D5269"><img src="content/images/scope_inprogress.svg"> <span ng-if="!vm.sampleReceived" style="font-size: 23px; margin-top: 24px">Sample Not Received Yet</span> <span ng-if="vm.sampleReceived" style="font-size: 23px; margin-top: 24px">Results for <span style="font-family: OpenSans-Semibold" ng-bind="vm.titleToSection(section.title)"></span> not yet available.</span> <span style="margin-top: 12px; color: #8795a1" ng-if="section.estimated_complete_date">Estimated completion date: <span style="font-family: OpenSans-Semibold">{{ section.estimated_complete_date | date : \'MM/dd/yyyy\' : \'UTC\' }}</span></span> <span style="margin-top: 12px; color: #8795a1" ng-if="vm.due_date && !section.estimated_complete_date">Estimated completion date: <span style="font-family: OpenSans-Semibold">{{ vm.due_date | date : \'MM/dd/yyyy\' : \'UTC\' }}</span></span></div></div></div></div></div></div></div></div><div ng-show="vm.showTallView == true" class="container-fluid sample-header" style="margin: 0 0 24px 0"><div class="row company-info" style="display:none"><table><tbody><tr><td ng-if="vm.companyLogo"><img ng-src="{{vm.companyLogo}}" alt="logo" class="img-responsive" style="max-height: 150px; width: auto"></td><td ng-if="vm.customer.phone != null || vm.customer.address != null"><div ng-if="vm.customer.phone"><span style="font-weight: 600">Phone</span> {{ vm.customer.phone }}</div><div ng-if="vm.customer.address"><span style="font-weight: 600">Address</span> {{ vm.customer.address }}</div></td><td ng-if="vm.customer.facebook_link || vm.customer.twitter_link || vm.customer.instagram_link || vm.customer.website"><div class="row"><div class="col-md-12 social-links"><a ng-if="vm.customer.facebook_link" target="_blank" ng-href="{{vm.customer.facebook_link}}"><i class="fa fa-facebook fa-lg"></i></a> <a ng-if="vm.customer.twitter_link" target="_blank" ng-href="{{vm.customer.twitter_link}}"><i class="fa fa-twitter fa-lg"></i></a> <a ng-if="vm.customer.instagram_link" target="_blank" ng-href="{{vm.customer.instagram_link}}"><i class="fa fa-instagram fa-lg"></i></a></div><div ng-if="vm.customer.website" class="col-md-2">Website</div><div ng-if="vm.customer.website" class="col-md-10"><a target="_blank" ng-href="{{ vm.customer.website }}" class="text-yellow">{{ vm.customer.website }}</a></div></div></td><td ng-if="vm.customer.address"><a target="_blank" ng-href="https://maps.google.com/?q={{ vm.customer.address }}"><img ng-src="{{vm.mapImageUrl}}" style="max-height: 150px; width: auto"></a></td></tr></tbody></table></div><div class="row" style="background: white; display: flex; flex-direction: column"><div style="display: flex; flex-direction: row; flex-wrap: wrap; row-gap: 8px; padding: 16px 24px; background: #eff5fb"><div style="display: flex; flex-direction: row; flex: 1; padding-right: 16px; justify-content: space-between; align-items: center"><div style="display: flex"><button ui-sref="public({hash:vm.prevNext.prev, page: vm.prevPage})" ng-show="vm.prevNext.prev" style="position: relative" class="ps-collapse-circle"><i style="position: absolute; top: 4px; left: 5px" class="fa fa-chevron-left"></i></button></div><div><select class="form-select" aria-label="Download sample file" ng-if="vm.hasDownloads()" ng-model="vm.selectedDownload" ng-change="vm.downloadAttachment(vm.selectedDownload, vm.sample)"><option value="">Downloads</option><option ng-if="vm.canDownloadCoaSummary()" value="coa">{{ vm.sample.id }}_COA_Summary.pdf</option><option ng-repeat="attach in vm.sample.attachments track by attach.hash" value="{{attach.hash}}" ng-if="attach.canSee">{{attach.file_name}}</option></select></div></div><div style="display: flex; flex-direction: row; flex: 1; padding-left: 16px; justify-content: space-between; align-items: center"><div><button class="btn-primary-gray" data-toggle="modal" data-target="#shareSampleModal" ng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)"><i class="fa fa-share-alt"></i>&nbsp;&nbsp;&nbsp;Share</button></div><div style="display: flex"><button ui-sref="public({hash:vm.prevNext.next, page: vm.nextPage})" ng-show="vm.prevNext.next" style="position: relative" class="ps-collapse-circle"><i style="position: absolute; top: 4px; right: 5px" class="fa fa-chevron-right"></i></button></div></div></div><div style="text-align: center; margin: 16px auto" class="col-md-12 col-lg-5 sample-image"><img ng-src="{{ vm.sample.picture ? vm.sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"></div><div><div style="display: inline-flex; padding: 0 24px"><!-- <a style="font-size: 17px;" ng-if="vm.isAuthenticated()" ng-click="toggleStarred(vm.sample.id, vm.sample)">\r\n                    \t<i ng-show="!vm.sample.starred" class="fa fa-star-o favorite-button"></i>\r\n                    \t<i ng-show="vm.sample.starred"  class="fa fa-star favorite-button"></i>\r\n                    </a> --><!-- <span style="font-size: 17px;" ng-if="!vm.isAuthenticated()">\r\n                    \t<i ng-show="!vm.sample.starred" class="fa fa-star-o favorite-button"></i>\r\n                    \t<i ng-show="vm.sample.starred"  class="fa fa-star favorite-button"></i>\r\n                    </span> --><div style="text-transform: uppercase; font-size: 18px; font-family: OpenSans-Bold">{{ vm.sample.name ? vm.sample.name : \'\' }}</div><!-- <h4 class="sample-name" style="margin-left: 10px; margin-top: 4px;" ng-bind="vm.sample.name" ng-show="vm.sample.name"></h4> --><!-- <div class="pull-right prev-next" style="position: absolute; right: 15px;">\r\n\t\t\t            <a class="btn-public-link"\r\n\t\t\t            \tstyle="padding: 6px 9px !important;height: 30px !important; font-size: 13px;" data-toggle="modal" data-target="#shareSampleModal"\r\n\t\t\t            \tng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)">\r\n\t\t\t            \t&nbsp;\r\n\t\t\t\t            <i class="fa fa-share-alt"></i>\r\n\t\t\t\t            &nbsp;&nbsp;Share\r\n\t\t\t\t            &nbsp;\r\n\t\t\t            </a>\r\n\t\t\t            <button\r\n\t\t\t            \tstyle="margin-left: 20px;"\r\n\t\t\t                ui-sref="public({hash:vm.prevNext.prev, page: vm.prevPage, size: vm.queryParams.size, sort: vm.queryParams.sort, search: vm.queryParams.search, productCategoryId: vm.queryParams.productCategoryId})"\r\n\t\t\t                class="btn-prev" ng-show="vm.prevNext.prev"><i class="fa fa-angle-left"></i> Previous </button>\r\n\t\t\t            <button\r\n\t\t\t                ui-sref="public({hash:vm.prevNext.next, page: vm.nextPage, size: vm.queryParams.size, sort: vm.queryParams.sort, search: vm.queryParams.search, productCategoryId: vm.queryParams.productCategoryId})"\r\n\t\t\t                class="btn-next" ng-show="vm.prevNext.next">Next <i class="fa fa-angle-right"></i></button>\r\n\t\t\t        </div> --></div><div style="display: flex; flex-direction: column; margin: 24px"><div class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Company</div><div class="ps-sample-info-table-variable">{{ vm.customerDisplayName ? vm.customerDisplayName : \'\' }}</div></div><div class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">{{ ((brand.branding && brand.branding.display_name) || \'Lab\') + \' ID\' }}</div><div class="ps-sample-info-table-variable">{{ vm.sample.id ? vm.sample.id : \'\' }}</div></div><div ng-show="vm.view_more_sample_info"><div ng-if="vm.sample.customerOrderId" class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Order ID</div><div class="ps-sample-info-table-variable">{{ vm.sample.customerOrderId ? vm.sample.customerOrderId : \'\' }}</div></div><div ng-if="vm.sample.lotBatchNumber" class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Lot/Batch Number</div><div class="ps-sample-info-table-variable">{{ vm.sample.lotBatchNumber ? vm.sample.lotBatchNumber : \'\' }}</div></div><div ng-if="vm.sample.sampleWeight" class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Sample Wt</div><div class="ps-sample-info-table-variable">{{ vm.sample.sampleWeight ? vm.sample.sampleWeight : \'\' }}</div></div><div ng-if="vm.sample.sampleType" class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Type</div><div class="ps-sample-info-table-variable">{{ vm.sample.sampleType ? vm.sample.sampleType : \'\' }}</div></div><div ng-if="vm.sample.date" class="ps-sample-info-table-row"><div class="ps-sample-info-table-static">Date</div><div class="ps-sample-info-table-variable">{{ vm.sample.date | date }}</div></div></div><div style="text-align: center; margin-top: 24px" ng-click="vm.view_more_sample_info = !vm.view_more_sample_info"><button class="ps-show-more-btn">{{ !vm.view_more_sample_info ? \'Show More\' : \'Show Less\' }}</button></div></div><!-- <div class="row">\r\n                    <div class="col-md-12 col-sm-8 col-md-7">\r\n                        <table class="table">\r\n                            <tbody>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">Company</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.customer.company_name"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">{{ ((brand.branding && brand.branding.display_name) || \'Lab\') + \' ID\' }}</p>\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.id"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">Order ID</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.customerOrderId"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">Lot/Batch Number</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.lotBatchNumber"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr ng-if="vm.sample.sampleWeight">\r\n                                    <td>\r\n                                        <p class="table-header">Sample Wt</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.sampleWeight"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">Type</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.sampleType"></p>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <p class="table-header">Date</p>\r\n                                    </td>\r\n                                    <td>\r\n                                        <p ng-bind="vm.sample.date | date"></p>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div> --></div></div></div><!-- <div ng-show="vm.showTallView == true" ng-class="{ \'ps-hide\' : !vm.sample.potencyProfile }" class="container-fluid potency-profile">\r\n\r\n        <div class="flex align-items center">\r\n\r\n            <div>\r\n\r\n                <div class="potency-profile-header flex align-items-center">\r\n\r\n                    <h4>Potency profile</h4>\r\n\r\n                    <p test-status test="vm.potencyProfile">\r\n\r\n                </div>\r\n\r\n                <p class="info">Full spectrum cannabinoid profiling and analysis utilizing High Performance Liquid\r\n                    Chromatography (HPLC/UV).</p>\r\n\r\n            </div>\r\n\r\n            <div style="margin-left: auto;">\r\n                <a ng-click="collapse.potencyProfile= !collapse.potencyProfile">\r\n                    <i style="font-size: 18px;" ng-class="{ \'fa fa-caret-square-o-up\' : !collapse.potencyProfile, \'fa fa-caret-square-o-down\' : collapse.potencyProfile }" aria-hidden="true"></i>\r\n                </a>\r\n            </div>\r\n\r\n\r\n        </div>\r\n\r\n        <hr style="margin-bottom: 0;">\r\n        <div ng-show="vm.potencyProfile.canSeeResults && !collapse.potencyProfile">\r\n\r\n            <div class="row">\r\n\r\n                <div class="col-md-12">\r\n\r\n                    <div class="well max-width flex align-items-center bg-white">\r\n\r\n                        <span class="thc-icon"></span>\r\n\r\n                        <div class="text-center ml-2">\r\n                            <p class="text-primary semi-bold">Total THC</p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'percent_dry\'">\r\n                                {{vm.sample.totalThcDryPercent ? vm.sample.totalThcDryPercent + \' % (dry)\' : \'ND\'}}</p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'percent\'">\r\n                                {{vm.sample.totalThcPercent ? vm.sample.totalThcPercent + \' %\' : \'ND\'}}</p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/g\'">\r\n                                {{vm.sample.totalThcDryMgpg ? vm.sample.totalThcDryMgpg + \' \' + vm.potencyUnit: \'ND\'}}\r\n                            </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/ml\'">\r\n                                {{vm.sample.totalThcMgpml ? vm.sample.totalThcMgpml + \' \' + vm.potencyUnit : \'ND\'}}</p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/serving\'">\r\n                                {{vm.sample.totalThcMgpu ? vm.sample.totalThcMgpu  + \' \' + vm.potencyUnit: \'ND\'}} </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/pkg\'">\r\n                                {{vm.sample.totalThcMgpp ? vm.sample.totalThcMgpp  + \' \' + vm.potencyUnit: \'ND\'}} </p>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                    <div class="well max-width flex align-items-center bg-white">\r\n\r\n                        <span class="cbd-icon" style="width:\'100%\'"></span>\r\n\r\n                        <div class="text-center ml-2">\r\n                            <p class="text-primary semi-bold">Total CBD</p>\r\n\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'percent_dry\'">\r\n                                {{vm.sample.totalCbdDryPercent ? vm.sample.totalCbdDryPercent + \' % (dry)\' : \'ND\'}} </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'percent\'">\r\n                                {{vm.sample.totalCbdPercent ? vm.sample.totalCbdPercent + \' %\' : \'ND\'}} </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/g\'">\r\n                                {{vm.sample.totalCbdDryMgpg ? vm.sample.totalCbdDryMgpg + \' \' + vm.potencyUnit : \'ND\'}}\r\n                            </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/ml\'">\r\n                                {{vm.sample.totalCbdMgpml ? vm.sample.totalCbdMgpml + \' \' + vm.potencyUnit : \'ND\'}} </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/serving\'">\r\n                                {{vm.sample.totalCbdMgpu ? vm.sample.totalCbdMgpu + \' \' + vm.potencyUnit : \'ND\'}} </p>\r\n                            <p class="font-weight-bold text-primary" ng-if="vm.potencyUnit == \'mg/pkg\'">\r\n                                {{vm.sample.totalCbdMgpp ? vm.sample.totalCbdMgpp + \' \' + vm.potencyUnit : \'ND\'}} </p>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n\r\n            <div class="row">\r\n\r\n                <div class="col-md-12 ">\r\n\r\n                    <div class="well bg-white relative">\r\n\r\n                        <div class="select-unit-of-measure" style="width:105px;">\r\n\r\n                            <select class="select" ng-model="vm.potencyUnit" ng-init="vm.potencyUnit = \'mg/pkg\'"\r\n                                ng-change="vm.togglePotencyUnit()" ng-if="vm.sample.totalMgpp !== \'\'">\r\n                                <option value="mg/pkg" ng-if="vm.sample.totalMgpp !== \'\'">mg/pkg</option>\r\n                                <option value="mg/g" ng-if="vm.sample.totalDryMgpg !== \'\'">mg/g</option>\r\n                                <option value="mg/ml" ng-if="vm.sample.totalMgpml !== \'\'">mg/ml</option>\r\n                                <option value="mg/serving" ng-if="vm.sample.totalMgpu !== \'\'">mg/serving</option>\r\n                                <option value="percent_dry" ng-if="vm.sample.totalDryPercent !== \'\'">% (dry)</option>\r\n                                <option value="percent" ng-if="vm.sample.totalPercent !== \'\'">%</option>\r\n                            </select>\r\n\r\n                            <select class="select" ng-model="vm.potencyUnit" ng-init="vm.potencyUnit = \'percent_dry\'"\r\n                                ng-change="vm.togglePotencyUnit()" ng-if="vm.sample.totalMgpp == \'\'">\r\n                                <option value="mg/pkg" ng-if="vm.sample.totalMgpp !== \'\'">mg/pkg</option>\r\n                                <option value="mg/g" ng-if="vm.sample.totalDryMgpg !== \'\'">mg/g</option>\r\n                                <option value="mg/ml" ng-if="vm.sample.totalMgpml !== \'\'">mg/ml</option>\r\n                                <option value="mg/serving" ng-if="vm.sample.totalMgpu !== \'\'">mg/serving</option>\r\n                                <option value="percent_dry" ng-if="vm.sample.totalDryPercent !== \'\'">% (dry)</option>\r\n                                <option value="percent" ng-if="vm.sample.totalPercent !== \'\'">%</option>\r\n                            </select>\r\n\r\n                        </div>\r\n\r\n                        <div class="row">\r\n                            <div class="chart-pie-wrapper">\r\n\r\n\r\n                                <div class="chart-wrapper">\r\n                                    <div class="total">\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'mg/pkg\'">\r\n                                            {{vm.sample.totalMgpp ? vm.sample.totalMgpp + \' \' + vm.potencyUnit: \'ND\'}}\r\n                                        </h3>\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'mg/g\'">\r\n                                            {{vm.sample.totalDryMgpg ? vm.sample.totalDryMgpg + \' \' + vm.potencyUnit : \'ND\'}}\r\n                                        </h3>\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'mg/ml\'">\r\n                                            {{vm.sample.totalMgpml ? vm.sample.totalDryMgpg + \' \' + vm.potencyUnit: \'ND\'}}\r\n                                        </h3>\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'mg/serving\'">\r\n                                            {{vm.sample.totalMgpu ? vm.sample.totalMgpu + \' \' + vm.potencyUnit: \'ND\'}}\r\n                                        </h3>\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'percent_dry\'">\r\n                                            {{vm.sample.totalDryPercent ? vm.sample.totalDryPercent + \' % (dry)\': \'ND\'}}\r\n                                        </h3>\r\n                                        <h3 class="text-primary" ng-if="vm.potencyUnit == \'percent\'">\r\n                                            {{vm.sample.totalPercent ? vm.sample.totalPercent + \' %\': \'ND\'}}</h3>\r\n\r\n\r\n\r\n                                        <p class="text-primary">Total Cannabinoids</p>\r\n                                    </div>\r\n                                    <div id="pie-chart"></div>\r\n                                    <div id="pie-chart-mobile"></div>\r\n\r\n                                </div>\r\n\r\n                            </div>\r\n\r\n                            <div class="chart-wrapper-details">\r\n\r\n                                <div class="row">\r\n                                    <div class="col-md-12 col-lg-6 meta-data col-color-{{$index}}"\r\n                                        ng-repeat="item in vm.sample.potencyProfile" ng-switch on="$index % 2"\r\n                                        ng-if="item !== null">\r\n\r\n                                        <div class="flex text-primary" ng-switch-when="0">\r\n                                            <p>\r\n                                                <strong>{{ item.display_name }}</strong>\r\n                                            </p>\r\n\r\n                                            <p class="ml-auto number-result"\r\n                                                ng-class="{\'text-nd\': item.value === \'ND\' || !item.value || item.value === \'0\'}">\r\n                                                {{ (item.value ? item.twoDecimalFormattedValue : \'N/A\') && (item.value ? item.twoDecimalFormattedValue : \'N/A\') !== "0" ? (item.value ? item.twoDecimalFormattedValue + \' \' + (vm.potencyUnit !== \'percent\' && vm.potencyUnit !== \'percent_dry\' ? vm.potencyUnit : (vm.potencyUnit == \'percent_dry\' ? \'% (dry)\': \'%\')): \'N/A\') : ""}}\r\n                                            </p>\r\n\r\n                                        </div>\r\n\r\n                                        <div class="flex text-primary" ng-switch-when="1">\r\n                                            <p>\r\n                                                <strong>{{ item.display_name }}</strong>\r\n                                            </p>\r\n\r\n                                            <p class="ml-auto number-result"\r\n                                                ng-class="{\'text-nd\': item.value === \'ND\' || !item.value || item.value === \'0\'}">\r\n                                                {{ (item.value ? item.twoDecimalFormattedValue : \'N/A\') && (item.value ? item.twoDecimalFormattedValue : \'N/A\') !== "0" ? (item.value ? item.twoDecimalFormattedValue + \' \' + (vm.potencyUnit !== \'percent\' && vm.potencyUnit !== \'percent_dry\' ? vm.potencyUnit : (vm.potencyUnit == \'percent_dry\' ? \'% (dry)\': \'%\')): \'N/A\') : ""}}\r\n                                            </p>\r\n\r\n                                        </div>\r\n\r\n                                        <hr>\r\n\r\n                                    </div>\r\n\r\n                                </div>\r\n\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <div ng-show="vm.showTallView == true" ng-class="{ \'ps-hide\' : !vm.sample.terpeneProfile }" class="container-fluid terpene-profile" style="margin-bottom: 25px;">\r\n\r\n        <div class="flex align-items center">\r\n\r\n            <div>\r\n\r\n                <div class="terpene-profile-header flex align-items-center">\r\n\r\n                    <h4>Terpene profile</h4>\r\n                    <p test-status test="vm.terpeneProfile"></p>\r\n\r\n                </div>\r\n\r\n                <p class="info">Identification and quantification of terpenoids utilizing gas chromatography mass\r\n                    spectrometry (GC/MS).</p>\r\n\r\n            </div>\r\n\r\n            <div style="margin-left: auto;">\r\n                <a ng-click="collapse.terpeneProfile= !collapse.terpeneProfile">\r\n                    <i style="font-size: 18px;" ng-class="{ \'fa fa-caret-square-o-up\' : !collapse.terpeneProfile, \'fa fa-caret-square-o-down\' : collapse.terpeneProfile }" aria-hidden="true"></i>\r\n                </a>\r\n            </div>\r\n\r\n\r\n        </div>\r\n\r\n        <hr style="margin-bottom: 0;">\r\n\r\n        <div ng-show="vm.terpeneProfile.canSeeResults && !collapse.terpeneProfile">\r\n\r\n            <div class="row">\r\n                <div class="col-md-12">\r\n                    <div class="well max-width flex align-items-center">\r\n                        <span class="total-terpenes-icon"></span>\r\n\r\n                        <div class="ml-2">\r\n                            <p class="text-primary semi-bold">Total Terpenes</p>\r\n                            <h3 class="font-weight-bold text-primary">\r\n                                {{ vm.terpeneProfile.worksheetData.total_terpenes.value && vm.terpeneProfile.worksheetData.total_terpenes.value != "0" ? vm.terpeneProfile.worksheetData.total_terpenes.value + \' %\' : \'\' }}\r\n                            </h3>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class="row">\r\n                <div class="col-md-12">\r\n\r\n                    <div class="well bg-white">\r\n\r\n                        <div class="row">\r\n\r\n                            <div class="chart-2-pie-wrapper ">\r\n\r\n\r\n                                <div class="chart-2-wrapper">\r\n\r\n                                    <canvas width="300" height="300" id="circle"></canvas>\r\n\r\n                                    <div class="chart2"></div>\r\n\r\n                                </div>\r\n\r\n                                <div class="chart-legend">\r\n                                    <span class="span-col-1"><i class="blue"></i> Piney</span>\r\n                                    <span class="span-col-2"><i class="green"></i> Minty</span>\r\n                                    <span class="span-col-3"><i class="purple"></i> Sweet</span>\r\n                                    <span class="span-col-4"><i class="pink"></i> Citrus</span>\r\n                                    <span class="span-col-5"><i class="red"></i> Spicy</span>\r\n\r\n                                    <div class="chart-swiper">\r\n                                        <button id="col-prev" class="button-prev-next" disabled="disabled"></button>\r\n                                        <div> 1/2 </div>\r\n                                        <button id="col-next" class="button-prev-next"></button>\r\n                                    </div>\r\n                                </div>\r\n\r\n                            </div>\r\n\r\n                            <div class="chart-2-wrapper-details">\r\n\r\n                                <div class="row flex-order">\r\n\r\n                                    <div class="col-md-12 col-lg-6 meta-data"\r\n                                        ng-repeat="item in vm.sample.terpeneProfile" ng-switch on="$index % 3" ng-class="{\r\n\t                                    \'text-nd\': item.value === \'ND\',\r\n\t                                     \'piney\': item.taste === \'piney\',\r\n\t                                     \'minty\': item.taste === \'minty\',\r\n\t                                     \'sweet\': item.taste === \'sweet\',\r\n\t                                     \'citrus\': item.taste === \'citrus\',\r\n\t                                     \'spicy\': item.taste === \'spicy\'\r\n\t                                }">\r\n\r\n                                        <div class="flex text-primary" ng-switch-when="0">\r\n                                            <p>\r\n                                                <strong>{{ item.display_name }}</strong>\r\n                                            </p>\r\n                                            <p class="ml-auto" ng-class="{\r\n\t                                             \'text-piney\': item.taste === \'piney\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-minty\': item.taste === \'minty\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-sweet\': item.taste === \'sweet\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-citrus\': item.taste === \'citrus\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                 \'text-spicy\': item.taste === \'spicy\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                 \'text-nd\': (item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\')\r\n                                            }">\r\n                                                {{((item.value ? item.value : item.default_value) !== \'0\'?(item.value ? item.value : item.default_value): "")!= "ND"?((item.value ? item.value : item.default_value) !== \'0\' ? (item.value ? ((item.value.toLowerCase()) == "nt" ? "" : item.value) :item.default_value) : ""): "ND"}}\r\n                                                {{ item.value.toLowerCase() !== "nt" && item.value !== \'ND\' && item.value !== \'0\' && item.value ? item.units ? "&nbsp;" + item.units : item.units === "%" ? item.units : "%" : \'\' }}\r\n                                            </p>\r\n\r\n                                        </div>\r\n\r\n                                        <div class="flex text-primary" ng-switch-when="1">\r\n                                            <p>\r\n                                                <strong>{{ item.display_name }}</strong>\r\n                                            </p>\r\n                                            <p class="ml-auto" ng-class="{\r\n                                                \'text-piney\': item.taste === \'piney\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                \'text-minty\': item.taste === \'minty\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                \'text-sweet\': item.taste === \'sweet\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                \'text-citrus\': item.taste === \'citrus\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                \'text-spicy\': item.taste === \'spicy\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                \'text-nd\': (item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\')\r\n                                           }">\r\n                                                {{((item.value ? item.value : item.default_value) !== \'0\'?(item.value ? item.value : item.default_value): "")!= "ND"?((item.value ? item.value : item.default_value) !== \'0\' ? (item.value ? ((item.value.toLowerCase()) == "nt" ? "" : item.value) :item.default_value) : ""): "ND"}}\r\n                                                {{ item.value.toLowerCase() !== "nt" && item.value !== \'ND\' && item.value !== \'0\' && item.value ? item.units ? "&nbsp;" + item.units : item.units === "%" ? item.units : "%" : \'\' }}\r\n                                            </p>\r\n                                        </div>\r\n\r\n                                        <div class="flex text-primary" ng-switch-when="2">\r\n                                            <p>\r\n                                                <strong>{{ item.display_name }}</strong>\r\n                                            </p>\r\n                                            <p class="ml-auto" ng-class="{\r\n\t                                             \'text-piney\': item.taste === \'piney\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-minty\': item.taste === \'minty\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-sweet\': item.taste === \'sweet\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n\t                                             \'text-citrus\': item.taste === \'citrus\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                 \'text-spicy\': item.taste === \'spicy\' && !(item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\'),\r\n                                                 \'text-nd\': (item.value === \'ND\' || item.value.toLowerCase() == \'nt\' || item.value == \'0\')\r\n                                            }">\r\n                                                {{((item.value ? item.value : item.default_value) !== \'0\'?(item.value ? item.value : item.default_value): "")!= "ND"?((item.value ? item.value : item.default_value) !== \'0\' ? (item.value ? ((item.value.toLowerCase()) == "nt" ? "" : item.value) :item.default_value) : ""): "ND"}}\r\n                                                {{ item.value.toLowerCase() !== "nt" && item.value !== \'ND\' && item.value !== \'0\' && item.value ? item.units ? "&nbsp;" + item.units : item.units === "%" ? item.units : "%" : \'\' }}\r\n                                            </p>\r\n                                        </div>\r\n\r\n                                        <hr>\r\n\r\n                                    </div>\r\n\r\n                                </div>\r\n\r\n                            </div>\r\n\r\n                        </div>\r\n\r\n                    </div>\r\n\r\n                </div>\r\n\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </div> --><div ng-show="vm.showTallView == true"><div ng-repeat="section in vm.sections" ng-class="{ \'ps-mobile-section-expanded\' : section.expanded, \'ps-mobile-section-collapsed\' : !section.expanded }" style="margin-bottom: 24px; display: flex; flex-direction: column; align-items: center; background: white"><div class="ps-section-title" style="margin-top: 24px"><span><span style="font-family: OpenSans-Bold; text-transform: uppercase" ng-bind="vm.titleToSectionHeader(section.title)"></span> <span style="font-size: 14px; margin-left: 4px" ng-bind-html="vm.overallPf(section.overall_pf, section.overall_show_results)"></span> </span><!-- <span ng-if="(vm.sectionTested(section.overall_pf) && section.section_data.length > 0) || (section.title.toLowerCase() == \'cannabis\' && vm.cannabinoidsTested)" style="position: absolute; right: 24px;"> --> <span style="position: absolute; right: 24px"><a ng-click="section.expanded = !section.expanded"><p style="position: relative" class="ps-collapse-circle"><i class="ps-chevron" ng-class="{ \'fa fa-chevron-up ps-chevron-up\' : section.expanded, \'fa fa-chevron-down ps-chevron-down\' : !section.expanded }" aria-hidden="true"></i></p></a></span></div><div ng-show="(section.expanded && section.section_data.length > 0) || (section.expanded && section.title.toLowerCase() == \'cannabis\' && vm.cannabinoidsTested && section.overall_show_results)" class="ps-analyte-background"><div class="ps-section-description" ng-if="section.description" style="width: 100%; text-align: center">{{ section.description ? section.description : \'\' }}</div><!-- pesticides graphic --> <a ng-click="vm.sort_section(section)" style="display: flex; margin-bottom: 24px; width: 100%; justify-content: center" ng-if="section.title.toLowerCase() == \'pesticides\' && section.overall_show_results"><div style="background: #eff5fb; border-radius: 4px; padding: 8px 24px"><div style="display: flex; flex-direction: column; align-items: center"><div style="margin-left: 6px" class="pesticides-icon"></div><div style="margin: 4px 0; color: #3d5269; font-size: 12px; font-family: OpenSans-Bold">{{ section.pesticides_detected }}</div><div style="color: #647f9c; font-size: 12px; font-family: OpenSans-Semibold">Pesticides Detected</div></div></div></a><!-- terpenes graphic --><div style="display: flex; flex-direction: column; margin: 0 auto 24px auto" ng-if="section.title.toLowerCase() == \'terpenoids\' && section.overall_show_results"><div style="display: flex; margin-bottom: 24px; width: 100%; justify-content: center"><div style="background: #eff5fb; border-radius: 4px; padding: 8px 24px"><div style="display: flex; flex-direction: column; align-items: center"><div class="terpenes-icon"></div><div style="margin: 4px 0; color: #3d5269; font-size: 12px; font-family: OpenSans-Bold">{{ section.total_terpenes }}</div><div style="color: #647f9c; font-size: 12px; font-family: OpenSans-Semibold">Total Terpenes</div></div></div></div><div style="display: flex; justify-content: center"><div id="mobile-view-terpenes-chart"></div></div></div><!-- cannabis graphic --><div style="display: flex; flex-direction: column; margin-bottom: 24px; width: 100%; justify-content: center" ng-if="section.title.toLowerCase() == \'cannabis\' && section.overall_show_results"><div style="display: flex; flex-direction: row; justify-content: center; margin-bottom: 24px"><div style="background: #eff5fb; border-radius: 4px; padding: 8px 0px; width: 134px; margin-right: 8px"><div style="display: flex; flex-direction: column; align-items: center"><div class="thc-icon-public"></div><div style="text-align: center; margin: 4px 0; color: #3d5269; font-size: 12px; font-family: OpenSans-Bold">{{ section.total_thc ? section.total_thc : \'0\' }}{{ section.active_unit_frontend }}</div><div style="color: #647f9c; font-size: 12px; font-family: OpenSans-Semibold">Total THC</div></div></div><div style="background: #eff5fb; border-radius: 4px; padding: 8px 0px; width: 134px; margin-left: 8px"><div style="display: flex; flex-direction: column; align-items: center"><div class="cbd-icon-public"></div><div style="text-align: center; margin: 4px 0; color: #3d5269; font-size: 12px; font-family: OpenSans-Bold">{{ section.total_cbd ? section.total_cbd : \'0\' }}{{ section.active_unit_frontend }}</div><div style="color: #647f9c; font-size: 12px; font-family: OpenSans-Semibold">Total CBD</div></div></div></div><div style="display: flex; justify-content: center"><div id="mobile-view-cannabis-chart"></div></div><div style="position: relative; display: flex; justify-content: center"><div ng-class="{ \'ps-cannabinoid-overflow\' : section.active_unit == \'mgpu\' }" style="position: absolute; top: -115px; text-align: center; width: 160px"><div style="color: #3d5269; font-size: 15px; font-family: OpenSans-Bold">{{ section.total_cannabinoids }}{{ section.active_unit_frontend }}</div><div style="display: block; font-size: 14px; color: #3D5269">Total Cannabinoids</div></div></div></div><!-- cannabis section --><div style="margin: 0 24px; flex-direction: column" class="ps-analyte-flex-container" ng-if="section.title.toLowerCase() == \'cannabis\' && section.overall_show_results"><div style="width: 100%; text-align: center; margin-bottom: 17px"><select style="text-align-last: center; padding: 3px 6px; color: #647F9C; border: 1px solid transparent; border-radius: 3px; background-color: #EFF5FB" ng-change="vm.changeCannabinoidTotals()" ng-model="section.active_unit" name="activeCannabinoidUnit" id="activeCannabinoidUnit"><option ng-if="section.dry_percent_exists" value="dry_percent">% (dry)</option><option ng-if="section.percent_exists" value="percent">%</option><option ng-if="section.dry_mgpg_exists" value="dry_mgpg">mg/g (dry)</option><option ng-if="section.mgpg_exists" value="mgpg">mg/g</option><option ng-if="section.mgpml_exists" value="mgpml">mg/ml</option><option ng-if="section.mgpu_exists" value="mgpu">mg/serving</option><option ng-if="section.mgpp_exists" value="mgpp">mg/pkg</option></select></div><div style="display: flex; justify-content: space-between; height: 45px; border-bottom: 1px solid #e3e3e3; align-items: center" class="ps-analayte-container" ng-repeat="analyte in section.section_data[section.active_unit]"><div style="display: flex; flex: 1; justify-content: space-between" ng-class="{ \'no-analyte-value-opacity\' : !analyte.value_exists }"><div><span><i class="terpene-color-dot" ng-style="analyte.color" ng-class="{ \'no-value-dot\' : !analyte.value_exists }"></i></span><span class="ps-table-item">{{ analyte.name }}</span></div><div><span style="color: #606F7B">{{ analyte.value }}{{ analyte.units == \'%\' || analyte.units == \'% (dry)\' ? \'\' : \' \' }}{{ analyte.units }}</span></div></div></div></div><!-- terpene section --><div class="ps-analyte-flex-container" ng-if="section.title.toLowerCase() == \'terpenoids\' && section.overall_show_results"><div style="display: flex; padding: 0 24px; margin-bottom: 24px; justify-content: space-between; width: 100%; max-width: 400px"><div style="color: #8795A1"><i style="margin-right: 4px" class="terpene-color-dot piney-dot"></i>Piney</div><div style="color: #8795A1"><i style="margin-right: 4px" class="terpene-color-dot minty-dot"></i>Minty</div><div style="color: #8795A1"><i style="margin-right: 4px" class="terpene-color-dot sweet-dot"></i>Sweet</div><div style="color: #8795A1"><i style="margin-right: 4px" class="terpene-color-dot citrus-dot"></i>Citrus</div><div style="color: #8795A1"><i style="margin-right: 4px" class="terpene-color-dot spicy-dot"></i>Spicy</div></div><div class="ps-analyte-container" style="width: 100%" ng-repeat="analyte in section.section_data"><div class="ps-analyte" style="display: flex; flex: 1; justify-content: space-between" ng-class="{ \'no-analyte-value-opacity\' : !analyte.value_exists }"><span style="font-family: OpenSans-Semibold; text-transform: capitalize"><span><i class="terpene-color-dot" ng-style="analyte.color"></i></span>{{ analyte.name }} </span><span style="color: #606f7b !important" ng-class="{\'ps-analyte-gray\' : !analyte.value_exists} ">{{ analyte.value }} {{ analyte.units }}</span></div></div></div><!-- regular sections --><div class="ps-analyte-flex-container" style="width: 100%" ng-if="section.section_data.length <= vm.viewMoreLength && section.title.toLowerCase() != \'cannabis\' && section.title.toLowerCase() != \'terpenoids\'"><div class="ps-analyte-th" style="display: flex"><span style="text-align: left; width: 55%; text-transform: capitalize">Analyte </span><span ng-class="{ \'ps-no-analyte-status\' : !section.show_status }" style="width: 35%; text-align: center">Findings {{ section.units_same_for_all ? \'(\' + section.units + \')\': \'\' }} </span><span ng-if="section.show_status" style="text-align: right; width: 10%">Status</span></div><div class="ps-analyte-container" style="width: 100%" ng-repeat="analyte in section.section_data"><div class="ps-analyte" style="display: flex"><span style="text-align: left; width: 55%; font-family: OpenSans-Semibold; text-transform: capitalize">{{ analyte.name }} </span><span ng-class="{ \'ps-no-analyte-status\' : !section.show_status }" style="width: 35%; text-align: center" style="color: #606f7b !important" ng-class="{\'ps-analyte-gray\' : !analyte.value_exists} ">{{ analyte.value ? analyte.value : \'-\' }} {{ section.units_same_for_all ? \'\' : analyte.units }} </span><span ng-if="section.show_status" style="text-align: right; width: 10%"><span ng-if="!analyte.status">-</span> <i ng-if="analyte.status" style="width: unset" ng-class="{ \'test-pass fa fa-check-circle\' : analyte.status.toLowerCase() == \'pass\', \'test-fail fa fa-times-circle\' :  analyte.status.toLowerCase() == \'fail\'}"></i></span></div></div></div><div class="ps-analyte-flex-container" style="width: 100%" ng-if="section.section_data.length > vm.viewMoreLength && section.title.toLowerCase() != \'cannabis\' && section.title.toLowerCase() != \'terpenoids\'"><div class="ps-analyte-th" style="display: flex"><span style="text-align: left; width: 55%; text-transform: capitalize">Analyte </span><span style="width: 35%; text-align: center">Findings {{ section.units_same_for_all ? \'(\' + section.units + \')\': \'\' }} </span><span style="text-align: right; width: 10%">Status</span></div><div class="ps-analyte-container" ng-repeat="analyte in section.section_data.slice(0,vm.viewMoreLength)" style="width: 100%"><div class="ps-analyte" style="display: flex"><span style="text-align: left; width: 55%; font-family: OpenSans-Semibold; text-transform: capitalize">{{ analyte.name }} </span><span style="width: 35%; text-align: center" style="color: #606f7b !important" ng-class="{\'ps-analyte-gray\' : !analyte.value_exists} ">{{ analyte.value ? analyte.value : \'-\' }} {{ analyte.units }} </span><span ng-if="section.show_status" style="text-align: right; width: 10%"><span ng-if="!analyte.status">-</span> <i ng-if="analyte.status" style="width: unset" ng-class="{ \'test-pass fa fa-check-circle\' : analyte.status.toLowerCase() == \'pass\', \'test-fail fa fa-times-circle\' :  analyte.status.toLowerCase() == \'fail\'}"></i></span></div></div><div style="margin: 16px 0 9px 0; width: 100%; text-align: center; padding: 0 24px"><button class="ps-show-more-btn" ng-click="section.view_more = !section.view_more">{{ !section.view_more ? \'Show More\' : \'Show Less\' }}</button></div><div ng-show="section.view_more" class="ps-analyte-container" ng-repeat="analyte in section.section_data.slice(vm.viewMoreLength,section.section_data.length)" style="width: 100%"><div class="ps-analyte" style="display: flex"><span style="text-align: left; width: 55%; font-family: OpenSans-Semibold; text-transform: capitalize">{{ analyte.name }} </span><span style="width: 35%; text-align: center" style="color: #606f7b !important" ng-class="{\'ps-analyte-gray\' : !analyte.value_exists} ">{{ analyte.value ? analyte.value : \'-\' }} {{ analyte.units }} </span><span ng-if="section.show_status" style="text-align: right; width: 10%"><span ng-if="!analyte.status">-</span> <i ng-if="analyte.status" style="width: unset" ng-class="{ \'test-pass fa fa-check-circle\' : analyte.status.toLowerCase() == \'pass\', \'test-fail fa fa-times-circle\' :  analyte.status.toLowerCase() == \'fail\'}"></i></span></div></div></div></div></div></div><footer style="margin-top: 30px" class="container-fluid"><ul><li><a ng-href="{{ (brand.web && (brand.web.marketing_url || brand.web.portal_url)) || \'#\' }}">{{ (brand.web && brand.web.marketing_label) || ((brand.branding && brand.branding.display_name) || \'Portal\') }}</a></li><li><a href="#">FAQ</a></li><li><a href="#">About Us</a></li><li><a href="#">Contact</a></li></ul></footer></div><!-- Email Modal --><div id="emailModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\'; " class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Info via Email</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style" style="font-size: 12px"><div style="height: 150px; margin-left: 10px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.sample.picture ? vm.sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.sample.name}}</h4><p><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Sample ID:</span> {{vm.sample.id}}</p><p ng-show="vm.sample.lotBatchNumber"><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Lot/Batch Number:</span> {{vm.sample.lotBatchNumber}}</p></div></div><div style="clear:both"></div><div style="padding-left:25px;padding-right:25px"><form name="emailForm"><div class="row"><strong>Emails:</strong><br><p><input id="testtaginput" type="text" data-role="tagsinput" class="form-control" placeholder="email@example.com" name="email" ng-change="vm.setEmail()" style="width:100%" ng-model="vm.emailsPending[$index]" size="100"></p><p id="emailValidation" class="help-block" style="color: darkred;display:none">Please Enter a valid Email Address</p><br></div><div class="row"><strong>Subject</strong> <input id="emailSubject" type="text" style="width: 100%; height: 35px" value="{{vm.customerDisplayName}}, Sample ID: {{vm.sample.id}}"></div><br><div class="row"><strong>Sample Page URL</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copyPublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copyPublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div><br><div class="row"><strong>Message:</strong><p><textarea rows="4" class="form-control" ng-model="vm.emailMessage" placeholder="Optional Message"></textarea></p></div></form></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left hover-btn-blue cancel SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\';" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Close</button> <button id="sendPublicSampleButton" class="btn btn-primary pull-right" style="background-color: #4f8fcc" ng-click="vm.sendPublicEmail(emailForm)">Send</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal Success --><div id="emailModalSuccess" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.sample = null" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Email has been sent</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><div style="height: 50px; width: 315px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.sample.picture ? vm.sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.sample.name}}</h4><span><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Sample ID:</span> {{vm.sample.id}}</span></div></div><br><div style="clear: both"></div><br>You successfully shared Sample <strong>{{vm.sample.name}}</strong> with <span ng-repeat="email in vm.emailsPending track by $index"><span ng-if="$last && vm.emailsPending.length > 1">and </span><strong>{{email}}</strong><span ng-if="!$last && vm.emailsPending.length > 1">, </span></span>.</div><div class="modal-footer modal-sample-submit" style="text-align:center"><button type="button" class="btn btn-default hover-btn-blue SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.sample = null" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Share Sample Modal --><div id="shareSampleModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Page</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><button class="circle-share-btn" data-toggle="modal" data-target="#emailModal" data-dismiss="modal"><i class="fa fa-envelope circle-share-icon"></i></button><br><span style="padding-left: 2px; color: #556d85; font-family: OpenSans-SemiBold">Email</span><br><br><strong>Copy Link to Public Sample Page:</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copySamplePublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copySamplePublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/pages/public-view/publicviewlog.html','<style>.filters-div input::-webkit-outer-spin-button,\r\n\t.filters-div input::-webkit-inner-spin-button,\r\n\t#publishToWeedmapsForm input::-webkit-outer-spin-button,\r\n\t#publishToWeedmapsForm input::-webkit-inner-spin-button {\r\n\t\t/* display: none; <- Crashes Chrome on hover */\r\n\t\t-webkit-appearance: none;\r\n\t\tmargin: 0;\r\n\t\t/* <-- Apparently some margin are still there even though it\'s hidden */\r\n\t}\r\n\r\n\tbutton.btn-no-style {\r\n\t\tborder: none;\r\n\t\tbackground-color: transparent;\r\n\t\toutline: none;\r\n\t}\r\n\r\n\t.help-block {\r\n\t\tdisplay: block;\r\n\t\tmargin-top: 5px;\r\n\t\tmargin-bottom: 10px;\r\n\t\tcolor: lighten(@text-color, 25%);\r\n\t}\r\n\r\n\t.test-result-text {\r\n\t\tfont-size: 14px\r\n\t}\r\n\r\n\t#table>tbody>tr>td {\r\n\t\tpadding: 8px 0 !important;\r\n\t}\r\n\r\n\t.sub-content{\r\n\t\tdisplay: flex;\r\n        justify-content: space-between;\r\n\t}\r\n\r\n\t@media only screen and (min-width: 0px) and (max-width: 1100px) {\r\n\r\n\t.btn{\r\n\t\tpadding: 6px 6px !important;\r\n\t}\r\n\r\n\t.sub-content{\r\n\t\tdisplay: flex;\r\n        justify-content: space-between;\r\n\t}\r\n\r\n\t.sub-content .left-content{\r\n\t\tfont-size: 11px;\r\n\t}\r\n\r\n\t.sub-content .left-content .btn-static-white {\r\n\t\twidth: 100px !important;\r\n        margin-left: 5px !important;\r\n        margin-right: 5px !important;\r\n        font-size: 11px;\r\n\t}\r\n\r\n\t.sub-content .right-cotent .add-sample{\r\n\t\twidth: 96px !important;\r\n\t\tfont-size: 11px !important;\r\n\t}\r\n\r\n\t.sub-content .right-cotent .btn-static-white {\r\n\t\twidth: 118px !important;\r\n        margin-right: 5px !important;\r\n        margin-left: 5px !important;\r\n        font-size: 11px;\r\n\t}\r\n}</style><div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid"><div class="row position-tbl-responsive-control"><div class="col-lg-4 col-md-4 col-sm-6 col-xs-6" style="float:left;line-height:32px;height:32px"><div style="color: #34485C;font-family: OpenSans-Semibold"><!-- <img ng-if="vm.customerData.logo" src="{{vm.customerData.logo}}" style="width:20px;height:20px;margin-right: 5px">  --> {{vm.customerData.company_name}}</div></div><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 statuslist statuslist1"><div id="btn-sample-csv" class="btn-box-for-sample-csv"><button ng-if="vm.samples.length" type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#setCriteriaModal"><i class="fa fa-list" aria-hidden="true"></i> &nbsp; {{\'Set Criteria\' | translate}}</button> <button ng-if="!vm.samples.length" disabled="disabled" style="opacity: 50%" type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample" data-toggle="modal" data-target="#setCriteriaModal"><i class="fa fa-list" aria-hidden="true"></i> &nbsp; {{\'Set Criteria\' | translate}}</button></div></div><!-- Table dots --><div class="tbl-responsive-control" ng-show="!galleryView"><ul class="tbl-dots"></ul><div class="control-buttons"><div class="control-buttons"><button class="prev btn-controls" id="col-prev" disabled="disabled"></button> <button class="next btn-controls" id="col-next"></button></div></div></div><!--./ Table dots --><div style="clear:both"></div></div></div></div><div class="tabbackall tabbackall3 tabbackal4"><!-- tabbackall1 --><div class="sub-content"><div class="left-content"><div style="float:left;line-height: 40px">{{\'Number of entries\' | translate}}: {{vm.totalItems}}</div></div><div style="float:right" class="right-cotent"><a style="width: 130px; background-color: #4f8fcc; border: 1px solid transparent" class="btn btn-primary add-sample" data-toggle="modal" data-target="#addSamplesModal"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;{{\'Add Samples\' | translate}}&nbsp;&nbsp;</a> <a ng-if="vm.samples.length" style="width: 150px; margin-right: 15px; margin-left: 15px" class="btn btn-static-white" ng-click="vm.confirmRemove(null);"><i class="fa fa-trash-o" aria-hidden="true"></i>&nbsp;&nbsp;{{\'Remove Selected\' | translate}}&nbsp;&nbsp; </a><a ng-if="!vm.samples.length" disabled="disabled" style="pointer-events: none; opacity: 50%; width: 150px; margin-right: 15px; margin-left: 15px" class="btn btn-static-white" ng-click="vm.confirmRemove(null);"><i class="fa fa-trash-o" aria-hidden="true"></i>&nbsp;&nbsp;{{\'Remove Selected\' | translate}}&nbsp;&nbsp;</a><div ng-if="vm.samples.length" class="custom-selectbox"><select id="lunch2" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div><div ng-if="!vm.samples.length" disabled="disabled" style="opacity: 50%; pointer-events: none" class="custom-selectbox"><select id="lunch2" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div></div></div><div class="tab-content tabback" ng-switch on="vm.customerData.businessType.id"><div><div class="bigbox box-shadow-table res-box-height"><div class="table-responsive table-text-left res-data-table"><table class="samplelog-page" id="table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width: 50px; text-align: left; padding-left: 26px !important"><label ng-if="vm.samples.length" style="display: inline-block" class="checkboxContainer"><input id="selectAllPubicView" type="checkbox" ng-click="vm.selectAllPublicViewToggle()"> <span class="checkmark" style="margin-top: -8px"></span></label><label ng-if="!vm.samples.length" disabled="disabled" style="pointer-events: none; opacity: 50%; display: inline-block" class="checkboxContainer"><input disabled="disabled" id="selectAllPubicView" type="checkbox"> <span disabled="disabled" class="checkmark" style="margin-top: -8px"></span></label></th><th style="width: 375px !important; text-align:left; padding-left: 120px !important"><span style="margin-bottom: 3px; padding-right: 30px">{{\'Sample Name\' | translate}}</span></th><th style="width: 100px"><span>{{\'Sample ID\' | translate}}</span></th><th style="width: 200px"><span>{{\'Lot #\' | translate}}</span></th><th ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')" style="width: 120px"><span>THC</span></th><th ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')" style="width: 120px"><span>CBD</span></th><th style="width: 50px"><span></span></th></tr></thead><tbody></tbody></table></div><hr style="margin-top: -5px"><!-- Begin Sample Public List --><div style="width:100%"><div ng-show="vm.samples.length == 0" class="information"><div style="text-align:center; margin: 100px; color: #d3ddde">No sample has been added<br><a style="width: 130px; background-color: #4f8fcc; border: 1px solid transparent; margin-top: 15px" class="btn btn-primary" data-toggle="modal" data-target="#addSamplesModal"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;Add Samples&nbsp;&nbsp;</a></div></div><ol id="sortable" style="width:100%"><li class="public-view-item" ng-repeat="sample in vm.samples track by $index" style="width:100%" sample="{{sample}}"><table style="width:100%; height: 100%"><tbody><tr><td style="width: 50px; text-align: left; padding-left: 20px"><label class="checkboxContainer" style="display: inline-block; margin-top: 9px; margin-left: 4px"><input style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px" class="checkmark"></span></label></td><td style="width: 375px !important; text-align:left; padding-left: 20px !important"><div style="text-overflow: ellipsis;white-space: nowrap;overflow:hidden;width: 300px !important" class="sample-public-title"><a ui-sref="public({hash:sample.hash})" style="margin-right: 15px;width:70px"><img style="width:85px; max-height: 64px" loading="lazy" decoding="async" ng-src="{{ sample.picture ? sample.picture : \'content/images/loading.gif\' }}"> </a>{{sample.name}}</div></td><td style="width: 100px"><a ui-sref="public({hash:sample.hash})" style="font-family: OpenSans-Semibold !important;color:#f1b21a !important;font-size: 12px">{{sample.id}}</a></td><td style="width: 200px;font-size: 13px">{{sample.lotBatchNumber}}</td><td ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')" style="width: 120px;font-size: 20px">{{sample.thc_mgpp ? sample.thc_mgpp + \' mg\' : sample.thc_percent ? sample.thc_percent + \'%\' : \'N/A\'}}</td><td ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')" style="width: 120px;font-size: 20px">{{sample.cbd_mgpp ? sample.cbd_mgpp + \' mg\' : sample.cbd_percent ? sample.cbd_percent + \'%\' : \'N/A\'}}</td><td style="width: 50px"><a class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important;font-size: 15px" ng-click="vm.confirmRemove($event);"><i class="fa fa-trash-o" aria-hidden="true"></i></a></td></tr></tbody></table></li></ol></div><!-- End Sample Public List --></div></div><!-- FOOTER PAGE SELECTER --><div class="page-list"><div class="pull-left mobile-box-pagination" ng-if="(vm.itemsPerPage * 1) < (vm.totalItems* 1)"><uib-pagination class="pagination pageset" total-items="vm.queryCount" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="statuslist mobile-box-statuslist"><!--<div class="btn-box-for-sample-csv">\r\n                        <button type="button" type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#downloadSamplesModal">Download Samples</button>\r\n                    </div> --><div ng-show="vm.samples.length" class="custom-selectbox"><select id="lunch4" class="selectpicker select-box-padding-tiny" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="30">30</option></select></div></div></div></div></div></div><!-- SET CRITERIA MODAL --><div id="setCriteriaModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Set Criteria\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><!-- <p ng-if="vm.currentLanguage !=\'jp\'">Set criteria for samples that will be automatically added to your public page. Other samples can still\r\n\t\t\t\tbe added manually.</p>\r\n\t\t\t\t<p ng-if="vm.currentLanguage ==\'jp\'">\u30D1\u30D6\u30EA\u30C3\u30AF\u30AE\u30E3\u30E9\u30EA\u30FC\u306B\u81EA\u52D5\u7684\u306B\u8FFD\u52A0\u3055\u308C\u308B\u691C\u4F53\u306E\u6761\u4EF6\u3092\u8A2D\u5B9A\u3057\u307E\u3059\u3002\u305D\u306E\u4ED6\r\n\t\t\t\t\t\u306E\u30B5\u30F3\u30D7\u30EB\u306F\u624B\u52D5\u3067\u8FFD\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002</p>\r\n\t\t\t\t<br>\r\n\t\t\t\t<div class="row" style="margin-top: 20px">\r\n\t\t\t\t\t<div class="col-md-12">\r\n\t\t\t\t\t\t<div class="form">\r\n\t\t\t\t\t\t\t<label class="cm-label">{{\'Category\' | translate}}</label>\r\n\t\t\t\t\t\t\t<div class="custom-selectbox-big w100">\r\n\t\t\t\t\t\t\t\t<select tabindex="104" id="category" style="width: 100%"\r\n\t\t\t\t\t\t\t\tclass="selectpicker select-box-padding" ng-model="vm.sampleCriteriaCategory"\r\n\t\t\t\t\t\t\t\tmultiple="multiple" data-live-search="true" title="Select Type"\r\n\t\t\t\t\t\t\t\tng-options="category as (category.name | translate) for category in vm.productCategories track by category.id">\r\n\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t</div> --><form id="setCriteriaForm"><div class="row" style="margin-top: 50px"><div class="col-md-12"><div style="float:left"><div class="form" id="orderTypeForm"><label class="cm-label">{{\'Order Type\' | translate}}</label><div><label for="ALL"><input type="radio" name="criteriaOrderType" checked="checked" value="ALL" id="ALL"> <span class="checkBoxLabel">{{\'All\' | translate}}</span></label><br><label for="RD"><input type="radio" name="criteriaOrderType" value="RD" id="RD"> <span class="checkBoxLabel">R&D</span></label><br><label for="COMPLIANCE"><input type="radio" name="criteriaOrderType" value="COMPLIANCE" id="COMPLIANCE"> <span class="checkBoxLabel">{{\'Compliance\' | translate}}</span></label></div></div></div><div style="float:right; width: 40%"><label class="cm-label">THC % {{\'(range)\' | translate}}</label><div><input type="text" style="width: 100px" placeholder="%" name="THC_LOW" id="THC_LOW"> - <input type="text" style="width: 100px" placeholder="%" name="THC_HIGH" id="THC_HIGH"></div><label class="cm-label">CBD % {{\'(range)\' | translate}}</label><div><input type="text" style="width: 100px" placeholder="%" name="CBD_LOW" id="CBD_LOW"> - <input type="text" style="width: 100px" placeholder="%" name="CBD_HIGH" id="CBD_HIGH"></div></div></div></div><div class="row" style="margin-top: 50px"><div class="col-md-12"><div style="float:left"><div class="form"><label class="cm-label">{{\'Pass/Fail Status\' | translate}}</label><div><label><input type="checkbox" id="sampleStatusPass" value="PASS"> <span class="checkBoxLabel">{{\'Pass\' | translate}}</span></label><br><label><input type="checkbox" id="sampleStatusFail" value="FAIL"> <span class="checkBoxLabel">{{\'Fail\' | translate}}</span></label><br><label><input type="checkbox" id="sampleStatusUndetermined" value="UNDETERMINED"> <span class="checkBoxLabel">{{\'Undetermined\' | translate}}</span></label></div></div></div></div></div></form></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal" ng-click="vm.searchResultsState = \'INITIAL\'"><i class="fa fa-times" aria-hidden="true"></i> {{\'Cancel\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="vm.setCriteria()">{{\'Save\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- ADD SAMPLES MODAL --><div id="addSamplesModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Add Samples\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><form id="searchSamplesForm"><div class="row"><div class="col-md-12"><div class="form"><div class="row"><div class="youremail foodadddate datepickerdate ss-input col-md-6"><label class="cm-label">{{\'Sample Name\' | translate}}</label><input name="sampleName" type="text" placeholder="{{\'e.g.\' | translate}} Blue Dream"></div><div class="youremail foodadddate datepickerdate ss-input col-md-6"><label class="cm-label">{{\'Sample Number\' | translate}}</label><input name="id" type="text" placeholder="{{\'e.g.\' | translate}} 129302"></div></div></div><div class="form"><div class="row"><div class="youremail foodadddate datepickerdate ss-input col-md-6"><label class="cm-label">{{\'Lot Number\' | translate}}</label><input name="lotNumber" type="text" placeholder="{{\'e.g.\' | translate}} 1234567"></div><div class="youremail foodadddate datepickerdate ss-input col-md-6"><label class="cm-label">{{\'Order Number\' | translate}}</label><input name="orderId" type="text" placeholder="{{\'e.g.\' | translate}} 325462"></div></div><hr style="margin: 0px"></div><div style="text-align:right; margin-top: 20px"><button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" ng-click="vm.clearAddSampleForm(\'#searchSamplesForm\')"><i class="fa fa-times" aria-hidden="true"></i> {{\'Reset\' | translate}}</button> &nbsp &nbsp <button type="button" class="btn btn-primary addSampleBtn" ng-click="vm.searchSamples(\'#searchSamplesForm\')"><i class="fa fa-search" aria-hidden="true"></i>&nbsp; {{\'Search Samples\' | translate}}</button></div><div style="margin-top: 20px"><h4 class="information-cont information">{{\'RESULTS\' | translate}} <span class="colorblue ng-binding">({{vm.searchedSamplesLength}})</span></h4><hr style="margin-top: 20px;margin-bottom: 25px"><div ng-show="vm.searchResultsState"><div class="bigbox box-shadow-table" style="min-height: 0px !important"><div class="table-responsive table-text-left res-data-table"><table class="samplelog-page" style="width: 100%"><thead><tr style="line-height: 40px"><th style="color:#2a9ecf; width: 50px"><label ng-if="vm.searchedSamplesLength" class="checkboxContainer"><input id="selectAllSearchedSamples" type="checkbox" ng-click="vm.selectAllSearchedSamplesToggle()"> <span style="margin-top: -6px" class="checkmark"></span></label><label ng-if="!vm.searchedSamplesLength" style="pointer-events: none; opacity: 50%" disabled="disabled" class="checkboxContainer"><input disabled="disabled" id="selectAllSearchedSamples" type="checkbox"> <span disabled="disabled" style="margin-top: -6px" class="checkmark"></span></label></th><th style="color:#2a9ecf">{{\'Sample Name\' | translate}}</th><th style="color:#2a9ecf">{{\'Sample No.\' | translate}}</th><th style="color:#2a9ecf">{{\'Lot #\' | translate}}</th><th style="color:#2a9ecf">{{\'Order No.\' | translate}}</th></tr></thead><tbody><tr ng-repeat="sample in vm.searchedSamples track by $index" style="line-height: 40px"><td><label class="checkboxContainer"><input class="selectedSearchSample" type="checkbox" sample="{{sample}}"> <span style="margin-top: -6px" class="checkmark"></span></label></td><td style="white-space: nowrap;overflow:hidden;text-overflow: ellipsis">{{sample.name}}</td><td><a class="text-yellow" ui-sref="public({hash:sample.hash, search: vm.currentSearch, page: vm.page, sort: vm.sort(), productCategoryId: vm.productCategoryId, pageSize: vm.itemsPerPage})" style="font-family: OpenSans-Semibold !important; font-size: 12px" target="_blank">{{sample.id}}</a></td><td style="white-space: nowrap;overflow:hidden;text-overflow: ellipsis">{{sample.lotBatchNumber}}</td><td><a class="text-yellow" ui-sref="order-details({orderId:sample.order.id})" style="font-family: OpenSans-Semibold !important; font-size: 12px" target="_blank">{{sample.order.id}}</a></td></tr></tbody></table><div ng-if="vm.searchedSamplesLength == 0" style="text-align: center; margin-top: 30px; margin-bottom: 30px; color: #d3ddde">No samples found</div></div></div></div><!--\r\n\t\t\t\t\t\t\t\t<div ng-show="vm.searchResultsState == \'NONE\'"\r\n\t\t\t\t\t\t\t\t\tstyle="text-align: center; padding: 20px;font-family: OpenSans-Semibold !important;color:lightgray !important;font-size: 18px;">\r\n\r\n\t\t\t\t\t\t\t\t\tNo results were found\r\n\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div ng-show="vm.searchResultsState == \'INITIAL\'"\r\n\t\t\t\t\t\t\t\t\tstyle="text-align: center; padding: 20px;font-family: OpenSans-Semibold !important;color:lightgray !important;font-size: 18px;">\r\n\r\n\t\t\t\t\t\t\t\t</div> --></div></div></div></form></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true" ng-click="vm.searchResultsState = \'INITIAL\'"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary addSampleBtn" ng-click="vm.addSamples()">{{\'Add Samples\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Embed Link Modal --><div id="embedLinkModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Embed Link</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><strong>Copy the link and paste onto your webpage to display public results within your own website</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="" id="copyEmbedLink"><br></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <a class="btn btn-primary" style="margin-top: 10px" ng-click="vm.copyLink(\'copyEmbedLink\')"><i class="fa fa-files-o"></i> Copy Embed Link</a></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Share Sample Modal --><div id="shareGalleryModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Page</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><div style="width: 100%; text-align: center"><img style="width: 350px; height: 350px" src="data:image/png;base64,{{ vm.shareQRCode }}"></div><br><br><button class="circle-share-btn" data-toggle="modal" data-target="#emailModal" data-dismiss="modal"><i class="fa fa-envelope circle-share-icon"></i></button><br><span style="padding-left: 2px; color: #556d85; font-family: OpenSans-SemiBold">Email</span><br><br><strong>Copy Link to Public Sample Page:</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.getEmbedLink()}}" id="copySamplePublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copySamplePublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal --><div id="emailModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\'; " class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Company Page via Email</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style" style="font-size: 12px"><div style="padding-left:25px;padding-right:25px"><form name="emailForm"><div class="row"><strong>Emails:</strong><br><p><input id="testtaginput" type="text" data-role="tagsinput" class="form-control" placeholder="email@example.com" name="email" ng-change="vm.setEmail()" style="width:100%" ng-model="vm.emailsPending[$index]" size="100"></p><p id="emailValidation" class="help-block" style="color: darkred;display:none">Please Enter a valid Email Address</p><br></div><div class="row"><strong>Subject</strong> <input id="emailSubject" type="text" style="width: 100%; height: 35px" value="{{vm.customerData.company_name}}, Company Page"></div><br><div class="row"><strong>Company Page URL</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.getEmbedLink()}}" id="copyPublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copyPublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div><br><div class="row"><strong>Message:</strong><p><textarea rows="4" class="form-control" ng-model="vm.emailMessage" placeholder="Optional Message"></textarea></p></div></form></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left hover-btn-blue cancel SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\';" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Close</button> <button id=" sendPublicSampleButton" class="btn btn-primary pull-right" style="background-color: #4f8fcc" ng-click="vm.sendEmail(emailForm)">Send</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal Success --><div id="emailModalSuccess" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Email has been sent</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style">You successfully shared your Company Page with <span ng-repeat="email in vm.emailsPending track by $index"><span ng-if="$last && vm.emailsPending.length > 1">and </span><strong>{{email}}</strong><span ng-if="!$last && vm.emailsPending.length > 1">, </span></span>.</div><div class="modal-footer modal-sample-submit" style="text-align:center"><button type="button" class="btn btn-default hover-btn-blue SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Confirm Remove Sample/Samples --><div id="confirmRemoveSampleModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog" style="top: 25%"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 id="confirmRemoveTitle" class="modal-title">{{\'Remove Samples?\' | translate}}</h4></div><div id="confirmRemoveMessage" class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style">{{"Remove samples from Public Gallery? You can\'t undo this." | translate}}</div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default hover-btn-blue SaveSampleCancel" ng-click="" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> &nbsp; {{"Don\'t remove" | translate}}</button> <button type="button" class="btn btn-primary" id="confirmRemoveSampleButton" data-dismiss="modal"><i class="fa fa-check" aria-hidden="true"></i> &nbsp; {{\'Yes, remove\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Public View Intro Modal --><div id="publicViewIntroModal" class="modal fade invoice-modal" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Public Gallery\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall generic-modal-style" style="color: #556d85; font-size:13px; line-height: 1.75"><div style="padding-left:25px;padding-right:25px"><div class="row" ng-if="vm.currentLanguage !=\'jp\'"><p>{{ vm.companyName }} provides a <strong>\'Public Gallery\'</strong> where you can share a curated selection of results with customers, suppliers, vendors, and/or employees, while keeping the rest proprietary. This page exists as a standalone URL-encrypted webpage (so only individuals who you share the link with can access it) and can also be embedded into your existing website.</p></div><div class="row" ng-if="vm.currentLanguage ==\'jp\'">\u5F53\u793E\u72EC\u81EA\u30B5\u30FC\u30D3\u30B9\u300C\u30D1\u30D6\u30EA\u30C3\u30AF\u30AE\u30E3\u30E9\u30EA\u30FC\u300D\u306F\u3001\u9867\u5BA2\u30FB\u30B5\u30D7\u30E9\u30A4\u30E4\u30FC\u30FB\u5F93\u696D\u54E1\u306A \u3069\u3068\u5171\u6709\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 \u305D\u308C\u305E\u308C\u306E\u30EA\u30F3\u30AF\u306FURL\u6697\u53F7\u5316\u3055\u308C\u305F\u72EC\u7ACB\u3057\u305F\u30A6\u30A7\u30D6\u30DA\u30FC\u30B8\u306E\u305F\u3081\u3001\u5171\u6709\u5148\u306E \u307F\u306B\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u304C\u4ED8\u4E0E\u3055\u308C\u307E\u3059\u3002 \u307E\u305F\u3001\u304A\u5BA2\u69D8\u306E\u65E2\u5B58\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u57CB\u3081\u8FBC\u3080\u3053\u3068\u3082\u53EF\u80FD\u3067\u3059\u3002</div><div class="row"><br><br><strong style="color: #556d85; font-size:16px">{{\'Public Gallery\' | translate}}</strong><hr><p ng-if="vm.currentLanguage !=\'jp\'">The samples listed on the Public Gallery and the order in which they are listed are completely customizable.</p><p ng-if="vm.currentLanguage ==\'jp\'">\u30D1\u30D6\u30EA\u30C3\u30AF\u30AE\u30E3\u30E9\u30EA\u30FC\u306B\u63B2\u8F09\u3055\u308C\u308B\u691C\u4F53\u3084\u63B2\u8F09\u9806\u306F\u5168\u3066\u30AB\u30B9\u30BF\u30DE\u30A4\u30BA\u53EF\u80FD\u3067\u3059\u3002</p><br><ol style="line-height:30px"><li><div class="number-marker"><strong>1</strong></div><span ng-if="vm.currentLanguage !=\'jp\'">Click <strong>\'Select Action\'</strong> button to view, embed, or share the Sample Page</span> <span ng-if="vm.currentLanguage ==\'jp\'">\u300C\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u304A\u597D\u304D\u306A\u30A2\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044</span></li><li><div class="number-marker"><strong>2</strong></div><span ng-if="vm.currentLanguage !=\'jp\'">By clicking the <strong>\'Set Criteria\'</strong> button, you can automate the criteria with which samples are &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;automatically added to the page.</span> <span ng-if="vm.currentLanguage ==\'jp\'">\u7279\u5B9A\u306E\u6761\u4EF6\u306B\u4E00\u81F4\u3059\u308B\u691C\u4F53\u3092\u81EA\u52D5\u3067\u8FFD\u52A0\u3059\u308B\u306B\u306F\u300C\u6761\u4EF6\u306E\u8A2D\u5B9A\u300D\u30DC\u30BF\u30F3\u3092\u30AF \u30EA\u30C3\u30AF\u3057\u3066\u304F\u3060\u3055\u3044</span></li><li><div class="number-marker"><strong>3</strong></div><span ng-if="vm.currentLanguage !=\'jp\'">Samples can also be added manually via the <strong>\'Add Samples\'</strong> button</span> <span ng-if="vm.currentLanguage ==\'jp\'">\u300C\u691C\u4F53\u3092\u8FFD\u52A0\u300D\u30DC\u30BF\u30F3\u304B\u3089\u3044\u3064\u3067\u3082\u624B\u52D5\u3067\u8FFD\u52A0\u3067\u304D\u307E\u3059</span></li><li><div class="number-marker"><strong>4</strong></div><span ng-if="vm.currentLanguage !=\'jp\'">Remove samples by clicking the <a class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 3px 2px !important;font-size: 12px"><i class="fa fa-trash-o" aria-hidden="true"></i> </a>&nbsp;in the rightmost column</span> <span ng-if="vm.currentLanguage ==\'jp\'">\u691C\u4F53\u3092\u30D1\u30D6\u30EA\u30C3\u30AF\u30AE\u30E3\u30E9\u30EA\u30FC\u304B\u3089\u524A\u9664\u3059\u308B\u306B\u306F\u53F3\u7AEF\u306B\u3042\u308B\u25A1\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057 \u3066\u304F\u3060\u3055\u3044</span></li></ol><br><div style="text-align:center"><img style="width: 553px; height: 323px" src="content/images/public_sample_preview/public_page_config.png"></div></div><br></div></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/pages/sample-log/sample-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sample.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Sample?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/pages/sample-log/sample-detail.html','<div><h2><span>Sample</span> {{vm.sample.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.sample.name}}</span></dd><dt><span>Lot Batch Number</span></dt><dd><span>{{vm.sample.lotBatchNumber}}</span></dd><dt><span>Residual Solvent</span></dt><dd><span>{{vm.sample.residualSolventPassFail1}}</span></dd><dt><span>Other</span></dt><dd><span>{{vm.sample.other}}</span></dd><dt><span>Product Type</span></dt><dd><a ui-sref="product-type-detail({id:vm.sample.productType.id})">{{vm.sample.productType.name}}</a></dd><dt><span>Customer Order</span></dt><dd><a ui-sref="customer-order-detail({id:vm.sample.customerOrder.id})">{{vm.sample.customerOrder.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="sample-detail.edit({id:vm.sample.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/pages/sample-log/sample_log.html','<style>.filters-div input::-webkit-outer-spin-button,\r\n\t.filters-div input::-webkit-inner-spin-button,\r\n\t#publishToWeedmapsForm input::-webkit-outer-spin-button,\r\n\t#publishToWeedmapsForm input::-webkit-inner-spin-button {\r\n\t\t/* display: none; <- Crashes Chrome on hover */\r\n\t\t-webkit-appearance: none;\r\n\t\tmargin: 0; /* <-- Apparently some margin are still there even though it\'s hidden */\r\n\t}\r\n\r\n\tbutton.btn-no-style {\r\n\t\tborder: none;\r\n\t\tbackground-color: transparent;\r\n\t\toutline:none;\r\n\t}\r\n\r\n\t.help-block {\r\n\tdisplay: block;\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 10px;\r\n\tcolor: lighten(@text-color, 25%);\r\n\t}\r\n\r\n\t.test-result-text {\r\n\t\tfont-size: 14px\r\n\t}\r\n\r\n\t#table>tbody>tr>td {\r\n\t\tpadding: 8px 0!important;\r\n\t}\r\n\r\n\t.bigbox-title.title-elipsis{\r\n\t\twhite-space: nowrap;\r\n\t\twidth: 84%;\r\n\t\toverflow: hidden;\r\n\t\ttext-overflow: ellipsis;\r\n\t}\r\n\t.sample-id{\r\n\t\tmargin-left: 22px;\r\n\t}\r\n\r\n\t#toast-container {\r\n    \tposition: fixed;\r\n    \ttop: 70px;\r\n    \tright: 70px;\r\n    \tz-index: 9999;\r\n\t}\r\n\r\n\t.toast {\r\n\t\tcolor: #fff;\r\n\t\tpadding: 10px 20px;\r\n\t\tborder-radius: 4px;\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.info-toast {\r\n   \t\t background-color: #4374ac; \r\n\t}\r\n\r\n\t.error-toast {\r\n\t\tbackground-color: #db2222; \r\n\t}</style><div class="content-wrapper-x content-page-height"><div class="sub-header"><div class="container-fluid"><div class="row position-tbl-responsive-control"><div class="col-lg-4 col-md-4 col-sm-6 col-xs-6" style="float:left;line-height:32px;height:32px"><div style="color: #34485C;font-family: OpenSans-Semibold"><!-- <img ng-if="vm.customerData.logo" src="{{vm.customerData.logo}}" style="width:20px;height:20px;margin-right: 5px">  --> {{vm.customerData.company_name}}</div></div><div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 statuslist statuslist1"><div id="btn-sample-csv" class="btn-box-for-sample-csv"><button type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#downloadSamplesModal">{{\'Download Samples\' | translate}}</button></div><div style="display:inline-block; position: relative"><div class="sample-log-btn-div"><button ng-class="vm.activeWidget === \'sampleEditColumns\' ? \'btn-active\' : \'\'" ng-click="vm.toggleWidget(\'sampleEditColumns\')" type="button" class="sample-log-btn pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue"><i class="fa fa-columns"></i><i class="fa fa-caret-down"></i></button></div><div ng-show="vm.activeWidget === \'sampleEditColumns\'" class="row edit-columns-div"><div class="col-md-6"><div><input type="checkbox" ng-model="vm.sampleColumns.lotNumber" class="css-checkbox" id="toggleSampleColumnLotNumber"><label for="toggleSampleColumnLotNumber" class="css-label">{{\'Lot #\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.orderId" class="css-checkbox" id="toggleSampleColumnOrderId"><label for="toggleSampleColumnOrderId" class="css-label">{{\'Order Number\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.name" class="css-checkbox" id="toggleSampleColumnName"><label for="toggleSampleColumnName" class="css-label">{{\'Name\' | translate}}</label></div><div ng-show="vm.customerData.consolidated_business_type.includes(\'cannabis\') || vm.customerData.consolidated_business_type.includes(\'hemp\')"><input type="checkbox" ng-model="vm.sampleColumns.productCategory" class="css-checkbox" id="toggleSampleColumnCategory"><label for="toggleSampleColumnCategory" class="css-label">{{\'Category (Sub)\' | translate}}</label></div><div ng-show="!vm.customerData.consolidated_business_type.includes(\'cannabis\') && !vm.customerData.consolidated_business_type.includes(\'hemp\')"><input type="checkbox" ng-model="vm.sampleColumns.sampleMatrix" class="css-checkbox" id="toggleSampleColumnSampleMatrix"><label for="toggleSampleColumnSampleMatrix" class="css-label">{{\'Sample Matrix\' | translate}}</label></div><div ng-show="vm.sampleColumnThc"><input type="checkbox" ng-model="vm.sampleColumns.thc" class="css-checkbox" id="toggleSampleColumnThc"><label for="toggleSampleColumnThc" class="css-label">THC</label></div><div ng-show="vm.sampleColumnCbd"><input type="checkbox" ng-model="vm.sampleColumns.cbd" class="css-checkbox" id="toggleSampleColumnCbd"><label for="toggleSampleColumnCbd" class="css-label">CBD</label></div><div ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')"><input type="checkbox" ng-model="vm.sampleColumns.alkaloids" class="css-checkbox" id="toggleSampleColumnAlkaloids"><label for="toggleSampleColumnalkaloids" class="css-label">Total Alkaloids</label></div><div ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')"><input type="checkbox" ng-model="vm.sampleColumns.mitragynine" class="css-checkbox" id="toggleSampleColumnMitragynine"><label for="toggleSampleColumnMitragynine" class="css-label">Mitragynine</label></div><div ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')"><input type="checkbox" ng-model="vm.sampleColumns.sCode" class="css-checkbox" id="toggleSampleColumnMetrcID"><label for="toggleSampleColumnMetrcID" class="css-label">Metrc ID</label></div><div ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')"><input type="checkbox" ng-model="vm.sampleColumns.totalCannabinoids" class="css-checkbox" id="toggleSampleColumnTotalCannabinoids"><label for="toggleSampleColumnTotalCannabinoids" class="css-label">{{\'Total Cannabinoids\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.public" class="css-checkbox" id="toggleSampleColumnPublic"><label for="toggleSampleColumnPublic" class="css-label">Gallery</label></div></div><div class="col-md-6"><div><input type="checkbox" ng-model="vm.sampleColumns.dateReceived" class="css-checkbox" id="toggleSampleColumnReceivedDate"><label for="toggleSampleColumnReceivedDate" class="css-label">{{\'Received Date\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.dateRequired" class="css-checkbox" id="toggleSampleColumnEstimatedDueDate"><label for="toggleSampleColumnEstimatedDueDate" class="css-label">{{\'Due Date\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.dateCompleted" class="css-checkbox" id="toggleSampleColumnCompleteDate"><label for="toggleSampleColumnCompleteDate" class="css-label">{{\'Completed Date\' | translate}}</label></div><!--\r\n\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t<input type="checkbox" ng-model="vm.sampleColumns.status" class="css-checkbox" id="toggleSampleColumnPassFail">\r\n\t\t\t\t\t\t\t\t\t<label for="toggleSampleColumnPassFail" class="css-label">Pass/Fail</label>\r\n\t\t\t\t\t\t\t\t</div> --><div ng-show="!vm.customerData.consolidated_business_type.includes(\'food\') && vm.currentLanguage !==\'jp\'"><input type="checkbox" ng-model="vm.sampleColumns.weedmaps" class="css-checkbox" id="toggleSampleColumnWeedmaps"><label for="toggleSampleColumnWeedmaps" class="css-label">Publish to Weedmaps</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.downloads" class="css-checkbox" id="toggleSampleColumnDownloads"><label for="toggleSampleColumnDownloads" class="css-label">{{\'Downloads\' | translate}}</label></div><div><input type="checkbox" ng-model="vm.sampleColumns.share" class="css-checkbox" id="toggleSampleColumnShare"><label for="toggleSampleColumnShare" class="css-label">{{\'Share\' | translate}}</label></div></div></div></div><div id="btn-sample-filters" class="sample-log-btn-div"><button ng-class="vm.activeWidget === \'sampleEditFilters\' ? \'btn-active\' : \'\'" ng-click="vm.toggleWidget(\'sampleEditFilters\')" type="button" class="sample-log-btn pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue"><i class="fa fa-sliders"></i>&nbsp; {{\'Filters\' | translate}} <span ng-show="vm.totalFilters > 0">({{vm.totalFilters}})</span> <i class="fa fa-caret-down"></i></button></div><!--\r\n\t\t\t\t\t<div class="custom-selectbox margin-right-15">\r\n\r\n\t\t\t\t\t\t<select id="lunch2" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 " data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)">\r\n\t\t\t\t\t\t\t<option value="10">10</option>\r\n\t\t\t\t\t\t\t<option value="20">20</option>\r\n\t\t\t\t\t\t\t<option value="30">30</option>\r\n\t\t\t\t\t\t</select>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t--></div><!-- Table dots --><div class="tbl-responsive-control" ng-show="!galleryView"><ul class="tbl-dots"></ul><div class="control-buttons"><div class="control-buttons"><button class="prev btn-controls" id="col-prev" disabled="disabled"></button> <button class="next btn-controls" id="col-next"></button></div></div></div><!--./ Table dots --><div style="clear:both"></div><div ng-show="vm.activeWidget === \'sampleEditFilters\'" class="row tabbackall filters-div" style="border-top: 1px solid #e6ebf0; margin-top: 8px; padding-top: 8px; padding-right: 8px"><div class="col-md-12"><div class="pull-right" style="padding-right: 12px" ng-click="vm.toggleWidget(\'sampleEditFilters\')">\xD7</div></div><div class="col-md-12"><table class="filters-table"><tr><td class="filter-column"><div class="form"><label>{{\'Sample No.\' | translate}}</label><input type="number" placeholder="{{\'Enter Number\' | translate}}" class="filter-input" ng-model="vm.sampleFilters.id"></div><div class="form"><label>{{\'Order No.\' | translate}}</label><input type="number" placeholder="{{\'Enter Number\' | translate}}" class="filter-input" ng-model="vm.sampleFilters.orderId"></div></td><td class="filter-column"><div class="form"><label>{{\'Sample Name\' | translate}}:</label><input placeholder="{{\'e.g.\' | translate}} Blue Dream" class="filter-input" ng-model="vm.sampleFilters.sampleName"></div><div class="form"><label>{{\'Lot #\' | translate}}:</label><input placeholder="{{\'e.g.\' | translate}} 11232145" class="filter-input" ng-model="vm.sampleFilters.lotNumber"></div><div class="form" ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')"><label>METRC ID:</label><input placeholder="{{\'e.g.\' | translate}} 1245836556" class="filter-input" ng-model="vm.sampleFilters.metrcId"></div></td><td class="filter-column" ng-show="vm.customerType.toLowerCase().includes(\'food\')"><div class="form"><label>{{\'Sample Matrix\' | translate}}</label><input placeholder="{{\'e.g.\' | translate}} Bevarage" class="filter-input" ng-model="vm.sampleFilters.sampleMatrix"></div></td><td class="filter-column" ng-show="!vm.customerType.toLowerCase().includes(\'food\')"><div class="form"><label>{{\'Category\' | translate}}</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Category" ng-change="vm.populateTypes()" ng-model="vm.sampleFilters.category" ng-options="category as (category.name | translate) for category in vm.productCategories | lngFilterOptions:vm.currentLanguage"><option value="">{{\'Select\' | translate}}</option></select></div></div><div class="form"><label>{{\'Subcategory\' | translate}}</label><div class="custom-selectbox w100"><select class="selectpicker select-box-padding" data-live-search="true" title="Type" ng-model="vm.sampleFilters.subCategory" ng-options="productType as (productType.name | translate) for productType in vm.productTypes track by productType.id"><option value="">{{\'Select\' | translate}}</option></select></div></div></td><td class="filter-column" ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')"><div class="form"><label>{{\'Order Type\' | translate}}</label><div><label for="filterAllOrders"><input type="radio" name="filterSampleOrderType" id="filterAllOrders" checked="checked" value="ALL" ng-model="vm.sampleFilters.orderType"> <span class="css-label">{{\'All\' | translate}}</span></label></div><div><label for="filterRndOrders"><input type="radio" name="filterSampleOrderType" id="filterRndOrders" value="R&D" ng-model="vm.sampleFilters.orderType"> <span class="css-label">R&D</span></label></div><div><label for="filterComplianceOrders"><input type="radio" name="filterSampleOrderType" id="filterComplianceOrders" value="COMPLIANCE" ng-model="vm.sampleFilters.orderType"> <span class="css-label">{{\'Compliance\' | translate}}</span></label></div></div></td><td class="filter-column" ng-show="vm.thcCbdFilterOptions" ng-model="vm.thcCbdFilterOptions"><div class="form row"><div class="col-md-12"><label>THC % {{\'(range)\' | translate}}:</label></div><div class="col-md-6 filter-input-range-1"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.thcLower"></div><div class="col-md-6 filter-input-range-2"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.thcUpper"></div></div><div class="form row"><div class="col-md-12"><label>CBD % {{\'(range)\' | translate}}:</label></div><div class="col-md-6 filter-input-range-1"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.cbdLower"></div><div class="col-md-6 filter-input-range-2"><input type="number" placeholder="#" class="filter-input" ng-model="vm.sampleFilters.cbdUpper"></div></div></td><td class="filter-column"><div class="form"><label>{{\'Pass/Fail Status\' | translate}}</label><div><input id="sampleFilterIsPass" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isPass"><label for="sampleFilterIsPass" class="css-label">{{\'Pass\' | translate}}</label></div><div><input id="sampleFilterIsFail" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isFail"><label for="sampleFilterIsFail" class="css-label">{{\'Fail\' | translate}}</label></div><div><input id="sampleFilterIsUndetermined" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isUndetermined"><label for="sampleFilterIsUndetermined" class="css-label">{{\'Undetermined\' | translate}}</label></div></div></td><td class="filter-column" ng-show="!vm.customerData.consolidated_business_type.includes(\'food\')  && vm.currentLanguage !==\'jp\'"><div class="form"><label>Weedmaps Pubish Status</label><div><input id="sampleFilterIsWeedmapsPublishedSuccess" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsSuccess"><label for="sampleFilterIsWeedmapsPublishedSuccess" class="css-label">Success</label></div><div><input id="sampleFilterIsWeedmapsPublishedFail" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsFail"><label for="sampleFilterIsWeedmapsPublishedFail" class="css-label">{{\'Fail\' | translate}}</label></div><div><input id="sampleFilterIsWeedmapsPublishedNone" type="checkbox" class="css-checkbox" ng-model="vm.sampleFilters.isWeedmapsNone"><label for="sampleFilterIsWeedmapsPublishedNone" class="css-label">None</label></div></div></td><!--\r\n\t\t\t\t\t\t\t\t<td class="filter-column">\r\n\t\t\t\t\t\t\t\t\t<div class="form">\r\n\t\t\t\t\t\t\t\t\t\t<label>Public Visibility:</label>\r\n\t\t\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t\t\t<label for="filterSamplesIsPublicAndPrivate">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="filterSamplesVisiblity" id="filterSamplesIsPublicAndPrivate" checked  value="BOTH" ng-model="vm.sampleFilters.visibility">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="css-label">Both</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t\t\t<label for="filterSamplesIsPublic">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="filterSamplesVisiblity" id="filterSamplesIsPublic" value="PUBLIC" ng-model="vm.sampleFilters.visibility">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="css-label">Visible</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div>\r\n\t\t\t\t\t\t\t\t\t\t\t<label for="filterSamplesIsPrivate">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="radio" name="filterSamplesVisiblity"  id="filterSamplesIsPrivate"  value="PRIVATE" ng-model="vm.sampleFilters.visibility">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="css-label">Not Visible</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t</td> --><td class="filter-column"><div class="form"><label>{{\'Completed Date Range\' | translate}}:</label><div class="filter-input-date"><input class="filter-input" placeholder="{{\'Start Date\' | translate}}" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sampleFilters.completeDateLower" is-open="vm.datePickerOpenStatus.sampleFilterCompleteDateLower" ng-click="vm.openCalendar(\'sampleFilterCompleteDateLower\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'sampleFilterCompleteDateLower\')"></i></div><div class="filter-input-date"><input class="filter-input" placeholder="{{\'End Date\' | translate}}" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sampleFilters.completeDateUpper" is-open="vm.datePickerOpenStatus.sampleFilterCompleteDateUpper" ng-click="vm.openCalendar(\'sampleFilterCompleteDateUpper\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'sampleFilterCompleteDateUpper\')"></i></div></div></td></tr></table></div><div class="col-md-12"><div class="pull-right"><button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" ng-click="vm.toggleWidget(\'sampleEditFilters\')"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-default SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" style="margin-left: 8px" ng-show="vm.totalFilters > 0" ng-click="vm.clear()"><i class="glyphicon glyphicon-ban-circle" aria-hidden="true"></i> Clear Filters</button> <button type="button" class="btn btn-primary" style="margin-left: 8px" ng-click="vm.filterSubmit()">{{\'Apply Filters\' | translate}}</button></div></div></div></div></div></div><div class="tabbackall tabbackall3 tabbackal4"><div class="sub-content"><div class="container-fluid" style="padding-left: 0"><ul class="nav-tabs" role="tablist" style="width: 650px; text-align: center"><li id="total" class="col-sm-3 samplelog-sample-filter filter-active" role="presentation"><a ng-click="vm.switchTab(\'total\')" aria-controls="total_controls" role="presentation" data-toggle="tab">{{\'All Samples\' | translate}} <span>{{ vm.filterCounts.total }}</span></a></li><li id="isInProgress" ng-disabled="vm.filterCounts.isInProgress == 0" ng-class="{\'filter-active\' : vm.filterCounts.isInProgress > 0, \'filter-disabled\' : vm.filterCounts.isInProgress == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'isInProgress\')" aria-controls="isInProgress_controls" role="tab" data-toggle="tab">{{\'In Progress\' | translate}} <span>{{ vm.filterCounts.isInProgress }}</span></a></li><li id="isCompleted" ng-disabled="vm.filterCounts.isCompleted == 0" ng-class="{\'filter-active\' : vm.filterCounts.isCompleted > 0, \'filter-disabled\' : vm.filterCounts.isCompleted == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'isCompleted\')" aria-controls="completed_controls" role="tab" data-toggle="tab">{{\'Completed\' | translate}} <span>{{ vm.filterCounts.isCompleted }}</span></a></li><li id="starred" ng-disabled="vm.filterCounts.starred == 0" ng-class="{\'filter-active\' : vm.filterCounts.starred > 0, \'filter-disabled\' : vm.filterCounts.starred == 0}" class="col-sm-3 samplelog-sample-filter" role="presentation"><a ng-click="vm.switchTab(\'starred\')" aria-controls="starred_controls" role="tab" data-toggle="tab">{{\'Starred\' | translate}} <i class="fa fa-star"></i><span>{{ vm.filterCounts.starred }}</span></a></li><li ng-if="false" id="external_tab" class="col-sm-3 samplelog-sample-filter filter-disabled" role="presentation"><a aria-controls="external" role="tab" data-toggle="tab">External Samples <span>0</span></a></li></ul></div></div><hr style="margin: 1px 30px"><div class="sub-content"><div style="float:left;line-height: 40px">{{\'Number of entries\' | translate}}: {{vm.totalItems}}</div><div style="float:right"><div class="custom-selectbox"><select id="lunch2" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="50">50</option></select></div></div></div><div class="tab-content tabback"><div ng-show="!galleryView"><div class="bigbox box-shadow-table res-box-height"><div class="table-responsive table-text-left res-data-table"><table class="samplelog-page" id="table"><!--\r\n\t\t\t\t\t\t\t<thead ng-switch-when="1">\r\n\t\t\t\t\t\t\t\t<tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\r\n\t\t\t\t\t\t\t\t\t<th jh-sort-by="id" class="tbl-col-1">\r\n\t\t\t\t\t\t\t\t\t<span class="tablesaw-sortable-btn">File No.</span>\r\n\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-sort"></span>\r\n\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t<th jh-sort-by="description" class="tbl-col-2">\r\n\t\t\t\t\t\t\t\t\t<span class="tablesaw-sortable-btn">Sample Name</span>\r\n\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-sort"></span>\r\n\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t<th jh-sort-by="test_count" class="tbl-col-3">\r\n\t\t\t\t\t\t\t\t\t<span class="tablesaw-sortable-btn">Analysis</span>\r\n\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-sort"></span>\r\n\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t<th jh-sort-by="dateCreated" class="tbl-col-4">\r\n\t\t\t\t\t\t\t\t\t<span class="tablesaw-sortable-btn">Receive Date</span>\r\n\t\t\t\t\t\t\t\t\t<span class="glyphicon glyphicon-sort"></span>\r\n\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t<th class="tbl-col-5">\r\n\t\t\t\t\t\t\t\t\t<span class="tablesaw-sortable-btn">Downloads</span>\r\n\t\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t\t<th></th>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t</thead> --><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id" class="tbl-col-1"><span>{{\'Sample No.\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="lotBatchNumber" class="tbl-col-2" ng-show="vm.sampleColumns.lotNumber"><span>{{\'Lot #\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="order_id" class="tbl-col-3" ng-show="vm.sampleColumns.orderId"><span>{{\'Order No.\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="name" class="tbl-col-4" ng-show="vm.sampleColumns.name"><span>{{\'Name\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="productType.name" class="tbl-col-5" ng-show="vm.sampleColumns.productCategory && (vm.customerData.consolidated_business_type.includes(\'cannabis\') || vm.customerData.consolidated_business_type.includes(\'hemp\'))"><span>{{\'Category (Sub)\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="sampleMatrix" class="tbl-col-5" ng-show="vm.sampleColumns.sampleMatrix && !vm.customerData.consolidated_business_type.includes(\'cannabis\') && !vm.customerData.consolidated_business_type.includes(\'hemp\')"><span>{{\'Sample Matrix\' | translate}}</span> <span class="glyphicon glyphicon-triangle-bottom"></span></th><th ng-show="vm.sampleColumnThc && vm.sampleColumns.thc" ng-model="vm.sampleColumnThc" jh-sort-by="thc_percent" class="tbl-col-6"><span>THC</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th ng-show="vm.sampleColumnCbd && vm.sampleColumns.cbd" ng-model="vm.sampleColumnCbd" jh-sort-by="cbd_percent" class="tbl-col-7"><span>CBD</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')" ng-model="vm.sampleColumnAlkaloids" jh-sort-by="thc_percent" class="tbl-col-6"><span>Total Alkaloids</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')" ng-model="vm.sampleColumnMitragynine" jh-sort-by="cbd_percent" class="tbl-col-7"><span>Mitragynine</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="sCode" class="tbl-col-12" ng-show="vm.sampleColumns.sCode"><span>Metrc ID</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th ng-show="!vm.customerData.consolidated_business_type.includes(\'food\') && vm.sampleColumns.totalCannabinoids" class="tbl-col-8"><span>Total Cannabinoids</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="isPublic" class="tbl-col-13" ng-show="vm.sampleColumns.public"><span>Gallery</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="customerOrder.dateReceived" class="tbl-col-9" ng-show="vm.sampleColumns.dateReceived"><span>{{\'Received Date\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="customerOrder.dateRequired" class="tbl-col-10" ng-show="vm.sampleColumns.dateRequired"><span>Due Date</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th jh-sort-by="customerOrder.dateCompleted" class="tbl-col-11" ng-show="vm.sampleColumns.dateCompleted"><span>{{\'Completed Date\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><!--                             \t<th jh-sort-by="status" class="tbl-col-11" ng-show="vm.sampleColumns.status"><span>Pass/Fail</span><span class="glyphicon glyphicon-triangle-bottom"></span></th> --><th class="tbl-col-14" ng-show="vm.sampleColumns.weedmaps && !vm.customerData.consolidated_business_type.includes(\'food\')"><span>Publish to</span></th><th class="tbl-col-15" ng-show="vm.sampleColumns.downloads"><span>{{\'Downloads\' | translate}}</span><span class="glyphicon glyphicon-triangle-bottom"></span></th><th class="tbl-col-16" ng-show="vm.sampleColumns.share"><span>Share</span><span class="glyphicon glyphicon-triangle-bottom"></span></th></tr></thead><tbody><!--\r\n\t\t\t\t\t\t\t\t<tr ng-switch-when="1" ng-repeat="sample in vm.samples track by sample.id">\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-1 text-yellow"><a ui-sref="public({hash:sample.hash})">{{sample.id}}</a></td>\r\n\r\n\t\t\t\t\t\t\t\t\t<td>{{sample.name}}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-2" ng-if="sample.testCount=== 0">None</td>\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-2" ng-if="sample.testCount === 1">Single</td>\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-2" ng-if="sample.testCount > 1">Various</td>\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-3">{{sample.dateCreated | date:\'MM/dd/yyyy\'}}</td>\r\n\t\t\t\t\t\t\t\t\t<td class="tbl-col-4 select-box-right select-box-btn">\r\n\t\t\t\t\t\t\t\t\t\t<div class="w100">\r\n\t\t\t\t\t\t\t\t\t\t\t<select id="lunch3" class="selectpicker select-box-table table_select " ng-click="getAttachments (sample,sample.id)" data-live-search="true" title="Select" ng-model="sample.select" ng-change="downloadAttachment(sample.select,sample)" value="select">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<option value="" selected="selected">{{\'Select\' | translate}}</option>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<option ng-repeat="attach in sample.attachments track by attach.id" value="{{attach.id}}">{{attach.file_name}}\r\n\t\t\t\t\t\t\t\t\t\t\t\t</option>\r\n\t\t\t\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t</tr> --><tr ng-repeat="(sampleIdx, sample) in vm.samples track by sample.id"><td class="tbl-col-1"><a ng-click="toggleStarred(sample.id, sample)"><i ng-show="!sample.starred" class="fa fa-star-o favorite-button"></i><i ng-show="sample.starred" class="fa fa-star favorite-button"></i></a> <a ui-sref="public({hash:sample.hash, search: vm.currentSearch, page: vm.page, sort: vm.sort(), productCategoryId: vm.productCategoryId, pageSize: vm.itemsPerPage})" hover-sample-results hover-sample-index="{{sampleIdx}}" class="hover-sample-id">{{sample.id}}</a><div class="hover-sample-results-{{sampleIdx}} hover-sample-results-div"><!-- <table ng-if="hasCannabinoids(sample)" class="hover-potency-table" > --><table ng-if="hasCannabinoids(sample) && sample.potencyLoaded && (sample.canSeeReport || canSeeTest(sample, \'Cannabinoid Profile\')) && (sample.thcDisplay || sample.cbdDisplay || sample.totalCannabinoidsDisplay)" class="hover-potency-table"><thead><tr><th>THC</th><th>CBD</th><th>{{\'Total\' | translate}}<br>Cannabinoids</th></tr></thead><tbody><tr ng-if="sample.canSeeReport || canSeeTest(sample, \'Cannabinoid Profile\')"><td>{{ sample.thcDisplay || \'-\' }}</td><td>{{ sample.cbdDisplay || \'-\' }}</td><td>{{ sample.totalCannabinoidsDisplay || \'-\' }}</td></tr><tr ng-if="!sample.canSeeReport && !canSeeTest(sample, \'Cannabinoid Profile\')"><td>-</td><td>-</td><td>-</td></tr></tbody></table><table class="hover-tests-table"><thead><tr><th>{{\'Tests\' | translate}}</th><th>{{\'Status\' | translate}}</th></tr></thead><tbody hover-display-results sample="sample" determine-test-pf="determineTestPf"></tbody></table></div><span display-sample-status sample="sample"></span></td><td class="tbl-col-2" ng-show="vm.sampleColumns.lotNumber">{{ sample.lotBatchNumber }}</td><td class="tbl-col-3 text-yellow" ng-show="vm.sampleColumns.orderId"><a ui-sref="order-details({orderId:sample.customerOrderId})">{{sample.customerOrderId}}</a></td><td class="tbl-col-4" ng-show="vm.sampleColumns.name">{{ sample.name }}</td><td class="tbl-col-5" ng-show="vm.sampleColumns.productCategory && (vm.customerData.consolidated_business_type.includes(\'cannabis\') || vm.customerData.consolidated_business_type.includes(\'hemp\'))"><span ng-if="sample.productCategory">{{ sample.productCategory.name }}</span><p ng-if="sample.productType">({{ sample.productType.name }})</p></td><td class="tbl-col-5" ng-show="vm.sampleColumns.sampleMatrix && !vm.customerData.consolidated_business_type.includes(\'cannabis\') && !vm.customerData.consolidated_business_type.includes(\'hemp\')">{{ sample.sampleMatrix }}</td><td ng-show="vm.sampleColumnThc && vm.sampleColumns.thc" ng-model="vm.sampleColumnThc" class="tbl-col-6"><span ng-if="sample.canSeeReport || canSeeTest(sample, \'Cannabinoid Profile\')">{{ sample.thcDisplay || \'-\' }}</span></td><td ng-show="vm.sampleColumnCbd && vm.sampleColumns.cbd" ng-model="vm.sampleColumnCbd" class="tbl-col-7"><span ng-if="sample.canSeeReport || canSeeTest(sample, \'Cannabinoid Profile\')">{{ sample.cbdDisplay || \'-\' }}</span></td><td ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')" ng-model="vm.sampleColumnAlkaloids" class="tbl-col-6">{{ sample.alkaloidsDisplay || \'-\' }}</td><td ng-show="vm.customerData.consolidated_business_type.includes(\'kratom\')" ng-model="vm.sampleColumnMitragynine" class="tbl-col-6">{{ sample.mitragynineDisplay || \'-\' }}</td><td class="tbl-col-12" ng-show="vm.sampleColumns.sCode">{{ sample.sCode }}</td><td ng-show="!vm.customerData.consolidated_business_type.includes(\'food\') && vm.sampleColumns.totalCannabinoids" class="tbl-col-8"><span ng-if="canSeeTest(sample, \'Cannabinoid Profile\') || sample.canSeeReport">{{ sample.totalCannabinoidsDisplay || \'-\' }}</span></td><td class="lineheightmin tbl-col-13" ng-show="vm.sampleColumns.public" style="padding: 0 !important"><label class="switch"><input type="checkbox" ng-checked="sample.is_public" ng-model="sample.public" ng-change="vm.updateSamplePublicity(sample)"><div class="slider round"></div></label></td><td class="tbl-col-9" ng-show="vm.sampleColumns.dateReceived">{{ sample.receivedDate | utcToLocal:\'MM/dd/yyyy\' }}</td><td class="tbl-col-10" ng-show="vm.sampleColumns.dateRequired">{{ sample.dueDateDisplay || \'Not Set\' }}</td><td class="tbl-col-11" ng-show="vm.sampleColumns.dateCompleted">{{ sample.dateCompleted | utcToLocal:\'MM/dd/yyyy\' }}</td><td class="tbl-col-14" ng-show="vm.sampleColumns.weedmaps && !vm.customerData.consolidated_business_type.includes(\'food\')" style="padding: 0 !important"><a class="ss-tooltips" style="margin-left: 0"><button ng-if="sample.weedmapsState == \'SUCCESS\'" class="btn btn-no-style"><img src="/content/images/weedmaps_logo.png" style="width: 80px; height: auto; border-radius: 4px; opacity: 0.5"></button> <span ng-if="sample.weedmapsPublishStatus">{{ sample.weedmapsPublishStatus }}</span> <i ng-if="sample.weedmapsState == \'FAILED\'" class="fa fa-exclamation" style="position: absolute; top: 0"></i> <button ng-if="sample.weedmapsState != \'SUCCESS\'" class="btn btn-no-style" ng-click="vm.openWeedmapsModal(sample)"><img src="/content/images/weedmaps_logo.png" style="width: 80px; height: auto; border-radius: 4px"></button></a></td><td class="tbl-col-15 select-box-btn tbl-col-14 load-btn" ng-show="vm.sampleColumns.downloads" style="padding: 0 !important"><div ng-if="!sample.attachments"><a class="btn btn-sm btn-load btn-success select-loader" ng-click="getAttachments (sample,sample.id)"><i class="fa fa-refresh" aria-hidden="true"></i>&nbsp;{{\'Load\' | translate}}<div ng-if="vm.getAttachmentsLoader && vm.idOfSelectedSample == sample.id" class="loader"><i class="fa fa-refresh" aria-hidden="true"></i></div></a></div><div class="select-wrapper" ng-if="sample.attachments"><select id="lunch" class="selectpicker select-box-table table_select" ng-click="getAttachments(sample,sample.id)" data-live-search="true" title="Select" ng-model="sample.select" ng-change="downloadAttachment(sample.select,sample)" value="select"><option value="" ng-if="!sample.attachments.length < 1">{{\'Select\' | translate}}</option><option value="" ng-if="sample.attachments.length < 1">Empty</option><!-- <option ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && sample.canSeeReport" value="coa">{{ sample.id }}_COA_Summary.pdf</option> --><option ng-if="(vm.customerData.consolidated_business_type.includes(\'cannabis\') || vm.customerData.consolidated_business_type.includes(\'hemp\'))&& sample.canSeeReport" value="coa">{{ sample.id }}_COA_Summary.pdf</option><option ng-if="false && isWithForeignTest(sample)" value="california">{{sample.id}}_California_QR_Code_Badge.png</option><option ng-if="false && isWithCDPHETest(sample)" value="colorado">{{sample.id}}_Colorado_QR_Code_Badge.png</option><option ng-repeat="attach in sample.attachments track by attach.hash" value="{{attach.hash}}" ng-click="downloadAttachment(sample.hash, sample)">{{attach.file_name}}</option></select></div></td><td class="tbl-col-16 select-box-btn tbl-col-14 load-btn" ng-show="vm.sampleColumns.share"><a class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 3px 2px !important;font-size: 12px" data-toggle="modal" data-target="#shareSampleModal" ng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)"><i class="fa fa-share-alt"></i></a></td></tr></tbody></table></div></div></div><div ng-show="galleryView"><!-- Embed Link --><div class="row" style="text-align:center; margin-top: -15px; margin-bottom: 20px" ng-show="showEmbedLink"><input type="text" onkeydown="return false;" style="width: 300px; height: 30px; color: #28d300" value="{{vm.embedLink}}"><a class="btn btn-link" ng-click="vm.copyEmbedLink()"><i class="fa fa-copy"></i> Copy Embed Link</a></div><div ng-init="galleryStateManagerObject = []" ng-repeat="sample in vm.samples track by sample.id" class="gallery-sample-box"><div ng-init="galleryStateManagerObject[sample.id]={showShares:false, showResults: false, showReports:false}" class="bigbox box-shadow-table" style="padding-top:30px;height: 500px"><div style="line-height: 30px;margin-bottom: 10px"><h3 class="bigbox-title title-elipsis" title="{{sample.name}}" style="height: 15px"><div style="float:left; margin-right: 5px"><a ng-click="toggleStarred(sample.id, sample)"><i ng-show="!sample.starred" class="fa fa-star-o favorite-button"></i><i ng-show="sample.starred" class="fa fa-star favorite-button"></i></a></div><a style="color:#556d85" ui-sref="public({hash:sample.hash})">{{sample.name}}</a></h3><div style="float:right"><!-- <span style="font-size: 13px; color: #34485c; margin-right: 10px;float: left;" ng-show="!sample.is_public">Not Visible</span>\r\n\t\t\t\t\t\t\t\t<span style="font-size: 13px; color: #34485c; margin-right: 10px;float: left;" ng-show="sample.is_public">Visible</span> --><label class="switch" style="margin-top: -12px !important"><input type="checkbox" ng-checked="{{sample.is_public}}" ng-click="toggleVisibility(sample.id, sample)"><div class="slider round"></div></label></div><span class="sample-id"><span style="color:#2a9ecf" class="big-heading">{{\'Sample ID\' | translate}}:</span> <a ui-sref="public({hash:sample.hash})" style="font-weight: 500;color: #f1b21a !important">{{sample.id}}</a></span></div><hr style="margin-left: -15px; margin-right: -15px; margin-bottom:0px; margin-top:0px"><div style="height: 345px"><div ng-show="!galleryStateManagerObject[sample.id].showResults" style="margin-left: -15px; margin-right: -15px"><div class="photocontainer" style="position: relative !important"><a ui-sref="public({hash:sample.hash})"><img class="center-img" style="width:100%;border: 1px" ng-src="{{ sample.picture ? sample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"></a></div><table style="width:100%; border-color: white;border-collapse:separate !important; height: 50px"><thead style="color:#2a9ecf"><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center"><img style="width: 15px" src="content/images/thc-icon.png"> THC</th><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center"><img style="width: 15px" src="content/images/cbd-icon.png"> CBD</th><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center">{{\'Total\' | translate}}</th><th style="width:40%;color:#2a9ecf; text-align:center">{{\'Status\' | translate}}</th></thead><tbody><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.thcDisplay || \'-\' }}</td><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.cbdDisplay || \'-\' }}</td><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.totalCannabinoidsDisplay || \'-\' }}</td><td style="font-size: 12px; text-align:center"><p style="color: #4291CA" ng-if=\'sample.status === "COMPLETED"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Tested\' | translate}}</span></p><p class="test-pass" style="color: #28d300" ng-if=\'sample.status === "PASS"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Pass\' | translate}}</span></p><p class="test-fail" style="color: red" ng-if=\'sample.status === "FAIL"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Fail\' | translate}}</span></p><p class="test-in-progress" style="color: #ff8100" ng-if=\'sample.status === "IN_PROGRESS" && vm.hasDueDate(sample) && vm.hasReceivedDate(sample)\'><span class="fa fa-clock-o test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-not-received" style="color: gray" ng-if=\'sample.status === "IN_PROGRESS" && !vm.hasReceivedDate(sample)\'><span class="test-result-text">&nbsp;Not Received</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "IN_PROGRESS" && !vm.hasDueDate(sample) && vm.hasReceivedDate(sample)\'><span class="fa fa-stop-circle test-result-icon" style="color: gray"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "NO_STATUS"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Not Tested</span></p><p class="test-retesting" style="color: #5eb1bf" ng-if=\'sample.status === "RETESTING"\'><span class="fa fa-repeat test-result-icon"></span> <span class="test-result-text">&nbsp;Retesting</span></p><p class="test-hold" style="color: #ff6b00" ng-if=\'sample.status === "HOLD"\'><i class="fa fa-hand-paper-o test-result-icon"></i> <span class="test-result-text">&nbsp;Hold</span></p></td></tbody></table></div><div style="background-color: #f9fcfe;margin-left:-15px;margin-right:-15px; height: 100%;padding-bottom: 10px" ng-show="galleryStateManagerObject[sample.id].showResults"><div ng-show="galleryStateManagerObject[sample.id].showResults" style="background-color: #f1f7fa; padding-top:5px"><a style="float:right; margin-right: 10px" ng-click="galleryStateManagerObject[sample.id].showResults = !galleryStateManagerObject[sample.id].showResults"><i class="fa fa-times-circle"></i></a><table style="width:100%;border-color: white;border-collapse:separate !important; height: 50px"><thead style="color:#2a9ecf"><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center"><img style="width: 15px" src="content/images/thc-icon.png"> THC</th><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center"><img style="width: 15px" src="content/images/cbd-icon.png"> CBD</th><th ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="width:20%;color:#2a9ecf; text-align:center">{{\'Total\' | translate}}</th><th style="width:40%;color:#2a9ecf; text-align:center">{{\'Status\' | translate}}</th></thead><tbody><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.thcDisplay || \'-\' }}</td><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.cbdDisplay || \'-\' }}</td><td ng-if="!vm.customerData.consolidated_business_type.includes(\'food\') && hasCannabinoids(sample)" style="font-size: 14px; text-align:center">{{ sample.totalCannabinoidsDisplay || \'-\' }}</td><td style="font-size: 12px; text-align:center"><p style="color: #4291CA" ng-if=\'sample.status === "COMPLETED"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Tested\' | translate}}</span></p><p class="test-pass" style="color: #28d300" ng-if=\'sample.status === "PASS"\'><span class="fa fa-check-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Pass\' | translate}}</span></p><p class="test-fail" style="color: red" ng-if=\'sample.status === "FAIL"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'Fail\' | translate}}</span></p><p class="test-in-progress" style="color: #ff8100" ng-if=\'sample.status === "IN_PROGRESS" && vm.hasDueDate(sample) && vm.hasReceivedDate(sample)\'><span class="fa fa-clock-o test-result-icon"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-not-received" style="color: gray" ng-if=\'sample.status === "IN_PROGRESS" && !vm.hasReceivedDate(sample)\'><span class="test-result-text">&nbsp;Not Received</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "IN_PROGRESS" && !vm.hasDueDate(sample) && vm.hasReceivedDate(sample)\'><span class="fa fa-stop-circle test-result-icon" style="color: gray"></span> <span class="test-result-text">&nbsp;{{\'In Progress\' | translate}}</span></p><p class="test-in-progress" style="color: gray" ng-if=\'sample.status === "NO_STATUS"\'><span class="fa fa-times-circle test-result-icon"></span> <span class="test-result-text">&nbsp;Not Tested</span></p><p class="test-retesting" style="color: #5eb1bf" ng-if=\'sample.status === "RETESTING"\'><span class="fa fa-repeat test-result-icon"></span> <span class="test-result-text">&nbsp;Retesting</span></p><p class="test-hold" style="color: #ff6b00" ng-if=\'sample.status === "HOLD"\'><span class="fa fa-hand-paper-o test-result-icon"></span> <span class="test-result-text">&nbsp;Hold</span></p></td></tbody></table></div><hr style="margin-bottom:0px; margin-top:0px"><div style="overflow:auto; height: 259px"><table class="hover-tests-table"><thead><tr><th>{{\'Tests\' | translate}}</th><th>{{\'Status\' | translate}}</th></tr></thead><tbody style="overflow:auto; height: 100px" hover-display-results determine-test-pf="determineTestPf" sample="sample"></tbody></table></div></div></div><div><hr style="margin-left: -15px; margin-right: -15px; margin-top: 2px"><div style="vertical-align: middle"><div style="float:left"><a class="btn btn-link action-button" data-toggle="modal" data-target="#shareSampleModal" ng-click="vm.emailSamplePublicLink = vm.createSamplePublicLink(sample)" ng-class="{active: galleryStateManagerObject[sample.id].showShares}" ng-click="galleryStateManagerObject[sample.id].showShares = !galleryStateManagerObject[sample.id].showShares"><i class="fa fa-share-alt"></i></a></div><div style="float:right; vertical-align: middle"><a style="width: 80px" class="btn btn-link img-gallery-btn test-button" ng-class="{active: galleryStateManagerObject[sample.id].showResults}" ng-click="galleryStateManagerObject[sample.id].showResults = !galleryStateManagerObject[sample.id].showResults"><i class="fa {{galleryStateManagerObject[sample.id].showResults == true ? \'fa-arrow-down\' : \'fa-arrow-up\'}}"></i> {{\'Tests\' | translate}}</a> <a style="width: 115px; background-color: #4f8fcc" class="btn btn-primary img-gallery-btn" ng-if="!sample.attachments" ng-click="getAttachments (sample,sample.id)"><i class="fa fa-arrow-circle-down"></i> {{\'Download\' | translate}}</a><div class="custom-selectbox img-gallery-btn downloads-button" style="width: 115px; float:right; margin-left: 5px; margin-top: -1px" ng-if="sample.attachments"><div style="width: 100%; color: black;height: 100%" ng-click="sample.attachments.length >= 1 ? galleryStateManagerObject[sample.id].showReports = !galleryStateManagerObject[sample.id].showReports : null" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 downloads-button sample-report-selectbox"><span ng-show="sample.attachments.length == 0">Empty</span> <span ng-show="sample.attachments.length > 0">Select</span></div><div ng-show="galleryStateManagerObject[sample.id].showReports && sample.attachments" class="selectpicker select-box-padding-tiny Businesstype1 Businesstype3 Businesstype2 downloads-button" style="width:auto;position:absolute; z-index: 9"><a ng-repeat="attach in sample.attachments track by attach.hash" ng-click="downloadAttachment(attach.hash,sample)">{{attach.file_name}}<br></a></div></div></div></div></div></div></div></div><!-- FOOTER PAGE SELECTER --><div class="page-list"><div class="pull-left mobile-box-pagination" ng-if="(vm.itemsPerPage * 1) < (vm.totalItems* 1)"><uib-pagination class="pagination pageset" total-items="vm.queryCount" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div><div class="statuslist mobile-box-statuslist"><div class="btn-box-for-sample-csv"><button type="button" type="button" class="btn-sample-csv pull-right pullright5 fullbtnsmall smallsizesubmitnewsample hover-btn-blue" data-toggle="modal" data-target="#downloadSamplesModal">{{\'Download Samples\' | translate}}</button></div><div class="custom-selectbox"><select id="lunch4" class="selectpicker select-box-padding-tiny" data-live-search="true" title="10" ng-model="vm.itemsPerPage" ng-change="vm.setpagesize(vm.itemsPerPage)"><option value="10">10</option><option value="20">20</option><option value="50">50</option></select></div></div></div></div></div></div><!-- DOWNLOAD SAMPLES MODAL (CSV / COA) --><div id="downloadSamplesModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Download Samples\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><form id="downloadSamplesForm"><div class="row"><div class="col-md-12"><div class="cm-label" style="margin-bottom: 14px">In addition to the filters potentially applied, you can also set a date range to better narrow down your range of samples.</div></div><div class="col-md-12"><div class="form"><label class="cm-label">{{\'Date Range\' | translate}}</label><a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{\'Retrieves by order complete date\' | translate}}</span></a><div class="row"><div class="youremail foodadddate datepickerdate ss-input col-md-6"><input class="datepicker" placeholder="Start Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.downloadSample.startDate" is-open="vm.datePickerOpenStatus.downloadSampleStartDate" ng-click="vm.openCalendar(\'downloadSampleStartDate\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'estimated_arrival_date\')"></i></div><div class="youremail foodadddate datepickerdate ss-input col-md-6"><input class="datepicker" placeholder="End Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.downloadSample.endDate" is-open="vm.datePickerOpenStatus.downloadSampleEndDate" ng-click="vm.openCalendar(\'downloadSampleEndDate\')"> <i class="fa fa-calendar-o" aria-hidden="true" ng-click="vm.openCalendar(\'estimated_arrival_date\')"></i></div></div></div><div class="form" style="margin-top: 10px"><label for="downloadCoa"><input type="radio" name="downloadSamplesFileType" id="downloadCoa" ng-model="vm.downloadSample.type" checked="checked" value="COA"> <span class="checkBoxLabel">COA</span></label><label for="downloadCsv"><input type="radio" name="downloadSamplesFileType" id="downloadCsv" ng-model="vm.downloadSample.type" value="CSV"> <span class="checkBoxLabel">CSV</span></label></div></div><div class="col-md-12" ng-show="vm.downloadSamplesError"><div ng-if="vm.downloadSamplesErrorMsg !== \'\'" class="alert alert-danger" role="alert">{{vm.downloadSamplesErrorMsg}}</div><div ng-if="vm.downloadSamplesErrorMsg == \'\'" class="alert alert-danger" role="alert"><strong>Error:</strong> An error occurred while attempting to download samples</div></div><div class="col-md-12" ng-show="vm.downloadSamplesNull"><div class="alert alert-warning" role="alert"><strong>Warning:</strong> No samples found for given date range</div></div><div class="col-md-12" ng-show="vm.downloadSamplesJobSubmitted"><div class="alert alert-success" role="alert"><strong>Success!</strong> Your CSV export is being processed. You will receive an email with the file when it\'s ready.</div></div></div></form></div><div id="toast-container"></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal" ng-click="clearBtn()"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="vm.downloadSamples()" ng-disabled="(vm.downloadSample.type == \'CSV\' && (!vm.downloadSample.startDate || !vm.downloadSample.endDate)) || (vm.downloadSample.type != \'CSV\' && !vm.downloadSample.startDate && !vm.downloadSample.endDate)" ng-show="vm.downloadingSamples == false && !vm.downloadSamplesJobSubmitted">{{\'Submit\' | translate}}</button> <button type="button" class="btn btn-primary" disabled="disabled" ng-show="vm.downloadingSamples">Processing...</button> <button type="button" class="btn btn-success" data-dismiss="modal" ng-click="clearBtn()" ng-show="vm.downloadSamplesJobSubmitted">Done</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- PUBLISH SAMPLE TO WEEDMAPS MODAL --><div id="publishToWeedmapsModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Publish sample <span ng-if="vm.publishToWeedmapsArgs.id">{{vm.publishToWeedmapsArgs.id}}</span> to Weedmaps</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><form class="form" id="publishToWeedmapsForm"><div class="row"><div class="col-md-6"><label>Weedmaps Listing ID<span>&nbsp;*</span></label><input type="number" ng-model="vm.publishToWeedmapsArgs.weedmapsListingId" placeholder="Weedmaps Listing ID"></div><div class="col-md-6"><label>Weedmaps Menu Item Name<span>&nbsp;*</span></label><input type="text" ng-model="vm.publishToWeedmapsArgs.weedmapsMenuItemName" placeholder="Weedmaps Menu Item Name"></div><div class="col-md-6"><label>Weedmaps Menu Item Category</label><input type="text" ng-model="vm.publishToWeedmapsArgs.weedmapsMenuItemCategory" placeholder="Weedmaps Menu Item Category"></div><div class="col-md-6"><label>Weedmaps Menu Item ID</label><input type="text" ng-model="vm.publishToWeedmapsArgs.weedmapsMenuItemId" placeholder="Weedmaps Menu Item ID"></div></div></form><div class="row" style="margin-top: 8px"><div class="col-md-12" ng-show="vm.publishToWeedmapsSuccess == false"><div class="alert alert-danger" role="alert"><strong>Error:</strong> An error occurred while attempting to publish to weedmaps</div></div><div class="col-md-12" ng-show="vm.publishToWeedmapsSuccess == true"><div class="alert alert-success" role="alert"><strong>Success!</strong> Your sample has been published to Weedmaps</div></div></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="vm.publishToWeedmaps()" ng-disabled="!vm.publishToWeedmapsArgs.weedmapsListingId || !vm.publishToWeedmapsArgs.weedmapsMenuItemName" ng-show="vm.publishingToWeedmaps != true">Submit</button> <button type="button" class="btn btn-primary" disabled="disabled" ng-show="vm.publishingToWeedmaps">Publishing...</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal --><div id="emailModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\'; " class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Info via Email</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style" style="font-size: 12px"><div style="height: 150px; margin-left: 10px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.currentPublicSample.picture ? vm.currentPublicSample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.currentPublicSample.name}}</h4><p><span style="color:#2a9ecf; font-size: 12px" class="big-heading">{{\'Sample ID\' | translate}}:</span> {{vm.currentPublicSample.id}}</p><p ng-show="vm.currentPublicSample.lotBatchNumber"><span style="color:#2a9ecf; font-size: 12px" class="big-heading">Lot/Batch Number:</span> {{vm.currentPublicSample.lotBatchNumber}}</p></div></div><div style="clear:both"></div><div style="padding-left:25px;padding-right:25px"><form name="emailForm"><div class="row"><strong>Emails:</strong><br><p><input id="testtaginput" type="text" data-role="tagsinput" class="form-control" placeholder="email@example.com" name="email" ng-change="vm.setEmail()" style="width:100%" ng-model="vm.emailsPending[$index]" size="100"></p><p id="emailValidation" class="help-block" style="color: darkred;display:none">Please Enter a valid Email Address</p><br></div><div class="row"><strong>Subject</strong> <input id="emailSubject" type="text" style="width: 100%; height: 35px" value="{{vm.customerData.company_name}}, Sample ID: {{vm.currentPublicSample.id}}"></div><br><div class="row"><strong>Sample Page URL</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copyPublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copyPublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div><br><div class="row"><strong>Message:</strong><p><textarea rows="4" class="form-control" ng-model="vm.emailMessage" placeholder="Optional Message"></textarea></p></div></form></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left hover-btn-blue cancel SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; $(\'#testtaginput\').tagsinput(\'removeAll\'); $(\'#emailValidation\').hide(); $(\'#testtaginput\').tagsinput(\'input\')[0].placeholder = \'email@example.com\';" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> Close</button> <button id="sendPublicSampleButton" class="btn btn-primary pull-right" style="background-color: #4f8fcc" ng-click="vm.sendPublicEmail(emailForm)">Send</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Email Modal Success --><div id="emailModalSuccess" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Email has been sent</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><div style="height: 50px; width: 315px"><!-- Image and Sample Deets --> <img style="width:180px;float:left" ng-src="{{ vm.currentPublicSample.picture ? vm.currentPublicSample.picture : \'content/images/loading.gif\' }}" alt="Sample picture"> &nbsp;<div style="top: 70px; position: absolute; left: 245px"><h4 class="bigbox-title">{{vm.currentPublicSample.name}}</h4><span><span style="color:#2a9ecf; font-size: 12px" class="big-heading">{{\'Sample ID\' | translate}}:</span> {{vm.currentPublicSample.id}}</span></div></div><br><div style="clear: both"></div><br>You successfully shared Sample <strong>{{vm.currentPublicSample.name}}</strong> with <span ng-repeat="email in vm.emailsPending track by $index"><span ng-if="$last && vm.emailsPending.length > 1">and </span><strong>{{email}}</strong><span ng-if="!$last && vm.emailsPending.length > 1">, </span></span>.</div><div class="modal-footer modal-sample-submit" style="text-align:center"><button type="button" class="btn btn-default hover-btn-blue SaveSampleCancel" ng-click="vm.emailsPending = [\'\']; vm.emailMessage=\'\'; vm.currentPublicSample = null" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Share Sample Modal --><div id="shareSampleModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Share Sample Page</h4></div><div class="modal-body modal-sample-submit tabbackall tabbackall20 generic-modal-style"><button class="circle-share-btn" data-toggle="modal" data-target="#emailModal" data-dismiss="modal"><i class="fa fa-envelope circle-share-icon"></i></button><br><span style="padding-left: 2px; color: #556d85; font-family: OpenSans-SemiBold">Email</span><br><br><strong>Copy Link to Public Sample Page:</strong> <input type="text" onkeydown="return false;" style="width: 100%; height: 35px" value="{{vm.emailSamplePublicLink}}" id="copySamplePublicLink"><br><a class="btn btn-static-white" style="margin-top: 10px" ng-click="vm.copyLink(\'copySamplePublicLink\')"><i class="fa fa-files-o"></i> Copy Link</a></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal --><!-- Samples Tab Intro Modal --><div id="samplesTabIntroModal" class="modal fade invoice-modal" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">{{\'Samples Tab\' | translate}}</h4></div><div class="modal-body modal-sample-submit tabbackall generic-modal-style" style="color: #556d85; font-size:13px; line-height: 1.75"><div style="padding-left:25px;padding-right:25px"><div class="row" ng-if="vm.currentLanguage !=\'jp\'"><p><strong>The \'Samples\' tab</strong> organizes and provides summary data for all samples your company submitted to our lab. There are two interfaces with which to interact with this data: the <strong>Table View</strong> and <strong>Gallery View</strong>. Both views permit the user to download files (COAs, labels, QR codes, pictures, more), filter samples, view test status, export reports/data, and view basic information about the samples. However, each interface has unique features as well.</p></div><div class="row" ng-if="vm.currentLanguage ==\'jp\'">\u3053\u306E\u201D\u691C\u67FB\u5C65\u6B74\u201D\u30BF\u30D6\u3067\u306F\u3001\u304A\u5BA2\u69D8\u304C\u30AA\u30FC\u30C0\u30FC\u3057\u305F\u691C\u4F53\u306B\u95A2\u3059\u308B\u60C5\u5831\u3092\u6574\u7406\u3057\u3001\u30C6\u30FC\u30D6\u30EB \u30D3\u30E5\u30FC\u3068\u30AE\u30E3\u30E9\u30EA\u30FC\u30D3\u30E5\u30FC\u3068\u3044\u3046 2\u3064\u306E\u8868\u793A\u65B9\u6CD5\u3067\u3054\u89A7\u3044\u305F\u3060\u3051\u307E\u3059\u3002 \u3069\u3061\u3089\u306E\u30D3\u30E5\u30FC\u3067\u3082\u3001\u30D5\u30A1\u30A4\u30EB\uFF08 COA\u3001\u30E9\u30D9\u30EB\u3001QR\u30B3\u30FC\u30C9\u3001\u753B\u50CF\u306A\u3069\uFF09\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3001\u30B5\u30F3\u30D7\u30EB \u306E\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u3001\u691C\u67FB\u72B6\u6CC1\u306E\u8868\u793A\u3001\u30EC\u30DD\u30FC\u30C8 /\u30C7\u30FC\u30BF\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3001\u304A\u3088\u3073\u691C\u4F53\u306E\u57FA\u672C\u60C5\u5831 \u306E\u8868\u793A\u3092\u884C\u3046\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002 \u4EE5\u4E0B\u306B\u305D\u308C\u305E\u308C\u306E\u8868\u793A\u65B9\u6CD5\u306E\u7279\u5FB4\u3084\u72EC\u81EA\u6A5F\u80FD\u3092\u3054\u7D39\u4ECB\u3057\u307E\u3059\u3002</div><div class="row"><br><br><strong style="color: #556d85; font-size:16px">{{\'TABLE VIEW\' | translate}}</strong> {{\'unique features\' | translate}}<hr><ol style="line-height:30px"><li><div class="number-marker"><strong>1</strong></div>{{\'View the results of more samples at one time\' | translate}}</li><li><div class="number-marker"><strong>2</strong></div>{{\'Star samples for easy viewing later\' | translate}} <i class="fa fa-star-o favorite-button"></i> <i class="fa fa-star favorite-button"></i></li><li><div class="number-marker"><strong>3</strong></div>{{\'Configure columns to quickly view the data that is important to you\' | translate}} &nbsp;&nbsp; <a style="width: 50px" class="btn btn-link"><i class="fa fa-columns"></i>&nbsp;&nbsp;<i class="fa fa-caret-down"></i></a></li><li ng-if="vm.currentLanguage !=\'jp\'"><div class="number-marker"><strong>4</strong></div>Publish results to Weedmaps <img src="/content/images/weedmaps_logo.png" style="width: 80px; height: auto; border-radius: 4px"></li></ol><div style="text-align:center"><img src="content/images/public_sample_preview/graphic_table_view.png"></div></div><div class="row"><br><br><strong style="color: #556d85; font-size:16px">{{\'GALLERY VIEW\' | translate}}</strong> {{\'unique features\' | translate}}<hr><ol style="line-height:30px"><li><div class="number-marker"><strong>1</strong></div>{{\'View sample images\' | translate}}</li><li ng-if="vm.currentLanguage !=\'jp\'"><div class="number-marker"><strong>2</strong></div>Share the results of a sample via email via the <a class="btn btn-link action-button"><i class="fa fa-share-alt"></i></a> icon</li><li ng-if="vm.currentLanguage ==\'jp\'"><div class="number-marker"><strong>2</strong></div><a class="btn btn-link action-button"><i class="fa fa-share-alt"></i></a> \u30A2\u30A4\u30B3\u30F3\u304B\u3089\u30E1\u30FC\u30EB\u3067\u306E\u691C\u67FB\u7D50\u679C\u306E\u30B7\u30A7\u30A2\u304C\u53EF\u80FD</li><!-- <li><div class="number-marker"> <strong>3</strong></div> Toggle the visibility of results on the Public Gallery &nbsp;\r\n\r\n\t\t\t\t\t\t<div style = "display: inline-block; line-height: 30px; vertical-align:center; padding-top: 5px; position: absolute">\r\n\t\t\t\t\t\t\t<label class="switch" style="margin-top: -12px !important;">\r\n\t\t\t\t\t\t\t\t<input type="checkbox" disabled checked>\r\n\t\t\t\t\t\t\t\t\t<div class="slider round"></div>\r\n\t\t\t\t\t\t\t\t</input>\r\n\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t<label class="switch" style="margin-top: -12px !important;">\r\n\t\t\t\t\t\t\t\t<input type="checkbox" disabled>\r\n\t\t\t\t\t\t\t\t\t<div class="slider round"></div>\r\n\t\t\t\t\t\t\t\t</input>\r\n\t\t\t\t\t\t\t</label>\r\n\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</li> --></ol><div style="text-align:center"><img src="content/images/public_sample_preview/graphic_gallery_view.png"></div></div><div class="row"><br><br><p>{{\'For more granular information on a given sample, click on the hyperlinked Sample ID number\' | translate}}</p></div><br></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><button type="button" class="btn btn-default pull-left hover-btn-blue SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> {{\'Close\' | translate}}</button></div></div><!-- /.modal-content --></div><!-- /.modal-dialog --></div><!-- /.modal -->');
$templateCache.put('app/pages/sample-log/samplelog-columns-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header modal-sample-submit"><div class="topbuffer1"></div><h2 class="modal-title pull-left samplemodaltitle">Edit Sample Columns</h2><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><div class="devider"><div class="topbuffer2"></div><div class="row form"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><ul ui-sortable="vm.sortableOptions" ng-model="vm.columns"><li ng-repeat="col in vm.columns" class="sample-col-item"><input ng-model="vm.columns[$index].shown" type="checkbox"> {{ col.display_name }}</li></ul></div></div></div><div class="line-div"></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><div class="topbuffer2"></div><div class="topbuffer2"></div><button tabindex="122" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-click="vm.save()">&nbsp; Save Columns</button><div class="topbuffer2"></div></div></form>');
$templateCache.put('app/pages/sample-log/samplelog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><div class=""><div class="topbuffer1"></div><h3 class="modal-title pull-left samplemodaltitle">{{ ((brand.branding && brand.branding.display_name) || \'Lab\') + \' \' + vm.sample.name + \' #\' + vm.sample.id }}</h3><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i><!--<button class="btn btn-primary pull-right SaveSample"><i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; <span>Save Sample</span></button>--></div></div><div class="modal-body"><div class="tabbackall tabbackall10"><div class="tab-content tabback tabback36 popuptabelist"><div class="file-status" align="center"><div class="topbuffer5"></div><div class="bigsizepopup"><div class="row bs-wizard" style="border-bottom:0"><div class="col-xs-1"></div><div class="col-xs-2 bs-wizard-step complete popupsize2"><div class="text-center bs-wizard-stepnum">File Created</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">1</a><div class="bs-wizard-info text-center">Completed on:<br><span>05/08/2016</span></div></div><div class="col-xs-2 bs-wizard-step active popupsize2"><div class="text-center bs-wizard-stepnum">Sample Received</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">2</a><div class="bs-wizard-info text-center">In progres</div></div><div class="col-xs-2 bs-wizard-step disabled popupsize2"><div class="text-center bs-wizard-stepnum">Assigned Analyst</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">3</a><div class="bs-wizard-info text-center"></div></div><div class="col-xs-2 bs-wizard-step disabled popupsize2"><div class="text-center bs-wizard-stepnum">{{\'Preliminary Results\' | translate}}</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">4</a><div class="bs-wizard-info text-center"></div></div><div class="col-xs-2 bs-wizard-step disabled popupsize2"><div class="text-center bs-wizard-stepnum">{{\'Completed\' | translate}}</div><div class="progress progress2"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">5</a><div class="bs-wizard-info text-center"></div></div></div></div><div class="smallsizepopup"><div class="row bs-wizard" style="border-bottom:0"><div class="col-xs-1 smalltablecol1"></div><div class="col-xs-3 bs-wizard-step complete smallwizardstep"><div class="text-center bs-wizard-stepnum">&nbsp;</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">1</a><div class="bs-wizard-info text-center">&nbsp;</div></div><div class="col-xs-3 bs-wizard-step active smallwizardstep"><div class="text-center bs-wizard-stepnum">Sample Received</div><div class="progress"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">2</a><div class="bs-wizard-info text-center">In progres</div></div><div class="col-xs-3 bs-wizard-step disabled smallwizardstep"><div class="text-center bs-wizard-stepnum">&nbsp;</div><div class="progress res-table-size"><div class="progress-bar"></div></div><a href="#" class="bs-wizard-dot">3</a><div class="bs-wizard-info text-center"></div></div></div></div><!--<img src="images/pagermobile.png" class="img-responsive mobilesizeimg"/>--><div class="topbuffer3"></div></div><div class="tables"><div class="centr clearfix"><div class="col-lg-5 col-md-5 col-sm-12 col-xs-12"><div class="table1"><div class="tabbackall tabbackall1 tabbackall2"><div class="tab-content tabcontent28"><div class="table-responsive"><table class="table table-bordered"><tbody><tr><td class="text-left-side">Product</td><td class="text-right-side">Lasagna</td></tr><tr><td class="text-left-side">Brand</td><td class="text-right-side">Zineth</td></tr><tr><td class="text-left-side">Submitted By</td><td class="text-right-side">Jon Stamos</td></tr><tr><td class="text-left-side">Service</td><td class="text-right-side">Routine 10</td></tr><tr><td class="text-left-side">Due Date</td><td class="text-right-side">10/20/16</td></tr></tbody></table></div></div></div></div></div><div class="col-lg-7 col-md-7 col-sm-12 col-xs-12"><div class="w3-content w3-display-container"><div id="slider"><a class="left carousel-control w3-btn-floating w3-display-left control_prev">&#10094;</a> <a class="right carousel-control w3-btn-floating w3-display-right control_next">&#10095;</a><ul><li><img class="mySlides" src="images/img1.png"></li><li><img class="mySlides" src="images/img2.png"></li><li><img class="mySlides" src="images/img1.png"></li><li><img class="mySlides" src="images/img2.png"></li></ul></div></div></div></div><div class="tabbackall clearfix"><div class="tabback"><div class="bigbox box-shadow-table table-height"><div class="table-responsive table-text-left res-data-table view-invo-table"><table class="table table-bordered tablesaw-stack tablesaw-sortable tablesaw tablesaw-swipe" data-tablesaw-sortable="" data-tablesaw-sortable-switch="" data-tablesaw-mode="swipe" data-tablesaw-minimap="" id="tablesaw-1431"><thead><tr><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="persist" class="tablesaw-cell-persist tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Sample Description</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-sortable-default-col="" data-tablesaw-priority="3" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Analysis</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="false" data-tablesaw-priority="2" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn">Department</button></th><th data-tablesaw-sortable-col="" data-sortable-numeric="" data-tablesaw-priority="1" class="tablesaw-sortable-head"><button class="tablesaw-sortable-btn tablesaw-sortable-btnlast">Downloads</button></th></tr></thead><tbody><tr><td>Suspension, P1<br>Suspension, P2</td><td>Potency Profile (GC - FID)</td><td>Gas Chromatography</td><td class="select-box-right"><a href="#"><img src="images/pdf.png" alt="pdf"></a></td></tr><tr><td>Suspension, P1</td><td>Residual Solvent - Ethanol</td><td>Gas Chromatography</td><td class="select-box-right"><a href="#"><img src="images/pdf.png" alt="pdf"></a></td></tr></tbody></table></div></div></div></div></div></div></div></div><div class="modal-footer"></div></form><script src="app/pages/sample-log/slider.js"></script>');
$templateCache.put('app/pages/sample-submit/dialog.comp.samplesubmit.html','<form name="editForm" role="form" novalidate><div class="modal-header modal-sample-submit"><div class="topbuffer1"></div><h2 class="modal-title pull-left samplemodaltitle">New Sample</h2><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i><!--<button class="btn btn-primary SaveSample SaveSample1 savemargin topbtnsubmitsave"><i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; <span>Save Sample</span></button>--></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><div class="devider"><div class="topbuffer2"></div><div class="row form"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Matrix <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="104" id="sampleType" class="selectpicker select-box-padding" data-live-search="true" title="Select Phase" ng-model="vm.sample.phase" ng-options="phase.value as phase.name for phase in vm.phases track by phase.id"><option value="">Select Matrix</option></select></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Inhalable/Non-Inhalable <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="107" id="inhalable_edible" class="selectpicker select-box-padding" data-live-search="true" title="Select Inhalable/Non-Inhalable" ng-model="vm.sample.inhalableEdible" ng-options="inhalable_edible.value as inhalable_edible.name for inhalable_edible in vm.inhalable_edible_array track by inhalable_edible.id"><option value="">Select Inhalable/Non-Inhalable</option></select></div></div></div><div class="row form"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Sample Name <span>&nbsp;*</span></label><input autofocus tabindex="101" type="text" ng-model="vm.sample.name"><div class="topbuffer2"></div><label>Product Category <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="103" id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Select Category" ng-change="vm.populateTypes()" ng-model="vm.sample.productCategory" ng-options="category as category.name for category in vm.productCategories track by category.id"><option value="">Select Category</option></select></div><div class="topbuffer2"></div><div class="strain-name-box"><label>Strain name</label><input tabindex="105" type="text" placeholder="Optional" ng-model="vm.sample.strainName.name" ng-change="vm.loadStrains()"><div class="popup live-search" ng-show="vm.suggestedStrains.length > 0"><div class="popuptext" id="myPopup"><span ng-repeat="strain in vm.suggestedStrains track by strain.id" ng-click="vm.setStrainName(strain.name)">{{strain.name}}<br></span></div></div></div><div class="topbuffer2"></div><label>Label Claims</label><input placeholder="Optional" tabindex="101" type="text" ng-model="vm.sample.labelClaims"><div class="topbuffer2"></div><label>METRC ID<span></span></label><input tabindex="107" type="text" placeholder="Optional" ng-model="vm.sample.sCode"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres" s><div class="topbuffer2"></div><label>Lot/Batch #<span>&nbsp;*</span></label><input tabindex="102" type="text" placeholder="" ng-model="vm.sample.lotBatchNumber"><div class="topbuffer2"></div><label>Product Type <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="104" id="sampleType" class="selectpicker select-box-padding" data-live-search="true" title="Select Type" ng-model="vm.sample.productType" ng-options="productType as productType.name for productType in vm.productTypes track by productType.id"><option value="">Select Type</option></select></div><div class="topbuffer2"></div><label>Strain Type</label><div class="custom-selectbox-big w100"><select tabindex="106" id="straintyperer" class="selectpicker select-box-padding" data-live-search="true" title="Select Type" ng-model="vm.sample.strainType" ng-options="strainType as strainType.name for strainType in vm.strainTypes track by strainType.id"><option value="">Select Strain Type</option></select></div><div class="topbuffer2"></div><label>Product Specifications</label><input placeholder="Optional" tabindex="101" type="text" ng-model="vm.sample.expectedPotency"><div class="topbuffer5"></div><input type="checkbox" ng-model="vm.sample.addTerpenes">&nbsp;<label>Add Terpenoid Profile</label></div></div></div><div class="topbuffer2"></div><div class="form" style="display:flex"><div><label for="prodBatch"><input tabindex="109" type="radio" name="batchType" ng-model="vm.sample.batchType" id="prodBatch" checked="checked" value="PRODUCT_BATCH" ng-change="vm.resetProductAndHarvestInputs(vm.sample.batchType)"> <span class="checkBoxLabel">Product Batch</span></label><label for="harvBatch"><input tabindex="110" type="radio" name="batchType" ng-model="vm.sample.batchType" id="harvBatch" checked="checked" value="HARVEST_BATCH" ng-change="vm.resetProductAndHarvestInputs(vm.sample.batchType)"> <span class="checkBoxLabel">Harvest Batch</span></label></div></div><div class="row form"><div ng-if="vm.sample.batchType == \'PRODUCT_BATCH\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Product Batch Size (Units)<span>&nbsp;*</span></label><input tabindex="111" type="text" placeholder="" ng-model="vm.sample.productBatchSize"></div><div ng-if="vm.sample.batchType == \'PRODUCT_BATCH\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Manufacture Date</label><div class="datepickerdate"><input placeholder="Optional" class="datepicker" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sample.manufactureDate" is-open="vm.datePickerOpenStatus.manufactureDate" ng-click="vm.openCalendar(\'manufactureDate\')"></div></div><div ng-if="vm.sample.batchType == \'HARVEST_BATCH\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Harvest Batch Size (lbs)<span>&nbsp;*</span></label><input tabindex="111" type="text" placeholder="" ng-model="vm.sample.harvestBatchSize"></div><div ng-if="vm.sample.batchType == \'HARVEST_BATCH\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Harvest Date</label><div class="datepickerdate"><input placeholder="Optional" class="datepicker" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sample.harvestDate" is-open="vm.datePickerOpenStatus.harvestDate" ng-click="vm.openCalendar(\'harvestDate\')"></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Unit Weight (g) <span ng-if="vm.sample.batchType == \'HARVEST_BATCH\'">(if packaged)</span> <span ng-if="vm.sample.batchType == \'PRODUCT_BATCH\'">&nbsp;*</span></label><input tabindex="113" type="text" placeholder="" ng-model="vm.sample.sampleWeightPerIncrement"></div></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><div class="topbuffer2"></div><button tabindex="123" ng-click="vm.clear()" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> &nbsp; &nbsp; Cancel &nbsp; &nbsp; &nbsp;</button><div class="topbuffer2"></div><button tabindex="121" class="btn btn-default default10 samplemarging hover-btn-blue SaveSampleAnother" ng-disabled="\n                    !vm.sample.productType ||\n                    !vm.sample.inhalableEdible ||\n                    !vm.sample.lotBatchNumber.trim() ||\n                    !vm.sample.productCategory ||\n                    !vm.sample.phase ||\n                    !vm.sample.name.trim() ||\n                    (vm.sample.batchType == \'HARVEST_BATCH\' && !vm.sample.harvestBatchSize.trim()) ||\n                    (vm.sample.batchType == \'PRODUCT_BATCH\' && (!vm.sample.productBatchSize.trim() || !vm.sample.sampleWeightPerIncrement.trim()))" ng-click="vm.save(2)"><i class="fa fa-plus" aria-hidden="true"></i> &nbsp; &nbsp; Save Sample and Add Another</button> <button tabindex="122" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-disabled="\n                    !vm.sample.productType ||\n                    !vm.sample.inhalableEdible ||\n                    !vm.sample.lotBatchNumber.trim() ||\n                    !vm.sample.productCategory ||\n                    !vm.sample.phase ||\n                    !vm.sample.name.trim() ||\n                    (vm.sample.batchType == \'HARVEST_BATCH\' && !vm.sample.harvestBatchSize.trim()) ||\n                    (vm.sample.batchType == \'PRODUCT_BATCH\' && (!vm.sample.productBatchSize.trim() || !vm.sample.sampleWeightPerIncrement.trim()))" ng-click="vm.save(1)">&nbsp; Save Sample</button><div class="topbuffer2"></div></div></form>');
$templateCache.put('app/pages/sample-submit/dialog.rnd.samplesubmit.html','<form name="editForm" role="form" novalidate><div class="modal-header modal-sample-submit"><div class="topbuffer1"></div><h2 class="modal-title pull-left samplemodaltitle">New Sample</h2><i class="fa fa-times pull-right fatimes2" aria-hidden="true" data-dismiss="modal" ng-click="vm.clear()"></i><!--<button class="btn btn-primary SaveSample SaveSample1 savemargin topbtnsubmitsave"><i class="fa fa-floppy-o" aria-hidden="true"></i> &nbsp; <span>Save Sample</span></button>--></div><div class="modal-body modal-sample-submit tabbackall tabbackall20"><div class="devider"><div class="topbuffer2"></div><div class="row form"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><label>Sample Name <span>&nbsp;*</span></label><input autofocus tabindex="101" type="text" ng-model="vm.sample.name"><div class="topbuffer2"></div><label>Product Category<span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="103" id="lunch" class="selectpicker select-box-padding" data-live-search="true" title="Select Category" ng-change="vm.populateTypes()" ng-model="vm.sample.productCategory" ng-options="category as category.name for category in vm.productCategories track by category.id"><option value="">Select Category</option></select></div><div class="topbuffer2"></div><div class="strain-name-box"><label>Strain name</label><input tabindex="105" type="text" placeholder="Optional" ng-model="vm.sample.strainName.name" ng-change="vm.loadStrains()"><div class="popup live-search" ng-show="vm.suggestedStrains.length > 0"><div class="popuptext" id="myPopup"><span ng-repeat="strain in vm.suggestedStrains track by strain.id" ng-click="vm.setStrainName(strain.name)">{{strain.name}}<br></span></div></div></div><div class="topbuffer2"></div><label>Inhalable/Non-Inhalable <span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="107" id="inhalable_edible" class="selectpicker select-box-padding" data-live-search="true" title="Select Inhalable/Edible" ng-model="vm.sample.inhalableEdible" ng-options="inhalable_edible.value as inhalable_edible.name for inhalable_edible in vm.inhalable_edible_array track by inhalable_edible.id"><option value="">Select Inhalable/Non-Inhalable</option></select></div><div class="topbuffer2"></div><label>Label Claims</label><input placeholder="Optional" tabindex="101" type="text" ng-model="vm.sample.labelClaims"><div class="topbuffer2"></div><label>Manufacture Date</label><div class="datepickerdate"><input placeholder="Optional" class="datepicker" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sample.manufactureDate" is-open="vm.datePickerOpenStatus.manufactureDate" ng-click="vm.openCalendar(\'manufactureDate\')"></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 divres"><label>Lot/Batch Number<span>&nbsp;*</span></label><input tabindex="102" type="text" placeholder="" ng-model="vm.sample.lotBatchNumber"><div class="topbuffer2"></div><label>Product Type<span>&nbsp;*</span></label><div class="custom-selectbox-big w100"><select tabindex="104" id="dinner" class="selectpicker select-box-padding" data-live-search="true" title="Select Type" ng-model="vm.sample.productType" ng-options="productType as productType.name for productType in vm.productTypes track by productType.id"><option value="">Select Type</option></select></div><div class="topbuffer2"></div><label>Strain Type</label><div class="custom-selectbox-big w100"><select tabindex="106" id="straintyperer" class="selectpicker select-box-padding" data-live-search="true" title="Select Type" ng-model="vm.sample.strainType" ng-options="strainType as strainType.name for strainType in vm.strainTypes track by strainType.id"><option value="">Select Strain Type</option></select></div><div class="topbuffer2"></div><label>METRC ID</label><input tabindex="107" type="text" placeholder="Optional" ng-model="vm.sample.sCode"><div class="topbuffer2"></div><label>Product Specifications</label><input placeholder="Optional" tabindex="101" type="text" ng-model="vm.sample.expectedPotency"><div class="topbuffer2"></div><label>Harvest Date</label><div class="datepickerdate"><input placeholder="Optional" class="datepicker" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks:false}" ng-model="vm.sample.harvestDate" is-open="vm.datePickerOpenStatus.harvestDate" ng-click="vm.openCalendar(\'harvestDate\')"></div></div></div></div><div class="line-div"></div><div class="busines form busines15"><div class="topbuffer3"></div><h3 class="TestsRequested">Tests Requested</h3><div class="topbuffer1"></div><label class="Youneedfont">You need to choose at least one test <span>&nbsp;*</span></label><!-- new --><table id="rd-submission-assay-list" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 checkboxcannabis"><tr><td class="col-lg-4 col-md-4 col-sm-12 col-xs-12 check-box-size"><div><input tabindex="116" type="checkbox" name="checkboxG17" id="checkboxG17" class="css-checkbox" ng-model="vm.selectedAssays[\'VITAMIN_E_ACETATE\']"><label for="checkboxG17" class="css-label">Vitamin E Acetate <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[\'VITAMIN_E_ACETATE\']}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'VITAMIN_E_ACETATE\']}}</span></a></label></div><div><input tabindex="108" type="checkbox" name="checkboxG5" id="checkboxG5" class="css-checkbox" ng-model="vm.selectedAssays[\'POTENCY_LCDAD\']"><label for="checkboxG5" class="css-label">Cannabinoid Profile (LC-DAD) <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important; z-index: 1000">{{vm.assayDescriptions[\'POTENCY_LCDAD\'] ? vm.assayDescriptions[\'POTENCY_LCDAD\'] : \'13 cannabinoids (\u03949-THC, \u03948-THC, THCA, THCV, THCVA, CBD, CBDA, CBDV, CBG, CBGA, CBN, CBC, & CBCA)\'}}</span></a></label></div><div><input tabindex="108" type="checkbox" name="checkboxG6999" id="checkboxG6999" class="css-checkbox" ng-model="vm.selectedAssays[\'POTENCY_LCMSMS\']"><label for="checkboxG6999" class="css-label">Cannabinoid Profile (LC-MS/MS) <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">Only for samples requiring extremely low limits of detection. Extra setup fee applies.</span></a></label></div><div><input tabindex="119" type="checkbox" name="checkboxG17" id="checkboxG400" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'FOREIGN_MATERIAL\']"><label for="checkboxG400" class="css-label">Foreign Material <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'FOREIGN_MATERIAL\'] ? vm.assayDescriptions[\'FOREIGN_MATERIAL\'] : \'Detection of sand, soil, cinders, dirt, mold, insect fragments, rodent hairs, mammalian excreta, and imbedded foreign material via microscopic analysis\'}}</span></a></label></div><div><input tabindex="114" type="checkbox" name="checkboxG8" id="checkboxG11" class="css-checkbox" ng-model="vm.selectedAssays[\'HEAVY_METALS\']"><label for="checkboxG11" class="css-label">Heavy Metals <span>(ppm)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'HEAVY_METALS\'] ? vm.assayDescriptions[\'HEAVY_METALS\'] : \'Arsenic, Lead, Cadmium, Mercury. Applicable to products cultivated or manufactured after January 1, 2019.\'}}</span></a></label></div><div><input tabindex="116" type="checkbox" name="checkboxG7" id="checkboxG13" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'HOMOGENEITY\']"><label for="checkboxG13" class="css-label">Homogeneity (USP) <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'HOMOGENEITY\'] ? vm.assayDescriptions[\'HOMOGENEITY\'] : \'Requires 10 samples to be submitted per USP protocols\' }}</span></a></label></div><div><input tabindex="116" type="checkbox" name="checkboxG7213" id="checkboxG7213" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'HOMOGENEITY_5\']"><label for="checkboxG7213" class="css-label">Homogeneity (5) <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'HOMOGENEITY_5\'] ? vm.assayDescriptions[\'HOMOGENEITY_5\'] : \'Only requires 5 samples for a reduced price. Not following USP protocols.\'}}</span></a></label></div><div ng-repeat="(key, assay) in vm.assays_col_1"><input tabindex="116" type="checkbox" name="{{\'checkboxG7213\' + key}}" id="{{\'checkboxG7213\' + key}}" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[assay.portalIdentifier]"><label for="{{\'checkboxG7213\' + key}}" class="css-label">{{assay.title}} <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[assay.portalIdentifier]}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[assay.portalIdentifier]}}</span></a></label></div></td><td class="col-lg-4 col-md-4 col-sm-12 col-xs-12 check-box-size"><div><input tabindex="109" type="checkbox" name="checkboxG102" id="checkboxG300" class="css-checkbox" ng-model="vm.selectedAssays[\'MICRO_INHALABLES\']"><label for="checkboxG300" class="css-label">Microbiological Screen <span>(Inhalables)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MICRO_INHALABLES\'] ? vm.assayDescriptions[\'MICRO_INHALABLES\'] : \'Salmonella, Shiga-Toxin Producing E. Coli (STEC), Aspergillus\'}}</span></a></label></div><div><input tabindex="112" type="checkbox" name="checkboxG9" id="checkboxG9" class="css-checkbox" ng-model="vm.selectedAssays[\'MICRO_NON_INHALABLES\']"><label for="checkboxG9" class="css-label">Microbiological Screen <span>(Non-Inhalables)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MICRO_NON_INHALABLES\'] ? vm.assayDescriptions[\'MICRO_NON_INHALABLES\'] : \'Salmonella, Shiga-Toxin Producing E. Coli (STEC)\' }}</span></a></label></div><div><input tabindex="115" type="checkbox" name="checkboxG9" id="checkboxG999" class="css-checkbox" ng-model="vm.selectedAssays[\'MICRO_QA_SCREEN\']"><label for="checkboxG999" class="css-label">Microbiological Screen (QA) <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MICRO_QA_SCREEN\'] ? vm.assayDescriptions[\'MICRO_QA_SCREEN\'] : \'Optional quality indicators commonly performed in food testing: standard plate count, yeast & mold, coliforms, and generic e. coli\'}}</span></a></label></div><div><input tabindex="115" type="checkbox" name="checkboxG9" id="checkboxG12" class="css-checkbox" ng-model="vm.selectedAssays[\'MICRO_PLUS\']"><label for="checkboxG12" class="css-label">Microbiological Screen Plus <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MICRO_PLUS\'] ? vm.assayDescriptions[\'MICRO_PLUS\'] : \'Combination of the required microbiological screen for inhalables with the micro QA screen: aspergillus, salmonella, shiga-toxin producing e. coli (STEC), generic e. coli, standard plate count, yeast & mold, and coliforms\'}}</span></a></label></div><div><input tabindex="117" type="checkbox" name="checkboxG8" id="checkboxG14" class="css-checkbox" ng-model="vm.selectedAssays[\'MOISTURE\']"><label for="checkboxG14" class="css-label">Moisture <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MOISTURE\'] ? vm.assayDescriptions[\'MOISTURE\'] : \'Can be performed either via moisture analyzer or forced air method\' }}</span></a></label></div><div><input tabindex="118" type="checkbox" name="checkboxG9" id="checkboxG15" class="css-checkbox" ng-model="vm.selectedAssays[\'MYCOTOXINS\']"><label for="checkboxG15" class="css-label">Mycotoxins <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[\'MYCOTOXINS\']}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'MYCOTOXINS\']}}</span></a></label></div><div ng-repeat="(key, assay) in vm.assays_col_2"><input tabindex="116" type="checkbox" name="{{\'checkboxG72132\' + key}}" id="{{\'checkboxG72132\' + key}}" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[assay.portalIdentifier]"><label for="{{\'checkboxG72132\' + key}}" class="css-label">{{assay.title}} <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[assay.portalIdentifier]}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[assay.portalIdentifier]}}</span></a></label></div></td><td class="col-lg-4 col-md-4 col-sm-12 col-xs-12 check-box-size"><div><input tabindex="119" type="checkbox" name="checkboxG17" id="checkboxG600" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'PESTICIDES_PHASE_II\']"><label for="checkboxG600" class="css-label">Pesticide Screen <span>(ppm)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'PESTICIDES_PHASE_II\'] ? vm.assayDescriptions[\'PESTICIDES_PHASE_II\'] : \'68 compounds. Applicable to manufactured goods produced after July 1, 2018\' }}</span></a></label></div><div><input tabindex="111" type="checkbox" name="checkboxG8" id="checkboxG200" class="css-checkbox" ng-model="vm.selectedAssays[\'PESTICIDES_PLUS\']"><label for="checkboxG200" class="css-label">Pesticide PLUS Screen <span>(ppm)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'PESTICIDES_PLUS\'] ? vm.assayDescriptions[\'PESTICIDES_PLUS\'] : \'Over 200 compounds. Based off USDA National Organic\\\'s Program list\'}}</span></a></label></div><div><input tabindex="121" type="checkbox" name="checkboxG42" id="checkboxG42" class="css-checkbox" ng-model="vm.selectedAssays[\'PESTICIDES_MYCOTOXINS\']"><label for="checkboxG42" class="css-label">Pesticides + Mycotoxins <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[\'PESTICIDES_MYCOTOXINS\']}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'PESTICIDES_MYCOTOXINS\']}}</span></a></label></div><div><input tabindex="109" type="checkbox" name="checkboxG102" id="checkboxG102" class="css-checkbox" ng-model="vm.selectedAssays[\'RESIDUAL_SOLVENT_PHASE_II\']"><label for="checkboxG102" class="css-label">Residual Solvent Screen <span>(ppm)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'RESIDUAL_SOLVENT_PHASE_II\'] ? vm.assayDescriptions[\'RESIDUAL_SOLVENT_PHASE_II\'] : \'20 solvents. Applicable to manufactured goods produced prior to July 1, 2018\'}}</span></a></label></div><div><input tabindex="120" type="checkbox" name="checkboxG20" id="checkboxG20" class="css-checkbox" ng-model="vm.selectedAssays[\'SULFUR\']"><label for="checkboxG20" class="css-label">Sulfur <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[\'SULFUR\']}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'SULFUR\']}}</span></a></label></div><div><input tabindex="113" type="checkbox" name="checkboxG10" id="checkboxG10" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'TERPENE_PROFILE\']"><label for="checkboxG10" class="css-label">Terpene Profile <span>(%)</span> <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'TERPENE_PROFILE\'] ? vm.assayDescriptions[\'TERPENE_PROFILE\'] : \'27 terpenoids\'}}</span></a></label></div><div><input tabindex="116" type="checkbox" name="checkboxG171" id="checkboxG171" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[\'WATER_ACTIVITY\']"><label for="checkboxG171" class="css-label">Water Activity <a class="ss-tooltips"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'WATER_ACTIVITY\'] ? vm.assayDescriptions[\'WATER_ACTIVITY\'] : \'Applicable to non-inhalable products manufactured after January 1, 2019\'}}</span></a></label></div><div><input tabindex="201" type="checkbox" name="checkboxG201" id="checkboxG201" class="css-checkbox" ng-model="vm.selectedAssays[\'ALKALOID\']"><label for="checkboxG201" class="css-label">Alkaloid Profile <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[\'ALKALOID\']}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[\'ALKALOID\']}}</span></a></label></div><div ng-repeat="(key, assay) in vm.assays_col_3"><input tabindex="116" type="checkbox" name="{{\'checkboxG72133\' + key}}" id="{{\'checkboxG72133\' + key}}" class="css-checkbox" checked="checked" ng-model="vm.selectedAssays[assay.portalIdentifier]"><label for="{{\'checkboxG72133\' + key}}" class="css-label">{{assay.title}} <a class="ss-tooltips" ng-show="{{vm.assayDescriptions[assay.portalIdentifier]}}"><i class="fa fa-question-circle" aria-hidden="true"></i> <span style="color: #FFFFFF !important; font-family: OpenSans-Regular !important; font-size: 13px !important">{{vm.assayDescriptions[assay.portalIdentifier]}}</span></a></label></div></td></tr></table><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="topbuffer2"></div><label>Other Analysis Requested</label><p><input id="otherAnalysisTagsInput" type="text" data-role="tagsinput" class="form-control" ng-model="vm.sample.otherAnalysis"></p></div></div></div></div><div class="modal-footer modal-sample-submit"><div class="line-div line-div-footer"></div><div class="topbuffer2"></div><button tabindex="123" ng-click="vm.clear(); vm.resetOtherAnalysis()" class="btn btn-default pull-left SaveSample SaveSample3 SaveSample4 hover-btn-blue default10 SaveSampleCancel" data-dismiss="modal"><i class="fa fa-times" aria-hidden="true"></i> &nbsp; &nbsp; Cancel &nbsp; &nbsp; &nbsp;</button><div class="topbuffer2"></div><button tabindex="121" class="btn btn-default default10 samplemarging hover-btn-blue SaveSampleAnother" ng-disabled="\n        \t\tvm.isSaving ||\n                !vm.hasSelectedAssay(vm.selectedAssays) ||\n                !vm.sample.inhalableEdible ||\n                !vm.sample.name.trim() ||\n                !vm.sample.productType ||\n                !vm.sample.lotBatchNumber.trim() ||\n                !vm.sample.productCategory" ng-click="vm.save(2); vm.resetOtherAnalysis();"><i class="fa fa-plus" aria-hidden="true"></i> &nbsp; &nbsp; Save Sample and Add Another</button> <button tabindex="122" class="btn btn-primary pull-right SaveSample SaveSample1 savemargin" ng-disabled="\n        \t\tvm.isSaving ||\n                !vm.hasSelectedAssay(vm.selectedAssays) ||\n                !vm.sample.inhalableEdible ||\n                !vm.sample.name.trim() ||\n                !vm.sample.productType ||\n                !vm.sample.lotBatchNumber.trim() ||\n                !vm.sample.productCategory" ng-click="vm.save(1);">&nbsp; Save Sample</button><div class="topbuffer2"></div></div></form>');
$templateCache.put('app/pages/sample-submit/sample-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sample.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Sample?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/pages/sample-submit/sample-detail.html','<div><h2><span>Sample</span> {{vm.sample.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.sample.name}}</span></dd><dt><span>Lot Batch Number</span></dt><dd><span>{{vm.sample.lotBatchNumber}}</span></dd><dt><span>Residual Solvent</span></dt><dd><span>{{vm.sample.residualSolventPassFail1}}</span></dd><dt><span>Other</span></dt><dd><span>{{vm.sample.otherAnalysis}}</span></dd><dt><span>Product Type</span></dt><dd><a ui-sref="product-type-detail({id:vm.sample.productType.id})">{{vm.sample.productType.name}}</a></dd><dt><span>Customer Order</span></dt><dd><a ui-sref="customer-order-detail({id:vm.sample.customerOrder.id})">{{vm.sample.customerOrder.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="sample-detail.edit({id:vm.sample.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down">Edit</span></button></div>');
$templateCache.put('app/pages/sample-submit/samplesubmit.html','<style>.batchFormContainer{\n    overflow-x: auto;\n    overflow-y: auto;\n    max-height: 65vh;\n}\n\n.batchFormContainer::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F5F5F5;\n}\n\n.batchFormContainer::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    background-color: #BBC3CD;\n}\n\n.batchFormContainer::-webkit-scrollbar-track {\n    background-color: #fff;\n}\n.batchRow{\n    min-width: 1064px;\n    max-width: 100%\n}\n\n.samples-assay-title {\n  \n    max-width: 150px;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n   \n}\n\n.rdCustomScrollBarThin::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n    background-color: #F5F5F5;\n}\n\n.rdCustomScrollBarThin::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    background-color: #BBC3CD;\n}\n\n.rdCustomScrollBarThin::-webkit-scrollbar-track {\n    background-color: #fff;\n}</style><div class="samplesubmit-page"><div class="sub-header"><div class="container-fluid"><div class="row"><div class="col-lg-12 col-md-12 col-sm-12 col-xs-12"><div class="card"><ul class="nav nav-tabs" role="tablist" ng-if="vm.show_tab.rd"><li ng-class="{\'active\' : vm.active_tab.rd, \'disabled\' : vm.isExcelImportProcessing()}" ng-click="vm.switch_tab(\'rd\', $event)" ng-attr-aria-disabled="{{vm.isExcelImportProcessing()}}" role="presentation" id="qa_testing_tab"><a aria-controls="qa_testing" role="tab" data-toggle="tab">{{\'QA/R&D Testing\' | translate}}</a></li><li ng-if="vm.show_tab.comp" ng-class="{\'active\' : vm.active_tab.comp, \'disabled\' : vm.isExcelImportProcessing()}" ng-click="vm.switch_tab(\'comp\', $event)" ng-attr-aria-disabled="{{vm.isExcelImportProcessing()}}" role="presentation" id="home_tab"><a aria-controls="home" role="tab" data-toggle="tab">{{\'Compliance Testing\' | translate}}</a></li></ul><ul class="nav nav-tabs" role="tablist" ng-if="vm.show_tab.analysis"><li class="active" ng-class="{\'disabled\' : vm.isExcelImportProcessing()}" ng-attr-aria-disabled="{{vm.isExcelImportProcessing()}}" role="presentation" id="food_testing_tab"><a aria-controls="food_testing" role="tab" ng-click="vm.switch_tab(\'analysis\', $event)" data-toggle="tab">{{\'Analysis\' | translate}}</a></li><li ng-if="vm.show_tab.fda" ng-class="{\'active\' : vm.active_tab.fda, \'disabled\' : vm.isExcelImportProcessing()}" ng-click="vm.switch_tab(\'fda\', $event)" ng-attr-aria-disabled="{{vm.isExcelImportProcessing()}}" role="presentation" id="home_tab"><a aria-controls="home" role="tab" data-toggle="tab">{{\'FDA DWPE Testing\' | translate}}</a></li></ul></div></div></div></div></div><!-- <div class="content-wrapper-x content-page-height"> --><div class="tabbackall"><div class="tab-content tabback" ng-if="vm.show_tab.rd"><!-- Compliance Testing --><form ng-class="{\'active\' : vm.active_tab.comp}" name="editForm" name="editForm" class="tab-pane" style="cursor: default" id="home" role="form"><div class="rdContainer"><div class="rdProgress rdViewRowBasic" style="padding: 0px 15%; text-align: center"><!--progress 1--><div ng-show="vm.comp.step == 1" class="row status-wizard" style="display: inline-flex; background-color: #eff5fb !important"><div class="comp-33-width status-wizard-step no-pointer-events active"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus1">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}} &nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus2">2 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus3">3 <span>{{\'Review\' | translate}}</span></a></div></div><!--progress 2--><div ng-show="vm.comp.step == 2" class="row status-wizard" style="display: inline-flex"><div class="comp-33-width status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div><!--progress 3--><div ng-show="vm.comp.step == 3" class="row status-wizard" style="display: inline-flex"><div class="comp-33-width status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="comp-33-width status-wizard-step no-pointer-events complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div></div><!-- page 1 --><div class="rdView rdViewRowBasic" ng-show="vm.comp.step == 1"><div class="rdViewRow1"><div class="rdTopBtnContainer"><div style="float: left"><button class="btnPrimaryWhite" ng-click="vm.comp.downloadExcel()"><i class="fa fa-cloud-download"></i>&nbsp;&nbsp;&nbsp;{{\'Download Excel\' | translate}}</button> <button class="btnPrimaryWhite btnLeftMargin" ng-click="!vm.comp.processingExcelUpload && vm.comp.uploadExcel()" ng-disabled="vm.comp.processingExcelUpload"><i class="fa fa-cloud-upload"></i>&nbsp;&nbsp;&nbsp;{{\'Upload Excel\' | translate}}</button> <input type="file" id="comp_upload_excel" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onchange="compUploadExcel()" style="display: none"> <button id="comp_click_upload" ng-click="vm.comp.handleExcel()" style="display: none"></button></div><div style="float: right"><button ng-disabled="vm.comp.samples.length == 0" ng-class="{ \'btnPrimaryCancel\' : !vm.comp.samples.length, \'btnPrimaryWhite\' : vm.comp.samples.length }" ng-click="vm.comp.deleteChecked()"><i class="fa fa fa-trash-o"></i>&nbsp;&nbsp;&nbsp;{{\'Delete Batches\' | translate}}</button> <button ng-click="vm.comp.addSample()" class="btnPrimaryBlue btnLeftMargin"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Batch\' | translate}}</button></div></div></div><div class="rdViewRow2 batchFormContainer"><div class="rdRow batchRow"><div class="rdColumn bigbox rdCustomScrollBarThin" style="max-height: 65vh; overflow: scroll"><table class="rdSamplesTable"><thead><tr><th style="margin-left: 5px" ng-show="vm.comp.customer_type.includes(\'Cannabis\') || vm.comp.customer_type.includes(\'Hemp\')"><p ng-class="{ \'rdMainCollapseUp\' : vm.comp.mainCollapse, \'rdMainCollapseDown\': !vm.comp.mainCollapse}"><i id="collapseAll" ng-model="vm.comp.mainCollapse" ng-click="vm.comp.collapseAll()" ng-class="{ \'fa fa-angle-up\' : vm.comp.mainCollapse, \'fa fa-angle-down\' : !vm.comp.mainCollapse}"></i></p><p></p></th><th><label style="display: inline-block" class="checkboxContainer"><input ng-click="vm.comp.clickCheckAllDelete()" style="display: inline-block" class="public-view-item-checkbox comp-delete-checkbox-header" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -10px" class="checkmark"></span></label></th><th>{{\'Matrix\' | translate}}*</th><th>{{\'Batch Name\' | translate}}*</th><th>{{\'Lot/Batch #\' | translate}}*</th><th>{{\'Product Category\' | translate}}*</th><th>{{\'Product Type\' | translate}}*</th><th>{{\'Inhalable/Non-Inhalable\' | translate}}*</th><th></th></tr><tr style="padding-bottom: 0"><th colspan="9"><hr style="margin: 0; color: #E4E8EB"></th></tr></thead><tbody><tr ng-show="vm.comp.samples.length == 0"><td colspan="9" style="height: 250px"><p class="information" style="margin-bottom: 20px; font-size: 11pt; color: #D3DDDE !important">{{\'No batch has been added\' | translate}}</p><button ng-click="vm.comp.addSample()" class="btnPrimaryBlue"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Batch\' | translate}}</button></td></tr><tr class="rowsTest" ng-repeat="sample in vm.comp.samples track by $index" ng-class="{ \'rdCollapsedBackground\' : sample.sample_expanded, \'\': !sample.sample_expanded}"><td><div style="padding-top: 10px; margin-left: 5px"><p ng-class="{ \'rdMainCollapseUp\' : sample.sample_expanded, \'rdMainCollapseDown\': !sample.sample_expanded}"><i ng-model="sample.sample_expanded" ng-click="sample.sample_expanded = !sample.sample_expanded" ng-class="{ \'fa fa-angle-up\' : sample.sample_expanded, \'fa fa-angle-down\': !sample.sample_expanded }"></i></p></div><div style="padding-top: 10px; margin-left: 5px" ng-show="sample.sample_expanded"></div><div style="padding-top: 10px; margin-left: 5px" ng-show="sample.sample_expanded"></div><div style="padding-top: 10px; margin-left: 5px" ng-show="sample.sample_expanded"></div></td><td><div><label style="display: inline-block" class="checkboxContainer"><input ng-checked="sample.sample_delete" ng-click="vm.comp.clickDelete($index)" style="display: inline-block" class="public-view-item-checkbox delete-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: 6px; margin-left: -9px" class="checkmark"></span></label></div><div ng-show="sample.sample_expanded"></div><div ng-show="sample.sample_expanded"></div><div ng-show="sample.sample_expanded"></div></td><td><div><select ng-model="sample.sample_matrix" data-live-search="true" type="text" ng-options="matrix as matrix.name for matrix in vm.comp.phases track by matrix.id" ng-change="vm.comp.changeMatrix($index)" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_matrix }"><option value="" selected="selected" disabled="disabled">{{\'Select Matrix\' | translate}}</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'TAG UID\' | translate}}</span><!-- <span>METRC UID</span> ANR-258--> <input ng-model="sample.sample_metrc_id" type="text" placeholder="e.g. 148000AC1234" value="{{ sample.sample_metrc_id }}"></div><div ng-show="sample.sample_expanded" style="padding: 20px 0"><div class="Requestedradio"><label for="product_batch-{{ $index }}"><input type="radio" name="batch_type-{{ $index }}" id="product_batch-{{ $index }}" value="PRODUCT_BATCH" ng-checked="sample.sample_product_harvest_batch == \'PRODUCT_BATCH\'" ng-model="sample.sample_product_harvest_batch" ng-change="vm.comp.checkPageOne()"><span>{{\'Product Batch\' | translate}}</span></label></div></div><div ng-show="sample.sample_expanded"><span>{{ sample.sample_product_harvest_batch == \'HARVEST_BATCH\' ? \'Harvest Batch Size (lbs)*\' : \'Product Batch Size (Units)*\'}}</span> <input ng-change="vm.comp.checkPageOne()" ng-model="sample.sample_product_batch_size" ng-class="{ \'required-input\' : !sample.sample_product_batch_size }" type="text" placeholder="Enter Batch Size" value="{{ sample.sample_product_batch_size }}"></div></td><td><div><input ng-model="sample.sample_name" type="text" placeholder="Batch Name" value="{{ sample.sample_name }}" ng-class="{ \'required-input\' : !sample.sample_name }" ng-change="vm.query_autofill(sample)" ng-focus="vm.give_focus(sample, \'autofill\')" ng-blur="vm.lose_focus(sample, \'autofill\')"><div ng-show="sample.focus.autofill && sample.options.autofill && sample.sample_name.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.autofill.length > 0" ng-focus="vm.give_focus(sample, \'autofill\')" ng-repeat="option in sample.options.autofill" ng-bind-html="option.name | highlightMatch:sample.sample_name" ng-click="vm.set_sample_autofill(sample, option)" style="margin: 5px 0; text-align: left">{{ option.name }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.autofill.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'Source UID\' | translate}}*</span> <input ng-change="vm.comp.checkPageOne()" ng-model="sample.sample_source_id" ng-class="{ \'required-input\' : !sample.sample_source_id }" type="text" placeholder="Source UID" value="{{ sample.sample_source_id }}"></div><div ng-show="sample.sample_expanded" style="padding: 20px 0"><div class="Requestedradio"><label for="harvest_batch-{{ $index }}"><input type="radio" name="batch_type-{{ $index }}" id="harvest_batch-{{ $index }}" ng-checked="sample.sample_product_harvest_batch == \'HARVEST_BATCH\'" value="HARVEST_BATCH" ng-model="sample.sample_product_harvest_batch" ng-change="vm.comp.checkPageOne()"><span>{{\'Harvest Batch\' | translate}}</span></label></div></div><div ng-show="sample.sample_expanded && sample.sample_product_harvest_batch == \'PRODUCT_BATCH\'"><span>{{\'Manufacture Date\' | translate}}</span> <input class="rdDatePicker" placeholder="e.g. 01/01/2024" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="sample.sample_manufacture_date" is-open="sample.sample_manufacture_date_open" ng-click="vm.comp.openCalendar(sample, \'sample_manufacture_date_open\')"></div><div ng-show="sample.sample_expanded && sample.sample_product_harvest_batch == \'HARVEST_BATCH\'"><span>{{\'Harvest Date\' | translate}}</span> <input ng-change="vm.comp.checkPageOne()" class="rdDatePicker" placeholder="e.g. 01/01/2024" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="sample.sample_harvest_date" is-open="sample.sample_harvest_date_open" ng-click="vm.comp.openCalendar(sample, \'sample_harvest_date_open\')"></div></td><td><div><input ng-model="sample.sample_lot_batch_number" type="text" placeholder="{{\'e.g. abc123\' | translate}}" value="{{ sample.sample_lot_batch_number }}" ng-class="{ \'required-input\' : !sample.sample_lot_batch_number }" ng-change="vm.query_sample_lot_batch_number(sample)" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-blur="vm.lose_focus(sample, \'lot_batch_number\')"><div ng-show="sample.focus.lot_batch_number && sample.options.lot_batch_number && sample.sample_lot_batch_number.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.lot_batch_number.length > 0" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-repeat="lot_batch_number in sample.options.lot_batch_number" ng-bind-html="lot_batch_number | highlightMatch:sample.sample_lot_batch_number" ng-click=" vm.set_sample_lot_batch_number(sample, lot_batch_number)" style="margin: 5px 0; text-align: left">{{ lot_batch_number }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.lot_batch_number.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'Strain Name\' | translate}}</span> <input ng-model="sample.sample_strain_name" type="text" placeholder="Optional" value="{{ sample.sample_strain_name }}"></div><div ng-show="sample.sample_expanded" style="padding: 21px 0px 10px 5px"><span><label style="display: inline-block" class="checkboxContainer"><input ng-model="sample.sample_add_terpenoid_profile" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -10px" class="checkmark"></span></label>&nbsp;&nbsp;&nbsp;Add Terpenoid Profile</span></div><div ng-show="sample.sample_expanded"><span>{{ sample.sample_product_harvest_batch == \'HARVEST_BATCH\' ? \'Unit Weight (g)\' : \'Unit Weight (g)*\'}}</span> <input ng-change="vm.comp.checkPageOne()" ng-model="sample.sample_unit_weight" ng-class="{ \'required-input\' : !sample.sample_unit_weight && sample.sample_product_harvest_batch == \'PRODUCT_BATCH\' }" type="text" placeholder="{{ sample.sample_product_harvest_batch == \'HARVEST_BATCH\' ? \'Optional\' : \'Enter Unit Weight in g\' }}" value="{{ sample.sample_unit_weight }}"></div></td><td valign="top"><div><select ng-change="vm.comp.populateTypes(sample)" ng-model="sample.sample_category" data-live-search="true" type="text" ng-options="category as category.name for category in vm.comp.categories | orderBy: \'+name\'" ng-change="vm.comp.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_category }"><option value="" selected="selected" disabled="disabled">{{\'Select Category\' | translate}}</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Strain Type\' | translate}}</span><select ng-model="sample.sample_strain_type" data-live-search="true" type="text" ng-options="strainType as strainType.name for strainType in vm.rd.strainTypes track by strainType.id" ng-class="{ \'rd-placeholder\' : !sample.sample_strain_type }"><option value="" selected="selected" disabled="disabled">Optional</option></select></div><div ng-show="sample.sample_expanded" style="padding: 21px 0px 10px 5px"><span><label style="display: inline-block" class="checkboxContainer"><input ng-model="sample.sample_analyze_by_lcmsms" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -10px" class="checkmark"></span></label>&nbsp;&nbsp;&nbsp;Analyze by LCMSMS</span></div><div ng-show="sample.sample_expanded"></div></td><td valign="top"><div><select ng-model="sample.sample_type" data-live-search="true" type="text" ng-options="type as type.name for type in sample.sample_types | orderBy: \'+name\'" ng-change="vm.comp.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_type }"><option value="" selected="selected" disabled="disabled">{{\'Select Type\' | translate}}</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Label Claims\' | translate}}</span> <input ng-model="sample.sample_label_claims" type="text" placeholder="Optional" value="{{ sample.sample_label_claims }}"></div><div ng-show="sample.sample_expanded" style="padding: 21px 0px 10px 5px"><span style="display: inline-flex; align-items: center; gap: 8px"><label style="display: inline-block; width: 18px; height: 18px; margin-bottom: 0" class="checkboxContainer"><input ng-model="sample.medicinal_batch" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span class="checkmark"></span></label>{{\'Medicinal Batch\' | translate}}</span></div><div ng-show="sample.sample_expanded"></div></td><td><div><select ng-model="sample.sample_inhalable" data-live-search="true" type="text" ng-options="inhalable.value as inhalable.name for inhalable in vm.comp.inhalable_edible_array track by inhalable.id" ng-change="vm.comp.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_inhalable }"><option value="" selected="selected" disabled="disabled">Select Inhalable</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Product Specifications\' | translate}}* <i id="info-modal-icon-0" class="sample-submit-info-modal-trigger product-info fa fa-info-circle"></i><div ng-class="{ \'sample-submit-info-modal-shadow-left\' : test.left, \'sample-submit-info-modal-shadow-right\' : !test.left, }" class="info-modal-0 sample-submit-info-modal product-description info-modal-new"><p>{{\'Please input any internal specifications, label claims, or pass/fail criteria into this field (e.g. 18-22% THC, 100mg CBD +/- 10%, &lt;400ppm acetonitrile). This will allow our lab to proactively investigate any out of spec result, saving time and reducing the potential for analytical or reporting error.\' | translate}}</p></div></span><!-- <span>Product Specifications</span> --> <input maxlength="255" ng-model="sample.sample_expected_potency" type="text" placeholder="{{\'e.g. 20% Vit C\' | translate}}" ng-class="{\'required-input\' : !sample.sample_expected_potency}" ng-change="vm.comp.checkPageOne()" value="{{ sample.sample_expected_potency }}"></div><div ng-show="sample.sample_expanded"></div><div ng-show="sample.sample_expanded"></div></td><td style="width: 5%"><div style="display: flex; flex-direction: row"><div style="margin-right: 5px"><a ng-click="vm.comp.removeSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-trash-o"></i></a></div><div style="margin-right: 5px"><a ng-click="vm.comp.cloneSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-clone"></i></a></div></div><div ng-show="sample.sample_expanded"></div><div ng-show="sample.sample_expanded"></div><div ng-show="sample.sample_expanded"></div></td></tr></tbody></table></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryBlue" ng-click="vm.comp.incrementPage()" ng-disabled="!vm.comp.pageOneValid || vm.comp.processingExcelUpload" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.comp.pageOneValid || vm.comp.processingExcelUpload }">{{\'Next\' | translate}} &nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 2 --><div class="rdView rdViewRowBasic" ng-show="vm.comp.step == 2"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><div><div class="rdRow"><div class="rdColumn"><label class="rdColumnLeftLabel">{{\'Contact Name\' | translate}}</label><input type="text" ng-model="vm.contact.name" disabled="disabled" class="ng-pristine ng-untouched ng-valid ng-not-empty"><div class="rdRow"><label class="rdColumnLeftLabel">{{\'Contact Phone #\' | translate}}</label><input type="text" ng-model="vm.contact.phone" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div class="rdColumn" style="width: 50%"><label class="rdColumnRightLabel" style="display: inline-flex"><div>{{\'Email Recipients\' | translate}}<span class="rdRequired">&nbsp;*</span></div><div style="font-size: 9pt; margin: auto 0 auto auto"><a ng-if="false" disabled="disabled" href="#">{{\'Manage users\' | translate}}</a></div></label><div class="rdColumnRightLabel" ng-class="{\'required-input\' : !vm.comp.emails || vm.comp.emails.length === 0}"><input type="text" class="rdColumnRightInput" id="emailToCompliance" data-role="tagsinput" ng-model="vm.comp.emails" ng-change="vm.comp.checkPageTwo()"></div><div class="rdRow"><div class="rdColumnRightLabel" style="margin-top: 0"><label>Project/PO#</label><input ng-model="vm.comp.orderPO" type="text" placeholder="Optional" style="width: 100% !important"></div></div></div></div><div class="rdRow"><div class="rdColumn" style="width:50%"><label class="rdColumnLeftLabel">Distributor Address<span class="rdRequired">&nbsp;*</span></label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 95% !important; height: 45px" ng-click="openDistributionList()" type="text" name="CM-location" class="add_option" ng-model="vm.fullLocationComp" placeholder="Choose Location / Add New" value="" readonly="readonly" ng-class="{\'required-input\' : !vm.fullLocationComp  || vm.fullLocationComp.length === 0}"></div><ul style="width: 95% !important" id="locationList" class="add_new_list location-list" ng-class="DistributionList"><li class="add_new_option" style="width: 95% !important; height: 45px" data-toggle="modal" data-target="#add-new-distribution">+ Add New</li><li ng-repeat="address in records" style="width: 95% !important; height: 45px" ng-if="address.locationType === \'DISTRIBUTION_LOCATION\'"><span class="spanDataAddress" ng-click="copyDistributionData(address.address, address.city, address.zipCode, address.distributorName, address.medicalLicence, address.fullLocation, address.licenceList)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'DISTRIBUTION\')" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="rdColumn" style="width:50%"><label class="rdColumnRightLabel">Cultivation/Manufacturing Location <span class="rdRequired">&nbsp;*</span></label><div class="input-autocomplate rdColumnRightLabel"><div class="add-option-caretRD"><input ng-click="openManufacturingList()" style="height: 45px" type="text" name="d-location" class="add_option" ng-model="vm.fullLocationManufactur" placeholder="Choose Location / Add New" value="" readonly="readonly" ng-class="{\'required-input\': !vm.fullLocationManufactur || vm.fullLocationManufactur.length === 0}"></div><ul style="width: 95% !important" class="add_new_list location-list" ng-class="ManufacturingList"><li style="width: 95% !important; height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-manufacturing">+ Add New</li><li style="width: 95% !important; height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'CULTIVATION_LOCATION\'"><span class="spanDataAddress" ng-click="copyManufacturingData(address.address, address.city,  address.zipCode, address.distributorName,  address.medicalLicence, address.fullLocation, address.licenceList)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'MANUFACTURING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div><div class="rdRow"><div class="rdColumn" style="width:50%"><label class="rdColumnRightLabel">Sampling Address<span class="rdRequired">&nbsp;*</span></label><div class="input-autocomplate rdColumnRightLabel"><div class="add-option-caretRD"><input ng-click="openpickupList()" style="height: 45px" type="text" name="pickup-location" class="add_option" ng-model="vm.fullLocationPickup" placeholder="Select pickup address" value="" readonly="readonly" ng-class="{\'required-input\' : !vm.fullLocationPickup  || vm.fullLocationPickup.length === 0}"></div><ul class="add_new_list location-list" ng-class="PickupList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-pickup">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'PICKUP_LOCATION\'"><span class="spanDataAddress" ng-click="copyPickupData(address.address, address.city,  address.zipCode, address.distributorName,  address.state)">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'PICKUP\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><!-- Error message if pickup address not in California --><div ng-if="vm.pickupOutOfStateError" style="color: #d9534f; margin-top: 8px; padding: 10px; background-color: #f2dede; border: 1px solid #ebccd1; border-radius: 4px; font-size: 14px"><strong>\u26A0 Pickup service is currently only available in California.</strong> Please select a California address or choose a different delivery option.</div><div class="rdColumn" style="width:50%"><label class="rdColumnRightLabel">Invoicing Address</label><div class="input-autocomplate rdColumnRightLabel"><div class="add-option-caretRD"><input ng-click="openInvoicingList()" style="height: 45px" type="text" name="invoicing-location" class="add_option" ng-model="vm.fullLocationInvoicing" placeholder="{{vm.customerData.qbAddress.replace(\'\\n\', \'; \')}}" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="InvoicingList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-invoicing">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'INVOICING_LOCATION\'"><span class="spanDataAddress" ng-click="copyInvoicingData(address.address, address.city,  address.zipCode, address.distributorName,  address.state, address.fullLocation)">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'INVOICING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div><div class="rdRow"><div class="rdColumn" style="width:50%"><label class="rdColumnLeftLabel">Pickup/Arrival Date<span class="rdRequired">&nbsp;*</span></label><div class="youremail foodadddate datepickerdate" style="margin-bottom: 0; width:95%" ng-class="{\'required-input\' : !vm.comp.pickup_arrival_date}"><input class="datepicker" ng-change="vm.comp.estimateReportDate(vm.comp.turnaroundTime)" placeholder="Pickup/Arrival Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="vm.comp.pickup_arrival_date" is-open="vm.datePickerOpenStatus.pickup_arrival_date" ng-click="vm.openCalendar(\'pickup_arrival_date\')" style="width: 100% !important"> <i style="margin-top: -29px !important" class="fa fa-calendar-o" ng-click="vm.openCalendar(\'pickup_arrival_date\')"></i></div></div><div class="rdColumn" style="width:50%"><label class="rdColumnLeftLabel">Tracking Number</label><input type="text" ng-model="vm.comp.tracking_number" placeholder="Tracking Number" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div class="rdRow"><div class="rdColumn" style="flex-direction: unset"><div class="companyinfo preference"><label class="cm-label">Turnaround Time<span class="rdRequired">&nbsp;*</span><a href="javascript:void(0)" class="ss-tooltips"><i class="fa fa-question-circle"></i><!-- <span>Standard turnaround time for routine analyses is 4 business days from receipt of your sample(s) unless otherwise noted or negotiated.  Standard turnaround time for non-routine analyses is 10 business days.  If a rush option is selected, a customer service representative will be in touch to confirm feasibility.</span> --> <span>{{\'Standard turnaround time varies depending on analysis.\' | translate}}<br><br>- {{\'Routine cannabis and hemp testing has a standard 3 day TAT.\' | translate}}<br>- {{\'Routine microbiological and kratom testing has a standard 5 day TAT.\' | translate}}<br>- {{\'Nutritional labeling has a standard 15 day TAT.\' | translate}}<br>- {{\'Most other assays have a standard 10 day TAT.\' | translate}}<br><br>Expedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or {{ vm.supportEmail }} for additional info regarding these options.</span></a></label><div class="topbuffer05"></div><div class="Requestedradio" ng-class="{\'required-input\' : !vm.comp.turnaroundTime}"><label for="comp-standard"><input type="radio" name="turnaroundTime" id="comp-standard" value="3 day (standard)" ng-change="vm.comp.estimateReportDate(vm.comp.turnaroundTime)" ng-model="vm.comp.turnaroundTime" checked="checked"><span>3 day (standard)</span></label><div class="topbuffer05"></div><label for="comp-rush2"><input type="radio" name="turnaroundTime" id="comp-rush2" value="2 day (rush)" ng-change="vm.comp.estimateReportDate(vm.comp.turnaroundTime)" ng-model="vm.comp.turnaroundTime"><span>{{\'2 days (rush)\' | translate}}</span></label><div class="topbuffer05"></div><label for="comp-rush1"><input type="radio" name="turnaroundTime" id="comp-rush1" value="1 day (rush)" ng-change="vm.comp.estimateReportDate(vm.comp.turnaroundTime)" ng-model="vm.comp.turnaroundTime"><span>{{\'1 day (rush)\' | translate}}</span></label></div></div></div><div class="rdColumn"><div style="height: 100%; width: 95%; margin: auto 0 -14px auto"><div ng-show="vm.comp.estimated_report_date" class="rdReportDateCard"><p style="font-size: 16px; font-family: OpenSans-SemiBold">{{\'Estimated Report Date\' | translate}}</p><p style="font-size: 20px; padding-top: 30px; font-family: OpenSans-Bold">{{ vm.comp.estimated_report_date.day ? vm.comp.estimated_report_date.day + \',\' : \'\' }}</p><p style="font-size: 30px; font-family: OpenSans-Bold">{{ vm.comp.estimated_report_date.month_day_year ? vm.comp.estimated_report_date.month_day_year : \'Unavailable\' }}</p></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt; display: flex; gap: 20px"><div style="flex: 1; text-align: left; position: relative"><details open><summary style="font-size: 13px; color: #4F8FCC">{{\'Special Instructions\' | translate}}</summary><textarea style="width: 100%; height: 100px" ng-model="vm.comp.specialInstructions" type="text" placeholder="{{\'Special Instructions\' | translate}}" ng-change="vm.query_order_field(\'comp\', \'specialInstructions\', \'special_instructions\')" ng-focus="vm.orderFieldFocus.specialInstructions = true" ng-blur="vm.orderFieldFocus.specialInstructions = false"></textarea><div ng-show="vm.orderFieldFocus.specialInstructions && vm.orderFieldOptions.specialInstructions.length > 0 && vm.comp.specialInstructions.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.specialInstructions track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'comp\', \'specialInstructions\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></details></div><div style="flex: 1; text-align: left; position: relative"><label style="font-size: 13px; color: #4F8FCC">{{\'Customer Comments\' | translate}} <span class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle" style="cursor: pointer"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px; left: -10px; bottom: 20px; margin-bottom: -5px"><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 12px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left; font-size: 12px">Any comment typed into this box will display on the consolidated COA below the sample photo and above the analytical results.</div></div></div></span></label><textarea style="width: 100%; height: 100px" ng-model="vm.comp.customerComments" type="text" placeholder="{{\'Customer Comments\' | translate}}" ng-change="vm.query_order_field(\'comp\', \'customerComments\', \'customer_comments\')" ng-focus="vm.orderFieldFocus.customerComments = true" ng-blur="vm.orderFieldFocus.customerComments = false"></textarea><div ng-show="vm.orderFieldFocus.customerComments && vm.orderFieldOptions.customerComments.length > 0 && vm.comp.customerComments.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.customerComments track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'comp\', \'customerComments\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt"><details open><summary style="font-size: 13px; color: #4F8FCC;display:block;text-align: left">{{\'Document Upload\' | translate}}</summary><div style="margin-top: 10px"><input type="file" id="comp-file-upload" multiple="multiple" style="display: none" onchange="onCompFileUpload()"> <button style="display:block; margin-bottom: 10px" type="button" class="btnPrimaryWhite" onclick="document.getElementById(\'comp-file-upload\').click()"><i class="fa fa-upload"></i>&nbsp;&nbsp;{{\'Select File\' | translate}}</button><div ng-if="vm.comp.uploadedFiles.length > 0" style="margin-top: 10px"><div ng-repeat="file in vm.comp.uploadedFiles" style="padding: 1px 20px; background: #fff; margin-bottom: 5px; border-radius: 3px; border: 1px solid #4f8fcc; display: flex; justify-content: space-between; align-items: center; height: 35px; font-size: 14px; width: 600px"><span><i class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }} ({{ vm.formatFileSize(file.size) }})</span> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.comp.removeFile($index)" style="padding: 2px 8px"><i class="fa fa-times"></i></button></div></div></div></details></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryWhite" ng-click="vm.comp.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button class="btnPrimaryBlue btnLeftMargin" ng-click="vm.comp.incrementPage()" ng-disabled="!vm.comp.pageTwoValid" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.comp.pageTwoValid }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 3 --><div class="rdView rdViewRowBasic" ng-show="vm.comp.step == 3"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><!-- reporting address, email recipients --><div class="rdRow"><div class="rdColumn"><table class="rdTable"><thead><tr><th>distributor address</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.distributionAddressDict.name }}</td></tr><tr><td>{{ vm.distributionAddressDict.address }}</td></tr><tr><td>{{ vm.distributionAddressDict.city + \', \' + vm.distributionAddressDict.zipCode }}</td></tr><tr ng-repeat="lic in (vm.distributionAddressDict.licenceList || vm.distributionAddressDict.medicalLicence || \'\').split(\',\')"><td>{{ lic.trim() }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>cultivation/manufacturing address</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>Attn: {{ vm.comp.cultivationLocation.name }}</td></tr><tr><td>{{ vm.comp.cultivationLocation.address }}</td></tr><tr><td>{{ vm.comp.cultivationLocation.city + \', \' + vm.customerData.address_zip}}</td></tr><tr ng-repeat="lic in (vm.comp.cultivationLocation.licenceList || vm.comp.cultivationLocation.medicalLicence || \'\').split(\',\')"><td>{{ lic.trim() }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Email Recipients\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr ng-repeat="email in vm.comp.emailsArray"><td>{{ email ? email : \'No Emails Selected\'}}</td></tr></tbody></table></div></div><!-- delivery, turnaround, po# --><div class="rdRow"><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Delivery\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.pickupLabel }}</td></tr><tr><td style="font-style: italic">{{ vm.comp.pickup_arrival_date | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Turnaround Time\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.comp.turnaroundTime ? vm.comp.turnaroundTime : \'4-5 days (standard)\' }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>PO#</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.comp.orderPO ? vm.comp.orderPO : \'None\' }}</td></tr></tbody></table></div></div><!-- special instructions --><div class="rdRow"><div class="rdColumn" style="flex: 2"><table class="rdTable"><thead><tr><th>{{\'Special Instructions\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.comp.specialInstructions ? vm.comp.specialInstructions : \'None\' }}</td></tr></tbody></table></div><div class="rdColumn" style="flex: 1"><table class="rdTable"><thead><tr><th>{{\'Invoicing Address\' | translate}}</th></tr></thead><tbody ng-if="vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr><td>{{ vm.invoicingAddressDict.name }}</td></tr><tr><td>{{ vm.invoicingAddressDict.address }}</td></tr><tr><td>{{ vm.invoicingAddressDict.city }}, {{ vm.invoicingAddressDict.state }} {{ vm.invoicingAddressDict.zipCode }}</td></tr></tbody><tbody ng-if="!vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr ng-repeat="line in vm.customerData.qbAddressArray"><td>{{ line }}</td></tr></tbody></table></div></div><!-- invoice table --><!--  samples table --><div class="rdRow"><div class="rdColumn bigbox" style="min-height: 200px !important"><table><table class="rdInvoiceSamplesTable"><thead><tr><th>{{\'Sample Name\' | translate}}</th><th>{{\'Lot/Batch #\' | translate}}</th><th>{{\'Category (Type)\' | translate}}</th><th>{{\'Type\' | translate}}</th><th>{{\'Matrix\' | translate}}</th></tr><tr><th colspan="5"><hr style="margin: 10px 0 5px 0"></th></tr></thead><tbody><tr ng-repeat="sample in vm.comp.samples"><td valign="center">{{ sample.sample_name }}</td><td>{{ sample.sample_lot_batch_number ? sample.sample_lot_batch_number : \'\' }}</td><td>{{ sample.sample_category.name ? sample.sample_category.name : \'\' }}</td><td>{{ sample.sample_type.name ? sample.sample_type.name : \'\' }}</td><td style="padding: 10px 0">{{ sample.sample_matrix.name ? sample.sample_matrix.name : \'\' }} {{ sample.sample_add_terpenoid_profile ? \' + Terpenes\' : \'\' }} {{ sample.sample_analyze_by_lcmsms ? \' + LCMSMS\' : \'\' }}</td></tr></tbody></table></table></div></div><!-- footer --><div class="rdRow"><div class="rdColumn"><div class="rdInvoiceFooter" style="text-align: center">Prepayment is required for all new clients. Payment terms can be negotiated for routine clients. After the invoice due date, a finance charge of 2% per month will be applied and any discounts will be nullified.<br>Federal Tax ID # 94-2528801<br>DUNS # 05-458-2416</div></div></div><div class="rdRow"><div class="rdColumn"><hr></div></div></div><div class="rdViewRow3"><div style="float: left"><button class="btnPrimaryCancel" ng-click="vm.comp.cancelOrder()"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;{{\'Cancel Order\' | translate}}</button></div><div style="float: right"><button class="btnPrimaryWhite" ng-click="vm.comp.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button ng-show="!vm.comp.submitting" class="btnPrimaryBlue btnLeftMargin progress-button" ng-click="vm.comp.submitOrder()">{{\'Submit Order\' | translate}}</button> <button ng-show="vm.comp.submitting" class="btnPrimaryBlue btnPrimaryBlueDisabled">Submitting&nbsp;<i class="fa fa-spinner fa-spin"></i></button></div></div></div></div></form><!-- QA/R&D Testing --><form name="editForm" ng-class="{\'active\' : vm.active_tab.rd}" class="tab-pane" style="cursor: default" role="form" id="qa_testing"><div class="rdContainer"><div class="rdProgress rdViewRowBasic" style="padding: 0px 15%; text-align: center"><!--progress 1--><div ng-show="vm.rd.step == 1" class="row status-wizard" style="background-color: #eff5fb !important"><div class="col-xs-3 status-wizard-step no-pointer-events active"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus1">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus2">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus3">3 <span>{{\'Order\' | translate}}</span></a></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus4">4 <span>{{\'Review\' | translate}}</span></a></div></div><!--progress 2--><div ng-show="vm.rd.step == 2" class="row status-wizard"><div class="col-xs-3 status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a></div></div><!--progress 3--><div ng-show="vm.rd.step == 3" class="row status-wizard"><div class="col-xs-3 status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div><!--progress 4--><div ng-show="vm.rd.step == 4" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.rd.step = 1" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.rd.step = 2" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.rd.step = 3" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div></div><!-- page 1 --><div class="rdView rdViewRowBasic" ng-show="vm.rd.step == 1"><div class="rdViewRow1"><div class="rdTopBtnContainer"><div style="float: left" ng-if="true"><button class="btnPrimaryWhite" ng-click="vm.rd.downloadExcel()"><i class="fa fa-cloud-download"></i>&nbsp;&nbsp;&nbsp;{{\'Download Excel\' | translate}}</button> <button class="btnPrimaryWhite btnLeftMargin" ng-click="!vm.rd.processingExcelUpload && vm.rd.uploadExcel()" ng-disabled="vm.rd.processingExcelUpload"><i class="fa fa-cloud-upload"></i>&nbsp;&nbsp;&nbsp;{{\'Upload Excel\' | translate}}</button> <input type="file" id="rd_upload_excel" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onchange="uploadExcel()" style="display: none"> <button id="rd_click_upload" ng-click="vm.rd.handleExcel()" style="display: none"></button></div><div style="float: right"><button ng-disabled="vm.rd.samples.length == 0" ng-class="{ \'btnPrimaryCancel\' : !vm.rd.samples.length, \'btnPrimaryWhite\' : vm.rd.samples.length }" ng-click="vm.rd.deleteChecked()"><i class="fa fa fa-trash-o"></i>&nbsp;&nbsp;&nbsp;{{\'Delete Samples\' | translate}}</button> <button ng-click="vm.rd.addSample()" class="btnPrimaryBlue btnLeftMargin"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Samples\' | translate}}</button></div></div></div><div class="rdViewRow2"><div class="rdRow"><div class="rdColumn bigbox rdCustomScrollBarThin" style="max-height: 65vh; overflow: scroll"><table class="rdSamplesTable"><thead><tr><th style="margin-left: 5px"><p ng-class="{ \'rdMainCollapseUp\' : vm.rd.mainCollapse, \'rdMainCollapseDown\': !vm.rd.mainCollapse}"><i id="collapseAll" ng-model="vm.rd.mainCollapse" ng-click="vm.rd.collapseAll()" ng-class="{ \'fa fa-angle-up\' : vm.rd.mainCollapse, \'fa fa-angle-down\' : !vm.rd.mainCollapse}"></i></p><p></p></th><th><label style="display: inline-block" class="checkboxContainer"><input ng-click="vm.rd.clickCheckAllDelete()" style="display: inline-block" class="public-view-item-checkbox delete-checkbox-header" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -10px" class="checkmark"></span></label></th><th>{{\'Sample Name\' | translate}}*</th><th>{{\'Lot/Batch #\' | translate}}</th><th>{{\'Product Category\' | translate}}*</th><th>{{\'Product Type\' | translate}}*</th><th>{{\'Inhalable/Non-Inhalable\' | translate}}*</th><th>{{\'Product Specifications\' | translate}}* <i id="info-modal-icon-0" class="sample-submit-info-modal-trigger product-info fa fa-info-circle"></i><div ng-class="{ \'sample-submit-info-modal-shadow-left\' : test.left, \'sample-submit-info-modal-shadow-right\' : !test.left, }" class="info-modal-0 sample-submit-info-modal product-description info-modal-new"><p>{{\'Please input any internal specifications, label claims, or pass/fail criteria into this field (e.g. 18-22% THC, 100mg CBD +/- 10%, &lt;400ppm acetonitrile). This will allow our lab to proactively investigate any out of spec result, saving time and reducing the potential for analytical or reporting error.\' | translate}}</p></div></th><th></th></tr><tr style="padding-bottom: 0"><th colspan="9"><hr style="margin: 0; color: #E4E8EB"></th></tr></thead><tbody><tr ng-show="vm.rd.samples.length == 0"><td colspan="9" style="height: 250px"><p class="information" style="margin-bottom: 20px; font-size: 11pt; color: #D3DDDE !important">{{\'No sample has been added\' | translate}}</p><button ng-click="vm.rd.addSample()" class="btnPrimaryBlue"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Samples\' | translate}}</button></td></tr><tr class="rowsTest rd-main-sample-row" ng-repeat-start="sample in vm.rd.samples track by $index" ng-class="{ \'rdCollapsedBackground\' : sample.sample_expanded, \'\': !sample.sample_expanded}"><td valign="top" ng-if="vm.rd.customer_type.includes(\'Cannabis\') || vm.rd.customer_type.includes(\'Hemp\')"><div style="padding-top: 10px; margin-left: 5px"><p ng-class="{ \'rdMainCollapseUp\' : sample.sample_expanded, \'rdMainCollapseDown\': !sample.sample_expanded}"><i ng-model="sample.sample_expanded" ng-click="sample.sample_expanded = !sample.sample_expanded" ng-class="{ \'fa fa-angle-up\' : sample.sample_expanded, \'fa fa-angle-down\': !sample.sample_expanded }"></i></p></div><div ng-show="sample.sample_expanded"></div></td><td valign="top"><div><label style="display: inline-block" class="checkboxContainer"><input ng-checked="sample.sample_delete" ng-click="vm.rd.clickDelete($index)" style="display: inline-block" class="public-view-item-checkbox delete-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: 6px; margin-left: -9px" class="checkmark"></span></label></div><div ng-show="sample.sample_expanded"></div></td><td valign="top"><div><input ng-model="sample.sample_name" type="text" placeholder="{{\'Sample Name\' | translate}}" value="{{ sample.sample_name }}" ng-class="{ \'required-input\' : !sample.sample_name }" ng-change="vm.query_autofill(sample)" ng-focus="vm.give_focus(sample, \'autofill\')" ng-blur="vm.lose_focus(sample, \'autofill\')"><div ng-show="sample.focus.autofill && sample.options.autofill && sample.sample_name.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.autofill.length > 0" ng-focus="vm.give_focus(sample, \'autofill\')" ng-repeat="option in sample.options.autofill" ng-bind-html="option.name | highlightMatch:sample.sample_name" ng-click="vm.set_sample_autofill(sample, option)" style="margin: 5px 0; text-align: left">{{ option.name }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.autofill.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'Strain Name\' | translate}}</span> <input ng-model="sample.sample_strain_name" type="text" placeholder="Optional" value="{{ sample.sample_strain_name }}"></div><div ng-show="sample.sample_expanded" style="margin-top:10px"><span>{{\'Expiration Date\' | translate}}</span> <input class="rdDatePicker" placeholder="e.g. 01/01/2025" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="sample.expiration_date" is-open="sample.expiration_date_open" ng-click="vm.rd.openCalendar(sample, \'expiration_date_open\')"></div></td><td valign="top"><div><input ng-model="sample.sample_lot_batch_number" type="text" placeholder="{{\'e.g. abc123\' | translate}}" value="{{ sample.sample_lot_batch_number }}" ng-change="vm.query_sample_lot_batch_number(sample)" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-blur="vm.lose_focus(sample, \'lot_batch_number\')"><div ng-show="sample.focus.lot_batch_number && sample.options.lot_batch_number && sample.sample_lot_batch_number.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.lot_batch_number.length > 0" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-repeat="lot_batch_number in sample.options.lot_batch_number" ng-bind-html="lot_batch_number | highlightMatch:sample.sample_lot_batch_number" ng-click=" vm.set_sample_lot_batch_number(sample, lot_batch_number)" style="margin: 5px 0; text-align: left">{{ lot_batch_number }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.lot_batch_number.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'Strain Type\' | translate}}</span><select ng-model="sample.sample_strain_type" data-live-search="true" type="text" ng-options="strainType as strainType.name for strainType in vm.rd.strainTypes track by strainType.id" ng-class="{ \'rd-placeholder\' : !sample.sample_strain_type }"><option value="" selected="selected" disabled="disabled">{{\'Optional\' | translate}}</option></select></div><div ng-show="sample.sample_expanded" style="margin-top:10px"><span>{{\'Best By Date\' | translate}}</span> <input class="rdDatePicker" placeholder="e.g. 01/01/2025" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="sample.best_buy_date" is-open="sample.best_buy_date_open" ng-click="vm.rd.openCalendar(sample, \'best_buy_date_open\')"></div><div style="margin-top:15px" ng-show="sample.sample_expanded" ng-if="vm.rd.customer_type.includes(\'Hemp\')"><span>{{\'MHLW Product Type\' | translate}}</span><select ng-model="sample.mhlw_product_type" data-live-search="true" type="text" ng-options="type as type for type in vm.rd.mhlwProductTypes"><option value="" selected="selected" disabled="disabled">{{\'Select MHLW Product Type\' | translate}}</option></select></div></td><td valign="top"><div><select ng-change="vm.rd.populateTypes(sample)" ng-model="sample.sample_category" data-live-search="true" type="text" ng-options="category as (category.name | translate) for category in vm.rd.categories | orderBy: \'+name\'" ng-change="vm.rd.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_category }"><option value="" selected="selected" disabled="disabled">{{\'Select Category\' | translate}}</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Label Claims\' | translate}}</span> <input ng-model="sample.sample_label_claims" type="text" placeholder="{{\'Optional\' | translate}}" value="{{ sample.sample_label_claims }}"></div><div ng-show="sample.sample_expanded" style="padding: 32px 0px 10px 5px"><span style="display: inline-flex; align-items: center; gap: 8px"><label style="display: inline-block; width: 18px; height: 18px; margin-bottom: 0" class="checkboxContainer"><input ng-model="sample.medicinal_batch" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span class="checkmark"></span></label>{{\'Medicinal Batch\' | translate}}</span></div></td><td valign="top"><div><select ng-model="sample.sample_type" data-live-search="true" type="text" ng-options="type as (type.name | translate) for type in sample.sample_types | orderBy: \'+name\'" ng-change="vm.rd.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_type }"><option value="" selected="selected" disabled="disabled">{{\'Select Type\' | translate}}</option></select></div><div ng-show="sample.sample_expanded" ng-if="vm.rd.customer_type.includes(\'Cannabis\') || vm.rd.customer_type.includes(\'Hemp\')"><span>{{\'Source UID\' | translate}}</span><!-- ng-if="vm.rd.customer_type.includes(\'Cannabis\') || vm.rd.customer_type.includes(\'Hemp\')" --> <input ng-model="sample.sample_source_id" type="text" placeholder="{{\'Optional\' | translate}}" value="{{ sample.sample_source_id }}"></div></td><td valign="top"><div><select ng-model="sample.sample_inhalable" data-live-search="true" type="text" ng-options="inhalable.value as inhalable.name for inhalable in vm.rd.inhalable track by inhalable.id" ng-change="vm.rd.checkPageOne()" ng-class="{ \'rd-placeholder required-input\' : !sample.sample_inhalable }"><option value="" selected="selected" disabled="disabled">{{\'Select Inhalable\' | translate}}</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Date Collected\' | translate}}</span><div class="food-datetimepicker"><input type="text" class="form-control" datetime-picker="MM/dd/yyyy hh:mm a" ng-model="sample.time_of_collection" is-open="sample.time_of_collection_open" ng-click="sample.time_of_collection_open = !sample.time_of_collection_open" placeholder="Date Collected"> <i style="top: 13px !important; position: absolute; right: 9px" class="fa fa-calendar-o" ng-click="sample.time_of_collection_open = !sample.time_of_collection_open"></i></div></div></td><td valign="top"><div><input maxlength="255" ng-model="sample.sample_expected_potency" ng-change="vm.rd.checkPageOne()" ng-class="{ \'required-input\' : !sample.sample_expected_potency }" type="text" placeholder="{{\'e.g. 20% Vit C\' | translate}}" value="{{ sample.sample_expected_potency }}"></div><div ng-show="sample.sample_expanded"><span>{{\'Production Date\' | translate}}</span> <input class="rdDatePicker" placeholder="e.g. 01/01/2025" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="sample.production_date" is-open="sample.production_date_open" ng-click="vm.rd.openCalendar(sample, \'production_date_open\')"></div></td><td valign="top" style="width: 5%"><div style="display: flex; flex-direction: row"><div style="margin-right: 5px"><a ng-click="vm.rd.removeSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-trash-o"></i></a></div><div style="margin-right: 5px"><a ng-click="vm.rd.cloneSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-clone"></i></a></div></div><div ng-show="sample.sample_expanded"></div></td></tr><tr ng-repeat-end ng-show="sample.sample_expanded" ng-class="{ \'rdCollapsedBackground\' : sample.sample_expanded }" class="rd-ingredients-row"><td ng-if="vm.rd.customer_type.includes(\'Cannabis\') || vm.rd.customer_type.includes(\'Hemp\')" style="border-top: none !important"></td><td style="border-top: none !important"></td><td colspan="3" style="padding: 0 0 15px 0 !important; border-top: none !important"><div><span style="color: #4B627A; font-family: OpenSans-Semibold; font-size: 13px; padding: 5px; display: block">{{\'Product Ingredients\' | translate}}</span><div class="bootstrap-tagsinput rdColumnRightLabel product-ingredients-box" style="padding: 4px 6px; width: 100%; border-radius: 4px"><span class="tag custom-label label-email" style="display: inline-flex; align-items: center; margin: 2px 3px 2px 0; padding: 2px 8px; border-radius: 3px; font-size: 12px; line-height: 1.6; max-width: 220px; overflow: hidden" ng-repeat="ingredient in sample.sample_product_ingredients_tags track by $index"><span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ingredient}}</span><span data-role="remove" style="cursor: pointer; margin-left: 6px; flex-shrink: 0" ng-click="vm.remove_ingredient(sample, $index)"></span> </span><input type="text" ng-model="sample.ingredient_input" ng-change="vm.query_ingredients(sample)" ng-keydown="vm.ingredient_keydown(sample, $event)" ng-focus="vm.give_focus(sample, \'ingredients\')" ng-blur="vm.lose_focus(sample, \'ingredients\')" placeholder="{{sample.sample_product_ingredients_tags.length ? \'\' : (\'Optional\' | translate)}}" style="border: none !important; outline: none; box-shadow: none; background-color: transparent; padding: 5px !important; width: auto; max-width: 100%"></div><div ng-show="sample.focus.ingredients && sample.options.ingredients.length > 0 && sample.ingredient_input.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-repeat="ingredient in sample.options.ingredients track by $index" ng-mousedown="$event.preventDefault(); vm.add_ingredient(sample, ingredient)" ng-bind-html="ingredient | highlightMatch:sample.ingredient_input" style="margin: 5px 0; text-align: left; cursor: pointer">{{ ingredient }}</li></div></div></div></td><td colspan="4" style="border-top: none !important"></td></tr></tbody></table></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryBlue" ng-disabled="!vm.rd.pageOneValid || vm.rd.processingExcelUpload" ng-click="vm.rd.incrementPage()" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.rd.pageOneValid || vm.rd.processingExcelUpload }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 2 --><div class="rdView rdViewRowBasic" ng-show="vm.rd.step == 2"><div class="rdViewRow1"><div class="rdTopBtnContainer" style="width: 330px; border-radius: 3px; margin-bottom: 20px; position: relative"><div id="add-test" class="dropdown"><button id="search-dropdown" data-toggle="dropdown" style="display: none"></button> <input id="search-assay-input" type="text" ng-change="vm.rd.filterAssays()" onfocus="$(\'#search-dropdown\').click()" placeholder="Search for tests.." ng-model="vm.rd.test_to_search"><ul id="rd-dropdown-menu" class="dropdown-menu" role="menu" style="padding-bottom: 5px"><li role="presentation"><button data-toggle="modal" data-target="#rdAddRequestedTest" class="request-test-btn"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Request Test</button></li><li ng-repeat="test in vm.rd.tests | filter: vm.rd.customFilter track by test.id" ng-click="test.display_name ? vm.rd.select_test_to_search(test.display_name) : vm.rd.select_test_to_search(test.reporting_title)"><span><span style="color:#069FD6;margin-right:5px">ID:{{test.id}}</span>{{ test.display_name ? test.display_name : test.reporting_title }}</span></li></ul></div><div><button ng-click="vm.rd.clear_test_to_search()" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.rd.test_to_search }" class="btnPrimaryBlue" style="position: absolute; top: 8px; left: 258px; padding: 1px 15px; height: 25px">{{\'Clear\' | translate}}</button></div></div></div><div class="rdViewRow2"><div class="rdRow rdTestsTable bigbox" style="padding: 0 15px"><div class="rdColumn" style="flex: 1; border-right: 1px solid #EDEDED; overflow-x: visible; overflow-y: auto; max-height: 65vh"><table class="rdTestsTableLeft" style="overflow: visible"><thead style="overflow: visible"><tr style="border-bottom: 1px solid #EDEDED"><th style="height: 150px; padding-top: 93px">{{\'Sample Name\' | translate}}</th><th ng-show="sample.sample_lot_batch_number">{{\'Lot/Batch#\' | translate}}</th><th style="height: 150px; overflow: visible; position: sticky; top: 0; background: #fff; padding-top: 93px"><div style="display: flex; flex-direction: column; align-items: center"><span>{{\'Panels\' | translate}}</span><div class="dropdown rnd-page" style="margin-bottom:8px; margin-right: 10px; position: relative; width: 90%; min-width: 125px"><button class="panel-btn dropdown-toggle-rnd" type="button" data-toggle="dropdown" style="width: 100%; font-size: 8pt">{{ \'Apply to All\' | translate }} <span class="caret"></span></button><ul class="dropdown-menu" role="menu" style="z-index: 1050; max-height: 300px; overflow-y: auto"><li role="presentation"><button ng-click="vm.rd.clearPanelFromAll()" class="clear-panel-btn">{{\'Clear All Panels\' | translate}}</button></li><li role="presentation"><button ng-click="vm.toggleQbenchPanelVisibility()" class="clear-panel-btn" style="border-color: #00000042">{{ vm.showQbenchPanels.settings.sample_submit.show_anresco_panels ? \'Hide Lab Panels\' : \'Show Lab Panels\' }}</button></li><li role="presentation" ng-repeat="panel in vm.rd.qbenchPanels" ng-show="vm.showQbenchPanels.settings.sample_submit.show_anresco_panels"><label style="width: 100%; cursor: pointer; padding: 3px 10px; color: #34485c; display: block" ng-click="vm.rd.applyPanelToAll(panel.id, panel.type)"><input type="radio" name="apply-to-all-panel" style="margin-right: 5px"> <span>ID:{{ panel.id }} {{ panel.title | translate }}&nbsp;<i>({{ panel.assays.length }})</i></span></label></li><li role="presentation" ng-repeat="customPanel in vm.rd.customPanels"><label style="width: 100%; cursor: pointer; padding: 3px 10px; color: #34485c; display: block" ng-click="vm.rd.applyPanelToAll(customPanel.id, customPanel.type)"><input type="radio" name="apply-to-all-panel" style="margin-right: 5px"> <span>ID:{{ customPanel.id }} {{ customPanel.title }}&nbsp;<i>({{ customPanel.assays.length }})</i></span></label></li></ul></div></div></th></tr></thead><tbody><tr ng-repeat="sample in vm.rd.samples track by $index"><td style="width: 30%; color: #34485c; font-size: 10pt !important; font-family: OpenSans-Regular">{{ sample.sample_name }}</td><td ng-show="sample.sample_lot_batch_number" style="width: 30%; color: #34485c; font-size: 10pt !important; font-family: OpenSans-Regular">{{ sample.sample_lot_batch_number }}</td><td ng-show="sample.sample_has_tests && !sample.sample_panel_selected && !sample.sample_current_panel_title" style="width: 40%; text-align: center"><button class="add-panel-btn" ng-click="vm.rd.savePanel($index, 1)"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Panel\' | translate}}</button></td><td ng-show="sample.sample_has_tests && sample.sample_panel_selected && (sample.sample_panel_type == \'custom_panel\')" style="width: 40%; text-align: center"><button class="add-panel-btn" ng-click="vm.rd.updatePanel($index, sample.sample_panel_selected)"><i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;{{\'Update Panel\' | translate}}</button></td><td ng-show="sample.sample_panel_selected || !sample.sample_has_tests || (sample.sample_panel_type == \'qbench_panel\')" style="width: 40%; text-align: center"><div class="dropdown rnd-page"><button class="panel-btn dropdown-toggle-rnd" id="menu-{{$index}}" type="button" data-toggle="dropdown" style="font-size: 8pt">{{ sample.sample_current_panel_title ? sample.sample_current_panel_title : \'Select Panel\' }} <span class="caret"></span></button><ul id="rd-dropdown-menu" class="dropdown-menu" role="menu" aria-labelledby="menu-{{$index}}"><li role="presentation"><button ng-disabled="!sample.sample_panel_type" ng-click="vm.rd.removePanelFromSample($index)" class="clear-panel-btn">{{\'Clear Panel\' | translate}}</button></li><li role="presentation"><button ng-click="vm.toggleQbenchPanelVisibility()" class="clear-panel-btn" style="border-color: #00000042">{{ vm.showQbenchPanels.settings.sample_submit.show_anresco_panels ? \'Hide Lab Panels\' : \'Show Lab Panels\' }}</button></li><li role="presentation" ng-repeat="panel in vm.rd.qbenchPanels" ng-show="vm.showQbenchPanels.settings.sample_submit.show_anresco_panels"><label for="panel-{{ $parent.$index }}-{{ panel.id }}"><input type="radio" ng-class="{\'ng-pristine ng-untouched ng-valid ng-not-empty\' : panel.length == 0}" ng-click="vm.rd.setPanel($parent.sample, panel.id, panel.type)" name="panel-{{ $parent.$index }}" id="panel-{{ $parent.$index }}-{{ panel.id }}" ng-model="sample.sample_panel_by_id" value="{{ panel.id }}"> <span class="spanDataAddress">ID:{{ panel.id }} {{ panel.title | translate }}&nbsp;<i>({{ panel.assays.length }})</i><div class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px;left: -80px; bottom: 100%; margin-bottom: -5px; max-height: 400px; overflow-y: auto"><svg style="position: absolute; top: 100%; left: 60px" height="20" width="50"><polygon points="20,0 11,10 20,20" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left;font-size: 20px; font-family: OpenSans-Bold; word-wrap: break-word; overflow-wrap: break-word"><span style="color:#069FD6">ID:{{panel.id}}&nbsp;</span>{{ panel.title }}</div><div ng-if="panel.description" style="color: #3d5269; text-align: left; padding-top: 10px" ng-style="{\'padding-bottom\': (panel.price || panel.turnaround_time || panel.min_sample_size) ? \'12px\' : \'0px\'}">{{ panel.description }}</div><div ng-if="panel.price" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><span>$</span>{{ panel.price }}</div></div><div ng-if="panel.turnaround_time" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Turnaround Time</div><div style="color: #3d5269">{{ panel.turnaround_time }} days</div></div><div ng-if="panel.min_sample_size" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Sample Size</div><div style="color: #3d5269">{{ panel.min_sample_size }}</div></div><div ng-if="panel.assays && panel.assays.length > 0" style="padding-top: 12px"><div style="color: #606f7b; padding-bottom: 8px">Assays:</div><ul style="display: block; margin: 0; padding-left: 0; color: #3d5269; list-style-type: none"><li ng-repeat="assay in panel.assays" style="margin-bottom: 4px"><i class="fa fa-circle" style="font-size: 6px; margin-right: 8px; vertical-align: middle"></i>{{ assay.display_name }}</li></ul></div></div></div></div></span></label></li><li role="presentation" ng-repeat="customPanel in vm.rd.customPanels"><label ng-disabled="customPanel.length == 0" for="customPanel-{{ $parent.$index }}-{{ customPanel.id }}" style="width: 100%"><input type="radio" ng-disabled="customPanel.length == 0" ng-class="{\'ng-pristine ng-untouched ng-valid ng-not-empty\' : customPanel.length == 0}" ng-click="vm.rd.setPanel($parent.sample, customPanel.id, customPanel.type)" name="customPanel-{{ $parent.$index }}" id="customPanel-{{ $parent.$index }}-{{ customPanel.id }}" ng-model="sample.sample_panel_by_id" value="{{ customPanel.id }}"> <span class="spanDataAddress">ID:{{ customPanel.id }} {{ customPanel.title }}&nbsp;<i>({{ customPanel.assays.length }})</i><div class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px;left:-80px; bottom: 100%; margin-bottom: -5px; max-height: 400px; overflow-y: auto"><svg style="position: absolute; top: 100%; left: 60px" height="20" width="50"><polygon points="20,0 11,10 20,20" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left;font-size: 20px; font-family: OpenSans-Bold; word-wrap: break-word; overflow-wrap: break-word"><span style="color:#069FD6">ID:{{customPanel.id}}&nbsp;</span>{{ customPanel.title }}</div><div ng-if="customPanel.description" style="color: #3d5269; text-align: left; padding-top: 10px" ng-style="{\'padding-bottom\': (customPanel.price || customPanel.duration || customPanel.minimum_quantity_required) ? \'12px\' : \'0px\'}">{{ customPanel.description }}</div><div ng-if="customPanel.price" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><span>$</span>{{ customPanel.price }}</div></div><div ng-if="customPanel.duration" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Turnaround Time</div><div style="color: #3d5269">{{ customPanel.duration }} days</div></div><div ng-if="customPanel.minimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Sample Size</div><div style="color: #3d5269">{{ customPanel.minimum_quantity_required }}</div></div><div ng-if="customPanel.assays && customPanel.assays.length > 0" style="padding-top: 12px"><div style="color: #606f7b; padding-bottom: 8px">Assays:</div><ul style="display: block; margin: 0; padding-left: 0; color: #3d5269; list-style-type: none"><li ng-repeat="assay in customPanel.assays" style="margin-bottom: 4px"><i class="fa fa-circle" style="font-size: 6px; margin-right: 8px; vertical-align: middle"></i>{{ assay.display_name }}</li></ul></div></div></div></div><span style="float: right; padding-right: 10px"><a ng-click="vm.rd.deletePanel(customPanel.id)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px"><i class="fa fa-trash-o"></i></a></span></span></label></li></ul></div></td><div ng-if="!test.analysis_description" style="color: #2f3e52 !important">{{ test.display_name ? test.display_name : test.reporting_title }}</div></tr></tbody></table></div><div id="rd-tests-scrollbar" class="rdColumn rdCustomScrollBarThin" style="flex: 2; max-width: 60%; overflow-x: scroll; overflow-y: auto; max-height: 65vh"><div class="rdRow" style="flex-wrap: nowrap; padding: 0; height: 100%"><table ng-show="vm.rd.other_analyses.length > 0 && !vm.rd.test_to_search" class="rdTestsTableRight" style="position: relative; border-right: 1px solid #EDEDED"><thead><tr style="border-bottom: 1px solid #EDEDED"><th style="height: 30px; white-space: nowrap" colspan="{{ vm.rd.other_analyses.length }}">{{\'Requested Tests\' | translate}}</th></tr><tr><th valign="bottom" style="height: 120px" ng-repeat="requested_test in vm.rd.other_analyses track by $index"><div class="samples-assay-title" style="color: #2f3e52 !important">{{ requested_test }}</div><br><label style="display: inline-block" class="checkboxContainer"><input class="added-assay-col-header-{{$index}}" ng-click="vm.rd.clickCheckAllAddedTest(requested_test, $index)" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></th></tr></thead><tbody><tr ng-repeat="sample in vm.rd.samples track by $index"><td ng-repeat="requested_test in vm.rd.other_analyses track by $index"><label style="display: inline-block" class="checkboxContainer"><input ng-click="vm.rd.checkPageTwo()" ng-model="sample.sample_other_analyses[requested_test]" ng-checked="sample.sample_other_analyses[requested_test]" class="added-assay-col-{{$index}} public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -7px; margin-left: -11px" class="checkmark"></span></label></td></tr></tbody></table><table class="rdTestsTableRight varHeight" style="border-right: 1px solid #EDEDED" ng-class="{ \'rdLastElementBorder\' : !vm.rd.test_to_search }"><thead><tr ng-show="!vm.rd.test_to_search" style="border-bottom: 1px solid #EDEDED"><th ng-if="vm.rd.number_of_freq_assays" style="height: 30px; white-space: nowrap; border-right: 1px solid #EDEDED" colspan="{{ vm.rd.number_of_freq_assays }}">{{\'Frequent Tests\' | translate}}</th><th ng-if="vm.rd.tests.length > vm.rd.number_of_freq_assays" style="height: 30px; white-space: nowrap; border-right: 1px solid #EDEDED" colspan="{{ vm.rd.tests.length - vm.rd.number_of_freq_assays }}">{{\'Configured Tests\' | translate}}</th></tr><tr><th valign="bottom" ng-class="{ \'rd150Height\' : vm.rd.test_to_search, \'rd120Height\' : !vm.rd.test_to_search, \'rdFrequentTestsBorderRight\' : $index == vm.rd.number_of_freq_assays-1 }" ng-show="vm.rd.tests[$index] && vm.rd.customFilter(vm.rd.tests[$index])" ng-repeat="test in vm.rd.tests track by $index" class="overflow-visible"><div><span class="samples-assay-title"><span style="color:#069FD6">ID:{{test.id}}&nbsp;</span>{{ test.display_name ? (test.display_name | translate) : (test.reporting_title | translate) }}&nbsp;</span><div class="sample-submit-info-modal-trigger-new"><i ng-if="test.info_modal" id="info-modal-icon-{{$index}}" class="fa fa-info-circle"></i><div ng-class="{ \'sample-submit-info-modal-shadow-left\' : test.left, \'sample-submit-info-modal-shadow-right\' : !test.left, }" class="info-modal-{{$index}} sample-submit-info-modal info-modal-new"><svg ng-if="!test.left" style="position: absolute; bottom: 10px; left: -20px" height="20" width="50"><polygon points="20,0 20,20 11,10" style="fill:#f5f5f5"/></svg> <svg ng-if="test.left" style="position: absolute; bottom: 10px; right: -20px" height="20" width="20"><polygon points="0,0 00,20 11,10" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left; padding-bottom: 24px; font-size: 20px; font-family: OpenSans-Bold"><span style="color:#069FD6">ID:{{test.id}}&nbsp;</span>{{ (test.display_name ? test.display_name : test.reporting_title) | translate }}</div><div style="color: #3d5269; text-align: left; padding-bottom: 12px">{{ test.info_modal.description ? test.info_modal.description.replaceAll("?", \'&#916;\') : \'\'}}</div><div ng-if="test.info_modal.base_price && vm.currentLanguage !== \'jp\'" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><div ng-if="!test.info_modal.display_price">{{ test.info_modal.base_price ? test.info_modal.base_price : \'\' }}</div><div ng-if="test.info_modal.display_price"><span style="text-decoration: line-through">{{ test.info_modal.base_price ? test.info_modal.base_price : \'\' }}</span> {{ test.info_modal.display_price ? test.info_modal.display_price : \'\'}}</div></div></div><div ng-if="test.info_modal.method" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Method</div><div style="color: #3d5269; max-width: 60%"><!-- <div style="text-align: right;" ng-repeat="method in test.info_modal.method">{{ method }}</div> --><div style="text-align: right">{{ test.info_modal.method.length > 1 ? \'Various\' : test.info_modal.method[0] }}</div></div></div><div ng-if="test.info_modal.instrument" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Instrument</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right" ng-repeat="instrument in test.info_modal.instrument">{{ instrument }}</div></div></div><div ng-if="test.info_modal.duration" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">{{\'Turnaround Time\' | translate}}</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.duration }} days</div></div></div><div ng-if="test.info_modal.minimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Minimum Sample Size</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.minimum_quantity_required }}</div></div></div><div ng-if="test.info_modal.optimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Optimal Sample Size</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.optimum_quantity_required }}</div></div></div></div></div></div></div><br><label style="display: inline-block" class="checkboxContainer"><input class="assay-col-header-{{$index}}" ng-click="vm.rd.clickCheckAllTest($index)" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></th></tr></thead><tbody><tr ng-repeat="sample in vm.rd.samples track by $index"><td ng-repeat="test in vm.rd.tests track by $index" ng-class="{ \'rdFrequentTestsBorderRight\' : $index == vm.rd.number_of_freq_assays-1 }" ng-show="vm.rd.showTests[test.display_name]"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.rd.sampleArray[$parent.$index][$index]" ng-checked="vm.rd.sampleArray[$parent.$index][$index]" ng-change="vm.rd.checkClick(sample, test, $parent.$index, $index)" ng-click="vm.rd.checkClick(sample, test, $parent.$index, $index)" class="assay-col-{{$index}} public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -7px; margin-left: -11px" class="checkmark"></span></label></td></tr></tbody></table><table style="width: 100%; height: 100%" ng-show="(vm.rd.tests | filter: vm.rd.customFilter).length == 0"><thead><th style="height: 150px"></th></thead><tbody><tr><td><p class="information" style="margin-bottom: 20px; font-size: 11pt; color: #D3DDDE !important">No tests found. Click below to request a test.</p><button data-toggle="modal" data-target="#rdAddRequestedTest" class="btnPrimaryBlue"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Request Test</button></td></tr></tbody></table></div></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryWhite" ng-click="vm.rd.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button class="btnPrimaryBlue btnLeftMargin" ng-click="vm.rd.incrementPage()" ng-disabled="!vm.rd.pageTwoValid" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.rd.pageTwoValid }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 3 --><div class="rdView rdViewRowBasic" ng-show="vm.rd.step == 3"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><div><div class="rdRow"><div class="rdColumn"><label class="rdColumnLeftLabel">{{\'Contact Name\' | translate}}</label><input type="text" ng-model="vm.contact.name" disabled="disabled" class="ng-pristine ng-untouched ng-valid ng-not-empty"><div class="rdRow"><label class="rdColumnLeftLabel">{{\'Contact Phone #\' | translate}}<span ng-if="vm.rd.deliveryPreference ===\'Anresco Pick-Up\'" class="rdRequired">&nbsp;*</span></label><input type="text" ng-change="vm.rd.checkPageThree()" ng-model="vm.contact.phone" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div class="rdColumn" style="width: 50%"><label class="rdColumnRightLabel" style="display: inline-flex"><div>{{\'Email Recipients\' | translate}}<span class="rdRequired">&nbsp;*</span></div><div style="font-size: 9pt; margin: auto 0 auto auto"><a ng-if="false" disabled="disabled" href="#">{{\'Manage users\' | translate}}</a></div></label><div class="rdColumnRightLabel" ng-class="{\'required-input\' : !vm.rd.emails || vm.rd.emails.length === 0}"><input type="text" class="rdColumnRightInput" id="rdEmailRecepients" data-role="tagsinput" ng-model="vm.rd.emails" ng-change="vm.rd.checkPageThree()"></div><div class="rdRow"><label class="rdColumnRightLabel">{{\'Project/PO#\' | translate}}</label><input ng-model="vm.rd.orderPO" type="text" placeholder="Optional" class="rdColumnRightInput"></div></div></div><div class="rdRow"><div class="rdColumn" style="width: 50%"><label class="rdColumnLeftLabel">{{\'Customer/Reporting Address\' | translate}}</label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 95% !important; height: 45px" ng-click="openDistributionList()" type="text" name="d-location" class="add_option" ng-model="vm.samplingAddress" placeholder="Choose Location / Add New" value="" readonly="readonly" ng-change="vm.rd.checkPageThree()"></div><ul style="width: 95% !important" class="add_new_list location-list" ng-class="DistributionList"><li style="width: 95% !important; height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-distribution">+ Add New</li><li style="width: 95% !important; height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'DISTRIBUTION_LOCATION\'"><span class="spanDataAddress" ng-click="copyDistributionData(address.address, address.city,  address.zipCode, address.distributorName,  address.medicalLicence, address.fullLocation, address.licenceList)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'DISTRIBUTION\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="rdColumn" style="width: 50%"><label class="rdColumnRightLabel">{{\'Invoicing Address\' | translate}}</label><div class="input-autocomplate rdColumnRightLabel"><div class="add-option-caretRD"><input ng-click="openInvoicingList()" style="height: 45px" type="text" name="invoicing-location" class="add_option" ng-model="vm.fullLocationInvoicing" placeholder="{{vm.customerData.qbAddress.replace(\'\\n\', \'; \')}}" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="InvoicingList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-invoicing">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'INVOICING_LOCATION\'"><span class="spanDataAddress" ng-click="copyInvoicingData(address.address, address.city,  address.zipCode, address.distributorName,  address.state)">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'INVOICING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div><div class="rdRow"><div class="rdColumn" style="width:50%"><label class="rdColumnLeftLabel">{{\'Manufacturing Address\' | translate}}</label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 95% !important; height: 45px" ng-click="openManufacturingList()" type="text" name="CM-location" class="add_option" ng-model="vm.fullLocationManufactur" placeholder="Choose Location / Add New" value="" readonly="readonly"></div><ul style="width: 95% !important" id="locationList" class="add_new_list location-list" ng-class="ManufacturingList"><li class="add_new_option" style="width: 95% !important; height: 45px" data-toggle="modal" data-target="#add-new-manufacturing">+ Add New</li><li ng-repeat="address in records" style="width: 95% !important; height: 45px" ng-if="address.locationType === \'CULTIVATION_LOCATION\'"><span class="spanDataAddress" ng-click="copyManufacturingData(address.address, address.city, address.zipCode, address.distributorName, address.medicalLicence, address.fullLocation, address.licenceList)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'CULTIVATION\')" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="rdColumn" style="width:50%"><label class="rdColumnLeftLabel">{{\'Pickup/Arrival Date\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div class="youremail foodadddate datepickerdate" ng-class="{\'required-input\' : !vm.rd.pickup_arrival_date}" style="width: 95% !important"><input class="datepicker" ng-change="vm.rd.estimateReportDate(vm.rd.turnaroundTime)" placeholder="{{\'Pickup/Arrival Date\' | translate}}" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="vm.rd.pickup_arrival_date" is-open="vm.datePickerOpenStatus.pickup_arrival_date" ng-click="vm.openCalendar(\'pickup_arrival_date\')" style="width: 100% !important"> <i style="margin-top: -29px !important" class="fa fa-calendar-o" ng-click="vm.openCalendar(\'pickup_arrival_date\')"></i></div></div></div><div class="rdRow"><div class="rdColumn" style="width: 50%" ng-if="vm.rd.deliveryPreference ===\'Anresco Pick-Up\'"><label ng-if="vm.rd.deliveryPreference ===\'Anresco Pick-Up\'" class="rdColumnRightLabel">{{\'Pickup Address\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div ng-if="vm.rd.deliveryPreference ===\'Anresco Pick-Up\'" class="input-autocomplate rdColumnRightLabel" ng-class="{ \'required-input\': !vm.fullLocationPickup || vm.fullLocationPickup.length === 0}"><div class="add-option-caretRD"><input ng-click="openpickupList()" style="height: 45px" type="text" name="pickup-location" class="add_option" ng-model="vm.fullLocationPickup" placeholder="Select pickup address" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="PickupList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-pickup">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'PICKUP_LOCATION\'"><span class="spanDataAddress" ng-click="copyPickupData(address.address, address.city,  address.zipCode, address.distributorName,  address.state);vm.rd.checkPageThree()">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'PICKUP\');vm.rd.checkPageThree()" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><!-- Error message if pickup address not in California --><div ng-if="vm.pickupOutOfStateError" style="color: #d9534f; margin-top: 8px; padding: 10px; background-color: #f2dede; border: 1px solid #ebccd1; border-radius: 4px; font-size: 14px"><strong>\u26A0 Pickup service is currently only available in California.</strong> Please select a California address or choose a different delivery option.</div><div class="rdColumn" style="width: 50%" ng-if="vm.rd.deliveryPreference === \'Mail\'"><label class="rdColumnLeftLabel">{{\'Tracking Number\' | translate}}</label><input style="width: 48% !important" type="text" ng-model="vm.rd.tracking_number" placeholder="{{\'Tracking Number\' | translate}}" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div class="rdRow"><div class="rdColumn" style="flex-direction: unset"><div class="companyinfo preference"><label class="cm-label">{{\'Delivery Preference\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div class="topbuffer05"></div><div class="Requestedradio" ng-class="{\'required-input\' : !vm.rd.deliveryPreference}"><label for="rd_anrescoPickUp"><input tabindex="7" type="radio" name="deliveryPreference" id="rd_anrescoPickUp" checked="checked" ng-model="vm.rd.deliveryPreference" ng-change="vm.rd.checkPageThree()" value="Anresco Pick-Up"> <span>{{ vm.pickupLabel }}</span></label><div class="topbuffer05"></div><label for="rd_clientDropOff"><input tabindex="8" type="radio" name="deliveryPreference" id="rd_clientDropOff" ng-model="vm.rd.deliveryPreference" ng-change="vm.rd.checkPageThree()" value="Client Drop-Off"> <span>Client Drop-Off</span></label><div class="topbuffer05"></div><label for="rd_mail"><input tabindex="9" type="radio" name="deliveryPreference" id="rd_mail" ng-change="vm.rd.checkPageThree()" ng-model="vm.rd.deliveryPreference" value="Mail"> <span>Mail</span></label></div></div><div class="companyinfo preference" style="margin-left: 10%; font-family: OpenSans-Regular"><label class="cm-label">{{\'Turnaround Time\' | translate}}<span class="rdRequired">&nbsp;*</span><a href="javascript:void(0)" class="ss-tooltips"><i class="fa fa-question-circle"></i><!-- <span>Standard turnaround time for routine analyses is 3 business days from receipt of your sample(s) unless otherwise noted or negotiated.  Standard turnaround time for non-routine analyses is 10 business days.  If a rush option is selected, a customer service representative will be in touch to confirm feasibility.</span> --> <span>{{\'Standard turnaround time varies depending on analysis.\' | translate}}<br><br>- {{\'Routine cannabis and hemp testing has a standard 3 day TAT.\' | translate}}<br>- {{\'Routine microbiological and kratom testing has a standard 5 day TAT.\' | translate}}<br>- {{\'Nutritional labeling has a standard 15 day TAT.\' | translate}}<br>- {{\'Most other assays have a standard 10 day TAT.\' | translate}}<br><br>Expedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or {{ vm.supportEmail }} for additional info regarding these options.</span></a></label><div class="topbuffer05"></div><div ng-if="!vm.rd.turnaroundTimeOptions" ng-init="turnaroundTime=\'10 Days (standard)\'" ng-class="{\'required-input\' : !vm.rd.turnaroundTime}"><label for="cannabis-turnaroundTime"><input type="radio" ng-model="vm.rd.turnaroundTime" value="10 Days (standard)"> <span>10 Days (standard)</span></label><div class="topbuffer05"></div></div><div class="Requestedradio" ng-class="{\'required-input\' : !vm.rd.turnaroundTime}"><div ng-repeat="turnaround in vm.rd.turnaroundTimeOptions"><label for="cannabis-turnaroundTime-{{$index}}"><input type="radio" name="cannabis-turnaroundTime-{{$index}}" id="cannabis-turnaroundTime-{{$index}}" ng-checked="$index == 0" value="{{turnaround}}" ng-change="vm.rd.estimateReportDate(vm.rd.turnaroundTime)" ng-model="vm.rd.turnaroundTime"> <span>{{turnaround}}</span></label><div class="topbuffer05"></div></div></div></div></div><div class="rdColumn"><div style="height: 100%; width: 95%; margin: auto 0 -14px auto"><div ng-show="vm.rd.estimated_report_date" class="rdReportDateCard"><p style="font-size: 16px; font-family: OpenSans-SemiBold">{{\'Estimated Report Date\' | translate}}</p><p style="font-size: 20px; padding-top: 30px; font-family: OpenSans-Bold">{{ vm.rd.estimated_report_date.day ? vm.rd.estimated_report_date.day + \',\' : \'\' }}</p><p style="font-size: 30px; font-family: OpenSans-Bold">{{ vm.rd.estimated_report_date.month_day_year ? vm.rd.estimated_report_date.month_day_year : \'Unavailable\' }}</p></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt; display: flex; gap: 20px"><div style="flex: 1; text-align: left; position: relative"><details open><summary style="font-size: 13px; color: #4F8FCC">{{\'Special Instructions\' | translate}}</summary><textarea style="width: 100%; height: 100px" ng-model="vm.rd.specialInstructions" type="text" placeholder="{{\'Special Instructions\' | translate}}" ng-change="vm.query_order_field(\'rd\', \'specialInstructions\', \'special_instructions\')" ng-focus="vm.orderFieldFocus.specialInstructions = true" ng-blur="vm.orderFieldFocus.specialInstructions = false"></textarea><div ng-show="vm.orderFieldFocus.specialInstructions && vm.orderFieldOptions.specialInstructions.length > 0 && vm.rd.specialInstructions.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.specialInstructions track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'rd\', \'specialInstructions\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></details></div><div style="flex: 1; text-align: left; position: relative"><label style="font-size: 13px; color: #4F8FCC">{{\'Customer Comments\' | translate}} <span class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle" style="cursor: pointer"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px; left: -10px; bottom: 20px; margin-bottom: -5px"><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 12px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left; font-size: 12px">Any comment typed into this box will display on the consolidated COA below the sample photo and above the analytical results.</div></div></div></span></label><textarea style="width: 100%; height: 100px" ng-model="vm.rd.customerComments" type="text" placeholder="{{\'Customer Comments\' | translate}}" ng-change="vm.query_order_field(\'rd\', \'customerComments\', \'customer_comments\')" ng-focus="vm.orderFieldFocus.customerComments = true" ng-blur="vm.orderFieldFocus.customerComments = false"></textarea><div ng-show="vm.orderFieldFocus.customerComments && vm.orderFieldOptions.customerComments.length > 0 && vm.rd.customerComments.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.customerComments track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'rd\', \'customerComments\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt"><details open><summary style="font-size: 13px; color: #4F8FCC;display:block;text-align: left">{{\'Document Upload\' | translate}}</summary><div style="margin-top: 10px"><input type="file" id="rd-file-upload" multiple="multiple" style="display: none" onchange="onRdFileUpload()"> <button style="display:block; margin-bottom: 10px" type="button" class="btnPrimaryWhite" onclick="document.getElementById(\'rd-file-upload\').click()"><i class="fa fa-upload"></i>&nbsp;&nbsp;{{\'Select File\' | translate}}</button><div ng-if="vm.rd.uploadedFiles.length > 0" style="margin-top: 10px"><div ng-repeat="file in vm.rd.uploadedFiles" style="padding: 1px 20px; background: #fff; margin-bottom: 5px; border-radius: 3px; border: 1px solid #4f8fcc; display: flex; justify-content: space-between; align-items: center; height: 35px; font-size: 14px; width: 600px"><span><i class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }} ({{ vm.formatFileSize(file.size) }})</span> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.rd.removeFile($index)" style="padding: 2px 8px"><i class="fa fa-times"></i></button></div></div></div></details></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryWhite" ng-click="vm.rd.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button class="btnPrimaryBlue btnLeftMargin" ng-click="vm.rd.incrementPage()" ng-disabled="!vm.rd.pageThreeValid" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.rd.pageThreeValid }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 4 --><div class="rdView rdViewRowBasic" ng-show="vm.rd.step == 4"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><!-- reporting address, email recipients --><div class="rdRow"><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Reporting Address\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td><span ng-show="vm.reportingAddressDict.name">Attn: {{ vm.reportingAddressDict.name }}</span></td></tr><tr><td><span ng-show="vm.reportingAddressDict.address">{{ vm.reportingAddressDict.address }}</span></td></tr><tr><td><span ng-show="vm.reportingAddressDict.zipCode">{{ vm.reportingAddressDict.city + \', \' + vm.reportingAddressDict.zipCode }}</span></td></tr><tr ng-repeat="lic in (vm.reportingAddressDict.licenceList || vm.reportingAddressDict.medicalLicence || \'\').split(\',\')"><td>{{ lic.trim() }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Email Recipients\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr ng-repeat="email in vm.rd.emailsArray"><td>{{ email ? email : \'No Emails Selected\'}}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Invoicing Address\' | translate}}</th></tr></thead><tbody ng-if="vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr><td>{{ vm.invoicingAddressDict.name }}</td></tr><tr><td>{{ vm.invoicingAddressDict.address }}</td></tr><tr><td>{{ vm.invoicingAddressDict.city }}, {{ vm.invoicingAddressDict.state }} {{ vm.invoicingAddressDict.zipCode }}</td></tr></tbody><tbody ng-if="!vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr ng-repeat="line in vm.customerData.qbAddressArray"><td>{{ line }}</td></tr></tbody></table></div></div><!-- delivery, turnaround, po# --><div class="rdRow" style="margin-top: 40px"><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Delivery\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.rd.deliveryPreference ? vm.getDeliveryPreferenceDisplay(vm.rd.deliveryPreference) : \'Delivery Preference Not Selected\' }}</td></tr><tr><td style="font-style: italic">{{ vm.rd.pickup_arrival_date | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Turnaround Time\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.rd.turnaroundTime ? vm.rd.turnaroundTime : \'4-5 days (standard)\' }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'PO#\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.rd.orderPO ? vm.rd.orderPO : \'None\' }}</td></tr></tbody></table></div></div><!-- special instructions --><div class="rdRow" style="margin-top: 40px"><div class="rdColumn" style="flex: 2"><table class="rdTable"><thead><tr><th>{{\'Special Instructions\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.rd.specialInstructions ? vm.rd.specialInstructions : \'None\' }}</td></tr></tbody></table></div><div class="rdColumn" style="flex: 1"></div></div><!-- invoice table --><!--  samples table --><div class="rdRow"><div class="rdColumn bigbox" style="min-height: 200px !important"><table><table class="rdInvoiceSamplesTable"><thead><tr><th>{{\'Sample Name\' | translate}}</th><th>{{\'Lot/Batch #\' | translate}}</th><th>{{\'Category (Type)\' | translate}}</th><th>{{\'Type\' | translate}}</th><th>{{\'Tests\' | translate}}</th></tr><tr><th colspan="5"><hr style="margin: 10px 0 5px 0"></th></tr></thead><tbody><tr ng-repeat="sample in vm.rd.samples"><td valign="center">{{ sample.sample_name }}</td><td>{{ sample.sample_lot_batch_number ? sample.sample_lot_batch_number : \'\' }}</td><td>{{ sample.sample_category.name ? sample.sample_category.name : \'\' }}</td><td>{{ sample.sample_type.name ? sample.sample_type.name : \'\' }}</td><td><ul style="padding-top: 15px; padding-bottom: 15px"><!-- Display tests in the organized order --><li style="white-space: nowrap; display: block; list-style-type:none; padding: 2px 0" ng-repeat="item in sample.actualFormattedTests track by $index"><!-- Panel header --> <span ng-if="item.isPanelHeader"><br ng-if="$index > 0"><strong>Panel: {{ item.panelName }}</strong><br></span><!-- Regular test --> <span ng-if="!item.isPanelHeader"><span ng-if="item.panel && item.panel.id">&nbsp;&nbsp;&nbsp;&nbsp;{{ vm.getTestDisplayNameById(item.assay.id, \'rd\') }}<br></span><span ng-if="!item.panel || !item.panel.id">{{ vm.getTestDisplayNameById(item.assay.id, \'rd\') }}<br></span></span></li><!-- Display other analyses separately --><li style="white-space: nowrap; display: block; list-style-type:none; padding: 2px 0" ng-repeat="(key, value) in sample.sample_other_analyses"><span ng-if="value">{{ key }}<br></span></li></ul></td></tr></tbody></table></table></div></div><!-- footer --><div class="rdRow"><div class="rdColumn"><div class="rdInvoiceFooter" style="text-align: center">Prepayment is required for all new clients. Payment terms can be negotiated for routine clients. After the invoice due date, a finance charge of 2% per month will be applied and any discounts will be nullified.<br>Federal Tax ID # 94-2528801<br>DUNS # 05-458-2416</div></div></div><div class="rdRow"><div class="rdColumn"><hr></div></div></div><div class="rdViewRow3"><div style="float: left"><button class="btnPrimaryCancel" ng-click="vm.rd.cancelOrder()"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;{{\'Cancel Order\' | translate}}</button></div><div style="float: right"><button class="btnPrimaryWhite" ng-click="vm.rd.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button ng-show="!vm.rd.submitting" class="btnPrimaryBlue btnLeftMargin" ng-click="vm.rd.submitOrder()">{{\'Submit Order\' | translate}}</button> <button ng-show="vm.rd.submitting" class="btnPrimaryBlue btnPrimaryBlueDisabled">Submitting&nbsp;<i class="fa fa-spinner fa-spin"></i></button></div></div></div></div></form></div><!-- Analysis Testing --><div class="tab-content tabback" ng-if="vm.show_tab.analysis"><form ng-class="{\'active\' : vm.active_tab.analysis}" name="editForm" class="tab-pane" style="cursor: default" role="form" id="food_testing"><div class="rdContainer"><div class="rdProgress rdViewRowBasic" style="padding: 0px 15%; text-align: center"><!--progress 1--><div ng-show="vm.food.step == 1" class="row status-wizard" style="background-color: #eff5fb !important"><div class="col-xs-3 status-wizard-step no-pointer-events active"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus1">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus2">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus3">3 <span>{{\'Order\' | translate}}</span></a></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="astatus4">4 <span>{{\'Review\' | translate}}</span></a></div></div><!--progress 2--><div ng-show="vm.food.step == 2" class="row status-wizard"><div class="col-xs-3 status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a></div></div><!--progress 3--><div ng-show="vm.food.step == 3" class="row status-wizard"><div class="col-xs-3 status-wizard-step no-pointer-events complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events disable"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div><!--progress 4--><div ng-show="vm.food.step == 4" class="row status-wizard"><div class="col-xs-3 status-wizard-step complete"><div class="text-center status-wizard-stepnum">{{\'Samples\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.food.step = 1" class="status-wizard-dot tooltips" id="">1 <span>{{\'Samples\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Tests\' | translate}}&nbsp;<button ng-if="false" class="rdHideButtonBackground" data-toggle="modal" data-target="#testsInfoModal"><i style="color: #556d85 !important" class="fa fa-info-circle"></i></button></div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.food.step = 2" class="status-wizard-dot tooltips" id="">2 <span>{{\'Tests\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step complete"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Order\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" ng-click="vm.food.step = 3" class="status-wizard-dot tooltips" id="">3 <span>{{\'Order\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div><div class="col-xs-3 status-wizard-step no-pointer-events active"><!-- complete --><div class="text-center status-wizard-stepnum">{{\'Review\' | translate}}</div><div class="status-progress"><div class="status-progress-bar"></div></div><a href="javascript:void(0)" class="status-wizard-dot tooltips" id="">4 <span>{{\'Review\' | translate}}</span></a><div class="status-wizard-info text-center"></div></div></div></div><!-- page 1 --><div class="rdView rdViewRowBasic" ng-show="vm.food.step == 1"><div class="rdViewRow1"><div class="rdTopBtnContainer"><div style="float: left" ng-if="true"><button class="btnPrimaryWhite" ng-click="vm.food.downloadExcel()"><i class="fa fa-cloud-download"></i>&nbsp;&nbsp;&nbsp;{{\'Download Excel\' | translate}}</button> <button style="float: right" ng-click="!vm.food.processingExcelUpload && vm.food.uploadExcel()" ng-class="{\n                                                \'btnPrimaryWhite\': !vm.food.processingExcelUpload,\n                                                \'btnPrimaryCancel\': vm.food.processingExcelUpload\n                                            }" ng-disabled="vm.food.processingExcelUpload" class="btnLeftMargin"><i class="fa" ng-class="{\n                                                \'fa-cloud-upload\': !vm.food.processingExcelUpload,\n                                                \'fa-spinner fa-spin\': vm.food.processingExcelUpload\n                                            }"></i>&nbsp;&nbsp;&nbsp;<span ng-bind="vm.food.processingExcelUpload ? (\'Processing file\' | translate) : (\'Upload Excel\' | translate)"></span></button> <input type="file" id="food_upload_excel" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onchange="foodUploadExcel()" style="display: none"> <button id="food_click_upload" ng-click="vm.food.handleExcel()" style="display: none"></button></div><div style="float: right"><button ng-disabled="vm.food.samples.length == 0" ng-class="{ \'btnPrimaryCancel\' : !vm.food.samples.length, \'btnPrimaryWhite\' : vm.food.samples.length }" ng-click="vm.food.deleteChecked()"><i class="fa fa fa-trash-o"></i>&nbsp;&nbsp;&nbsp;{{\'Delete Samples\' | translate}}</button> <button ng-click="vm.food.addSample()" class="btnPrimaryBlue btnLeftMargin"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Samples\' | translate}}</button></div></div></div><div class="rdViewRow2"><div class="rdRow"><div class="rdColumn bigbox rdCustomScrollBarThin" style="max-height: 65vh; overflow: scroll"><table class="rdSamplesTable"><thead><tr><th style="margin-left: 5px"><p ng-class="{ \'rdMainCollapseUp\' : vm.food.mainCollapse, \'rdMainCollapseDown\': !vm.food.mainCollapse}"><i id="collapseAll" ng-model="vm.food.mainCollapse" ng-click="vm.food.collapseAll()" ng-class="{ \'fa fa-angle-up\' : vm.food.mainCollapse, \'fa fa-angle-down\' : !vm.food.mainCollapse}"></i></p><p></p></th><th><label style="display: inline-block" class="checkboxContainer"><input ng-click="vm.food.clickCheckAllDelete()" style="display: inline-block" class="public-view-item-checkbox food-delete-checkbox-header" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -10px" class="checkmark"></span></label></th><th style="width: 25% !important; text-align: left">{{\'Sample Description\' | translate}}*</th><th class="food-sample-column">{{\'Lot/Batch #\' | translate}}</th><th class="food-sample-column">{{\'Date Collected\' | translate}}</th><th class="food-sample-column">{{\'Sample Condition\' | translate}}*</th><th class="food-sample-column">{{\'Sample Matrix\' | translate}}</th><th class="food-sample-column">{{\'Product Specifications\' | translate}} <i id="info-modal-icon-0" class="sample-submit-info-modal-trigger product-info fa fa-info-circle"></i><div ng-class="{ \'sample-submit-info-modal-shadow-left\' : test.left, \'sample-submit-info-modal-shadow-right\' : !test.left, }" class="info-modal-0 sample-submit-info-modal product-description info-modal-new"><p>{{\'Please input any internal specifications, label claims, or pass/fail criteria into this field (e.g. 18-22% THC, 100mg CBD +/- 10%, &lt;400ppm acetonitrile). This will allow our lab to proactively investigate any out of spec result, saving time and reducing the potential for analytical or reporting error.\' | translate}}</p></div></th><th style="width: 1%"></th></tr><tr style="padding-bottom: 0"><th colspan="8"><hr style="margin: 0; color: #E4E8EB"></th></tr></thead><tbody><tr ng-show="vm.food.samples.length == 0"><td colspan="8" style="height: 250px"><p class="information" style="margin-bottom: 20px; font-size: 11pt; color: #D3DDDE !important">{{\'No sample has been added\' | translate}}</p><button ng-click="vm.food.addSample()" class="btnPrimaryBlue"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;{{\'Add New Samples\' | translate}}</button></td></tr><tr class="rowsTest" ng-repeat="sample in vm.food.samples track by $index" ng-class="{ \'rdCollapsedBackground\' : sample.sample_expanded, \'\': !sample.sample_expanded}"><td valign="top"><div style="padding-top: 10px; margin-left: 5px"><p ng-class="{ \'rdMainCollapseUp\' : sample.sample_expanded, \'rdMainCollapseDown\': !sample.sample_expanded}"><i ng-model="sample.sample_expanded" ng-click="sample.sample_expanded = !sample.sample_expanded" ng-class="{ \'fa fa-angle-up\' : sample.sample_expanded, \'fa fa-angle-down\': !sample.sample_expanded }"></i></p></div><div ng-show="sample.sample_expanded"></div></td><td valign="top"><div><label style="display: inline-block" class="checkboxContainer"><input ng-checked="sample.sample_delete" ng-click="vm.food.clickDelete($index)" style="display: inline-block" class="public-view-item-checkbox delete-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: 6px; margin-left: -9px" class="checkmark"></span></label></div></td><td valign="top" style="width: 25% !important"><div><input ng-model="sample.sample_name" type="text" placeholder="e.g. Spinach" value="{{ sample.sample_name }}" ng-class="{ \'required-input\' : !sample.sample_name }" ng-change="vm.query_sample_name(sample)" ng-focus="vm.give_focus(sample, \'name\')" ng-blur="vm.lose_focus(sample, \'name\')"><div ng-show="sample.focus.name && sample.options.name && sample.sample_name.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.name.length > 0" ng-focus="vm.give_focus(sample, \'name\')" ng-repeat="name in sample.options.name track by $index" ng-bind-html="name | highlightMatch:sample.sample_name" ng-click="vm.set_sample_name(sample, name)" style="margin: 5px 0; text-align: left">{{ name }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.name.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'UPC Number\' | translate}}</span> <input ng-model="sample.sample_upc_number" type="text" placeholder="e.g. 485282300604" value="{{ sample.sample_upc_number }}"></div><div ng-show="sample.sample_expanded" style="margin-top:10px"><span>{{\'Sample Comment\' | translate}}</span> <input ng-model="sample.sample_comments" placeholder="e.g. blue" type="text" rows="1" maxlength="255"></div></td><td valign="top" class="food-sample-column"><div><input ng-model="sample.sample_lot_batch_number" type="text" placeholder="{{\'e.g. abc123\' | translate}}" value="{{ sample.sample_lot_batch_number }}" ng-change="vm.query_sample_lot_batch_number(sample)" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-blur="vm.lose_focus(sample, \'lot_batch_number\')"><div ng-show="sample.focus.lot_batch_number && sample.options.lot_batch_number && sample.sample_lot_batch_number.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal"><div class="sample-name-search-list"><li ng-show="sample.options.lot_batch_number.length > 0" ng-focus="vm.give_focus(sample, \'lot_batch_number\')" ng-repeat="lot_batch_number in sample.options.lot_batch_number" ng-bind-html="lot_batch_number | highlightMatch:sample.sample_lot_batch_number" ng-click=" vm.set_sample_lot_batch_number(sample, lot_batch_number)" style="margin: 5px 0; text-align: left">{{ lot_batch_number }}</li></div><div class="sample-name-search-no-results" ng-show="sample.options.lot_batch_number.length == 0">{{\'No results found\' | translate}}</div></div></div><div ng-show="sample.sample_expanded"><span>{{\'# of Units Submitted\' | translate}}</span> <input ng-model="sample.sample_number_of_units_submitted" type="text" placeholder="e.g. 5" value="{{ sample.sample_number_of_units_submitted }}"></div><div ng-show="sample.sample_expanded" style="margin-top:10px"><span>{{\'Supplier Name\' | translate}}</span> <input ng-model="sample.sample_supplier_name" type="text" placeholder="e.g. ABC Suppliers" value="{{ sample.sample_supplier_name }}"></div></td><td valign="top" class="food-sample-column"><div class="food-datetimepicker"><input type="text" class="form-control" datetime-picker="MM/dd/yyyy hh:mm a" ng-model="sample.sample_time_of_collection" is-open="sample.sample_calendar_open" ng-click="sample.sample_calendar_open = !sample.sample_calendar_open" placeholder="Date Collected"> <i style="top: 13px !important; position: absolute; right: 9px" class="fa fa-calendar-o" ng-click="sample.sample_calendar_open = !sample.sample_calendar_open"></i></div><div ng-show="sample.sample_expanded"><span>{{\'Supplier Lot Code\' | translate}}</span> <input ng-model="sample.sample_supplier_lot_code" type="text" placeholder="e.g. LOT-12345" value="{{ sample.sample_supplier_lot_code }}"></div></td><td valign="top" class="food-sample-column"><div><select ng-model="sample.sample_condition" ng-options="option for option in vm.food.sampleConditionOptions" ng-class="{ \'required-input\' : !sample.sample_condition }" ng-change="vm.food.checkPageOne()"><option value="">Select...</option></select></div><div ng-show="sample.sample_expanded"><span>{{\'Production Date\' | translate}}</span> <input ng-change="vm.food.checkPageOne()" class="rdDatePicker" placeholder="e.g. 01/01/2024" uib-datepicker-popup="MM/dd/yyyy" datepicker-options="{showWeeks: false}" ng-model="sample.sample_production_date" is-open="sample.sample_production_date_open" ng-click="vm.food.openCalendar(sample, \'sample_production_date_open\')"></div></td><td valign="top" class="food-sample-column"><div><input ng-model="sample.food_sample_matrix" type="text" placeholder="e.g. Beverage" value="{{ sample.food_sample_matrix }}"></div><div ng-show="sample.sample_expanded"><span>Expiration Date</span> <input ng-change="vm.food.checkPageOne()" class="rdDatePicker" placeholder="e.g. 01/01/2024" uib-datepicker-popup="MM/dd/yyyy" datepicker-options="{showWeeks: false}" ng-model="sample.sample_expiration_date" is-open="sample.sample_expiration_date_open" ng-click="vm.food.openCalendar(sample, \'sample_expiration_date_open\')"></div></td><td valign="top" class="food-sample-column"><div><input ng-model="sample.sample_expected_potency" type="text" placeholder="{{\'e.g. 20% Vit C\' | translate}}" value="{{ sample.sample_expected_potency }}" maxlength="255"></div></td><td valign="top" style="width: 5%"><div style="display: flex; flex-direction: row"><div style="margin-right: 5px"><a ng-click="vm.food.removeSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-trash-o"></i></a></div><div style="margin-right: 5px"><a ng-click="vm.food.cloneSample($index)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px; margin-top: 7px"><i class="fa fa-clone"></i></a></div></div></td></tr></tbody></table></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryBlue" ng-disabled="!vm.food.pageOneValid || vm.food.processingExcelUpload" ng-click="vm.food.incrementPage()" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.food.pageOneValid || vm.food.processingExcelUpload }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 2 --><div class="rdView rdViewRowBasic" ng-show="vm.food.step == 2"><div class="rdViewRow1"><div class="rdTopBtnContainer" style="width: 330px; border-radius: 3px; margin-bottom: 20px; position: relative"><div id="add-test" class="dropdown"><button id="search-dropdown" data-toggle="dropdown" style="display: none"></button> <input id="search-assay-input" type="text" ng-change="vm.food.filterAssays()" onfocus="$(\'#search-dropdown\').click()" placeholder="Search for tests.." ng-model="vm.food.test_to_search"><ul id="rd-dropdown-menu" class="dropdown-menu" role="menu"><li role="presentation"><button data-toggle="modal" data-target="#foodAddRequestedTest" class="request-test-btn"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Request Test</button></li><li ng-repeat="test in vm.food.tests | filter:vm.food.customFilter track by test.id" ng-click="vm.food.select_test_to_search(test.display_name)"><span><span style="color:#069FD6;margin-right:5px">ID:{{test.id}}</span>{{ test.display_name ? test.display_name : test.reporting_title }}</span></li></ul></div><div><button ng-click="vm.food.clear_test_to_search()" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.food.test_to_search }" class="btnPrimaryBlue" style="position: absolute; top: 8px; left: 258px; padding: 1px 15px; height: 25px">Clear</button></div></div></div><div class="rdViewRow2"><div class="rdRow rdTestsTable bigbox" style="padding: 0 15px"><div class="rdColumn" style="flex: 1; border-right: 1px solid #EDEDED; overflow-x: visible; overflow-y: auto; max-height: 65vh"><table class="rdTestsTableLeft" style="overflow: visible"><thead style="overflow: visible"><tr style="border-bottom: 1px solid #EDEDED"><th style="height: 150px; padding-top: 93px">{{\'Sample Description\' | translate}}</th><th style="height: 150px; overflow: visible; position: sticky; top: 0; background: #fff; padding-top: 93px"><div style="display: flex; flex-direction: column; align-items: center"><span>{{\'Panels\' | translate}}</span><div class="dropdown rnd-page" style="margin-bottom: 8px; margin-right: 10px;position: relative; width: 90%; min-width: 125px"><button class="panel-btn dropdown-toggle-rnd" type="button" data-toggle="dropdown" style="width: 100%; font-size: 8pt">{{ \'Apply to All\' | translate }} <span class="caret"></span></button><ul class="dropdown-menu" role="menu" style="z-index: 1050; max-height: 300px; overflow-y: auto"><li role="presentation"><button ng-click="vm.food.clearPanelFromAll()" class="clear-panel-btn">{{\'Clear All Panels\' | translate}}</button></li><li role="presentation"><button ng-click="vm.toggleQbenchPanelVisibility()" class="clear-panel-btn" style="border-color: #00000042">{{ vm.showQbenchPanels.settings.sample_submit.show_anresco_panels ? \'Hide Lab Panels\' : \'Show Lab Panels\' }}</button></li><li role="presentation" ng-repeat="panel in vm.food.qbenchPanels" ng-show="vm.showQbenchPanels.settings.sample_submit.show_anresco_panels"><label style="width: 100%; cursor: pointer; padding: 3px 10px; color: #34485c; display: block" ng-click="vm.food.applyPanelToAll(panel.id, panel.type)"><input type="radio" name="apply-to-all-panel-food" style="margin-right: 5px"> <span>ID:{{ panel.id }} {{ panel.title }}&nbsp;<i>({{ panel.assays.length }})</i></span></label></li><li role="presentation" ng-repeat="customPanel in vm.food.customPanels"><label style="width: 100%; cursor: pointer; padding: 3px 10px; color: #34485c; display: block" ng-click="vm.food.applyPanelToAll(customPanel.id, customPanel.type)"><input type="radio" name="apply-to-all-panel-food" style="margin-right: 5px"> <span>ID:{{ customPanel.id }} {{ customPanel.title }}&nbsp;<i>({{ customPanel.assays.length }})</i></span></label></li></ul></div></div></th></tr></thead><tbody><tr ng-repeat="sample in vm.food.samples track by $index"><td style="width: 60%; color: #34485c; font-size: 10pt !important; font-family: OpenSans-Regular"><div style="height: 40px; padding: 2px 5px 0 0 ; overflow: hidden">{{ sample.sample_name }}</div></td><td ng-show="sample.sample_has_tests && !sample.sample_panel_selected && !sample.sample_current_panel_title" style="width: 40%; text-align: center"><button class="add-panel-btn" ng-click="vm.food.savePanel($index, 1)"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Add New Panel</button></td><td ng-show="sample.sample_has_tests && sample.sample_panel_selected && (sample.sample_panel_type == \'custom_panel\')" style="width: 40%; text-align: center"><button class="add-panel-btn" ng-click="vm.food.updatePanel($index, sample.sample_panel_selected)"><i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;Update Panel</button></td><td ng-show="sample.sample_panel_selected || !sample.sample_has_tests || (sample.sample_panel_type == \'qbench_panel\')" style="width: 40%; text-align: center"><div class="dropdown rnd-page"><button class="panel-btn dropdown-toggle-rnd" id="menu-{{$index}}" type="button" data-toggle="dropdown" style="font-size: 8pt">{{ sample.sample_current_panel_title ? sample.sample_current_panel_title : \'Select Panel\' }} <span class="caret"></span></button><ul id="rd-dropdown-menu" class="dropdown-menu" role="menu" aria-labelledby="menu-{{$index}}"><li role="presentation"><button ng-disabled="!sample.sample_panel_type" ng-click="vm.food.removePanelFromSample($index)" class="clear-panel-btn">{{\'Clear Panel\' | translate}}</button></li><li role="presentation"><button ng-click="vm.toggleQbenchPanelVisibility()" class="clear-panel-btn" style="border-color: #00000042">{{ vm.showQbenchPanels.settings.sample_submit.show_anresco_panels ? \'Hide Lab Panels\' : \'Show Lab Panels\' }}</button></li><li role="presentation" ng-repeat="panel in vm.food.qbenchPanels" ng-show="vm.showQbenchPanels.settings.sample_submit.show_anresco_panels"><label for="panel-{{ $parent.$index }}-{{ panel.id }}"><input type="radio" ng-class="{\'ng-pristine ng-untouched ng-valid ng-not-empty\' : panel.length == 0}" ng-click="vm.food.setPanel($parent.sample, panel.id, panel.type)" name="panel-{{ $parent.$index }}" id="panel-{{ $parent.$index }}-{{ panel.id }}" ng-model="sample.sample_panel_by_id" value="{{ panel.id }}"> <span class="spanDataAddress">ID:{{ panel.id }} {{ panel.title }}&nbsp;<i>({{ panel.assays.length }})</i><div class="sample-submit-info-modal-trigger-new" style="display: inline-block; margin-left: 3px"><i class="fa fa-info-circle"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px;left: -80px; bottom: 100%; margin-bottom: -5px; max-height: 400px; overflow-y: auto"><svg style="position: absolute; top: 100%; left: 60px" height="20" width="50"><polygon points="20,0 11,10 20,20" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left;font-size: 20px; font-family: OpenSans-Bold; word-wrap: break-word; overflow-wrap: break-word"><span style="color:#069FD6">ID:{{panel.id}}&nbsp;</span>{{ panel.title }}</div><div ng-if="panel.description" style="color: #3d5269; text-align: left; padding-top: 10px" ng-style="{\'padding-bottom\': (panel.price || panel.turnaround_time || panel.min_sample_size) ? \'12px\' : \'0px\'}">{{ panel.description }}</div><div ng-if="panel.price" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><span>$</span>{{ panel.price }}</div></div><div ng-if="panel.turnaround_time" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Turnaround Time</div><div style="color: #3d5269">{{ panel.turnaround_time }} days</div></div><div ng-if="panel.min_sample_size" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Sample Size</div><div style="color: #3d5269">{{ panel.min_sample_size }}</div></div><div ng-if="panel.assays && panel.assays.length > 0" style="padding-top: 12px"><div style="color: #606f7b; padding-bottom: 8px">Assays:</div><ul style="display: block; margin: 0; padding-left: 0; color: #3d5269; list-style-type: none"><li ng-repeat="assay in panel.assays" style="margin-bottom: 4px"><i class="fa fa-circle" style="font-size: 6px; margin-right: 8px; vertical-align: middle"></i>{{ assay.display_name }}</li></ul></div></div></div></div></span></label></li><li role="presentation" ng-repeat="customPanel in vm.food.customPanels"><label ng-disabled="customPanel.length == 0" for="customPanel-{{ $parent.$index }}-{{ customPanel.id }}" style="width: 100%"><input type="radio" ng-disabled="customPanel.length == 0" ng-class="{\'ng-pristine ng-untouched ng-valid ng-not-empty\' : customPanel.length == 0}" ng-click="vm.food.setPanel($parent.sample, customPanel.id, customPanel.type)" name="customPanel-{{ $parent.$index }}" id="customPanel-{{ $parent.$index }}-{{ customPanel.id }}" ng-model="sample.sample_panel_by_id" value="{{ customPanel.id }}"> <span class="spanDataAddress">ID:{{ customPanel.id }} {{ customPanel.title }}&nbsp;<i>({{ customPanel.assays.length }})</i><div class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px; left: -80px; bottom: 100%; margin-bottom: -5px; max-height: 400px; overflow-y: auto"><svg style="position: absolute; top: 100%; left: 60px" height="20" width="50"><polygon points="20,0 11,10 20,20" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left;font-size: 20px; font-family: OpenSans-Bold; word-wrap: break-word; overflow-wrap: break-word"><span style="color:#069FD6">ID:{{customPanel.id}}&nbsp;</span>{{ customPanel.title }}</div><div ng-if="customPanel.description" style="color: #3d5269; text-align: left; padding-top: 10px" ng-style="{\'padding-bottom\': (customPanel.price || customPanel.duration || customPanel.minimum_quantity_required) ? \'12px\' : \'0px\'}">{{ customPanel.description }}</div><div ng-if="customPanel.price" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><span>$</span>{{ customPanel.price }}</div></div><div ng-if="customPanel.duration" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Turnaround Time</div><div style="color: #3d5269">{{ customPanel.duration }} days</div></div><div ng-if="customPanel.minimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Sample Size</div><div style="color: #3d5269">{{ customPanel.minimum_quantity_required }}</div></div><div ng-if="customPanel.assays && customPanel.assays.length > 0" style="padding-top: 12px"><div style="color: #606f7b; padding-bottom: 8px">Assays:</div><ul style="display: block; margin: 0; padding-left: 0; color: #3d5269; list-style-type: none"><li ng-repeat="assay in customPanel.assays" style="margin-bottom: 4px"><i class="fa fa-circle" style="font-size: 6px; margin-right: 8px; vertical-align: middle"></i>{{ assay.display_name }}</li></ul></div></div></div></div><span style="float: right; padding-right: 10px"><a ng-click="vm.food.deletePanel(customPanel.id)" class="btn btn-link action-button" style="width: 25px !important; height: 25px !important; padding: 1px 2px !important; font-size: 15px"><i class="fa fa-trash-o"></i></a></span></span></label></li></ul></div></td><div ng-if="!test.analysis_description" style="color: #2f3e52 !important">{{ test.display_name ? test.display_name : test.reporting_title }}</div></tr></tbody></table></div><div id="food-tests-scrollbar" class="rdColumn rdCustomScrollBarThin" style="flex: 2; max-width: 60%; overflow-x: scroll; overflow-y: auto; max-height: 65vh"><div class="rdRow" style="flex-wrap: nowrap; padding: 0; height: 100%"><table ng-show="vm.food.other_analyses.length > 0 && !vm.food.test_to_search" class="rdTestsTableRight" style="border-right: 1px solid #EDEDED"><thead><tr style="border-bottom: 1px solid #EDEDED"><th style="height: 30px; white-space: nowrap" colspan="{{ vm.food.other_analyses.length }}">Requested Tests</th></tr><tr><th valign="bottom" style="height: 120px" ng-repeat="requested_test in vm.food.other_analyses track by $index"><div class="samples-assay-title" style="color: #2f3e52 !important">{{ requested_test }}</div><br><label style="display: inline-block" class="checkboxContainer"><input class="added-assay-col-header-{{$index}}" ng-click="vm.food.clickCheckAllAddedTest(requested_test, $index)" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></th></tr></thead><tbody><tr ng-repeat="sample in vm.food.samples track by $index"><td ng-repeat="requested_test in vm.food.other_analyses track by $index"><label style="display: inline-block" class="checkboxContainer"><input ng-click="vm.food.checkPageTwo()" ng-model="sample.sample_other_analyses[requested_test]" ng-checked="sample.sample_other_analyses[requested_test]" class="added-assay-col-{{$index}} public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -7px; margin-left: -11px" class="checkmark"></span></label></td></tr></tbody></table><table class="rdTestsTableRight" style="border-right: 1px solid #EDEDED" ng-class="{ \'rdLastElementBorder\' : !vm.food.test_to_search }"><thead><tr ng-show="!vm.food.test_to_search" style="border-bottom: 1px solid #EDEDED"><th ng-if="vm.food.number_of_freq_assays" style="height: 30px; white-space: nowrap; border-right: 1px solid #EDEDED" colspan="{{ vm.food.number_of_freq_assays }}">{{\'Frequent Tests\' | translate}}</th><th ng-if="vm.food.tests.length > vm.food.number_of_freq_assays" style="height: 30px; white-space: nowrap; border-right: 1px solid #EDEDED" colspan="{{ vm.food.tests.length - vm.food.number_of_freq_assays }}">Configured Tests</th></tr><tr><th valign="bottom" ng-class="{ \'food150Height\' : vm.food.test_to_search, \'rd120Height\' : !vm.food.test_to_search, \'rdFrequentTestsBorderRight\' : $index == vm.food.number_of_freq_assays-1 }" ng-show="vm.food.tests[$index] && vm.food.customFilter(vm.food.tests[$index])" ng-repeat="test in vm.food.tests track by $index" class="overflow-visible"><div><span class="samples-assay-title"><span style="color:#069FD6;margin-right:5px">ID:{{test.id}}</span>{{ test.display_name ? (test.display_name | translate) : (test.reporting_title | translate) }}</span><div class="sample-submit-info-modal-trigger-new"><i ng-if="test.info_modal" id="info-modal-icon-{{$index}}" class="sample-submit-info-modal-trigger fa fa-info-circle"></i><div ng-class="{ \'sample-submit-info-modal-shadow-left\' : test.left, \'sample-submit-info-modal-shadow-right\' : !test.left, }" class="info-modal-{{$index}} sample-submit-info-modal info-modal-new"><svg ng-if="!test.left" style="position: absolute; bottom: 10px; left: -20px" height="20" width="50"><polygon points="20,0 20,20 11,10" style="fill:#f5f5f5"/></svg> <svg ng-if="test.left" style="position: absolute; bottom: 10px; right: -20px" height="20" width="20"><polygon points="0,0 00,20 11,10" style="fill:#f5f5f5"/></svg><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 24px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left; padding-bottom: 24px; font-size: 20px; font-family: OpenSans-Bold"><span style="color:#069FD6">ID:{{test.id}}&nbsp;</span>{{ (test.display_name ? test.display_name : test.reporting_title) | translate }}</div><div style="color: #3d5269; text-align: left; padding-bottom: 12px">{{ test.info_modal.description ? test.info_modal.description : \'\' }}</div><div ng-if="test.info_modal.base_price && vm.currentLanguage !== \'jp\'" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Price</div><div style="color: #3d5269"><div ng-if="!test.info_modal.display_price">{{ test.info_modal.base_price ? test.info_modal.base_price : \'\' }}</div><div ng-if="test.info_modal.display_price"><span style="text-decoration: line-through">{{ test.info_modal.base_price ? test.info_modal.base_price : \'\' }}</span> {{ test.info_modal.display_price ? test.info_modal.display_price : \'\'}}</div></div></div><div ng-if="test.info_modal.method" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Method</div><div style="color: #3d5269; max-width: 60%"><!-- <div style="text-align: right;" ng-repeat="method in test.info_modal.method">{{ method }}</div> --><div style="text-align: right">{{ test.info_modal.method.length > 1 ? \'Various\' : test.info_modal.method[0] }}</div></div></div><div ng-if="test.info_modal.instrument" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Instrument</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right" ng-repeat="instrument in test.info_modal.instrument">{{ instrument }}</div></div></div><div ng-if="test.info_modal.duration" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">{{\'Turnaround Time\' | translate}}</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.duration }} days</div></div></div><div ng-if="test.info_modal.minimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Minimum Sample Size</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.minimum_quantity_required }}</div></div></div><div ng-if="test.info_modal.optimum_quantity_required" style="padding: 12px 0; justify-content: space-between; display: flex; flex-direction: row; border-bottom: 1px solid #e3e3e3"><div style="color: #606f7b">Optimal Sample Size</div><div style="color: #3d5269; max-width: 60%"><div style="text-align: right">{{ test.info_modal.optimum_quantity_required }}</div></div></div></div></div></div></div><br><label style="display: inline-block" class="checkboxContainer"><input class="assay-col-header-{{$index}}" ng-click="vm.food.clickCheckAllTest($index)" style="display: inline-block" class="public-view-item-checkbox" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label></th></tr></thead><tbody><tr ng-repeat="sample in vm.food.samples track by $index"><td ng-repeat="test in vm.food.tests track by $index" ng-class="{ \'rdFrequentTestsBorderRight\' : $index == vm.food.number_of_freq_assays-1 }" ng-show="vm.food.showTests[test.display_name]"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.food.sampleArray[$parent.$index][$index]" ng-checked="vm.food.sampleArray[$parent.$index][$index]" ng-change="vm.food.checkClick(sample, test, $parent.$index, $index)" ng-click="vm.food.checkClick(sample, test, $parent.$index, $index)" class="assay-col-{{$index}} public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -7px; margin-left: -11px" class="checkmark"></span></label></td></tr></tbody></table><table style="width: 100%; height: 100%" ng-show="(vm.food.tests | filter: vm.food.customFilter).length == 0"><thead><th style="height: 150px"></th></thead><tbody><tr><td><p class="information" style="margin-bottom: 20px; font-size: 11pt; color: #D3DDDE !important">No tests found. Click below to request a test.</p><button data-toggle="modal" data-target="#rdAddRequestedTest" class="btnPrimaryBlue"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Request Test</button></td></tr></tbody></table></div></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryWhite" ng-click="vm.food.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button class="btnPrimaryBlue btnLeftMargin" ng-click="vm.food.incrementPage()" ng-disabled="!vm.food.pageTwoValid" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.food.pageTwoValid }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 3 --><div class="rdView rdViewRowBasic" ng-show="vm.food.step == 3"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><div><div class="rdRow"><div class="rdColumn"><label class="rdColumnLeftLabel">{{\'Contact Name\' | translate}}</label><input type="text" ng-model="vm.contact.name" disabled="disabled" class="ng-pristine ng-untouched ng-valid ng-not-empty"><div class="rdRow"><label class="rdColumnLeftLabel">{{\'Contact Phone #\' | translate}}<span ng-if="vm.food.deliveryPreference ===\'Anresco Pick-Up\'" class="rdRequired">&nbsp;*</span></label><input type="text" ng-change="vm.food.checkPageThree()" ng-model="vm.contact.phone" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div class="rdColumn" style="width: 50%"><label class="rdColumnRightLabel" style="display: inline-flex"><div>{{\'Email Recipients\' | translate}}:<span class="rdRequired">&nbsp;*</span></div><div style="font-size: 9pt; margin: auto 0 auto auto"><a ng-if="false" disabled="disabled" href="#">{{\'Manage users\' | translate}}</a></div></label><div class="rdColumnRightLabel" ng-class="{\'required-input\' : !vm.food.emails || vm.food.emails.length === 0}"><input type="text" class="rdColumnRightInput" id="foodEmailRecepients" data-role="tagsinput" ng-model="vm.food.emails" ng-change="vm.food.checkPageThree()"></div><div class="rdRow"><label class="rdColumnRightLabel">{{\'Project/PO#\' | translate}}</label><input ng-model="vm.food.orderPO" type="text" placeholder="Optional" class="rdColumnRightInput"></div></div></div><div class="rdRow"><div class="rdColumn" style="width: 50%"><label class="rdColumnLeftLabel">{{\'Customer/Reporting Address\' | translate}}</label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 95% !important; height: 45px" ng-click="openManufacturingList()" type="text" name="CM-location" class="add_option" ng-model="vm.fullLocationManufactur" placeholder="Choose Location / Add New" value="" readonly="readonly" ng-change="vm.food.checkPageThree()"></div><ul style="width: 95% !important" class="add_new_list location-list" ng-class="ManufacturingList"><li style="width: 95% !important; height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-manufacturing">+ Add New</li><li style="width: 95% !important; height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'CULTIVATION_LOCATION\'"><span class="spanDataAddress" ng-click="copyManufacturingData(address.address, address.city,  address.zipCode, address.distributorName,  address.medicalLicence, address.fullLocation, address.licenceList)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'MANUFACTURING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div><div class="rdColumn" style="width: 50%"><label class="rdColumnRightLabel">{{\'Invoicing Address\' | translate}}</label><div class="input-autocomplate rdColumnRightLabel"><div class="add-option-caretRD"><input ng-click="openInvoicingList()" style="height: 45px" type="text" name="invoicing-location" class="add_option" ng-model="vm.fullLocationInvoicing" placeholder="{{vm.customerData.qbAddress.replace(\'\\n\', \'; \')}}" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="InvoicingList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-invoicing">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'INVOICING_LOCATION\'"><span class="spanDataAddress" ng-click="copyInvoicingData(address.address, address.city,  address.zipCode, address.distributorName,  address.state, address.fullLocation)">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'INVOICING\')" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div><div class="rdRow"><div class="rdColumn" style="width: 50%"><label class="rdColumnLeftLabel">{{\'Pickup/Arrival Date\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div class="youremail foodadddate datepickerdate" ng-class="{\'required-input\' : !vm.food.pickup_arrival_date}" style="width:95%"><input class="datepicker" ng-change="vm.food.estimateReportDate(vm.food.turnaroundTime)" placeholder="Pickup/Arrival Date" uib-datepicker-popup="{{dateformat}}" datepicker-options="{showWeeks: false}" ng-model="vm.food.pickup_arrival_date" is-open="vm.datePickerOpenStatus.pickup_arrival_date" ng-click="vm.openCalendar(\'pickup_arrival_date\')" style="width: 100% !important"> <i style="margin-top: -29px !important" class="fa fa-calendar-o" ng-click="vm.openCalendar(\'pickup_arrival_date\')"></i></div></div><div class="rdColumn" style="width: 50%" ng-if="vm.food.deliveryPreference === \'Mail\'"><label class="rdColumnLeftLabel">{{\'Tracking Number\' | translate}}</label><input type="text" ng-model="vm.food.tracking_number" placeholder="Tracking Number" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div><div class="rdColumn" style="width: 50%" ng-if="vm.food.deliveryPreference === \'Anresco Pick-Up\'"><label ng-if="vm.food.deliveryPreference === \'Anresco Pick-Up\'" class="rdColumnRightLabel">{{\'Pickup Address\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div class="input-autocomplate rdColumnRightLabel" ng-if="vm.food.deliveryPreference === \'Anresco Pick-Up\'" ng-class="{ \'required-input\': !vm.fullLocationPickup || vm.fullLocationPickup.length === 0}"><div class="add-option-caretRD"><input ng-click="openpickupList()" style="height: 45px" type="text" name="pickup-location" class="add_option" ng-model="vm.fullLocationPickup" placeholder="Select pickup address" value="" readonly="readonly"></div><ul class="add_new_list location-list" ng-class="PickupList"><li style="height: 45px" class="add_new_option" data-toggle="modal" data-target="#add-new-pickup">+ Add New</li><li style="height: 45px" ng-repeat="address in records" ng-if="address.locationType === \'PICKUP_LOCATION\'"><span class="spanDataAddress" ng-click="copyPickupData(address.address, address.city,  address.zipCode, address.distributorName,  address.state);vm.food.checkPageThree()">{{address.distributorName}} {{address.address}}, {{address.city}}, {{address.state}} {{address.zipCode}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'PICKUP\');vm.food.checkPageThree()" id="remove-1" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div><!-- Error message if pickup address not in California --><div ng-if="vm.pickupOutOfStateError" style="color: #d9534f; margin-top: 8px; padding: 10px; background-color: #f2dede; border: 1px solid #ebccd1; border-radius: 4px; font-size: 14px"><strong>\u26A0 Pickup service is currently only available in California.</strong> Please select a California address or choose a different delivery option.</div></div></div><div class="rdRow"><div class="rdColumn" style="flex-direction: unset"><div class="companyinfo preference"><label class="cm-label">{{\'Delivery Preference\' | translate}}<span class="rdRequired">&nbsp;*</span></label><div class="topbuffer05"></div><div class="Requestedradio" ng-class="{\'required-input\' : !vm.food.deliveryPreference}"><label for="rd_anrescoPickUp"><input tabindex="7" type="radio" name="deliveryPreference" id="rd_anrescoPickUp" checked="checked" ng-model="vm.food.deliveryPreference" ng-change="vm.food.checkPageThree()" value="Anresco Pick-Up"> <span>{{ vm.pickupLabel }}</span></label><div class="topbuffer05"></div><label for="rd_clientDropOff"><input tabindex="8" type="radio" name="deliveryPreference" id="rd_clientDropOff" ng-model="vm.food.deliveryPreference" ng-change="vm.food.checkPageThree()" value="Client Drop-Off"> <span>Client Drop-Off</span></label><div class="topbuffer05"></div><label for="rd_mail"><input tabindex="9" type="radio" name="deliveryPreference" id="rd_mail" ng-change="vm.food.checkPageThree()" ng-model="vm.food.deliveryPreference" value="Mail"> <span>Mail</span></label></div></div><div class="companyinfo preference" style="margin-left: 10%"><label class="cm-label">{{\'Turnaround Time\' | translate}}<span class="rdRequired">&nbsp;*</span><a href="javascript:void(0)" class="ss-tooltips"><i class="fa fa-question-circle"></i><!-- <span>Standard turnaround time varies depending on the analysis.  Microbiological assays, kratom testing, and hemp testing have a 4-5 day standard turnaround.  Most non-routine assays have a 10 business day standard turnaround.  If you are unsure of the turnaround options for the order you are submitting, please contact your customer service representative.</span> --> <span>{{\'Standard turnaround time varies depending on analysis.\' | translate}}<br><br>- {{\'Routine cannabis and hemp testing has a standard 3 day TAT.\' | translate}}<br>- {{\'Routine microbiological and kratom testing has a standard 5 day TAT.\' | translate}}<br>- {{\'Nutritional labeling has a standard 15 day TAT.\' | translate}}<br>- {{\'Most other assays have a standard 10 day TAT.\' | translate}}<br><br>Expedited TATs are available with pre-approval and a corresponding surcharge. Please contact your rep or {{ vm.supportEmail }} for additional info regarding these options.</span></a></label><div class="topbuffer05"></div><div ng-if="!vm.food.turnaroundTimeOptions" ng-init="turnaroundTime=\'10 Days (standard)\'" ng-class="{\'required-input\' : !vm.food.turnaroundTime}"><label for="cannabis-turnaroundTime"><input type="radio" ng-model="vm.food.turnaroundTime" value="10 Days (standard)"> <span>10 Days (standard)</span></label><div class="topbuffer05"></div></div><div class="Requestedradio" ng-class="{\'required-input\' : !vm.food.turnaroundTime}"><div ng-repeat="turnaround in vm.food.turnaroundTimeOptions"><label for="food-turnaroundTime-{{$index}}"><input type="radio" name="food-turnaroundTime-{{$index}}" id="food-turnaroundTime-{{$index}}" ng-checked="$index == 0" value="{{turnaround}}" ng-change="vm.food.estimateReportDate(vm.food.turnaroundTime)" ng-model="vm.food.turnaroundTime"> <span>{{turnaround}}</span></label><div class="topbuffer05"></div></div></div></div></div><div class="rdColumn"><div style="height: 100%; width: 95%; margin: auto 0 -14px auto"><div ng-show="vm.food.estimated_report_date" class="rdReportDateCard"><p style="font-size: 16px; font-family: OpenSans-SemiBold">{{\'Estimated Report Date\' | translate}}</p><p style="font-size: 20px; padding-top: 30px; font-family: OpenSans-Bold">{{ vm.food.estimated_report_date.day ? vm.food.estimated_report_date.day + \',\' : \'\' }}</p><p style="font-size: 30px; font-family: OpenSans-Bold">{{ vm.food.estimated_report_date.month_day_year ? vm.food.estimated_report_date.month_day_year : \'Unavailable\' }}</p></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt; display: flex; gap: 20px"><div style="flex: 1; text-align: left; position: relative"><details open><summary style="font-size: 13px; color: #4F8FCC">{{\'Special Instructions\' | translate}}</summary><textarea style="width: 100%; height: 100px" ng-model="vm.food.specialInstructions" type="text" placeholder="{{\'Special Instructions\' | translate}}" ng-change="vm.query_order_field(\'food\', \'specialInstructions\', \'special_instructions\')" ng-focus="vm.orderFieldFocus.specialInstructions = true" ng-blur="vm.orderFieldFocus.specialInstructions = false"></textarea><div ng-show="vm.orderFieldFocus.specialInstructions && vm.orderFieldOptions.specialInstructions.length > 0 && vm.food.specialInstructions.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.specialInstructions track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'food\', \'specialInstructions\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></details></div><div style="flex: 1; text-align: left; position: relative"><label style="font-size: 13px; color: #4F8FCC">{{\'Customer Comments\' | translate}} <span class="sample-submit-info-modal-trigger-new" style="display: inline-block"><i class="fa fa-info-circle" style="cursor: pointer"></i><div class="sample-submit-info-modal sample-submit-info-modal-shadow-right" style="background-color: #FFFFFF; width: 290px; left: -10px; bottom: 20px; margin-bottom: -5px"><div style="display: flex; height: 100%; width: 100%; flex-direction: column; padding: 12px; font-family: OpenSans-Regular"><div style="color: #3d5269; text-align: left; font-size: 12px">Any comment typed into this box will display on the consolidated COA below the sample photo and above the analytical results.</div></div></div></span></label><textarea style="width: 100%; height: 100px" ng-model="vm.food.customerComments" type="text" placeholder="{{\'Customer Comments\' | translate}}" ng-change="vm.query_order_field(\'food\', \'customerComments\', \'customer_comments\')" ng-focus="vm.orderFieldFocus.customerComments = true" ng-blur="vm.orderFieldFocus.customerComments = false"></textarea><div ng-show="vm.orderFieldFocus.customerComments && vm.orderFieldOptions.customerComments.length > 0 && vm.food.customerComments.length > 2" class="sample-name-search-box rdCustomScrollBarHorizontal" style="position: absolute; z-index: 100; width: 100%; left: 0"><div class="sample-name-search-list"><li ng-repeat="opt in vm.orderFieldOptions.customerComments track by $index" ng-mousedown="$event.preventDefault(); vm.set_order_field(\'food\', \'customerComments\', opt)" style="cursor: pointer; margin: 5px 0; text-align: left">{{opt}}</li></div></div></div></div><div class="rdRow" style="margin-top: 10px; font-size: 9pt"><details open><summary style="font-size: 13px; color: #4F8FCC;display:block;text-align: left">{{\'Document Upload\' | translate}}</summary><div style="margin-top: 10px"><input type="file" id="food-file-upload" multiple="multiple" style="display: none" onchange="onFoodFileUpload()"> <button style="display:block; margin-bottom: 10px" type="button" class="btnPrimaryWhite" onclick="document.getElementById(\'food-file-upload\').click()"><i class="fa fa-upload"></i>&nbsp;&nbsp;{{\'Select File\' | translate}}</button><div ng-if="vm.food.uploadedFiles.length > 0" style="margin-top: 10px"><div ng-repeat="file in vm.food.uploadedFiles" style="padding: 1px 20px; background: #fff; margin-bottom: 5px; border-radius: 3px; border: 1px solid #4f8fcc; display: flex; justify-content: space-between; align-items: center; height: 35px; font-size: 14px; width: 600px"><span><i class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }} ({{ vm.formatFileSize(file.size) }})</span> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.food.removeFile($index)" style="padding: 2px 8px"><i class="fa fa-times"></i></button></div></div></div></details></div></div></div><div class="rdViewRow3"><div class="rdBottomBtnContainer"><button class="btnPrimaryWhite" ng-click="vm.food.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button> <button class="btnPrimaryBlue btnLeftMargin" ng-click="vm.food.incrementPage()" ng-disabled="!vm.food.pageThreeValid" ng-class="{ \'btnPrimaryBlueDisabled\' : !vm.food.pageThreeValid }">{{\'Next\' | translate}}&nbsp;&nbsp;&nbsp;<i class="fa fa-arrow-right"></i></button></div></div></div><!-- page 4 --><div class="rdView rdViewRowBasic" ng-show="vm.food.step == 4"><div class="rdViewRow1"><div class="rdTopBtnContainer"></div></div><div class="rdViewRow2"><!-- reporting address, email recipients --><div class="rdRow"><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Reporting Address\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>Attn: {{ vm.reportingAddressDict.name }}</td></tr><tr><td>{{ vm.reportingAddressDict.address }}</td></tr><tr><td>{{ vm.reportingAddressDict.city + \', \' + vm.reportingAddressDict.zipCode }}</td></tr><tr ng-repeat="lic in (vm.reportingAddressDict.licenceList || vm.reportingAddressDict.medicalLicence || \'\').split(\',\')"><td>{{ lic.trim() }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Email Recipients\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr ng-repeat="email in vm.food.emailsArray"><td>{{ email ? email : \'No Emails Selected\'}}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Invoicing Address\' | translate}}</th></tr></thead><tbody ng-if="vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr><td>{{ vm.invoicingAddressDict.name }}</td></tr><tr><td>{{ vm.invoicingAddressDict.address }}</td></tr><tr><td>{{ vm.invoicingAddressDict.city }}, {{ vm.invoicingAddressDict.state }} {{ vm.invoicingAddressDict.zipCode }}</td></tr></tbody><tbody ng-if="!vm.invoicing_address"><tr><td>&nbsp;</td></tr><tr ng-repeat="line in vm.customerData.qbAddressArray"><td>{{ line }}</td></tr></tbody></table></div></div><!-- delivery, turnaround, po# --><div class="rdRow" style="margin-top: 40px"><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Delivery\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.food.deliveryPreference ? vm.getDeliveryPreferenceDisplay(vm.food.deliveryPreference) : \'Delivery Preference Not Selected\' }}</td></tr><tr><td style="font-style: italic">{{ vm.food.pickup_arrival_date | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>{{\'Turnaround Time\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.food.turnaroundTime ? vm.food.turnaroundTime : \'4-5 days (standard)\' }}</td></tr></tbody></table></div><div class="rdColumn"><table class="rdTable"><thead><tr><th>PO#</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.food.orderPO ? vm.food.orderPO : \'None\' }}</td></tr></tbody></table></div></div><!-- special instructions --><div class="rdRow" style="margin-top: 40px"><div class="rdColumn" style="flex: 2"><table class="rdTable"><thead><tr><th>{{\'Special Instructions\' | translate}}</th></tr></thead><tbody><tr><td>&nbsp;</td></tr><tr><td>{{ vm.food.specialInstructions ? vm.food.specialInstructions : \'None\' }}</td></tr></tbody></table></div><div class="rdColumn" style="flex: 1"></div></div><!-- invoice table --><!--  samples table --><div class="rdRow"><div class="rdColumn bigbox" style="min-height: 200px !important"><table><table class="rdInvoiceSamplesTable"><thead><tr><th>{{\'Sample Description\' | translate}}</th><th>{{\'Lot/Batch #\' | translate}}</th><th>{{\'Date Collected\' | translate}}</th><th>{{\'Product Specifications\' | translate}}</th><th>{{\'Tests\' | translate}}</th></tr><tr><th colspan="5"><hr style="margin: 10px 0 5px 0"></th></tr></thead><tbody><tr ng-repeat="sample in vm.food.samples"><td valign="center">{{ sample.sample_name }}</td><td>{{ sample.sample_lot_batch_number ? sample.sample_lot_batch_number : \'\' }}</td><td>{{ sample.sample_time_of_collection_frontend ? sample.sample_time_of_collection_frontend : \'\' }}</td><td>{{ sample.sample_expected_potency ? sample.sample_expected_potency : \'\' }}</td><td><ul style="padding-top: 15px; padding-bottom: 15px"><!-- Display tests in the organized order --><li style="white-space: nowrap; display: block; list-style-type:none; padding: 2px 0" ng-repeat="item in sample.actualFormattedTests track by $index"><!-- Panel header --> <span ng-if="item.isPanelHeader"><br ng-if="$index > 0"><strong>Panel: {{ item.panelName }}</strong><br></span><!-- Regular test --> <span ng-if="!item.isPanelHeader"><span ng-if="item.panel && item.panel.id">&nbsp;&nbsp;&nbsp;&nbsp;{{ vm.getTestDisplayNameById(item.assay.id, \'food\') }}<br></span><span ng-if="!item.panel || !item.panel.id">{{ vm.getTestDisplayNameById(item.assay.id, \'food\') }}<br></span></span></li><!-- Display other analyses separately --><li style="white-space: nowrap; display: block; list-style-type:none; padding: 2px 0" ng-repeat="(key, value) in sample.sample_other_analyses"><span ng-if="value">{{ key }}<br></span></li></ul></td></tr></tbody></table></table></div></div><!-- footer --><div class="rdRow"><div class="rdColumn"><div class="rdInvoiceFooter" style="text-align: center">{{\'Prepayment is required for all new clients. Payment terms can be negotiated for routine clients. After the invoice due date, a finance charge of 2% per month will be applied and any discounts will be nullified.\' | translate}}<br>{{\'Federal Tax ID # 94-2528801\' | translate}}<br>{{\'DUNS # 05-458-2416\' | translate}}</div></div></div><div class="rdRow"><div class="rdColumn"><hr></div></div></div><div class="rdViewRow3"><div style="float: left"><button class="btnPrimaryCancel" ng-click="vm.food.cancelOrder()"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;{{\'Cancel Order\' | translate}}</button></div><div style="float: right"><button class="btnPrimaryWhite" ng-click="vm.food.decrementPage()"><i class="fa fa-arrow-left"></i>&nbsp;&nbsp;&nbsp;{{\'Previous\' | translate}}</button><!-- <a href="#/orders" ng-show="!vm.food.submitting"class="btnPrimaryBlue btnLeftMargin"  ng-click="vm.food.submitOrder()">Submit Order</a> --> <button ng-show="!vm.food.submitting" class="btnPrimaryBlue btnLeftMargin progress-button" ng-click="vm.food.submitOrder()">{{\'Submit Order\' | translate}}</button> <button ng-show="vm.food.submitting" class="btnPrimaryBlue btnPrimaryBlueDisabled">Submitting&nbsp;<i class="fa fa-spinner fa-spin"></i></button></div></div></div></div></form></div><!-- FDA Testing --><div class="tab-content tabback" ng-if="vm.show_tab.fda"><form ng-class="{\'active\' : vm.active_tab.fda}" name="editForm" class="tab-pane" style="cursor: default" id="home" role="form"><div class="rdContainer"><div class="fdaViewRow2"><div><h3>Order Details</h3><div class="rdRow"><div class="rdColumn"><label class="rdColumnLeftLabel">FDA Entry #<span class="rdRequired">&nbsp;*</span></label><input type="text" ng-model="vm.fda.payload.entry" placeholder="FDA Entry" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.entry }" ng-change="vm.fda.checkfdaform()"></div><div class="rdColumn"><label class="rdColumnLeftLabel">Warehouse Address<span class="rdRequired">&nbsp;*</span></label><div class="input-autocomplate"><div class="add-option-caretRD"><input style="width: 95% !important; height: 45px" ng-click="openDistributionList()" type="text" name="CM-location" class="add_option" ng-model="vm.fda.payload.warehouse_address" placeholder="Choose Location / Add New" value="" readonly="readonly" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.warehouse_address }"></div><ul style="width: 95% !important" id="locationList" class="add_new_list location-list" ng-class="DistributionList"><li class="add_new_option" style="width: 95% !important; height: 45px" data-toggle="modal" data-target="#add-new-distribution">+ Add New</li><li ng-repeat="address in records" style="width: 95% !important; height: 45px" ng-if="address.locationType === \'DISTRIBUTION_LOCATION\'"><span class="spanDataAddress" ng-click="vm.fda.location(address.address, address.city, address.zipCode, address.distributorName, address.medicalLicence, address.fullLocation)">{{address.fullLocation}}</span> <span class="remove-option" ng-click="removeAddressData(address.fullLocation, address.id, $event, \'DISTRIBUTION\')" data-toggle="modal" data-target="#removeModal">&#10005;</span></li></ul></div></div></div><div class="rdRow"><div class="rdColumn file-upload-input"><label class="rdColumnRightLabel">FDA Detention Notice <span class="rdRequired">&nbsp;*</span></label><input class="fileUpload" type="file" id="detention_notice" onchange="onDetentionfileUpload(\'detention_notice_upload\')" value="FDA Detention Notice" placeholder="FDA Detention Notice"><button id="detention_notice_upload" ng-click="vm.onfileUpload(\'detention_notice\')" style="display: none"></button> <i class="fa fa-cloud-upload file-upload-icon"></i></div><div class="rdColumn file-upload-input"><label class="rdColumnRightLabel">Packing List and/or Invoice List <span class="rdRequired">&nbsp;*</span></label><input class="fileUpload" type="file" id="list_invoice_pack" onchange="onListfileUpload(\'list_upload\')" value="Packing List and/or Invoice List" placeholder="Packing List and/or Invoice List"><button id="list_upload" ng-click="vm.onfileUpload(\'list_invoice_pack\')" style="display: none"></button> <i class="fa fa-cloud-upload file-upload-icon"></i></div></div><div class="rdRow"><div class="rdColumn file-upload-input"><label class="rdColumnRightLabel">Additional Shipping Documents</label><input class="fileUpload" type="file" id="additional_shipping" onchange="onaddtionalShipfileUpload(\'additional_shipping_upload\')" value="Additional Shipping Documents" placeholder="Additional Shipping Documents"><button id="additional_shipping_upload" ng-click="vm.onfileUpload(\'additional_shipping\')" style="display: none"></button> <i class="fa fa-cloud-upload file-upload-icon"></i></div><div class="rdColumn file-upload-input"><label class="rdColumnRightLabel">FDA Extension</label><input class="fileUpload" type="file" value="FDA Extension" id="fda_extension" onchange="onfdaExtenfileUpload(\'fda_extension_upload\')" ng-model="vm.fda.payload.fdaextension" base-sixty-four-input placeholder="FDA Extension"><button id="fda_extension_upload" ng-click="vm.onfileUpload(\'fda_extension\')" style="display: none"></button> <i class="fa fa-cloud-upload file-upload-icon"></i></div></div><div class="rdRow"><div class="rdColumn"><label class="rdColumnLeftLabel">{{\'Special Instructions\' | translate}}</label><input type="text" ng-model="vm.fda.payload.special_instructions" placeholder="{{\'Special Instructions\' | translate}}" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-change="vm.fda.checkfdaform()"></div><div class="rdColumn file-upload-input"></div></div><div class="rdRow" style="margin-top: 20px"><div class="rdColumn"><label class="rdColumnLeftLabel">{{\'Document Upload\' | translate}}</label><input type="file" id="fda-file-upload" multiple="multiple" style="display: none" onchange="onFdaFileUpload()"> <button type="button" class="btnPrimaryWhite" onclick="document.getElementById(\'fda-file-upload\').click()" style="margin-bottom: 10px"><i class="fa fa-upload"></i>&nbsp;&nbsp;{{\'Select File\' | translate}}</button><div ng-if="vm.fda.uploadedFiles.length > 0" style="margin-top: 10px"><div ng-repeat="file in vm.fda.uploadedFiles" style="padding: 1px 20px; background: #fff; margin-bottom: 5px; border-radius: 3px; border: 1px solid #4f8fcc; display: flex; justify-content: space-between; align-items: center; height: 35px; font-size: 14px; width: 600px"><span><i class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }} ({{ file.size | number:0 }} bytes)</span> <button type="button" class="btn btn-sm btn-danger" ng-click="vm.fda.removeFile($index)" style="padding: 2px 8px"><i class="fa fa-times"></i></button></div></div></div></div><div class="rdRow"></div><h3>Sample Details</h3><div class="rdRow" style="margin-top: 1%;gap:40px;align-items: flex-end" ng-repeat="line in vm.fda.line track by $index"><div style="width: calc(30% - 40px)"><label class="rdColumnLeftLabel">Product Description<span class="rdRequired">&nbsp;*</span></label><input type="text" ng-model="line.productdesc" placeholder="Product Description" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !line.productdesc }" ng-change="vm.fda.checkfdaform()"></div><div style="width: calc(20% - 40px)"><label class="rdColumnLeftLabel">Line Item<span class="rdRequired">&nbsp;*</span></label><input type="text" ng-model="line.lineItem" placeholder="Line Item" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !line.lineItem }" ng-change="vm.fda.checkfdaform()"></div><div style="width: calc(50% - 160px)"><div><label class="rdColumnLeftLabel">Product Details/Code/Lot/Batch No. (Optional)</label><input type="text" ng-model="line.batchNo" placeholder="Product Details/Code/Lot/Batch No" class="ng-pristine ng-untouched ng-valid ng-not-empty"></div></div><div><button ng-if="$index == 0" style="height:40px;margin-left:-20px" class="btnPrimaryBlue btnLeftMargin progress-button" ng-click="vm.fda.addLine()">Add Line</button><div style="margin-right: 15px" ng-if="$index > 0"><a ng-click="vm.fda.removeLine($index)" class="btn btn-link action-button" style="width: 40px !important; height: 40px !important; padding: 7px 2px !important; font-size: 18px"><i class="fa fa-trash-o"></i></a></div></div></div><!-- <div class="rdRow" style="margin-top: 1%;gap:40px;align-items: flex-end;">\n                                    <div style="width: calc(30% - 40px);">\n                                        <label class="rdColumnLeftLabel">Product Description<span class="rdRequired">&nbsp;*</span></label>\n                                        <input type="text" ng-model="vm.fda.payload.description" placeholder="Product Description" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.description }" ng-change="vm.fda.checkfdaform()">\n                                    </div>\n                                    <div style="width: calc(20% - 40px);">\n                                        <label class="rdColumnLeftLabel">Line Item<span class="rdRequired">&nbsp;*</span></label>\n                                        <input type="text" ng-model="vm.fda.payload.lineItem" placeholder="Line Item" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.lineItem }" ng-change="vm.fda.checkfdaform()">\n                                    </div>\n                                    <div style="width: calc(50% - 160px);">\n                                        <div >\n                                            <label class="rdColumnLeftLabel">Product Details/Code/Lot/Batch No. (Optional)</label>\n                                            <input type="text" ng-model="vm.fda.payload.lineItem" placeholder="Product Details/Code/Lot/Batch No" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-change="vm.fda.checkfdaform()">\n                                        </div>\n                                    </div>\n                                    <div>\n                                        <button style="height:40px;margin-left:-20px" class="btnPrimaryBlue btnLeftMargin progress-button" ng-click="vm.fda.addLine()">Add Line</button>\n                                    </div>\n                                </div>\n                                <div class="rdRow" style="margin-top: 1%;gap:40px;align-items: flex-end;">\n                                    <div style="width: calc(30% - 40px);">\n                                        <label class="rdColumnLeftLabel">Product Description<span class="rdRequired">&nbsp;*</span></label>\n                                        <input type="text" ng-model="vm.fda.payload.description" placeholder="Product Description" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.description }" ng-change="vm.fda.checkfdaform()">\n                                    </div>\n                                    <div style="width: calc(20% - 40px);">\n                                        <label class="rdColumnLeftLabel">Line Item<span class="rdRequired">&nbsp;*</span></label>\n                                        <input type="text" ng-model="vm.fda.payload.lineItem" placeholder="Line Item" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-class="{ \'rd-placeholder required-input\' : !vm.fda.payload.lineItem }" ng-change="vm.fda.checkfdaform()">\n                                    </div>\n                                    <div style="width: calc(50% - 160px);">\n                                        <div >\n                                            <label class="rdColumnLeftLabel">Product Details/Code/Lot/Batch No. (Optional)</label>\n                                            <input type="text" ng-model="vm.fda.payload.lineItem" placeholder="Product Details/Code/Lot/Batch No" class="ng-pristine ng-untouched ng-valid ng-not-empty" ng-change="vm.fda.checkfdaform()">\n                                        </div>\n                                    </div>\n                                    <div style="display: flex;margin-left:-20px">\n                                        <div style="margin-right: 15px;"><a ng-click="vm.rd.removeSample($index)" class="btn btn-link action-button" style="width: 40px !important; height: 40px !important; padding: 7px 2px !important; font-size: 18px;">\n                                            <i class="fa fa-trash-o" ></i></a></div>\n                                            <div style="margin-right: 15px;"><a ng-click="vm.rd.removeSample($index)" class="btn btn-link action-button" style="width: 40px !important; height: 40px !important; padding: 7px 2px !important; font-size: 18px;">\n                                                <i class="fa fa-trash-o" ></i></a></div>\n                                    </div>\n                                </div> --></div><div class="submit-fda-btn" style="margin-bottom: 25px"><button class="btnPrimaryBlue btnLeftMargin progress-button" ng-click="vm.fda.submitOrder()" ng-disabled="vm.fda.isFdaDisabled" ng-class="{ \'btnPrimaryBlueDisabled\' : vm.fda.isFdaDisabled }">{{\'Submit Order\' | translate}}</button><!-- <button class="btnPrimaryBlue btnPrimaryBlueDisabled">Submitting&nbsp;<i class="fa fa-spinner fa-spin"></i></button> --></div></div></div></form></div><!-- Modal - Add requested test --><div class="modal fade" id="testsInfoModal" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content" style="color: #2E3F52"><div class="modal-header modal-sample-submit"><button type="button" class="close" data-dismiss="modal" aria-label="Close" style="padding-right: 8px"><span>&times;</span></button><h4 class="modal-title">Select Test(s)</h4></div><div class="modal-body" style="background-color: #F3F7FA"><ol style="line-height:30px"><li><div style="display: table-row"><div style="display: table-cell"><div class="number-marker"><strong>1</strong></div></div><div style="display: table-cell">All tests previously performed or quoted for your account will appear under <span style="font-family: OpenSans-Bold">recent tests</span></div></div></li><li><div style="display: table-row"><div style="display: table-cell"><div class="number-marker"><strong>2</strong></div></div><div style="display: table-cell">Based on your account type and the tests performed so far, <span style="font-family: OpenSans-Bold">recommended tests</span> will be displayed to the right of recent tests.</div></div></li><div style="text-align:center"><img src="content/images/sample-submit/test_info_modal_1.png"></div><li><div style="display: table-row"><div style="display: table-cell"><div class="number-marker"><strong>3</strong></div></div><div style="display: table-cell">To requeset other tests, type the name of the test into the search bar then click "<span style="font-family: OpenSans-Bold">Request Test</span>". Our office will process the request if we are able to perform the test and it will appear in your portal as an option for your next submission.</div></div></li><div style="text-align:center"><img src="content/images/sample-submit/test_info_modal_2.png"></div></ol></div></div></div></div><!-- Modal - Add rd requested test --><div class="modal fade" id="rdAddRequestedTest" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Add New Test</h4></div><div class="modal-body" style="background-color: #F3F7FA"><label for="testName" style="margin-left: 5px">Test Name</label><input type="text" id="testName" placeholder="i.e. Citric Acid Test" ng-model="vm.rd.test_to_search"></div><div class="modal-footer"><button class="btnPrimaryCancel" ng-click="vm.rd.clearOtherAnalysis()" data-dismiss="modal"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;Cancel</button> <button class="add-panel-btn" style="height: 35px; width: auto" ng-click="vm.rd.addOtherAnalysis()" data-dismiss="modal" style="float: right"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Add New Test</button></div></div></div></div><!-- Modal - Add food requested test --><div class="modal fade" id="foodAddRequestedTest" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Add New Test</h4></div><div class="modal-body" style="background-color: #F3F7FA"><label for="testName" style="margin-left: 5px">Test Name</label><input type="text" id="testName" placeholder="i.e. Citric Acid Test" ng-model="vm.food.test_to_search"></div><div class="modal-footer"><button class="btnPrimaryCancel" ng-click="vm.food.clearOtherAnalysis()" data-dismiss="modal"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;Cancel</button> <button class="add-panel-btn" style="height: 35px; width: auto" ng-click="vm.food.addOtherAnalysis()" data-dismiss="modal" style="float: right"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Add New Test</button></div></div></div></div><!-- Modal - Add panel name --><div class="modal fade" id="addPanelName" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">New Panel</h4></div><div class="modal-body" style="background-color: #F3F7FA"><label for="panelName" style="margin-left: 5px">Panel Name</label><input ng-if="vm.active_tab.rd" type="text" placeholder="i.e. Panel Name 564" id="panelName" ng-model="vm.rd.panels.new_panel_name"> <input ng-if="vm.active_tab.analysis" type="text" placeholder="i.e. Panel Name 564" id="panelName" ng-model="vm.food.panels.new_panel_name"></div><div ng-if="vm.active_tab.rd" class="modal-footer"><button class="btnPrimaryCancel" ng-click="vm.rd.clearPanel()" data-dismiss="modal"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;Cancel</button> <button class="btnPrimaryBlue" ng-click="vm.rd.savePanel(null, 2)" data-dismiss="modal" style="float: right"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Add New Panel</button></div><div ng-if="vm.active_tab.analysis" class="modal-footer"><button class="btnPrimaryCancel" ng-click="vm.food.clearPanel()" data-dismiss="modal"><i class="fa fa-times"></i>&nbsp;&nbsp;&nbsp;Cancel</button> <button class="btnPrimaryBlue" ng-click="vm.food.savePanel(null, 2)" data-dismiss="modal" style="float: right"><i class="fa fa-plus"></i>&nbsp;&nbsp;&nbsp;Add New Panel</button></div></div></div></div><!-- Modal - Add new distribution --><div class="modal fade addOption" id="add-new-invoicing" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.InvoicingAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.InvoicingAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.InvoicingAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.InvoicingAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.InvoicingAddress.state" class="form-control"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newInvoicingAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.InvoicingAddress.distributorName || !vm.InvoicingAddress.address || !vm.InvoicingAddress.city || !vm.InvoicingAddress.zipCode || !vm.InvoicingAddress.state"></div></div></form></div></div><!-- Modal - Add new pickup --><div class="modal fade addOption" id="add-new-pickup" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.PickupAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.PickupAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.PickupAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.PickupAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" ng-model="vm.PickupAddress.state" class="form-control"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newPickupAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.PickupAddress.distributorName || !vm.PickupAddress.address || !vm.PickupAddress.city || !vm.PickupAddress.zipCode || !vm.PickupAddress.state"></div></div></form></div></div><!-- Modal - Add new distribution --><div class="modal fade addOption" id="add-new-distribution" role="dialog"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.DistributionAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.DistributionAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.DistributionAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.DistributionAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>License #(s) <span class="require-field">*</span></label><input type="text" ng-model="vm.DistributionAddress.licenceList" class="form-control" placeholder="e.g. LIC-001, LIC-002, LIC-003"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" name="d_state" ng-model="vm.DistributionAddress.state" class="form-control"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input type="submit" ng-click="newDistributionAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.DistributionAddress.distributorName || !vm.DistributionAddress.address || !vm.DistributionAddress.city || !vm.DistributionAddress.zipCode || !vm.DistributionAddress.state || !vm.DistributionAddress.licenceList"></div></div></form></div></div><!-- Modal - Add new manufacturing --><div class="modal fade addOption" id="add-new-manufacturing" role="dialog" style="z-index: 2000"><div class="modal-dialog modal-lg"><form><!-- Modal content--><div class="modal-content new-location-modal"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Add New Location</h4></div><div class="modal-body"><div class="row"><div ng-if="vm.order_type == \'Compliance\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Company Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.ManufacturingAddress.distributorName" class="form-control"></div><div ng-if="vm.order_type == \'RnD\'" class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Name <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.ManufacturingAddress.distributorName" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Manufacturing Address <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.ManufacturingAddress.address" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>City <span class="require-field">*</span></label><input type="text" name="d_name" ng-model="vm.ManufacturingAddress.city" class="form-control"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>Zip Code <span class="require-field">*</span></label><input type="text" name="d_address" ng-model="vm.ManufacturingAddress.zipCode" class="form-control"></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>State <span class="require-field">*</span></label><input type="text" name="d_state" ng-model="vm.ManufacturingAddress.state" class="form-control"></div></div><div class="row" ng-if="(vm.order_type == \'Compliance\' || vm.order_type == \'RnD\') && (vm.customer_type.includes(\'cannabis\') || vm.customer_type.includes(\'hemp\'))"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group"><label>License #(s) <span class="require-field" ng-hide="vm.ManufacturingAddress.licenseNA">*</span></label><input type="text" ng-model="vm.ManufacturingAddress.licenceList" class="form-control" ng-disabled="vm.ManufacturingAddress.licenseNA" placeholder="e.g. LIC-001, LIC-002, LIC-003"></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 form-group" style="padding-top: 32px"><label style="font-weight: normal"><input type="checkbox" ng-model="vm.ManufacturingAddress.licenseNA" ng-change="vm.ManufacturingAddress.licenseNA ? (vm.ManufacturingAddress.licenceList = \'N/A\') : (vm.ManufacturingAddress.licenceList = \'\')"> N/A</label></div></div></div><div class="modal-footer new-location-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal" ng-click="clearCityZipListDataOnClose()"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <input ng-if="vm.order_type == \'Compliance\' && !vm.active_tab.rd" type="submit" ng-click="newManufacturingAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.ManufacturingAddress.distributorName || !vm.ManufacturingAddress.address || !vm.ManufacturingAddress.city || !vm.ManufacturingAddress.zipCode || !vm.ManufacturingAddress.state || !vm.ManufacturingAddress.licenceList"> <input ng-if="vm.order_type == \'RnD\' || vm.active_tab.rd" type="submit" ng-click="newManufacturingAddress()" class="btn btn-primary" data-dismiss="modal" value="Save" ng-disabled="!vm.ManufacturingAddress.distributorName || !vm.ManufacturingAddress.address || !vm.ManufacturingAddress.city || !vm.ManufacturingAddress.zipCode || !vm.ManufacturingAddress.state"></div></div></form></div></div><!-- Modal - Remove option --><div class="modal fade" id="removeModal" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Delete Location</h4></div><div class="modal-body"><p>Are you sure you want to permanently delete location<br><strong>{{vm.removeAddressData}}</strong>?</p></div><div class="modal-footer"><button type="button" class="btn btn-default btn-close" data-dismiss="modal"><i class="fa fa-close"></i> {{\'Close\' | translate}}</button> <button type="button" class="btn btn-primary" ng-click="removeAddressQuery()" data-dismiss="modal">Delete</button></div></div></div></div><!-- Submitting - info modal --><div class="modal fade" id="submittingModal" role="dialog"><div class="modal-dialog modal-md"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Delete Location</h4></div><div class="modal-body"><i class="fa fa-spinner fa-spin" style="font-size: 100px"></i></div></div></div></div></div><script>function selectTab(i) {\n            console.log("tab");\n            if (i == 0) {\n                $("#home").addClass("active");\n                $("#home_tab").addClass("active");\n                $("#qa_testing").removeClass("active");\n                $("#qa_testing_tab").removeClass("active");\n            } else if (i == 1) {\n                $("#home").removeClass("active");\n                $("#home_tab").removeClass("active");\n                $("#qa_testing").addClass("active");\n                $("#qa_testing_tab").addClass("active");\n            }\n        }\n\n        function uploadExcel() {\n            $("#rd_click_upload").click();\n        }\n\n        function compUploadExcel() {\n            $("#comp_click_upload").click();\n        }\n\n        function foodUploadExcel() {\n            $("#food_click_upload").click();\n        }\n        function onListfileUpload() {\n            $(`#list_upload`).click();\n        }\n        function onaddtionalShipfileUpload() {\n            $(`#additional_shipping_upload`).click();\n        }\n        function onfdaExtenfileUpload() {\n            $(`#fda_extension_upload`).click();\n        }\n        function onDetentionfileUpload() {\n            $(`#detention_notice_upload`).click();\n        }\n        function onCompFileUpload() {\n            var fileInput = document.getElementById(\'comp-file-upload\');\n            var injector = angular.element(document.body).injector();\n            var $rootScope = injector.get(\'$rootScope\');\n            $rootScope.$broadcast(\'compFileSelected\', fileInput.files);\n        }\n        function onRdFileUpload() {\n            var fileInput = document.getElementById(\'rd-file-upload\');\n            var injector = angular.element(document.body).injector();\n            var $rootScope = injector.get(\'$rootScope\');\n            $rootScope.$broadcast(\'rdFileSelected\', fileInput.files);\n        }\n        function onFoodFileUpload() {\n            var fileInput = document.getElementById(\'food-file-upload\');\n            var injector = angular.element(document.body).injector();\n            var $rootScope = injector.get(\'$rootScope\');\n            $rootScope.$broadcast(\'foodFileSelected\', fileInput.files);\n        }\n        function onFdaFileUpload() {\n            var fileInput = document.getElementById(\'fda-file-upload\');\n            var injector = angular.element(document.body).injector();\n            var $rootScope = injector.get(\'$rootScope\');\n            $rootScope.$broadcast(\'fdaFileSelected\', fileInput.files);\n        }</script></div>');
$templateCache.put('app/pages/sample-submit/samplesubmit.notify.html','<div><div class="content-wrapper-x content-page-height"><div class="tabbackall fullheight"><div class="tab-content tabback tabbackall9 text-center thankyoutabcon" style="padding-top: 100px"><span class="fa-stack fa-2x"><i class="fa fa-circle fa-stack-2x" style="color: #fff"></i> <i class="fa fa-check-circle fa-stack-2x" style="color: #00E0C1"></i></span><p class="thenkyouhadding" style="padding-top: 0">{{\'Your order has been submitted successfully\' | translate}}</p><div class="topbuffer4"></div><div ng-if="type == \'RD\'"><p class="font-type-1">Thank you for choosing {{ vm.companyName }}</p><div class="topbuffer2"></div><p class="font-type-1">{{\'Please print out the Submission Form below and include with your sample(s)\' | translate}}</p></div><div ng-if="type == \'COMPLIANCE\'"><p class="font-type-1">Thank you for choosing {{ vm.companyName }}</p><div class="topbuffer2"></div><p class="font-type-1">{{\'A compliance representative will contact you shortly to confirm your sampling appointment\' | translate}}</p><div class="topbuffer2"></div><p class="font-type-1">{{\'Submission order details will be available in the portal. Otherwise you can print the document at the link below\' | translate}}</p></div><button class="btnPrimaryBlue" ng-click="vm.downloadOrderPdf()" style="margin-top: 40px; margin-bottom: 15px"><i class="fa fa-print"></i>&nbsp;&nbsp;&nbsp; {{\'Print Submission Form\' | translate}}</button><br><div ng-if="deliveryPreference == \'Mail\'"><button class="btnPrimaryBlue" ng-click="vm.openShippingGuide()" style="margin-top: 15px; margin-bottom: 30px"><i class="fa fa-truck"></i>&nbsp;&nbsp;&nbsp; {{\'View Packaging & Shipping Guidelines\' | translate}}</button><div style="color: #34485c; font-family: OpenSans-Regular"><strong>Sample Receiving Address</strong><br>{{\'Attn: Lab Sample\' | translate}}<br>{{ vm.companyName }}<br>{{ vm.address.line_1 }}<br>{{ vm.address.city + \', \' + vm.address.state + \' \' + vm.address.postal_code }}</div></div><hr style="padding: 10px"><div class="btnsmallsize"><button class="btnPrimaryWhite" ui-sref="orders">{{\'Check Order Status\' | translate}}</button> <button class="btnPrimaryWhite" ui-sref="samplesubmit" style="margin-left: 20px">{{\'Submit Another Order\' | translate}}</button></div></div></div></div></div>');
$templateCache.put('app/pages/signup/signup.html','<style>#signup-page {\r\n        height: 100vh;\r\n        font-size: 14px;\r\n        background-color: #EFF5FB;;\r\n    }\r\n\r\n    .content-box {\r\n        height: 100vh;\r\n        display: -webkit-flex;\r\n        -webkit-align-items: flex-start;\r\n        display: flex;\r\n        align-items: flex-start;\r\n    }\r\n\r\n    .content-center {\r\n        -webkit-align-items: center;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    .content-left {\r\n        background-color: #3a516b;\r\n        border-top-left-radius: 4px;\r\n        border-bottom-left-radius: 4px;\r\n        height: 100%;\r\n        width: 348px;\r\n        padding-left: 46px;\r\n        padding-top: 56px;\r\n        color: white;\r\n    }\r\n\r\n    .content-right {\n        background-color: #F3F7FA;\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n        height: 100%;\n        width: 812px;\n        border: 1px solid #DDE7F2;\n    }\n\n    .signup-brand-logo-dark {\n        display: block;\n        width: 220px;\n        max-width: calc(100% - 24px);\n        height: auto;\n    }\n\r\n    .flex-row {\r\n        display: flex;\r\n        flex-direction: row;\r\n    }\r\n\r\n    .flex-column {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .content-input-container {\r\n        height: 740px;\r\n        width: 100%;\r\n        color: #3D5269;\r\n        padding: 40px 112px 0px 112px;\r\n        overflow: auto;\r\n    }\r\n    \r\n    /* Style the track (background) */\r\n    .content-input-container::-webkit-scrollbar-track {\r\n        background: transparent;\r\n    }\r\n    \r\n    /* Style the scrollbar itself */\r\n    .content-input-container::-webkit-scrollbar {\r\n        width: 8px;  /* Adjust width of scrollbar */\r\n    }\r\n    \r\n    /* Style the draggable scrolling handle */\r\n    .content-input-container::-webkit-scrollbar-thumb {\r\n        background: #BBC3CD;  /* Color of the scroll thumb */\r\n        border-radius: 4px;  /* Rounded corners */\r\n    }\r\n    \r\n    /* Style the thumb on hover */\r\n    .content-input-container::-webkit-scrollbar-thumb:hover {\r\n        background: #8f959c;  /* Darker shade when hovering */\r\n    }\r\n\r\n    .bottom-nav {\r\n        width: 100%;\r\n        height: 72px;\r\n        background-color: white;\r\n        border-top: 1px solid #dbe0e7;\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: flex-end;\r\n        padding: 16px 40px;\r\n        border-bottom-right-radius: 4px;\r\n    }\r\n\r\n    .signup-btn {\r\n        display: flex;\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        padding: 6px 16px;\r\n        border-radius: 4px;\r\n        width: 153px;\r\n        height: 40px;\r\n        border: 1px solid black;\r\n    }\r\n\r\n    .btn-blue-disabled {\r\n        background-color: #dae1e7;\r\n        pointer-events: none;\r\n        border: none;\r\n    }\r\n\r\n    .btn-blue {\r\n        background-color: #4f8fcc;\r\n        color: #fff;\r\n        border: none;\r\n    }\r\n\r\n    .btn-blue:hover {\r\n        background-color: #fff;\r\n        color: #4f8fcc;\r\n        border: 1px solid #4f8fcc;\r\n    }\r\n\r\n    .btn-white {\r\n        background-color: #fff;\r\n        color: #4f8fcc;\r\n        border: 1px solid #4f8fcc;\r\n    }\r\n\r\n    .btn-white:hover {\r\n        background-color: #4f8fcc;\r\n        color: #fff;\r\n    }\r\n\r\n    .left-progress {\r\n        border-left: 3px solid #293A4C;\r\n        height: 58px;\r\n        padding-left: 36px;\r\n        position: relative;\r\n    }\r\n\r\n    .hide-border-left {\r\n        border-left: 3px solid transparent !important;\r\n    }\r\n\r\n    .hide-border-bottom {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    .position-background-circle {\r\n        position: absolute;\r\n        font-size: 22px;\r\n        left: -11px;\r\n        top: -2px;\r\n    }\r\n\r\n    .position-main-circle {\r\n        position: absolute;\r\n        font-size: 24px;\r\n        left: -12px;\r\n        top: -3px;\r\n    }\r\n\r\n    .main-circle-not-started {\r\n        z-index: 100;\r\n        color: #3a516b;\r\n    }\r\n\r\n    .main-circle-in-progress {\r\n        z-index: 100;\r\n        color: #298ed0;\r\n    }\r\n\r\n    .main-circle-complete {\r\n        z-index: 100;\r\n        color: #298ed0;\r\n    }\r\n\r\n    .not-started-background-circle {\r\n        z-index: 50;\r\n        color: #35485e;\r\n    }\r\n\r\n    .dark-background-circle {\r\n        z-index: 50;\r\n        color: #293A4C;\r\n    }\r\n\r\n    .white-background-circle {\r\n        z-index: 50;\r\n        color: #fff;\r\n    }\r\n\r\n    .text-color-complete {color: #F3B033;}         /* Unvisited link  */\r\n    .text-color-complete:visited {color: #F3B033;} /* Visited link    */\r\n    .text-color-complete:hover {color: #F3B033;}   /* Mouse over link */\r\n    .text-color-complete:active {color: #F3B033;}\r\n\r\n    .step-header {\r\n        font-family: OpenSans-Bold;\r\n        font-size: 24px;\r\n        color: #3D5269;\r\n    }\r\n\r\n    .step-description {\r\n        margin-top: 16px;\r\n        font-size: 14px;\r\n        color: #3D5269;\r\n    }\r\n\r\n    .input-title {\r\n        font-family: OpenSans-Semibold;\r\n        color: #64798E;\r\n    }\r\n\r\n    .input-container {\r\n        margin-top: 16px;\r\n    }\r\n\r\n    .input {\r\n        width: 100%;\r\n        height: 40px;\r\n        background: #fff;\r\n        border: 1px solid #e6ebf0;\r\n        border-radius: 4px;\r\n        margin-top: 8px;\r\n        padding: 12px 8px;\r\n        color: #3d5269;\r\n    }\r\n\r\n    .input-dropdown {\r\n        margin-top: 8px;\r\n        padding: 0px 8px;\r\n        width: 100%;\r\n        height: 40px;\r\n        border: 1px solid #E7EBEF;\r\n        background-color: white;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        appearance:none;\r\n        -webkit-appearance:none;\r\n        -moz-appearance:none;\r\n        -ms-appearance:none;\r\n    }\r\n\r\n    .placeholder {\r\n        color: rgba(85, 109, 133, 0.9);\r\n        opacity: 1;\r\n    }\r\n\r\n    .checkboxContainer input:checked ~ .checkmark {\r\n        background-color: #298ed0;\r\n        border: none;\r\n    }\r\n\r\n    .checkboxContainer input:disabled:checked ~ .checkmark {\r\n        background-color: #b6c2cd;\r\n        border: none;\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .checkboxContainer input:disabled {\r\n        cursor: not-allowed;\r\n    }\r\n\r\n    .checkmark {\r\n        border: 2px solid #b6c2cd;\r\n        box-sizing: border-box;\r\n        border-radius: 2.4px;\r\n    }\r\n\r\n    .blue-a-tag {color: #2D9CDB;}         /* Unvisited link  */\r\n    .blue-a-tag:visited {color: #2D9CDB;} /* Visited link    */\r\n    .blue-a-tag:hover {color: #2D9CDB;}   /* Mouse over link */\r\n    .blue-a-tag:active {color: #2D9CDB;}\r\n\r\n    .gray-a-tag {color: gray;}         /* Unvisited link  */\r\n    .gray-a-tag:visited {color: gray;} /* Visited link    */\r\n    .gray-a-tag:hover {color: gray;}   /* Mouse over link */\r\n    .gray-a-tag:active {color: gray;}\r\n\r\n    .wire-transfer-row {\n        border-bottom: 1px solid #DFEAF7;\n    }\n\n    .wire-transfer-section-title {\n        color: #263f6a;\n        font-family: OpenSans-Semibold;\n        margin: 18px 0px 6px;\n        text-wrap: balance;\n    }\n\n    .wire-transfer-intro {\n        text-wrap: pretty;\n    }\n\r\n    .wire-transfer-left {\r\n        font-family: OpenSans-Semibold;\r\n        padding: 6px 0px 6px 24px;\r\n        width: 191px;\r\n        border-right: 1px solid #DFEAF7;\r\n    }\r\n\r\n    .wire-transfer-right {\n        display: flex;\n        flex-direction: column;\n        overflow-wrap: anywhere;\n        padding: 6px 0px 6px 24px;\n        width: 276px;\n    }\n\n    .wire-transfer-detail {\n        margin-top: 2px;\n    }\n\r\n    .contact-row {\r\n        align-items: center;\r\n        margin-top: 8px;\r\n        justify-content: space-between;\r\n        height: 52px;\r\n        padding: 8px 16px;\r\n        background-color: white;\r\n        border: 1px solid #E7EBEF;\r\n        border-radius: 4px;\r\n    }\r\n\r\n    .disabled-signup {\r\n        opacity: 0.6;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .red {\r\n        color: red;\r\n    }\r\n\r\n    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n        color: #8795A1;\r\n        opacity: 1; /* Firefox */\r\n    }\r\n\r\n    :-ms-input-placeholder { /* Internet Explorer 10-11 */\r\n        color: #8795A1;\r\n    }\r\n\r\n    ::-ms-input-placeholder { /* Microsoft Edge */\r\n        color: #8795A1;\r\n    }\r\n\r\n    .payment-methods-nav-btn {\r\n        height: 32px;\r\n        width: 172px;\r\n        border-radius: 4px;\r\n        padding: 6px 16px;\r\n        border: none;\r\n    }\r\n\r\n    .payment-methods-gray-btn {\r\n        background-color: #3d5269;\r\n        color: white\r\n    }\r\n\r\n    .payment-methods-gray-btn:hover {\r\n        background-color: #eff5fb;\r\n        color: #3d5269;\r\n        border-color: #3d5269;\r\n        border-style: solid;\r\n        border-width: 1px;\r\n    }\r\n\r\n    .payment-methods-light-btn {\r\n        background-color: #eff5fb;\r\n        color: #3d5269;\r\n    }\r\n\r\n    .payment-methods-light-btn:hover {\r\n        transition: background-color .2s ease-in-out;\r\n        background-color: #3d5269;\r\n        color: #eff5fb;\r\n    }\r\n    .input-selected-additional-info{\r\n        display: flex;\r\n        width: 100%;\r\n        margin-top: 8px;\r\n    }\r\n    .input-not-selected-yet{\r\n        opacity: 0.6\r\n    }</style><div id="signup-page"><div><div class="content-box content-center"><div style="display: flex; height: 812px; width: 1040px; border-radius: 4px"><div class="content-left"><img src="/content/brand/logo-sidebar.png" alt="portal logo" class="signup-brand-logo-dark"><div style="position: relative; margin-top: 70px"><div class="left-progress" ng-class="{ \'hide-border-left\' : $last }" ng-repeat="step in vm.steps" ng-if="step.current"><div ng-bind-html="vm.nav.stepDotsStatus(step.status)"></div><span ng-class="{ \'text-color-complete\' : step.status == \'complete\' }" style="font-family: OpenSans-Semibold">{{ step.title }}</span></div></div><div style="margin-top: 272px">Already have an account? <a class="text-color-complete" href="/#/login">Log in</a></div></div><div class="content-right flex-column" ng-class="{\'no-pointer-events\': !vm.quotation_valid || vm.submitting}"><div class="content-input-container"><div ng-show="vm.loading_quotation && !vm.error_message" style="justify-content: center; display: flex; flex-direction: column; height: 100%; text-align: center"><i ng-cloak style="font-size: 32px" class="fa fa-spinner fa-spin"></i> <span style="font-size: 18px">Please wait while we retreive your quotation</span></div><div ng-show="!vm.loading_quotation && vm.error_message" style="justify-content: center; display: flex; flex-direction: column; height: 100%; text-align: center"><span style="font-size: 18px">{{ vm.error_message }}</span><br><span style="font-size: 18px">Please contact {{brand.contact.info_email}} if this issue persists.</span><br></div><div ng-show="!vm.loading_quotation && !vm.error_message && vm.current_step.current == \'company_info\'"><div class="step-header">{{ vm.steps.company_info.title }}</div><div class="flex-column" style="padding-top: 24px"><div class="flex-column input-container"><div class="input-title">Business Name*</div><input class="input" placeholder="Business name" ng-model="vm.steps.company_info.company.business_name" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.business_name }" maxlength="255"></div><div class="flex-column input-container"><div class="flex-column" style="width: 100%"><div class="input-title">Industry*</div><div class="select-container" style="position: relative"><select ng-options="industry for industry in vm.steps.company_info.industries" ng-model="vm.steps.company_info.company.industry" ng-change="vm.steps.company_info.checkRequiredFields()" class="input-dropdown placeholder" ng-class="{ \'required-input\' : !vm.steps.company_info.company.industry }"><option value="" selected="selected" disabled="disabled">Industry</option></select><div style="position: absolute; right: 16px; top: 17px"><svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.578201 0.292941C0.391394 0.481833 0.286621 0.736777 0.286621 1.00244C0.286621 1.2681 0.391394 1.52305 0.578201 1.71194L3.5172 4.67694C3.7352 4.89194 4.0172 4.99894 4.2962 4.99894C4.5752 4.99894 4.8522 4.89194 5.0652 4.67694L7.9952 1.72194C8.18177 1.53292 8.28638 1.27803 8.28638 1.01244C8.28638 0.746856 8.18177 0.49196 7.9952 0.302941C7.90337 0.209757 7.79393 0.135759 7.67324 0.0852509C7.55255 0.0347429 7.42303 0.0087328 7.2922 0.0087328C7.16137 0.0087328 7.03185 0.0347429 6.91116 0.0852509C6.79047 0.135759 6.68103 0.209757 6.5892 0.302941L4.2912 2.61994L1.9842 0.292941C1.89216 0.20012 1.78266 0.126444 1.662 0.0761652C1.54134 0.0258864 1.41192 0 1.2812 0C1.15049 0 1.02106 0.0258864 0.900405 0.0761652C0.779746 0.126444 0.670238 0.20012 0.578201 0.292941Z" fill="#42526E"/></svg></div></div></div></div><div class="flex-column input-container"><div class="input-title">Address*</div><input class="input" placeholder="Address" ng-model="vm.steps.company_info.company.address" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.address }" maxlength="41"></div><div class="flex-column input-container"><div class="flex-row"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">Country*</div><select ng-model="vm.steps.company_info.company.country" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.country }" ng-options="country for country in vm.list_of_countries" class="input" style="padding: 8px"><option value="" selected="selected" disabled="disabled">Select Country</option></select></div><div class="flex-column" style="width: 100%"><div class="input-title">City*</div><input class="input" placeholder="City" ng-model="vm.steps.company_info.company.city" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.city }"></div></div></div><div class="flex-column input-container"><div class="flex-row"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">Zip Code*</div><input class="input" placeholder="Zip Code" ng-model="vm.steps.company_info.company.zip_code" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.zip_code }" ng-style="{ \'width\': vm.steps.company_info.company.country !== \'United States of America\' ? \'50%\' : \'100%\' }"></div><div ng-show="vm.steps.company_info.company.country === \'United States of America\'" class="flex-column" style="width: 100%"><div class="input-title">State*</div><select class="input" ng-model="vm.steps.company_info.company.state" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.state }" ng-options="state for state in vm.list_of_states" style="padding: 8px"><option value="" selected="selected" disabled="disabled">Select State</option></select><!-- <input class="input" placeholder="State" ng-model="vm.steps.company_info.company.state" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.state }"> --></div></div></div><div class="flex-column input-container"><div class="input-title">Main Phone*</div><input type="tel" class="input" placeholder="Phone number" ng-model="vm.steps.company_info.company.main_phone" ng-change="vm.steps.company_info.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.company_info.company.main_phone }" pattern="[0-9\\(\\)+\\s\\-]*"></div><div class="flex-column input-container"><div class="input-title">License Number</div><input class="input" placeholder="Optional" ng-model="vm.steps.company_info.company.license_number" ng-change="vm.steps.company_info.checkRequiredFields()"></div></div></div><div ng-show="!vm.loading_quotation && !vm.error_message && vm.current_step.current == \'primary_contact\'"><div class="step-header">{{ vm.steps.primary_contact.title }}</div><div class="step-description">{{ vm.steps.primary_contact.description }}</div><div class="flex-column"><div class="flex-column input-container" style="margin-top: 32px"><div class="flex-row"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">First Name*</div><input class="input" placeholder="First Name" ng-model="vm.steps.primary_contact.contact.first_name" ng-change="vm.steps.primary_contact.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.primary_contact.contact.first_name }"></div><div class="flex-column" style="width: 100%"><div class="input-title">Last Name*</div><input class="input" placeholder="Last Name" ng-model="vm.steps.primary_contact.contact.last_name" ng-change="vm.steps.primary_contact.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.primary_contact.contact.last_name }"></div></div><div class="flex-column input-container"><div class="input-title">Title</div><input class="input" placeholder="Title" ng-model="vm.steps.primary_contact.contact.title" ng-change="vm.steps.primary_contact.checkRequiredFields()"></div><div class="flex-column input-container"><div class="input-title">Email Address*</div><input class="input" type="email" placeholder="Email Address" ng-model="vm.steps.primary_contact.contact.email_address" ng-change="vm.steps.primary_contact.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.primary_contact.contact.email_address }"></div><div class="flex-column input-container"><div class="input-title">Direct Phone*</div><input type="tel" class="input" placeholder="Phone number" ng-model="vm.steps.primary_contact.contact.direct_phone" ng-change="vm.steps.primary_contact.checkRequiredFields()" ng-class="{ \'required-input\' : !vm.steps.primary_contact.contact.direct_phone}" pattern="[0-9\\(\\)+\\s\\-]*"></div><div class="flex-row" style="padding-left: 12px; margin-top: 26px"><div style="position: relative"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.primary_contact.contact.receive_reports" ng-checked="vm.steps.primary_contact.contact.receive_reports" class="public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span class="generic-popover-trigger" style="margin-left: 16px">Reports</span><div class="generic-popover">Access to <strong>Reports</strong> includes you in automated emails regarding received samples and final reports.</div></div><div ng-show="false" style="margin-left: 36px" style="position: relative"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.primary_contact.contact.receive_invoices" ng-checked="vm.steps.primary_contact.contact.receive_invoices" class="public-view-item-checkbox" style="display: inline-block" type="checkbox"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span class="generic-popover-trigger" style="margin-left: 16px">Invoices</span><div class="generic-popover">Access to <strong>Invoices</strong> includes you in automated emails regarding quotations and invoices.</div></div></div></div></div></div><div ng-show="!vm.loading_quotation && !vm.error_message && vm.current_step.current == \'additional_contacts\'"><div class="step-header">{{ vm.steps.additional_contacts.title }}</div><div class="flex-column input-container" style="margin-top: 32px"><div class="flex-row"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">First Name</div><input class="input" placeholder="First Name" ng-model="vm.steps.additional_contacts.contact.first_name" ng-change="vm.steps.additional_contacts.checkRequiredFields()"></div><div class="flex-column" style="width: 100%"><div class="input-title">Last Name</div><input class="input" placeholder="Last Name" ng-model="vm.steps.additional_contacts.contact.last_name" ng-change="vm.steps.additional_contacts.checkRequiredFields()"></div></div><div class="flex-column input-container"><div class="input-title">Title</div><input class="input" placeholder="Title" ng-model="vm.steps.additional_contacts.contact.title"></div><div class="flex-column input-container"><div class="input-title">Email Address</div><input class="input" type="email" placeholder="Email Address" ng-model="vm.steps.additional_contacts.contact.email_address" ng-change="vm.steps.additional_contacts.checkRequiredFields()"></div><div class="flex-column input-container"><div class="input-title">Direct Phone</div><input type="tel" class="input" placeholder="Phone number" ng-model="vm.steps.additional_contacts.contact.direct_phone" pattern="[0-9\\(\\)+\\s\\-]*"></div><div class="flex-row" style="padding-left: 12px; margin-top: 26px"><div style="position: relative"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.additional_contacts.contact.receive_reports" class="public-view-item-checkbox" style="display: inline-block" type="checkbox" disabled="disabled"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span class="generic-popover-trigger" style="margin-left: 16px">Reports</span><div class="generic-popover">Access to <strong>Reports</strong> includes you in automated emails regarding received samples and final reports.</div></div><div style="margin-left: 36px" style="position: relative"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.additional_contacts.contact.receive_invoices" class="public-view-item-checkbox" style="display: inline-block" type="checkbox" disabled="disabled"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span class="generic-popover-trigger" style="margin-left: 16px">Invoices</span><div class="generic-popover">Access to <strong>Invoices</strong> includes you in automated emails regarding quotations and invoices.</div></div><div style="margin-left: 36px" style="position: relative"><label style="display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.additional_contacts.contact.is_admin" class="public-view-item-checkbox" style="display: inline-block" type="checkbox" disabled="disabled"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span class="text-color-complete generic-popover-trigger" style="margin-left: 16px; font-family: OpenSans-Semibold">Admin</span><div class="generic-popover">Designating a contact as an <strong>Admin</strong> gives them the ability to add and remove other users to a customer account.</div></div></div><div style="margin-top: 32px; color: #2D9CDB; font-family: OpenSans-Semibold"><a ng-click="vm.steps.additional_contacts.addContact()" ng-disabled="!vm.steps.additional_contacts.enable_add_contact" ng-class="{ \'blue-a-tag\': vm.steps.additional_contacts.enable_add_contact, \'gray-a-tag no-pointer-events\': !vm.steps.additional_contacts.enable_add_contact }">Add contact</a></div><div class="flex-column" style="margin-top: 16px"><div class="flex-row contact-row" ng-repeat="contact in vm.steps.additional_contacts.contacts"><div class="flex-column" style="justify-content: space-between"><div class="flex-row" style="font-family: OpenSans-Semibold; white-space: nowrap">{{ contact.first_name ? contact.first_name : \'\' }}&nbsp;{{ contact.last_name ? contact.last_name : \'\' }}</div><div class="flex-row" style="color: #8795a1; font-family: OpenSans-Light; white-space: nowrap; font-size: 12px">{{ contact.title ? contact.title : \'\' }}</div></div><div class="flex-row" style="width: 86px"><span ng-click="vm.steps.additional_contacts.editContact($index)" class="edit-icon" style="height: 14px"></span> <span ng-click="vm.steps.additional_contacts.deleteContact($index)" class="trash-icon" style="margin-left: 8px; height: 14px; width: 18px"></span></div></div></div></div></div><div ng-show="!vm.loading_quotation && !vm.error_message && vm.current_step.current == \'billing_info\'"><div class="step-header">{{ vm.steps.billing_info.title }}</div><div class="step-description">{{ vm.steps.billing_info.description }}</div><div class="flex-column" style="width: 100%; margin-top: 32px"><div class="input-title">Account Representative</div><div class="select-container" style="position: relative"><select class="input-dropdown placeholder" ng-model="vm.steps.company_info.selected_primary_rep" ng-change="vm.steps.billing_info.checkRequiredFields()" ng-options="rep as rep.name for rep in vm.steps.company_info.primary_rep_list" ng-class="{ \'required-input\' : !vm.steps.company_info.selected_primary_rep }"><option value="" selected="selected" disabled="disabled">{{\'Select\' | translate}}</option></select></div><div class="input-title" style="margin-top: 14px">Representative Email</div><div class="input-dropdown placeholder" ng-class="{ \'input-not-selected-yet\' : !vm.steps.company_info.selected_primary_rep.email }" style="position: relative"><span class="input-selected-additional-info">{{vm.steps.company_info.selected_primary_rep.email ? vm.steps.company_info.selected_primary_rep.email : \'Select Representative\'}}</span></div><div class="input-title" style="margin-top: 14px">Primary Support Phone</div><div class="input-dropdown placeholder" ng-class="{ \'input-not-selected-yet\' : !vm.steps.company_info.selected_primary_rep.phone }" style="position: relative"><span class="input-selected-additional-info">{{vm.steps.company_info.selected_primary_rep.phone ? vm.steps.company_info.selected_primary_rep.phone : \'Select Representative\'}}</span></div><div class="input-title" style="margin-top: 14px">What is your preferred method of payment?*</div><div class="select-container" style="position: relative"><select class="input-dropdown placeholder" ng-model="vm.steps.billing_info.selected_payment_method" ng-change="vm.steps.billing_info.checkRequiredFields()" ng-options="method as method.display for method in vm.steps.billing_info.payment_methods" ng-class="{ \'required-input\' : !vm.steps.billing_info.selected_payment_method }"><option value="" selected="selected" disabled="disabled">{{\'Select\' | translate}}</option></select><div style="position: absolute; right: 16px; top: 17px"><svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.578201 0.292941C0.391394 0.481833 0.286621 0.736777 0.286621 1.00244C0.286621 1.2681 0.391394 1.52305 0.578201 1.71194L3.5172 4.67694C3.7352 4.89194 4.0172 4.99894 4.2962 4.99894C4.5752 4.99894 4.8522 4.89194 5.0652 4.67694L7.9952 1.72194C8.18177 1.53292 8.28638 1.27803 8.28638 1.01244C8.28638 0.746856 8.18177 0.49196 7.9952 0.302941C7.90337 0.209757 7.79393 0.135759 7.67324 0.0852509C7.55255 0.0347429 7.42303 0.0087328 7.2922 0.0087328C7.16137 0.0087328 7.03185 0.0347429 6.91116 0.0852509C6.79047 0.135759 6.68103 0.209757 6.5892 0.302941L4.2912 2.61994L1.9842 0.292941C1.89216 0.20012 1.78266 0.126444 1.662 0.0761652C1.54134 0.0258864 1.41192 0 1.2812 0C1.15049 0 1.02106 0.0258864 0.900405 0.0761652C0.779746 0.126444 0.670238 0.20012 0.578201 0.292941Z" fill="#42526E"/></svg></div></div><div ng-show="vm.steps.billing_info.selected_payment_method.id == \'credit_card\'"><div class="flex-column input-container"><div class="input-title">Card Details</div><div id="card-container" ng-show="!vm.steps.billing_info.square_info.nonce" style="margin-top: 8px; min-height: 48px"></div><div ng-show="vm.steps.billing_info.square_info.nonce == null"><button id="card-button" class="payment-methods-nav-btn payment-methods-gray-btn" style="float: right; margin-top: 16px">Add Card</button></div><div ng-show="vm.steps.billing_info.square_info.nonce != null" style="margin-top: 8px">Your card has been added.</div></div><div style="display: none"><div class="flex-column input-container"><div class="input-title">Card Number*</div><input class="input" id="sq-card-number" placeholder="Card Number" ng-model="vm.steps.billing_info.square_info.cardholder_name"></div><div class="flex-column input-container"><div class="input-title">Name on Card*</div><input class="input" placeholder="Name on Card" ng-model="vm.steps.billing_info.square_info.cardholder_name"></div><div class="flex-row input-container"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">Expiration Date*</div><input class="input" id="sq-expiration-date" placeholder="Expiration Date"></div><div class="flex-column" style="width: 100%"><div class="input-title">CVV*</div><input class="input" id="sq-cvv" placeholder="CVV"></div></div><div class="flex-row input-container"><div class="flex-column" style="margin-right: 24px; width: 100%"><div class="input-title">Zip Code</div><input class="input" id="sq-zip-code" placeholder="Zip Code"></div><div class="flex-column" style="width: 100%"><div class="input-title">Country</div><input class="input" placeholder="Country"></div></div></div></div><div ng-show="vm.steps.billing_info.selected_payment_method.id == \'cash\'"><div style="margin-top: 24px">Please include with your sample(s) upon submission.</div></div><div ng-show="vm.steps.billing_info.selected_payment_method.id == \'check\'"><div style="margin-top: 24px">Please make payable to {{brand.legal.company_name}} and include with your sample(s) upon submission.</div></div><div ng-show="vm.steps.billing_info.selected_payment_method.id == \'wire_transfer\'"><div ng-if="vm.steps.billing_info.wire_transfer_title" class="step-description" style="margin-top: 24px; font-family: OpenSans-Semibold">{{ vm.steps.billing_info.wire_transfer_title }}</div><div class="wire-transfer-intro" style="margin-top: 16px">{{ vm.steps.billing_info.wire_transfer_intro }}</div><div ng-if="vm.steps.billing_info.wire_transfer_sections.length"><div ng-repeat="section in vm.steps.billing_info.wire_transfer_sections"><div class="wire-transfer-section-title">{{ section.title }}</div><div class="flex-column" style="border-radius: 6px; background-color: #fff"><div ng-repeat="row in section.rows" ng-class="{ \'hide-border-bottom\' : $last }" class="flex-row wire-transfer-row"><span class="wire-transfer-left">{{ row.left }}</span> <span class="wire-transfer-right"><span>{{ row.right }}</span> <span ng-if="row.detail" class="wire-transfer-detail">{{ row.detail }}</span></span></div></div></div></div><div ng-if="!vm.steps.billing_info.wire_transfer_sections.length" class="flex-column" style="margin-top: 16px; border-radius: 6px; background-color: #fff"><div ng-repeat="row in vm.steps.billing_info.wire_transfer_info" ng-class="{ \'hide-border-bottom\' : $last }" class="flex-row wire-transfer-row"><span class="wire-transfer-left">{{ row.left }}</span> <span class="wire-transfer-right"><span>{{ row.right }}</span> <span ng-if="row.detail" class="wire-transfer-detail">{{ row.detail }}</span></span></div></div><div ng-if="vm.steps.billing_info.wire_transfer_remittance"><div class="wire-transfer-section-title">{{ vm.steps.billing_info.wire_transfer_remittance.title }}</div><div class="wire-transfer-intro">{{ vm.steps.billing_info.wire_transfer_remittance.intro }}</div><div class="flex-column" style="margin-top: 8px; border-radius: 6px; background-color: #fff"><div ng-repeat="row in vm.steps.billing_info.wire_transfer_remittance.rows" ng-class="{ \'hide-border-bottom\' : $last }" class="flex-row wire-transfer-row"><span class="wire-transfer-left">{{ row.left }}</span> <span class="wire-transfer-right">{{ row.right }}</span></div></div></div><div ng-if="!vm.steps.billing_info.wire_transfer_remittance" style="margin-top: 24px">After completing a transfer, please email remittance documentation with your Order Number to <span style="font-family: OpenSans-Semibold">{{brand.contact.billing_email}}</span></div><div ng-repeat="note in vm.steps.billing_info.wire_transfer_notes" style="margin-top: 8px">{{ note }}</div></div><div class="flex-column input-container" style="margin-bottom: 14px"><div class="input-title">Invoicing Notes/Referral Code</div><input class="input" type="text" placeholder="Invoicing Notes/Referral Code" ng-model="vm.steps.billing_info.invoicing_notes" ng-change="vm.steps.billing_info.checkRequiredFields()"></div></div></div><div ng-show="!vm.loading_quotation && !vm.error_message && vm.current_step.current == \'terms_and_conditions\'"><div class="step-header">{{ vm.steps.terms_and_conditions.title }}</div><div class="step-description">{{ vm.steps.terms_and_conditions.description }}</div><div id="t_and_c" class="rdCustomScrollBarHorizontal" style="padding: 16px; background-color: #fff; max-height: 500px; overflow-y: scroll"><div ng-if="brand.key != \'njlabs\'"><strong>1. Agreement.</strong><br>The following Terms and Conditions constitute a legal agreement (\u201CAgreement\u201D) between {{ brand.legal.company_name }} (\u201C{{ brand.branding.display_name }}\u201D) and you and the company you represent (\u201Cyou\u201D or \u201Cyour\u201D) that apply to the use of {{ brand.legal.company_name }} services ("Services") and client portal ("Portal"). These Terms and Conditions supersede any previous conversations or written memoranda between {{ brand.branding.display_name }} and you. Any commitment by {{ brand.branding.display_name }} representatives or agents is only valid if accompanied by a written, signed confirmation by {{ brand.branding.display_name }} on {{ brand.branding.display_name }} letterhead. No contract exists in the absence of such documentation. By accepting this Agreement, you agree to be bound by the terms of this Agreement and understand that the Agreement is legally binding and the equivalent of a signed, written contract. If you do not agree to all the terms of this Agreement, you must not accept this Agreement and may not employ our Services or Portal. We may amend this Agreement at any time by posting amended terms on the Portal and/or sending a notification email to the primary account holder. Amended terms shall be effective upon the date of posting, or such later date specified therein, and shall apply to your use of our Services and Portal. We may add, delete, modify, alter, substitute or discontinue our Services or Portal, in whole or part, in our sole discretion at any time.<br><br><strong>2. Payment Policy.</strong><br>Payment terms are negotiated on a case-by-case basis. For first-time or inactive clients, we require prepayment at time of submission prior to releasing results. Please be advised that any and all discounts are only valid if all invoices are paid in full by the invoice due date. After this time, all discounts will be nullified and our regular service fees will apply. Discounts are subject to change at any time at the discretion of {{ brand.legal.company_name }} or in the case of a signed quotation, upon the end of the quotation validity period. If no validity period is indicated, the default validity period will be 1 year. A late charge of 1.5% per month late charge may be added to all unpaid balances. Delinquent accounts may be served on a C.O.D. basis. Accounts delinquent 90 days or more will be scheduled for collection.<br><br><strong>3. Prices.</strong><br>It is the client\u2019s responsibility to confirm pricing before services are started. Shipping charges are not included and will be added to the cost of services.<br><br><strong>4. Sample Submissions.</strong><br>A client order will only be valid when submitted with a {{ brand.branding.display_name }} submission form or signed written documentation (\u201CWritten Documentation\u201D) that includes contact information, sample description/s, requested analysis/es, requested turnaround time/s, and special instructions. Orders that arrive without the appropriate Written Documentation will be charged a $10 fee. In the absence of Written Documentation, {{ brand.legal.company_name }} is not responsible for the selection of the test procedures used for the affected samples and you assume all responsibility. Each client order is a new contract and not subject to the same commercial considerations of any previous contracts. In the absence of a signed quotation, these considerations include, but are not limited to, price and turnaround time. {{ brand.legal.company_name }} reserves the right to amend any information provided in {{ brand.branding.display_name }} advertising, price lists, website, or other written or digital materials at any time. Such material in no way commits {{ brand.legal.company_name }}.<br><br><strong>5. Turnaround Time.</strong><br>If a sample is received prior to 10:30AM, the same day acts as day 1 of the turnaround time. If a sample is received after 10:30AM, the next day acts as day 1 of the turnaround time. The receiving date and time is established when Written Documentation is provided containing all required information to log-in a given sample. {{ brand.branding.display_name }} turnaround times are meant to serve as a generic guide for routine sample analysis. Clients should recognize that certain conditions can impact sample turnaround time, e.g., excessive sample backlog, complexity of testing, personnel changes, equipment failure, etc. {{ brand.branding.display_name }} is not responsible for adhering to turnaround times. Any loss suffered by you or any third party due to delay in reporting test results is not the responsibility of {{ brand.branding.display_name }}.<br><br><strong>6. Receipt and Storage of Samples.</strong><br>Analytical samples are stored frozen, refrigerated or at room temperature upon receipt. Storage conditions are based on instructions supplied by the client or the nature of the sample matrix. Non-perishable samples will be retained for a minimum of 30 days after reporting results. Perishable samples will be retained for a minimum of 5 business days. If your sample needs to be retained for a period longer than the above examples, please contact your customer service representative. Storage fees may apply for long-term stability studies. Hazardous material samples may be accepted for analysis under the condition that they can be returned to you. A return fee or disposal charge may be added to the analysis fee.<br><br><strong>7. Limitation of Liability.</strong><br>{{ brand.legal.company_name }} shall not be liable for any loss or damage arising from our results. {{ brand.branding.display_name }} liability for any failure in our analytical work (quality, timelines, etc.) is the amount charged by {{ brand.branding.display_name }} for the work.<br><br><strong>8. Records Retention</strong><br>Reports, records and laboratory notebooks will be held for no less than 5 years from the time the data was generated. The 5-year holding time for records applies in general to all regular sample related records. For cGMP analyses, the record retention requirements are no less than 5 years from the time the data was generated or are based on the expiration date and/or distribution dates of the product.<br><br><strong>9. Confidentiality.</strong><br>All results, information, and reports are strictly confidential and the property of the client contracting the services of {{ brand.legal.company_name }}. No results, information, or reports will be released to a third party without your permission unless obliged by law. Access at {{ brand.branding.display_name }} is limited to authorized personnel and strict confidentiality is maintained in all interactions with clients. Mutual non-disclosure agreements are executed upon request.<br><br><strong>10. Subcontracting.</strong><br>{{ brand.legal.company_name }} evaluates its capabilities, resources, and capacity before work is accepted for testing. At times, when {{ brand.branding.display_name }} sees fit and necessary, it may outsource a portion of or the entire analysis requested by a client. In such an event, {{ brand.branding.display_name }} will maintain its responsibility for the quality of a subcontractor\u2019s work. For analyses within its scope of accreditation, {{ brand.branding.display_name }} will select from its approved list of subcontractors, which are labs accredited for ISO/IEC 17025:2005 or otherwise deemed be competent to perform such work.<br><br><strong>11. Eligibility.</strong><br>{{ brand.legal.company_name }} reserves the right to refuse use of our Services and access to our Portal to anyone or any entity at any time, at our sole discretion. {{ brand.branding.display_name }} holds no responsibility to independently verify any person\u2019s authority to access client data on the Portal.<br><br><strong>12. Limited Use License.</strong><br>We hereby grant you a limited, revocable, nontransferable, nonexclusive license to access the Portal solely for your internal use for purposes of accessing and reviewing the status and results of sample submissions and analytical services that have been ordered from us by or on behalf of our client who has granted you authority to access this Portal and use the Services on its behalf (the \u201CClient Data\u201D). Without limiting the foregoing or expanding any of your rights hereunder, you agree that you will not disclose, republish, reproduce, or distribute any of the information, data (other than Client Data), materials or other content accessed on or through the Portal (the \u201CContent\u201D) or make any use of the Content that would allow a third party to have access to the Content. You may not (a) copy the Services or any software or programming related thereto, (b) permit other individuals or companies to use the Services, (c) modify, translate, reverse engineer, decompile, disassemble or create derivative works based upon the Services or any software or programming related thereto (d) rent, lease, transfer, resell and/or or otherwise transfer rights to the Services, or (e) delete or write over any portion of any software relating in any manner to the Services. You also agree that you shall only use the Services in a manner that complies with all applicable laws in the jurisdictions in which you use the Services, and that you shall not violate or infringe the rights of any third party.<br><br><strong>13. Password and Security.</strong><br>You are solely responsible for maintaining the confidentiality of any user name and password that you obtain during the onboarding process and are fully responsible for all activities that occur under your password or account. We will assume that anyone using your user name and password is you. You agree to (a) immediately notify us of any unauthorized use of your password or account or any other breach of security, and (b) ensure that you exit from your account at the end of each session. We cannot and will not be liable for any loss or damage arising from your failure to comply with this provision.<br><br><strong>14. Site Integrity and Limits on Access.</strong><br>We do not guarantee continuous, uninterrupted or secure access to or use of the Portal or our Service, and access to and use of the Portal or the Services may be subject to interference from numerous factors outside of our reasonable control. You agree not to use any device, software or routine to interfere or attempt to interfere with the proper working of the Portal, the Services or any of our other computer systems. You may not take any action that imposes an unreasonable or disproportionately large load on our infrastructure. You may not disclose or share your password to any third parties or use your password for any unauthorized purpose. Except as otherwise expressly permitted by us, any access or attempt to access other areas of our computer systems or other information contained on our systems for any purposes is strictly prohibited, and you may not access data of which you are not an intended recipient or log into a server or account that you are not expressly authorized to access. You will not interfere with or disrupt the Services or servers or networks connected to the Services. You agree that you will not use any robot, spider, other automatic device, or manual process to \u201Cscreen scrape,\u201D monitor, \u201Cmine,\u201D \u201Cmirror\u201D or copy the Site or any Content or Client Data.<br><br><strong>15. Data Security.</strong><br>The Site uses Secure Sockets Layer encryption (or other reasonable technical security safeguards) in the transmission of sensitive information. We maintain a secured area on the Site for transmission of registration information, test sample information and analytical data and store this data in a private database. Because encryption slows down the response time of Web pages, some areas of the Site are not secured. Nevertheless, we endeavor to ensure that all pages transmitting financial information are encrypted. Please inform us immediately if any such page is not encrypted. Please refer to your browser\u2019s online help for further information on determining whether a specific page you are viewing is encrypted. We utilize reasonable technical security measures such as firewalls, passwords and other mechanisms on our computer systems housing all registration and financial data.<br><br><strong>16. Intellectual Property.</strong><br>The Portal is proprietary to us and our licensors and are protected by applicable patent, copyright, trademark, trade secret and other intellectual property right laws, and we and our licensors retain sole ownership thereof. Nothing in this Agreement shall confer any right of ownership of any of such intellectual property to you, and any use of the foregoing that is not specifically and expressly permitted in this Agreement is prohibited. You will abide by any and all additional intellectual property notices, information, or restrictions contained on the Portal or through our Services.<br><br><strong>17. Disclaimer of Warranty.</strong><br>The Portal and the Services and Content, including all software, functions, materials, and information, is provided \u201CAs-Is\u201D without warranties of any kind, either express or implied. We disclaim all warranties, express or implied, including, but not limited to, warranties of quiet enjoyment and non-infringement and implied warranties of merchantability, fitness for a particular purpose, non-infringement, title, data accuracy, system integration, and informational content. We do not warrant or make any representations regarding the access to, use of or operation of the Portal or the Services or the use, validity, accuracy or reliability of, or the results of the use of the content on the Portal or any other sites linked to the Portal. The content may be out of date, and we make no commitment to update the content on the Portal. We do not and cannot guarantee or warrant that the files available for downloading from this Portal and the Services, if any, will be free from infection, viruses, worms, trojan horses, or other code that manifest contaminating or destructive properties. We do not warrant that the Portal, the Services or the Content will be uninterrupted or error-free or that any defects in the Portal, the Services, or the Content will be corrected.<br><br><strong>18. Additional Limitation of Liability.</strong><br>In no event will we, our suppliers, licensors or other third parties, be liable for any damages, including, without limitation, direct, indirect, special, incidental, or consequential damages, damages resulting from lost profits, lost data or business interruption arising or relating to the use, inability to use, or resulting from the use of the Portal, the Services, the Content, any sites linked to the Portal, or the materials, software or other information contained in any or all such sites, whether based on warranty, contracts, statutes, regulations, tort, (including but not limited to, negligence) or any other legal theory and whether or not advised of the possibility of such damages. If your use of the Portal, the Services or the Content results in the need for servicing, repair or correction of equipment or data, you assume all costs thereof.<br><br><strong>19. Indemnification.</strong><br>You shall defend, indemnify and hold harmless us, our affiliates and subsidiaries, and their respective directors, officers, employees, agents, shareholders, co-branders, partners, successors and assigns (collectively, \u201CIndemnified Parties\u201D), from and against any claim, loss, damage, liabilities and judgments, and fees and expenses related thereto (including, without limitation, reasonable attorney\u2019s fees) incurred by any of the Indemnified Parties arising from or related to: (a) your use of the Portal or the Service or any Content or Client Data, (b) any breach or violation of this Agreement by you, including without limitation, any breach of any of your representations, warranties and covenants herein, or (c) the violation of any rights of another resulting from or relating to your use of the Site, the Service, the Content or the Client Data.<br><br><strong>20. Assignment.</strong><br>This Agreement may not be assigned or otherwise transferred by you without our express written consent.<br><br><strong>21. Applicable Law and Jurisdiction.</strong><br>THIS AGREEMENT SHALL BE GOVERNED BY AND CONSTRUED IN ACCORDANCE WITH THE LAWS OF THE STATE OF CALIFORNIA, WITHOUT REGARD TO CONFLICT OF LAWS PROVISIONS. SOLE AND EXCLUSIVE JURISDICTION FOR ANY ACTION OR PROCEEDING ARISING OUT OF OR RELATED TO THIS AGREEMENT SHALL BE IN THE COURTS OF THE STATE OF CALIFORNIA. You agree that any cause of action you may have with respect to your use of our Services or Portal must be commenced within one (1) year after the claim or cause of action arises.<br><br><strong>22. No Waiver.</strong><br>No act, delay or omission on our part will be deemed a waiver unless expressly made in writing.<br><br><strong>23. Severability.</strong><br>If for any reason a court of competent jurisdiction finds any provision of this Agreement, or portion thereof, to be unenforceable, that provision shall be enforced to the maximum extent permissible so as to effect the intent of this Agreement. The remainder of this Agreement shall be valid and enforceable to the maximum extent possible.</div><div ng-if="brand.key == \'njlabs\'"><strong>Client Onboarding &amp; Services Agreement</strong><br>Includes: Non-Disclosure Agreement &bull; Quality Agreement &bull; Terms &amp; Conditions &bull; Payment Terms<br><br><strong>About Anresco NJ Labs (ANJL).</strong><br>A comprehensive analytical testing laboratory and division of Anresco NJ Labs Group, with 85+ years of combined expertise. We test supplements, cosmetics, foods, pharma/biotech, and consumer products people use every day.<br><br><strong>Testing Network.</strong><br>Services may be performed at ANJL or in collaboration with our partner laboratories. Clients will be notified of applicable testing location(s).<ul><li>Anresco NJ Labs New Brunswick &mdash; 1110 Somerset St, New Brunswick, NJ 08901 | njlabs.com</li><li>Anresco Laboratories (HQ) &mdash; 1375 Van Dyke Ave, San Francisco, CA 94124 | anresco.com</li><li>Anresco NJ Labs West &mdash; 5400 Jillson St, City of Commerce, CA 90040 | anresco.com</li></ul><br><strong>Section I: Non-Disclosure &amp; Confidentiality Agreement</strong><br><br><strong>Confidentiality Obligations</strong><br>ANJL will use all Client Information solely to provide Services and will keep it strictly confidential. These obligations extend to all partner laboratory locations. ANJL will not disclose the existence of this Agreement, that Services are being performed for Client, or any Client information or communications &mdash; except as required by law, in which case ANJL will provide prompt written notice.<br><br><strong>Exclusions</strong><br>Confidentiality obligations do not apply to information that is publicly available, disclosed by a non-bound third party, independently developed by ANJL, or becomes public through no breach by ANJL.<br><br><strong>General Terms</strong><br>No provision may be waived or amended except by written consent of both parties. This Agreement is governed by New Jersey law. All disputes shall be resolved in Middlesex County courts or the U.S. District Court for the District of New Jersey. Each party warrants it has authority to enter into and be bound by this Agreement.<br><br><strong>Section II: Quality Agreement</strong><br><br><strong>Standards</strong><br>All Services will be performed in compliance with cGMP guidelines, AOAC International methods, USP compendial methods, ISO/IEC 17025 standards (accreditation in progress), applicable FDA regulations, and ICH guidelines for method validation where applicable.<br><br><strong>ANJL Responsibilities</strong><ul><li>Maintain a documented Quality Management System (QMS) across all testing activities.</li><li>Ensure analysts are trained and qualified for assigned testing procedures.</li><li>Use validated or verified methods appropriate to each sample type.</li><li>Maintain calibrated and qualified instrumentation with documented records.</li><li>Investigate and document any Out-of-Specification (OOS) or Out-of-Trend (OOT) results and communicate findings to Client.</li><li>Retain all test records for a minimum of seven (7) years.</li><li>Notify Client promptly of quality events that may impact testing results.</li><li>Schedule client audits with a minimum of two (2) months\' written notice; agenda required two weeks prior.</li></ul><strong>Client Responsibilities</strong><ul><li>Provide accurate and complete information on the Sample Submission Form (SSF).</li><li>Submit samples in appropriate containers with proper labeling and condition.</li><li>Communicate applicable specifications, methods, or regulatory requirements at submission.</li><li>Disclose any known hazards associated with submitted samples.</li><li>Respond to ANJL inquiries in a timely manner.</li></ul><strong>Partner Laboratory Quality Oversight</strong><br>Where testing is performed at partner labs (Anresco NJ Labs New Brunswick, Anresco SF, or Anresco NJ Labs West), ANJL will ensure equivalent quality standards are maintained, oversee all outsourced testing, notify Client of partner lab involvement, and ensure final reports reflect all testing regardless of location.<br><br><strong>Section III: Payment Terms</strong><br><br><strong>Credit Card on File (Required for All Clients)</strong><br>All clients are required to maintain a valid credit card on file via the ANJL Client Portal (portal.anresconjlabs.com). Log in &rarr; Account Settings &rarr; Payment Methods. Cards are stored securely and charged only upon invoice. A 3% processing fee applies to all credit card payments. ACH/check payments are not subject to this fee.<br><br><strong>Payment Schedule</strong><ul><li><strong>New Clients:</strong> Full payment required before testing begins for the first three (3) months. Net 30 terms apply thereafter upon satisfactory payment history.</li><li><strong>Current Clients:</strong> Net 30 terms. Include PO number on SSF if required.</li><li><strong>Late Payments:</strong> Invoices outstanding beyond 30 days accrue 1.5% monthly interest. ANJL reserves the right to suspend services and withhold reports for overdue accounts.</li><li><strong>Cancellations:</strong> $100 fee per sample canceled after logging. Tests started or completed will be invoiced in full plus the cancellation fee.</li><li><strong>Billing Address:</strong> Anresco NJ Labs, 201 Blackford Ave, Middlesex, NJ 08846.</li></ul><strong>Section IV: Terms &amp; Conditions of Service</strong><br><br><strong>Conduct of Services</strong><br>ANJL will perform all testing and reports in compliance with industry standards, applicable laws, and regulatory guidelines under cGMP conditions. Partner laboratories are held to the same standards.<br><br><strong>Key Terms</strong><ul><li><strong>Sample Disposal:</strong> Remaining materials discarded 30 days after testing. Hazardous/controlled disposal fees invoiced to Client.</li><li><strong>Works for Hire:</strong> All deliverables are Client\'s sole property. ANJL irrevocably assigns all rights, titles, and interests including patents and copyrights to Client.</li><li><strong>Records Retention:</strong> Test records retained for 7 years. Raw data requests subject to $100 admin fee per analysis.</li><li><strong>Subcontracting:</strong> No outsourcing outside the Anresco NJ Labs Group network without Client\'s prior written consent.</li><li><strong>ANJL IP:</strong> Pre-existing materials and independently developed tools remain ANJL\'s sole property.</li><li><strong>Warranties:</strong> Services performed with reasonable skill and care. Breach remedies include repair/re-performance or refund by mutual agreement.</li><li><strong>Indemnification:</strong> Each party indemnifies the other against third-party claims from negligence, misconduct, breach of warranties, or personal injury/property damage.</li><li><strong>Insurance:</strong> Each party maintains its own liability and professional insurance. ANJL workers\' comp does not cover Client employees.</li><li><strong>Termination:</strong> 30 days\' written notice for cause. Client may terminate anytime but owes payment for all work completed or in progress.</li><li><strong>Governing Law:</strong> New Jersey law. Disputes resolved exclusively in NJ courts (Middlesex County or U.S. District Court, District of NJ).</li><li><strong>Force Majeure:</strong> ANJL not liable for delays caused by events beyond its reasonable control.</li><li><strong>Limitation of Liability:</strong> Capped at 2x total fees paid in preceding 12 months. No indirect/consequential damages except for willful misconduct or confidentiality breaches.</li><li><strong>Personnel:</strong> No ANJL personnel are FDA-debarred under the Generic Drug Enforcement Act.</li><li><strong>Entire Agreement:</strong> This document supersedes all prior communications and constitutes the complete agreement between parties.</li></ul><strong>Authorization &amp; Signatures</strong><br>By signing below, both parties agree to all terms in this Client Onboarding &amp; Services Agreement, including the NDA, Quality Agreement, Payment Terms, and Terms &amp; Conditions.</div></div><div id="read_terms" style="padding-top: 16px" class="disabled-signup"><label style="margin-left: 12px; display: inline-block" class="checkboxContainer"><input ng-model="vm.steps.terms_and_conditions.agree_terms" ng-checked="vm.steps.terms_and_conditions.agree_terms" ng-change="vm.steps.terms_and_conditions.checkRequiredFields()" class="public-view-item-checkbox" style="display: inline-block" type="checkbox" ng-class="{ \'required-input\' : !vm.steps.terms_and_conditions.agree_terms }"> <span style="display: inline-block; margin-top: -9px; margin-left: -11px" class="checkmark"></span></label><span style="margin-left: 10px">I have read and agree with the terms and conditions.</span> <input ng-model="vm.steps.terms_and_conditions.signed_by" ng-change="vm.steps.terms_and_conditions.checkRequiredFields()" class="input" placeholder="Full Name"></div></div></div><div class="bottom-nav"><button ng-show="vm.current_step.show_prev" ng-click="vm.nav.prev($event)" class="signup-btn btn-white">Previous</button> <button ng-show="vm.current_step.show_next" ng-click="vm.nav.next($event)" ng-class="{ \'btn-blue\' : vm.current_step.next_active, \'btn-blue-disabled\' : !vm.current_step.next_active }" class="signup-btn" ng-disabled="!vm.current_step.next_active" style="margin-left: 16px">Next</button> <button ng-show="vm.current_step.current == \'terms_and_conditions\'" ng-click="vm.steps.submitAll()" class="signup-btn" ng-class="{ \'btn-blue\' : vm.steps.terms_and_conditions.submit_active && !vm.submitting, \'btn-blue-disabled\' : !vm.steps.terms_and_conditions.submit_active || vm.submitting }" style="margin-left: 16px"><span ng-show="!vm.submitting">Submit</span> <span ng-show="vm.submitting">Submitting&nbsp;<i class="fa fa-spinner fa-spin"></i></span></button></div></div></div></div></div></div>');
$templateCache.put('app/pages/signup/signup.success.html','<style>#main-page {\n        display: flex; \n        justify-content: center; \n        align-items: center;\n        height: 100vh;\n        background-color: #3d5269;\n    }\n\n    #center-box {\n        height: 583px;\n        width: 806px;\n        border-radius: 6px;\n        background-color: white;\n        display: flex;\n        flex-direction: column;\n        padding: 72px 106px 0px 106px;\n        align-items: center\n    }\n\n    div {\n        color: #3d5269;\n    }\n\n    .signup-success-brand-logo {\n        display: block;\n        width: 160px;\n        max-width: 100%;\n        height: auto;\n    }</style><div id="main-page"><div id="center-box"><div><svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M104 43.3984V103.805H0.0214482L37.8521 70.7845L0 43.3984L52.0001 0.19519L104 43.3984Z" fill="#91AFCF"/><path d="M9.5271 10.3997H93.9296V75.9197H9.5271V10.3997Z" fill="#EEEFEE"/><path d="M16.2163 17.0568H52.4286V19.2598H16.2163V17.0568Z" fill="#DBD8DD"/><path d="M16.2163 28.0842H60.7703V30.2873H16.2163V28.0842Z" fill="#DBD8DD"/><path d="M67.9211 28.0842H87.2399V30.2873H67.9211V28.0842Z" fill="#DBD8DD"/><path d="M16.2163 39.1108H32.9832V41.3139H16.2163V39.1108Z" fill="#DBD8DD"/><path d="M38.0205 39.1108H87.2392V41.3139H38.0205V39.1108Z" fill="#DBD8DD"/><path d="M16.2163 50.1392H51.3455V52.3422H16.2163V50.1392Z" fill="#DBD8DD"/><path d="M57.6831 50.1392H87.2394V52.3422H57.6831V50.1392Z" fill="#DBD8DD"/><path d="M87.2393 61.1666V63.3697H16.2163V61.1666" fill="#DBD8DD"/><path d="M66.1482 70.7841L103.979 103.804H104V43.3979L66.1482 70.7841Z" fill="#647F9C"/><path d="M37.8521 70.7841L0.0214482 103.804H0V43.3979L37.8521 70.7841Z" fill="#647F9C"/><path d="M103.979 103.804H0.0214844L37.8522 70.7842H66.1479L103.979 103.804Z" fill="#91AFCF"/><g filter="url(#filter0_ddd)"><circle cx="52" cy="36" r="20" fill="#27AE60"/></g><path d="M42.4689 37.154C41.04 35.4955 43.2006 32.9597 44.6293 34.6182L49.0149 39.686L58.5603 28.5454C59.9892 26.8776 62.1616 29.4131 60.7327 31.0809L50.1065 43.4763C49.5098 44.173 48.542 44.175 47.9431 43.4798L42.4689 37.154Z" fill="white"/><defs><filter id="filter0_ddd" x="24" y="12" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="0.5"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/><feBlend mode="normal" in2="effect2_dropShadow" result="effect3_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow" result="shape"/></filter></defs></svg></div><div style="font-size: 40px; margin-top: 40px; font-family: OpenSans-Semibold">Welcome!</div><div style="margin-top: 24px; text-align: center"><div>Thanks for onboarding with {{brand.legal.company_name}}! You are now free to make your first submission.</div><br><div>To activate your personal portal account, please look out for a verification email. Once confirmed, you will be able to access the portal where you can submit orders, view results, check order status, download reports, view invoices, manage your account, and more.</div><br><div>If you have any questions or concerns contact your customer service representative or email <a ng-href="mailto:{{brand.contact.info_email}}">{{brand.contact.info_email}}</a>.</div></div><div style="margin-top: 60px"><img src="/content/brand/logo.png" alt="portal logo" class="signup-success-brand-logo"></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="logo-shadow login-box"><div class="background-logo-img"></div><div class="signinbox signinbox-center"><div class="logo" align="center"><div class="topbuffer5"></div><img src="/content/brand/logo.png" alt="portal logo" class="auth-brand-logo"><div class="topbuffer6"></div></div><div class="sign-in-box"><div class="header header-radius"><div align="center"><div align="center"><p ng-show="vm.authenticationError" class="signup-title-reset">Please check your credentials and try again.</p><p ng-show="vm.errorEmailNotExists" class="signup-title-reset">E-mail address not exists.</p><p ng-hide="vm.success" class="signup-title-reset">Enter the e-mail address you used to register.</p><p ng-hide="!vm.success" class="signup-title-reset">Check your e-mails for details on how to reset your password.</p></div></div></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="tab-content tabback singuptable tabbackall6 box-bg-color"><div class="companyinfo"><label class="form-label">Email</label><div class="Username2"><input type="email" class="form-control rrp-input" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary rrp-btn pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2" style="margin-top: 26px">Send</button></div><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div></div></form></div></div><div class="topbuffer5"></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div class="logo-shadow"><!-- <div class="background-logo-img"></div> --><div class="signinbox"><div class="logo" align="center"><div class="topbuffer5"></div><img src="/content/brand/logo.png" alt="portal logo" class="auth-brand-logo"><div class="topbuffer6"></div></div><div class="sign-in-box"><div class="header header-radius"><div align="center"><p ng-show="vm.error" class="signup-title-reset">Your password couldn\'t be reset.<br>Remember a password request is only valid for 24 hours.</p><p ng-show="vm.success" class="signup-title-reset">Your password has been reset. <a ng-href="{{(brand.web && brand.web.portal_url) || \'/#/login\'}}">Sign In</a></p><p ng-show="vm.doNotMatch" class="signup-title-reset">The password and its confirmation do not match!</p><p ng-show="vm.keyMissing" class="signup-title-reset">The password reset key is missing.</p><p ng-show="vm.keyMissing" class="signup-title-reset">The password reset hash is missing.</p><p ng-hide="vm.keyMissing || vm.success" class="signup-title-reset">Choose a new password.</p></div></div><form ng-show="!vm.success && !vm.keyMissing" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="tab-content tabback singuptable tabbackall6 box-bg-color"><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required ng-disabled="vm.disable_page"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required ng-disabled="vm.disable_page"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right saveall1 saveall2 loginsignupbtn btnsmallsize btnsmallsize2" style="margin-top: 26px">Reset</button></div></form></div></div><div class="topbuffer5"></div></div>');}]);})();